import React from 'react';

const MIX_BLEND_MODE_SCREEN = 'screen';
const MIX_BLEND_MODE_MULTIPLY = 'multiply';
const MIX_BLEND_MODE_OVERLAY = 'overlay';
const MIX_BLEND_MODE_COLOR_DODGE = 'color-dodge';

export const IconAkaAT = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="72" fill="none" viewBox="0 0 63 72">
      <g clipPath="url(#clip0_1416_103115)">
        <path
          fill="#797879"
          d="M41.742 36.563c5.704-1.622 11.387-3.302 17.116-4.826.453-.128.93-.149 1.393-.059a2.204 2.204 0 011.775 1.642c.023.077 0 .177.085.231v1.026c-.098.3-.185.603-.295.9-3.855 10.455-7.714 20.91-11.576 31.366a.89.89 0 01-.277.418 16.241 16.241 0 00-.257-1.99c-.257-1.284-.706-2.515-1.055-3.775-.684-2.465-1.339-4.939-2.003-7.412-.208-.77-.462-1.54-.616-2.337.626-1.742 1.229-3.495 1.714-5.28.364-1.34-.452-2.51-1.82-2.748-.72-.126-1.387.138-2.07.282a.537.537 0 01-.066-.108c-.793-2.412-1.458-4.86-2.048-7.33z"
        ></path>
        <path fill="#FD6165" d="M45.263 71.94V72h-1.282v-.063l1.282.003z"></path>
        <path
          fill="#FD0108"
          d="M45.265 71.94h-1.283c-2.258-.182-4.028-1.624-4.672-3.892-1.3-4.577-2.566-9.164-3.848-13.741-.696-2.456-1.301-4.94-2.127-7.359a.386.386 0 000-.095 86.485 86.485 0 00-1.54-5.672 11.127 11.127 0 00-.577-1.737c-.02-.095-.033-.19-.059-.28a20973.5 20973.5 0 00-2.696-9.79c-.185-.678-.355-1.363-.578-2.027-.441-1.283-1.403-1.948-2.737-2.053-1.334-.105-2.26.485-2.881 1.624-2.224 4.088-4.448 8.177-6.671 12.267-.951 1.756-1.898 3.509-2.84 5.257-.095.046-.121.146-.165.228a8804.762 8804.762 0 00-3.02 5.511c-.738 1.35-1.387 2.763-2.632 3.759-1.283.536-2.565.77-3.928.346A4.362 4.362 0 01.19 48.855c.257-.924.726-1.747 1.16-2.589 2.263-4.389 4.53-8.779 6.804-13.17A11603.596 11603.596 0 0022.395 5.5c.47-.908.929-1.821 1.406-2.724.675-1.27 1.734-2.112 3.017-2.707a.734.734 0 01.313-.046c.288.015.577.015.865 0 1.37-.142 2.375.533 3.248 1.467.798.857 1.206 1.924 1.508 3.033 2.26 8.295 4.583 16.569 6.91 24.843.646 2.297 1.29 4.594 1.932 6.891.02.116.071.223.148.31a87.467 87.467 0 002.053 7.33c.018.04.04.075.067.109a77.063 77.063 0 002.175 7.745c.154.793.408 1.56.616 2.338.665 2.473 1.319 4.946 2.004 7.412.349 1.26.795 2.491 1.054 3.774.127.658.212 1.322.257 1.99-.495 1.769-1.35 3.28-3.033 4.18a4.323 4.323 0 01-1.67.496z"
        ></path>
        <path
          fill="#797879"
          d="M6.938 53.94c1.244-.995 1.893-2.41 2.632-3.759l3.02-5.51c.043-.083.069-.183.164-.23a4.58 4.58 0 001.006-.169c1.94-.528 3.878-1.062 5.816-1.6l11.627-3.23c.24.562.433 1.142.578 1.736a86.404 86.404 0 011.54 5.673.386.386 0 010 .095l-19.756 5.316c-1.655.446-3.284.985-4.955 1.37-.549.145-1.108.248-1.672.308z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1416_103115">
          <path fill="#fff" d="M0 0H62.112V72H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconPlay = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg viewBox="0 0 132 128" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.994141 68.2619V59.7633C1.18808 58.242 1.35023 56.7175 1.58551 55.2056C4.17354 38.3335 12.1507 24.4164 25.7458 13.8486C40.1548 2.63599 56.6655 -1.77142 74.8326 0.642014C92.0014 2.92397 106.121 10.9406 116.89 24.3099C128.336 38.5151 132.755 54.7893 130.389 72.7351C128.72 85.3939 123.458 96.5783 114.861 106.147C104.426 117.761 91.4036 124.841 75.8118 127.258C73.9837 127.543 72.146 127.756 70.3147 128H61.6794C60.1406 127.809 58.5954 127.643 57.0597 127.421C44.2372 125.58 32.8708 120.55 23.1641 112.082C11.3812 101.818 4.20216 89.0062 1.74766 73.6742C1.45833 71.8743 1.24213 70.065 0.994141 68.2619ZM49.7407 63.914C49.7407 71.6583 49.7407 79.4046 49.7407 87.1531C49.7407 88.4208 49.9061 89.5915 51.1524 90.2833C52.3987 90.9751 53.4861 90.5244 54.5798 89.8326C66.7654 82.1113 78.9531 74.3899 91.1429 66.6686C93.7532 65.0159 93.7373 63.0031 91.1016 61.3472C78.9478 53.63 66.7929 45.9286 54.637 38.2427C53.5528 37.5541 52.4623 37.0751 51.2096 37.72C49.8902 38.3961 49.7312 39.5981 49.7344 40.9254C49.7513 48.5882 49.7535 56.2511 49.7407 63.914Z"
        fill="white"
      />
    </svg>
  </span>
);

export const IconEdit = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3 17.461v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15l10.92-10.91-3.75-3.75-10.91 10.91c-.1.1-.15.22-.15.36zm17.71-10.42a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
      ></path>
    </svg>
  </span>
);

export const IconMagnifier = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 85 84">
      <path
        fill="#101828"
        d="M49.583 63a28.378 28.378 0 01-17.343-5.908L16.67 72.478l-5.007-4.949 15.569-15.386A27.624 27.624 0 0121.25 35c0-15.439 12.711-28 28.333-28 15.623 0 28.334 12.561 28.334 28 0 15.438-12.711 28-28.334 28zm0-49c-11.719 0-21.25 9.419-21.25 21s9.531 21 21.25 21c11.72 0 21.25-9.419 21.25-21s-9.53-21-21.25-21z"
      ></path>
      <path
        fill="#101828"
        d="M44.583 30.051c-1.343 1.33-2.083 3.087-2.083 4.95h-7.083a13.778 13.778 0 011.076-5.361 13.91 13.91 0 013.081-4.538c5.363-5.292 14.66-5.292 20.018 0l-5 4.956c-2.692-2.653-7.332-2.646-10.01-.007z"
      ></path>
    </svg>
  </span>
);

export const IconCommunity = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="none" viewBox="0 0 100 100">
      <path
        fill="#D0D5DD"
        d="M41.38 41.715c.137-3.328 1.422-5.94 4.337-7.723l2.75-.642c1.025 0-2.123-.408 1.91-.408 4.687 0 8.422 3.893 8.422 8.808 0 3.107-1.515 4.787-2.5 6.075.108.082.283.235.475.365 3.048 2.06 4.853 4.925 5.5 8.527.087.555.133 1.114.138 1.675.027.94-.5 1.558-1.318 1.608-.88.055-1.53-.5-1.545-1.48a9.665 9.665 0 00-5.475-8.583 1.432 1.432 0 00-1.23-.092 8.39 8.39 0 01-5.842-.028 1.114 1.114 0 00-.96.043c-3.478 1.715-5.39 4.475-5.635 8.365a3.337 3.337 0 01-.123.822 1.312 1.312 0 01-1.425.955c-.675-.037-1.217-.432-1.25-1.135a10.083 10.083 0 01.133-2.407A12.198 12.198 0 0143.499 48c.069-.05.133-.107.193-.168-.688-1.077-.918-2.265-1.593-3.325l-.72-2.792zm14.472-.07c.102-3-2.4-5.88-5.825-5.893a5.89 5.89 0 00-5.895 5.84c0 3.38 2.862 5.893 5.842 5.9 3.093.008 5.94-2.575 5.878-5.847z"
      ></path>
      <path
        fill="#EA2127"
        d="M57.938 44.58c-.675 1.062-.892 2.18-1.58 3.25.06.061.124.117.193.167a12.196 12.196 0 015.75 8.455c.14.794.184 1.603.132 2.408-.045.702-.587 1.097-1.262 1.135a1.313 1.313 0 01-1.425-.955 3.341 3.341 0 01-.123-.823c-.25-3.89-2.157-6.65-5.635-8.365a1.113 1.113 0 00-.96-.042 8.39 8.39 0 01-5.842.027 1.43 1.43 0 00-1.23.093 9.664 9.664 0 00-5.475 8.582c-.015.973-.665 1.535-1.545 1.48-.823-.05-1.345-.667-1.318-1.607.003-.561.05-1.121.138-1.675.655-3.603 2.46-6.468 5.5-8.528.19-.13.367-.282.475-.365-.973-1.287-2.5-2.967-2.5-6.075 0-4.915 3.96-8.807 8.342-8.807 4.035 0 1.045.61 2.073.61l2.687.455c2.915 1.782 4 4.437 4.143 7.765l-.538 2.815zm-7.862 2.92c2.98 0 5.85-2.52 5.842-5.9a5.89 5.89 0 00-5.895-5.85c-3.425 0-5.927 2.887-5.825 5.892-.062 3.275 2.785 5.858 5.878 5.858z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M50 72.888H38.78c-.25.014-.5.008-.75-.018a1.412 1.412 0 01-1.19-1.45 1.332 1.332 0 011.28-1.342c.25-.019.5-.024.75-.018h22.25c.25 0 .5 0 .75.015a1.333 1.333 0 011.283 1.34 1.415 1.415 0 01-1.185 1.455c-.249.026-.5.032-.75.018H50.001zM59.695 67.412c-.685 0-1.373.03-2.058 0-.767-.042-1.305-.485-1.442-1.11a1.383 1.383 0 011.25-1.75 42.105 42.105 0 014.387 0 1.38 1.38 0 011.34 1.415A1.425 1.425 0 0161.75 67.4c-.683.047-1.37 0-2.055 0v.012zM39.695 65.968a1.5 1.5 0 01-1.415 1.442 1.445 1.445 0 111.415-1.442zM43.09 64.525a1.442 1.442 0 11.12 2.882 1.442 1.442 0 01-.12-2.882zM49.42 65.933a1.5 1.5 0 01-1.382 1.475 1.442 1.442 0 11-.068-2.883 1.5 1.5 0 011.45 1.408z"
      ></path>
      <path
        fill="#D0D5DD"
        fillRule="evenodd"
        d="M47.332 9.853a5.357 5.357 0 015.368 0h.002l30.748 17.75a5.367 5.367 0 012.682 4.647v35.522h-1.25l1.25.002a5.372 5.372 0 01-2.693 4.649l-30.762 17.75a5.37 5.37 0 01-5.367 0l-30.75-17.75a5.37 5.37 0 01-2.685-4.65V32.246a5.365 5.365 0 012.71-4.646l.005-.002L47.331 9.853h.001zm36.3 57.918V32.25a2.867 2.867 0 00-1.432-2.483L51.448 12.016a2.857 2.857 0 00-2.864 0h-.002L17.83 29.77l-.004.002a2.865 2.865 0 00-1.45 2.48v35.52a2.87 2.87 0 001.435 2.485m0 0l30.75 17.75a2.872 2.872 0 002.868 0l30.762-17.75h.002a2.873 2.873 0 001.44-2.486"
        clipRule="evenodd"
      ></path>
    </svg>
  </span>
);

export const IconEnterprises = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="101" fill="none" viewBox="0 0 100 101">
      <path
        fill="#D0D5DD"
        d="M48.5 98.41c-.302-.125-.597-.267-.905-.375a7.578 7.578 0 01-5.177-7.15c0-.827.195-1.655.315-2.577L20.83 75.66c-2.722 2.668-5.845 3.44-9.235 1.725C8.663 75.903 7.235 73.32 7.54 70c.343-3.692 2.603-5.827 6.075-6.835V37.848c-4.05-1.25-6.382-3.885-6.065-8.288.218-2.98 1.893-5.127 4.66-6.23 3.23-1.287 6.093-.482 8.615 2.02L42.77 12.683c-.927-3.893.045-7.088 3.585-9.13 2.695-1.553 5.5-1.373 8 .44 2.95 2.132 3.75 5.115 2.843 8.67l21.95 12.677c2.775-2.69 5.935-3.472 9.382-1.647 2.923 1.545 4.273 4.17 3.908 7.452-.4 3.59-2.633 5.7-6.058 6.668V63.17c3.693 1.115 6 3.418 6.088 7.405.08 3.293-1.525 5.715-4.5 7.013-3.25 1.417-6.2.635-8.8-1.928L57.195 88.35c.293 1.098.4 2.237.318 3.37-.35 3.405-3.143 6.043-5.923 6.52a1 1 0 00-.285.17H48.5zm29.275-70.57L55.723 15.105a8 8 0 01-4.275 2.518v4.79c.004.337-.038.674-.125 1a1.373 1.373 0 01-2.643 0 3.6 3.6 0 01-.127-1c-.013-1.585 0-3.17 0-4.813a8.023 8.023 0 01-4.285-2.5L22.23 27.825a7.7 7.7 0 010 4.973c1.433.827 2.803 1.617 4.17 2.412.249.13.485.282.705.455a1.435 1.435 0 01.273 1.783 1.387 1.387 0 01-1.7.597 6.05 6.05 0 01-.82-.44c-1.343-.767-2.688-1.54-4.088-2.345a8.043 8.043 0 01-4.25 2.5v25.49a7.857 7.857 0 014.27 2.485c1.033-.602 2-1.165 2.963-1.722.592-.34 1.185-.685 1.79-1a1.322 1.322 0 011.56.202 1.38 1.38 0 01.417 1.448c-.11.5-.5.767-.912 1-1.45.832-2.898 1.67-4.388 2.532a7.695 7.695 0 010 4.983l22.05 12.727c1.13-1.342 2.608-2.09 4.265-2.53v-4.817c-.005-.31.03-.62.105-.92a1.38 1.38 0 012.678-.02 3.9 3.9 0 01.115 1v4.77a8.044 8.044 0 014.29 2.5l22.045-12.733a7.648 7.648 0 01-.018-4.98l-4.032-2.327a5.967 5.967 0 01-.785-.5 1.418 1.418 0 01-.343-1.77 1.397 1.397 0 011.765-.625c.255.114.5.247.735.397l4.14 2.375c1.148-1.367 2.635-2.092 4.23-2.525V37.77a8.037 8.037 0 01-4.25-2.482l-.67.38c-1.32.75-2.627 1.537-3.962 2.272-.8.438-1.615.19-2-.537-.36-.663-.12-1.458.605-1.925.417-.268.86-.5 1.29-.75l3.312-1.93a7.385 7.385 0 01-.01-4.958zM54.698 10.18c.105-2.12-1.565-4.692-4.698-4.75-2.567-.055-4.632 2.09-4.722 4.66a4.729 4.729 0 004.667 4.805c2.583.073 4.745-2.097 4.753-4.715zm-9.403 80.665c0 2.633 2.113 4.808 4.715 4.75a4.702 4.702 0 004.698-4.677c-.028-2.65-2.05-4.798-4.68-4.783-3.158.01-4.853 2.668-4.733 4.71zm-30.2-55.827c2.32.077 4.683-1.925 4.665-4.7a4.718 4.718 0 10-4.665 4.7zm69.865 0c2.343.077 4.668-1.86 4.705-4.67a4.717 4.717 0 00-9.432-.058c-.04 2.795 2.355 4.838 4.727 4.725v.003zM15.058 65.985c-2.5-.082-4.698 2-4.733 4.643a4.718 4.718 0 009.435.015c-.01-2.73-2.332-4.755-4.702-4.658zM80.235 70.7a4.72 4.72 0 006.564 4.43 4.718 4.718 0 002.869-4.467 4.75 4.75 0 00-4.793-4.698c-2.29.015-4.687 1.93-4.64 4.735z"
      ></path>
      <path
        fill="#EA2127"
        d="M43.689 48.28l-2-3.157c-.587.03-1.176.025-1.763-.013a14.629 14.629 0 01-2.555-.457 1.525 1.525 0 00-1.25.077c-3.192 1.648-5.062 4.218-5.44 7.825-.035.34-.045.685-.107 1.02-.153.848-.675 1.275-1.478 1.235a1.329 1.329 0 01-1.325-1.4c.037-1.086.185-2.166.443-3.222a12.165 12.165 0 015.25-7.223c.152-.1.3-.21.517-.365-2.145-2.427-3.025-5.19-2.23-8.35a8.467 8.467 0 014.215-5.452c4.25-2.388 10.14-.955 12.475 4.592h3.1c1.668-3.717 4.52-5.852 8.72-5.66 3.445.158 6.028 1.943 7.448 5.098 1.587 3.535.87 6.79-1.685 9.75.182.145.355.302.547.432 3.413 2.315 5.25 5.555 5.645 9.635.032.28.036.56.013.84a1.402 1.402 0 01-1.315 1.335c-.803.055-1.355-.367-1.5-1.205-.13-.75-.15-1.55-.32-2.305-.675-2.975-2.435-5.112-5.125-6.515a1.536 1.536 0 00-1.408-.105 7.41 7.41 0 01-3.212.438l-1-.058-2.033 3.21c.108.083.283.235.475.365 3.048 2.06 4.853 4.925 5.5 8.528.086.554.132 1.114.138 1.675.027.937-.5 1.557-1.318 1.607-.882.055-1.53-.5-1.545-1.48a9.673 9.673 0 00-5.475-8.585 1.443 1.443 0 00-1.23-.09 8.39 8.39 0 01-5.842-.027 1.112 1.112 0 00-.96.042c-3.478 1.715-5.39 4.475-5.635 8.365a3.341 3.341 0 01-.123.823 1.313 1.313 0 01-1.425.955c-.675-.038-1.217-.433-1.262-1.135a9.83 9.83 0 01.132-2.408 12.197 12.197 0 015.75-8.455 1.63 1.63 0 00.193-.18zm12.16-6.192c.102-3-2.4-5.88-5.828-5.893a5.895 5.895 0 00-5.895 5.84c0 3.38 2.865 5.893 5.845 5.9 3.093.01 5.94-2.575 5.878-5.847zm2.957.105a5.87 5.87 0 002.363-11.5c-3.5-.84-6.35 1.585-6.838 3.71 3.218 2.212 4.195 4.465 4.475 7.79zm-13.092-7.75a5.868 5.868 0 00-11.185 3.527c.977 3.45 4.355 4.79 6.687 4.188.138-3.335 1.583-5.94 4.498-7.723v.008z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M50 73.33H38.775c-.25.015-.5.009-.75-.017a1.413 1.413 0 01-1.19-1.45 1.33 1.33 0 011.278-1.343c.25-.018.5-.024.75-.017h22.25c.25 0 .5 0 .75.015a1.335 1.335 0 011.282 1.34 1.418 1.418 0 01-1.185 1.455c-.25.026-.5.032-.75.017H50zM59.691 67.855c-.688 0-1.373.03-2.058 0-.767-.043-1.305-.485-1.442-1.11a1.383 1.383 0 011.25-1.75c1.46-.083 2.93-.07 4.39 0a1.38 1.38 0 011.34 1.415 1.428 1.428 0 01-1.422 1.44c-.683.047-1.37 0-2.056 0l-.002.005zM39.69 66.41a1.5 1.5 0 01-1.414 1.443 1.446 1.446 0 111.415-1.443zM43.086 64.968a1.444 1.444 0 011.058 2.482 1.444 1.444 0 01-2.44-1.04 1.442 1.442 0 011.382-1.442zM49.416 66.375a1.5 1.5 0 01-1.382 1.475 1.443 1.443 0 11-.068-2.882 1.5 1.5 0 011.45 1.407z"
      ></path>
    </svg>
  </span>
);

export const IconCheckCircle = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9.29 16.29L5.7 12.7C5.31 12.31 5.31 11.68 5.7 11.29C6.09 10.9 6.72 10.9 7.11 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.7 16.29C10.32 16.68 9.68 16.68 9.29 16.29Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export const IconCheckCirclePricing = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="url(#paint0_linear_1623_98738)"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7a.996.996 0 111.41-1.41L10 14.17l6.88-6.88a.996.996 0 111.41 1.41l-7.59 7.59a.996.996 0 01-1.41 0z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1623_98738"
          x1="-30.77"
          x2="5.361"
          y1="11.972"
          y2="43.214"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.498" stopColor="#0197EC" stopOpacity="0.98"></stop>
          <stop offset="0.938" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const IconCompany = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_50_17034)">
        <path
          d="M12.0584 4.00033V0.666992H4.01953V6.00033"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M6.69922 15.334H9.37885"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M6.69909 8H0.669922V15.3333H6.69909V8Z"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M15.4081 6H9.37891V15.3333H15.4081V6Z"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M12.0586 8.66699H12.7285"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M12.0586 10.667H12.7285"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M12.0586 12.667H12.7285"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M3.34961 12.667H4.01952"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M3.34961 10.667H4.01952"
          stroke="white"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_50_17034">
          <rect width="16.0778" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconApartment = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24">
      <path
        fill="#344054"
        d="M17.5 11V5c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v2h-2c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h5c.55 0 1-.45 1-1v-3h2v3c0 .55.45 1 1 1h5c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-2zm-10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm4 4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
      ></path>
    </svg>
  </span>
);

export const IconPhone = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 3.86441C0.0572591 3.72444 0.101794 3.57727 0.174322 3.44578C0.600584 2.67215 1.14094 1.97486 1.73898 1.32847C2.09966 0.948139 2.48097 0.587923 2.88119 0.249452C3.43258 -0.22601 3.98184 0.0568922 4.26474 0.444133C4.9773 1.41966 5.6415 2.42954 6.14878 3.53231C6.22236 3.70221 6.2847 3.87677 6.3354 4.05485C6.3795 4.18126 6.38891 4.31719 6.36266 4.44847C6.3364 4.57976 6.27543 4.70161 6.1861 4.80134C5.99863 5.01341 5.78232 5.20512 5.57322 5.39938C5.43367 5.52916 5.28819 5.65386 5.13847 5.77135C5.05831 5.83455 5.04643 5.89138 5.08079 5.98766C5.4642 7.06661 6.10834 8.03406 6.95592 8.80396C7.62747 9.41551 8.41136 9.89086 9.2641 10.2036C9.39134 10.2507 9.46853 10.2401 9.56099 10.1298C9.8036 9.83547 10.0568 9.5496 10.3147 9.26882C10.6243 8.9295 11.0069 8.82432 11.4242 9.02112C12.0028 9.29342 12.5792 9.57505 13.1318 9.89612C13.6845 10.2172 14.2079 10.5917 14.7436 10.9446C14.9833 11.0965 15.1631 11.3267 15.2525 11.5961C15.3225 11.8056 15.32 12.0075 15.1974 12.1899C15.0532 12.4049 14.909 12.6246 14.7347 12.8142C13.9373 13.6816 13.0194 14.403 12.0303 15.0418C11.6401 15.2937 11.2503 15.2776 10.8292 15.1928C9.48041 14.9205 8.25167 14.3606 7.10522 13.6192C4.45942 11.9108 2.36247 9.69338 0.938201 6.87115C0.487763 5.97536 0.164991 5.03546 0.0424141 4.03491C0.0373244 3.98232 0.033083 3.92973 0.0279933 3.87713L0 3.86441ZM3.47796 1.05532C3.4562 1.06351 3.43519 1.07358 3.41519 1.08543C2.52521 1.88939 1.74603 2.80807 1.0981 3.81733C1.06745 3.8767 1.05674 3.94438 1.06756 4.01031C1.19269 4.9201 1.50358 5.76838 1.92645 6.57425C3.36599 9.31293 5.44682 11.4493 8.09304 13.0322C9.08044 13.6226 10.1323 14.0654 11.2822 14.2325C11.3633 14.2441 11.4459 14.2258 11.5146 14.1812C12.0906 13.749 12.6733 13.3249 13.2264 12.8664C13.5908 12.5631 13.9093 12.2047 14.2579 11.8624C14.188 11.8069 14.14 11.7657 14.0883 11.7288C13.2095 11.09 12.2742 10.5328 11.294 10.0641C11.0523 9.94829 11.0552 9.95126 10.872 10.157C10.562 10.5048 10.2502 10.8513 9.93339 11.1931C9.80318 11.334 9.6314 11.3594 9.44902 11.3204C9.36165 11.3009 9.27427 11.278 9.1886 11.25C7.61164 10.7453 6.32437 9.82444 5.31534 8.51809C4.70797 7.7241 4.2376 6.8563 3.99244 5.87866C3.94197 5.67719 3.97336 5.50159 4.12223 5.35102C4.19645 5.27553 4.26389 5.1924 4.34278 5.12199C4.64279 4.85478 4.94605 4.58955 5.25257 4.3263C5.32934 4.26056 5.34418 4.20499 5.29498 4.11423C4.95227 3.49371 4.62865 2.86174 4.2711 2.24801C4.02934 1.83871 3.74432 1.45486 3.47796 1.05532Z"
        fill="white"
      />
      <path
        d="M8.17969 1.52171V0.52795C11.6678 0.42446 14.8472 3.47319 14.7755 7.11996H13.7792C13.7444 5.59305 13.2181 4.26506 12.1361 3.17883C11.0541 2.09261 9.72653 1.55734 8.17969 1.52171Z"
        fill="white"
      />
      <path
        d="M12.2365 7.12024H11.2334C11.2071 6.28807 10.9242 5.56491 10.3359 4.9745C9.74766 4.3841 9.02704 4.09314 8.18555 4.06769V3.07393C10.1718 2.97977 12.2573 4.73571 12.2365 7.12024Z"
        fill="white"
      />
    </svg>
  </span>
);

export const IconHourglass = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" fill="none" viewBox="0 0 90 91">
      <path
        stroke="url(#paint0_linear_1223_115914)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10"
        d="M8.792 61.71C4.018 49.224 1.3 21.316 28.622 9.566c4.896-2.326 17.553-5.876 29.01-1.47"
      ></path>
      <path
        stroke="url(#paint1_linear_1223_115914)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="10"
        d="M79.082 25.59c6.449 11.707 12.986 38.975-12.455 54.378-4.53 2.978-10.466 4.968-16.313 5.943"
      ></path>
      <circle cx="8.672" cy="61.817" r="3.672" fill="url(#paint2_linear_1223_115914)"></circle>
      <circle
        cx="79.243"
        cy="25.51"
        r="3.724"
        fill="url(#paint3_linear_1223_115914)"
        transform="rotate(172.08 79.243 25.51)"
      ></circle>
      <path
        fill="#FEFEFE"
        d="M32.844 67.578l-13.083-8.452c2.113-2.239 11.161-11.273 20.233-11.895l2.884 2.546 3.672 1.148c4.166 8.081 1.12 20.5.3 23.464l-14.006-6.811z"
      ></path>
      <path
        fill="url(#paint4_linear_1223_115914)"
        d="M39.792 47.827l2.608 2.3.187.164.238.074 3.319 1.038c3.654 7.386 1.303 18.398.33 22.151l-12.98-6.313-.36-.175-.34-.218-12.121-7.832c2.709-2.78 10.911-10.488 19.123-11.192m.405-1.195c-10.76.564-21.334 12.607-21.334 12.607l13.294 8.59-.03.049.427.206.396.255.03-.049 14.234 6.922s4.83-15.28-.264-24.776l-3.782-1.184-2.975-2.624.004.004z"
      ></path>
      <path
        fill="url(#paint5_linear_1223_115914)"
        d="M41.439 47.998s-.757 4.392-4.322 5.581a92.658 92.658 0 01-6.6 1.929l1.166 2.794s3.77-.675 5.435 1.341c1.665 2.016 2.123 5.085 3.27 6.291 1.145 1.207 4.049.373 4.049.373s-1.973-4.293-1.363-8.513c.61-4.22.84-5.275 2.081-7.158 1.241-1.882-3.712-2.638-3.712-2.638h-.004z"
      ></path>
      <path
        fill="url(#paint6_linear_1223_115914)"
        d="M19.01 68.757c-3.774-6.385-.85-11.638 6.53-11.735 7.379-.097 16.425 4.997 20.199 11.382 3.774 6.384.854 11.638-6.53 11.735-7.379.097-16.425-4.998-20.203-11.383h.004z"
      ></path>
      <path
        fill="#FEFEFE"
        stroke="#86A0E3"
        strokeMiterlimit="10"
        strokeWidth="2.261"
        d="M48.38 47.904c1.238 2.094.28 3.815-2.14 3.848-2.419.032-5.382-1.639-6.62-3.732-1.237-2.094-.28-3.815 2.14-3.848 2.42-.032 5.383 1.639 6.62 3.732z"
      ></path>
      <path
        fill="url(#paint7_linear_1223_115914)"
        d="M46.421 78.49l-1.357 2.39c-1.244 2.19-3.92 3.567-7.747 3.62-7.699.103-17.131-5.212-21.068-11.872-1.98-3.352-2.194-6.401-.934-8.621l1.358-2.39c-1.26 2.22-1.047 5.269.934 8.62 3.936 6.66 13.369 11.975 21.067 11.873 3.824-.05 6.504-1.427 7.747-3.62z"
      ></path>
      <path
        fill="url(#paint8_linear_1223_115914)"
        d="M45.487 69.868c3.937 6.66.886 12.137-6.812 12.24-7.698.101-17.131-5.214-21.067-11.874s-.89-12.137 6.808-12.238c7.699-.102 17.131 5.212 21.071 11.872z"
      ></path>
      <path
        fill="url(#paint9_linear_1223_115914)"
        d="M46.639 76.664l-.719 1.257c-1.192 2.099-3.76 3.423-7.425 3.47-7.38.096-16.426-4.999-20.2-11.383-1.901-3.212-2.101-6.14-.896-8.266l.719-1.257c-1.206 2.129-1.002 5.053.896 8.266 3.774 6.384 12.82 11.479 20.2 11.382 3.668-.05 6.236-1.37 7.425-3.47z"
      ></path>
      <path
        fill="url(#paint10_linear_1223_115914)"
        d="M45.743 68.398c3.774 6.384.85 11.638-6.529 11.735-7.379.097-16.425-4.998-20.199-11.382-3.774-6.385-.854-11.638 6.529-11.735 7.38-.097 16.426 4.998 20.203 11.382h-.004z"
      ></path>
      <path
        fill="url(#paint11_linear_1223_115914)"
        fillRule="evenodd"
        d="M34.981 63.208c-3.28-1.827-6.874-2.882-9.986-2.843-3.123.039-4.804 1.135-5.49 2.353-.686 1.223-.745 3.233.857 5.912 1.596 2.666 4.38 5.167 7.659 6.994 3.278 1.828 6.873 2.882 9.985 2.843 3.121-.038 4.803-1.135 5.488-2.353.688-1.223.747-3.233-.855-5.911l-.143-.239c-1.618-2.577-4.334-4.983-7.515-6.756zm12.248 8.048l-1.347-2.946c-2.012-3.36-5.35-6.28-9.055-8.344-3.703-2.064-7.95-3.372-11.883-3.323-3.926.049-7.161 1.475-8.73 4.264-1.565 2.785-1.096 6.266.908 9.615 2.01 3.36 5.348 6.28 9.052 8.344 3.703 2.064 7.95 3.372 11.883 3.323 3.924-.049 7.16-1.475 8.728-4.263 1.11-1.972 1.198-4.294.444-6.67z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint12_linear_1223_115914)"
        d="M44.151 75.16c.013-.03.03-.06.043-.087.047-.095.094-.19.137-.285.8-1.685 1.452-3.335 1.737-4.892L43.2 68.16c-2.927-4.678-9.258-8.459-14.881-9.012l-3.658-2.216a19.594 19.594 0 00-3.842 4.687l.015.008c-1.197 1.768-1.107 4.303.55 7.103 3.105 5.254 10.545 9.443 16.617 9.364 3.062-.038 5.189-1.157 6.149-2.929v-.004z"
      ></path>
      <path
        fill="url(#paint13_linear_1223_115914)"
        d="M45.43 64.19c-.787-.63-1.966-1.116-3.6-1.44-3.024-.597-3.038-3.171-4.072-5.555 3.115 1.593 5.89 3.967 7.467 6.636.072.12.14.24.205.359z"
      ></path>
      <path
        fill="url(#paint14_linear_1223_115914)"
        d="M40.223 72.827c-5.66.075-12.596-3.834-15.49-8.729-2.226-3.755-1.42-7.007 1.64-8.344.27-.236 4.705-4.017 8.822-1.566 1.363.809 2.075 1.887 2.564 3.01 1.034 2.383 1.048 4.957 4.072 5.554 1.634.324 2.81.81 3.6 1.44 1.366 1.093 1.583 2.623.999 4.512-.4 2.446-2.613 4.082-6.204 4.127l-.003-.004z"
      ></path>
      <path
        fill="url(#paint15_linear_1223_115914)"
        d="M40.354 39.182s-.908 3.282.793 8.067c.04.235.133.484.288.744.726 1.223 2.457 2.2 3.87 2.18.303-.006.562-.056.78-.144 0 0 5.146-.906 7.29-3.51L40.35 39.18l.004.003z"
      ></path>
      <path
        fill="url(#paint16_linear_1223_115914)"
        d="M53.124 42.522c1.725 2.913.39 5.312-2.983 5.36-3.368.043-7.5-2.284-9.22-5.197-1.721-2.912-.39-5.312 2.979-5.36 3.368-.043 7.5 2.284 9.224 5.197z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }} opacity="0.54">
        <path
          fill="url(#paint17_linear_1223_115914)"
          d="M38.25 50.978c.249.012.267-.376.018-.387-.248-.012-.266.376-.017.387z"
        ></path>
        <path
          fill="url(#paint18_linear_1223_115914)"
          d="M39.622 50.728c.248.012.266-.376.017-.387-.248-.012-.266.376-.017.387z"
        ></path>
        <path
          fill="url(#paint19_linear_1223_115914)"
          d="M39.149 57.15c.248.012.266-.376.018-.388-.249-.01-.266.377-.018.388z"
        ></path>
        <path
          fill="url(#paint20_linear_1223_115914)"
          d="M46.59 55.1c.249.01.266-.377.018-.388-.248-.012-.266.376-.018.387z"
        ></path>
        <path
          fill="url(#paint21_linear_1223_115914)"
          d="M44.778 54.53c.248.01.266-.377.018-.389-.249-.011-.267.377-.018.388z"
        ></path>
        <path
          fill="url(#paint22_linear_1223_115914)"
          d="M45.094 58.254c.248.011.266-.377.018-.388-.248-.011-.266.377-.018.388z"
        ></path>
        <path
          fill="url(#paint23_linear_1223_115914)"
          d="M36.68 52.775c.248.012.266-.376.018-.388-.248-.01-.266.377-.018.388z"
        ></path>
        <path
          fill="url(#paint24_linear_1223_115914)"
          d="M34.406 51.76c.5.023.536-.753.036-.776-.5-.023-.536.753-.036.776z"
        ></path>
        <path
          fill="url(#paint25_linear_1223_115914)"
          d="M45.89 53.668c.501.023.537-.753.036-.776-.5-.023-.536.753-.035.776z"
        ></path>
        <path
          fill="url(#paint26_linear_1223_115914)"
          d="M45.992 61.295c.5.023.536-.753.036-.776-.5-.023-.536.753-.036.776z"
        ></path>
        <path
          fill="url(#paint27_linear_1223_115914)"
          d="M30.45 60.309c1.249.057 1.338-1.883.088-1.94-1.249-.057-1.338 1.882-.088 1.94z"
        ></path>
        <path
          fill="url(#paint28_linear_1223_115914)"
          d="M32.75 64.563c.997.045 1.072-1.506.071-1.552-1-.046-1.072 1.506-.071 1.551z"
        ></path>
        <path
          fill="url(#paint29_linear_1223_115914)"
          d="M39.34 68.781c.749.034.802-1.13.054-1.163-.75-.035-.802 1.129-.054 1.163z"
        ></path>
        <path
          fill="url(#paint30_linear_1223_115914)"
          d="M40.782 67.672c.248.011.266-.377.018-.388-.249-.012-.267.376-.018.388z"
        ></path>
        <path
          fill="url(#paint31_linear_1223_115914)"
          d="M43.88 66.566c.248.012.265-.376.017-.388-.248-.01-.266.377-.018.388z"
        ></path>
        <path
          fill="url(#paint32_linear_1223_115914)"
          d="M35.86 59.236c.5.023.535-.752.035-.775-.5-.023-.536.752-.036.775z"
        ></path>
        <path
          fill="url(#paint33_linear_1223_115914)"
          d="M46.387 43.049c.5.023.536-.753.035-.776-.5-.023-.536.753-.035.776z"
        ></path>
        <path
          fill="url(#paint34_linear_1223_115914)"
          d="M42.528 40.664c.748.034.802-1.13.053-1.164-.749-.034-.802 1.13-.053 1.164z"
        ></path>
        <path
          fill="url(#paint35_linear_1223_115914)"
          d="M51.3 44.752c.501.023.537-.753.036-.776-.5-.023-.536.753-.035.776z"
        ></path>
        <path
          fill="url(#paint36_linear_1223_115914)"
          d="M48.934 46.986c.248.012.266-.376.018-.388-.248-.011-.266.377-.018.388z"
        ></path>
        <path
          fill="url(#paint37_linear_1223_115914)"
          d="M43.797 48.185c.249.012.266-.376.018-.387-.248-.012-.266.376-.018.387z"
        ></path>
        <path
          fill="url(#paint38_linear_1223_115914)"
          d="M47.98 48.652c.25.012.267-.376.019-.388-.249-.011-.266.377-.018.388z"
        ></path>
        <path
          fill="url(#paint39_linear_1223_115914)"
          d="M46.855 49.023c.5.023.536-.752.036-.775-.5-.023-.536.753-.036.775z"
        ></path>
      </g>
      <path
        fill="url(#paint40_linear_1223_115914)"
        d="M69.15 36.748l-.718 1.257c-1.193 2.099-3.761 3.423-7.425 3.47-7.38.096-16.426-4.999-20.2-11.383-1.901-3.212-2.101-6.14-.896-8.266l.719-1.258c-1.206 2.13-1.002 5.054.896 8.266 3.774 6.385 12.82 11.48 20.2 11.383 3.668-.05 6.236-1.37 7.424-3.47z"
      ></path>
      <path
        fill="#A6BFFE"
        d="M46.954 50.437l-3.782-1.184-2.975-2.624c-10.76.564-21.334 12.606-21.334 12.606l.14.089c-2.1 2.146-2.262 5.579.014 9.43 3.774 6.384 12.82 11.479 20.2 11.382 4.454-.06 7.284-1.998 7.997-4.927 0 0 4.83-15.28-.263-24.776l.003.004z"
        opacity="0.58"
      ></path>
      <path
        fill="#A6BFFE"
        d="M54.418 30.633l.03-.05-.427-.205-.396-.256-.03.05-14.234-6.923s-4.675 14.798.024 24.318c.067.151.146.303.236.458 1.237 2.094 4.201 3.761 6.62 3.732.164 0 .324-.012.472-.033l.047.084c10.76-.564 20.952-12.581 20.952-12.581l-13.294-8.59v-.004z"
        opacity="0.58"
      ></path>
      <path
        fill="#A6BFFE"
        d="M40.105 24.904l12.98 6.313.36.176.34.218 12.14 7.845c-2.59 2.741-10.401 10.297-18.506 11.13l-.061-.111-.778.089a2.883 2.883 0 01-.355.022c-.082 0-.163 0-.249-.003-1.978-.091-4.378-1.507-5.352-3.153a2.918 2.918 0 01-.175-.342l-.007-.02-.01-.02c-2.299-4.65-2.175-10.742-1.671-15.034a53.22 53.22 0 011.344-7.11m-.744-1.659s-4.675 14.798.024 24.318c.067.151.146.303.236.458 1.183 2.002 3.947 3.617 6.302 3.725a4.388 4.388 0 00.79-.026l.047.084c10.76-.564 20.952-12.581 20.952-12.581l-13.294-8.59.03-.05-.427-.205-.396-.256-.03.05-14.234-6.923v-.003z"
      ></path>
      <path
        fill="url(#paint41_linear_1223_115914)"
        d="M71.042 34.807l-1.357 2.39c-1.244 2.19-3.92 3.568-7.747 3.622-7.699.102-17.131-5.213-21.068-11.873-1.98-3.352-2.194-6.401-.934-8.621l1.358-2.39c-1.26 2.22-1.047 5.269.934 8.62 3.936 6.661 13.369 11.976 21.067 11.874 3.824-.05 6.504-1.428 7.747-3.622z"
      ></path>
      <path
        fill="url(#paint42_linear_1223_115914)"
        d="M70.108 26.187c3.936 6.66.886 12.137-6.813 12.239-7.698.101-17.13-5.213-21.067-11.873-3.936-6.656-.886-12.137 6.812-12.235 7.699-.102 17.132 5.213 21.072 11.873l-.004-.004z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint43_linear_1223_115914)"
        d="M70.219 26.203c-3.937-6.657-13.37-11.971-21.068-11.87-3.835.05-6.52 1.44-7.755 3.64 0-.007.008-.014.012-.022l-1.357 2.39c-.584 1.027-.845 2.232-.77 3.56-.799 2.844-3.707 14.54-.161 22.853-1.62.205-3.222.653-4.778 1.262-.324.125-.642.258-.963.398a29.744 29.744 0 00-2.79 1.404 38.551 38.551 0 00-2.608 1.618 43.51 43.51 0 00-1.616 1.142c-4.41 3.273-7.393 6.67-7.393 6.67l.129.083c-1.02.603-1.806 1.387-2.326 2.32 0-.009.008-.016.012-.024l-1.357 2.39c-1.26 2.22-1.047 5.27.934 8.622C20.3 79.3 29.733 84.614 37.431 84.512c3.824-.05 6.504-1.428 7.747-3.621l1.358-2.39c-.038.064-.08.124-.118.188.61-.986.919-2.146.9-3.433 0-.012.001-.024.01-.031 0 0 4.406-13.95.357-23.476C57.45 50.722 66.54 40.695 67.698 39.38c.909-.576 1.615-1.305 2.101-2.162l1.358-2.39c-.038.064-.08.125-.118.189 1.382-2.234 1.222-5.363-.817-8.807l-.003-.008zm-1.04 10.707l-.015.011.016-.01zM40.627 20.76c.004-.073.011-.147.018-.22-.003.073-.014.147-.018.22zm.552-2.365c.034-.072.069-.14.107-.209-.034.069-.073.137-.107.21zm-.184.447a3.6 3.6 0 01.088-.214c-.03.073-.061.141-.088.214zM16.02 64.224c-.004.081-.015.162-.019.244.004-.082.011-.163.019-.244zm.15-.989c-.019.077-.038.15-.053.231.015-.077.034-.154.053-.23zm-.092.49c-.012.077-.027.158-.034.236.007-.082.023-.159.034-.236zm.485 4.092c-.031-.087-.055-.174-.085-.26.027.086.054.173.085.26zM16.002 65c-.003-.081 0-.163 0-.248a2.718 2.718 0 000 .248zm.692 3.165c.03.083.062.166.097.25-.035-.084-.062-.167-.098-.25zm.564 1.258l.107.215c-.04-.072-.071-.143-.107-.215zm26.605 11.579c.084-.043.167-.086.247-.129-.08.047-.163.086-.247.129zm-5.079 1.131zm2.304-.217c.118-.022.24-.04.357-.065-.118.025-.235.043-.357.065zm1.207-.287c.102-.03.209-.06.307-.09-.099.034-.205.06-.307.09zm.556-.184c.095-.035.194-.069.29-.107-.096.038-.19.073-.29.107zm2.121-1.147c-.068.055-.14.103-.213.154.072-.051.145-.102.213-.154zm-.41.296c-.076.051-.152.095-.232.141l.232-.14zm.596-.447l.198-.165c-.065.059-.133.11-.198.165zm.86-.87c-.053.064-.107.128-.164.187.053-.063.11-.123.164-.187zm23.757-42.806c.069-.055.137-.11.198-.17-.064.06-.133.11-.198.17zm.696-.687c.054-.064.111-.123.164-.187-.053.064-.106.127-.164.187z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1223_115914"
          x1="27.85"
          x2="27.85"
          y1="206.559"
          y2="-47.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1223_115914"
          x1="45.301"
          x2="80.33"
          y1="-116.146"
          y2="135.651"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1223_115914"
          x1="5"
          x2="16.597"
          y1="56.767"
          y2="57.201"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#EA2127"></stop>
          <stop offset="0.771" stopColor="#F28A8D"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1223_115914"
          x1="75.519"
          x2="87.281"
          y1="20.389"
          y2="20.829"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#EA2127"></stop>
          <stop offset="0.771" stopColor="#F28A8D"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1223_115914"
          x1="49.985"
          x2="-3.222"
          y1="62.184"
          y2="58.981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8596BE"></stop>
          <stop offset="1" stopColor="#D4D6F9"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1223_115914"
          x1="44.028"
          x2="30.461"
          y1="57.339"
          y2="56.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1223_115914"
          x1="17.153"
          x2="47.6"
          y1="67.878"
          y2="69.274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8DAEFE"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1223_115914"
          x1="47.322"
          x2="-9.093"
          y1="74.766"
          y2="71.074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8596BE"></stop>
          <stop offset="1" stopColor="#D4D6F9"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1223_115914"
          x1="48.103"
          x2="-7.278"
          y1="71.625"
          y2="68.091"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8596BE"></stop>
          <stop offset="1" stopColor="#D4D6F9"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_1223_115914"
          x1="47.516"
          x2="-5.634"
          y1="72.525"
          y2="69.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_1223_115914"
          x1="48.251"
          x2="-4.843"
          y1="70.083"
          y2="66.695"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_1223_115914"
          x1="48.616"
          x2="-8.643"
          y1="71.067"
          y2="67.442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_1223_115914"
          x1="44.361"
          x2="19.903"
          y1="68.063"
          y2="66.941"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_1223_115914"
          x1="45.04"
          x2="37.607"
          y1="60.832"
          y2="60.491"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_1223_115914"
          x1="45.29"
          x2="23.35"
          y1="63.466"
          y2="62.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1223_115914"
          x1="52.522"
          x2="39.962"
          y1="45.092"
          y2="44.516"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_1223_115914"
          x1="53.028"
          x2="40.074"
          y1="42.85"
          y2="42.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_1223_115914"
          x1="38.42"
          x2="38.073"
          y1="50.791"
          y2="50.775"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_1223_115914"
          x1="39.791"
          x2="39.444"
          y1="50.541"
          y2="50.525"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_1223_115914"
          x1="39.319"
          x2="38.972"
          y1="56.963"
          y2="56.947"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_1223_115914"
          x1="46.76"
          x2="46.413"
          y1="54.912"
          y2="54.896"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_1223_115914"
          x1="44.948"
          x2="44.6"
          y1="54.342"
          y2="54.326"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_1223_115914"
          x1="45.264"
          x2="44.917"
          y1="58.066"
          y2="58.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_1223_115914"
          x1="36.85"
          x2="36.503"
          y1="52.588"
          y2="52.572"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_1223_115914"
          x1="34.748"
          x2="34.049"
          y1="51.385"
          y2="51.352"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_1223_115914"
          x1="46.233"
          x2="45.533"
          y1="53.293"
          y2="53.261"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_1223_115914"
          x1="46.334"
          x2="45.635"
          y1="60.92"
          y2="60.888"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_1223_115914"
          x1="31.304"
          x2="29.557"
          y1="59.37"
          y2="59.29"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint28_linear_1223_115914"
          x1="33.433"
          x2="32.035"
          y1="63.812"
          y2="63.748"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint29_linear_1223_115914"
          x1="39.852"
          x2="38.806"
          y1="68.218"
          y2="68.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint30_linear_1223_115914"
          x1="40.952"
          x2="40.604"
          y1="67.484"
          y2="67.468"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint31_linear_1223_115914"
          x1="44.049"
          x2="43.702"
          y1="66.379"
          y2="66.363"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint32_linear_1223_115914"
          x1="36.201"
          x2="35.502"
          y1="58.861"
          y2="58.829"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint33_linear_1223_115914"
          x1="46.729"
          x2="46.029"
          y1="42.674"
          y2="42.642"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint34_linear_1223_115914"
          x1="43.04"
          x2="41.993"
          y1="40.101"
          y2="40.053"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint35_linear_1223_115914"
          x1="51.643"
          x2="50.943"
          y1="44.377"
          y2="44.345"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint36_linear_1223_115914"
          x1="49.104"
          x2="48.757"
          y1="46.799"
          y2="46.783"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint37_linear_1223_115914"
          x1="43.967"
          x2="43.62"
          y1="47.998"
          y2="47.982"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint38_linear_1223_115914"
          x1="48.151"
          x2="47.804"
          y1="48.465"
          y2="48.449"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint39_linear_1223_115914"
          x1="47.197"
          x2="46.498"
          y1="48.648"
          y2="48.616"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint40_linear_1223_115914"
          x1="70.028"
          x2="16.878"
          y1="32.609"
          y2="29.094"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8596BE"></stop>
          <stop offset="1" stopColor="#D4D6F9"></stop>
        </linearGradient>
        <linearGradient
          id="paint41_linear_1223_115914"
          x1="71.943"
          x2="15.528"
          y1="31.084"
          y2="27.392"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8596BE"></stop>
          <stop offset="1" stopColor="#D4D6F9"></stop>
        </linearGradient>
        <linearGradient
          id="paint42_linear_1223_115914"
          x1="72.723"
          x2="17.344"
          y1="27.945"
          y2="24.411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint43_linear_1223_115914"
          x1="22.528"
          x2="41.984"
          y1="37.826"
          y2="48.695"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#27A7F9"></stop>
          <stop offset="1" stopColor="#4FCCF9" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const IconChart = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="83" height="80" fill="none" viewBox="0 0 83 80">
      <g clipPath="url(#clip0_1223_115976)">
        <path
          fill="url(#paint0_linear_1223_115976)"
          d="M47.562 64.824c3.449 1.99 3.449 5.224 0 7.216-3.449 1.99-9.05 1.99-12.499 0-3.449-1.992-3.449-5.225 0-7.216 3.449-1.992 9.05-1.992 12.499 0z"
          opacity="0.2"
        ></path>
        <path
          fill="url(#paint1_linear_1223_115976)"
          d="M47.563 29.135c-3.449-1.991-9.05-3.234-12.499-1.243-1.727 1-2.591 2.302-2.591 3.611v36.932c0 1.303.864 2.612 2.591 3.611 3.449 1.992 9.05 1.992 12.5 0 1.727-.999 2.59-2.302 2.59-3.611V31.497c0-1.303-.863-2.613-2.59-3.612v1.25z"
        ></path>
        <path
          fill="url(#paint2_linear_1223_115976)"
          d="M47.566 27.794c3.449 1.992 3.449 5.225 0 7.216-3.449 1.992-9.05 1.992-12.499 0-3.449-1.991-3.449-5.224 0-7.216 3.449-1.991 9.05-1.991 12.499 0z"
        ></path>
        <path
          fill="url(#paint3_linear_1223_115976)"
          d="M47.566 64.824c3.449 1.99 3.449 5.224 0 7.216-3.449 1.99-9.05 1.99-12.499 0-3.449-1.992-3.449-5.225 0-7.216 3.449-1.992 9.05-1.992 12.499 0z"
        ></path>
        <g opacity="0.2">
          <path
            fill="url(#paint4_linear_1223_115976)"
            d="M22.32 64.824c3.448 1.99 3.448 5.224 0 7.216-3.449 1.99-9.05 1.99-12.5 0-3.448-1.992-3.448-5.225 0-7.216 3.45-1.992 9.051-1.992 12.5 0z"
            opacity="0.19"
          ></path>
        </g>
        <path
          fill="url(#paint5_linear_1223_115976)"
          d="M22.321 53.16c-3.449-1.992-9.05-1.992-12.499 0-1.728.998-2.592 2.301-2.592 3.61v11.672c0 1.303.864 2.612 2.592 3.612 3.449 1.99 9.05 1.99 12.499 0 1.728-1 2.591-2.302 2.591-3.612V56.771c0-1.303-.863-2.613-2.591-3.611z"
        ></path>
        <path
          fill="url(#paint6_linear_1223_115976)"
          d="M22.324 53.16c3.448 1.99 3.448 5.224 0 7.216-3.449 1.99-9.05 1.99-12.5 0-3.448-1.992-3.448-5.225 0-7.216 3.45-1.992 9.051-1.992 12.5 0z"
        ></path>
        <path
          fill="url(#paint7_linear_1223_115976)"
          d="M22.32 64.824c3.448 1.99 3.448 5.224 0 7.216-3.449 1.99-9.05 1.99-12.5 0-3.448-1.992-3.448-5.225 0-7.216 3.45-1.992 9.051-1.992 12.5 0z"
        ></path>
        <g opacity="0.2">
          <path
            fill="url(#paint8_linear_1223_115976)"
            d="M66.56 73.538c4.882 0 8.84-2.284 8.84-5.103 0-2.818-3.958-5.103-8.84-5.103-4.883 0-8.841 2.285-8.841 5.103 0 2.819 3.958 5.103 8.84 5.103z"
            opacity="0.29"
          ></path>
        </g>
        <path
          fill="url(#paint9_linear_1223_115976)"
          d="M72.802 12.128c-3.448-1.99-9.05-6.074-12.498-4.083-1.721.999-2.585 2.302-2.585 3.611v56.778c0 1.303.864 2.612 2.591 3.611 3.449 1.991 9.05 1.991 12.5 0 1.727-.999 2.59-2.302 2.59-3.611V11.656c0-1.302-.863-2.612-2.59-3.611l-.008 4.083z"
        ></path>
        <path
          fill="#CF1016"
          d="M72.8 7.954c3.449 1.992 3.449 5.225 0 7.217-3.448 1.99-9.05 1.99-12.499 0-3.448-1.992-3.448-5.225 0-7.217 3.449-1.99 9.05-1.99 12.5 0z"
        ></path>
        <path
          fill="url(#paint10_linear_1223_115976)"
          d="M66.56 73.538c4.882 0 8.84-2.284 8.84-5.103 0-2.818-3.958-5.103-8.84-5.103-4.883 0-8.841 2.285-8.841 5.103 0 2.819 3.958 5.103 8.84 5.103z"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1223_115976"
          x1="41.313"
          x2="41.313"
          y1="62.029"
          y2="84.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F97830" stopOpacity="0.22"></stop>
          <stop offset="1" stopColor="#FFDE55"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1223_115976"
          x1="40.008"
          x2="40.008"
          y1="194.852"
          y2="-17.783"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1223_115976"
          x1="56.33"
          x2="36.795"
          y1="50.232"
          y2="17.853"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1223_115976"
          x1="49.354"
          x2="36.795"
          y1="76.278"
          y2="54.883"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1223_115976"
          x1="-44.055"
          x2="-43.38"
          y1="62.029"
          y2="84.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4918D1"></stop>
          <stop offset="1" stopColor="#4A8BFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1223_115976"
          x1="14.765"
          x2="14.765"
          y1="130.439"
          y2="30.719"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1223_115976"
          x1="43.77"
          x2="11.553"
          y1="90.232"
          y2="43.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1223_115976"
          x1="24.108"
          x2="11.549"
          y1="76.278"
          y2="54.883"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1223_115976"
          x1="57.719"
          x2="58.394"
          y1="62.029"
          y2="84.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5592FF"></stop>
          <stop offset="1" stopColor="#69DFED"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_1223_115976"
          x1="66.334"
          x2="66.334"
          y1="17.019"
          y2="76.474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#F97066"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_1223_115976"
          x1="66.334"
          x2="66.334"
          y1="61.859"
          y2="74.145"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#F97066"></stop>
        </linearGradient>
        <clipPath id="clip0_1223_115976">
          <path fill="#fff" d="M0 0H82.254V80H0z" transform="translate(.668)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconComputer = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="78" height="80" fill="none" viewBox="0 0 78 80">
      <path
        fill="url(#paint0_linear_1223_116004)"
        d="M33.972 78.512L74.527 56.76c.715-.381 1.071-.892 1.079-1.428v-2.504c-.012-.65-.53.481-1.53-.055L51.06 40.431c-1.85-.991-4.647-1.098-6.248-.242L4.262 61.94c-.534.287-.921-.929-1.06-.543-.047.128-.016 2.47-.02 2.606-.015.668.502 1.373 1.53 1.924L27.728 78.27c1.85.992 4.648 1.098 6.248.243h-.004z"
      ></path>
      <path
        fill="url(#paint1_linear_1223_116004)"
        d="M34.01 76.246l40.555-21.752c1.6-.859 1.399-2.36-.45-3.351L51.097 38.8c-1.85-.991-4.648-1.097-6.248-.242L4.299 60.309c-1.6.86-1.4 2.36.45 3.352l23.017 12.342c1.849.992 4.647 1.102 6.248.243h-.004z"
      ></path>
      <path
        fill="#fff"
        d="M4.748 63.348L27.764 75.69c1.85.992 4.648 1.098 6.248.243L74.567 54.18c.664-.356 1.016-.822 1.067-1.318.083.61-.264 1.2-1.067 1.63L34.012 76.245c-1.6.859-4.398.752-6.248-.243L4.748 63.66c-1.083-.58-1.596-1.333-1.517-2.034.083.606.592 1.226 1.517 1.722z"
      ></path>
      <path
        fill="url(#paint2_linear_1223_116004)"
        d="M26.8 68.236l32.932-17.662c.66-.352.577-.973-.186-1.38l-12.366-6.63c-.763-.408-1.913-.452-2.572-.1L11.68 60.127c-.66.353-.577.973.186 1.38l12.365 6.63c.763.408 1.913.452 2.573.1H26.8z"
      ></path>
      <path
        fill="#CED3F4"
        d="M46.468 43.615c-.265-.143-.7-.143-.969 0l-2.11 1.13c-.269.144-.269.379 0 .522.265.143.7.143.968 0l2.11-1.13c.27-.144.27-.379 0-.522zm-3.612 1.938c-.265-.143-.7-.143-.969 0l-1 .537c-.268.143-.268.378 0 .52.265.144.7.144.969 0l1-.535c.268-.143.268-.378 0-.522zm-2.502 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.265.143.7.143.968 0l1-.536c.269-.144.269-.379 0-.522zm-2.502 1.344c-.264-.143-.699-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.144-.269.379 0 .522.265.143.7.143.968 0l1-.536c.269-.143.269-.378 0-.522zm-2.502 1.344c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.144.7.144.968 0l1-.536c.269-.143.269-.378 0-.52zm-2.501 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.27.143-.27.378 0 .521.264.143.7.143.968 0l1-.536c.268-.143.268-.378 0-.521zm-2.502 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.265.143.7.143.968 0l1-.536c.269-.144.269-.379 0-.522zm-2.502 1.344c-.264-.143-.699-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.521zm-2.501 1.344c-.265-.144-.7-.144-.968 0l-1 .536c-.269.143-.269.378 0 .52.265.144.7.144.968 0l1-.535c.269-.143.269-.378 0-.521zm-2.502 1.343c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.144.7.144.968 0l1-.536c.27-.143.27-.378 0-.52zM17.84 58.99c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.265.143.7.143.968 0l1-.536c.268-.143.268-.378 0-.521zm-2.553 1.37c-.265-.144-.7-.144-.968 0l-1 .535c-.269.143-.269.378 0 .521.264.144.7.144.968 0l1-.535c.268-.144.268-.379 0-.522zm33.445-15.522l-.861-.463c-.305-.161-.799-.161-1.103 0l-.865.463c-.305.165-.309.43 0 .59l.861.463c.304.162.798.162 1.103 0l.865-.462c.304-.166.309-.43 0-.591zm-3.37 2.397l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591l.862.463c.304.162.798.162 1.102 0zm-1.633.286l-.861-.462c-.305-.162-.799-.162-1.103 0l-.866.462c-.304.166-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59zm-2.502 1.344l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .591l.861.462c.305.162.799.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591zm-5.335 1.938l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.304.162.798.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.162.798.162 1.102 0l.866-.463c.304-.165.308-.429 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.463c-.304.165-.308.429 0 .59zm-2.502 1.344l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.861-.463c-.305-.162-.799-.162-1.103 0l-.866.462c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.305.162.799.162 1.103 0l.866-.462c.304-.165.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.304.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591zm.328.746l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59l.861.463c.305.162.799.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591zm-5.335 1.938l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.102 0l-.866.463c-.304.165-.308.43 0 .591zm-3.663 1.964l.861.463c.305.161.799.161 1.103 0l1.976-1.061c.304-.165.308-.43 0-.591l-.862-.463c-.304-.162-.798-.162-1.102 0l-1.976 1.061c-.305.165-.309.43 0 .591zm36.342-16.083l-.862-.463c-.304-.161-.798-.161-1.102 0l-1.976 1.061c-.304.166-.308.43 0 .591l.861.463c.305.161.799.161 1.103 0l1.976-1.061c.304-.165.308-.43 0-.591zm-3.612 1.938l-.862-.462c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.59zm-2.506 1.935c.305-.165.309-.43 0-.591l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.309.43 0 .59l.861.464c.305.161.799.161 1.103 0l.865-.463zm-2.501 1.343c.304-.165.308-.429 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .592l.862.462c.304.162.798.162 1.102 0l.866-.462zm-4.462.29l-.866.463c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.861-.463c-.305-.162-.799-.162-1.103 0zm-2.45 1.315l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0l.972-.522c.277-.146.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.522c-.277.147-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.52c.277-.148.277-.39 0-.537l-.964-.518c-.273-.146-.72-.146-.996 0zm-2.501 1.344l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.996 0l.972-.521c.276-.147.276-.39 0-.536l-.965-.518c-.272-.147-.719-.147-.995 0zm-2.502 1.344l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0l.972-.522c.277-.147.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.522c-.276.147-.276.389 0 .536l.965.517c.272.147.719.147.995 0l.973-.521c.276-.147.276-.386 0-.536l-.965-.518c-.272-.146-.719-.146-.996 0zm-1.513 2.915l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.522c-.277.146-.277.389 0 .536l.964.517c.273.147.72.147.996 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-4.517.855l.964.518c.273.147.72.147.996 0l.973-.521c.276-.147.276-.39 0-.536l-.965-.518c-.273-.147-.719-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536zm36.449-16.024l-.964-.518c-.273-.147-.72-.147-.996 0l-3.138 1.681c-.277.147-.277.39 0 .537l.964.517c.273.147.72.147.996 0l3.138-1.681c.277-.147.277-.39 0-.536zm-4.667 2.503l-.965-.517c-.272-.147-.719-.147-.995 0l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.996 0l.972-.522c.276-.146.276-.389 0-.535zm-2.502 1.344l-.964-.518c-.273-.146-.72-.146-.996 0l-.972.522c-.277.147-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.52c.277-.148.277-.39 0-.537zm-2.501 1.344l-.965-.518c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.995 0l.973-.521c.276-.147.276-.39 0-.536zm-3.478 2.397l.972-.521c.277-.147.277-.386 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.344l.973-.522c.276-.146.276-.389 0-.536l-.965-.517c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.146.72.146.996 0zm-2.501 1.343l.972-.521c.276-.147.276-.39 0-.536l-.964-.518c-.273-.146-.72-.146-.996 0l-.972.522c-.277.146-.277.389 0 .536l.964.517c.273.147.72.147.996 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.501 1.343l.972-.52c.276-.148.276-.39 0-.537l-.965-.517c-.272-.147-.719-.147-.995 0l-.973.52c-.276.148-.276.39 0 .537l.965.517c.272.147.719.147.995 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.522c-.277.146-.277.385 0 .535l.964.518c.273.147.72.147.996 0zm-1.53.287l-.964-.518c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.995 0l.973-.522c.276-.146.276-.389 0-.535zm-6.94 2.687l.965.517c.273.147.72.147.996 0l2.47-1.325c.277-.147.277-.389 0-.536l-.964-.518c-.273-.146-.72-.146-.996 0l-2.47 1.326c-.277.147-.277.389 0 .536zm36.438-16.032l-.838-.448c-.308-.165-.814-.165-1.126 0l-4.454 2.386c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l4.454-2.386c.312-.169.312-.437 0-.602zm-6.114 3.278l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.127 0l-.841.452c-.312.168-.312.436 0 .602l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-2.502 1.343l-.838-.447c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.502 1.344l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.169.312-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .601l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-2.502 1.343l-.837-.448c-.309-.165-.815-.165-1.127 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.309.165.814.165 1.127 0l.841-.451c.313-.17.313-.437 0-.603zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602zm-2.502 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.501 1.343l-.838-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.168.312-.436 0-.602zm-2.502 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-5.367 1.979l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602zm32.398-14.89l.838.447c.308.166.814.166 1.127 0l1.952-1.046c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-1.953 1.047c-.312.168-.312.436 0 .602zm-2.501 1.343l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602l-.838-.448c-.308-.166-.814-.166-1.127 0l-.841.451c-.313.169-.313.437 0 .602zm-2.502 1.344l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602zM31.628 63.16l.838.448c.308.165.814.165 1.126 0l15.86-8.506c.312-.169.312-.437 0-.602l-.838-.448c-.309-.165-.814-.165-1.127 0l-15.859 8.506c-.312.17-.312.437 0 .602zm-2.501 1.344l.837.448c.309.165.815.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602zm-2.502 1.343l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602zm-2.553 1.37l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602z"
      ></path>
      <path
        fill="#E5E9FF"
        d="M46.468 43.33c-.265-.143-.7-.143-.969 0l-2.11 1.13c-.269.144-.269.379 0 .522.265.143.7.143.968 0l2.11-1.13c.27-.144.27-.379 0-.522zm-3.612 1.938c-.265-.143-.7-.143-.969 0l-1 .536c-.268.143-.268.378 0 .522.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.522zm-2.502 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.265.144.7.144.968 0l1-.536c.269-.143.269-.378 0-.521zm-2.502 1.344c-.264-.144-.699-.144-.968 0l-1 .536c-.268.143-.268.378 0 .52.265.144.7.144.969 0l1-.535c.268-.143.268-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.268.143.7.143.968 0l1-.536c.269-.144.269-.378 0-.522zm-2.502 1.344c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.968 0l1-.536c.269-.143.269-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .537c-.27.143-.27.378 0 .52.264.144.7.144.968 0l1-.535c.268-.143.268-.378 0-.522zm-2.502 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.265.143.7.143.968 0l1-.536c.269-.144.269-.379 0-.522zm-2.502 1.344c-.264-.143-.699-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.144-.269.379 0 .522.265.143.7.143.968 0l1-.536c.269-.143.269-.378 0-.522zm-2.502 1.344c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.144.7.144.968 0l1-.536c.27-.143.27-.378 0-.52zm-2.501 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.265.143.7.143.968 0l1-.536c.268-.143.268-.378 0-.521zm-2.553 1.369c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.264.144.7.144.968 0l1-.536c.268-.143.268-.378 0-.521zm33.445-15.521l-.861-.463c-.305-.162-.799-.162-1.103 0l-.865.462c-.305.166-.309.43 0 .592l.861.462c.304.162.798.162 1.103 0l.865-.462c.304-.166.309-.43 0-.591zm-3.37 2.397l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.102 0zm-1.633.286l-.861-.462c-.305-.162-.799-.162-1.103 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59zm-2.502 1.344l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59l.861.463c.305.162.799.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591zm-5.335 1.938l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.591l-.862-.462c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.304.162.798.162 1.103 0l.865-.462c.305-.166.309-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.162.798.162 1.102 0l.866-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591zm-2.502 1.344l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0l-.866.463c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.305.162.799.162 1.103 0l.866-.462c.304-.166.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.304.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591zm.328.745l-.861-.462c-.304-.162-.798-.162-1.103 0l-.865.462c-.305.166-.308.43 0 .591l.861.463c.305.162.799.162 1.103 0l.865-.462c.305-.166.309-.43 0-.592zm-5.335 1.939l.862.462c.304.162.798.162 1.102 0l.866-.462c.304-.165.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.102 0l-.866.463c-.304.165-.308.43 0 .59zm-3.663 1.964l.861.462c.305.162.799.162 1.103 0l1.976-1.06c.304-.166.308-.43 0-.592l-.862-.462c-.304-.162-.798-.162-1.102 0l-1.976 1.06c-.305.166-.309.43 0 .592zM51.056 45.8l-.862-.463c-.304-.161-.798-.161-1.102 0L47.116 46.4c-.304.165-.308.43 0 .591l.861.463c.305.161.799.161 1.103 0l1.976-1.061c.304-.165.308-.43 0-.591zm-3.612 1.938l-.862-.462c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.59zm-2.506 1.935c.305-.166.309-.43 0-.591l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.309.43 0 .59l.861.463c.305.162.799.162 1.103 0l.865-.462zm-2.501 1.343c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591l.862.463c.304.162.798.162 1.102 0l.866-.463zm-4.462.29l-.866.463c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0zm-2.45 1.315l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.146.72.146.996 0l.972-.522c.277-.147.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.522c-.277.146-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0zm-2.501 1.344l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.996 0l.972-.522c.276-.146.276-.389 0-.535l-.965-.518c-.272-.147-.719-.147-.995 0zm-2.502 1.344l-.972.52c-.277.148-.277.386 0 .537l.964.517c.273.147.72.147.996 0l.972-.52c.277-.148.277-.39 0-.537l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.995 0l.973-.521c.276-.147.276-.39 0-.536l-.965-.518c-.272-.147-.719-.147-.996 0zm-1.513 2.915l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.344l.972-.522c.277-.146.277-.385 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.146.72.146.996 0zm-4.517.855l.964.518c.273.147.72.147.996 0l.973-.522c.276-.147.276-.389 0-.536l-.965-.517c-.273-.147-.719-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536zm36.449-16.024l-.964-.518c-.273-.147-.72-.147-.996 0l-3.138 1.681c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0l3.138-1.681c.277-.147.277-.39 0-.536zm-4.667 2.503l-.965-.517c-.272-.147-.719-.147-.995 0l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.146.719.146.996 0l.972-.522c.276-.147.276-.389 0-.536zm-2.502 1.344l-.964-.518c-.273-.146-.72-.146-.996 0l-.972.522c-.277.147-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.521c.277-.147.277-.39 0-.536zm-2.501 1.344l-.965-.518c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.386 0 .536l.965.518c.272.147.719.147.995 0l.973-.521c.276-.147.276-.39 0-.536zm-3.478 2.397l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.343l.973-.52c.276-.148.276-.39 0-.537l-.965-.517c-.273-.147-.72-.147-.996 0l-.972.52c-.277.148-.277.39 0 .537l.964.517c.273.147.72.147.996 0zm-2.501 1.344l.972-.521c.276-.147.276-.386 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.344l.972-.522c.277-.146.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.501 1.343l.972-.521c.276-.147.276-.39 0-.536l-.965-.518c-.272-.146-.719-.146-.995 0l-.973.522c-.276.147-.276.389 0 .536l.965.517c.272.147.719.147.995 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-1.53.286l-.964-.517c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.146.719.146.995 0l.973-.522c.276-.146.276-.389 0-.536zm-6.94 2.688l.965.517c.273.147.72.147.996 0l2.47-1.325c.277-.147.277-.39 0-.536l-.964-.518c-.273-.146-.72-.146-.996 0l-2.47 1.326c-.277.146-.277.389 0 .536zm36.438-16.032l-.838-.448c-.308-.165-.814-.165-1.126 0l-4.454 2.386c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l4.454-2.386c.312-.169.312-.437 0-.602zm-6.114 3.278l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.127 0l-.841.451c-.312.17-.312.437 0 .602l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.502 1.343l-.838-.447c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.168.312-.436 0-.602zm-2.502 1.344l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.169.312-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.502 1.343l-.837-.448c-.309-.165-.815-.165-1.127 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.309.165.814.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-2.502 1.343l-.838-.447c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.501 1.344l-.838-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.169.312-.437 0-.602zm-2.502 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.451c-.312.17-.312.437 0 .603l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-5.367 1.978l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602zm32.398-14.89l.838.448c.308.166.814.166 1.127 0l1.952-1.046c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-1.953 1.046c-.312.17-.312.437 0 .602zm-2.501 1.344l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.447c-.308-.166-.814-.166-1.127 0l-.841.451c-.313.169-.313.437 0 .602zm-2.502 1.344l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602zm-17.519 9.394l.838.448c.308.165.814.165 1.126 0l15.86-8.506c.312-.169.312-.437 0-.602l-.838-.448c-.309-.165-.814-.165-1.127 0l-15.859 8.506c-.312.169-.312.437 0 .602zm-2.501 1.344l.837.448c.309.165.815.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602zm-2.502 1.343l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.451c-.312.17-.312.437 0 .602zm-2.553 1.37l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.436 0 .602z"
      ></path>
      <path
        fill="url(#paint3_linear_1223_116004)"
        d="M4.342 60.25L46.02 37.924c1.43-.767 2.592-2.827 2.592-4.6V2.752C48.612.98 47.45.164 46.02.932L4.342 23.254c-1.43.768-2.592 2.827-2.592 4.6v30.57c0 1.773 1.162 2.588 2.592 1.82v.004z"
      ></path>
      <path
        fill="url(#paint4_linear_1223_116004)"
        d="M4.005 58.864l41.282-22.111c1.154-.68 1.866-2.041 1.866-3.429V2.62c0-.33-.387-.536-.692-.367a3.294 3.294 0 00-.083.044l-41.31 22.13c-1.37.734-1.865 2.04-1.865 3.432v30.64c0 .352.411.575.743.4l.06-.034z"
      ></path>
      <path
        fill="#AFB6E5"
        d="M3.203 27.858v30.64c0 .352.411.575.743.4l.06-.034 41.282-22.111c1.154-.68 1.865-2.041 1.865-3.429V2.62c0-.33-.387-.536-.692-.367a3.294 3.294 0 00-.083.044l-41.31 22.13c-1.37.734-1.865 2.04-1.865 3.432zm.293 0c0-1.04.296-2.434 1.719-3.198L46.608 2.487a.175.175 0 01.082-.022c.083 0 .17.058.17.158V33.32c0 1.325-.68 2.58-1.719 3.197L3.804 58.662a.203.203 0 01-.103.026c-.099 0-.205-.073-.205-.19v-30.64z"
      ></path>
      <path
        fill="url(#paint5_linear_1223_116004)"
        d="M3.147 22.613L44.824.289c.566-.305 1.091-.36 1.518-.206.055.019 1.237.657 1.288.683-.442-.198-1.003-.161-1.612.165L4.341 23.255c-1.431.768-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-1.276-.709-1.308-.731-.494-.32-.798-.98-.798-1.89V27.216c0-1.774 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint6_linear_1223_116004)"
        d="M3.167 22.628L44.844.301c.565-.305 1.09-.36 1.517-.206.056.018 1.214.642 1.265.672-.442-.198-1.004-.162-1.612.165L4.34 23.256c-1.43.767-2.592 2.827-2.592 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.032-.018-1.253-.697-1.285-.716-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.832 2.593-4.6h-.004z"
      ></path>
      <path
        fill="url(#paint7_linear_1223_116004)"
        d="M3.19 22.64L44.868.316c.565-.304 1.09-.36 1.517-.205.055.018 1.194.631 1.245.657-.443-.198-1.004-.162-1.613.165L4.34 23.257c-1.43.767-2.592 2.827-2.592 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.473.473 0 01-.225-.074c-.032-.018-1.233-.683-1.265-.705-.494-.32-.798-.98-.798-1.89V27.244c0-1.773 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint8_linear_1223_116004)"
        d="M3.217 22.654L44.891.33c.565-.305 1.09-.36 1.517-.206.056.019 1.17.617 1.222.643-.443-.198-1.004-.162-1.613.165L4.344 23.256c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.473.473 0 01-.225-.074c-.031-.018-1.21-.668-1.24-.69-.495-.32-.799-.98-.799-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint9_linear_1223_116004)"
        d="M3.233 22.667L44.91.34c.566-.305 1.091-.36 1.518-.206.055.018 1.15.602 1.197.632-.442-.199-1.003-.162-1.612.165L4.34 23.255c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.048a.472.472 0 01-.225-.073c-.032-.018-1.19-.657-1.221-.676-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.161-3.832 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint10_linear_1223_116004)"
        d="M3.257 22.68L44.93.354c.565-.304 1.09-.36 1.517-.205.056.018 1.127.59 1.178.616-.443-.198-1.004-.161-1.612.166L4.339 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.473.473 0 01-.225-.073c-.032-.019-1.166-.643-1.198-.665-.494-.319-.798-.98-.798-1.89V27.283c0-1.773 1.162-3.833 2.593-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint11_linear_1223_116004)"
        d="M3.28 22.695L44.957.371c.565-.305 1.091-.36 1.518-.206.055.019 1.106.577 1.154.602-.443-.198-1.004-.161-1.613.166L4.343 23.257c-1.43.767-2.592 2.826-2.592 4.6V58.43c0 1.105.45 1.839 1.138 2.048a.472.472 0 01-.226-.073c-.031-.019-1.146-.628-1.177-.65-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.161-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint12_linear_1223_116004)"
        d="M3.303 22.709L44.977.38c.565-.305 1.09-.36 1.517-.206.056.018 1.083.565 1.135.591-.443-.198-1.004-.161-1.613.165L4.343 23.255c-1.43.768-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.473.473 0 01-.225-.073c-.031-.019-1.122-.617-1.154-.636-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.832 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint13_linear_1223_116004)"
        d="M3.319 22.72L44.996.396c.566-.304 1.091-.36 1.518-.205.055.018 1.059.55 1.11.576-.442-.198-1.003-.161-1.612.165L4.339 23.256c-1.431.768-2.593 2.827-2.593 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.032-.018-1.103-.602-1.134-.624-.494-.319-.798-.98-.798-1.89V27.324c0-1.773 1.161-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint14_linear_1223_116004)"
        d="M3.342 22.734L45.016.41c.565-.305 1.09-.36 1.517-.206.056.019 1.04.536 1.091.562-.443-.198-1.004-.161-1.612.165L4.338 23.255c-1.43.768-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-1.08-.592-1.11-.61-.495-.32-.799-.98-.799-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint15_linear_1223_116004)"
        d="M3.362 22.75L45.039.422c.566-.305 1.091-.36 1.518-.206.055.018 1.015.525 1.067.55C47.18.57 46.62.607 46.01.933L4.338 23.256c-1.43.767-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.032-.018-1.06-.576-1.091-.595-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.161-3.832 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint16_linear_1223_116004)"
        d="M3.39 22.761L45.066.437c.565-.304 1.09-.36 1.517-.205.056.018.996.51 1.047.536-.442-.199-1.003-.162-1.612.165L4.342 23.257c-1.43.767-2.593 2.827-2.593 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.031-.018-1.035-.562-1.067-.584-.494-.319-.798-.98-.798-1.89V27.365c0-1.773 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint17_linear_1223_116004)"
        d="M3.409 22.775L45.086.447c.565-.305 1.09-.36 1.518-.206.055.019.972.496 1.023.522-.442-.198-1.004-.162-1.612.165L4.34 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.473.473 0 01-.225-.073c-.032-.019-1.016-.55-1.043-.57-.494-.319-.799-.98-.799-1.89v-30.57c0-1.772 1.162-3.832 2.593-4.6h-.004z"
      ></path>
      <path
        fill="url(#paint18_linear_1223_116004)"
        d="M3.428 22.785L45.106.46c.565-.305 1.09-.36 1.517-.206.056.019.953.485 1.004.51-.443-.198-1.004-.161-1.612.166L4.337 23.255c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.473.473 0 01-.225-.073l-1.024-.554c-.494-.32-.798-.98-.798-1.891v-30.57c0-1.773 1.162-3.832 2.592-4.6v-.003z"
      ></path>
      <path
        fill="url(#paint19_linear_1223_116004)"
        d="M3.452 22.8L45.129.476c.565-.304 1.09-.36 1.518-.205.055.018.928.47.98.495-.443-.198-1.004-.161-1.613.166L4.341 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.472.472 0 01-.226-.073c-.031-.019-.972-.522-1-.544-.493-.319-.798-.98-.798-1.89V27.404c0-1.773 1.162-3.833 2.593-4.6l-.004-.003z"
      ></path>
      <path
        fill="url(#paint20_linear_1223_116004)"
        d="M3.475 22.816L45.153.488c.565-.305 1.09-.36 1.517-.205.055.018.91.455.96.48-.442-.198-1.003-.161-1.612.166L4.341 23.256c-1.43.768-2.593 2.827-2.593 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.031-.018-.948-.51-.98-.528-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint21_linear_1223_116004)"
        d="M3.495 22.826L45.172.502c.565-.305 1.09-.36 1.518-.206.055.019.885.444.936.47-.442-.198-1.003-.161-1.612.165L4.34 23.255c-1.43.768-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-.925-.496-.956-.518-.494-.32-.799-.98-.799-1.89V27.428c0-1.773 1.162-3.832 2.593-4.6l-.004-.003z"
      ></path>
      <path
        fill="url(#paint22_linear_1223_116004)"
        d="M3.518 22.84L45.196.515c.565-.304 1.09-.36 1.517-.205.056.018.866.43.917.455-.443-.198-1.004-.161-1.612.165L4.34 23.254c-1.43.768-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-.905-.481-.937-.503-.494-.32-.798-.98-.798-1.891V27.443c0-1.773 1.162-3.833 2.592-4.6v-.003z"
      ></path>
      <path
        fill="url(#paint23_linear_1223_116004)"
        d="M3.542 22.855L45.219.527c.565-.305 1.09-.36 1.517-.205.056.018.842.414.894.444-.443-.198-1.004-.162-1.613.165L4.344 23.255c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.139 2.049a.472.472 0 01-.226-.074c-.031-.018-.881-.47-.913-.488-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.833 2.593-4.6h-.004z"
      ></path>
      <path
        fill="url(#paint24_linear_1223_116004)"
        d="M3.561 22.867L45.24.543c.565-.305 1.09-.36 1.517-.206.055.019.822.404.873.43-.442-.199-1.003-.162-1.612.165L4.34 23.256c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.031-.018-.861-.455-.893-.477-.494-.32-.798-.98-.798-1.89V27.47c0-1.774 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint25_linear_1223_116004)"
        d="M3.58 22.883L45.259.558c.565-.304 1.09-.36 1.518-.205.055.018.798.389.85.415-.443-.199-1.005-.162-1.613.165L4.339 23.257c-1.43.767-2.592 2.827-2.592 4.6V58.43c0 1.105.45 1.84 1.138 2.048a.473.473 0 01-.225-.073c-.032-.018-.838-.44-.87-.462-.494-.32-.798-.98-.798-1.891v-30.57c0-1.773 1.162-3.832 2.593-4.6H3.58z"
      ></path>
      <path
        fill="url(#paint26_linear_1223_116004)"
        d="M3.608 22.896L45.285.568c.566-.305 1.091-.36 1.518-.205.055.018.779.374.83.403-.443-.198-1.004-.161-1.613.166L4.343 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.472.472 0 01-.225-.073c-.032-.019-.818-.43-.85-.448-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="#fff"
        d="M4.217 23.2L45.895.874c.589-.316 1.126-.36 1.56-.187-.37-.055-.797.03-1.248.271L4.53 23.285c-1.43.767-2.593 2.827-2.593 4.604v30.57c0 1.045.407 1.754 1.032 2.004-.799-.118-1.344-.881-1.344-2.093V27.8c0-1.772 1.162-3.832 2.592-4.6z"
      ></path>
      <path
        stroke="url(#paint27_linear_1223_116004)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M14 26l10.5 3"
      ></path>
      <path
        stroke="url(#paint28_linear_1223_116004)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M33 21l6 2"
      ></path>
      <path
        stroke="url(#paint29_linear_1223_116004)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M37 28l4 1"
      ></path>
      <path
        stroke="url(#paint30_linear_1223_116004)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M18 38l20 5"
      ></path>
      <circle
        cx="51.145"
        cy="34.147"
        r="10.767"
        fill="url(#paint31_linear_1223_116004)"
        transform="rotate(172.08 51.145 34.147)"
      ></circle>
      <defs>
        <linearGradient
          id="paint0_linear_1223_116004"
          x1="131.449"
          x2="7.658"
          y1="51.392"
          y2="71.805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#CFD1E8"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1223_116004"
          x1="102.204"
          x2="34.631"
          y1="85.826"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.85"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1223_116004"
          x1="38.348"
          x2="12.714"
          y1="59.48"
          y2="13.017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.14" stopColor="#B5BCE8"></stop>
          <stop offset="0.35" stopColor="#C7CDF0"></stop>
          <stop offset="0.58" stopColor="#E5E9FF"></stop>
          <stop offset="0.86" stopColor="#F4F6FF"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1223_116004"
          x1="81.287"
          x2="-20.554"
          y1="19.151"
          y2="43.212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.14" stopColor="#B5BCE8"></stop>
          <stop offset="0.35" stopColor="#C7CDF0"></stop>
          <stop offset="0.58" stopColor="#E5E9FF"></stop>
          <stop offset="0.86" stopColor="#F4F6FF"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1223_116004"
          x1="-68.808"
          x2="27.01"
          y1="30.496"
          y2="94.641"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.498" stopColor="#0197EC" stopOpacity="0.98"></stop>
          <stop offset="0.938" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1223_116004"
          x1="34.324"
          x2="3.011"
          y1="-5.684"
          y2="61.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3BAE7"></stop>
          <stop offset="0.19" stopColor="#B7BDE9"></stop>
          <stop offset="0.28" stopColor="#BAC0E9"></stop>
          <stop offset="0.41" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B3BAE7"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1223_116004"
          x1="34.336"
          x2="3.023"
          y1="-5.676"
          y2="61.854"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4BBE8"></stop>
          <stop offset="0.19" stopColor="#B9BEEA"></stop>
          <stop offset="0.28" stopColor="#BCC2EA"></stop>
          <stop offset="0.41" stopColor="#B2B8E6"></stop>
          <stop offset="0.43" stopColor="#B2B8E6"></stop>
          <stop offset="0.54" stopColor="#B3B9E6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B4BBE8"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1223_116004"
          x1="34.343"
          x2="3.034"
          y1="-5.668"
          y2="61.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B5BCE8"></stop>
          <stop offset="0.19" stopColor="#BAC0EA"></stop>
          <stop offset="0.28" stopColor="#BDC3EB"></stop>
          <stop offset="0.41" stopColor="#B4BBE7"></stop>
          <stop offset="0.43" stopColor="#B4BBE7"></stop>
          <stop offset="0.54" stopColor="#B7BDE7"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B5BCE8"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1223_116004"
          x1="34.359"
          x2="3.049"
          y1="-5.661"
          y2="61.865"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7BDE9"></stop>
          <stop offset="0.19" stopColor="#BCC1EB"></stop>
          <stop offset="0.28" stopColor="#BFC5EC"></stop>
          <stop offset="0.41" stopColor="#B7BDE9"></stop>
          <stop offset="0.43" stopColor="#B7BDE9"></stop>
          <stop offset="0.54" stopColor="#BAC0E9"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B7BDE9"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_1223_116004"
          x1="34.363"
          x2="3.057"
          y1="-5.655"
          y2="61.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8BFE9"></stop>
          <stop offset="0.19" stopColor="#BDC3EC"></stop>
          <stop offset="0.28" stopColor="#C1C6EC"></stop>
          <stop offset="0.41" stopColor="#B9C0EA"></stop>
          <stop offset="0.43" stopColor="#B9C0EA"></stop>
          <stop offset="0.54" stopColor="#BEC4EA"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B8BFE9"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_1223_116004"
          x1="34.374"
          x2="3.068"
          y1="-5.643"
          y2="61.875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9C0EA"></stop>
          <stop offset="0.19" stopColor="#BFC4ED"></stop>
          <stop offset="0.28" stopColor="#C2C8ED"></stop>
          <stop offset="0.41" stopColor="#BCC2EB"></stop>
          <stop offset="0.43" stopColor="#BCC2EB"></stop>
          <stop offset="0.54" stopColor="#C2C7EB"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B9C0EA"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_1223_116004"
          x1="34.39"
          x2="3.084"
          y1="-5.635"
          y2="61.884"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAC1EA"></stop>
          <stop offset="0.19" stopColor="#C0C6ED"></stop>
          <stop offset="0.28" stopColor="#C4C9EE"></stop>
          <stop offset="0.41" stopColor="#BEC4EC"></stop>
          <stop offset="0.43" stopColor="#BEC5EC"></stop>
          <stop offset="0.54" stopColor="#C6CBEC"></stop>
          <stop offset="0.7" stopColor="#B2B9E6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#BAC1EA"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_1223_116004"
          x1="34.397"
          x2="3.091"
          y1="-5.629"
          y2="61.886"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC2EB"></stop>
          <stop offset="0.19" stopColor="#C2C7EE"></stop>
          <stop offset="0.28" stopColor="#C6CBEF"></stop>
          <stop offset="0.41" stopColor="#C1C7ED"></stop>
          <stop offset="0.43" stopColor="#C1C7EE"></stop>
          <stop offset="0.54" stopColor="#CACEEE"></stop>
          <stop offset="0.68" stopColor="#B6BCE7"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.99" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BCC2EB"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_1223_116004"
          x1="34.405"
          x2="3.099"
          y1="-5.621"
          y2="61.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDC3EC"></stop>
          <stop offset="0.19" stopColor="#C4C9EF"></stop>
          <stop offset="0.28" stopColor="#C7CDF0"></stop>
          <stop offset="0.41" stopColor="#C3C9EF"></stop>
          <stop offset="0.43" stopColor="#C4C9EF"></stop>
          <stop offset="0.54" stopColor="#CDD2EF"></stop>
          <stop offset="0.66" stopColor="#B9BFE8"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.98" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BDC3EC"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_1223_116004"
          x1="34.413"
          x2="3.11"
          y1="-5.614"
          y2="61.897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BEC4EC"></stop>
          <stop offset="0.19" stopColor="#C5CAEF"></stop>
          <stop offset="0.28" stopColor="#C9CEF1"></stop>
          <stop offset="0.41" stopColor="#C6CBF0"></stop>
          <stop offset="0.43" stopColor="#C6CCF0"></stop>
          <stop offset="0.53" stopColor="#D0D4F0"></stop>
          <stop offset="0.54" stopColor="#D1D5F0"></stop>
          <stop offset="0.65" stopColor="#BDC3E9"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.98" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BEC4EC"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1223_116004"
          x1="34.424"
          x2="3.122"
          y1="-5.606"
          y2="61.905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFC5ED"></stop>
          <stop offset="0.19" stopColor="#C7CCF0"></stop>
          <stop offset="0.28" stopColor="#CBD0F2"></stop>
          <stop offset="0.41" stopColor="#C8CEF1"></stop>
          <stop offset="0.43" stopColor="#C9CEF1"></stop>
          <stop offset="0.52" stopColor="#D3D7F1"></stop>
          <stop offset="0.54" stopColor="#D5D9F1"></stop>
          <stop offset="0.64" stopColor="#C1C6EA"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.98" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BFC5ED"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_1223_116004"
          x1="34.436"
          x2="3.137"
          y1="-5.594"
          y2="61.909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1C7ED"></stop>
          <stop offset="0.19" stopColor="#C8CDF1"></stop>
          <stop offset="0.28" stopColor="#CCD1F2"></stop>
          <stop offset="0.41" stopColor="#CBD0F2"></stop>
          <stop offset="0.43" stopColor="#CBD1F3"></stop>
          <stop offset="0.51" stopColor="#D5D8F3"></stop>
          <stop offset="0.54" stopColor="#D9DCF3"></stop>
          <stop offset="0.63" stopColor="#C5CAEC"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.97" stopColor="#B9C0E9"></stop>
          <stop offset="1" stopColor="#C1C7ED"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_1223_116004"
          x1="34.447"
          x2="3.148"
          y1="-5.588"
          y2="61.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2C8EE"></stop>
          <stop offset="0.19" stopColor="#CACFF2"></stop>
          <stop offset="0.28" stopColor="#CED3F3"></stop>
          <stop offset="0.41" stopColor="#CDD3F3"></stop>
          <stop offset="0.43" stopColor="#CED3F4"></stop>
          <stop offset="0.51" stopColor="#D8DBF4"></stop>
          <stop offset="0.54" stopColor="#DDE0F4"></stop>
          <stop offset="0.62" stopColor="#C9CEED"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.97" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#C2C8EE"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_1223_116004"
          x1="34.455"
          x2="3.156"
          y1="-5.582"
          y2="61.918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C3C9EE"></stop>
          <stop offset="0.19" stopColor="#CBD0F2"></stop>
          <stop offset="0.28" stopColor="#D0D4F4"></stop>
          <stop offset="0.41" stopColor="#D0D5F4"></stop>
          <stop offset="0.43" stopColor="#D0D6F5"></stop>
          <stop offset="0.5" stopColor="#DADDF5"></stop>
          <stop offset="0.54" stopColor="#E1E3F5"></stop>
          <stop offset="0.62" stopColor="#CDD1EE"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.97" stopColor="#B9C0E9"></stop>
          <stop offset="1" stopColor="#C3C9EE"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_1223_116004"
          x1="34.467"
          x2="3.171"
          y1="-5.574"
          y2="61.922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4CAEF"></stop>
          <stop offset="0.19" stopColor="#CDD2F3"></stop>
          <stop offset="0.28" stopColor="#D1D6F5"></stop>
          <stop offset="0.41" stopColor="#D2D7F6"></stop>
          <stop offset="0.43" stopColor="#D3D8F6"></stop>
          <stop offset="0.5" stopColor="#DDE0F6"></stop>
          <stop offset="0.54" stopColor="#E4E7F6"></stop>
          <stop offset="0.61" stopColor="#D0D4EF"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#C4CAEF"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_1223_116004"
          x1="34.478"
          x2="3.183"
          y1="-5.566"
          y2="61.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6CBF0"></stop>
          <stop offset="0.19" stopColor="#CFD3F4"></stop>
          <stop offset="0.28" stopColor="#D3D8F6"></stop>
          <stop offset="0.41" stopColor="#D5DAF7"></stop>
          <stop offset="0.43" stopColor="#D6DAF8"></stop>
          <stop offset="0.5" stopColor="#E0E2F8"></stop>
          <stop offset="0.54" stopColor="#E8EAF8"></stop>
          <stop offset="0.61" stopColor="#D4D8F1"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9BFEA"></stop>
          <stop offset="1" stopColor="#C6CBF0"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_1223_116004"
          x1="34.486"
          x2="3.194"
          y1="-5.559"
          y2="61.933"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C7CCF0"></stop>
          <stop offset="0.19" stopColor="#D0D5F4"></stop>
          <stop offset="0.28" stopColor="#D5D9F7"></stop>
          <stop offset="0.41" stopColor="#D7DCF8"></stop>
          <stop offset="0.43" stopColor="#D8DDF9"></stop>
          <stop offset="0.49" stopColor="#E2E5F9"></stop>
          <stop offset="0.54" stopColor="#ECEEF9"></stop>
          <stop offset="0.61" stopColor="#D8DBF2"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9BFE9"></stop>
          <stop offset="1" stopColor="#C7CCF0"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_1223_116004"
          x1="34.498"
          x2="3.206"
          y1="-5.549"
          y2="61.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C8CDF1"></stop>
          <stop offset="0.19" stopColor="#D2D6F5"></stop>
          <stop offset="0.28" stopColor="#D6DBF8"></stop>
          <stop offset="0.41" stopColor="#DADEF9"></stop>
          <stop offset="0.43" stopColor="#DBDFFA"></stop>
          <stop offset="0.49" stopColor="#E5E7FA"></stop>
          <stop offset="0.54" stopColor="#F0F1FA"></stop>
          <stop offset="0.6" stopColor="#DCDFF3"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9BFEA"></stop>
          <stop offset="1" stopColor="#C8CDF1"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_1223_116004"
          x1="34.513"
          x2="3.221"
          y1="-5.541"
          y2="61.944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C9CFF1"></stop>
          <stop offset="0.19" stopColor="#D3D8F6"></stop>
          <stop offset="0.28" stopColor="#D8DCF8"></stop>
          <stop offset="0.41" stopColor="#DCE1FA"></stop>
          <stop offset="0.43" stopColor="#DDE2FB"></stop>
          <stop offset="0.49" stopColor="#E7EAFB"></stop>
          <stop offset="0.54" stopColor="#F4F5FB"></stop>
          <stop offset="0.6" stopColor="#E0E3F4"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#C9CFF1"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_1223_116004"
          x1="34.517"
          x2="3.229"
          y1="-5.533"
          y2="61.952"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBD0F2"></stop>
          <stop offset="0.19" stopColor="#D5D9F7"></stop>
          <stop offset="0.28" stopColor="#DADEF9"></stop>
          <stop offset="0.41" stopColor="#DFE3FC"></stop>
          <stop offset="0.43" stopColor="#E0E4FD"></stop>
          <stop offset="0.49" stopColor="#EAECFD"></stop>
          <stop offset="0.54" stopColor="#F7F8FD"></stop>
          <stop offset="0.6" stopColor="#E3E5F6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#CBD0F2"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_1223_116004"
          x1="34.529"
          x2="3.24"
          y1="-5.525"
          y2="61.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCD1F2"></stop>
          <stop offset="0.19" stopColor="#D6DBF7"></stop>
          <stop offset="0.28" stopColor="#DBDFFA"></stop>
          <stop offset="0.41" stopColor="#E1E6FD"></stop>
          <stop offset="0.43" stopColor="#E2E7FE"></stop>
          <stop offset="0.48" stopColor="#ECEFFE"></stop>
          <stop offset="0.54" stopColor="#FBFCFE"></stop>
          <stop offset="0.59" stopColor="#E7E9F7"></stop>
          <stop offset="0.71" stopColor="#B4BBE6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#B9C0E9"></stop>
          <stop offset="1" stopColor="#CCD1F2"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_1223_116004"
          x1="34.54"
          x2="3.255"
          y1="-5.519"
          y2="61.962"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD2F3"></stop>
          <stop offset="0.43" stopColor="#E5E9FF"></stop>
          <stop offset="0.48" stopColor="#EFF1FF"></stop>
          <stop offset="0.54" stopColor="#fff"></stop>
          <stop offset="0.59" stopColor="#EBEDF8"></stop>
          <stop offset="0.7" stopColor="#B8BEE8"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#CDD2F3"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_1223_116004"
          x1="11.5"
          x2="33"
          y1="26"
          y2="32.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB"></stop>
        </linearGradient>
        <linearGradient
          id="paint28_linear_1223_116004"
          x1="30"
          x2="43.05"
          y1="20"
          y2="22.303"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.98"></stop>
        </linearGradient>
        <linearGradient
          id="paint29_linear_1223_116004"
          x1="35"
          x2="43.5"
          y1="27.5"
          y2="29.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.98"></stop>
        </linearGradient>
        <linearGradient
          id="paint30_linear_1223_116004"
          x1="14"
          x2="48"
          y1="38.5"
          y2="46.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.99"></stop>
        </linearGradient>
        <linearGradient
          id="paint31_linear_1223_116004"
          x1="40.378"
          x2="74.382"
          y1="19.343"
          y2="20.613"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#EA2127"></stop>
          <stop offset="0.771" stopColor="#F28A8D"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const IconCodelessGui = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="63" height="52" fill="none" viewBox="0 0 63 52">
      <path
        fill="#667085"
        d="M1.834 38.584v.762c0 2.246.019 2.267 2.237 2.267H7.4c.152 0 .305 0 .456.006.564.035.903.328.91.898.005.57-.356.908-.899.915-1.762.024-3.528.075-5.284-.025-1.517-.086-2.574-1.32-2.576-2.855-.008-10.005-.009-20.01-.004-30.016 0-.695.359-1.118.908-1.116.589 0 .922.45.922 1.25V36.663h58.992v-2.535c0-.77.315-1.196.877-1.215.589-.021.954.434.956 1.22.005 2.087.013 4.176 0 6.264-.014 1.844-1.236 3.043-3.095 3.049-6.048.006-12.096.006-18.143 0h-.812v3.043h.712c1.718 0 3.435-.01 5.155 0 1.66.012 2.878 1.178 2.89 2.731.01 1.54-1.141 2.693-2.775 2.772-.197.01-.393.007-.59.008-9.79 0-19.58-.002-29.369-.006-.474 0-.969-.008-1.419-.133-1.32-.37-2.098-1.652-1.903-3.028.188-1.332 1.298-2.317 2.719-2.34 1.762-.028 3.524-.007 5.286-.008h.73v-3.043h-9.797c-.258 0-.59.044-.755-.098-.267-.227-.554-.57-.59-.892-.053-.44.28-.763.755-.825a5.93 5.93 0 01.785-.02H58.84c1.848 0 1.984-.139 1.984-2.019v-1.004H1.834zM31.26 50.167h14.75c.24.006.479-.002.717-.025.508-.064.785-.386.797-.876.014-.466-.251-.785-.708-.89a2.848 2.848 0 00-.648-.045H16.47a2.736 2.736 0 00-.646.046c-.491.123-.735.458-.692.96.039.472.316.753.79.807.239.021.478.029.717.023h14.62zm7.41-3.713v-2.97H23.946v2.97h14.723zM31.366 0h27.997c2.16 0 3.297 1.137 3.298 3.3v26.1c.013.217.003.435-.03.65-.117.508-.437.803-.982.756-.505-.044-.779-.35-.815-.854-.017-.237-.01-.478-.01-.717V3.46c0-1.363-.27-1.63-1.648-1.63H3.443c-1.35 0-1.607.255-1.608 1.585 0 .934.01 1.865 0 2.805-.009.707-.355 1.101-.928 1.1-.573-.002-.898-.375-.903-1.11a400.471 400.471 0 01-.001-3.197C.019 1.19 1.209 0 3.04 0h28.326z"
      ></path>
      <path
        fill="#EC5357"
        d="M40.673 18.54v11.287c0 1.669-.67 2.34-2.324 2.341H27.194c-1.605 0-2.3-.692-2.3-2.305-.004-7.545-.004-15.089 0-22.633 0-1.662.687-2.35 2.33-2.356 3.72-.004 7.438-.004 11.156 0 1.605 0 2.292.702 2.293 2.317.003 3.782.003 7.565 0 11.348zM38.808 6.712h-.698c-3.544 0-7.088.015-10.631-.013-.604-.005-.76.168-.758.763.02 7.37.024 14.738.014 22.106 0 .232.02.463.031.705h12.042V6.714zM21.809 18.544v11.35c0 1.548-.72 2.267-2.28 2.269-3.762.004-7.525.004-11.287 0-1.523 0-2.221-.712-2.222-2.244V7.155c0-1.57.696-2.277 2.257-2.28 3.74-.005 7.48-.005 11.221 0 1.592 0 2.304.726 2.305 2.32.005 3.784.007 7.566.006 11.349zM7.886 6.756v23.509h12.04V6.756H7.886z"
      ></path>
      <path
        fill="#667085"
        d="M54.747 16.811a4.72 4.72 0 11-4.75-4.684 4.69 4.69 0 014.75 4.684zm-1.835.086a2.885 2.885 0 10-2.95 2.834c1.631.022 2.928-1.223 2.95-2.834zM50.038 32.253a4.716 4.716 0 114.711-4.718 4.702 4.702 0 01-4.711 4.718zm2.879-4.77c-.023-1.612-1.32-2.854-2.955-2.827a2.884 2.884 0 102.955 2.827zM50.03 10.863c-.849 0-1.698.032-2.544-.008a2.945 2.945 0 01-2.829-2.861c-.04-1.604 1.08-2.977 2.671-3.059a52.315 52.315 0 015.408 0c1.6.085 2.709 1.458 2.66 3.064a2.924 2.924 0 01-2.827 2.855c-.844.041-1.693.009-2.54.009zm0-1.827c.76 0 1.519.014 2.278 0 .776-.017 1.236-.44 1.253-1.115.018-.707-.45-1.172-1.252-1.178a195.826 195.826 0 00-4.557 0c-.795.008-1.276.485-1.26 1.178.019.664.49 1.1 1.26 1.117.768.017 1.519-.002 2.28-.002h-.003z"
      ></path>
      <path
        fill="#EC5357"
        d="M32.771 13.283c1 0 1.998-.008 2.996 0 .721.008 1.096.335 1.091.916-.005.58-.398.91-1.109.913-1.975.009-3.95.009-5.926 0-.716 0-1.109-.332-1.123-.9-.015-.596.377-.925 1.141-.93.973-.006 1.954.001 2.93.001zM32.728 22.38c-.976 0-1.954.01-2.93 0-.719-.01-1.1-.346-1.099-.917.002-.57.393-.91 1.107-.915 1.975-.01 3.95-.01 5.925 0 .73 0 1.112.32 1.128.89.017.597-.373.934-1.136.943-.998.004-1.996-.001-2.995-.001zM32.798 16.911c.998 0 1.997-.01 2.995 0 .687.01 1.05.324 1.065.883.017.579-.367.946-1.07.95-1.997.014-3.993.014-5.988 0-.71 0-1.102-.357-1.1-.924 0-.567.387-.898 1.105-.907.997-.01 1.995-.002 2.993-.002zM34.416 9.652c.52 0 1.04-.016 1.56 0 .518.015.85.314.878.85.028.57-.295.931-.841.954-1.08.044-2.165.038-3.246 0-.545-.018-.895-.356-.884-.922.01-.566.35-.87.91-.883.54-.014 1.083 0 1.623 0zM31.106 25.992c-.498 0-.997.011-1.494 0-.532-.015-.861-.294-.901-.828-.042-.572.28-.947.821-.972a35.395 35.395 0 013.18 0c.517.023.84.401.817.92-.024.543-.355.87-.93.88-.497.006-.997.001-1.493 0zM13.941 13.282c.982 0 1.955-.007 2.933 0 .756.006 1.17.346 1.158.926-.012.554-.425.902-1.128.905-1.976.008-3.954.008-5.931 0-.702 0-1.12-.354-1.133-.907-.013-.553.423-.918 1.167-.924.978-.005 1.956 0 2.934 0zM13.928 16.91c1 0 1.998-.01 2.998 0 .715.01 1.11.351 1.108.914-.003.564-.407.922-1.115.922-1.977.012-3.954.012-5.93 0-.735 0-1.173-.392-1.148-.958.023-.547.432-.868 1.154-.875.976-.011 1.957-.003 2.933-.002zM13.97 20.537c.982 0 1.956-.008 2.933 0 .715.008 1.118.343 1.13.9.012.556-.385.927-1.092.931-1.999.013-3.997.013-5.996 0-.696 0-1.115-.379-1.105-.926.01-.548.429-.898 1.133-.905.998-.008 1.998 0 2.997 0zM12.362 25.996h-1.56c-.57 0-.892-.313-.957-.858-.058-.5.352-.944.928-.96 1.083-.03 2.166-.03 3.249 0 .589.017.955.431.913.963-.045.572-.388.841-.948.855h-1.625zM15.504 11.483c-.477 0-.953.01-1.43 0-.655-.02-1.03-.36-1.035-.914-.005-.554.361-.905 1.02-.912.975-.012 1.949-.012 2.923 0 .646.007 1.043.36 1.046.9.004.538-.392.896-1.031.929h-.13l-1.363-.003z"
      ></path>
    </svg>
  </span>
);

export const IconDynamicTesting = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" fill="none" viewBox="0 0 53 53">
      <path
        fill="#667085"
        d="M51.657 12.88c-.897-.82-1.962-1.137-3.164-1.134-3.841.013-7.683.01-11.526-.007a1.79 1.79 0 01-.874-.285L36 11.396c.83.578 1.586 1.256 2.25 2.018h10.372c1.31 0 2.287.702 2.59 1.86.075.33.108.67.099 1.008.006 7.802.006 15.605 0 23.408 0 .165-.016.33-.027.559h-.569c-11.576 0-23.154-.004-34.731-.01-.297 0-.667-.086-.88-.272-1.34-1.168-2.862-1.505-4.622-1.411-2.38.126-4.772.031-7.158.031h-.61c-.012-.21-.033-.383-.033-.56V16.294c0-1.89.998-2.879 2.882-2.88h10.18a12.913 12.913 0 011.916-1.785l-.024.015c-.151.1-.385.098-.582.098-3.858.006-7.717.006-11.575 0-1.46 0-2.678.477-3.595 1.64a4.15 4.15 0 00-.886 2.649v26.655c0 2.394 1.848 4.306 4.433 4.283 3.333-.032 6.667-.007 10-.007h.63v3.353h-3.282v1.69h28.438v-1.69h-2.69c-.63 0-.63 0-.635-.63V46.99c.225-.01.42-.028.616-.028 3.332 0 6.665-.01 9.996 0 1.5.006 2.785-.474 3.642-1.724.398-.58.575-1.313.852-1.977v-27.82c-.222-.975-.583-1.87-1.34-2.562zm-3.142 32.413H19.494v1.669h16.702v3.31H17.795v-4.978H5.537c-1.855 0-2.85-.994-2.857-2.852v-2.191h.596c2.911 0 5.823-.007 8.733.01.298.012.587.1.84.257.736.445 1.393 1.117 2.184 1.356.791.238 1.71.067 2.574.067h33.641c.35 1.981-.785 3.35-2.733 3.352z"
      ></path>
      <path
        fill="#EC5357"
        d="M39.595 0v3.353c-.56 0-1.064.02-1.566-.007-.37-.021-.61.089-.85.393-1.41 1.798-2.852 3.572-4.27 5.357-.215.273-.387.372-.75.239-3.435-1.26-6.874-1.26-10.316 0-.357.13-.534.046-.753-.231-1.427-1.806-2.878-3.593-4.307-5.4a.82.82 0 00-.764-.358c-.518.024-1.04.006-1.6.006V.036H1.032v8.326h13.38V5.093c.748-.12 1.326-.112 1.834.59 1.02 1.411 2.157 2.737 3.245 4.097.105.13.203.265.297.39-.723.501-1.414.998-2.127 1.462a12.908 12.908 0 00-1.916 1.786h.017c-3.278 3.898-4.51 8.277-3.514 13.193.706 3.49 2.507 6.374 5.277 8.605a15.03 15.03 0 0019.098-.117 15.088 15.088 0 005.19-14.47 14.468 14.468 0 00-1.68-4.541 16.836 16.836 0 00-1.912-2.666h.037a12.272 12.272 0 00-2.25-2.018H36a6.168 6.168 0 01-.261-.167l-.016-.01c-.498-.324-.986-.676-1.503-1.03.076-.105.154-.23.244-.342 1.089-1.366 2.224-2.69 3.247-4.097.507-.695 1.074-.82 1.865-.643v3.28h12.821c.202 0 .403.02.605.032V0H39.595zm-26.89 6.676H2.708V1.717h9.993l.002 4.96zm8.192 4.877c.42.51.83 1.015 1.26 1.544l1.3-1.037-.935-1.19a11.723 11.723 0 013.65-.735v.716c0 .761.012 1.523-.013 2.282 0 .128-.165.348-.274.362-2.968.368-5.3 1.805-7.09 4.17-.009.013-.028.018-.104.06l-2.852-1.654c1.293-1.957 2.973-3.42 5.052-4.517h.006zm-5.857 5.995l2.866 1.653c-1.273 2.857-1.278 5.694 0 8.566l-2.857 1.644c-1.838-3.263-2.006-8.166-.015-11.863h.006zm11.107 19.306c-4.37-.382-7.773-2.364-10.315-5.95l2.908-1.68c1.84 2.497 4.296 3.95 7.407 4.28v3.35zm-7.531-13.358c-.03-4.584 3.725-8.353 8.35-8.386 4.624-.033 8.41 3.728 8.427 8.36.016 4.585-3.736 8.362-8.35 8.403-4.596.046-8.399-3.741-8.433-8.377h.006zm9.26 13.36v-3.348c3.065-.342 5.54-1.763 7.389-4.291l2.908 1.68c-2.532 3.587-5.932 5.56-10.304 5.96h.006zm11.081-19.303c2.054 3.677 1.79 8.86-.025 11.85l-2.829-1.638c1.272-2.854 1.28-5.69 0-8.562l2.854-1.65zm-.794-1.482l-2.878 1.666c-.35-.402-.675-.808-1.032-1.182a9.796 9.796 0 00-5.987-3.024c-.341-.044-.457-.149-.448-.495.02-.946.007-1.891.007-3.011l3.709.76c-.385.497-.676.877-.99 1.284l1.299 1.038 1.249-1.553a13.437 13.437 0 015.07 4.517zm13.12-9.398H41.276c-.01-.16-.027-.308-.027-.455 0-1.37 0-2.74-.005-4.11 0-.283.051-.432.384-.43 3.146.01 6.291.007 9.437.01.074.007.147.02.218.039v4.946z"
      ></path>
      <path
        fill="#667085"
        d="M49.62 26.867v1.627h-6.64v-1.627h6.64zM49.621 30.22v1.63h-6.64v-1.63h6.64zM42.96 35.193V33.57h6.66v1.623h-6.66zM49.62 36.932v1.628h-6.64v-1.628h6.64zM10.19 16.741H4.383v-1.598h5.808v1.598zM4.367 20.095v-1.597h5.82v1.597h-5.82zM4.367 23.447v-1.6h5.82v1.597l-5.82.003zM4.367 26.801V25.21h5.82v1.596l-5.82-.004zM6.004 43.58H4.379v-1.605h1.625v1.605zM9.365 43.572H7.746v-1.605h1.619v1.605zM12.713 43.58h-1.62v-1.602h1.62v1.601zM4.375 5.006V3.391h6.646v1.615H4.375zM42.96 4.996V3.383h6.66v1.613h-6.66z"
      ></path>
    </svg>
  </span>
);

export const IconMultiPlatforms = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="53" height="52" fill="none" viewBox="0 0 53 52">
      <path
        fill="#667085"
        d="M31.206 10.4v-.651-8.61c0-.85.289-1.137 1.134-1.137h16.787c.869 0 1.145.29 1.145 1.182v9.217c.24 0 .449-.007.657 0 .7.025 1.068.47.926 1.142a217.158 217.158 0 01-.697 3.168c-.157.7-.398.887-1.13.889H31.512c-.824 0-1.032-.165-1.216-.986-.215-.967-.42-1.936-.628-2.906-.192-.896.126-1.302 1.038-1.302.14-.008.283-.006.5-.006zm1.772-8.643V10.4c1.913 0 3.789.016 5.663 0 .657-.009 1.135.16 1.262.86h1.653c.29-.746.448-.851 1.254-.851h5.698V1.757h-15.53zm16.604 12.09l.359-1.69h-6.57c-.144.723-.649.881-1.319.855a34.474 34.474 0 00-2.596 0c-.683.026-1.225-.104-1.348-.848h-6.575l.371 1.687 17.678-.004zM13.192 48.53c.186.77.357 1.468.524 2.17.204.861-.126 1.302-.999 1.302h-6.39c-.813 0-1.157-.434-.982-1.227.164-.723.349-1.432.536-2.198-.189-.016-.339-.038-.491-.038-.938 0-1.881.013-2.815-.007a2.575 2.575 0 01-2.561-2.56c-.019-2.925-.019-5.85 0-8.773a2.542 2.542 0 012.53-2.525c4.656-.018 9.314-.018 13.97 0a2.55 2.55 0 012.55 2.56c.02 2.906.02 5.812 0 8.72a2.577 2.577 0 01-2.596 2.574c-1.062.014-2.126.001-3.276.001zm4.142-5.22c0-2.063.013-4.08-.01-6.096 0-.531-.393-.814-1.012-.814H2.784c-.736 0-1.04.316-1.044 1.064V43.31h15.594zM1.795 45.09c-.186 1.158-.007 1.755 1.39 1.723 2.36-.055 4.723-.016 7.09-.016h6.005c.745 0 1.05-.311 1.062-1.046v-.659l-15.547-.001zm9.6 3.44c-1.17 0-2.302-.007-3.432.012a.434.434 0 00-.337.236c-.145.473-.24.96-.363 1.485h4.205c.104 0 .209-.019.35-.03l-.422-1.702z"
      ></path>
      <path
        fill="#EC5357"
        d="M32.706 23.216c.742.1 1.366.173 1.985.271.595.093.84.382.844.991.01 1.01.01 2.021 0 3.032 0 .628-.253.908-.89 1.013-.604.094-1.21.164-1.944.262.388.495.724.924 1.058 1.353.565.724.548 1.04-.087 1.676-.635.637-1.273 1.28-1.914 1.915-.565.558-.915.579-1.555.08a531.97 531.97 0 00-1.418-1.1c-.094.701-.165 1.302-.258 1.904-.104.676-.376.918-1.034.922-.992.008-1.984.008-2.977 0-.66 0-.932-.245-1.036-.92-.093-.598-.165-1.199-.26-1.898l-1.35 1.04c-.742.58-1.036.555-1.714-.122l-1.882-1.882c-.561-.565-.579-.907-.082-1.551.33-.434.661-.857.99-1.287.016-.021 0-.066 0-.144-.594-.08-1.197-.145-1.796-.243-.678-.104-.915-.374-.92-1.035-.007-.993-.007-1.986 0-2.978 0-.662.241-.93.92-1.035.599-.093 1.202-.164 1.904-.256l-1.098-1.421c-.497-.644-.48-.986.08-1.552.65-.653 1.3-1.304 1.953-1.952.588-.579.92-.6 1.592-.084.434.337.868.676 1.394 1.077.095-.698.166-1.303.26-1.896.109-.699.373-.92 1.085-.923h2.87c.734 0 .987.223 1.102.97.09.58.156 1.169.245 1.852.477-.365.888-.673 1.291-.99.83-.649 1.076-.636 1.834.123.614.61 1.229 1.221 1.836 1.838.536.541.555.898.086 1.512-.339.45-.695.9-1.114 1.439zm-12.788 7.608l1.222 1.303c.456-.352.932-.654 1.327-1.04.579-.56 1.123-.351 1.736-.096.546.227.669.65.724 1.157.056.547.145 1.092.21 1.626h1.761c.078-.631.145-1.24.232-1.846.152-1.012 1.476-1.552 2.289-.933.485.37.965.747 1.434 1.111l1.28-1.244c-.367-.47-.7-.942-1.076-1.375-.376-.433-.405-.858-.182-1.39.236-.564.52-.963 1.187-1.004.578-.034 1.141-.133 1.717-.204v-1.778c-.654-.083-1.283-.145-1.904-.242-.94-.155-1.465-1.485-.895-2.243.378-.5.767-.993 1.106-1.428l-1.21-1.32c-.469.363-.933.679-1.346 1.05-.47.424-.923.42-1.487.186-.565-.235-.91-.586-.947-1.232-.032-.553-.131-1.101-.204-1.664h-1.768c-.077.618-.145 1.223-.23 1.826-.152 1.05-1.478 1.592-2.316.945-.482-.37-.96-.746-1.424-1.108l-1.276 1.247c.36.465.689.937 1.068 1.365.4.454.415.891.188 1.447-.239.572-.547.942-1.207.98-.567.033-1.132.145-1.7.21v1.76c.643.08 1.272.144 1.892.243.977.156 1.498 1.484.9 2.273-.367.478-.746.957-1.1 1.418z"
      ></path>
      <path
        fill="#667085"
        d="M52.005 42.481v6.712c0 1.722-1.082 2.8-2.807 2.805h-6.549c-1.681 0-2.773-1.097-2.774-2.783V35.737c0-1.722 1.083-2.8 2.807-2.802h6.549c1.687 0 2.771 1.089 2.774 2.782.005 2.253 0 4.515 0 6.764zm-9.703-7.764c-.533.123-.695.342-.695 1.088V49.12c0 .854.29 1.145 1.126 1.147h6.387c.868 0 1.157-.29 1.157-1.176v-8.28-5.14c0-.629-.23-.876-.69-.939-.304.59-.495 1.219-.884 1.675-1.109 1.302-4.442 1.286-5.534-.022-.392-.463-.578-1.09-.867-1.667zm1.9-.027c.107.55.397.823.892.836.578.017 1.157.025 1.725 0 .49-.025.781-.3.837-.834l-3.454-.002zM15.605 9.531v6.712c0 1.751-1.08 2.82-2.845 2.822H2.854C1.07 19.064.008 17.991.008 16.192V2.878C.008 1.046 1.063 0 2.905 0h9.797c1.869 0 2.895 1.042 2.903 2.925.002 2.198.002 4.4 0 6.606zm-1.736 0V2.874c.001-.848-.285-1.137-1.135-1.137H2.878c-.853 0-1.142.29-1.142 1.134v13.323c0 .85.29 1.137 1.137 1.137h9.857c.848 0 1.136-.289 1.137-1.136.006-2.22.008-4.441.006-6.662l-.004-.002zM26.88 37.306v6.019h11.232v1.737H26.348c-.95 0-1.207-.264-1.207-1.228v-6.53l1.74.002zM26.872 14.711h-1.727V10.42h-7.762V8.697c.145-.01.29-.029.448-.029h7.896c.853 0 1.142.29 1.143 1.127.003 1.62.002 3.24.002 4.916zM14.727 25.138v1.7h-5.17v6.059H7.813V30.79 26.14c0-.588.277-.984.776-.99 2.026-.025 4.06-.012 6.14-.012zM39.852 17.357h1.736c.008.145.02.264.02.384v7.137c0 .817-.29 1.116-1.098 1.12h-3.205v-1.706h2.551l-.004-6.935z"
      ></path>
      <path
        fill="#EC5357"
        d="M26 21.666a4.334 4.334 0 11-4.328 4.35A4.342 4.342 0 0126 21.666zm.03 6.93a2.599 2.599 0 10-2.622-2.604 2.605 2.605 0 002.621 2.605z"
      ></path>
      <path fill="#667085" d="M6.965 15.56v-1.667H8.63v1.664l-1.666.003z"></path>
    </svg>
  </span>
);

export const IconTestingIntegrate = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="none" viewBox="0 0 52 52">
      <g clipPath="url(#clip0_1926_54732)">
        <path
          fill="#667085"
          d="M49.45 38.277c-1.16.059-2.326.012-3.544.012v-.586-10.61c0-.88-.22-1.096-1.117-1.096h-9.648v1.565h9.212v10.727H40.59c-1.54 0-2.299.763-2.3 2.308 0 .524-.008 1.049 0 1.574.008.525.316.83.764.828.448-.004.743-.324.753-.84.011-.574.011-1.15 0-1.726-.008-.421.173-.625.604-.623 3.148.003 6.297.003 9.445 0 .423 0 .62.178.62.609-.005 3.148-.005 6.297 0 9.445 0 .426-.186.618-.61.617-3.148-.004-6.297-.004-9.445 0-.467 0-.617-.235-.61-.669.012-1.32 0-2.64 0-3.96a3.622 3.622 0 00-.007-.407c-.046-.432-.374-.743-.777-.71-.425.033-.722.276-.726.705-.018 1.608-.047 3.218.017 4.823.035.906.7 1.411 1.493 1.738h10.667A2.539 2.539 0 0052 50.478V39.812c-.452-1.172-1.32-1.598-2.55-1.535zM50.478 0H39.813c-1.177.45-1.6 1.32-1.537 2.55.06 1.161.013 2.325.013 3.544h-8.813c-.858 0-1.088.223-1.088 1.074V16.86h1.569V7.645h8.31c.009.161.023.324.023.486 0 1.184-.008 2.37 0 3.555s.845 2.019 2.02 2.022c3.216.01 6.431 0 9.649 0 1.058 0 1.661-.61 2.042-1.524V1.524A2.53 2.53 0 0050.477 0zm-.804 12.188h-9.137c-.604 0-.723-.114-.723-.701V2.245c0-.61.112-.724.7-.724h9.242c.62.002.722.112.722.754v9.14c0 .682-.095.773-.804.773zM38.574 23.44c.12 0 .251.235.343.383a2.284 2.284 0 004.241-1.08 2.283 2.283 0 00-1.56-2.256 2.234 2.234 0 00-2.7 1.043c-.157.285-.326.37-.631.365-1.016-.016-2.032-.006-3.128-.006v1.53c1.16.003 2.298-.008 3.435.02zm2.284-1.541a.749.749 0 11.031 1.496.747.747 0 01-.57-1.274.747.747 0 01.539-.222zM30.352 38.713c-.383-.214-.46-.459-.448-.844.024-.846.01-1.694.014-2.54.007-.063.019-.127.036-.188h-1.568c0 .807-.019 1.611.007 2.414.016.541-.023.941-.601 1.277-.856.497-1.126 1.633-.789 2.564a2.26 2.26 0 002.247 1.502 2.29 2.29 0 002.113-1.684c.246-.962-.14-2.01-1.011-2.501zm-1.174 2.658a.748.748 0 11.718-.751.73.73 0 01-.718.752zm-6.799-31.6c-1.536.827-1.613 3.034-.111 3.932.345.203.45.42.438.796-.025.768-.008 1.538-.008 2.36h1.524c0-.927-.02-1.828.02-2.73.006-.147.263-.304.432-.42a2.282 2.282 0 00-2.295-3.939zm1.124 2.757a.746.746 0 11.71-.765.733.733 0 01-.71.765zm-.848 31.586h-8.944v-.91c0-.98.012-1.962-.005-2.945-.018-1.096-.839-1.958-1.919-1.964a951.5 951.5 0 00-9.851 0C.93 38.302.362 38.941 0 39.812v10.665A2.53 2.53 0 001.523 52h10.664c1.171-.454 1.597-1.32 1.537-2.551-.06-1.231-.013-2.466-.013-3.78h9.344c.962 0 1.165-.202 1.165-1.161V35.14h-1.564v8.973zm-10.468 5.652c0 .596-.115.71-.71.71H2.235c-.598 0-.712-.114-.712-.71v-9.243c0-.598.113-.71.711-.71h9.243c.598 0 .71.113.71.71v9.243zm5.79-15.058a2.556 2.556 0 01-.654-.643c.171.256.394.474.654.64v.003zm-2.392-6.749a2.276 2.276 0 00-4.152 1.291 2.261 2.261 0 001.546 2.16c.935.321 2.058.028 2.55-.83.332-.58.73-.616 1.33-.515v-1.64c-.766.174-.854.138-1.273-.468l-.001.002zM13.745 30a.747.747 0 11.711-.758.734.734 0 01-.71.756v.002zM2.55 13.723c1.16-.058 2.325-.012 3.544-.012v10.382c0 .948.203 1.15 1.17 1.151h9.595v-1.568H7.641v-9.942c.165-.008.328-.022.49-.022 1.185 0 2.37.008 3.555 0s2.005-.848 2.023-2.022c.01-.61.01-1.219 0-1.828-.008-.524-.292-.842-.736-.855-.469-.015-.773.311-.784.858-.01.546 0 1.083 0 1.625 0 .57-.122.7-.673.7H2.172c-.444 0-.65-.172-.65-.63.007-3.131.007-6.262 0-9.393.001-.447.176-.644.631-.644 3.132.007 6.263.007 9.394 0 .49 0 .65.229.646.689a271.004 271.004 0 000 4.063c0 .635.277.983.766.979.49-.004.752-.355.752-.998 0-1.235-.046-2.473.014-3.706S13.363.45 12.188 0H1.523A2.525 2.525 0 000 1.523v10.664c.45 1.176 1.32 1.598 2.55 1.536z"
        ></path>
        <path
          fill="#667085"
          d="M48.955 42.605c0-.795-.473-1.257-1.267-1.267-.846-.01-1.692 0-2.539 0-.847 0-1.692-.007-2.539 0-.794.01-1.263.473-1.267 1.267a488.415 488.415 0 000 5.078c0 .79.475 1.263 1.266 1.267 1.693.009 3.385.009 5.078 0 .794 0 1.263-.472 1.267-1.267a547.3 547.3 0 000-5.078zm-1.548 4.784h-4.51v-4.507h4.507l.003 4.507zM10.664 4.406c0-.896-.45-1.354-1.332-1.357a677.787 677.787 0 00-4.976 0c-.85.004-1.31.47-1.31 1.33-.004 1.66-.004 3.318 0 4.977 0 .847.472 1.305 1.331 1.307 1.643.006 3.285.006 4.926 0 .914 0 1.354-.454 1.358-1.384V6.894c.003-.83.003-1.659.003-2.488zm-1.55 4.695H4.606V4.593h4.508v4.508zM32.042 26.35c0 1.422.005 2.844 0 4.266-.005 1.006-.418 1.431-1.417 1.433-3.08.008-6.16.008-9.242 0-1.008 0-1.427-.422-1.43-1.422-.005-3.08-.005-6.158 0-9.237 0-1.016.407-1.422 1.413-1.422 1.49-.005 2.978 0 4.47 0 .405 0 .744.102.876.532.162.532-.19.971-.826.985-.947.022-1.894.008-2.844.008H21.51v9.006h8.972v-9.012c-.378 0-.744.012-1.108 0-.568-.024-.88-.305-.874-.774.006-.47.321-.733.894-.743a37.84 37.84 0 011.27 0c.944.011 1.368.419 1.374 1.361.01 1.67.004 3.35.004 5.02zM48.952 4.374c-.007-.862-.46-1.32-1.312-1.32a676.684 676.684 0 00-4.977 0c-.86 0-1.32.458-1.326 1.31a676.676 676.676 0 000 4.976c0 .857.46 1.32 1.31 1.326 1.659.007 3.318.007 4.977 0 .86 0 1.32-.457 1.326-1.31.007-.83 0-1.66 0-2.489s.007-1.664.002-2.493zm-1.56 4.733h-4.506V4.594h4.505v4.513zM10.664 42.62c0-.82-.472-1.274-1.303-1.28-.832-.008-1.66 0-2.489 0H4.384c-.86.005-1.33.458-1.333 1.304a690.267 690.267 0 000 5.026c0 .813.478 1.28 1.305 1.283 1.675.006 3.35.006 5.026 0 .818 0 1.279-.474 1.282-1.304.006-1.677.006-3.353 0-5.03zm-1.56 4.788H4.598v-4.507h4.508v4.507z"
        ></path>
        <path
          fill="#EA2127"
          d="M32.042 26.35c0 1.422.005 2.844 0 4.266-.005 1.006-.418 1.431-1.417 1.433-3.08.008-6.16.008-9.242 0-1.008 0-1.427-.422-1.43-1.422-.005-3.08-.005-6.158 0-9.237 0-1.016.407-1.422 1.413-1.422 1.49-.005 2.978 0 4.47 0 .405 0 .744.102.876.532.162.532-.19.971-.826.985-.947.022-1.894.008-2.844.008H21.51v9.006h8.972v-9.012c-.378 0-.744.012-1.108 0-.568-.024-.88-.305-.874-.774.006-.47.321-.733.894-.743a37.84 37.84 0 011.27 0c.944.011 1.368.419 1.374 1.361.01 1.67.004 3.35.004 5.02z"
        ></path>
        <path
          fill="#667085"
          d="M35.09 28.209c0 1.438.01 2.877 0 4.315-.013 1.573-.952 2.522-2.52 2.569-.475.014-.95 0-1.423 0h-1.186a.401.401 0 01-.01.045h2.65a2.539 2.539 0 002.54-2.54v-5.037h-.05v.648zm.034-2.213h.017v-2.573h-.017v2.573zm-2.522-9.137h-2.647v.057h.595c.727 0 1.455-.016 2.183.006 1.315.04 2.26.951 2.336 2.264.038.624.014 1.251.017 1.878v.829h.055v-2.495a2.539 2.539 0 00-2.54-2.539zm-8.378 18.282h4.164-4.164zm0-18.256h4.164v-.026h-4.164v.026zm-6.532.634c.43-.381 1.024-.595 1.74-.6.898-.009 1.795 0 2.691 0 .178 0 .356-.021.575-.034v-.026h-3.3a2.525 2.525 0 00-1.706.66zm4.218 17.577c-.964-.01-1.93.022-2.89-.045a2.225 2.225 0 01-1.032-.339c.417.28.908.43 1.41.429h3.256v-.045c-.275 0-.513.003-.744 0zm-5.05-11.42h.05v-.594c0-1.219-.013-2.437 0-3.656.01-.717.225-1.307.608-1.734a2.525 2.525 0 00-.659 1.706v4.278zm.05 7.062v-.67l-.05-.006v2.54c-.001.523.16 1.035.463 1.462a2.281 2.281 0 01-.378-1.094c-.058-.74-.028-1.486-.035-2.232zm-.034-5.494h-.017v3.18h.017v-3.18z"
        ></path>
        <path
          fill="#EA2127"
          d="M35.14 23.423v-1.53h-.05v-.829c0-.627.022-1.254-.016-1.878-.08-1.313-1.025-2.224-2.336-2.264-.727-.022-1.456-.005-2.183-.006h-.595v-.057h-1.574v.026h-4.164v-.026h-1.524v.023c-.22.013-.397.032-.575.033-.896 0-1.793-.005-2.691 0-.716.006-1.31.22-1.74.602a3.044 3.044 0 00-.168.168c-.381.427-.597 1.016-.61 1.734-.016 1.218 0 2.437 0 3.656v.594h-.055v1.568h.017v3.176h-.017v1.65l.05.008v.669c.007.744-.023 1.492.035 2.234.03.391.16.768.379 1.094.177.252.399.47.654.643l.01.006c.31.197.665.313 1.032.34.96.066 1.93.034 2.89.044h.745v.04h7.301a.425.425 0 00.01-.045h1.18c.472 0 .947.011 1.421 0 1.57-.047 2.508-.996 2.522-2.569.013-1.438 0-2.877 0-4.315v-.648h.053V26h-.017v-2.577h.017zm-1.576 8.949c0 .938-.265 1.2-1.218 1.2H19.65c-.954 0-1.218-.26-1.218-1.199V19.628c0-.94.256-1.187 1.218-1.187h12.696c.96 0 1.218.248 1.218 1.187.002 4.248.002 8.496 0 12.744z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1926_54732">
          <path fill="#fff" d="M0 0H52V52H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconLightning = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#EA2127"
        d="M10.664 21c-.35 0-.62-.31-.57-.66l.9-6.34h-3.5c-.88 0-.33-.75-.31-.78 1.26-2.23 3.15-5.53 5.65-9.93a.577.577 0 011.07.37l-.9 6.34h3.51c.4 0 .62.19.4.66-3.29 5.74-5.2 9.09-5.75 10.05-.1.18-.29.29-.5.29z"
      ></path>
    </svg>
  </span>
);
export const IconMacOS = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="67" height="68" fill="none" viewBox="0 0 67 80">
      <path
        fill="#344054"
        d="M22.594 80h-1.88c-.293-.09-.581-.186-.876-.266-2.766-.753-4.763-2.619-6.547-4.707C6.29 66.802 2.125 57.35 1.135 46.562c-.43-4.741-.028-9.41 1.723-13.9 2.006-5.15 5.399-9.045 10.43-11.393 3.585-1.671 7.352-2.35 11.238-1.262a58.886 58.886 0 016.247 2.204c2.17.88 4.263.932 6.422.017a65.528 65.528 0 015.04-1.88c6.294-2.075 12.166-1.096 17.601 2.608a14.99 14.99 0 014.113 4.28c-12.831 8.396-10.6 26.065 2.08 31.494-.006.1-.02.2-.045.297a46.956 46.956 0 01-10.609 17.566c-2.706 2.837-6.07 3.983-9.957 2.94-1.497-.4-2.943-1.016-4.386-1.599-3.513-1.419-7.07-1.604-10.682-.454-2.588.817-4.997 2.212-7.756 2.52zM49.398 0c1.253 9.11-7.442 19.126-15.87 18.357C32.305 11.195 38.922.825 49.398 0z"
      ></path>
    </svg>
  </span>
);

export const IconWindowsOS = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="73" height="68" fill="none" viewBox="0 0 73 68">
      <path
        fill="#344054"
        d="M72.76 31.733H36.531V4.529L72.761 0v31.733zM72.19 68.001c-1.3-.187-2.6-.393-3.904-.558a4985.349 4985.349 0 00-15.444-1.935L37.539 63.6c-.328-.041-.654-.095-1.016-.142v-27.19h36.235v31.733h-.568zM31.908 31.702H.25V9.063l31.658-3.952V31.7zM31.916 36.317v26.58L.258 58.94V36.317h31.658z"
      ></path>
    </svg>
  </span>
);

export const IconExpanded = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#F5F5FF"
        d="M18.521 11.6l-2.52 2.52-2.52-2.52c-.52-.52-1.36-.52-1.88 0-.52.52-.52 1.36 0 1.88l2.52 2.52-2.52 2.52c-.52.52-.52 1.36 0 1.88.52.52 1.36.52 1.88 0l2.52-2.52 2.52 2.52c.52.52 1.36.52 1.88 0 .52-.52.52-1.36 0-1.88L17.881 16l2.52-2.52c.52-.52.52-1.36 0-1.88-.52-.507-1.373-.507-1.88 0zm-2.52-8.934A13.321 13.321 0 002.668 15.999c0 7.374 5.96 13.334 13.333 13.334 7.374 0 13.334-5.96 13.334-13.334 0-7.373-5.96-13.333-13.334-13.333zm0 24c-5.88 0-10.666-4.787-10.666-10.667S10.12 5.333 16 5.333c5.88 0 10.667 4.786 10.667 10.666 0 5.88-4.787 10.667-10.667 10.667z"
      ></path>
    </svg>
  </span>
);

export const IconCollapse = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28">
      <path
        fill="#667085"
        d="M14.001 7.333c-.733 0-1.333.6-1.333 1.333v4h-4c-.733 0-1.333.6-1.333 1.333 0 .734.6 1.334 1.333 1.334h4v4c0 .733.6 1.333 1.333 1.333.734 0 1.334-.6 1.334-1.333v-4h4c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333h-4v-4c0-.733-.6-1.333-1.334-1.333zm0-6.667C6.655.666.668 6.653.668 13.999c0 7.347 5.987 13.334 13.333 13.334 7.347 0 13.334-5.987 13.334-13.334C27.335 6.653 21.348.666 14 .666zm0 24c-5.88 0-10.666-4.787-10.666-10.667S8.12 3.333 14 3.333c5.88 0 10.667 4.786 10.667 10.666 0 5.88-4.787 10.667-10.667 10.667z"
      ></path>
    </svg>
  </span>
);

export const IconHome = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M9.995 19.327v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87l-8.36-7.53c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87h1.7v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z"
      ></path>
    </svg>
  </span>
);

export const IconSave = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 00-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41l-2.82-2.83zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm1-10H7c-1.1 0-2-.9-2-2s.9-2 2-2h6c1.1 0 2 .9 2 2s-.9 2-2 2z"
      ></path>
    </svg>
  </span>
);

export const IconVisibilityOn = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      ></path>
    </svg>
  </span>
);

export const IconVisibilityOff = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 6.47c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53-1.73-4.38-6-7.49-11-7.49-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24zM2.71 3.13a.996.996 0 000 1.41l1.97 1.97A11.892 11.892 0 001 11.47c1.73 4.39 6 7.5 11 7.5 1.52 0 2.97-.3 4.31-.82l2.72 2.72a.996.996 0 101.41-1.41L4.13 3.13c-.39-.39-1.03-.39-1.42 0zM12 16.47c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07l1.57 1.57c-.65.32-1.37.5-2.14.5zm2.97-5.33a2.97 2.97 0 00-2.64-2.64l2.64 2.64z"
      ></path>
    </svg>
  </span>
);

export const IconModalConfirmLogin = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 34.54 33.92"
    >
      <title>users-arrow-right-profile-avatar-user-svgrepo-com</title>
      <path
        strokeWidth="1.42"
        strokeMiterlimit="10"
        fill="none"
        stroke="#eb1d28"
        d="M7.8,26l.79-2.87C9.9,18.39,13.39,16,16.84,16"
      />
      <circle strokeWidth="1.42" strokeMiterlimit="10" fill="none" stroke="#eb1d28" cx="16.8" cy="10.98" r="5" />
      <circle strokeWidth="1.42" strokeMiterlimit="10" fill="none" stroke="#eb1d28" cx="21.8" cy="23" r="5" />
      <path
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
        stroke="#eb1d28"
        d="M21.73,25l1.86-1.86a.21.21,0,0,0,0-.28L21.73,21"
      />
      <circle strokeWidth="1.42" strokeMiterlimit="10" fill="none" stroke="#eb1d28" cx="17.3" cy="17.06" r="16.02" />
    </svg>
  </span>
);
/* logo products menu icon */
export const IconLogoStudio = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 137.05 146.4">
      <g fill="#eb2127">
        <path d="M130.97 42.94c-5.58.35-11.15.73-16.73 1.13-3.38.24-5.57 2.75-5.36 6.05.22 3.33 2.69 5.53 6.07 5.34 2.79-.16 5.58-.37 8.36-.56 2.79-.19 5.58-.36 8.36-.57 3.39-.26 5.57-2.75 5.36-6.05-.22-3.34-2.68-5.55-6.06-5.34zM79.07 23.98c0 .12.02.23.03.35.31 3.22 2.84 5.34 6.1 5.11 3.23-.23 5.47-2.71 5.28-5.95-.34-5.64-.73-11.27-1.14-16.9-.25-3.37-2.77-5.52-6.11-5.29-3.31.23-5.47 2.73-5.28 6.12.16 2.73.36 5.46.55 8.19l.57 8.36zM112.09 31.38c3.38-3.77 6.68-7.62 10-11.44 1.11-1.28 1.73-2.75 1.51-4.51-.23-2.42-1.43-4.19-3.76-4.96-2.49-.82-4.73-.21-6.49 1.78-3.35 3.8-6.7 7.6-9.99 11.45-2.29 2.68-2.11 6.34.3 8.46 2.4 2.12 6.09 1.83 8.43-.78zM114.48 68.23c-2.59-2.2-6.25-1.94-8.32.43-2.07 2.37-1.84 6.03.68 8.31 3.85 3.47 7.78 6.85 11.71 10.23 1.24 1.07 2.69 1.61 3.9 1.44 2.84-.24 4.56-1.44 5.36-3.66.88-2.46.37-4.75-1.61-6.53-3.87-3.45-7.76-6.87-11.71-10.22zM47.26 24.97c3.85 3.39 7.68 6.79 11.59 10.1 2.61 2.21 6.24 1.97 8.33-.39 2.13-2.4 1.82-6.07-.76-8.43-1.85-1.69-3.76-3.31-5.65-4.95-2.06-1.8-4.09-3.65-6.22-5.36-1.96-1.58-4.21-1.69-6.4-.56-2.16 1.12-3.12 3.04-2.92 5.88.01 1.3.81 2.63 2.03 3.71zM84.49 45.29c-.16.07-76 36.83-76.17 36.91-17.72 9.39-2.73 35.1 14.15 24.37l48.78-31.25-20.45 54.71c-.14.38-.27.79-.38 1.2-3.66 15.69 19.18 21.59 23.61 6.14l21.58-82.95c1.85-6.25-5.29-12.21-11.13-9.13z"></path>
      </g>
      <g fill="#eb2127">
        <path d="M130.63 41.66c-5.58.35-11.15.73-16.73 1.13-3.38.24-5.57 2.75-5.36 6.05.22 3.33 2.69 5.53 6.07 5.34 2.79-.16 5.58-.37 8.36-.56 2.79-.19 5.58-.36 8.36-.57 3.39-.26 5.57-2.75 5.36-6.05-.22-3.34-2.68-5.55-6.06-5.34zM78.73 22.7c0 .12.02.23.03.35.31 3.22 2.84 5.34 6.1 5.11 3.23-.23 5.47-2.71 5.28-5.95-.34-5.64-.73-11.27-1.14-16.9-.25-3.37-2.77-5.52-6.11-5.29-3.31.23-5.47 2.73-5.28 6.12.16 2.73.36 5.46.55 8.19l.57 8.36zM111.75 30.1c3.38-3.77 6.68-7.62 10-11.44 1.11-1.28 1.73-2.75 1.51-4.51-.23-2.42-1.43-4.19-3.76-4.96-2.49-.82-4.73-.21-6.49 1.78-3.35 3.8-6.7 7.6-9.99 11.45-2.29 2.68-2.11 6.34.3 8.46 2.4 2.12 6.09 1.83 8.43-.78zM114.13 66.95c-2.59-2.2-6.25-1.94-8.32.43-2.07 2.37-1.84 6.03.68 8.31 3.85 3.47 7.78 6.85 11.71 10.23 1.24 1.07 2.69 1.61 3.9 1.44 2.84-.24 4.56-1.44 5.36-3.66.88-2.46.37-4.75-1.61-6.53-3.87-3.45-7.76-6.87-11.71-10.22zM46.91 23.69c3.85 3.39 7.68 6.79 11.59 10.1 2.61 2.21 6.24 1.97 8.33-.39 2.13-2.4 1.82-6.07-.76-8.43-1.85-1.69-3.76-3.31-5.65-4.95-2.06-1.8-4.09-3.65-6.22-5.36-1.96-1.58-4.21-1.69-6.4-.56-2.16 1.12-3.12 3.04-2.92 5.88.01 1.3.81 2.63 2.03 3.71zM84.14 44c-.16.07-76 36.83-76.17 36.91-17.72 9.39-2.73 35.1 14.15 24.37L70.9 74.03l-20.45 54.71c-.14.38-.27.79-.38 1.2-3.66 15.69 19.18 21.59 23.61 6.14l21.58-82.95c1.85-6.25-5.29-12.21-11.13-9.13z"></path>
      </g>
    </svg>
  </span>
);

export const IconLogoTestEngine = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 138.2 154.69">
      <path
        fill="#eb2127"
        d="M132.78 97.96L96.12 81.88c-2.41-1.06-5.15-.96-7.52.29-4.44 2.34-6.41 8.11-4.44 12.74l16.72 44.13.05.12c.95 2.25 2.76 3.93 4.97 4.61.76.23 1.53.35 2.29.35 3.75 0 7.32-2.71 8.71-6.91.77-2.33.74-4.78-.01-6.67l-6.24-20.11c-.06-.15-.09-.44.02-.77.05-.14.11-.25.16-.32l14.27 7.41 1.55.66c1.85.54 3.85.38 5.68-.48 2.44-1.15 4.36-3.43 5.27-6.27 1.66-5.18-.45-10.75-4.82-12.7zM89.57 72.98a8.9 8.9 0 003.11.57c1.26 0 2.49-.28 3.6-.82l37.19-16.3.14-.07c1.9-.93 3.34-2.64 4.07-4.81 1.47-4.35-.22-9.34-3.94-11.6-2.12-1.29-4.59-1.49-6.47-.66l-16.72 5.61c-.25-.14-.5-.78-.44-.97l8.32-18.1c1.8-4.87-.22-10.93-4.6-13.79-2.38-1.56-5.19-1.98-7.72-1.16-2.49.81-4.5 2.77-5.51 5.4L84.02 59.97c-.93 2.42-.89 5.2.11 7.63 1.04 2.51 3.02 4.48 5.43 5.39zM8.12 48.48l53 23.67c1.27.57 2.63.86 3.99.86s2.71-.29 3.96-.87c4.79-2.21 6.95-8.1 4.87-13.01L54.26 7.42l-.04-.1a12.16 12.16 0 00-5.08-5.78C46.45-.02 43.32-.42 40.57.46c-2.5.81-4.47 2.57-5.54 4.95-1.13 2.5-1.13 5.5-.08 8.01l8.61 25.52c.14.35.16.7.05.97-.03.07-.12.29-.43.4-.3.11-.69.08-.84.02L18.99 26.77l-1.43-.72c-3.14-1.31-6.64-1.45-9.73-.37-3.02 1.05-5.41 3.17-6.73 5.97-1.33 2.82-1.45 6.04-.34 9.08 1.24 3.38 3.92 6.2 7.36 7.75zM68.1 82.11c-2.47-.9-5.14-.75-7.41.38L7.15 106.46l-.11.05c-2.63 1.29-4.71 3.43-5.85 6.04-1.23 2.84-1.21 6.01.07 8.69 1.27 2.67 3.7 4.68 6.65 5.51 2.86.81 5.95.49 8.5-.8l26.18-11.13c.35-.18.73-.23 1.02-.12.2.07.34.18.42.37.12.27.11.61.08.72l-11.7 24.2v.19c-1.02 3.06-.83 6.29.56 8.97 1.38 2.66 3.77 4.52 6.73 5.23.87.21 1.75.31 2.62.31 5.13 0 10.15-3.43 12.15-8.65l19.3-50.86c.97-2.54.92-5.4-.15-7.84-1.08-2.47-3.03-4.32-5.52-5.23z"
      ></path>
    </svg>
  </span>
);

export const IconLogoTestManagement = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 160.59 172.76">
      <path
        fill="#eb2127"
        d="M77.91 37.99c-.78-1.41-2.2-2.63-3.92-3.37-3.42-1.47-7.08-.68-8.15 1.78l-41.06 97.79c-1 2.49.99 5.65 4.44 7.07 1.74.71 3.6.87 5.15.44l83.38-15.71c2.12-.59 3.37-2.01 3.66-3.72 1.02-1.4 1.15-3.29.09-5.22L77.91 37.99zm14.05 71.54l-29.56 4.93c-1.42.4-3.26-.3-4.12-1.56-.42-.62-.53-1.29-.33-1.85L72.54 76.3c.26-.55.82-.93 1.55-1.07 1.5-.27 3.28.55 4 1.84l15.28 29.08c.73 1.32.03 2.98-1.42 3.38zM62.83 28.45c7.54 3.16 16.21-.38 19.37-7.92s-.38-16.21-7.92-19.37-16.21.38-19.37 7.92.38 16.21 7.92 19.37zM151.51 125.07c-7.54-3.16-16.21.38-19.37 7.92s.38 16.21 7.92 19.37 16.21-.38 19.37-7.92-.38-16.21-7.92-19.37zM20.53 144.31c-7.54-3.16-16.21.38-19.37 7.92s.38 16.21 7.92 19.37 16.21-.38 19.37-7.92-.38-16.21-7.92-19.37z"
      ></path>
    </svg>
  </span>
);

export const IconLogoDeviceFarm = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 102.15 153.14">
      <path
        fill="#eb2127"
        d="M41.6 97.46c0 7.56 6.13 13.68 13.68 13.68s13.68-6.13 13.68-13.68-6.13-13.68-13.68-13.68S41.6 89.91 41.6 97.46z"
      ></path>
      <path
        fill="#eb2127"
        d="M73.96 19.04C86.49 17.56 84.76-.8 72.21.03L10.36 5.7c-4.78.46-8.59 4.45-8.67 9.36.02.07-1.72 111.19-1.69 111.25.18 15.08 22.31 14.99 22.47 0V23.91c17.07-1.57 51.49-4.87 51.49-4.87zM83.06 33.07v92.98c-14.43 1.81-43.08 5.43-43.66 5.47-14.1 2.89-10.37 23.62 3.82 21.46.2-.1 50.91-8.98 51.06-9.1a9.54 9.54 0 007.86-9.39V33.07c-.32-12.63-18.8-12.54-19.09 0z"
      ></path>
    </svg>
  </span>
);

/* logo products pages icon */
export const IconLogoTextStudio = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 333.66 146.4">
      <g fill="#e7e8e9">
        <path d="M130.63 41.66c-5.58.35-11.15.73-16.73 1.13-3.38.24-5.57 2.75-5.36 6.05.22 3.33 2.69 5.53 6.07 5.34 2.79-.16 5.58-.37 8.36-.56 2.79-.19 5.58-.36 8.36-.57 3.39-.26 5.57-2.75 5.36-6.05-.22-3.34-2.68-5.55-6.06-5.34zM78.73 22.7c0 .12.02.23.03.35.31 3.22 2.84 5.34 6.1 5.11 3.23-.23 5.47-2.71 5.28-5.95-.34-5.64-.73-11.27-1.14-16.9-.25-3.37-2.77-5.52-6.11-5.29-3.31.23-5.47 2.73-5.28 6.12.16 2.73.36 5.46.55 8.19l.57 8.36zM111.75 30.1c3.38-3.77 6.68-7.62 10-11.44 1.11-1.28 1.73-2.75 1.51-4.51-.23-2.42-1.43-4.19-3.76-4.96-2.49-.82-4.73-.21-6.49 1.78-3.35 3.8-6.7 7.6-9.99 11.45-2.29 2.68-2.11 6.34.3 8.46 2.4 2.12 6.09 1.83 8.43-.78zM114.13 66.95c-2.59-2.2-6.25-1.94-8.32.43-2.07 2.37-1.84 6.03.68 8.31 3.85 3.47 7.78 6.85 11.71 10.23 1.24 1.07 2.69 1.61 3.9 1.44 2.84-.24 4.56-1.44 5.36-3.66.88-2.46.37-4.75-1.61-6.53-3.87-3.45-7.76-6.87-11.71-10.22zM46.91 23.69c3.85 3.39 7.68 6.79 11.59 10.1 2.61 2.21 6.24 1.97 8.33-.39 2.13-2.4 1.82-6.07-.76-8.43-1.85-1.69-3.76-3.31-5.65-4.95-2.06-1.8-4.09-3.65-6.22-5.36-1.96-1.58-4.21-1.69-6.4-.56-2.16 1.12-3.12 3.04-2.92 5.88.01 1.3.81 2.63 2.03 3.71zM84.14 44c-.16.07-76 36.83-76.17 36.91-17.72 9.39-2.73 35.1 14.15 24.37L70.9 74.03l-20.45 54.71c-.14.38-.27.79-.38 1.2-3.66 15.69 19.18 21.59 23.61 6.14l21.58-82.95c1.85-6.25-5.29-12.21-11.13-9.13z"></path>
      </g>
    </svg>
  </span>
);

export const IconLogoTextTestEngine = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 350.78 154.69">
      <g fill="#e7e8e9">
        <path d="M132.78 97.96L96.12 81.88c-2.41-1.06-5.15-.96-7.52.29-4.44 2.34-6.41 8.11-4.44 12.74l16.72 44.13.05.12c.95 2.25 2.76 3.93 4.97 4.61.76.23 1.53.35 2.29.35 3.75 0 7.32-2.71 8.71-6.91.77-2.33.74-4.78-.01-6.67l-6.24-20.11c-.06-.15-.09-.44.02-.77.05-.14.11-.25.16-.32l14.27 7.41 1.55.66c1.85.54 3.85.38 5.68-.48 2.44-1.15 4.36-3.43 5.27-6.27 1.66-5.18-.45-10.75-4.82-12.7zM89.57 72.98a8.9 8.9 0 003.11.57c1.26 0 2.49-.28 3.6-.82l37.19-16.3.14-.07c1.9-.93 3.34-2.64 4.07-4.81 1.47-4.35-.22-9.34-3.94-11.6-2.12-1.29-4.59-1.49-6.47-.66l-16.72 5.61c-.25-.14-.5-.78-.44-.97l8.32-18.1c1.8-4.87-.22-10.93-4.6-13.79-2.38-1.56-5.19-1.98-7.72-1.16-2.49.81-4.5 2.77-5.51 5.4L84.02 59.97c-.93 2.42-.89 5.2.11 7.63 1.04 2.51 3.02 4.48 5.43 5.39zM8.12 48.48l53 23.67c1.27.57 2.63.86 3.99.86s2.71-.29 3.96-.87c4.79-2.21 6.95-8.1 4.87-13.01L54.26 7.42l-.04-.1a12.16 12.16 0 00-5.08-5.78C46.45-.02 43.32-.42 40.57.46c-2.5.81-4.47 2.57-5.54 4.95-1.13 2.5-1.13 5.5-.08 8.01l8.61 25.52c.14.35.16.7.05.97-.03.07-.12.29-.43.4-.3.11-.69.08-.84.02L18.99 26.77l-1.43-.72c-3.14-1.31-6.64-1.45-9.73-.37-3.02 1.05-5.41 3.17-6.73 5.97-1.33 2.82-1.45 6.04-.34 9.08 1.24 3.38 3.92 6.2 7.36 7.75zM68.1 82.11c-2.47-.9-5.14-.75-7.41.38L7.15 106.46l-.11.05c-2.63 1.29-4.71 3.43-5.85 6.04-1.23 2.84-1.21 6.01.07 8.69 1.27 2.67 3.7 4.68 6.65 5.51 2.86.81 5.95.49 8.5-.8l26.18-11.13c.35-.18.73-.23 1.02-.12.2.07.34.18.42.37.12.27.11.61.08.72l-11.7 24.2v.19c-1.02 3.06-.83 6.29.56 8.97 1.38 2.66 3.77 4.52 6.73 5.23.87.21 1.75.31 2.62.31 5.13 0 10.15-3.43 12.15-8.65l19.3-50.86c.97-2.54.92-5.4-.15-7.84-1.08-2.47-3.03-4.32-5.52-5.23z"></path>
      </g>
    </svg>
  </span>
);

export const IconLogoTextTestManagement = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 420.53 172.76">
      <g fill="#e7e8e9">
        <path d="M77.91 37.99c-.78-1.41-2.2-2.63-3.92-3.37-3.42-1.47-7.08-.68-8.15 1.78l-41.06 97.79c-1 2.49.99 5.65 4.44 7.07 1.74.71 3.6.87 5.15.44l83.38-15.71c2.12-.59 3.37-2.01 3.66-3.72 1.02-1.4 1.15-3.29.09-5.22L77.91 37.99zm14.05 71.54l-29.56 4.93c-1.42.4-3.26-.3-4.12-1.56-.42-.62-.53-1.29-.33-1.85L72.54 76.3c.26-.55.82-.93 1.55-1.07 1.5-.27 3.28.55 4 1.84l15.28 29.08c.73 1.32.03 2.98-1.42 3.38zM62.83 28.45c7.54 3.16 16.21-.38 19.37-7.92s-.38-16.21-7.92-19.37-16.21.38-19.37 7.92.38 16.21 7.92 19.37zM151.51 125.07c-7.54-3.16-16.21.38-19.37 7.92s.38 16.21 7.92 19.37 16.21-.38 19.37-7.92-.38-16.21-7.92-19.37zM20.53 144.31c-7.54-3.16-16.21.38-19.37 7.92s.38 16.21 7.92 19.37 16.21-.38 19.37-7.92-.38-16.21-7.92-19.37z"></path>
      </g>
    </svg>
  </span>
);

export const IconLogoTextDeviceFarm = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 102.15 153.14">
      <path
        fill="#e7e8e9"
        d="M41.6 97.46c0 7.56 6.13 13.68 13.68 13.68s13.68-6.13 13.68-13.68-6.13-13.68-13.68-13.68S41.6 89.91 41.6 97.46z"
      ></path>
      <path
        fill="#e7e8e9"
        d="M73.96 19.04C86.49 17.56 84.76-.8 72.21.03L10.36 5.7c-4.78.46-8.59 4.45-8.67 9.36.02.07-1.72 111.19-1.69 111.25.18 15.08 22.31 14.99 22.47 0V23.91c17.07-1.57 51.49-4.87 51.49-4.87zM83.06 33.07v92.98c-14.43 1.81-43.08 5.43-43.66 5.47-14.1 2.89-10.37 23.62 3.82 21.46.2-.1 50.91-8.98 51.06-9.1a9.54 9.54 0 007.86-9.39V33.07c-.32-12.63-18.8-12.54-19.09 0z"
      ></path>
    </svg>
  </span>
);

export const IconBenefitTestEngine1 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" fill="none" viewBox="0 0 81 80">
      <path
        fill="#C6CCF4"
        d="M13.948 21.522a13.583 13.583 0 013.38.081l-.154-1.414c-.366 0-.732 0-1.089.066l-2.632-4.648a12.116 12.116 0 00-3.86 1.308l-2.136 1.268a12.317 12.317 0 013.86-1.308l2.631 4.647zM41.977 38.113l-2.08 2.437a51.024 51.024 0 012.348 4.729l3.558.536a54.508 54.508 0 012.129 6.345l2.136-1.267a51.62 51.62 0 00-2.136-6.345l-3.559-.537a49.956 49.956 0 00-2.34-4.72l2.072-2.437a59.306 59.306 0 00-3.859-5.76L38.11 32.36a59.31 59.31 0 013.867 5.752zM21.65 18.533l1.186 4.817c.617.293 1.243.618 1.877.983.633.366 1.259.764 1.876 1.187l.748-2.161c-.163-.098-.317-.204-.48-.293a26.1 26.1 0 00-1.876-.983l-1.186-4.818a22.75 22.75 0 00-4.818-1.519l-2.145 1.268c1.658.325 3.273.834 4.818 1.519zM32.595 26.11l-.487 4.063a47.94 47.94 0 013.38 3.826l2.12-1.3a47.25 47.25 0 00-3.364-3.793l.496-4.063a44.383 44.383 0 00-4.818-4.062l-2.145 1.268a43.609 43.609 0 014.818 4.062zM47.3 64.531l-1.771-.812a19.245 19.245 0 01-.845 3.713l3.25 4.127a15.432 15.432 0 01-2.145 3.859l2.144-1.276a14.955 14.955 0 002.145-3.859l-3.25-4.127a16.4 16.4 0 00.472-1.625zM51.451 58.538l-3.778-2.592a36.965 36.965 0 00-.609-3.68l-2.38.268c.37 1.54.641 3.104.812 4.68l3.778 2.591c.081.983.13 1.95.13 2.909 0 .958-.049 1.876-.13 2.762l2.177-1.292c.081-.886.122-1.812.122-2.762s-.04-1.901-.122-2.884z"
      ></path>
      <path
        fill="#CED3F4"
        d="M42.604 72.21l-.358-.366a10.207 10.207 0 01-2.348 2.015l1.942 4.509c.79-.233 1.552-.55 2.275-.943l-2.072-4.874c.203-.082.374-.244.56-.342z"
      ></path>
      <path
        fill="#AFB6E5"
        d="M32.105 75.28l.488 4.59 2.145-1.268-.496-4.598-2.136 1.275zM41.978 78.7l2.137-1.276-2.072-4.834-2.145 1.267 2.08 4.842zM46.836 66.156l-2.137 1.268 3.25 4.127 2.145-1.276-3.258-4.119zM32.105 30.133l2.137-1.268.496-4.021-2.145 1.267-.488 4.022zM22.838 23.35l2.145-1.267-1.186-4.817-2.145 1.267 1.186 4.818zM13.94 21.522l2.145-1.267-2.632-4.648-2.137 1.268 2.625 4.647zM7.191 25.031l2.137-1.267-3.558-3.567-2.137 1.268L7.19 25.03zM.121 31.408l2.145-1.267 3.778 1.77-2.145 1.268L.12 31.408zM3.625 43.45L1.48 44.725l3.258-.373 2.137-1.276-3.25.374zM21.652 74.81l2.145-1.268 1.186-3.444-2.145 1.267-1.186 3.445z"
      ></path>
      <path
        fill="url(#paint0_linear_1950_54584)"
        d="M49.306 65.474c.082-.885.13-1.803.13-2.762 0-.959-.048-1.926-.13-2.909l-3.81-2.591a37.248 37.248 0 00-.812-4.68l3.25-.374a54.509 54.509 0 00-2.145-6.345l-3.543-.536a51.023 51.023 0 00-2.348-4.72l2.08-2.437a59.32 59.32 0 00-3.859-5.76l-2.632 1.624a47.9 47.9 0 00-3.38-3.826l.488-4.062a43.598 43.598 0 00-4.818-4.063l-1.186 3.445a32.95 32.95 0 00-1.877-1.186c-.634-.374-1.26-.69-1.877-.983l-1.186-4.818a22.643 22.643 0 00-4.817-1.519l.495 4.59a13.582 13.582 0 00-3.38-.08l-2.632-4.648c-1.35.219-2.654.66-3.859 1.308l2.072 4.875a10.324 10.324 0 00-2.34 2.006l-3.558-3.558a15.437 15.437 0 00-2.153 3.867l3.25 4.127a19.102 19.102 0 00-.813 3.721L.122 31.41A30.202 30.202 0 000 34.171c0 .959.04 1.926.122 2.909L3.9 39.663c.17 1.576.441 3.139.812 4.68l-3.25.374c.581 2.159 1.3 4.278 2.153 6.345l3.559.544a50.808 50.808 0 002.34 4.712l-2.072 2.437a59.416 59.416 0 003.859 5.769l2.632-1.625a43.608 43.608 0 003.38 3.818l-.496 4.062a44.371 44.371 0 004.818 4.063l1.186-3.445c.618.422 1.243.812 1.877 1.186.634.374 1.26.682 1.877.983l1.186 4.81a22.833 22.833 0 004.817 1.527l-.487-4.598c1.118.174 2.254.204 3.38.089l2.632 4.639a12.298 12.298 0 003.859-1.3l-2.08-4.874a10.203 10.203 0 002.364-2.015l3.559 3.566a15.435 15.435 0 002.128-3.859l-3.25-4.119a19.25 19.25 0 00.813-3.72l3.81 1.762zM24.714 55.14a12.878 12.878 0 01-5.833-10.066c0-3.705 2.616-5.191 5.833-3.33a12.862 12.862 0 015.841 10.065c0 3.697-2.616 5.192-5.84 3.331z"
      ></path>
      <path
        fill="url(#paint1_linear_1950_54584)"
        d="M24.715 26.697C14.251 20.652 5.77 25.494 5.77 37.502s8.481 26.68 18.945 32.684C35.18 76.19 43.67 71.388 43.67 59.381c0-12.008-8.49-26.64-18.954-32.684zm0 30.726c-4.322-2.494-7.823-8.539-7.823-13.503s3.501-6.954 7.823-4.46c4.323 2.494 7.832 8.539 7.832 13.502 0 4.964-3.51 6.955-7.832 4.46z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#AFB6E5"
          d="M33.359 52.15c0-4.965-3.51-11.01-7.832-13.503-2.844-1.625-5.33-1.333-6.703.487 1.438-1.056 3.542-1.032 5.89.325 4.323 2.494 7.832 8.539 7.832 13.503a6.5 6.5 0 01-1.13 3.964c1.203-.87 1.943-2.494 1.943-4.777z"
        ></path>
        <path
          fill="#AFB6E5"
          d="M25.528 69.374C15.064 63.37 6.582 48.698 6.582 36.69c0-4.477 1.178-7.946 3.193-10.237-2.51 2.234-4.005 6.045-4.005 11.05 0 12.007 8.481 26.68 18.945 32.683 6.573 3.794 12.357 3.299 15.762-.569-3.47 3.096-8.872 3.258-14.95-.243z"
        ></path>
      </g>
      <path
        fill="#AFB6E5"
        d="M44.115 36.844l-2.137 1.267-2.08 2.446 2.145-1.268 2.072-2.445zM44.383 44.01l-2.137 1.267 3.558.536 2.137-1.267-3.558-.536zM45.527 57.213l2.145-1.268 3.778 2.592-2.145 1.267-3.778-2.591z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}>
        <path
          fill="#AFB6E5"
          d="M18.797 45.156a12.886 12.886 0 005.833 10.09c1.966 1.13 3.696 1.016 4.753-.073-1.065 1-2.755 1.064-4.648 0a12.853 12.853 0 01-5.841-10.066 4.582 4.582 0 011.089-3.25 4.47 4.47 0 00-1.186 3.299zM7.691 24.497zM21.568 18.613l1.178 4.818c.626.292 1.243.617 1.877.983.633.365 1.259.764 1.876 1.186l.05-.138c-.602-.406-1.211-.813-1.82-1.146-.61-.333-1.26-.69-1.877-.983l-1.187-4.817a23.305 23.305 0 00-4.817-1.528v.122c1.623.33 3.205.833 4.72 1.503zM11.234 16.957l2.633 4.647a13.573 13.573 0 013.38.081v-.113a13.483 13.483 0 00-3.25-.066l-2.625-4.647c-1.365.21-2.684.653-3.9 1.308v.041a12.34 12.34 0 013.762-1.251zM4.628 44.344l-3.128.341v.09l3.128-.366v-.065zM32.495 26.195l-.487 4.022a46.56 46.56 0 013.38 3.827l2.632-1.625a59.304 59.304 0 013.875 5.768l-2.088 2.437a49.956 49.956 0 012.34 4.72l3.558.537a52.656 52.656 0 012.12 6.263h.123a53.981 53.981 0 00-2.145-6.345l-3.559-.544a50.835 50.835 0 00-2.34-4.712l2.072-2.437a59.313 59.313 0 00-3.859-5.76l-2.632 1.624a45.108 45.108 0 00-3.38-3.826l.488-4.062a45.232 45.232 0 00-4.81-4.063l-.049.139a43.503 43.503 0 014.761 4.037zM41.676 72.454c.17-.171.333-.342.487-.52a6.004 6.004 0 01-.487.52zM39.809 73.933l2.055 4.801.114-.065-2.064-4.81-.105.074zM32.023 75.356l.472 4.476h.105l-.48-4.484-.097.008zM45.495 63.816h-.081a19.382 19.382 0 01-.812 3.721l3.25 4.127a15.438 15.438 0 01-2.064 3.746 15.371 15.371 0 002.145-3.916l-3.25-4.062c.39-1.175.663-2.386.812-3.616zM7.109 25.113l.097-.097-3.558-3.567-.082.114 3.543 3.55zM49.33 59.788l-3.786-2.592a37.372 37.372 0 00-.813-4.598h-.122c.37 1.54.642 3.104.813 4.68l3.778 2.59c.08.984.13 1.95.13 2.91 0 .958 0 1.779-.114 2.615l.09.05c.08-.886.121-1.813.121-2.763s-.016-1.917-.097-2.892zM3.817 33.263v-.138l-3.68-1.73a.812.812 0 010 .138l3.68 1.73zM22.747 71.445l-1.13 3.299h.057l1.137-3.25-.064-.049z"
        ></path>
      </g>
      <path fill="#AFB6E5" d="M47.266 35.512l2.137-1.267-.731-3.932-2.137 1.275.731 3.924z"></path>
      <path
        fill="#C6CCF4"
        d="M51.93 34.731a7.312 7.312 0 013.306-.812l-.13-.861a6.501 6.501 0 00-1.031.447l-2.348-2.82a8.503 8.503 0 00-1.836 1.625l2.039 2.421zM77.683 63.93l-1.625-.715a11.123 11.123 0 01-1.316 3.737l1.934 3.25a8.53 8.53 0 01-2.438 2.437l2.129-1.275a8.628 8.628 0 002.437-2.438l-1.942-3.25a9.328 9.328 0 00.821-1.746zM54.75 30.588c1.36.068 2.702.342 3.98.812l1.138 3.429c.704.29 1.389.626 2.048 1.007.706.415 1.39.868 2.047 1.357l1.089-2.007c-.334-.211-.659-.422-1-.617a17.521 17.521 0 00-2.039-1.008l-1.145-3.428a13.519 13.519 0 00-3.981-.813l-2.137 1.268zM80.813 58.275l-2.64-1.918a28.37 28.37 0 00-1.219-5.053l1.893-1.121a41.152 41.152 0 00-2.437-5.305l-2.348.114a33.578 33.578 0 00-3.307-4.672l.496-2.722a32.844 32.844 0 00-3.981-3.785l-2.145 1.275a32.097 32.097 0 013.932 3.778l-.487 2.721a34.063 34.063 0 013.306 4.672l2.34-.114a40.085 40.085 0 012.437 5.305l-1.909.983a27.9 27.9 0 011.26 5.192l2.64 1.925c.089.81.135 1.623.138 2.438 0 .776-.045 1.552-.138 2.323l2.145-1.267c.085-.772.129-1.547.13-2.324.024-.78-.025-1.608-.106-2.445z"
      ></path>
      <path
        fill="#AFB6E5"
        d="M58.73 69.461l2.137-1.267 1.146-2.104-2.145 1.267-1.138 2.104zM69.081 73.964l2.145-1.267-.496-3.299-2.136 1.276.487 3.29zM74.766 66.951l2.136-1.267 1.942 3.217-2.145 1.275-1.933-3.225zM76.027 57.627l2.145-1.268 2.64 1.918-2.144 1.275-2.64-1.925zM71.898 46.26l2.145-1.267 2.34-.114-2.145 1.267-2.34.114zM68.594 41.587l2.136-1.268.496-2.721-2.145 1.267-.487 2.722zM59.868 34.829l2.145-1.268-1.146-3.428-2.136 1.267 1.137 3.429zM51.93 34.731l2.145-1.267-2.349-2.82-2.136 1.268 2.34 2.82zM47.8 41.336l2.137-1.275-2.64-1.13L45.16 40.2l2.64 1.137z"
      ></path>
      <path
        fill="url(#paint2_linear_1950_54584)"
        d="M78.666 64.353a19.32 19.32 0 00.139-2.324 23.133 23.133 0 00-.139-2.437l-2.64-1.926a27.904 27.904 0 00-1.283-5.232l1.933-.983a40.085 40.085 0 00-2.437-5.305l-2.34.114a34.072 34.072 0 00-3.307-4.672l.488-2.721a31.573 31.573 0 00-3.981-3.778l-1.138 2.104a22.9 22.9 0 00-2.047-1.357 16.987 16.987 0 00-2.047-1.007L58.73 31.4a13.519 13.519 0 00-3.981-.812l.495 3.29a7.312 7.312 0 00-3.306.813l-2.38-2.779a8.566 8.566 0 00-2.438 2.437l1.933 3.25a11.139 11.139 0 00-1.259 3.73l-2.64-1.13a19.321 19.321 0 00-.138 2.324c.003.814.05 1.627.138 2.437l2.64 1.925a28.06 28.06 0 001.26 5.192L47.12 53.1a40.098 40.098 0 002.437 5.306l2.34-.114a34.074 34.074 0 003.347 4.671l-.487 2.722a32.777 32.777 0 003.98 3.778l1.138-2.104c.657.486 1.34.937 2.047 1.348.658.386 1.343.725 2.048 1.016l1.129 3.396c1.27.47 2.604.744 3.956.812l-.463-3.25a7.392 7.392 0 003.307-.812l2.34 2.81a8.53 8.53 0 002.437-2.436l-1.933-3.25a11.123 11.123 0 001.259-3.737l2.665 1.097zm-16.752-6.378a10.942 10.942 0 01-4.972-8.571c0-3.153 2.226-4.42 4.972-2.836a10.96 10.96 0 014.972 8.58c0 3.144-2.226 4.411-4.972 2.827z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint3_radial_1950_54584)"
          d="M58.665 31.53l1.145 3.404c.703.29 1.384.63 2.04 1.016.709.407 1.392.858 2.047 1.348l.081-.154a22.663 22.663 0 00-2.039-1.349 16.98 16.98 0 00-2.047-1.007l-1.138-3.429a13.517 13.517 0 00-3.98-.812v.154c1.33.08 2.643.359 3.891.829z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint4_radial_1950_54584)"
          d="M56.868 49.558a10.969 10.969 0 004.964 8.58c1.95 1.12 3.631.812 4.444-.593-.813 1.275-2.437 1.527-4.355.438a10.944 10.944 0 01-4.972-8.57c-.028-.8.16-1.591.544-2.292a4.29 4.29 0 00-.625 2.437z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint5_radial_1950_54584)"
          d="M69.055 38.997l-.496 2.73a33.497 33.497 0 013.307 4.663l2.307-.08a38.433 38.433 0 012.438 5.223l.122-.065a39.082 39.082 0 00-2.438-5.305l-2.34.114a33.593 33.593 0 00-3.306-4.672l.495-2.721a33.443 33.443 0 00-3.98-3.786l-.09.154a32.763 32.763 0 013.981 3.745z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint6_radial_1950_54584)"
          d="M48.97 52.148l-1.853.927v.08l1.82-.917a.405.405 0 01.032-.09z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint7_radial_1950_54584)"
          d="M49.554 32.04l2.34 2.812a7.45 7.45 0 013.307-.813v-.138a7.312 7.312 0 00-3.201.813l-2.34-2.82a8.564 8.564 0 00-2.437 2.438 8.342 8.342 0 012.331-2.291z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint8_radial_1950_54584)"
          d="M78.688 59.52l-2.64-1.918A27.54 27.54 0 0074.82 52.5l-.122.057a27.448 27.448 0 011.268 5.191l2.64 1.926c.081.812.13 1.625.13 2.437 0 .717-.038 1.433-.114 2.145h.065c.082-.747.12-1.499.114-2.25.006-.83-.032-1.66-.114-2.487z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint9_radial_1950_54584)"
          d="M76.018 63.37h-.049a10.968 10.968 0 01-1.227 3.704l1.934 3.25.09-.13-1.934-3.25c.599-1.114 1-2.324 1.186-3.575z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint10_radial_1950_54584)"
          d="M68.527 70.794L69 73.93h.113l-.47-3.153-.115.017z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint11_radial_1950_54584)"
          d="M59.81 67.48l-1.064 1.958 1.064-1.95v-.007z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint12_radial_1950_54584)"
          d="M47.736 41.432a1.278 1.278 0 000-.17l-2.584-1.114v.18l2.584 1.104z"
        ></path>
      </g>
      <path
        fill="url(#paint13_linear_1950_54584)"
        d="M61.916 37.858c-6.938-4.005-12.56-.812-12.56 7.166 0 7.978 5.621 17.662 12.56 21.668 6.938 4.005 12.568.812 12.568-7.166 0-7.978-5.63-17.662-12.568-21.668zm0 21.977c-3.64-2.096-6.59-7.19-6.59-11.374s2.95-5.858 6.59-3.762c3.64 2.096 6.588 7.198 6.588 11.374s-2.949 5.866-6.588 3.762z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#AFB6E5"
          d="M66.805 60.16c1.527-.503 2.51-2.08 2.51-4.484 0-4.176-2.95-9.27-6.589-11.374-1.942-1.113-3.68-1.154-4.874-.317a5.084 5.084 0 014.062.723c3.64 2.104 6.588 7.198 6.588 11.374 0 1.95-.641 3.347-1.697 4.079z"
        ></path>
        <path
          fill="#AFB6E5"
          d="M62.728 66.287c-6.938-4.006-12.56-13.706-12.56-21.668 0-3.908 1.357-6.662 3.55-7.986-2.673 1.105-4.363 4.021-4.363 8.392 0 7.962 5.623 17.662 12.56 21.668 3.535 2.039 6.728 2.201 9.01.812-2.201.918-5.061.593-8.197-1.218z"
        ></path>
      </g>
      <path
        fill="url(#paint14_linear_1950_54584)"
        d="M56.941 49.404a10.943 10.943 0 004.972 8.571c1.95 1.13 3.624.813 4.445-.585a4.501 4.501 0 01-2.308-.682 10.96 10.96 0 01-4.964-8.571 4.444 4.444 0 01.528-2.242c-1.584.04-2.673 1.316-2.673 3.51z"
      ></path>
      <path
        fill="#C6CCF4"
        d="M37.193 1.78L38.818 5.8a13.74 13.74 0 012.616 1.511l1.373-1.787a12.017 12.017 0 00-1.82-.975L39.362.528a9.319 9.319 0 00-4.24-.446l-2.138 1.267a9.335 9.335 0 014.209.43zM47.267 9.604l-.731 3.079a25.863 25.863 0 011.828 3.152l3.055.918a27.354 27.354 0 011.738 5.841l2.145-1.267a27.725 27.725 0 00-1.747-5.841l-3.054-.927a25.339 25.339 0 00-1.828-3.144l.739-3.087A28.055 28.055 0 0045.195 3.9L43.06 5.168a27.718 27.718 0 014.208 4.436z"
      ></path>
      <path
        fill="url(#paint15_linear_1950_54584)"
        d="M36.625 16.41a7.71 7.71 0 003.502 6.037c1.543.894 2.851.504 3.314-.812a3.542 3.542 0 01-1.194-.455 7.71 7.71 0 01-3.502-6.037 3.61 3.61 0 01.187-1.17c-1.34-.227-2.307.691-2.307 2.438z"
      ></path>
      <path
        fill="#AFB6E5"
        d="M52.702 23.195v-.545l-2.202.277c.049.52.081 1.031.081 1.535-.001.478-.029.955-.081 1.43l2.673 3.437a9.067 9.067 0 01-1.739 3.818l2.137-1.267a9.205 9.205 0 001.747-3.827l-2.681-3.428c.05-.475.072-.953.065-1.43zM30.977 2.445l-2.145 1.276 3.055 2.6 2.145-1.268-3.055-2.608zM27.086 14.275l2.145-1.268 2.673-.341-2.137 1.267-2.681.342zM37.191 31.692l2.137-1.267 1.65-2.12-2.145 1.267-1.642 2.12z"
      ></path>
      <path fill="#C6CCF4" d="M52.621 24.625l-2.137 1.267 2.673 3.429 2.145-1.268-2.68-3.428z"></path>
      <path
        fill="url(#paint16_linear_1950_54584)"
        d="M50.564 24.464c0-.504 0-1.016-.081-1.536l2.673-.333a27.359 27.359 0 00-1.739-5.841l-3.055-.918a25.87 25.87 0 00-1.828-3.152l.732-3.08a27.727 27.727 0 00-4.209-4.435l-1.625 2.144a14.069 14.069 0 00-1.292-.812c-.418-.24-.85-.456-1.291-.65L37.224 1.83a9.335 9.335 0 00-4.209-.431l.732 3.932c-.677.211-1.3.566-1.828 1.04l-3.055-2.6a9.123 9.123 0 00-1.747 3.819l2.681 3.428c-.052.478-.08.958-.081 1.438 0 .504 0 1.016.081 1.527l-2.68.342a27.793 27.793 0 001.746 5.833l3.055.926a24.76 24.76 0 001.828 3.144l-.732 3.087a27.307 27.307 0 004.176 4.371l1.625-2.12c.423.3.853.585 1.292.812.417.243.849.46 1.292.65l1.625 4.062a9.214 9.214 0 004.208.431l-.731-3.924a5.119 5.119 0 001.828-1.04l3.055 2.6a9.066 9.066 0 001.738-3.819l-2.673-3.436c.064-.477.102-.957.114-1.438zm-10.44-2.015a7.71 7.71 0 01-3.501-6.036c0-2.218 1.568-3.112 3.501-1.999a7.72 7.72 0 013.502 6.045c0 2.218-1.568 3.103-3.502 1.99z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint17_radial_1950_54584)"
          d="M29.74 13.926l-2.6.333a.29.29 0 010 .081l2.592-.325a.331.331 0 01.008-.09z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint18_radial_1950_54584)"
          d="M37.166 1.862l1.624 4.062c.442.194.873.41 1.292.65.43.252.861.536 1.292.813l1.625-2.129a28.375 28.375 0 014.208 4.428l-.731 3.087a25.26 25.26 0 011.82 3.144l3.055.926a27.53 27.53 0 011.73 5.752h.09a27.763 27.763 0 00-1.74-5.833l-3.013-.95a25.77 25.77 0 00-1.828-3.145l.731-3.087a28.013 28.013 0 00-4.208-4.428L41.47 7.313c-.422-.3-.812-.585-1.291-.812-.42-.24-.85-.456-1.292-.65L37.263 1.83a9.335 9.335 0 00-4.208-.431v.09a9.376 9.376 0 014.11.373z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint19_radial_1950_54584)"
          d="M36.605 16.493a7.71 7.71 0 003.501 6.037c1.333.772 2.486.585 3.08-.333-.61.812-1.73.975-3.007.235a7.71 7.71 0 01-3.501-6.036 3.038 3.038 0 01.414-1.666 2.932 2.932 0 00-.487 1.763z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint20_radial_1950_54584)"
          d="M50.62 24.438c0-.471 0-.95-.082-1.438h-.081c.058.51.087 1.022.09 1.535 0 .49-.03.978-.09 1.463l2.681 3.428a9.287 9.287 0 01-1.446 3.429 9.392 9.392 0 001.52-3.526L50.537 25.9c.054-.485.081-.973.082-1.462z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint21_radial_1950_54584)"
          d="M46.516 31.686l.715 3.835h.089l-.723-3.859-.081.024z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint22_radial_1950_54584)"
          d="M28.813 3.797l3.055 2.608a4.826 4.826 0 011.828-1.04V5.3a4.923 4.923 0 00-1.738 1.007L28.886 3.7c-.106.13-.204.26-.301.398a4.2 4.2 0 01.227-.3z"
        ></path>
      </g>
      <path
        fill="url(#paint23_linear_1950_54584)"
        d="M40.125 8.037c-5.004-2.892-9.066-.577-9.066 5.167s4.062 12.739 9.066 15.631c5.005 2.892 9.059.577 9.059-5.167S45.13 10.921 40.125 8.037zm0 16.07a10.902 10.902 0 01-4.947-8.53c0-3.129 2.218-4.388 4.947-2.812a10.878 10.878 0 014.94 8.523c0 3.136-2.21 4.395-4.94 2.819z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#AFB6E5"
          d="M45.495 20.475a10.878 10.878 0 00-4.94-8.523c-2.193-1.267-4.062-.698-4.696 1.195.813-1.22 2.438-1.447 4.29-.382a10.879 10.879 0 014.915 8.522c.006.551-.076 1.1-.243 1.625.469-.724.704-1.575.674-2.437zM40.532 28.022c-5.004-2.892-9.066-9.887-9.066-15.63a8.865 8.865 0 01.609-3.372 8.002 8.002 0 00-1.016 4.184c0 5.743 4.062 12.738 9.067 15.63 3.86 2.227 7.15 1.35 8.458-1.803-1.512 2.478-4.542 3.03-8.052.991z"
        ></path>
      </g>
      <path
        fill="#AFB6E5"
        d="M40.977 4.533l-2.144 1.268-1.642-4.022L39.328.512l1.65 4.021zM47.266 9.603l2.137-1.267-.731 3.079-2.137 1.267.731-3.079zM50.5 14.566l3.055.918-2.137 1.268-3.055-.918 2.137-1.268z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1950_54584"
          x1="-13.568"
          x2="39.712"
          y1="101.765"
          y2="27.558"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.39" stopColor="#CED3F4"></stop>
          <stop offset="0.67" stopColor="#DEE2FC"></stop>
          <stop offset="0.78" stopColor="#E5E9FF"></stop>
          <stop offset="1" stopColor="#EFF1FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1950_54584"
          x1="41.088"
          x2="5.77"
          y1="48.294"
          y2="48.294"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1950_54584"
          x1="20.269"
          x2="71.915"
          y1="93.803"
          y2="42.303"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.39" stopColor="#CED3F4"></stop>
          <stop offset="0.67" stopColor="#DEE2FC"></stop>
          <stop offset="0.78" stopColor="#E5E9FF"></stop>
          <stop offset="1" stopColor="#EFF1FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint3_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(59.372 33.935) scale(4.03778)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint4_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(5.29705 0 0 5.29704 61.588 52.962)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint5_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(70.883 43.279) scale(7.12501)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint6_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.74743 0 0 .74743 48.076 52.652)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint7_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(51.163 33.373) scale(3.02224)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint8_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(4.42775 0 0 4.42774 76.763 58.414)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint9_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(75.717 66.814) scale(2.55915)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint10_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(68.82 72.362) scale(1.12928)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint11_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(59.282 68.463) scale(.78806)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint12_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.468 40.815) scale(1.02366)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint13_linear_1950_54584"
          x1="5.939"
          x2="76.214"
          y1="32.862"
          y2="57.235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#01C9EC"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_1950_54584"
          x1="57.031"
          x2="65.041"
          y1="47.324"
          y2="58.682"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.47" stopColor="#D1D5F0"></stop>
          <stop offset="0.8" stopColor="#B8BEE8"></stop>
          <stop offset="0.99" stopColor="#AFB6E5"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1950_54584"
          x1="36.796"
          x2="42.288"
          y1="14.827"
          y2="22.545"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.47" stopColor="#D1D5F0"></stop>
          <stop offset="0.8" stopColor="#B8BEE8"></stop>
          <stop offset="0.99" stopColor="#AFB6E5"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_1950_54584"
          x1="5.718"
          x2="44.893"
          y1="81.903"
          y2="9.629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.39" stopColor="#CED3F4"></stop>
          <stop offset="0.67" stopColor="#DEE2FC"></stop>
          <stop offset="0.78" stopColor="#E5E9FF"></stop>
          <stop offset="1" stopColor="#EFF1FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint17_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.9343 0 0 .9343 28.449 14.137)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint18_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.2 12.846) scale(10.3829)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint19_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(38.522 20.06) scale(3.7453)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint20_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(51.838 27.915) scale(3.60719)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint21_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.914 33.571) scale(1.39738)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint22_radial_1950_54584"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(31.137 5.056) scale(2.0392)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint23_linear_1950_54584"
          x1="14.079"
          x2="84.354"
          y1="9.402"
          y2="33.775"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#5277F7"></stop>
          <stop offset="0.69" stopColor="#5B76F7"></stop>
          <stop offset="0.79" stopColor="#7374F6"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const IconBenefitTestEngine2 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="77" height="80" fill="none" viewBox="0 0 77 80">
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint0_radial_1950_54691)"
        d="M47.129 75.659c16.027 0 29.02-7.013 29.02-15.664 0-8.65-12.993-15.663-29.02-15.663s-29.02 7.013-29.02 15.663c0 8.651 12.993 15.664 29.02 15.664z"
      ></path>
      <path
        fill="url(#paint1_linear_1950_54691)"
        d="M35.04 38.53V80C19.095 70.78 5.602 51.775.667 31.505l34.371 7.026z"
      ></path>
      <path fill="#AFB6E5" d="M35.04 80.002l3.228-1.891-.056-41.006-3.173 1.427v41.47z"></path>
      <path fill="#E5E9FF" d="M.668 31.504l3.229-1.883 34.371 7.027-3.229 1.883L.668 31.504z"></path>
      <path
        fill="url(#paint2_linear_1950_54691)"
        d="M65.46 40.502C60.757 21.305 45.334 3.35 30.952.41 26.634-.472 22.9.105 19.896 1.86L15.73 4.928l.272.449c-4.006 5.248-5.192 13.949-2.628 24.477L33.7 34.012l5.713 9.254v23.33a27.082 27.082 0 008.46 3.35 16.69 16.69 0 007.949-.144l.432.697s4.006-2.893 4.495-3.317l.625-.457-.048-.064c5.152-4.928 6.986-14.414 4.134-26.16z"
      ></path>
      <path
        fill="url(#paint3_linear_1950_54691)"
        d="M36.186 37.601l-26.047-5.328C5.468 13.044 13.344-.112 27.765 2.829c14.422 2.94 29.789 20.895 34.46 40.1 4.67 19.205-3.197 32.385-17.578 29.444a27.238 27.238 0 01-8.461-3.349V37.601z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint4_radial_1950_54691)"
        d="M62.443 42.713C57.772 23.508 42.333 5.561 27.91 2.621a17.322 17.322 0 00-6.61-.168 18.14 18.14 0 015.664.296c14.422 2.949 29.829 20.895 34.508 40.1 3.894 16.024-.937 27.826-10.984 29.645 10.72-1.234 15.968-13.284 11.954-29.78z"
      ></path>
      <defs>
        <radialGradient
          id="paint0_radial_1950_54691"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(28.9623 0 0 15.6681 45.333 59.792)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </radialGradient>
        <linearGradient
          id="paint1_linear_1950_54691"
          x1="-3.883"
          x2="47.731"
          y1="68.928"
          y2="37.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.14" stopColor="#B6BCE8"></stop>
          <stop offset="0.35" stopColor="#C8CDF1"></stop>
          <stop offset="0.58" stopColor="#E5E9FF"></stop>
          <stop offset="0.86" stopColor="#F5F6FF"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1950_54691"
          x1="59.507"
          x2="21.346"
          y1="66.533"
          y2="2.124"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09" stopColor="#4088EC"></stop>
          <stop offset="0.5" stopColor="#388CD6"></stop>
          <stop offset="0.69" stopColor="#4EC1EA"></stop>
          <stop offset="0.8" stopColor="#58D9F3"></stop>
          <stop offset="1" stopColor="#38A6F5"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1950_54691"
          x1="52.907"
          x2="10.043"
          y1="16.473"
          y2="70.626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#5277F7"></stop>
          <stop offset="0.69" stopColor="#5B76F7"></stop>
          <stop offset="0.79" stopColor="#7374F6"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <radialGradient
          id="paint4_radial_1950_54691"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.14 28.452) scale(29.0195)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.1" stopColor="#FAFAFA"></stop>
          <stop offset="0.22" stopColor="#EAEAEA"></stop>
          <stop offset="0.36" stopColor="#D1D1D1"></stop>
          <stop offset="0.51" stopColor="#ADADAD"></stop>
          <stop offset="0.66" stopColor="gray"></stop>
          <stop offset="0.82" stopColor="#484848"></stop>
          <stop offset="0.98" stopColor="#070707"></stop>
          <stop offset="1"></stop>
        </radialGradient>
      </defs>
    </svg>
  </span>
);

export const IconBenefitTestEngine3 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="80" fill="none" viewBox="0 0 69 80">
      <g clipPath="url(#clip0_1950_54706)">
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
          fill="url(#paint0_radial_1950_54706)"
          d="M45.591 79.999c12.844 0 23.256-5.432 23.256-12.132 0-6.7-10.412-12.133-23.256-12.133-12.843 0-23.255 5.432-23.255 12.133 0 6.7 10.412 12.132 23.255 12.132z"
        ></path>
        <path
          fill="url(#paint1_linear_1950_54706)"
          d="M63.908 55.316c0-18.837-13.306-41.786-29.722-51.257-7.909-4.545-15.1-5.15-20.4-2.437l-4.65 2.541 2.139 3.67a30.104 30.104 0 00-1.54 9.965c0 18.83 13.306 41.78 29.721 51.25a30.32 30.32 0 009.628 3.738l2.183 3.738 3.08-1.652c5.875-2.84 9.56-9.629 9.56-19.556z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint2_radial_1950_54706)"
          d="M51.858 76.246c11.533-6.742 11.416-28.402-.262-48.38C39.917 7.89 21.1-2.838 9.566 3.904c-11.533 6.743-11.415 28.403.263 48.38C21.507 72.26 40.324 82.989 51.858 76.246z"
        ></path>
        <path
          fill="url(#paint3_linear_1950_54706)"
          d="M51.194 76.608c11.533-6.743 11.416-28.403-.263-48.38C39.254 8.25 20.436-2.478 8.904 4.265c-11.534 6.742-11.416 28.402.262 48.38C20.843 72.62 39.66 83.35 51.194 76.606z"
        ></path>
        <path
          fill="#fff"
          d="M48.094 71.302c9.84-5.753 9.74-24.236-.226-41.283-9.966-17.047-26.022-26.203-35.863-20.45-9.84 5.752-9.739 24.235.227 41.282 9.965 17.047 26.022 26.203 35.862 20.45z"
        ></path>
        <path
          fill="url(#paint4_linear_1950_54706)"
          d="M52.192 67.39c2.04-2.99 3.215-7.17 3.215-12.312v-.24L30.043 40.434l22.15 26.955z"
        ></path>
        <path
          fill="url(#paint5_linear_1950_54706)"
          d="M31.084 69.018C17.075 60.929 5.72 41.344 5.72 25.273c0-8.044 2.848-13.68 7.475-16.296-5.232 2.324-8.484 8.222-8.484 16.819-.022 16.064 11.318 35.65 25.334 43.723 6.996 4.036 13.328 4.44 17.94 1.838-4.507 2.019-10.42 1.398-16.901-2.34z"
        ></path>
        <path
          fill="url(#paint6_linear_1950_54706)"
          d="M31.433 41.232c0 .882-.62 1.233-1.39.792a3.057 3.057 0 01-1.383-2.407c0-.882.62-1.233 1.383-.792a3.057 3.057 0 011.39 2.407z"
        ></path>
        <path
          fill="#AFB6E5"
          d="M30.432 15.698a.942.942 0 01-.381-.748v-1.263c0-.284.172-.418.381-.291a.904.904 0 01.389.747v1.293c0 .262-.172.397-.389.262zM30.432 67.471a.918.918 0 01-.381-.747v-1.271c0-.284.172-.419.381-.292a.904.904 0 01.389.748v1.293c0 .262-.172.396-.389.27zM8.89 27.994c0 .239-.15.35-.33.246l-1.36-.747a.815.815 0 01-.329-.636c0-.246.15-.351.329-.246l1.36.747a.8.8 0 01.33.636zM54.003 54.04c0 .246-.15.358-.337.254l-1.352-.748a.747.747 0 01-.33-.635c0-.24.143-.351.33-.247l1.352.748a.748.748 0 01.337.628zM19.66 12.805c-.187 0-.42-.194-.524-.471l-.628-1.6c-.104-.269-.045-.508.142-.523.187 0 .419.194.524.47l.628 1.6c.104.27.044.501-.143.524zM42.19 70.657c-.179 0-.418-.195-.523-.464l-.62-1.607c-.112-.269-.045-.5.135-.516.186 0 .418.187.53.464l.62 1.6c.128.269.068.508-.141.523zM11.773 42.025c.105.269.045.5-.142.515l-1.084.068c-.18 0-.418-.195-.523-.464-.105-.276-.045-.508.142-.523l1.084-.09c.18.008.418.217.523.494zM50.839 38.698c.104.27.044.501-.142.516l-1.077.097c-.187 0-.418-.194-.53-.463-.105-.277 0-.509.141-.523l1.084-.098c.187-.015.419.195.524.471zM11.773 17.299c-.105.15-.344.09-.523-.142l-1.084-1.338a.65.65 0 01-.142-.688c.104-.15.344-.082.523.142l1.084 1.345a.636.636 0 01.142.68zM50.84 65.737c-.104.15-.336.083-.522-.142l-1.084-1.308a.665.665 0 01-.142-.688c.112-.149.343-.082.53.143l1.077 1.293a.65.65 0 01.142.702zM19.663 55.623a.651.651 0 01.142.688l-.628.882c-.104.15-.336.082-.523-.142a.65.65 0 01-.142-.688l.628-.882c.105-.164.336-.082.523.142zM42.191 23.816a.65.65 0 01.142.688l-.598.912c-.112.15-.343.082-.53-.142a.643.643 0 01-.135-.688l.62-.882c.105-.18.344-.112.501.112z"
        ></path>
        <path fill="#344054" d="M30.717 41.832l-1.338-.778V19.57l1.338.778v21.484z"></path>
        <path fill="#667085" d="M30.282 40.148l-.41.576 18.12 22.47.41-.583-18.12-22.463z"></path>
        <path
          fill="#EB4680"
          d="M30.738 40.836c0 .433-.306.613-.695.396a1.538 1.538 0 01-.688-1.196c0-.441.307-.62.688-.396a1.494 1.494 0 01.695 1.196z"
        ></path>
        <path
          fill="#667085"
          d="M35.383 38.272l-.733-1.256-2.952 1.682.194.328L13.57 49.47l.352.598 18.314-10.443.194.33 2.953-1.682z"
        ></path>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1950_54706"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(23.2099 0 0 12.1757 43.797 64.045)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </radialGradient>
        <linearGradient
          id="paint1_linear_1950_54706"
          x1="56.627"
          x2="17.128"
          y1="73.227"
          y2="0.112"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09" stopColor="#4088EC"></stop>
          <stop offset="0.5" stopColor="#388CD6"></stop>
          <stop offset="0.69" stopColor="#4EC1EA"></stop>
          <stop offset="0.8" stopColor="#58D9F3"></stop>
          <stop offset="1" stopColor="#38A6F5"></stop>
        </linearGradient>
        <radialGradient
          id="paint2_radial_1950_54706"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-.136 16721.978 -12846.93) scale(34.0358)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint3_linear_1950_54706"
          x1="8"
          x2="53"
          y1="-1.501"
          y2="81.999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1950_54706"
          x1="42.4"
          x2="42.4"
          y1="44.315"
          y2="68.588"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#F97066"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1950_54706"
          x1="4.689"
          x2="47.955"
          y1="40.993"
          y2="40.993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#45108A"></stop>
          <stop offset="1" stopColor="#7C1DC9"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1950_54706"
          x1="28.66"
          x2="31.433"
          y1="40.432"
          y2="40.432"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#45108A"></stop>
          <stop offset="1" stopColor="#7C1DC9"></stop>
        </linearGradient>
        <clipPath id="clip0_1950_54706">
          <path fill="#fff" d="M0 0H68.518V80H0z" transform="translate(.332)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconBenefitProduct4 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="80" fill="none" viewBox="0 0 90 80">
      <g clipPath="url(#clip0_1416_98747)">
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
          fill="url(#paint0_radial_1416_98747)"
          d="M67.083 80c2.952 0 5.345-1.292 5.345-2.886s-2.393-2.886-5.345-2.886-5.345 1.293-5.345 2.886c0 1.594 2.393 2.886 5.345 2.886z"
        ></path>
        <path fill="#00719E" d="M45.676 37.604L50.05 35.1l16.635-13.814-4.375 2.503-16.635 13.814z"></path>
        <path
          fill="url(#paint1_linear_1416_98747)"
          d="M32.59 18.77l4.376-2.502 13.2 11.651-4.384 2.496L32.59 18.77z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
          fill="url(#paint2_radial_1416_98747)"
          d="M72.358 11.487l4.245-2.604-4.411 2.423-16.954 5.323.319.318 16.8-5.46z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
          fill="url(#paint3_radial_1416_98747)"
          d="M32.591 19.189l13.192 11.645 12.694-10.531-.109-.116-.116-.116-12.469 10.343-13.192-11.645-23.81 17.163.318.189 23.492-16.932z"
        ></path>
        <path fill="#35004D" d="M69.6 74.647a3.016 3.016 0 11-5.308 2.863 3.016 3.016 0 015.308-2.864z"></path>
        <path
          fill="url(#paint4_linear_1416_98747)"
          d="M57.65 51.352l-6.51 3.515L63.285 77.2c.564 1.049 2.481 1.114 4.282.145 1.8-.97 2.806-2.611 2.242-3.66L57.65 51.352z"
        ></path>
        <path
          fill="url(#paint5_linear_1416_98747)"
          d="M57.658 51.351c.564 1.05-.441 2.684-2.242 3.66s-3.718.904-4.282-.145c-.564-1.048.434-2.683 2.235-3.66 1.8-.976 3.718-.925 4.289.145z"
        ></path>
        <path
          fill="url(#paint6_linear_1416_98747)"
          d="M53.818 47.453l-3.877 2.09 2.315 4.224c.34.622 1.446.658 2.553.087 1.107-.571 1.663-1.555 1.33-2.17l-2.32-4.23z"
        ></path>
        <path fill="#fff" d="M58.318 2.105H17.852v54.636h40.466V2.105z"></path>
        <g opacity="0.2">
          <path
            fill="#ABB2E2"
            d="M1.67 37.612a1.707 1.707 0 00-.912 1.446 1.851 1.851 0 001.005 1.592s5.063 3.175 5.12 3.196l3.69 2.243 1.12.723c.574.315 1.219.48 1.874.477a3.146 3.146 0 001.54-.362S18 44.852 18 44.844a1.685 1.685 0 00.912-1.446 1.845 1.845 0 00-.998-1.599s-5.063-3.16-5.107-3.182l-3.681-2.25-1.027-.621a3.855 3.855 0 00-1.873-.477 3.146 3.146 0 00-1.54.361s-3.002 1.982-3.017 1.982z"
            opacity="0.05"
          ></path>
          <path
            fill="#A7ADDF"
            d="M1.814 37.611a1.693 1.693 0 00-.904 1.367 1.75 1.75 0 00.904 1.526c-.058.036 4.803 3.067 4.875 3.11l3.566 2.17 1.085.658a3.776 3.776 0 001.808.463c.518.01 1.03-.11 1.49-.347.036 0 2.784-1.975 2.813-1.99a1.692 1.692 0 00.904-1.366 1.751 1.751 0 00-.904-1.548c.058-.036-4.788-3.06-4.86-3.096l-3.559-2.17-.998-.607a3.718 3.718 0 00-1.8-.456 3.044 3.044 0 00-1.49.34s-2.9 1.946-2.93 1.946z"
            opacity="0.1"
          ></path>
          <path
            fill="#A3A9DC"
            d="M1.957 37.554a1.706 1.706 0 00-.897 1.324 1.67 1.67 0 00.803 1.497c-.087.05 4.52 2.958 4.643 3.023l3.443 2.083 1.049.637c.535.288 1.134.44 1.743.44.502.018 1-.094 1.446-.325.05 0 2.676-1.873 2.72-1.894a1.707 1.707 0 00.896-1.324 1.656 1.656 0 00-.802-1.497c.086-.058-4.506-2.951-4.615-3.016l-3.435-2.076-.998-.586a3.668 3.668 0 00-1.743-.448 3.016 3.016 0 00-1.447.325c-.029 0-2.763 1.816-2.806 1.837z"
            opacity="0.14"
          ></path>
          <path
            fill="#9FA4D8"
            d="M2.104 37.511a1.707 1.707 0 00-.896 1.273 1.577 1.577 0 00.723 1.447c-.123.072 4.23 2.85 4.376 2.893l3.32 1.996 1.012.615a3.617 3.617 0 001.685.427c.478.011.952-.093 1.382-.304.072 0 2.574-1.78 2.625-1.808a1.714 1.714 0 00.897-1.28 1.57 1.57 0 00-.724-1.447c.123-.072-4.223-2.842-4.339-2.893l-3.313-1.996-.925-.557a3.616 3.616 0 00-1.7-.434 2.894 2.894 0 00-1.389.304c-.072.014-2.669 1.728-2.734 1.764z"
            opacity="0.19"
          ></path>
          <path
            fill="#9BA0D5"
            d="M2.256 37.461a1.75 1.75 0 00-.897 1.237 1.49 1.49 0 00.615 1.396c-.152.094 3.956 2.748 4.13 2.85L9.3 44.845l.977.585c.5.264 1.055.403 1.62.406.458.017.915-.075 1.33-.268.095 0 2.467-1.678 2.532-1.714a1.75 1.75 0 00.875-1.237 1.511 1.511 0 00-.593-1.389c.152-.087-3.942-2.734-4.123-2.835l-3.19-1.916-.889-.536a3.516 3.516 0 00-1.62-.405c-.46-.017-.917.08-1.33.282-.095-.014-2.568 1.606-2.633 1.642z"
            opacity="0.24"
          ></path>
          <path
            fill="#979BD2"
            d="M2.4 37.417a1.751 1.751 0 00-.89 1.193 1.447 1.447 0 00.513 1.345c-.18.109 3.675 2.633 3.891 2.763l3.067 1.83.94.557a3.371 3.371 0 001.555.398c.445.014.886-.077 1.288-.268.108 0 2.35-1.577 2.43-1.62a1.778 1.778 0 00.89-1.193 1.447 1.447 0 00-.514-1.353c.18-.101-3.66-2.625-3.877-2.748l-3.066-1.837-.854-.507a3.371 3.371 0 00-1.555-.397 2.793 2.793 0 00-1.287.267c-.109 0-2.452 1.526-2.532 1.57z"
            opacity="0.29"
          ></path>
          <path
            fill="#9397CF"
            d="M2.544 37.373c-.376.239-.882.752-.882 1.143 0 .39-.05 1.034.42 1.302-.218.123 3.384 2.524 3.616 2.669l2.98 1.75c.043 0 .86.52.903.535.46.245.97.374 1.49.376.421.015.84-.069 1.223-.246.123 0 2.249-1.446 2.336-1.533.39-.217.89-.723.89-1.143 0-.42.043-1.034-.42-1.302.217-.123-3.378-2.517-3.616-2.661l-2.944-1.75s-.781-.478-.825-.492c-.46-.242-.97-.371-1.49-.376a2.747 2.747 0 00-1.229.238c-.152.008-2.358 1.432-2.452 1.49z"
            opacity="0.33"
          ></path>
          <path
            fill="#8F92CC"
            d="M2.687 37.324c-.354.21-.882.723-.882 1.106 0 .384-.108.998.325 1.252-.245.137 3.11 2.415 3.393 2.581l2.82 1.671c.05 0 .818.485.868.507.448.231.943.355 1.447.361a2.75 2.75 0 001.179-.224c.144 0 2.17-1.382 2.242-1.447.361-.202.89-.723.89-1.099s.1-.998-.326-1.251c.246-.145-3.096-2.416-3.385-2.575l-2.82-1.67c-.037 0-.724-.45-.789-.464a3.226 3.226 0 00-1.447-.369 2.778 2.778 0 00-1.142.225c-.188.007-2.264 1.338-2.373 1.396z"
            opacity="0.38"
          ></path>
          <path
            fill="#8B8EC9"
            d="M2.842 37.279c-.333.195-.882.723-.882 1.063 0 .34-.174.97.224 1.193-.275.167 2.828 2.315 3.146 2.503l2.705 1.584c.05 0 .767.463.824.484a3.06 3.06 0 001.367.34c.387.02.773-.05 1.129-.202.166 0 2.032-1.28 2.17-1.353.325-.188.875-.723.875-1.056 0-.332.173-.969-.225-1.2.29-.13-2.828-2.3-3.153-2.496l-2.698-1.584c-.043 0-.723-.419-.723-.44a3.161 3.161 0 00-1.367-.348 2.539 2.539 0 00-1.172.203c-.159.007-2.104 1.236-2.22 1.309z"
            opacity="0.43"
          ></path>
          <path
            fill="#8789C6"
            d="M2.986 37.236c-.304.174-.875.724-.875 1.013 0 .29-.239.94.13 1.15-.31.18 2.539 2.206 2.893 2.416l2.582 1.497c.051 0 .724.434.789.455.403.208.848.322 1.302.333a2.43 2.43 0 001.077-.188c.712-.37 1.4-.783 2.062-1.237.303-.173.875-.723.875-1.012 0-.29.231-.94-.13-1.15.303-.181-2.532-2.17-2.894-2.409L8.215 36.6c-.05 0-.658-.39-.723-.413a3.016 3.016 0 00-1.302-.332c-.37-.019-.74.043-1.085.18-.728.361-1.435.762-2.119 1.201z"
            opacity="0.48"
          ></path>
          <path
            fill="#8385C2"
            d="M3.132 37.184c-.275.166-.875.723-.875.977 0 .253-.297.904 0 1.099-.34.195 2.256 2.097 2.654 2.322l2.452 1.446c.058 0 .68.405.723.427.385.192.807.3 1.237.318.352.012.704-.045 1.034-.166.677-.35 1.332-.741 1.96-1.172.275-.16.868-.723.868-.97 0-.245.304-.91 0-1.099.34-.195-2.25-2.097-2.64-2.321l-2.451-1.447c-.058 0-.622-.376-.724-.398a3.075 3.075 0 00-1.244-.318 2.46 2.46 0 00-1.027.167c-.679.336-1.336.715-1.967 1.135z"
            opacity="0.52"
          ></path>
          <path
            fill="#7F80BF"
            d="M3.276 37.143c-.246.145-.868.68-.868.933s-.361.875-.065 1.049c-.369.21 1.982 1.989 2.409 2.235l2.329 1.316c.065 0 .636.376.723.405.368.181.77.282 1.179.296.332.018.664-.03.976-.144.648-.314 1.271-.674 1.866-1.078.246-.145.868-.672.868-.926 0-.253.362-.875.065-1.048.37-.217-1.967-1.99-2.394-2.235L8.028 36.63c-.065 0-.586-.348-.65-.37a2.793 2.793 0 00-1.18-.303 2.496 2.496 0 00-.983.145c-.672.296-1.32.644-1.939 1.041z"
            opacity="0.57"
          ></path>
          <path
            fill="#7B7CBC"
            d="M3.421 37.098c-.217.123-.86.658-.86.882 0 .224-.391.846-.16.998-.405.231 1.693 1.888 2.17 2.17l2.192 1.237c.072.043.593.354.68.383.347.17.727.266 1.113.282.315.018.63-.026.926-.13a11.69 11.69 0 001.772-.97c.224-.13.868-.658.868-.882 0-.224.427-.846.16-.998.397-.231-1.686-1.88-2.17-2.17l-2.17-1.258c-.065-.036-.543-.318-.622-.347a2.822 2.822 0 00-1.114-.29 2.358 2.358 0 00-.94.16c-.64.257-1.258.57-1.845.933z"
            opacity="0.62"
          ></path>
          <path
            fill="#7777B9"
            d="M3.572 37.055c-.196.109-.861.644-.861.84 0 .194-.492.81-.26.947-.427.253 1.41 1.779 1.909 2.068l2.083 1.172c.08.043.55.318.644.354a2.67 2.67 0 001.048.26c.296.022.594-.015.875-.108a9.776 9.776 0 001.678-.89c.196-.108.861-.643.861-.839 0-.195.492-.817.26-.947.434-.253-1.403-1.78-1.902-2.061l-2.083-1.18c-.072-.035-.506-.288-.586-.325a2.806 2.806 0 00-1.048-.267 2.466 2.466 0 00-.883.087 9.735 9.735 0 00-1.735.89z"
            opacity="0.67"
          ></path>
          <path
            fill="#7373B6"
            d="M3.716 37.005c-.166.094-.825.608-.825.803 0 .195-.55.781-.347.897-.463.267 1.129 1.67 1.657 1.974l1.96 1.092c.086.051.506.297.6.326.31.147.647.233.99.253.279.017.557-.013.825-.087a7.956 7.956 0 001.548-.803c.166-.094.86-.629.86-.795 0-.167.55-.789.355-.904.463-.26-1.12-1.664-1.656-1.975l-1.96-1.085a5.845 5.845 0 00-.55-.303 2.667 2.667 0 00-.99-.232 2.337 2.337 0 00-.825.08 8.364 8.364 0 00-1.642.759z"
            opacity="0.71"
          ></path>
          <path
            fill="#6F6EB3"
            d="M3.861 36.96c-.137.08-.853.616-.853.724 0 .109-.615.723-.448.854-.492.282.846 1.562 1.446 1.887l1.78 1.035c.179.112.365.213.556.303.294.134.61.212.933.232.268.033.54.019.803-.044a6.565 6.565 0 001.49-.723c.137-.08.854-.615.854-.723 0-.109.614-.724.448-.854.492-.282-.846-1.555-1.41-1.887l-1.838-1.006a5.834 5.834 0 00-.513-.282 2.822 2.822 0 00-.926-.238 2.714 2.714 0 00-.781.065 6.913 6.913 0 00-1.54.658z"
            opacity="0.76"
          ></path>
          <path
            fill="#6B6AB0"
            d="M4.006 36.89c-.109.058-.846.593-.846.724 0 .13-.68.723-.55.795-.52.304.564 1.447 1.172 1.808l1.714.94c.094.051.42.24.52.275.276.12.57.194.868.217.243.02.487.004.724-.05a5.288 5.288 0 001.396-.615c.108-.065.846-.6.846-.723s.68-.724.55-.803c.52-.304-.565-1.447-1.165-1.801l-1.714-.911a6.012 6.012 0 00-.477-.254 2.698 2.698 0 00-.868-.224 2.368 2.368 0 00-.724.044 5.367 5.367 0 00-1.446.578z"
            opacity="0.81"
          ></path>
          <path
            fill="#6765AC"
            d="M4.157 36.89a5.065 5.065 0 00-.846.666c0 .094-.723.723-.644.723-.556.318.275 1.345.919 1.721l1.591.84c.101.057.376.21.485.252.255.11.526.178.803.203.223.026.449.026.672 0a4.514 4.514 0 001.302-.528c.304-.193.587-.416.846-.665 0-.094.724-.724.644-.724.557-.318-.282-1.345-.919-1.714l-1.59-.846c-.095-.05-.34-.188-.442-.231a2.52 2.52 0 00-.81-.203 2.311 2.311 0 00-.673 0c-.47.095-.922.266-1.338.506z"
            opacity="0.86"
          ></path>
          <path
            fill="#6361A9"
            d="M4.337 36.825a6.394 6.394 0 00-.846.622c0 .065-.803.658-.723.723-.586.333 0 1.237.673 1.627l1.446.767c.109.058.333.18.448.224a2.83 2.83 0 001.346.181 3.384 3.384 0 001.208-.434c.295-.189.578-.396.846-.622 0-.065.803-.665.723-.723.586-.34 0-1.237-.673-1.628l-1.446-.766a3.612 3.612 0 00-.412-.203 2.465 2.465 0 00-.724-.195 2.548 2.548 0 00-.622 0c-.437.064-.859.209-1.244.427z"
            opacity="0.9"
          ></path>
          <path
            fill="#5F5CA6"
            d="M4.446 36.78s-.832.549-.832.578c0 .029-.868.63-.839.644-.614.361-.282 1.135.427 1.547l1.345.68c.132.077.27.142.413.196.217.088.446.146.68.173.187.018.376.018.564 0 .391-.03.772-.146 1.113-.34 0 0 .84-.55.84-.579 0-.028.875-.629.838-.65.615-.355.283-1.136-.426-1.548l-1.338-.666a2.606 2.606 0 00-1.056-.362 2.516 2.516 0 00-.572 0c-.405.022-.8.134-1.157.326z"
            opacity="0.95"
          ></path>
          <path
            fill="#5B58A3"
            d="M6.747 40.027l1.772-1.135c.644-.376.564-1.027-.18-1.447l-1.223-.593a2.813 2.813 0 00-2.524-.108l-1.765 1.12c-.65.377-.571 1.028.18 1.447l1.216.593a2.813 2.813 0 002.524.123z"
          ></path>
        </g>
        <path fill="#006D9C" d="M46.16 40.439l5.483-3.132L76.948 16.31l-5.475 3.132L46.16 40.44z"></path>
        <path fill="#1F45CC" d="M6.48 42.24l5.476-3.132 22.978-16.534-5.475 3.132L6.48 42.24z"></path>
        <path
          fill="url(#paint7_linear_1416_98747)"
          d="M29.793 16.867l5.475-3.125L51.78 28.316l-5.475 3.124-16.512-14.573z"
        ></path>
        <path fill="#CAFF82" d="M62.621 10.482l5.475-3.132L89.671.58l-5.475 3.132-21.575 6.77z"></path>
        <path fill="#51A245" d="M75.356 23.428l5.475-3.125L89.669.58l-5.475 3.132-8.838 19.716z"></path>
        <path
          fill="url(#paint8_linear_1416_98747)"
          d="M62.62 10.48l3.92 3.935.137.138L46.303 31.44 29.791 16.867 0 38.341l6.48 3.898L29.46 25.705 46.172 40.46 71.48 19.464l.08.08 3.797 3.883 8.838-19.716-21.575 6.77z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
          fill="url(#paint9_radial_1416_98747)"
          d="M84.044 4.043L89.36.781l-5.526 3.045-21.213 6.654.398.398 21.025-6.835z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
          fill="url(#paint10_radial_1416_98747)"
          d="M29.791 17.396L46.303 31.97l20.374-16.895-.137-.138-.152-.152-20.085 16.657-16.512-14.574L0 38.342l.398.239L29.79 17.396z"
        ></path>
        <path
          fill="url(#paint11_linear_1416_98747)"
          d="M40.813 47.107c-10.24-5.88-18.551-20.244-18.551-32.005 0-4.723 1.338-8.317 3.616-10.538-4.325 1.404-7.073 5.859-7.073 12.65 0 11.76 8.31 26.088 18.559 32.005 6.133 3.544 11.572 3.269 14.942-.044-3.182 1.027-7.16.427-11.492-2.068z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint12_radial_1416_98747)"
          d="M50.349 48.67c6.788-3.948 6.749-16.68-.088-28.438C43.424 8.473 32.38 2.14 25.591 6.087c-6.787 3.946-6.748 16.678.088 28.437 6.837 11.758 17.882 18.092 24.67 14.145z"
          opacity="0.5"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
          fill="url(#paint13_radial_1416_98747)"
          d="M50.349 48.67c6.788-3.948 6.749-16.68-.088-28.438C43.424 8.473 32.38 2.14 25.591 6.087c-6.787 3.946-6.748 16.678.088 28.437 6.837 11.758 17.882 18.092 24.67 14.145z"
        ></path>
        <path
          fill="url(#paint14_linear_1416_98747)"
          d="M41.27 4.39c-5.063-2.893-9.612-3.247-12.953-1.446-.094.05-4.897 2.727-5.063 2.958 3.4-2.568 8.44-2.524 14.06.723 10.249 5.924 18.552 20.252 18.552 32.012 0 5.996-2.17 10.169-5.642 12.028.317-.094.621-.228.904-.398.102-.05 3.378-2.04 3.472-2.098 3.219-1.967 5.208-6.039 5.208-11.781.021-11.753-8.289-26.081-18.538-31.998z"
        ></path>
        <path
          fill="url(#paint15_linear_1416_98747)"
          d="M37.335 6.633c-10.249-5.91-18.53-1.18-18.53 10.581 0 11.76 8.281 26.088 18.53 32.004 10.248 5.917 18.551 1.186 18.551-10.574S47.583 12.556 37.335 6.633zm-.13 41.175c-9.46-5.46-17.135-18.69-17.135-29.545 0-10.856 7.674-15.232 17.135-9.772 9.46 5.461 17.134 18.697 17.134 29.553 0 10.856-7.674 15.232-17.134 9.764z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint16_radial_1416_98747)"
          d="M38.224 6.191c-4.91-2.835-9.402-3.218-12.693-1.562 3.096-.86 7.645-.398 11.804 2.004 10.248 5.923 18.551 20.251 18.551 32.011 0 6.119-2.965 10.51-6.567 12.296 4.528-1.273 7.464-5.786 7.464-12.766 0-11.738-8.324-26.066-18.559-31.983z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint17_radial_1416_98747)"
          d="M35.773 21.185a57.007 57.007 0 019.844-7.905 31.102 31.102 0 00-7.392-6.14c-9.7-5.599-17.56-1.115-17.56 10.01 0 5.597 1.988 11.81 5.2 17.314a56.356 56.356 0 019.908-13.28z"
          opacity="0.5"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
          fill="url(#paint18_radial_1416_98747)"
          d="M62.127 40.517a6.329 6.329 0 10-12.485-2.08 6.329 6.329 0 0012.485 2.08z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
          fill="url(#paint19_radial_1416_98747)"
          d="M30.592 31.997c8.836 0 15.999-7.163 15.999-15.998C46.59 7.163 39.428 0 30.592 0c-8.835 0-15.998 7.163-15.998 15.999 0 8.835 7.162 15.998 15.998 15.998z"
          opacity="0.6"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
          fill="url(#paint20_radial_1416_98747)"
          d="M46.667 15.842a6.329 6.329 0 10-4.844-11.694 6.329 6.329 0 004.844 11.694z"
        ></path>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(5.3384 0 0 2.88799 65.296 76.936)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </radialGradient>
        <linearGradient
          id="paint1_linear_1416_98747"
          x1="52.588"
          x2="26.608"
          y1="34.486"
          y2="8.666"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#84EFA9"></stop>
          <stop offset="0.14" stopColor="#80F0AD"></stop>
          <stop offset="0.49" stopColor="#51F8D8"></stop>
          <stop offset="0.77" stopColor="#34FDF3"></stop>
          <stop offset="0.92" stopColor="#29FFFD"></stop>
        </linearGradient>
        <radialGradient
          id="paint2_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(71.483 2.178) scale(17.286)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint3_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(31.622 30.964) scale(18.5661)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint4_linear_1416_98747"
          x1="57.718"
          x2="64.219"
          y1="66.975"
          y2="63.472"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B3ABA"></stop>
          <stop offset="0.14" stopColor="#564BD7"></stop>
          <stop offset="0.23" stopColor="#6152E3"></stop>
          <stop offset="0.4" stopColor="#4528C9"></stop>
          <stop offset="0.48" stopColor="#4221A9"></stop>
          <stop offset="0.57" stopColor="#401B8D"></stop>
          <stop offset="0.63" stopColor="#3F1982"></stop>
          <stop offset="0.87" stopColor="#5E239E"></stop>
          <stop offset="1" stopColor="#491C8B"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1416_98747"
          x1="55.654"
          x2="53.781"
          y1="47.901"
          y2="55.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B3ABA"></stop>
          <stop offset="0.17" stopColor="#3F34BF"></stop>
          <stop offset="0.57" stopColor="#4528C9"></stop>
          <stop offset="0.59" stopColor="#472BCB"></stop>
          <stop offset="0.85" stopColor="#5A47DC"></stop>
          <stop offset="1" stopColor="#6152E3"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1416_98747"
          x1="51.421"
          x2="55.273"
          y1="52.237"
          y2="50.161"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.11" stopColor="#E5E9FF"></stop>
          <stop offset="0.17" stopColor="#fff"></stop>
          <stop offset="0.4" stopColor="#DFE3FC"></stop>
          <stop offset="0.7" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#BAC0EA"></stop>
          <stop offset="1" stopColor="#BDC3EC"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1416_98747"
          x1="54.818"
          x2="22.314"
          y1="36.539"
          y2="4.224"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#29FFFD"></stop>
          <stop offset="0.68" stopColor="#69A9F3"></stop>
          <stop offset="1" stopColor="#8484EF"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1416_98747"
          x1="78.461"
          x2="0"
          y1="22.866"
          y2="22.866"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <radialGradient
          id="paint9_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(82.945 -7.601) scale(21.6328)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint10_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(30.645 31.514) scale(24.9308)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint11_linear_1416_98747"
          x1="23.036"
          x2="42.347"
          y1="7.472"
          y2="52.191"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9DA6EA"></stop>
          <stop offset="0.11" stopColor="#E5E9FF"></stop>
          <stop offset="0.4" stopColor="#DFE3FC"></stop>
          <stop offset="0.7" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#BAC0EA"></stop>
          <stop offset="1" stopColor="#BDC3EC"></stop>
        </linearGradient>
        <radialGradient
          id="paint12_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(.136 -8933.693 14504.708) scale(25.0239)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#6CF"></stop>
          <stop offset="1" stopColor="#5277F7"></stop>
        </radialGradient>
        <radialGradient
          id="paint13_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(.136 -9015.226 14465.343) scale(25.0239)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.48" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#AFB6E5"></stop>
        </radialGradient>
        <linearGradient
          id="paint14_linear_1416_98747"
          x1="33.242"
          x2="56.683"
          y1="1.317"
          y2="46.181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9DA6EA"></stop>
          <stop offset="0.11" stopColor="#E5E9FF"></stop>
          <stop offset="0.17" stopColor="#fff"></stop>
          <stop offset="0.4" stopColor="#DFE3FC"></stop>
          <stop offset="0.7" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#BAC0EA"></stop>
          <stop offset="1" stopColor="#BDC3EC"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1416_98747"
          x1="21.177"
          x2="45.674"
          y1="33.14"
          y2="25.235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.14" stopColor="#B6BCE8"></stop>
          <stop offset="0.35" stopColor="#C8CDF1"></stop>
          <stop offset="0.58" stopColor="#E5E9FF"></stop>
          <stop offset="0.95" stopColor="#F5F4FC"></stop>
          <stop offset="1" stopColor="#F7F6FB"></stop>
        </linearGradient>
        <radialGradient
          id="paint16_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(45.855 12.824) scale(20.0488)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint17_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(33.907 17.2) scale(13.7275)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint18_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(56.087 39.678) scale(4.62888)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#273B98"></stop>
          <stop offset="0.04" stopColor="#23368A"></stop>
          <stop offset="0.2" stopColor="#192560"></stop>
          <stop offset="0.35" stopColor="#10183E"></stop>
          <stop offset="0.51" stopColor="#090D23"></stop>
          <stop offset="0.67" stopColor="#04060F"></stop>
          <stop offset="0.83" stopColor="#010104"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint19_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(31.106 16.512) scale(11.6951)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#6CF"></stop>
          <stop offset="0.02" stopColor="#62C4F5"></stop>
          <stop offset="0.09" stopColor="#4E9BC2"></stop>
          <stop offset="0.18" stopColor="#3B7694"></stop>
          <stop offset="0.26" stopColor="#2B566C"></stop>
          <stop offset="0.35" stopColor="#1E3C4A"></stop>
          <stop offset="0.44" stopColor="#13262F"></stop>
          <stop offset="0.54" stopColor="#0A151A"></stop>
          <stop offset="0.66" stopColor="#05090B"></stop>
          <stop offset="0.79" stopColor="#010203"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint20_radial_1416_98747"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(44.453 10.2) scale(4.62888)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#364F87"></stop>
          <stop offset="0.15" stopColor="#263860"></stop>
          <stop offset="0.31" stopColor="#19243D"></stop>
          <stop offset="0.48" stopColor="#0E1422"></stop>
          <stop offset="0.65" stopColor="#06090F"></stop>
          <stop offset="0.82" stopColor="#020204"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <clipPath id="clip0_1416_98747">
          <path fill="#fff" d="M0 0H89.67V80H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconBenefitProduct5 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="80" fill="none" viewBox="0 0 57 80">
      <g opacity="0.95">
        <path fill="url(#paint0_linear_1416_98812)" d="M43.119 0l6.336 3.664-6.342 3.659-6.336-3.664L43.12 0z"></path>
        <path fill="url(#paint1_linear_1416_98812)" d="M49.459 55.322l-6.342 3.659V7.322l6.342-3.664v51.664z"></path>
        <path fill="url(#paint2_linear_1416_98812)" d="M43.119 58.98l-6.342-3.658V3.658l6.342 3.664v51.659z"></path>
      </g>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint3_radial_1416_98812)"
        d="M36.777 3.658l6.31 3.398 6.373-3.398-6.15 3.803-.191 51.52-.299-51.568-6.043-3.755z"
      ></path>
      <path
        fill="url(#paint4_linear_1416_98812)"
        d="M34.027 15.568l6.342 3.664-6.342 3.659-6.336-3.664 6.336-3.659z"
      ></path>
      <path fill="url(#paint5_linear_1416_98812)" d="M40.373 60.384l-6.342 3.659V22.89l6.342-3.664v41.157z"></path>
      <path fill="url(#paint6_linear_1416_98812)" d="M34.033 64.043l-6.342-3.66V19.228l6.342 3.664v41.152z"></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint7_radial_1416_98812)"
        d="M27.691 19.227l6.31 3.397 6.373-3.397-6.15 3.802-.191 41.014-.304-41.062-6.038-3.754z"
      ></path>
      <g opacity="0.95">
        <path
          fill="url(#paint8_linear_1416_98812)"
          d="M24.73 31.719l6.337 3.664-6.337 3.658-6.335-3.664 6.335-3.658z"
        ></path>
        <path fill="url(#paint9_linear_1416_98812)" d="M31.072 65.286L24.73 68.95V39.041l6.34-3.664v29.91z"></path>
        <path fill="url(#paint10_linear_1416_98812)" d="M24.736 68.95l-6.341-3.664V35.377l6.34 3.664v29.91z"></path>
      </g>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint11_radial_1416_98812)"
        d="M18.395 35.377l6.303 3.397 6.374-3.397-6.15 3.803-.186 29.77-.304-29.813-6.037-3.76z"
      ></path>
      <g opacity="0.95">
        <path
          fill="url(#paint12_linear_1416_98812)"
          d="M15.547 49.402l6.336 3.664-6.336 3.659-6.336-3.664 6.336-3.659z"
        ></path>
        <path
          fill="url(#paint13_linear_1416_98812)"
          d="M15.547 67.21l6.336 3.665-6.336 3.664-6.336-3.664 6.336-3.664z"
        ></path>
        <path fill="url(#paint14_linear_1416_98812)" d="M21.888 71.013l-6.341 3.663V56.725l6.341-3.663v17.952z"></path>
        <path fill="url(#paint15_linear_1416_98812)" d="M15.552 74.677l-6.341-3.665V53.06l6.341 3.664v17.953z"></path>
      </g>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint16_radial_1416_98812)"
        d="M9.21 53.06l6.305 3.398 6.373-3.398-6.15 3.803-.186 17.814-.304-17.862-6.037-3.755z"
      ></path>
      <g opacity="0.95">
        <path
          fill="url(#paint17_linear_1416_98812)"
          d="M6.336 63.04l6.336 3.658-6.336 3.664L0 66.698l6.336-3.659z"
        ></path>
        <path fill="url(#paint18_linear_1416_98812)" d="M12.676 76.255L6.34 79.919v-9.563l6.336-3.659v9.558z"></path>
        <path fill="url(#paint19_linear_1416_98812)" d="M6.341 79.919L0 76.255v-9.558l6.341 3.659v9.563z"></path>
      </g>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint20_radial_1416_98812)"
        d="M0 66.697l6.31 3.398 6.367-3.398L6.533 70.5l-.192 9.419-.304-9.467L0 66.697z"
      ></path>
      <path
        fill="url(#paint21_linear_1416_98812)"
        d="M50.134 67.396c-3.648 0-6.603-1.723-6.603-3.845v.832c0 2.133 2.955 3.845 6.603 3.845 3.648 0 6.603-1.717 6.603-3.845V63.55c.016 2.122-2.94 3.845-6.603 3.845z"
        opacity="0.15"
      ></path>
      <path
        fill="url(#paint22_linear_1416_98812)"
        d="M56.773 61.277h-13.21v1.915c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.717 6.608-3.845v-1.915z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint23_linear_1416_98812)"
        d="M50.165 66.627c-3.642 0-6.602-1.723-6.602-3.846v.411c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.717 6.608-3.845v-.411c0 2.123-2.96 3.846-6.608 3.846z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 66.856l.182-.042v-4.88h-.182v4.922zM53.02 66.663l.186-.053v-4.672h-.187v4.725zM53.867 66.387l.187-.08v-4.373h-.187v4.453zM51.36 66.974h.186v-5.019h-.187v5.019zM55.512 65.448l.186-.154v-3.36h-.186v3.514zM56.336 64.53c.071-.102.134-.211.187-.325v-2.293h-.187v2.619zM54.68 65.998c.064-.031.126-.065.186-.102v-3.962h-.186v4.064zM50.535 67.025h.182v-5.088h-.182v5.088zM49.703 67.026h.187v-5.098h-.187v5.098zM48.043 66.835l.187.037v-4.938h-.187v4.9zM48.871 66.963h.187v-5.045h-.187v5.045zM47.21 66.632l.188.048v-4.746h-.187v4.698zM43.895 64.392c.057.101.119.2.186.294v-2.752h-.187v2.458zM44.727 65.368c.058.054.122.096.18.144v-3.578h-.18v3.434zM46.402 66.344l.187.07v-4.48h-.187v4.41zM45.555 65.944l.186.096v-4.106h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint24_linear_1416_98812)"
        d="M56.773 61.33c0 2.133-2.96 3.845-6.608 3.845-3.648 0-6.602-1.75-6.602-3.845 0-2.096 2.96-3.846 6.602-3.846 3.643 0 6.608 1.712 6.608 3.846z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint25_radial_1416_98812)"
        d="M50.166 65.065c-3.568 0-6.47-1.653-6.592-3.733v.133c0 2.134 2.96 3.846 6.603 3.846s6.608-1.723 6.608-3.846a1.024 1.024 0 000-.133c-.144 2.064-3.045 3.733-6.619 3.733z"
      ></path>
      <path
        fill="url(#paint26_linear_1416_98812)"
        d="M50.165 64.179c2.728 0 4.939-1.287 4.939-2.875 0-1.587-2.211-2.874-4.939-2.874-2.727 0-4.938 1.287-4.938 2.874 0 1.588 2.21 2.875 4.938 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint27_radial_1416_98812)"
        d="M50.33 58.573c2.64 0 4.8 1.205 4.923 2.72a1.376 1.376 0 000-.155c0-1.6-2.213-2.874-4.939-2.874-2.725 0-4.933 1.29-4.933 2.874a1.426 1.426 0 000 .155c.165-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint28_linear_1416_98812)"
        d="M50.166 58.739c2.667 0 4.8 1.205 4.928 2.72v-.155c0-1.6-2.208-2.874-4.939-2.874-2.73 0-4.922 1.301-4.922 2.901a1.478 1.478 0 000 .155c.149-1.542 2.298-2.747 4.933-2.747z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint29_radial_1416_98812)"
        d="M53.637 57.598c1.482.501 2.48 1.51 2.234 2.245-.245.736-1.658.917-3.14.416-1.484-.501-2.486-1.514-2.236-2.245.251-.73 1.66-.918 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint30_linear_1416_98812)"
        d="M50.55 60.403c-.122 0-.25.053-.384.085a4.512 4.512 0 00-.736.25l.4.225.128-.043.144-.053c.23-.08.438-.144.64-.197.175-.05.353-.086.534-.107.166-.024.335-.024.501 0 .162.03.317.087.459.17.141.067.256.18.325.32a.436.436 0 010 .347.992.992 0 01-.245.347c-.13.122-.271.23-.422.325l.534.31-.443.256-.533-.315a7.405 7.405 0 01-.88.373c-.297.104-.6.188-.907.25l-.288-.703c.15 0 .304-.059.464-.102.16-.042.283-.074.448-.127.158-.051.313-.112.464-.182l-.384-.224a10.34 10.34 0 01-1.03.32 3.111 3.111 0 01-.495.075c-.14.006-.28-.005-.416-.032a1.429 1.429 0 01-.363-.144.762.762 0 01-.32-.299.534.534 0 01-.048-.341.828.828 0 01.192-.352c.112-.133.243-.248.39-.342l-.443-.26.442-.257.448.261c.134-.064.272-.122.411-.175l.41-.14a4.1 4.1 0 01.395-.116l.347-.091.261.688zm-1.482.71a.33.33 0 00.165 0c.083-.01.165-.026.245-.049l-.336-.197c-.144.123-.17.192-.074.245zm2.133.351a.294.294 0 00-.176 0 1.432 1.432 0 00-.256.059l.325.186a.445.445 0 00.144-.133.07.07 0 00-.037-.112z"
      ></path>
      <path
        fill="url(#paint31_linear_1416_98812)"
        d="M50.55 60.264c-.122 0-.25.053-.384.085l-.362.107c-.128.043-.251.09-.374.144l.4.23.128-.048.144-.054c.23-.08.438-.144.64-.197.175-.05.353-.086.534-.107a1.74 1.74 0 01.501 0c.162.03.317.088.459.17a.72.72 0 01.325.32.437.437 0 010 .347.993.993 0 01-.245.347c-.13.122-.271.231-.422.326l.534.309-.443.256-.533-.315a7.388 7.388 0 01-1.787.63l-.288-.705c.15-.032.304-.064.464-.106.16-.043.283-.075.448-.128.158-.05.313-.111.464-.181l-.384-.225a8.157 8.157 0 01-.432.15 5.31 5.31 0 01-.597.17 3.111 3.111 0 01-.496.075c-.14.006-.28-.004-.416-.032a1.263 1.263 0 01-.363-.144.763.763 0 01-.32-.299.534.534 0 01-.048-.34.828.828 0 01.192-.353c.114-.13.245-.245.39-.341l-.443-.256.442-.256.448.256c.134-.065.271-.122.411-.17.139-.054.272-.102.41-.145.14-.042.267-.085.395-.117l.347-.09.261.687zm-1.482.683a.33.33 0 00.165 0c.083-.01.165-.025.245-.048l-.336-.197c-.144.122-.17.192-.074.245zm2.133.352a.343.343 0 00-.176 0 1.433 1.433 0 00-.256.059l.325.186a.39.39 0 00.144-.133.069.069 0 00.013-.067.07.07 0 00-.05-.045z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint32_radial_1416_98812)"
        d="M50.55 60.264c-.122 0-.25.053-.384.085l-.362.107c-.128.043-.251.09-.374.144l.4.23.128-.048.144-.054c.23-.08.438-.144.64-.197.175-.05.353-.086.534-.107a1.74 1.74 0 01.501 0c.162.03.317.088.459.17a.72.72 0 01.325.32.437.437 0 010 .347.993.993 0 01-.245.347c-.13.122-.271.231-.422.326l.534.309-.443.256-.533-.315a7.388 7.388 0 01-1.787.63l-.288-.705c.15-.032.304-.064.464-.106.16-.043.283-.075.448-.128.158-.05.313-.111.464-.181l-.384-.225a8.157 8.157 0 01-.432.15 5.31 5.31 0 01-.597.17 3.111 3.111 0 01-.496.075c-.14.006-.28-.004-.416-.032a1.263 1.263 0 01-.363-.144.763.763 0 01-.32-.299.534.534 0 01-.048-.34.828.828 0 01.192-.353c.114-.13.245-.245.39-.341l-.443-.256.442-.256.448.256c.134-.065.271-.122.411-.17.139-.054.272-.102.41-.145.14-.042.267-.085.395-.117l.347-.09.261.687zm-1.482.683a.33.33 0 00.165 0c.083-.01.165-.025.245-.048l-.336-.197c-.144.122-.17.192-.074.245zm2.133.352a.343.343 0 00-.176 0 1.433 1.433 0 00-.256.059l.325.186a.39.39 0 00.144-.133.069.069 0 00.013-.067.07.07 0 00-.05-.045z"
      ></path>
      <path
        fill="url(#paint33_linear_1416_98812)"
        d="M56.773 59.2h-13.21v1.919c0 2.134 2.96 3.846 6.602 3.846 3.643 0 6.608-1.723 6.608-3.846V59.2z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint34_linear_1416_98812)"
        d="M50.165 64.533c-3.642 0-6.602-1.718-6.602-3.846v.416c0 2.134 2.96 3.846 6.602 3.846 3.643 0 6.608-1.723 6.608-3.846v-.415c0 2.138-2.96 3.845-6.608 3.845z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 64.772l.182-.042v-4.88h-.182v4.922zM53.02 64.575l.186-.053V59.85h-.187v4.725zM53.867 64.303l.187-.08V59.85h-.187v4.453zM51.36 64.891h.186v-5.024h-.187v5.024zM55.512 63.364l.186-.15V59.85h-.186v3.514zM56.336 62.474c.07-.106.133-.216.187-.331V59.85h-.187v2.624zM54.68 63.914c.064-.031.126-.065.186-.102V59.85h-.186v4.064zM50.535 64.949h.182v-5.093h-.182v5.093zM49.703 64.942h.187v-5.098h-.187v5.098zM48.043 64.75l.187.038V59.85h-.187v4.9zM48.871 64.885h.187v-5.051h-.187v5.05zM47.21 64.533l.188.048v-4.747h-.187v4.699zM43.895 62.308c.057.101.119.2.186.294V59.85h-.187v2.458zM44.727 63.284c.057.052.118.1.18.144V59.85h-.18v3.434zM46.402 64.26l.187.075V59.85h-.187v4.41zM45.555 63.86l.186.096V59.85h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint35_linear_1416_98812)"
        d="M56.773 59.2c0 2.134-2.96 3.846-6.608 3.846-3.648 0-6.602-1.712-6.602-3.845s2.96-3.846 6.602-3.846c3.643 0 6.608 1.745 6.608 3.846z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint36_radial_1416_98812)"
        d="M50.166 62.964c-3.568 0-6.47-1.648-6.592-3.733v.133c0 2.133 2.96 3.845 6.603 3.845s6.608-1.723 6.608-3.845a1.14 1.14 0 000-.133c-.144 2.1-3.045 3.733-6.619 3.733z"
      ></path>
      <path
        fill="url(#paint37_linear_1416_98812)"
        d="M50.165 62.097c2.728 0 4.939-1.287 4.939-2.875 0-1.587-2.211-2.874-4.939-2.874-2.727 0-4.938 1.287-4.938 2.874 0 1.588 2.21 2.875 4.938 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint38_radial_1416_98812)"
        d="M50.33 56.491c2.64 0 4.8 1.205 4.923 2.72a1.376 1.376 0 000-.155c0-1.6-2.213-2.874-4.939-2.874-2.725 0-4.933 1.29-4.933 2.874a1.426 1.426 0 000 .155c.165-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint39_linear_1416_98812)"
        d="M50.165 56.657c2.666 0 4.8 1.205 4.928 2.72v-.155c0-1.6-2.208-2.874-4.939-2.874-2.73 0-4.933 1.29-4.933 2.874a1.376 1.376 0 000 .155c.16-1.515 2.31-2.72 4.944-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint40_radial_1416_98812)"
        d="M53.637 55.52c1.482.5 2.48 1.509 2.234 2.245-.245.736-1.658.917-3.14.416-1.484-.502-2.486-1.51-2.236-2.245.251-.736 1.66-.923 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint41_linear_1416_98812)"
        d="M50.55 58.32c-.123 0-.251.054-.384.086l-.363.106c-.128.043-.25.091-.373.144l.4.23.128-.048.144-.054c.229-.074.437-.144.64-.197a3.32 3.32 0 01.533-.107c.166-.024.335-.024.501 0 .174.032.34.095.49.187a.72.72 0 01.326.32.438.438 0 010 .347.95.95 0 01-.245.346c-.128.124-.27.233-.421.326l.533.31-.443.255-.533-.315a7.398 7.398 0 01-1.787.63l-.288-.704c.15-.032.304-.064.464-.107.16-.043.283-.075.448-.128.159-.05.313-.111.464-.181l-.384-.224a8.22 8.22 0 01-.432.15 5.333 5.333 0 01-.597.17c-.163.04-.329.066-.496.074-.14.007-.28-.004-.416-.032a1.256 1.256 0 01-.363-.144.762.762 0 01-.32-.298.533.533 0 01-.048-.342.826.826 0 01.192-.352c.114-.13.245-.245.39-.34l-.443-.257.443-.256.448.256c.133-.065.27-.121.41-.17.139-.054.272-.102.41-.145.14-.042.268-.085.396-.117l.346-.09.23.671zm-1.483.71a.33.33 0 00.165 0c.083-.01.165-.025.246-.048l-.336-.198c-.144.123-.171.192-.075.246zm2.133.352a.298.298 0 00-.176 0 1.066 1.066 0 00-.256.053l.326.187a.388.388 0 00.144-.134.07.07 0 00-.01-.09.07.07 0 00-.028-.016z"
      ></path>
      <path
        fill="url(#paint42_linear_1416_98812)"
        d="M50.55 58.133c-.122 0-.25.054-.384.091-.133.037-.234.059-.362.101-.128.043-.251.091-.374.144l.4.23.128-.048.144-.048c.23-.08.438-.15.64-.203.175-.05.353-.086.534-.107.166-.021.335-.021.501 0 .161.032.316.09.459.171a.72.72 0 01.325.32.436.436 0 010 .347.948.948 0 01-.245.346c-.129.124-.27.233-.422.326l.534.309-.443.256-.533-.31a8.36 8.36 0 01-.88.369 8.03 8.03 0 01-.907.256l-.288-.704c.15-.032.304-.064.464-.107.16-.043.283-.075.448-.128.158-.05.313-.111.464-.181l-.384-.224a8.067 8.067 0 01-.432.149 5.331 5.331 0 01-.597.17c-.163.041-.329.066-.496.075-.14.006-.28-.004-.416-.032a1.12 1.12 0 01-.363-.144.763.763 0 01-.32-.298.534.534 0 01-.048-.342.86.86 0 01.192-.352c.114-.13.245-.245.39-.341l-.443-.256.442-.256.448.256c.134-.064.272-.117.411-.17.139-.054.272-.102.41-.145l.395-.117.347-.09.261.687zm-1.482.731c.05.027.108.038.165.032.083-.011.165-.03.245-.053l-.336-.192c-.144.09-.17.165-.074.213zm2.133.352a.298.298 0 00-.176 0c-.087.01-.172.027-.256.053l.325.187a.39.39 0 00.144-.133.07.07 0 00-.037-.123v.016z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint43_radial_1416_98812)"
        d="M50.55 58.133c-.122 0-.25.054-.384.091-.133.037-.234.059-.362.101-.128.043-.251.091-.374.144l.4.23.128-.048.144-.048c.23-.08.438-.15.64-.203.175-.05.353-.086.534-.107.166-.021.335-.021.501 0 .161.032.316.09.459.171a.72.72 0 01.325.32.436.436 0 010 .347.948.948 0 01-.245.346c-.129.124-.27.233-.422.326l.534.309-.443.256-.533-.31a8.36 8.36 0 01-.88.369 8.03 8.03 0 01-.907.256l-.288-.704c.15-.032.304-.064.464-.107.16-.043.283-.075.448-.128.158-.05.313-.111.464-.181l-.384-.224a8.067 8.067 0 01-.432.149 5.331 5.331 0 01-.597.17c-.163.041-.329.066-.496.075-.14.006-.28-.004-.416-.032a1.12 1.12 0 01-.363-.144.763.763 0 01-.32-.298.534.534 0 01-.048-.342.86.86 0 01.192-.352c.114-.13.245-.245.39-.341l-.443-.256.442-.256.448.256c.134-.064.272-.117.411-.17.139-.054.272-.102.41-.145l.395-.117.347-.09.261.687zm-1.482.731c.05.027.108.038.165.032.083-.011.165-.03.245-.053l-.336-.192c-.144.09-.17.165-.074.213zm2.133.352a.298.298 0 00-.176 0c-.087.01-.172.027-.256.053l.325.187a.39.39 0 00.144-.133.07.07 0 00-.037-.123v.016z"
      ></path>
      <path
        fill="url(#paint44_linear_1416_98812)"
        d="M56.773 57h-13.21v1.915c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.723 6.608-3.845V57z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint45_linear_1416_98812)"
        d="M50.165 62.35c-3.642 0-6.602-1.723-6.602-3.846v.411c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.723 6.608-3.845v-.411c0 2.123-2.96 3.845-6.608 3.845z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 62.574l.182-.038v-4.88h-.182v4.918zM53.02 62.397l.186-.053v-4.672h-.187v4.725zM53.867 62.11l.187-.08v-4.374h-.187v4.454zM51.36 62.696h.186v-5.018h-.187v5.018zM55.512 61.17l.186-.154v-3.36h-.186v3.515zM56.336 60.263c.071-.103.134-.212.187-.325v-2.294h-.187v2.62zM54.68 61.72l.186-.101v-3.963h-.186v4.064zM50.535 62.75h.182v-5.088h-.182v5.088zM49.703 62.751h.187v-5.099h-.187v5.099zM48.043 62.552l.187.043v-4.939h-.187v4.896zM48.871 62.686h.187v-5.045h-.187v5.045zM47.21 62.35l.188.053v-4.747h-.187v4.694zM43.895 60.115c.058.096.117.197.186.293v-2.752h-.187v2.459zM44.727 61.09l.18.145v-3.579h-.18v3.435zM46.402 62.067l.187.07v-4.48h-.187v4.41zM45.555 61.667l.186.096v-4.107h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint46_linear_1416_98812)"
        d="M56.773 57.029c0 2.133-2.96 3.845-6.608 3.845-3.648 0-6.602-1.722-6.602-3.845s2.96-3.845 6.602-3.845c3.643 0 6.608 1.749 6.608 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint47_radial_1416_98812)"
        d="M50.166 60.8c-3.568 0-6.47-1.654-6.592-3.734v.134c0 2.133 2.96 3.845 6.603 3.845s6.608-1.723 6.608-3.845a1.022 1.022 0 000-.134C56.64 59.12 53.74 60.8 50.166 60.8z"
      ></path>
      <path
        fill="url(#paint48_linear_1416_98812)"
        d="M55.102 57.027c0 1.6-2.207 2.875-4.938 2.875-2.73 0-4.934-1.286-4.934-2.875 0-1.59 2.209-2.875 4.934-2.875s4.938 1.312 4.938 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint49_radial_1416_98812)"
        d="M50.33 54.298c2.64 0 4.8 1.205 4.923 2.72a1.535 1.535 0 000-.155c0-1.6-2.213-2.875-4.939-2.875-2.725 0-4.933 1.286-4.933 2.875a1.478 1.478 0 000 .155c.165-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint50_linear_1416_98812)"
        d="M50.165 54.462c2.666 0 4.8 1.205 4.928 2.72v-.155c0-1.6-2.208-2.875-4.939-2.875-2.73 0-4.933 1.286-4.933 2.875a1.535 1.535 0 000 .155c.16-1.515 2.31-2.72 4.944-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint51_radial_1416_98812)"
        d="M53.637 53.332c1.482.533 2.48 1.515 2.234 2.245-.245.731-1.658.923-3.14.416-1.484-.506-2.486-1.509-2.236-2.245.251-.736 1.66-.95 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint52_linear_1416_98812)"
        d="M50.548 56.126c-.13.022-.258.05-.384.086-.112 0-.235.064-.363.106l-.373.14.4.228.128-.048c.048 0 .096-.032.144-.048.23-.08.437-.144.64-.197.175-.05.353-.087.533-.112.167-.021.335-.021.502 0 .161.03.316.088.458.17a.673.673 0 01.326.32.438.438 0 010 .347c-.058.131-.142.25-.246.347-.13.122-.27.23-.421.325l.533.31-.442.256-.534-.315a6.61 6.61 0 01-.88.368 6.307 6.307 0 01-.907.256l-.288-.704c.15 0 .304-.064.465-.101l.447-.128c.16-.054.32-.118.465-.182l-.384-.224-.432.15a9.2 9.2 0 01-.598.17c-.163.04-.329.063-.496.07-.14.011-.28 0-.416-.032a1.249 1.249 0 01-.362-.139.741.741 0 01-.32-.304.49.49 0 01-.049-.336.826.826 0 01.192-.352c.114-.133.245-.25.39-.347l-.443-.256.443-.256.448.262a6.313 6.313 0 01.821-.32l.395-.112.346-.096.262.698zm-1.483.704c.05.028.108.039.166.032.083-.008.165-.026.245-.053l-.336-.192c-.144.096-.17.165-.075.213zm2.134.358a.294.294 0 00-.176 0 1.433 1.433 0 00-.257.058l.326.187a.442.442 0 00.144-.133.069.069 0 00-.007-.096.069.069 0 00-.03-.016z"
      ></path>
      <path
        fill="url(#paint53_linear_1416_98812)"
        d="M50.55 55.961c-.122 0-.25.054-.384.086a4.076 4.076 0 00-.362.106l-.374.14.4.228.128-.042.144-.054c.23-.08.438-.144.64-.197.175-.05.353-.086.534-.107.166-.024.335-.024.501 0 .162.03.317.088.459.171.141.067.256.18.325.32a.436.436 0 010 .347.993.993 0 01-.245.346c-.13.122-.271.231-.422.326l.534.31-.443.255-.533-.315a6.596 6.596 0 01-.88.368 6.294 6.294 0 01-.907.256l-.288-.704c.15-.026.304-.064.464-.1a5.197 5.197 0 00.912-.31l-.384-.224a10.34 10.34 0 01-1.03.32 3.111 3.111 0 01-.495.074c-.14.007-.28-.004-.416-.032a1.429 1.429 0 01-.363-.144.762.762 0 01-.32-.298.534.534 0 01-.048-.342.828.828 0 01.192-.352c.112-.132.243-.247.39-.34l-.443-.262.442-.256.448.261c.134-.064.272-.123.411-.176l.41-.144.395-.112.347-.09.261.687zm-1.482.704c.05.028.108.039.165.032.083-.009.165-.025.245-.048l-.336-.197c-.144.08-.17.165-.074.213zm2.133.358a.294.294 0 00-.176 0 1.432 1.432 0 00-.256.058l.325.187a.445.445 0 00.144-.133.07.07 0 00-.037-.112z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint54_radial_1416_98812)"
        d="M50.55 55.961c-.122 0-.25.054-.384.086a4.076 4.076 0 00-.362.106l-.374.14.4.228.128-.042.144-.054c.23-.08.438-.144.64-.197.175-.05.353-.086.534-.107.166-.024.335-.024.501 0 .162.03.317.088.459.171.141.067.256.18.325.32a.436.436 0 010 .347.993.993 0 01-.245.346c-.13.122-.271.231-.422.326l.534.31-.443.255-.533-.315a6.596 6.596 0 01-.88.368 6.294 6.294 0 01-.907.256l-.288-.704c.15-.026.304-.064.464-.1a5.197 5.197 0 00.912-.31l-.384-.224a10.34 10.34 0 01-1.03.32 3.111 3.111 0 01-.495.074c-.14.007-.28-.004-.416-.032a1.429 1.429 0 01-.363-.144.762.762 0 01-.32-.298.534.534 0 01-.048-.342.828.828 0 01.192-.352c.112-.132.243-.247.39-.34l-.443-.262.442-.256.448.261c.134-.064.272-.123.411-.176l.41-.144.395-.112.347-.09.261.687zm-1.482.704c.05.028.108.039.165.032.083-.009.165-.025.245-.048l-.336-.197c-.144.08-.17.165-.074.213zm2.133.358a.294.294 0 00-.176 0 1.432 1.432 0 00-.256.058l.325.187a.445.445 0 00.144-.133.07.07 0 00-.037-.112z"
      ></path>
      <path
        fill="url(#paint55_linear_1416_98812)"
        d="M56.773 54.773h-13.21v1.915c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.717 6.608-3.845v-1.915z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint56_linear_1416_98812)"
        d="M50.165 60.123c-3.642 0-6.602-1.723-6.602-3.846v.411c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.717 6.608-3.845v-.411c0 2.123-2.96 3.846-6.608 3.846z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 60.352l.182-.042v-4.88h-.182v4.922zM53.02 60.155l.186-.053V55.43h-.187v4.725zM53.867 59.883l.187-.08V55.43h-.187v4.453zM51.36 60.47h.186V55.45h-.187v5.019zM55.512 58.944l.186-.149V55.43h-.186v3.514zM56.336 58.048c.071-.103.134-.212.187-.325V55.43h-.187v2.618zM54.68 59.494c.064-.03.126-.065.186-.102V55.43h-.186v4.064zM50.535 60.523h.182v-5.088h-.182v5.088zM49.703 60.525h.187v-5.1h-.187v5.1zM48.043 60.331l.187.037V55.43h-.187v4.901zM48.871 60.46h.187v-5.046h-.187v5.045zM47.21 60.128l.188.048V55.43h-.187v4.698zM43.895 57.888c.057.101.119.2.186.294V55.43h-.187v2.458zM44.727 58.864c.058.054.122.096.18.144V55.43h-.18v3.434zM46.402 59.84l.187.07v-4.48h-.187v4.41zM45.555 59.44l.186.096V55.43h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint57_linear_1416_98812)"
        d="M56.773 54.798c0 2.134-2.96 3.846-6.608 3.846-3.648 0-6.602-1.723-6.602-3.846 0-2.122 2.96-3.845 6.602-3.845 3.643 0 6.608 1.723 6.608 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint58_radial_1416_98812)"
        d="M50.166 58.544c-3.568 0-6.47-1.653-6.592-3.733v.133c0 2.133 2.96 3.845 6.603 3.845s6.608-1.723 6.608-3.845a1.024 1.024 0 000-.134c-.144 2.08-3.045 3.734-6.619 3.734z"
      ></path>
      <path
        fill="url(#paint59_linear_1416_98812)"
        d="M55.102 54.8c0 1.6-2.207 2.875-4.938 2.875-2.73 0-4.934-1.285-4.934-2.875 0-1.589 2.209-2.874 4.934-2.874s4.938 1.285 4.938 2.874z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint60_radial_1416_98812)"
        d="M50.33 52.07c2.64 0 4.8 1.204 4.923 2.72a1.376 1.376 0 000-.156c0-1.6-2.213-2.874-4.939-2.874-2.725 0-4.933 1.29-4.933 2.874a1.426 1.426 0 000 .155c.165-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint61_linear_1416_98812)"
        d="M50.165 52.235c2.666 0 4.8 1.205 4.928 2.72V54.8c0-1.6-2.208-2.874-4.939-2.874-2.73 0-4.933 1.285-4.933 2.874a1.535 1.535 0 000 .155c.16-1.515 2.31-2.72 4.944-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint62_radial_1416_98812)"
        d="M53.637 51.098c1.482.501 2.48 1.51 2.234 2.245-.245.736-1.658.918-3.14.416-1.484-.5-2.486-1.493-2.236-2.245.251-.752 1.66-.923 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint63_linear_1416_98812)"
        d="M51.913 54.234l1.867.336c.314.058.378.293.112.405l-1.6.645c-.107.043-.171.118-.166.192v1.126c0 .192-.362.298-.63.186l-1.567-.677a.635.635 0 00-.363-.037l-1.85.362c-.31.059-.603-.112-.502-.293l.624-1.067a.155.155 0 00-.058-.208l-1.174-.906c-.197-.15 0-.368.32-.363h1.952c.116.004.23-.03.326-.096l1.125-.917a.534.534 0 01.699.064l.586 1.066a.372.372 0 00.299.182z"
      ></path>
      <path
        fill="url(#paint64_linear_1416_98812)"
        d="M51.913 54.022l1.867.336c.314.059.378.299.112.405l-1.6.65c-.107.044-.171.113-.166.188v1.13c0 .187-.362.294-.63.182l-1.567-.678a.634.634 0 00-.363-.032l-1.85.358c-.31.058-.603-.112-.502-.288l.624-1.067a.16.16 0 00-.058-.213l-1.174-.907c-.197-.15 0-.363.32-.363h1.952c.116.005.23-.03.326-.096l1.125-.922a.533.533 0 01.699.069l.586 1.067a.368.368 0 00.299.18z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint65_radial_1416_98812)"
        d="M51.913 54.022l1.867.336c.314.059.378.299.112.405l-1.6.65c-.107.044-.171.113-.166.188v1.13c0 .187-.362.294-.63.182l-1.567-.678a.634.634 0 00-.363-.032l-1.85.358c-.31.058-.603-.112-.502-.288l.624-1.067a.16.16 0 00-.058-.213l-1.174-.907c-.197-.15 0-.363.32-.363h1.952c.116.005.23-.03.326-.096l1.125-.922a.533.533 0 01.699.069l.586 1.067a.368.368 0 00.299.18z"
      ></path>
      <path
        fill="url(#paint66_linear_1416_98812)"
        d="M56.773 52.734h-13.21v1.915c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.717 6.608-3.845v-1.915z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint67_linear_1416_98812)"
        d="M50.165 58.084c-3.642 0-6.602-1.718-6.602-3.846v.411c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.717 6.608-3.845v-.411c0 2.128-2.96 3.846-6.608 3.846z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 58.313l.182-.042v-4.88h-.182v4.922zM53.02 58.132l.186-.054v-4.672h-.187v4.726zM53.867 57.844l.187-.08v-4.373h-.187v4.453zM51.36 58.43h.186v-5.018h-.187v5.019zM55.512 56.905l.186-.149v-3.365h-.186v3.514zM56.336 55.998c.071-.103.134-.212.187-.326V53.38h-.187v2.619zM54.68 57.455c.064-.031.126-.065.186-.102v-3.962h-.186v4.064zM50.535 58.484h.182v-5.087h-.182v5.087zM49.703 58.485h.187v-5.098h-.187v5.098zM48.043 58.292l.187.037v-4.938h-.187v4.901zM48.871 58.42h.187v-5.045h-.187v5.045zM47.21 58.09l.188.047v-4.746h-.187v4.698zM43.895 55.85c.057.1.119.198.186.293V53.39h-.187v2.458zM44.727 56.825c.058.054.122.096.18.144v-3.578h-.18v3.434zM46.402 57.801l.187.07v-4.48h-.187v4.41zM45.555 57.401l.186.096v-4.106h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint68_linear_1416_98812)"
        d="M56.773 52.761c0 2.134-2.96 3.846-6.608 3.846-3.648 0-6.602-1.723-6.602-3.846 0-2.122 2.96-3.845 6.602-3.845 3.643 0 6.608 1.75 6.608 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint69_radial_1416_98812)"
        d="M50.166 56.53c-3.568 0-6.47-1.653-6.592-3.733v.133c0 2.133 2.96 3.846 6.603 3.846s6.608-1.723 6.608-3.846a1.022 1.022 0 000-.133c-.144 2.053-3.045 3.733-6.619 3.733z"
      ></path>
      <path
        fill="url(#paint70_linear_1416_98812)"
        d="M50.165 55.636c2.728 0 4.939-1.287 4.939-2.875 0-1.587-2.211-2.874-4.939-2.874-2.727 0-4.938 1.287-4.938 2.874 0 1.588 2.21 2.875 4.938 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint71_radial_1416_98812)"
        d="M50.33 50.03c2.64 0 4.8 1.205 4.923 2.72a1.375 1.375 0 000-.155c0-1.6-2.213-2.874-4.939-2.874-2.725 0-4.933 1.29-4.933 2.874a1.424 1.424 0 000 .155c.165-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint72_linear_1416_98812)"
        d="M50.166 50.196c2.667 0 4.8 1.205 4.928 2.72v-.155c0-1.6-2.208-2.874-4.939-2.874-2.73 0-4.922 1.312-4.922 2.874a1.478 1.478 0 000 .155c.149-1.515 2.298-2.72 4.933-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint73_radial_1416_98812)"
        d="M53.637 49.065c1.482.501 2.48 1.51 2.234 2.245-.245.736-1.658.918-3.14.416-1.484-.501-2.486-1.514-2.236-2.245.251-.73 1.66-.95 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint74_linear_1416_98812)"
        d="M50.55 51.86c-.122 0-.25.053-.384.085l-.362.107c-.128.042-.251.09-.374.144l.4.224.128-.043.144-.053c.23-.08.438-.144.64-.197.175-.05.353-.086.534-.107a1.74 1.74 0 01.501 0c.162.03.317.087.459.17a.72.72 0 01.325.32.437.437 0 010 .347.993.993 0 01-.245.347c-.13.122-.271.23-.422.325l.534.31-.443.255-.533-.314a7.388 7.388 0 01-.88.373c-.297.104-.6.188-.907.25l-.288-.703c.15 0 .304-.059.464-.102.16-.042.283-.074.448-.127.158-.051.313-.112.464-.182l-.384-.224a10.34 10.34 0 01-1.03.32 3.111 3.111 0 01-.495.075c-.14.006-.28-.005-.416-.032a1.433 1.433 0 01-.363-.144.763.763 0 01-.32-.299.534.534 0 01-.048-.341.828.828 0 01.192-.352c.112-.132.243-.247.39-.342l-.443-.26.442-.257.448.261c.134-.064.272-.122.411-.175l.41-.14a4.1 4.1 0 01.395-.116l.347-.091.261.688zm-1.482.71a.331.331 0 00.165.026c.083-.01.165-.025.245-.048l-.336-.198c-.144.096-.17.166-.074.22zm2.133.351a.294.294 0 00-.176 0 1.433 1.433 0 00-.256.059l.325.187a.444.444 0 00.144-.134.069.069 0 00-.006-.096.068.068 0 00-.031-.016z"
      ></path>
      <path
        fill="url(#paint75_linear_1416_98812)"
        d="M50.55 51.694c-.122 0-.25.053-.384.085l-.362.107c-.128.042-.251.09-.374.144l.4.23.128-.049.144-.053c.23-.075.438-.144.64-.197.175-.05.353-.086.534-.107a1.74 1.74 0 01.501 0c.162.03.317.087.459.17a.72.72 0 01.325.32.436.436 0 010 .347.95.95 0 01-.245.347c-.129.123-.27.232-.422.325l.534.31-.443.255-.533-.314a7.405 7.405 0 01-1.787.63l-.288-.705c.15-.032.304-.064.464-.107.16-.042.283-.074.448-.128.158-.05.313-.11.464-.18l-.384-.225a8.157 8.157 0 01-.432.15 5.31 5.31 0 01-.597.17c-.163.041-.329.066-.496.075-.14.006-.28-.005-.416-.032a1.263 1.263 0 01-.363-.144.763.763 0 01-.32-.299.534.534 0 01-.048-.341.827.827 0 01.192-.352c.114-.131.245-.246.39-.341l-.443-.256.442-.257.448.257c.134-.065.271-.122.411-.171.139-.053.272-.101.41-.144.14-.043.267-.085.395-.117l.347-.091.261.688zm-1.482.71a.33.33 0 00.165 0c.083-.01.165-.026.245-.049l-.336-.197c-.144.106-.17.192-.074.245zm2.133.351a.298.298 0 00-.176 0 1.067 1.067 0 00-.256.053l.325.187a.39.39 0 00.144-.133.07.07 0 00-.037-.107z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint76_radial_1416_98812)"
        d="M50.55 51.694c-.122 0-.25.053-.384.085l-.362.107c-.128.042-.251.09-.374.144l.4.23.128-.049.144-.053c.23-.075.438-.144.64-.197.175-.05.353-.086.534-.107a1.74 1.74 0 01.501 0c.162.03.317.087.459.17a.72.72 0 01.325.32.436.436 0 010 .347.95.95 0 01-.245.347c-.129.123-.27.232-.422.325l.534.31-.443.255-.533-.314a7.405 7.405 0 01-1.787.63l-.288-.705c.15-.032.304-.064.464-.107.16-.042.283-.074.448-.128.158-.05.313-.11.464-.18l-.384-.225a8.157 8.157 0 01-.432.15 5.31 5.31 0 01-.597.17c-.163.041-.329.066-.496.075-.14.006-.28-.005-.416-.032a1.263 1.263 0 01-.363-.144.763.763 0 01-.32-.299.534.534 0 01-.048-.341.827.827 0 01.192-.352c.114-.131.245-.246.39-.341l-.443-.256.442-.257.448.257c.134-.065.271-.122.411-.171.139-.053.272-.101.41-.144.14-.043.267-.085.395-.117l.347-.091.261.688zm-1.482.71a.33.33 0 00.165 0c.083-.01.165-.026.245-.049l-.336-.197c-.144.106-.17.192-.074.245zm2.133.351a.298.298 0 00-.176 0 1.067 1.067 0 00-.256.053l.325.187a.39.39 0 00.144-.133.07.07 0 00-.037-.107z"
      ></path>
      <path
        fill="url(#paint77_linear_1416_98812)"
        d="M56.773 50.666h-13.21v1.92c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.722 6.608-3.845v-1.92z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint78_linear_1416_98812)"
        d="M50.165 56c-3.642 0-6.602-1.724-6.602-3.852v.416c0 2.134 2.96 3.846 6.602 3.846 3.643 0 6.608-1.723 6.608-3.846v-.416c0 2.134-2.96 3.851-6.608 3.851z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 56.227l.182-.042v-4.88h-.182v4.922zM53.02 56.03l.186-.053v-4.672h-.187v4.725zM53.867 55.758c.064 0 .123-.053.187-.08v-4.373h-.187v4.453zM51.36 56.345h.186v-5.04h-.187v5.04zM55.512 54.82c.064-.049.128-.097.186-.15v-3.365h-.186v3.514zM56.336 53.929c.071-.105.134-.216.187-.331v-2.293h-.187v2.624zM54.68 55.369c.064-.03.126-.065.186-.102v-3.962h-.186v4.064zM50.535 56.403h.182v-5.098h-.182v5.098zM49.703 56.398h.187v-5.093h-.187v5.093zM48.043 56.206l.187.037v-4.938h-.187v4.901zM48.871 56.34h.187v-5.035h-.187v5.034zM47.21 55.998l.188.053v-4.746h-.187v4.693zM43.895 53.763c.057.101.119.2.186.294v-2.752h-.187v2.458zM44.727 54.74c.057.05.118.099.18.143v-3.578h-.18v3.434zM46.402 55.715l.187.075v-4.485h-.187v4.41zM45.555 55.315l.186.096v-4.106h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint79_linear_1416_98812)"
        d="M56.773 50.666c0 2.133-2.96 3.845-6.608 3.845-3.648 0-6.602-1.712-6.602-3.845 0-2.134 2.96-3.846 6.602-3.846 3.643 0 6.608 1.712 6.608 3.846z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint80_radial_1416_98812)"
        d="M50.166 54.397c-3.568 0-6.47-1.648-6.592-3.733v.133c0 2.134 2.96 3.846 6.603 3.846s6.608-1.723 6.608-3.846a1.14 1.14 0 000-.133c-.144 2.133-3.045 3.733-6.619 3.733z"
      ></path>
      <path
        fill="url(#paint81_linear_1416_98812)"
        d="M50.165 53.55c2.728 0 4.939-1.287 4.939-2.875 0-1.587-2.211-2.874-4.939-2.874-2.727 0-4.938 1.287-4.938 2.874 0 1.588 2.21 2.875 4.938 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint82_radial_1416_98812)"
        d="M50.33 47.946c2.64 0 4.8 1.205 4.923 2.72a1.376 1.376 0 000-.155c0-1.6-2.213-2.874-4.939-2.874-2.725 0-4.933 1.29-4.933 2.874a1.426 1.426 0 000 .155c.165-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint83_linear_1416_98812)"
        d="M50.166 48.11c2.667 0 4.8 1.205 4.928 2.72v-.155c0-1.6-2.208-2.874-4.939-2.874-2.73 0-4.922 1.29-4.922 2.864a1.426 1.426 0 000 .154c.149-1.504 2.298-2.709 4.933-2.709z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint84_radial_1416_98812)"
        d="M53.637 46.975c1.482.533 2.48 1.509 2.234 2.245-.245.736-1.658.917-3.14.416-1.484-.501-2.486-1.51-2.236-2.245.251-.736 1.66-.923 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint85_linear_1416_98812)"
        d="M50.55 49.775c-.123 0-.251.053-.384.085l-.363.107c-.128.043-.25.09-.373.144l.4.23.128-.049.144-.053c.229-.075.437-.144.64-.197a3.32 3.32 0 01.533-.107c.166-.024.335-.024.501 0 .175.034.341.101.49.197a.72.72 0 01.326.32.438.438 0 010 .347.95.95 0 01-.245.346c-.128.124-.27.233-.421.326l.533.31-.443.255-.533-.315a7.381 7.381 0 01-.88.374c-.297.103-.6.188-.907.256l-.288-.704c.15-.032.304-.064.464-.107.16-.042.283-.075.448-.128a4 4 0 00.464-.181l-.384-.224a8.129 8.129 0 01-.432.15 5.333 5.333 0 01-.597.17c-.163.04-.329.066-.496.075-.14.006-.28-.005-.416-.032a1.118 1.118 0 01-.363-.145.762.762 0 01-.32-.298.533.533 0 01-.048-.341.826.826 0 01.192-.352c.114-.131.245-.246.39-.342l-.459-.293.443-.256.448.256c.133-.065.27-.122.41-.17.139-.054.272-.102.411-.145.139-.042.267-.085.395-.117l.346-.09.246.698zm-1.483.71a.278.278 0 00.165 0c.083-.01.165-.026.246-.049l-.336-.192c-.144.117-.171.192-.075.24zm2.133.351a.298.298 0 00-.176 0 1.066 1.066 0 00-.256.053l.326.187a.39.39 0 00.144-.133.07.07 0 00-.01-.09.07.07 0 00-.028-.017z"
      ></path>
      <path
        fill="url(#paint86_linear_1416_98812)"
        d="M50.55 49.6c-.122 0-.25.053-.384.09l-.362.102c-.128.042-.251.09-.374.144l.4.229.128-.048.144-.048c.23-.08.438-.15.64-.203.175-.05.353-.085.534-.106a1.74 1.74 0 01.501 0c.161.028.317.084.459.165a.72.72 0 01.325.32.436.436 0 010 .347.95.95 0 01-.245.346c-.129.124-.27.233-.422.326l.534.309-.443.256-.533-.31c-.286.14-.58.263-.88.369-.297.102-.6.188-.907.256l-.288-.704c.15-.032.304-.064.464-.107.16-.043.283-.075.448-.128.158-.05.313-.111.464-.181l-.384-.224a8.157 8.157 0 01-.432.149 5.331 5.331 0 01-.597.17c-.163.041-.329.066-.496.075-.14.006-.28-.004-.416-.032a1.124 1.124 0 01-.363-.144.763.763 0 01-.32-.298.534.534 0 01-.048-.342.86.86 0 01.192-.352c.114-.13.245-.245.39-.341l-.443-.256.442-.256.448.256.411-.17c.139-.054.272-.102.41-.145l.395-.117.347-.09.261.693zm-1.482.72c.05.027.108.038.165.032.083-.012.165-.03.245-.054l-.346-.165c-.134.064-.16.139-.064.187zm2.133.346a.298.298 0 00-.176 0c-.087.01-.172.028-.256.054l.325.186a.39.39 0 00.144-.133.068.068 0 00.01-.063.068.068 0 00-.047-.044z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint87_radial_1416_98812)"
        d="M50.55 49.6c-.122 0-.25.053-.384.09l-.362.102c-.128.042-.251.09-.374.144l.4.229.128-.048.144-.048c.23-.08.438-.15.64-.203.175-.05.353-.085.534-.106a1.74 1.74 0 01.501 0c.161.028.317.084.459.165a.72.72 0 01.325.32.436.436 0 010 .347.95.95 0 01-.245.346c-.129.124-.27.233-.422.326l.534.309-.443.256-.533-.31c-.286.14-.58.263-.88.369-.297.102-.6.188-.907.256l-.288-.704c.15-.032.304-.064.464-.107.16-.043.283-.075.448-.128.158-.05.313-.111.464-.181l-.384-.224a8.157 8.157 0 01-.432.149 5.331 5.331 0 01-.597.17c-.163.041-.329.066-.496.075-.14.006-.28-.004-.416-.032a1.124 1.124 0 01-.363-.144.763.763 0 01-.32-.298.534.534 0 01-.048-.342.86.86 0 01.192-.352c.114-.13.245-.245.39-.341l-.443-.256.442-.256.448.256.411-.17c.139-.054.272-.102.41-.145l.395-.117.347-.09.261.693zm-1.482.72c.05.027.108.038.165.032.083-.012.165-.03.245-.054l-.346-.165c-.134.064-.16.139-.064.187zm2.133.346a.298.298 0 00-.176 0c-.087.01-.172.028-.256.054l.325.186a.39.39 0 00.144-.133.068.068 0 00.01-.063.068.068 0 00-.047-.044z"
      ></path>
      <path
        fill="url(#paint88_linear_1416_98812)"
        d="M56.773 48.457h-13.21v1.915c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.723 6.608-3.845v-1.915z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint89_linear_1416_98812)"
        d="M50.165 53.806c-3.642 0-6.602-1.722-6.602-3.845v.411c0 2.133 2.96 3.845 6.602 3.845 3.643 0 6.608-1.723 6.608-3.845v-.411c0 2.123-2.96 3.845-6.608 3.845z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 54.036l.182-.043v-4.88h-.182v4.923zM53.02 53.865l.186-.053v-4.699h-.187v4.752zM53.867 53.567l.187-.08v-4.374h-.187v4.454zM51.36 54.153h.186v-5.04h-.187v5.04zM55.512 52.628l.186-.155v-3.36h-.186v3.515zM56.336 51.732c.071-.103.134-.212.187-.325v-2.294h-.187v2.619zM54.68 53.177l.186-.101v-3.963h-.186v4.064zM50.535 54.207h.182v-5.094h-.182v5.094zM49.703 54.207h.187v-5.094h-.187v5.094zM48.043 54.01l.187.042v-4.939h-.187v4.896zM48.871 54.143h.187v-5.03h-.187v5.03zM47.21 53.807l.188.053v-4.747h-.187v4.694zM43.895 51.572c.058.096.117.197.186.293v-2.752h-.187v2.459zM44.727 52.548l.18.144v-3.579h-.18v3.435zM46.402 53.524l.187.07v-4.48h-.187v4.41zM45.555 53.124l.186.096v-4.107h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint90_linear_1416_98812)"
        d="M56.773 48.484c0 2.133-2.96 3.845-6.608 3.845-3.648 0-6.602-1.722-6.602-3.845s2.96-3.845 6.602-3.845c3.643 0 6.608 1.722 6.608 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint91_radial_1416_98812)"
        d="M50.166 52.23c-3.568 0-6.47-1.654-6.592-3.734v.133c0 2.134 2.96 3.846 6.603 3.846s6.608-1.723 6.608-3.846a1.022 1.022 0 000-.133c-.144 2.08-3.045 3.733-6.619 3.733z"
      ></path>
      <path
        fill="url(#paint92_linear_1416_98812)"
        d="M55.102 48.484c0 1.6-2.207 2.875-4.938 2.875-2.73 0-4.934-1.286-4.934-2.875 0-1.59 2.209-2.875 4.934-2.875s4.938 1.286 4.938 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint93_radial_1416_98812)"
        d="M50.33 45.755c2.64 0 4.8 1.205 4.923 2.72a1.533 1.533 0 000-.155c0-1.6-2.213-2.875-4.939-2.875-2.725 0-4.933 1.286-4.933 2.875a1.476 1.476 0 000 .155c.165-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint94_linear_1416_98812)"
        d="M50.165 45.919c2.666 0 4.8 1.205 4.928 2.72v-.155c0-1.6-2.208-2.875-4.939-2.875-2.73 0-4.933 1.286-4.933 2.875a1.535 1.535 0 000 .155c.16-1.515 2.31-2.72 4.944-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint95_radial_1416_98812)"
        d="M53.637 44.799c1.482.533 2.48 1.514 2.234 2.245-.245.73-1.658.923-3.14.416-1.484-.507-2.486-1.51-2.236-2.245.251-.736 1.66-.95 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint96_linear_1416_98812)"
        d="M50.548 47.581c-.13.022-.258.05-.384.086a4.391 4.391 0 00-.363.106l-.373.14.4.229a.723.723 0 01.128-.043l.144-.053c.23-.08.437-.145.64-.198.175-.05.353-.087.533-.112.167-.021.335-.021.502 0 .161.03.316.088.458.17a.673.673 0 01.326.32.438.438 0 010 .348.992.992 0 01-.246.346c-.13.122-.27.231-.421.325l.533.31-.442.256-.534-.315a6.583 6.583 0 01-.88.368 6.294 6.294 0 01-.907.256l-.288-.704c.15 0 .304-.064.465-.101l.447-.128c.16-.053.32-.117.465-.181l-.384-.224a10.34 10.34 0 01-1.03.32 3.113 3.113 0 01-.496.074 1.492 1.492 0 01-.779-.176.74.74 0 01-.32-.304.49.49 0 01-.047-.336.826.826 0 01.191-.352c.114-.133.245-.25.39-.347l-.443-.255.443-.256.448.26a6.313 6.313 0 01.821-.32l.395-.111.346-.096.262.698zm-1.483.704c.05.028.108.039.166.033.083-.01.165-.027.245-.054l-.336-.192c-.144.096-.17.165-.075.213zm2.134.358a.294.294 0 00-.176 0 1.433 1.433 0 00-.257.059l.326.186a.442.442 0 00.144-.133.07.07 0 00-.037-.112z"
      ></path>
      <path
        fill="url(#paint97_linear_1416_98812)"
        d="M50.55 47.419c-.122 0-.25.053-.384.085a4.044 4.044 0 00-.362.107l-.374.138.4.23.128-.043.144-.053c.23-.08.438-.145.64-.198.175-.05.353-.086.534-.107a1.74 1.74 0 01.501 0c.162.03.317.088.459.171.141.067.256.18.325.32a.437.437 0 010 .347.993.993 0 01-.245.347c-.13.121-.271.23-.422.325l.534.31-.443.255-.533-.314a7.388 7.388 0 01-.88.373c-.297.103-.6.187-.907.25l-.288-.704c.15 0 .304-.058.464-.1.16-.044.283-.075.448-.129.158-.05.313-.111.464-.181l-.384-.224a10.34 10.34 0 01-1.03.32 3.111 3.111 0 01-.495.075c-.14.006-.28-.005-.416-.032a1.433 1.433 0 01-.363-.145.763.763 0 01-.32-.298.534.534 0 01-.048-.341.828.828 0 01.192-.353c.112-.132.243-.247.39-.34l-.443-.262.442-.256.448.261c.134-.064.272-.123.411-.176l.41-.139a4.1 4.1 0 01.395-.117l.347-.09.261.688zm-1.482.709a.331.331 0 00.165.026c.083-.009.165-.025.245-.048l-.336-.197c-.144.09-.17.166-.074.219zm2.133.352a.294.294 0 00-.176-.027 1.433 1.433 0 00-.256.059l.325.187a.444.444 0 00.144-.134.07.07 0 00-.037-.085z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint98_radial_1416_98812)"
        d="M50.55 47.419c-.122 0-.25.053-.384.085a4.044 4.044 0 00-.362.107l-.374.138.4.23.128-.043.144-.053c.23-.08.438-.145.64-.198.175-.05.353-.086.534-.107a1.74 1.74 0 01.501 0c.162.03.317.088.459.171.141.067.256.18.325.32a.437.437 0 010 .347.993.993 0 01-.245.347c-.13.121-.271.23-.422.325l.534.31-.443.255-.533-.314a7.388 7.388 0 01-.88.373c-.297.103-.6.187-.907.25l-.288-.704c.15 0 .304-.058.464-.1.16-.044.283-.075.448-.129.158-.05.313-.111.464-.181l-.384-.224a10.34 10.34 0 01-1.03.32 3.111 3.111 0 01-.495.075c-.14.006-.28-.005-.416-.032a1.433 1.433 0 01-.363-.145.763.763 0 01-.32-.298.534.534 0 01-.048-.341.828.828 0 01.192-.353c.112-.132.243-.247.39-.34l-.443-.262.442-.256.448.261c.134-.064.272-.123.411-.176l.41-.139a4.1 4.1 0 01.395-.117l.347-.09.261.688zm-1.482.709a.331.331 0 00.165.026c.083-.009.165-.025.245-.048l-.336-.197c-.144.09-.17.166-.074.219zm2.133.352a.294.294 0 00-.176-.027 1.433 1.433 0 00-.256.059l.325.187a.444.444 0 00.144-.134.07.07 0 00-.037-.085z"
      ></path>
      <path
        fill="url(#paint99_linear_1416_98812)"
        d="M56.773 46.227h-13.21V48.14c0 2.134 2.96 3.846 6.602 3.846 3.643 0 6.608-1.718 6.608-3.846V46.227z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint100_linear_1416_98812)"
        d="M50.165 51.576c-3.642 0-6.602-1.718-6.602-3.846v.411c0 2.134 2.96 3.846 6.602 3.846 3.643 0 6.608-1.718 6.608-3.846v-.411c0 2.129-2.96 3.846-6.608 3.846z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M52.191 51.806l.182-.043v-4.88h-.182v4.922zM53.02 51.608l.186-.053v-4.672h-.187v4.725zM53.867 51.336l.187-.08v-4.373h-.187v4.453zM51.36 51.923h.186v-5.04h-.187v5.04zM55.512 50.398l.186-.15v-3.365h-.186v3.514zM56.336 49.502c.071-.104.134-.212.187-.326v-2.293h-.187V49.5zM54.68 50.947c.064-.03.126-.065.186-.102v-3.962h-.186v4.064zM50.535 51.976h.182v-5.093h-.182v5.093zM49.703 51.976h.187v-5.093h-.187v5.093zM48.043 51.784l.187.038v-4.94h-.187v4.902zM48.871 51.912h.187v-5.03h-.187v5.03zM47.21 51.581l.188.048v-4.746h-.187v4.698zM43.895 49.342c.057.1.119.198.186.293v-2.752h-.187v2.459zM44.727 50.318c.058.053.122.096.18.144v-3.58h-.18v3.436zM46.402 51.294l.187.074v-4.485h-.187v4.41zM45.555 50.894l.186.096v-4.107h-.186v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint101_linear_1416_98812)"
        d="M56.773 46.255c0 2.134-2.96 3.846-6.608 3.846-3.648 0-6.602-1.723-6.602-3.846 0-2.122 2.96-3.845 6.602-3.845 3.643 0 6.608 1.723 6.608 3.846z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint102_radial_1416_98812)"
        d="M50.166 49.999c-3.568 0-6.47-1.653-6.592-3.733v.133c0 2.133 2.96 3.845 6.603 3.845s6.597-1.712 6.597-3.845a1.142 1.142 0 000-.133c-.133 2.08-3.034 3.733-6.608 3.733z"
      ></path>
      <path
        fill="url(#paint103_linear_1416_98812)"
        d="M55.102 46.254c0 1.6-2.207 2.874-4.938 2.874-2.73 0-4.934-1.285-4.934-2.874 0-1.59 2.209-2.875 4.934-2.875s4.938 1.285 4.938 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint104_radial_1416_98812)"
        d="M50.33 43.524c2.64 0 4.8 1.206 4.923 2.72a1.376 1.376 0 000-.154c0-1.6-2.213-2.875-4.939-2.875-2.725 0-4.933 1.29-4.933 2.874a1.426 1.426 0 000 .155c.165-1.514 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint105_linear_1416_98812)"
        d="M50.165 43.688c2.666 0 4.8 1.206 4.928 2.72v-.154c0-1.6-2.208-2.875-4.939-2.875-2.73 0-4.933 1.285-4.933 2.875a1.533 1.533 0 000 .154c.16-1.514 2.31-2.72 4.944-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint106_radial_1416_98812)"
        d="M47.376 46.218c1.323.357 1.91 2.443 1.307 4.656-.603 2.213-2.133 3.733-3.483 3.355-1.35-.379-1.91-2.443-1.306-4.63.602-2.186 2.16-3.733 3.482-3.381z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint107_radial_1416_98812)"
        d="M53.637 42.553c1.482.502 2.48 1.51 2.234 2.246-.245.736-1.658.917-3.14.416-1.484-.502-2.486-1.515-2.236-2.246.251-.73 1.66-.922 3.142-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint108_linear_1416_98812)"
        d="M51.913 45.69l1.867.337c.314.058.378.293.112.405l-1.6.645c-.107.043-.171.118-.166.192v1.126c0 .192-.362.298-.63.186l-1.567-.677a.634.634 0 00-.363-.037l-1.85.362c-.31.059-.603-.112-.502-.293l.624-1.067a.155.155 0 00-.058-.208l-1.174-.906c-.197-.15 0-.368.32-.363h1.952c.116.004.23-.03.326-.096l1.125-.917a.533.533 0 01.699.064l.586 1.066a.374.374 0 00.299.182z"
      ></path>
      <path
        fill="url(#paint109_linear_1416_98812)"
        d="M51.915 45.475l1.866.336c.315.06.379.3.112.406l-1.6.65c-.106.043-.17.112-.165.187v1.13c0 .187-.363.3-.63.182l-1.567-.677a.634.634 0 00-.363-.032l-1.813.341c-.31.059-.603-.112-.502-.288l.624-1.067a.16.16 0 00-.058-.213l-1.174-.907c-.197-.149 0-.362.32-.362h1.952c.116.004.23-.03.326-.096l1.125-.923a.533.533 0 01.699.07l.586 1.066a.369.369 0 00.262.197z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint110_radial_1416_98812)"
        d="M51.915 45.475l1.866.336c.315.06.379.3.112.406l-1.6.65c-.106.043-.17.112-.165.187v1.13c0 .187-.363.3-.63.182l-1.567-.677a.634.634 0 00-.363-.032l-1.813.341c-.31.059-.603-.112-.502-.288l.624-1.067a.16.16 0 00-.058-.213l-1.174-.907c-.197-.149 0-.362.32-.362h1.952c.116.004.23-.03.326-.096l1.125-.923a.533.533 0 01.699.07l.586 1.066a.369.369 0 00.262.197z"
      ></path>
      <path
        fill="url(#paint111_linear_1416_98812)"
        d="M40.052 73.254c-3.648 0-6.603-1.723-6.603-3.846v.832c0 2.134 2.955 3.846 6.603 3.846 3.648 0 6.603-1.718 6.603-3.846V69.408c0 2.123-2.955 3.846-6.603 3.846z"
        opacity="0.15"
      ></path>
      <path
        fill="url(#paint112_linear_1416_98812)"
        d="M46.67 67.137H33.465V69.05c0 2.134 2.954 3.846 6.602 3.846s6.603-1.718 6.603-3.846V67.137z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint113_linear_1416_98812)"
        d="M40.068 72.486c-3.648 0-6.603-1.717-6.603-3.845v.41c0 2.134 2.954 3.846 6.602 3.846s6.603-1.718 6.603-3.846v-.41c0 2.128-2.939 3.845-6.602 3.845z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M42.09 72.716l.186-.043v-4.88h-.186v4.923zM42.922 72.534l.187-.053v-4.672h-.187v4.725zM43.734 72.246l.182-.08v-4.373h-.182v4.453zM41.262 72.833h.186v-5.019h-.186v5.02zM45.414 71.308l.181-.15v-3.365h-.18v3.515zM46.238 70.4c.07-.104.132-.213.187-.325V67.78h-.187V70.4zM44.582 71.857c.064-.03.126-.064.187-.101v-3.963h-.187v4.064zM40.43 72.885h.186v-5.088h-.186v5.088zM39.605 72.886h.187v-5.099h-.187v5.099zM37.945 72.694l.182.038v-4.939h-.182v4.901zM38.773 72.822h.187v-5.05h-.187v5.05zM37.113 72.492l.187.048v-4.747h-.187v4.699zM33.797 70.252c.055.102.117.2.187.293v-2.752h-.187v2.459zM34.629 71.228c.053.053.123.096.181.144v-3.579h-.181v3.435zM36.266 72.204l.181.074v-4.485h-.181v4.41zM35.457 71.804l.187.096v-4.107h-.187v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint114_linear_1416_98812)"
        d="M46.67 67.164c0 2.133-2.955 3.845-6.602 3.845-3.648 0-6.603-1.723-6.603-3.845 0-2.123 2.954-3.846 6.602-3.846s6.603 1.75 6.603 3.846z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint115_radial_1416_98812)"
        d="M40.069 70.933c-3.568 0-6.47-1.654-6.592-3.734v.134c0 2.133 2.954 3.845 6.602 3.845s6.603-1.723 6.603-3.845a1.142 1.142 0 000-.134c-.144 2.054-3.04 3.734-6.613 3.734z"
      ></path>
      <path
        fill="url(#paint116_linear_1416_98812)"
        d="M45.005 67.164c0 1.6-2.214 2.874-4.939 2.874s-4.933-1.285-4.933-2.874c0-1.59 2.208-2.875 4.933-2.875 2.725 0 4.939 1.312 4.939 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint117_radial_1416_98812)"
        d="M40.234 64.432c2.635 0 4.8 1.206 4.923 2.72a1.376 1.376 0 000-.154c0-1.6-2.213-2.875-4.939-2.875-2.725 0-4.939 1.29-4.939 2.875a1.376 1.376 0 000 .154c.171-1.514 2.32-2.72 4.955-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint118_linear_1416_98812)"
        d="M40.069 64.598c2.666 0 4.8 1.206 4.922 2.72a1.535 1.535 0 000-.154c0-1.6-2.213-2.875-4.938-2.875-2.726 0-4.934 1.285-4.934 2.875a1.478 1.478 0 000 .154c.166-1.514 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint119_radial_1416_98812)"
        d="M43.54 63.467c1.482.502 2.48 1.51 2.229 2.246-.251.736-1.654.917-3.136.416-1.483-.502-2.486-1.515-2.235-2.246.25-.73 1.653-.949 3.141-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint120_linear_1416_98812)"
        d="M40.451 66.262c-.123 0-.25.054-.384.086l-.363.106c-.127.042-.251.09-.373.144l.4.23.128-.048.144-.054c.224-.08.437-.144.635-.197.185-.051.374-.087.565-.107.166-.024.335-.024.501 0 .16.03.314.087.454.17.141.07.257.182.33.32a.436.436 0 010 .348.991.991 0 01-.245.346c-.13.12-.272.23-.421.326l.533.309-.443.256-.533-.315a7.388 7.388 0 01-.88.373c-.296.104-.6.188-.907.251l-.288-.704c.15 0 .304-.058.459-.101.155-.043.288-.075.448-.128.16-.05.317-.111.47-.181l-.39-.224-.427.149a6.326 6.326 0 01-.602.17 2.968 2.968 0 01-.491.075c-.14.007-.28-.004-.416-.032a1.429 1.429 0 01-.363-.144.816.816 0 01-.325-.298.534.534 0 01-.043-.342.828.828 0 01.192-.352c.113-.132.244-.247.39-.341l-.448-.261.448-.256.448.26c.133-.063.272-.122.405-.175l.416-.139c.133-.048.267-.085.39-.117l.351-.09.235.687zm-1.493.71a.32.32 0 00.165.026c.081-.008.162-.025.24-.048l-.33-.197c-.134.096-.16.165-.075.219zm2.133.352a.292.292 0 00-.176 0 1.6 1.6 0 00-.261.058l.33.187a.443.443 0 00.144-.133.07.07 0 00.007-.078.07.07 0 00-.07-.034h.026z"
      ></path>
      <path
        fill="url(#paint121_linear_1416_98812)"
        d="M40.451 66.096c-.123 0-.25.053-.384.085l-.363.107a3.87 3.87 0 00-.373.144l.4.23.128-.049.144-.053c.224-.075.437-.144.635-.197.185-.051.374-.087.565-.107.166-.024.335-.024.501 0 .16.03.314.087.454.17.141.07.257.182.33.32a.436.436 0 010 .348.948.948 0 01-.245.346c-.13.122-.27.231-.421.326l.533.309-.443.256-.533-.315a7.388 7.388 0 01-1.787.63l-.288-.704c.15-.032.304-.064.459-.107.155-.043.288-.075.448-.128.16-.05.317-.111.47-.181l-.39-.224-.427.149c-.197.07-.398.126-.602.17a2.49 2.49 0 01-.491.075c-.14.007-.28-.004-.416-.032a1.26 1.26 0 01-.363-.144.816.816 0 01-.325-.298.534.534 0 01-.043-.342.828.828 0 01.192-.352c.114-.13.245-.246.39-.341l-.448-.256.448-.256.448.256c.132-.064.267-.12.405-.17a6.45 6.45 0 01.416-.145l.39-.117.351-.09.235.687zm-1.493.71a.32.32 0 00.165 0c.081-.01.162-.025.24-.049l-.33-.197c-.134.107-.16.192-.075.245zm2.133.352a.3.3 0 00-.176 0 1.137 1.137 0 00-.261.053l.33.186a.389.389 0 00.144-.133.069.069 0 00.002-.073.07.07 0 00-.066-.034h.027z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint122_radial_1416_98812)"
        d="M40.451 66.096c-.123 0-.25.053-.384.085l-.363.107a3.87 3.87 0 00-.373.144l.4.23.128-.049.144-.053c.224-.075.437-.144.635-.197.185-.051.374-.087.565-.107.166-.024.335-.024.501 0 .16.03.314.087.454.17.141.07.257.182.33.32a.436.436 0 010 .348.948.948 0 01-.245.346c-.13.122-.27.231-.421.326l.533.309-.443.256-.533-.315a7.388 7.388 0 01-1.787.63l-.288-.704c.15-.032.304-.064.459-.107.155-.043.288-.075.448-.128.16-.05.317-.111.47-.181l-.39-.224-.427.149c-.197.07-.398.126-.602.17a2.49 2.49 0 01-.491.075c-.14.007-.28-.004-.416-.032a1.26 1.26 0 01-.363-.144.816.816 0 01-.325-.298.534.534 0 01-.043-.342.828.828 0 01.192-.352c.114-.13.245-.246.39-.341l-.448-.256.448-.256.448.256c.132-.064.267-.12.405-.17a6.45 6.45 0 01.416-.145l.39-.117.351-.09.235.687zm-1.493.71a.32.32 0 00.165 0c.081-.01.162-.025.24-.049l-.33-.197c-.134.107-.16.192-.075.245zm2.133.352a.3.3 0 00-.176 0 1.137 1.137 0 00-.261.053l.33.186a.389.389 0 00.144-.133.069.069 0 00.002-.073.07.07 0 00-.066-.034h.027z"
      ></path>
      <path
        fill="url(#paint123_linear_1416_98812)"
        d="M46.67 65.066H33.465v1.92c0 2.134 2.954 3.846 6.602 3.846s6.603-1.723 6.603-3.846v-1.92z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint124_linear_1416_98812)"
        d="M40.068 70.398c-3.648 0-6.603-1.723-6.603-3.845v.41c0 2.134 2.954 3.846 6.602 3.846s6.603-1.723 6.603-3.846v-.41c0 2.128-2.939 3.845-6.602 3.845z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M42.09 70.63l.186-.038v-4.885h-.186v4.923zM42.922 70.432l.187-.053v-4.672h-.187v4.725zM43.734 70.16a1.9 1.9 0 00.182-.08v-4.373h-.182v4.453zM41.262 70.747h.186v-5.04h-.186v5.04zM45.414 69.222l.181-.15v-3.365h-.18v3.515zM46.238 68.331c.07-.106.132-.216.187-.33v-2.294h-.187v2.624zM44.582 69.771c.064-.03.126-.064.187-.101v-3.963h-.187v4.064zM40.43 70.806h.186v-5.099h-.186v5.099zM39.605 70.8h.187v-5.093h-.187V70.8zM37.945 70.608l.182.038v-4.939h-.182v4.901zM38.773 70.742h.187v-5.035h-.187v5.035zM37.113 70.4l.187.054v-4.747h-.187V70.4zM33.797 68.166c.055.102.117.2.187.293v-2.752h-.187v2.459zM34.629 69.142c.053.053.123.101.181.149v-3.584h-.181v3.435zM36.266 70.118l.181.074v-4.485h-.181v4.41zM35.457 69.718l.187.096v-4.107h-.187v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint125_linear_1416_98812)"
        d="M46.67 65.066c0 2.133-2.955 3.845-6.602 3.845-3.648 0-6.603-1.712-6.603-3.845s2.954-3.845 6.602-3.845 6.603 1.712 6.603 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint126_radial_1416_98812)"
        d="M40.069 68.8c-3.568 0-6.47-1.648-6.592-3.734v.134c0 2.133 2.954 3.845 6.602 3.845s6.603-1.723 6.603-3.845a1.14 1.14 0 000-.134c-.144 2.134-3.04 3.734-6.613 3.734z"
      ></path>
      <path
        fill="url(#paint127_linear_1416_98812)"
        d="M40.068 67.95c2.727 0 4.938-1.287 4.938-2.874 0-1.588-2.21-2.875-4.938-2.875-2.728 0-4.94 1.287-4.94 2.875s2.212 2.875 4.94 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint128_radial_1416_98812)"
        d="M40.234 62.344c2.635 0 4.8 1.206 4.923 2.72a1.376 1.376 0 000-.154c0-1.6-2.213-2.875-4.939-2.875-2.725 0-4.939 1.29-4.939 2.875a1.376 1.376 0 000 .154c.171-1.514 2.32-2.72 4.955-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint129_linear_1416_98812)"
        d="M40.069 62.51c2.666 0 4.8 1.206 4.922 2.72a1.376 1.376 0 000-.154c0-1.6-2.213-2.875-4.938-2.875-2.726 0-4.934 1.29-4.934 2.875a1.426 1.426 0 000 .155c.166-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint130_radial_1416_98812)"
        d="M43.54 61.375c1.482.533 2.48 1.51 2.229 2.245-.251.736-1.654.918-3.136.416-1.483-.501-2.486-1.509-2.235-2.245.25-.736 1.653-.923 3.141-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint131_linear_1416_98812)"
        d="M40.451 64.176c-.123 0-.25.054-.384.086l-.363.106a3.87 3.87 0 00-.373.144l.4.23.128-.048.144-.054c.224-.074.437-.144.635-.197.185-.051.374-.087.565-.107a1.74 1.74 0 01.501 0c.16.032.313.09.454.17.141.07.257.182.33.32a.437.437 0 010 .348.95.95 0 01-.245.346c-.13.123-.27.231-.421.326l.533.309-.443.256-.533-.315a7.388 7.388 0 01-1.787.63l-.288-.704c.15-.032.304-.064.459-.107.155-.043.288-.075.448-.128.16-.05.317-.111.47-.181l-.39-.224-.427.149c-.197.07-.398.126-.602.17-.161.042-.325.067-.491.075-.14.007-.28-.004-.416-.032a1.122 1.122 0 01-.363-.144.816.816 0 01-.325-.298.534.534 0 01-.043-.342.828.828 0 01.192-.352c.114-.13.245-.245.39-.341l-.448-.256.448-.256.448.256c.133-.064.272-.117.405-.17.133-.054.277-.102.416-.145l.39-.117.351-.09.235.687zm-1.493.71a.271.271 0 00.165 0c.081-.01.162-.025.24-.048l-.33-.192c-.134.117-.16.192-.075.24zm2.133.352a.298.298 0 00-.176 0 1.142 1.142 0 00-.261.053l.33.187a.389.389 0 00.144-.134.069.069 0 00.002-.073.069.069 0 00-.066-.033h.027z"
      ></path>
      <path
        fill="url(#paint132_linear_1416_98812)"
        d="M40.452 63.998c-.122 0-.25.053-.384.09-.133.038-.234.065-.362.107-.127.04-.252.086-.374.139l.4.23.128-.049.144-.048c.224-.08.438-.149.635-.202.185-.051.374-.087.565-.107a1.74 1.74 0 01.502 0c.16.027.313.083.453.165.142.069.258.181.33.32a.438.438 0 010 .347.95.95 0 01-.245.347c-.129.122-.27.23-.42.325l.532.31-.442.255-.534-.309c-.286.14-.58.262-.88.368-.297.103-.6.188-.906.256l-.288-.704c.15-.032.304-.064.458-.107.155-.042.288-.074.448-.128.16-.05.317-.11.47-.181l-.39-.224-.426.15a5.08 5.08 0 01-.603.17c-.16.041-.325.066-.49.075-.14.006-.28-.005-.417-.032a1.12 1.12 0 01-.362-.144.816.816 0 01-.326-.299.491.491 0 01-.042-.336.842.842 0 01.192-.357c.114-.131.245-.246.39-.342l-.449-.256.448-.256.448.256.405-.17c.14-.054.278-.102.416-.144l.39-.118.352-.09.234.693zm-1.493.71c.05.027.108.038.165.031.082-.01.162-.028.24-.053l-.33-.192c-.134.101-.16.176-.075.224v-.01zm2.133.351a.298.298 0 00-.176 0c-.088.01-.175.028-.26.054l.33.186a.39.39 0 00.144-.133.07.07 0 00-.064-.101l.026-.006z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint133_radial_1416_98812)"
        d="M40.452 63.998c-.122 0-.25.053-.384.09-.133.038-.234.065-.362.107-.127.04-.252.086-.374.139l.4.23.128-.049.144-.048c.224-.08.438-.149.635-.202.185-.051.374-.087.565-.107a1.74 1.74 0 01.502 0c.16.027.313.083.453.165.142.069.258.181.33.32a.438.438 0 010 .347.95.95 0 01-.245.347c-.129.122-.27.23-.42.325l.532.31-.442.255-.534-.309c-.286.14-.58.262-.88.368-.297.103-.6.188-.906.256l-.288-.704c.15-.032.304-.064.458-.107.155-.042.288-.074.448-.128.16-.05.317-.11.47-.181l-.39-.224-.426.15a5.08 5.08 0 01-.603.17c-.16.041-.325.066-.49.075-.14.006-.28-.005-.417-.032a1.12 1.12 0 01-.362-.144.816.816 0 01-.326-.299.491.491 0 01-.042-.336.842.842 0 01.192-.357c.114-.131.245-.246.39-.342l-.449-.256.448-.256.448.256.405-.17c.14-.054.278-.102.416-.144l.39-.118.352-.09.234.693zm-1.493.71c.05.027.108.038.165.031.082-.01.162-.028.24-.053l-.33-.192c-.134.101-.16.176-.075.224v-.01zm2.133.351a.298.298 0 00-.176 0c-.088.01-.175.028-.26.054l.33.186a.39.39 0 00.144-.133.07.07 0 00-.064-.101l.026-.006z"
      ></path>
      <path
        fill="url(#paint134_linear_1416_98812)"
        d="M46.67 62.857H33.465v1.915c0 2.133 2.954 3.845 6.602 3.845s6.603-1.722 6.603-3.845v-1.915z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint135_linear_1416_98812)"
        d="M40.068 68.209c-3.648 0-6.603-1.723-6.603-3.846v.411c0 2.133 2.954 3.845 6.602 3.845s6.603-1.722 6.603-3.845v-.411c0 2.123-2.939 3.846-6.602 3.846z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M42.09 68.436l.186-.042v-4.88h-.186v4.922zM42.922 68.266l.187-.053v-4.672h-.187v4.725zM43.734 67.967l.182-.08v-4.373h-.182v4.453zM41.262 68.554h.186v-5.019h-.186v5.019zM45.414 67.028c.064-.048.123-.101.181-.154v-3.36h-.18v3.514zM46.238 66.132c.07-.104.132-.213.187-.325v-2.293h-.187v2.618zM44.582 67.578l.187-.102v-3.962h-.187v4.064zM40.43 68.608h.186v-5.089h-.186v5.089zM39.605 68.606h.187v-5.098h-.187v5.098zM37.945 68.41l.182.042v-4.938h-.182v4.896zM38.773 68.543h.187v-5.045h-.187v5.045zM37.113 68.207l.187.053v-4.746h-.187v4.693zM33.797 65.972c.056.102.119.2.187.294v-2.752h-.187v2.458zM34.629 66.948c.053.048.123.096.181.144v-3.578h-.181v3.434zM36.266 67.924l.181.07v-4.48h-.181v4.41zM35.457 67.524l.187.096v-4.106h-.187v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint136_linear_1416_98812)"
        d="M46.67 62.884c0 2.134-2.955 3.846-6.602 3.846-3.648 0-6.603-1.723-6.603-3.846 0-2.122 2.954-3.845 6.602-3.845s6.603 1.723 6.603 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint137_radial_1416_98812)"
        d="M40.069 66.628c-3.568 0-6.47-1.653-6.592-3.733v.133c0 2.133 2.954 3.845 6.602 3.845s6.603-1.723 6.603-3.845a1.06 1.06 0 000-.133c-.144 2.08-3.04 3.733-6.613 3.733z"
      ></path>
      <path
        fill="url(#paint138_linear_1416_98812)"
        d="M45.005 62.884c0 1.6-2.214 2.875-4.939 2.875s-4.933-1.285-4.933-2.875c0-1.589 2.208-2.874 4.933-2.874 2.725 0 4.939 1.285 4.939 2.874z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint139_radial_1416_98812)"
        d="M40.234 60.153c2.635 0 4.8 1.205 4.923 2.72a1.478 1.478 0 000-.155c0-1.6-2.214-2.874-4.939-2.874s-4.939 1.285-4.939 2.874a1.535 1.535 0 000 .155c.171-1.515 2.32-2.72 4.955-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint140_linear_1416_98812)"
        d="M40.069 60.32c2.666 0 4.8 1.204 4.922 2.72a1.535 1.535 0 000-.156c0-1.6-2.213-2.874-4.938-2.874-2.726 0-4.934 1.285-4.934 2.874a1.478 1.478 0 000 .155c.166-1.515 2.315-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint141_radial_1416_98812)"
        d="M43.54 59.2c1.482.532 2.48 1.514 2.229 2.244-.251.731-1.654.923-3.136.416-1.483-.506-2.486-1.509-2.235-2.245.25-.736 1.653-.95 3.141-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint142_linear_1416_98812)"
        d="M40.451 61.984c-.13.022-.258.05-.384.085a4.39 4.39 0 00-.363.107l-.373.139.4.229a.712.712 0 01.128-.043l.144-.053c.224-.08.437-.144.635-.197.185-.05.374-.088.565-.112.166-.022.335-.022.501 0 .16.028.314.086.454.17.143.066.26.179.33.32a.436.436 0 010 .347.992.992 0 01-.245.346c-.13.121-.272.23-.421.326l.533.31-.443.255-.533-.314a6.61 6.61 0 01-.88.367 6.307 6.307 0 01-.907.256l-.288-.704c.15 0 .304-.063.459-.1.155-.038.288-.08.448-.129.16-.048.32-.117.47-.181l-.39-.224-.427.15a6.324 6.324 0 01-.602.17 2.968 2.968 0 01-.491.075c-.14.006-.28-.005-.416-.032a1.433 1.433 0 01-.363-.144.816.816 0 01-.325-.3.534.534 0 01-.043-.34.828.828 0 01.192-.352c.114-.133.245-.25.39-.347l-.448-.256.448-.256.448.261a5.398 5.398 0 01.821-.32l.39-.112.351-.096.235.699zm-1.493.704c.05.028.108.039.165.032.082-.009.162-.026.24-.053l-.33-.193c-.134.097-.16.166-.075.214zm2.133.357a.292.292 0 00-.176 0 1.6 1.6 0 00-.261.059l.33.187a.443.443 0 00.144-.134.07.07 0 00.007-.078.07.07 0 00-.07-.034h.026z"
      ></path>
      <path
        fill="url(#paint143_linear_1416_98812)"
        d="M40.451 61.818c-.123 0-.25.054-.384.086l-.363.106c-.127.042-.251.09-.373.144l.4.224.128-.042.144-.054c.224-.08.437-.144.635-.197.185-.051.374-.087.565-.107.166-.024.335-.024.501 0 .16.03.314.087.454.171a.71.71 0 01.33.32.436.436 0 010 .347.991.991 0 01-.245.346c-.13.121-.272.23-.421.326l.533.309-.443.256-.533-.315a7.405 7.405 0 01-.88.374c-.296.103-.6.187-.907.25l-.288-.704c.15 0 .304-.058.459-.101.155-.043.288-.075.448-.128.16-.05.317-.111.47-.181l-.39-.224-.427.149a6.326 6.326 0 01-.602.17 2.968 2.968 0 01-.491.075c-.14.007-.28-.004-.416-.032a1.429 1.429 0 01-.363-.144.816.816 0 01-.325-.298.534.534 0 01-.043-.342.828.828 0 01.192-.352c.113-.132.244-.247.39-.341l-.448-.261.448-.256.448.261c.133-.064.272-.123.405-.176l.405-.144c.134-.048.267-.085.39-.117l.352-.091.245.693zm-1.493.71a.32.32 0 00.165.026c.081-.008.162-.024.24-.048l-.33-.197c-.134.09-.16.165-.075.219zm2.133.352a.293.293 0 00-.176-.027 1.59 1.59 0 00-.261.059l.33.186a.442.442 0 00.144-.133.068.068 0 00-.012-.058.07.07 0 00-.052-.027h.027z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint144_radial_1416_98812)"
        d="M40.451 61.818c-.123 0-.25.054-.384.086l-.363.106c-.127.042-.251.09-.373.144l.4.224.128-.042.144-.054c.224-.08.437-.144.635-.197.185-.051.374-.087.565-.107.166-.024.335-.024.501 0 .16.03.314.087.454.171a.71.71 0 01.33.32.436.436 0 010 .347.991.991 0 01-.245.346c-.13.121-.272.23-.421.326l.533.309-.443.256-.533-.315a7.405 7.405 0 01-.88.374c-.296.103-.6.187-.907.25l-.288-.704c.15 0 .304-.058.459-.101.155-.043.288-.075.448-.128.16-.05.317-.111.47-.181l-.39-.224-.427.149a6.326 6.326 0 01-.602.17 2.968 2.968 0 01-.491.075c-.14.007-.28-.004-.416-.032a1.429 1.429 0 01-.363-.144.816.816 0 01-.325-.298.534.534 0 01-.043-.342.828.828 0 01.192-.352c.113-.132.244-.247.39-.341l-.448-.261.448-.256.448.261c.133-.064.272-.123.405-.176l.405-.144c.134-.048.267-.085.39-.117l.352-.091.245.693zm-1.493.71a.32.32 0 00.165.026c.081-.008.162-.024.24-.048l-.33-.197c-.134.09-.16.165-.075.219zm2.133.352a.293.293 0 00-.176-.027 1.59 1.59 0 00-.261.059l.33.186a.442.442 0 00.144-.133.068.068 0 00-.012-.058.07.07 0 00-.052-.027h.027z"
      ></path>
      <path
        fill="url(#paint145_linear_1416_98812)"
        d="M46.67 60.645H33.465V62.559c0 2.133 2.954 3.846 6.602 3.846s6.603-1.723 6.603-3.846v-1.914z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint146_linear_1416_98812)"
        d="M40.068 65.994c-3.648 0-6.603-1.723-6.603-3.846v.411c0 2.133 2.954 3.845 6.602 3.845s6.603-1.722 6.603-3.845v-.411c0 2.123-2.939 3.846-6.602 3.846z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M42.09 66.218l.186-.038v-4.885h-.186v4.923zM42.922 66.026l.187-.054v-4.677h-.187v4.73zM43.734 65.754l.182-.08v-4.38h-.182v4.46zM41.262 66.34h.186v-5.024h-.186v5.024zM45.414 64.815l.181-.155v-3.365h-.18v3.52zM46.238 63.919a3.39 3.39 0 00.187-.325v-2.3h-.187v2.625zM44.582 65.359l.187-.096v-3.968h-.187v4.064zM40.43 66.394h.186v-5.093h-.186v5.093zM39.605 66.388h.187v-5.099h-.187v5.099zM37.945 66.196l.182.038v-4.94h-.182v4.902zM38.773 66.33h.187v-5.05h-.187v5.05zM37.113 65.994l.187.053v-4.752h-.187v4.699zM33.797 63.754c.055.103.117.203.187.298v-2.757h-.187v2.459zM34.629 64.735c.053.048.123.096.181.144v-3.584h-.181v3.44zM36.266 65.706l.181.074v-4.485h-.181v4.41zM35.457 65.306c.06.037.123.07.187.1v-4.111h-.187v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint147_linear_1416_98812)"
        d="M46.67 60.672c0 2.133-2.955 3.845-6.602 3.845-3.648 0-6.603-1.723-6.603-3.845 0-2.123 2.954-3.846 6.602-3.846s6.603 1.718 6.603 3.846z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint148_radial_1416_98812)"
        d="M40.069 64.41c-3.568 0-6.47-1.649-6.592-3.734v.133c0 2.133 2.954 3.85 6.602 3.85s6.603-1.722 6.603-3.85a1.235 1.235 0 000-.133c-.144 2.085-3.04 3.733-6.613 3.733z"
      ></path>
      <path
        fill="url(#paint149_linear_1416_98812)"
        d="M40.068 63.546c2.727 0 4.938-1.287 4.938-2.874 0-1.588-2.21-2.875-4.938-2.875-2.728 0-4.94 1.287-4.94 2.875 0 1.587 2.212 2.874 4.94 2.874z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint150_radial_1416_98812)"
        d="M40.234 57.942c2.635 0 4.8 1.206 4.923 2.72a1.476 1.476 0 000-.154c0-1.6-2.214-2.875-4.939-2.875s-4.939 1.285-4.939 2.874a1.533 1.533 0 000 .155c.171-1.514 2.32-2.72 4.955-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint151_linear_1416_98812)"
        d="M40.066 58.1c2.667 0 4.8 1.206 4.923 2.726v-.154c0-1.6-2.213-2.875-4.938-2.875-2.726 0-4.934 1.285-4.934 2.875v.154c.166-1.52 2.315-2.725 4.95-2.725z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint152_radial_1416_98812)"
        d="M43.54 56.965c1.482.533 2.48 1.51 2.229 2.245-.251.736-1.654.923-3.136.416-1.483-.506-2.486-1.51-2.235-2.245.25-.736 1.653-.923 3.141-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint153_linear_1416_98812)"
        d="M40.452 59.764c-.122 0-.25.053-.384.09-.133.038-.234.064-.362.107-.127.04-.252.086-.374.139l.4.229.128-.048.144-.048c.224-.08.438-.15.635-.203.186-.048.375-.084.565-.106.167-.022.335-.022.502 0 .16.027.313.083.453.165.143.069.26.183.33.325a.422.422 0 010 .342.95.95 0 01-.245.346c-.13.123-.271.233-.42.331l.532.304-.442.256-.534-.31a7.37 7.37 0 01-.88.369 6.293 6.293 0 01-.906.256l-.288-.704c.15-.027.304-.064.458-.107.155-.043.288-.075.448-.128.16-.05.317-.111.47-.181l-.39-.224a4.997 4.997 0 01-.426.149c-.15.043-.422.133-.603.176a2.93 2.93 0 01-.49.07c-.14.011-.28 0-.417-.033a1.247 1.247 0 01-.362-.138.82.82 0 01-.326-.304.49.49 0 01-.042-.336.875.875 0 01.192-.358c.115-.13.246-.244.39-.341l-.449-.256.448-.256.448.261a5.515 5.515 0 01.821-.32l.39-.117.352-.09.234.693zm-1.493.709c.05.028.108.04.165.032.082-.009.163-.026.24-.053l-.33-.192c-.134.09-.16.165-.075.213zm2.133.352a.298.298 0 00-.176 0c-.088.01-.175.028-.26.053l.33.192a.443.443 0 00.144-.138c0-.054-.01-.08-.064-.107h.026z"
      ></path>
      <path
        fill="url(#paint154_linear_1416_98812)"
        d="M40.452 59.6c-.122 0-.25.053-.384.09-.133.038-.234.064-.362.107l-.374.139.4.229.128-.048.144-.048c.224-.08.438-.144.635-.197a3.52 3.52 0 01.565-.112c.167-.022.335-.022.502 0 .16.027.313.083.453.165.143.069.26.183.33.325a.438.438 0 010 .347c-.057.13-.14.249-.245.347a3.492 3.492 0 01-.42.325l.532.31-.442.255-.534-.314a6.598 6.598 0 01-.88.368 6.306 6.306 0 01-.906.256l-.288-.704c.15 0 .304-.064.458-.102a5.27 5.27 0 00.448-.133c.161-.048.318-.11.47-.181l-.39-.22-.426.15c-.219.07-.422.128-.603.17-.16.04-.325.064-.49.07a1.3 1.3 0 01-.417-.032 1.252 1.252 0 01-.362-.138.79.79 0 01-.326-.304.491.491 0 01-.042-.336.875.875 0 01.192-.358c.115-.13.246-.244.39-.341l-.449-.256.448-.256.448.261a5.471 5.471 0 01.821-.32l.39-.112.352-.096.234.694zm-1.493.709c.05.028.108.039.165.032.082-.009.163-.026.24-.053l-.33-.192c-.134.096-.16.17-.075.213zm2.133.357a.292.292 0 00-.176 0c-.088.01-.175.028-.26.054l.33.192a.536.536 0 00.144-.134.07.07 0 00-.024-.105.07.07 0 00-.04-.007h.026z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint155_radial_1416_98812)"
        d="M40.452 59.6c-.122 0-.25.053-.384.09-.133.038-.234.064-.362.107l-.374.139.4.229.128-.048.144-.048c.224-.08.438-.144.635-.197a3.52 3.52 0 01.565-.112c.167-.022.335-.022.502 0 .16.027.313.083.453.165.143.069.26.183.33.325a.438.438 0 010 .347c-.057.13-.14.249-.245.347a3.492 3.492 0 01-.42.325l.532.31-.442.255-.534-.314a6.598 6.598 0 01-.88.368 6.306 6.306 0 01-.906.256l-.288-.704c.15 0 .304-.064.458-.102a5.27 5.27 0 00.448-.133c.161-.048.318-.11.47-.181l-.39-.22-.426.15c-.219.07-.422.128-.603.17-.16.04-.325.064-.49.07a1.3 1.3 0 01-.417-.032 1.252 1.252 0 01-.362-.138.79.79 0 01-.326-.304.491.491 0 01-.042-.336.875.875 0 01.192-.358c.115-.13.246-.244.39-.341l-.449-.256.448-.256.448.261a5.471 5.471 0 01.821-.32l.39-.112.352-.096.234.694zm-1.493.709c.05.028.108.039.165.032.082-.009.163-.026.24-.053l-.33-.192c-.134.096-.16.17-.075.213zm2.133.357a.292.292 0 00-.176 0c-.088.01-.175.028-.26.054l.33.192a.536.536 0 00.144-.134.07.07 0 00-.024-.105.07.07 0 00-.04-.007h.026z"
      ></path>
      <path
        fill="url(#paint156_linear_1416_98812)"
        d="M46.67 58.613H33.465v1.915c0 2.133 2.954 3.845 6.602 3.845s6.603-1.717 6.603-3.845v-1.915z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint157_linear_1416_98812)"
        d="M40.068 63.962c-3.648 0-6.603-1.722-6.603-3.845v.411c0 2.133 2.954 3.845 6.602 3.845s6.603-1.717 6.603-3.845v-.411c0 2.123-2.939 3.846-6.602 3.846z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M42.09 64.192l.186-.042v-4.88h-.186v4.922zM42.922 63.999l.187-.054v-4.672h-.187V64zM43.734 63.723l.182-.08V59.27h-.182v4.453zM41.262 64.31h.186V59.29h-.186v5.019zM45.414 62.784a2.51 2.51 0 00.181-.154v-3.36h-.18v3.514zM46.238 61.867c.07-.104.132-.213.187-.326v-2.293h-.187v2.619zM44.582 63.334c.064-.031.126-.065.187-.102V59.27h-.187v4.063zM40.43 64.361h.186v-5.088h-.186v5.088zM39.605 64.362h.187v-5.098h-.187v5.098zM37.945 64.17l.182.038V59.27h-.182v4.9zM38.773 64.3h.187v-5.046h-.187v5.045zM37.113 63.968l.187.048V59.27h-.187v4.7zM33.797 61.728c.055.102.117.2.187.294V59.27h-.187v2.458zM34.629 62.704c.053.053.123.096.181.144V59.27h-.181v3.434zM36.266 63.68l.181.07v-4.48h-.181v4.41zM35.457 63.28l.187.096V59.27h-.187v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint158_linear_1416_98812)"
        d="M46.67 58.666c0 2.133-2.955 3.845-6.602 3.845-3.648 0-6.603-1.75-6.603-3.845 0-2.096 2.954-3.846 6.602-3.846s6.603 1.712 6.603 3.846z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint159_radial_1416_98812)"
        d="M40.069 62.401c-3.568 0-6.47-1.653-6.592-3.733v.133c0 2.134 2.954 3.846 6.602 3.846s6.603-1.723 6.603-3.846a1.059 1.059 0 000-.133c-.144 2.064-3.04 3.733-6.613 3.733z"
      ></path>
      <path
        fill="url(#paint160_linear_1416_98812)"
        d="M40.068 61.515c2.727 0 4.938-1.287 4.938-2.875 0-1.587-2.21-2.874-4.938-2.874-2.728 0-4.94 1.287-4.94 2.874 0 1.588 2.212 2.875 4.94 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint161_radial_1416_98812)"
        d="M40.234 55.91c2.635 0 4.8 1.206 4.923 2.72a1.376 1.376 0 000-.154c0-1.6-2.213-2.874-4.939-2.874-2.725 0-4.939 1.29-4.939 2.874a1.376 1.376 0 000 .155c.171-1.515 2.32-2.72 4.955-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint162_linear_1416_98812)"
        d="M40.068 56.075c2.667 0 4.8 1.205 4.923 2.72a1.535 1.535 0 000-.155c0-1.6-2.213-2.874-4.939-2.874-2.725 0-4.917 1.301-4.917 2.901a1.533 1.533 0 000 .155c.15-1.542 2.299-2.747 4.933-2.747z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint163_radial_1416_98812)"
        d="M37.279 58.603c1.322.357 1.909 2.442 1.306 4.656-.602 2.213-2.133 3.733-3.482 3.355-1.35-.38-1.91-2.443-1.307-4.657.603-2.213 2.16-3.717 3.483-3.354z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint164_radial_1416_98812)"
        d="M43.54 54.934c1.482.501 2.48 1.51 2.229 2.245-.251.736-1.654.917-3.136.416-1.483-.501-2.486-1.515-2.235-2.245.25-.73 1.653-.918 3.141-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint165_linear_1416_98812)"
        d="M41.817 58.075l1.867.336c.31.059.379.294.112.406l-1.6.645c-.107.043-.17.117-.17.192l.031 1.125c0 .192-.368.299-.63.187l-1.557-.699a.64.64 0 00-.362-.037l-1.85.363c-.31.058-.604-.112-.502-.294l.624-1.066a.16.16 0 00-.059-.208l-1.173-.907c-.198-.15 0-.368.314-.363h1.958c.116.005.23-.03.325-.096l1.125-.917a.534.534 0 01.7.064l.586 1.067a.363.363 0 00.261.202z"
      ></path>
      <path
        fill="url(#paint166_linear_1416_98812)"
        d="M41.816 57.862l1.867.336c.31.058.378.298.112.405l-1.6.65c-.107.043-.17.113-.17.187l.031 1.131c0 .187-.368.293-.63.181l-1.567-.677a.64.64 0 00-.363-.032l-1.85.357c-.31.06-.603-.112-.502-.288l.624-1.066a.166.166 0 00-.059-.214l-1.173-.906c-.197-.15 0-.363.315-.363h1.957c.116.004.23-.03.325-.096l1.126-.923a.534.534 0 01.698.07l.587 1.066a.356.356 0 00.272.182z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint167_radial_1416_98812)"
        d="M41.816 57.862l1.867.336c.31.058.378.298.112.405l-1.6.65c-.107.043-.17.113-.17.187l.031 1.131c0 .187-.368.293-.63.181l-1.567-.677a.64.64 0 00-.363-.032l-1.85.357c-.31.06-.603-.112-.502-.288l.624-1.066a.166.166 0 00-.059-.214l-1.173-.906c-.197-.15 0-.363.315-.363h1.957c.116.004.23-.03.325-.096l1.126-.923a.534.534 0 01.698.07l.587 1.066a.356.356 0 00.272.182z"
      ></path>
      <path
        fill="url(#paint168_linear_1416_98812)"
        d="M29.963 79.166c-3.648 0-6.608-1.723-6.608-3.846v.832c0 2.134 2.96 3.846 6.608 3.846 3.648 0 6.603-1.723 6.603-3.846V75.32c0 2.123-2.965 3.846-6.603 3.846z"
        opacity="0.15"
      ></path>
      <path
        fill="url(#paint169_linear_1416_98812)"
        d="M36.58 73.066H23.375v1.915c0 2.133 2.955 3.845 6.603 3.845 3.648 0 6.602-1.722 6.602-3.845v-1.915z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint170_linear_1416_98812)"
        d="M29.978 78.398c-3.648 0-6.603-1.723-6.603-3.845v.41c0 2.134 2.955 3.846 6.603 3.846 3.648 0 6.602-1.723 6.602-3.846v-.41c0 2.122-2.954 3.845-6.602 3.845z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M32 78.622l.187-.037v-4.886H32v4.923zM32.832 78.43l.181-.053v-4.678h-.181v4.73zM33.66 78.158l.187-.08v-4.379h-.187v4.459zM31.168 78.745h.187V73.72h-.187v5.024zM35.316 77.22l.187-.155v-3.366h-.187v3.52zM36.148 76.323a2.48 2.48 0 00.182-.325v-2.299h-.182v2.624zM34.492 77.769l.181-.102V73.7h-.18v4.07zM30.34 78.798h.186v-5.093h-.186v5.093zM29.508 78.794h.187v-5.099h-.187v5.099zM27.852 78.6l.186.038v-4.939h-.186v4.902zM28.684 78.734h.186v-5.05h-.186v5.05zM27.023 78.398l.182.053V73.7h-.182v4.699zM23.707 76.158c.053.104.114.203.181.299v-2.758h-.181v2.459zM24.535 77.14l.187.143V73.7h-.187v3.44zM26.191 78.11l.187.075v-4.486h-.187v4.41zM25.367 77.71l.181.101V73.7h-.18v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint171_linear_1416_98812)"
        d="M29.978 76.921c3.646 0 6.602-1.722 6.602-3.845 0-2.124-2.956-3.845-6.602-3.845-3.647 0-6.603 1.721-6.603 3.845s2.956 3.845 6.603 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint172_radial_1416_98812)"
        d="M29.977 76.8c-3.573 0-6.47-1.648-6.592-3.734a1.234 1.234 0 000 .14c0 2.132 2.954 3.844 6.602 3.844 3.649 0 6.603-1.722 6.603-3.845v-.139c-.144 2.102-3.045 3.734-6.613 3.734z"
      ></path>
      <path
        fill="url(#paint173_linear_1416_98812)"
        d="M29.978 75.95c2.727 0 4.938-1.287 4.938-2.874 0-1.588-2.21-2.875-4.938-2.875-2.728 0-4.939 1.287-4.939 2.875s2.211 2.875 4.939 2.875z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint174_radial_1416_98812)"
        d="M30.143 70.344c2.634 0 4.8 1.206 4.922 2.72a1.535 1.535 0 000-.154c0-1.6-2.208-2.875-4.933-2.875-2.725 0-4.939 1.285-4.939 2.875a1.535 1.535 0 000 .154c.16-1.514 2.31-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint175_linear_1416_98812)"
        d="M29.978 70.51c2.635 0 4.8 1.2 4.923 2.72v-.154c0-1.6-2.208-2.875-4.933-2.875-2.726 0-4.902 1.264-4.902 2.864v.155c.128-1.51 2.272-2.71 4.912-2.71z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint176_radial_1416_98812)"
        d="M33.445 69.37c1.483.532 2.486 1.508 2.235 2.245-.25.736-1.659.922-3.141.416-1.483-.507-2.486-1.51-2.235-2.246.25-.736 1.659-.922 3.141-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint177_linear_1416_98812)"
        d="M30.358 72.17c-.123.027-.25.053-.379.09-.128.038-.234.065-.368.107-.133.043-.25.09-.368.139l.395.23.128-.049.15-.048c.223-.08.437-.15.634-.202.175-.048.353-.084.533-.107.167-.022.335-.022.502 0 .161.027.317.083.458.165.142.07.258.184.331.326a.47.47 0 010 .34.966.966 0 01-.25.348c-.129.124-.27.235-.422.33l.533.304-.442.256-.534-.31c-.285.141-.58.264-.88.369a6.565 6.565 0 01-.912.256l-.288-.704c.15-.027.304-.064.464-.101l.448-.134c.161-.048.318-.109.47-.181l-.39-.224-.426.155c-.224.069-.422.128-.603.17-.163.037-.329.06-.496.07-.14.011-.28 0-.416-.032a1.308 1.308 0 01-.363-.14.768.768 0 01-.32-.303.491.491 0 01-.042-.336.875.875 0 01.192-.357c.113-.13.242-.245.384-.342L27.638 72l.443-.256.448.262c.138-.064.272-.123.41-.176l.411-.144.395-.112.346-.096.267.693zm-1.488.71c.048.027.105.038.16.031.084-.007.166-.025.245-.053l-.336-.192c-.138.096-.138.165-.069.213zm2.133.351a.272.272 0 00-.17 0 1.34 1.34 0 00-.262.054l.326.192c.085-.06.133-.102.144-.14.01-.036-.016-.08-.054-.106h.016z"
      ></path>
      <path
        fill="url(#paint178_linear_1416_98812)"
        d="M30.356 72c-.128.021-.254.05-.379.085-.112 0-.235.064-.368.107-.133.042-.25.09-.368.138l.395.23.128-.048.15-.048a8.37 8.37 0 01.634-.198c.174-.051.353-.089.533-.112.167-.021.335-.021.502 0 .16.03.315.086.458.166a.74.74 0 01.33.325.485.485 0 010 .347c-.059.131-.144.249-.25.346-.128.124-.27.233-.421.326l.533.31-.442.255-.534-.315a6.94 6.94 0 01-.88.368 6.573 6.573 0 01-.912.256l-.288-.704c.15-.026.304-.064.464-.1l.448-.129c.166-.053.32-.117.47-.181l-.39-.224-.427.15c-.224.068-.42.127-.602.17-.163.039-.329.062-.496.07a1.32 1.32 0 01-.379.01 1.306 1.306 0 01-.363-.139.74.74 0 01-.32-.304.49.49 0 01-.042-.336.876.876 0 01.192-.357 2.05 2.05 0 01.384-.342l-.443-.256.443-.256.448.262c.139-.064.272-.123.41-.176l.411-.144.395-.112.346-.096.23.656zm-1.488.704a.257.257 0 00.16.032c.084-.008.166-.026.245-.054l-.336-.192c-.139.107-.139.176-.07.224v-.01zM31 73.06a.267.267 0 00-.17 0c-.089.012-.176.03-.262.053l.326.192c.06-.03.11-.075.143-.133 0-.053-.015-.08-.053-.107l.016-.005z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint179_radial_1416_98812)"
        d="M30.356 72c-.128.021-.254.05-.379.085-.112 0-.235.064-.368.107-.133.042-.25.09-.368.138l.395.23.128-.048.15-.048a8.37 8.37 0 01.634-.198c.174-.051.353-.089.533-.112.167-.021.335-.021.502 0 .16.03.315.086.458.166a.74.74 0 01.33.325.485.485 0 010 .347c-.059.131-.144.249-.25.346-.128.124-.27.233-.421.326l.533.31-.442.255-.534-.315a6.94 6.94 0 01-.88.368 6.573 6.573 0 01-.912.256l-.288-.704c.15-.026.304-.064.464-.1l.448-.129c.166-.053.32-.117.47-.181l-.39-.224-.427.15c-.224.068-.42.127-.602.17-.163.039-.329.062-.496.07a1.32 1.32 0 01-.379.01 1.306 1.306 0 01-.363-.139.74.74 0 01-.32-.304.49.49 0 01-.042-.336.876.876 0 01.192-.357 2.05 2.05 0 01.384-.342l-.443-.256.443-.256.448.262c.139-.064.272-.123.41-.176l.411-.144.395-.112.346-.096.23.656zm-1.488.704a.257.257 0 00.16.032c.084-.008.166-.026.245-.054l-.336-.192c-.139.107-.139.176-.07.224v-.01zM31 73.06a.267.267 0 00-.17 0c-.089.012-.176.03-.262.053l.326.192c.06-.03.11-.075.143-.133 0-.053-.015-.08-.053-.107l.016-.005z"
      ></path>
      <path
        fill="url(#paint180_linear_1416_98812)"
        d="M36.58 70.932H23.375v1.914c0 2.134 2.955 3.846 6.603 3.846 3.648 0 6.602-1.723 6.602-3.846v-1.914z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint181_linear_1416_98812)"
        d="M29.978 76.265c-3.648 0-6.603-1.722-6.603-3.845v.411c0 2.133 2.955 3.845 6.603 3.845 3.648 0 6.602-1.723 6.602-3.845v-.411c0 2.123-2.954 3.845-6.602 3.845z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#FDD65B"
          d="M32 76.495l.187-.043v-4.88H32v4.923zM32.832 76.298l.181-.054v-4.672h-.181v4.726zM33.66 76.026l.187-.08v-4.374h-.187v4.454zM31.168 76.612h.187v-5.04h-.187v5.04zM35.316 75.087l.187-.155v-3.36h-.187v3.515zM36.148 74.19c.07-.102.13-.211.182-.324v-2.294h-.182v2.619zM34.492 75.636l.181-.101v-3.963h-.18v4.064zM30.34 76.666h.186v-5.094h-.186v5.094zM29.508 76.666h.187v-5.094h-.187v5.094zM27.852 76.468l.186.043v-4.939h-.186v4.896zM28.684 76.602h.186v-5.03h-.186v5.03zM27.023 76.266l.182.053v-4.747h-.182v4.694zM23.707 74.03c.055.102.115.2.181.294v-2.752h-.181v2.459zM24.535 75.007l.187.144v-3.579h-.187v3.435zM26.191 75.983l.187.07v-4.48h-.187v4.41zM25.367 75.583l.181.096v-4.107h-.18v4.01z"
        ></path>
      </g>
      <path
        fill="url(#paint182_linear_1416_98812)"
        d="M36.58 70.931c0 2.134-2.954 3.846-6.602 3.846s-6.603-1.712-6.603-3.846c0-2.133 2.955-3.845 6.603-3.845 3.648 0 6.602 1.712 6.602 3.845z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint183_radial_1416_98812)"
        d="M29.977 74.665c-3.573 0-6.47-1.653-6.592-3.733a1.06 1.06 0 000 .133c0 2.133 2.955 3.845 6.603 3.845 3.648 0 6.602-1.722 6.602-3.845v-.133c-.144 2.101-3.045 3.733-6.613 3.733z"
      ></path>
      <path
        fill="url(#paint184_linear_1416_98812)"
        d="M34.912 70.933c0 1.6-2.208 2.875-4.934 2.875-2.725 0-4.912-1.275-4.912-2.875s2.214-2.874 4.94-2.874c2.724 0 4.906 1.274 4.906 2.874z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint185_radial_1416_98812)"
        d="M30.143 68.212c2.634 0 4.8 1.205 4.922 2.72a1.535 1.535 0 000-.155c0-1.6-2.208-2.875-4.933-2.875-2.725 0-4.939 1.286-4.939 2.875a1.535 1.535 0 000 .155c.16-1.515 2.31-2.72 4.95-2.72z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint186_linear_1416_98812)"
        d="M29.977 68.378c2.634 0 4.8 1.205 4.922 2.72a1.478 1.478 0 000-.155c0-1.6-2.208-2.875-4.933-2.875-2.726 0-4.902 1.264-4.902 2.864a1.476 1.476 0 000 .155c.128-1.504 2.273-2.71 4.913-2.71z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint187_radial_1416_98812)"
        d="M27.2 70.931c1.323.358 1.91 2.443 1.307 4.651-.603 2.208-2.133 3.734-3.477 3.36-1.344-.373-1.91-2.448-1.312-4.656.597-2.208 2.144-3.744 3.482-3.355z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint188_radial_1416_98812)"
        d="M33.445 67.236c1.483.533 2.486 1.515 2.235 2.245-.25.73-1.659.923-3.141.416-1.483-.506-2.486-1.51-2.235-2.245.25-.736 1.659-.917 3.141-.416z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
        fill="url(#paint189_linear_1416_98812)"
        d="M31.72 70.4l1.867.341c.315.053.384.293.118.4l-1.6.65c-.107.044-.166.113-.166.188l.06 1.088c0 .186-.369.298-.63.186l-1.6-.677a.635.635 0 00-.363-.037l-1.845.357c-.31.064-.608-.107-.502-.288l.62-1.067a.15.15 0 00-.013-.17.148.148 0 00-.047-.038l-1.173-.906c-.197-.155 0-.369.32-.363h1.952a.533.533 0 00.33-.096l1.12-.918a.534.534 0 01.7.065l.586 1.066a.362.362 0 00.267.219z"
      ></path>
      <path
        fill="url(#paint190_linear_1416_98812)"
        d="M31.72 70.164l1.867.336c.314.058.384.299.117.405l-1.6.65c-.107.043-.165.113-.165.188l.032 1.125c0 .192-.368.299-.63.187l-1.6-.678a.636.636 0 00-.362-.032l-1.846.358c-.309.058-.608-.112-.5-.288l.618-1.067a.15.15 0 00-.013-.17.149.149 0 00-.046-.038l-1.173-.907c-.198-.15 0-.362.32-.362h1.952a.533.533 0 00.33-.091l1.12-.923a.533.533 0 01.7.064l.586 1.067a.385.385 0 00.293.176z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint191_radial_1416_98812)"
        d="M31.72 70.164l1.867.336c.314.058.384.299.117.405l-1.6.65c-.107.043-.165.113-.165.188l.032 1.125c0 .192-.368.299-.63.187l-1.6-.678a.636.636 0 00-.362-.032l-1.846.358c-.309.058-.608-.112-.5-.288l.618-1.067a.15.15 0 00-.013-.17.149.149 0 00-.046-.038l-1.173-.907c-.198-.15 0-.362.32-.362h1.952a.533.533 0 00.33-.091l1.12-.923a.533.533 0 01.7.064l.586 1.067a.385.385 0 00.293.176z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1416_98812"
          x1="50.136"
          x2="36.273"
          y1="3.661"
          y2="3.338"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#EFA4A7"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1416_98812"
          x1="46.288"
          x2="46.288"
          y1="3.658"
          y2="58.981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6CCF2"></stop>
          <stop offset="1" stopColor="#9198C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1416_98812"
          x1="40.045"
          x2="62.65"
          y1="7.163"
          y2="28.541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <radialGradient
          id="paint3_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(37.839 17.264) scale(19.9733)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint4_linear_1416_98812"
          x1="39.505"
          x2="27.691"
          y1="19.209"
          y2="19.209"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1416_98812"
          x1="37.202"
          x2="37.202"
          y1="19.227"
          y2="64.043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6CCF2"></stop>
          <stop offset="1" stopColor="#9198C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1416_98812"
          x1="30.959"
          x2="49.082"
          y1="22.066"
          y2="43.223"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <radialGradient
          id="paint7_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(28.753 30.245) scale(16.48)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint8_linear_1416_98812"
          x1="30.203"
          x2="18.395"
          y1="35.359"
          y2="35.359"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_1416_98812"
          x1="27.901"
          x2="27.901"
          y1="35.377"
          y2="68.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6CCF2"></stop>
          <stop offset="1" stopColor="#9198C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_1416_98812"
          x1="21.662"
          x2="34.152"
          y1="37.504"
          y2="56.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <radialGradient
          id="paint11_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(19.45 43.633) scale(12.848)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint12_linear_1416_98812"
          x1="21.02"
          x2="9.211"
          y1="53.043"
          y2="53.043"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_1416_98812"
          x1="19.046"
          x2="13.75"
          y1="64.816"
          y2="73.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5513AB"></stop>
          <stop offset="1" stopColor="#BE3BFF"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_1416_98812"
          x1="18.718"
          x2="18.718"
          y1="53.06"
          y2="74.677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6CCF2"></stop>
          <stop offset="1" stopColor="#9198C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1416_98812"
          x1="12.479"
          x2="18.722"
          y1="54.43"
          y2="69.543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <radialGradient
          id="paint16_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(10.267 58.373) scale(9.232)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint17_linear_1416_98812"
          x1="11.809"
          x2="0"
          y1="66.68"
          y2="66.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_1416_98812"
          x1="9.508"
          x2="9.508"
          y1="66.697"
          y2="79.919"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6CCF2"></stop>
          <stop offset="1" stopColor="#9198C8"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_1416_98812"
          x1="3.268"
          x2="5.838"
          y1="67.535"
          y2="77.707"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD4E7"></stop>
          <stop offset="1" stopColor="#EEEFFF"></stop>
        </linearGradient>
        <radialGradient
          id="paint20_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(7.06133 0 0 7.06134 1.056 69.945)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint21_linear_1416_98812"
          x1="43.611"
          x2="56.609"
          y1="65.892"
          y2="65.892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="64.157"
          y2="64.157"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="64.909"
          y2="64.909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="49.026"
          y2="62.023"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint25_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 64.132) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint26_linear_1416_98812"
          x1="55.472"
          x2="45.819"
          y1="55.966"
          y2="65.683"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint27_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 58.152) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint28_linear_1416_98812"
          x1="57.254"
          x2="48.139"
          y1="53.859"
          y2="63.032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint29_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 48.097 61)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint30_linear_1416_98812"
          x1="47.702"
          x2="52.625"
          y1="61.342"
          y2="61.342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint31_linear_1416_98812"
          x1="54.988"
          x2="50.79"
          y1="58.515"
          y2="60.803"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint32_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.796 61.502) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint33_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="62.074"
          y2="62.074"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint34_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="62.831"
          y2="62.831"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint35_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="46.945"
          y2="59.942"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint36_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 62.052) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint37_linear_1416_98812"
          x1="55.472"
          x2="45.819"
          y1="53.884"
          y2="63.601"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint38_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 56.075) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint39_linear_1416_98812"
          x1="57.253"
          x2="48.138"
          y1="51.777"
          y2="60.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint40_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 48.112 58.937)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint41_linear_1416_98812"
          x1="47.702"
          x2="52.624"
          y1="59.259"
          y2="59.259"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint42_linear_1416_98812"
          x1="54.988"
          x2="50.79"
          y1="56.432"
          y2="58.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint43_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.796 59.419) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint44_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="59.88"
          y2="59.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint45_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="60.632"
          y2="60.632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint46_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="44.746"
          y2="57.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint47_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 59.856) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint48_linear_1416_98812"
          x1="55.471"
          x2="45.817"
          y1="51.688"
          y2="61.406"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint49_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 53.876) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint50_linear_1416_98812"
          x1="57.253"
          x2="48.138"
          y1="49.582"
          y2="58.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint51_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 48.128 56.765)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint52_linear_1416_98812"
          x1="47.7"
          x2="52.623"
          y1="57.065"
          y2="57.065"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint53_linear_1416_98812"
          x1="54.988"
          x2="50.79"
          y1="54.239"
          y2="56.527"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint54_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.796 57.225) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint55_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="57.653"
          y2="57.653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint56_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="58.405"
          y2="58.405"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint57_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="42.521"
          y2="55.519"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint58_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 57.627) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint59_linear_1416_98812"
          x1="55.471"
          x2="45.817"
          y1="49.462"
          y2="59.179"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint60_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 51.653) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint61_linear_1416_98812"
          x1="57.253"
          x2="48.138"
          y1="47.355"
          y2="56.528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint62_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 48.143 54.56)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint63_linear_1416_98812"
          x1="46.564"
          x2="54.057"
          y1="55.007"
          y2="55.007"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint64_linear_1416_98812"
          x1="42.729"
          x2="51.454"
          y1="61.057"
          y2="53.542"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint65_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(51.684 53.558) scale(3.06133)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint66_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="55.614"
          y2="55.614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint67_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="56.366"
          y2="56.366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint68_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="40.484"
          y2="53.481"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint69_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 55.586) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint70_linear_1416_98812"
          x1="55.472"
          x2="45.819"
          y1="47.423"
          y2="57.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint71_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 49.614) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint72_linear_1416_98812"
          x1="57.254"
          x2="48.139"
          y1="45.316"
          y2="54.489"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint73_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 48.158 52.541)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint74_linear_1416_98812"
          x1="47.702"
          x2="52.625"
          y1="52.798"
          y2="52.798"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint75_linear_1416_98812"
          x1="54.988"
          x2="50.79"
          y1="49.971"
          y2="52.259"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint76_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.796 52.958) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint77_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="53.53"
          y2="53.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint78_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="54.287"
          y2="54.287"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint79_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="38.399"
          y2="51.396"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint80_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 53.507) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint81_linear_1416_98812"
          x1="55.472"
          x2="45.819"
          y1="45.337"
          y2="55.054"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint82_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 47.53) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint83_linear_1416_98812"
          x1="57.254"
          x2="48.139"
          y1="43.23"
          y2="52.404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint84_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-70.346 59.9 -8.94) scale(1.39305 2.87435)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint85_linear_1416_98812"
          x1="47.702"
          x2="52.624"
          y1="50.714"
          y2="50.714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint86_linear_1416_98812"
          x1="54.988"
          x2="50.79"
          y1="47.888"
          y2="50.181"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint87_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.796 50.874) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint88_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="51.337"
          y2="51.337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint89_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="52.089"
          y2="52.089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint90_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="36.201"
          y2="49.204"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint91_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 51.312) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint92_linear_1416_98812"
          x1="55.471"
          x2="45.817"
          y1="43.145"
          y2="52.863"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint93_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 45.333) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint94_linear_1416_98812"
          x1="57.253"
          x2="48.138"
          y1="41.039"
          y2="50.207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint95_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 48.189 48.307)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint96_linear_1416_98812"
          x1="47.7"
          x2="52.623"
          y1="48.52"
          y2="48.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint97_linear_1416_98812"
          x1="54.988"
          x2="50.79"
          y1="45.696"
          y2="47.984"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint98_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(46.796 48.682) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint99_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="49.107"
          y2="49.107"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint100_linear_1416_98812"
          x1="43.627"
          x2="56.624"
          y1="49.858"
          y2="49.858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint101_linear_1416_98812"
          x1="62.368"
          x2="49.45"
          y1="33.978"
          y2="46.975"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint102_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(47.329 49.082) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint103_linear_1416_98812"
          x1="55.471"
          x2="45.817"
          y1="40.915"
          y2="50.632"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint104_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(52.49 43.108) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint105_linear_1416_98812"
          x1="57.253"
          x2="48.138"
          y1="38.808"
          y2="47.982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint106_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.12512 -4.03168 2.43155 .67857 35.252 36.252)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint107_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 48.204 46.101)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint108_linear_1416_98812"
          x1="46.564"
          x2="54.057"
          y1="46.464"
          y2="46.464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint109_linear_1416_98812"
          x1="42.731"
          x2="51.456"
          y1="52.51"
          y2="44.995"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint110_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(51.685 45.011) scale(3.06133)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint111_linear_1416_98812"
          x1="33.513"
          x2="46.511"
          y1="71.749"
          y2="71.749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint112_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="70.017"
          y2="70.017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint113_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="70.769"
          y2="70.769"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint114_linear_1416_98812"
          x1="52.27"
          x2="39.353"
          y1="54.886"
          y2="67.884"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint115_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(37.231 69.989) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint116_linear_1416_98812"
          x1="45.373"
          x2="35.719"
          y1="61.825"
          y2="71.542"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint117_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(42.394 64.016) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint118_linear_1416_98812"
          x1="47.151"
          x2="38.042"
          y1="59.718"
          y2="68.892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint119_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 37.813 66.68)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint120_linear_1416_98812"
          x1="37.603"
          x2="42.526"
          y1="67.201"
          y2="67.201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint121_linear_1416_98812"
          x1="44.888"
          x2="40.691"
          y1="64.374"
          y2="66.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint122_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(4.40533 0 0 4.40534 36.696 67.36)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint123_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="67.936"
          y2="67.936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint124_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="68.686"
          y2="68.686"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint125_linear_1416_98812"
          x1="52.27"
          x2="39.353"
          y1="52.799"
          y2="65.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint126_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(37.231 67.91) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint127_linear_1416_98812"
          x1="45.374"
          x2="35.721"
          y1="59.737"
          y2="69.454"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint128_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(42.394 61.928) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint129_linear_1416_98812"
          x1="47.151"
          x2="38.042"
          y1="57.63"
          y2="66.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint130_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 37.827 64.615)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint131_linear_1416_98812"
          x1="37.603"
          x2="42.526"
          y1="65.115"
          y2="65.115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint132_linear_1416_98812"
          x1="44.89"
          x2="40.692"
          y1="62.286"
          y2="64.579"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint133_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(36.698 65.273) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint134_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="65.737"
          y2="65.737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint135_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="66.491"
          y2="66.491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint136_linear_1416_98812"
          x1="52.27"
          x2="39.353"
          y1="50.607"
          y2="63.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint137_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(37.231 65.71) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint138_linear_1416_98812"
          x1="45.373"
          x2="35.719"
          y1="57.546"
          y2="67.263"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint139_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(42.394 59.732) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint140_linear_1416_98812"
          x1="47.151"
          x2="38.042"
          y1="55.439"
          y2="64.607"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint141_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 37.842 62.443)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint142_linear_1416_98812"
          x1="37.603"
          x2="42.526"
          y1="62.922"
          y2="62.922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint143_linear_1416_98812"
          x1="44.888"
          x2="40.691"
          y1="60.096"
          y2="62.384"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint144_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(36.696 63.082) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint145_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="63.525"
          y2="63.525"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint146_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="64.276"
          y2="64.276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint147_linear_1416_98812"
          x1="52.27"
          x2="39.353"
          y1="48.389"
          y2="61.392"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint148_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(37.231 63.497) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint149_linear_1416_98812"
          x1="45.374"
          x2="35.721"
          y1="55.328"
          y2="65.045"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint150_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(42.394 57.52) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint151_linear_1416_98812"
          x1="47.149"
          x2="38.04"
          y1="53.226"
          y2="62.394"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint152_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 37.86 60.251)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint153_linear_1416_98812"
          x1="37.604"
          x2="42.527"
          y1="60.708"
          y2="60.708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint154_linear_1416_98812"
          x1="44.89"
          x2="40.692"
          y1="57.882"
          y2="60.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint155_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(36.698 60.864) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint156_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="61.493"
          y2="61.493"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint157_linear_1416_98812"
          x1="33.529"
          x2="46.526"
          y1="62.245"
          y2="62.245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint158_linear_1416_98812"
          x1="52.27"
          x2="39.353"
          y1="46.362"
          y2="59.359"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint159_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(37.231 61.468) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint160_linear_1416_98812"
          x1="45.374"
          x2="35.721"
          y1="53.302"
          y2="63.019"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint161_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(42.394 55.495) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint162_linear_1416_98812"
          x1="47.151"
          x2="38.041"
          y1="51.195"
          y2="60.368"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint163_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.12512 -4.03168 2.43155 .67857 24.91 48.709)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint164_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-70.346 60.26 2.25) scale(1.39305 2.87435)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint165_linear_1416_98812"
          x1="36.468"
          x2="43.961"
          y1="58.849"
          y2="58.849"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint166_linear_1416_98812"
          x1="32.632"
          x2="41.357"
          y1="64.896"
          y2="57.382"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint167_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(41.581 57.398) scale(3.06133)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint168_linear_1416_98812"
          x1="23.419"
          x2="36.417"
          y1="77.656"
          y2="77.656"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint169_linear_1416_98812"
          x1="23.434"
          x2="36.436"
          y1="75.93"
          y2="75.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint170_linear_1416_98812"
          x1="23.434"
          x2="36.436"
          y1="76.681"
          y2="76.681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint171_linear_1416_98812"
          x1="42.18"
          x2="29.263"
          y1="60.793"
          y2="73.796"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint172_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(27.14 75.904) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint173_linear_1416_98812"
          x1="35.284"
          x2="25.626"
          y1="67.732"
          y2="77.449"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint174_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(32.303 69.923) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint175_linear_1416_98812"
          x1="37.061"
          x2="27.946"
          y1="65.63"
          y2="74.799"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint176_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46854 -1.3119 2.7069 .96675 27.535 72.412)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint177_linear_1416_98812"
          x1="27.51"
          x2="32.433"
          y1="73.114"
          y2="73.114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint178_linear_1416_98812"
          x1="34.793"
          x2="30.596"
          y1="70.288"
          y2="72.576"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint179_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(26.601 73.27) scale(4.40533)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint180_linear_1416_98812"
          x1="23.434"
          x2="36.436"
          y1="73.796"
          y2="73.796"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint181_linear_1416_98812"
          x1="23.434"
          x2="36.436"
          y1="74.548"
          y2="74.548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint182_linear_1416_98812"
          x1="42.18"
          x2="29.263"
          y1="58.659"
          y2="71.662"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint183_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(27.14 73.769) scale(8.29867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint184_linear_1416_98812"
          x1="35.285"
          x2="25.626"
          y1="65.605"
          y2="75.323"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint185_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(32.303 67.79) scale(3.65333)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint186_linear_1416_98812"
          x1="37.059"
          x2="27.945"
          y1="63.498"
          y2="72.666"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <radialGradient
          id="paint187_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.12512 -4.03168 2.43155 .67857 14.578 61.086)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint188_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46853 -1.3119 2.7069 .96675 27.55 70.302)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint189_linear_1416_98812"
          x1="26.371"
          x2="33.87"
          y1="71.147"
          y2="71.147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBB96"></stop>
          <stop offset="0.23" stopColor="#FFFBC9"></stop>
          <stop offset="0.54" stopColor="#F9B673"></stop>
          <stop offset="0.64" stopColor="#F9B876"></stop>
          <stop offset="0.72" stopColor="#FABE81"></stop>
          <stop offset="0.81" stopColor="#FCC993"></stop>
          <stop offset="0.86" stopColor="#FED2A3"></stop>
          <stop offset="0.97" stopColor="#FFC28C"></stop>
        </linearGradient>
        <linearGradient
          id="paint190_linear_1416_98812"
          x1="22.541"
          x2="31.261"
          y1="77.198"
          y2="69.684"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFBA78"></stop>
          <stop offset="0.4" stopColor="#FFC987"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <radialGradient
          id="paint191_radial_1416_98812"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(31.49 69.7) scale(3.06133)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F49587"></stop>
          <stop offset="0.12" stopColor="#BD7368"></stop>
          <stop offset="0.24" stopColor="#8B554D"></stop>
          <stop offset="0.36" stopColor="#603B35"></stop>
          <stop offset="0.48" stopColor="#3E2622"></stop>
          <stop offset="0.61" stopColor="#231513"></stop>
          <stop offset="0.74" stopColor="#0F0908"></stop>
          <stop offset="0.86" stopColor="#040202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
      </defs>
    </svg>
  </span>
);

export const IconBenefitProduct6 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="68" height="80" fill="none" viewBox="0 0 68 80">
      <path
        fill="url(#paint0_linear_1416_99425)"
        d="M34.245 0L3.276 8.592C-3.363 35.496-.74 64.078 18.857 76.807 43.36 65.07 57.37 36.84 61.525 9.901L34.245 0z"
      ></path>
      <path
        fill="url(#paint1_linear_1416_99425)"
        d="M63.97 28.407c.065-.205.124-.416.182-.628.165-.587.323-1.12.476-1.684l.21-.78c.054-.212.118-.43.171-.646l.135-.605c.135-.552.276-1.103.405-1.66.088-.365.176-.734.258-1.098.13-.587.253-1.133.37-1.696.076-.352.153-.705.223-1.05.121-.615.239-1.231.352-1.85.059-.299.118-.587.17-.892.165-.91.317-1.82.452-2.729l-5.869-3.187c-.14.912-.293 1.822-.458 2.73-.052.293-.111.586-.17.892-.111.586-.229 1.226-.352 1.842-.07.353-.147.705-.223 1.05a60.75 60.75 0 01-.37 1.697c-.082.37-.17.734-.258 1.103-.129.552-.27 1.104-.405 1.661-.111.423-.217.851-.328 1.274l-.194.74c-.153.557-.311 1.12-.475 1.684-.06.211-.118.416-.182.628-.224.763-.452 1.52-.693 2.277-.041.135-.088.264-.13.393a128.683 128.683 0 01-1.59 4.584c-.34.933-.704 1.854-1.074 2.782-.14.352-.293.71-.44 1.062-.194.47-.387.939-.587 1.403-.158.37-.328.733-.493 1.103-.164.37-.405.91-.587 1.362l-.587 1.262c-.158.328-.316.663-.48.991-.218.44-.44.875-.664 1.31-.158.316-.317.633-.481.944-.323.587-.657 1.232-.992 1.837-.053.094-.106.188-.153.282-.428.745-.833 1.432-1.25 2.124-.1.17-.2.34-.305.505-.305.51-.587 1.015-.933 1.52l-.417.657c-.317.493-.64.986-.968 1.468l-.317.48a79.335 79.335 0 01-1.291 1.838 74.727 74.727 0 01-1.925 2.559l-.528.657a79.216 79.216 0 01-1.544 1.872l-.699.816-.399.446c-.45.505-.907 1.004-1.373 1.497l-.17.182a80.928 80.928 0 01-1.573 1.596l-.422.405c-.435.422-.87.833-1.315 1.238l-.393.37c-.552.499-1.115.986-1.679 1.467l-.428.352c-.452.37-.904.74-1.362 1.098l-.587.458c-.399.305-.804.587-1.209.904l-.775.551c-.41.294-.833.587-1.25.857l-.727.481c-.288.188-.587.364-.875.546-.475.294-.95.587-1.432.869-.317.188-.634.364-.957.54a64.05 64.05 0 01-1.396.763c-.587.305-1.174.587-1.761.898L24.748 80c.458-.223.915-.446 1.367-.68.135-.07.27-.153.411-.223.47-.247.933-.505 1.397-.763l.957-.534c.48-.282.956-.587 1.432-.875.217-.135.446-.264.669-.405l.205-.14c.247-.153.487-.324.728-.482.417-.282.84-.587 1.25-.857l.775-.552c.223-.17.458-.328.686-.498.23-.17.347-.27.523-.405l.587-.458c.457-.358.91-.728 1.361-1.098l.429-.352.135-.111a84.874 84.874 0 001.543-1.356l.393-.364c.259-.235.517-.47.763-.704l.552-.534.423-.411a62.555 62.555 0 001.514-1.538l.059-.058.17-.182c.465-.493.923-.992 1.373-1.497l.393-.446.352-.393c.118-.135.23-.282.347-.423a69.972 69.972 0 001.55-1.866c.11-.147.234-.276.345-.423.112-.146.118-.158.182-.24.658-.84 1.303-1.69 1.925-2.56l.07-.087c.412-.587.817-1.174 1.222-1.761l.316-.475c.2-.3.405-.587.587-.892l.37-.587c.14-.218.282-.435.417-.658.317-.5.628-1.005.933-1.514l.305-.505.1-.164c.381-.64.751-1.285 1.115-1.937.047-.094.1-.188.153-.281.293-.535.587-1.069.874-1.609l.117-.228c.165-.311.323-.628.482-.945.223-.435.452-.869.663-1.31.164-.328.323-.656.481-.99.159-.336.288-.588.429-.893l.17-.37c.205-.452.41-.904.587-1.361l.493-1.104c.2-.463.393-.933.587-1.402.117-.276.24-.587.352-.84l.088-.223c.37-.921.733-1.848 1.074-2.782.04-.1.07-.2.111-.299.305-.84.587-1.678.892-2.524 0-.093.065-.187.1-.287.165-.493.329-.986.487-1.48.041-.134.082-.263.13-.392.246-.74.475-1.503.721-2.266z"
      ></path>
      <path
        fill="url(#paint2_linear_1416_99425)"
        d="M33.336 4.555L6.221 12.073C3.521 24.445 3.1 36.206 4.99 46.253c2.154 11.451 7.148 20.067 14.854 25.648 9.86-5.188 18.247-13.498 24.95-24.767 5.868-9.877 10.153-21.55 12.412-33.934L33.336 4.555z"
      ></path>
      <path
        fill="url(#paint3_linear_1416_99425)"
        d="M38.096 23.957l3.022 4.748-19.954 18.646-8.105-12.724 4.889-4.572 5.082 7.976 15.066-14.074z"
      ></path>
      <path
        fill="url(#paint4_linear_1416_99425)"
        d="M42.505 8.44c-5.693 12.007-12.155 23.722-20.46 34.133A130.758 130.758 0 018.723 56.87a34.628 34.628 0 0011.15 14.409c9.65-5.153 17.878-13.364 24.457-24.415 5.757-9.667 9.977-21.176 12.266-33.319L42.505 8.44z"
        opacity="0.3"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1416_99425"
          x1="57.335"
          x2="0"
          y1="38.185"
          y2="38.185"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1416_99425"
          x1="68.466"
          x2="-16.196"
          y1="47.38"
          y2="46.605"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#475467"></stop>
          <stop offset="1" stopColor="#98A2B3"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1416_99425"
          x1="44.628"
          x2="19.262"
          y1="54.781"
          y2="13.834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1D0EB"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1416_99425"
          x1="42.582"
          x2="14.405"
          y1="37.078"
          y2="47.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#F97066"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1416_99425"
          x1="45.979"
          x2="33.296"
          y1="53.901"
          y2="36.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1F9FF"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const IconBenefitProduct7 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="none" viewBox="0 0 80 80">
      <g fill="#000" opacity="0.2">
        <path
          d="M24.652 37.012a8.835 8.835 0 016.257-.878 7.317 7.317 0 011.812.715l38.661 22.317c1.34.766 2.022 1.984 1.941 3.306a3.797 3.797 0 01-.232 1.071c-.338.945-1.294 1.952-2.38 2.578l-21.718 12.54c-.305.174-.62.33-.942.466a9.25 9.25 0 01-3.435.677 7.156 7.156 0 01-3.614-.856L2.2 56.542C.862 55.774.177 54.553.265 53.23c.024-.314.085-.624.182-.923.311-1.001 1.302-2.072 2.442-2.728l21.763-12.567z"
          opacity="0.09"
        ></path>
        <path
          d="M24.753 37.18a8.635 8.635 0 014.422-1.07c1.264.023 2.5.364 3.598.99l38.512 22.22c1.325.766 1.946 1.976 1.783 3.267-.053.35-.15.693-.287 1.02-.329.838-1.43 1.909-2.41 2.473L48.974 78.441c-.3.172-.61.328-.926.466a9.104 9.104 0 01-3.376.693 7.062 7.062 0 01-3.566-.827L2.299 56.376C.96 55.607.355 54.389.529 53.096c.048-.304.127-.603.236-.892.31-.888 1.459-2.029 2.484-2.62L24.753 37.18z"
          opacity="0.18"
        ></path>
        <path
          d="M24.849 37.348a8.425 8.425 0 014.412-1.036c.607.028 1.21.123 1.796.284a9.64 9.64 0 011.775.76l38.364 22.149c1.317.76 1.874 1.965 1.625 3.212a5.08 5.08 0 01-.342.972c-.316.736-1.567 1.874-2.437 2.37L48.957 78.23c-.222.13-.67.362-.913.464a8.93 8.93 0 01-3.32.71 6.858 6.858 0 01-3.512-.804L2.395 56.22C1.07 55.454.521 54.239.789 52.978c.07-.292.165-.577.283-.852.303-.782 1.607-1.989 2.528-2.514l21.249-12.264z"
          opacity="0.27"
        ></path>
        <path
          d="M24.942 37.518a7.955 7.955 0 016.174-.69c.606.212 1.193.473 1.756.781L71.09 59.675c1.31.758 1.796 1.954 1.465 3.178a5.942 5.942 0 01-.397.92c-.3.638-1.705 1.827-2.465 2.266L48.919 78.032c-.193.113-.682.37-.894.464a8.869 8.869 0 01-3.264.722 6.709 6.709 0 01-3.464-.776L2.49 56.039c-1.323-.763-1.794-1.976-1.435-3.212.097-.274.21-.542.337-.803.29-.672 1.772-1.947 2.57-2.41l20.981-12.096z"
          opacity="0.36"
        ></path>
        <path
          d="M25.043 37.683a7.686 7.686 0 016.145-.624c.597.227 1.177.496 1.737.803l38.067 21.98c1.307.752 1.727 1.944 1.307 3.135-.132.3-.282.59-.45.87-.268.536-1.842 1.786-2.493 2.163L48.895 77.822c-.167.096-.697.38-.879.46a8.692 8.692 0 01-3.212.737 6.533 6.533 0 01-3.414-.744L2.571 55.869c-1.32-.763-1.727-1.97-1.269-3.17.096-.254.268-.484.388-.752.268-.568 1.928-1.906 2.613-2.3l20.74-11.964z"
          opacity="0.45"
        ></path>
        <path
          d="M25.14 37.853a7.903 7.903 0 014.371-.94c.595.059 1.18.185 1.746.377.586.244 1.16.52 1.716.828l37.922 21.894c1.299.75 1.66 1.933 1.146 3.092a3.311 3.311 0 01-.506.822c-.153.476-1.976 1.743-2.52 2.056L48.868 77.614c-.136.08-.712.391-.862.458-.991.45-2.06.706-3.148.752a6.381 6.381 0 01-3.36-.717L2.677 55.702c-1.317-.76-1.657-1.966-1.1-3.133.117-.254.264-.494.44-.712.139-.503 2.085-1.874 2.652-2.19l20.47-11.814z"
          opacity="0.55"
        ></path>
        <path
          d="M25.237 38.015a7.745 7.745 0 014.361-.91c.59.071 1.17.209 1.73.41.238.077 1.502.736 1.697.848L70.8 60.172c1.294.746 1.593 1.924.986 3.052a3.41 3.41 0 01-.56.77c-.123.38-2.112 1.7-2.546 1.952L48.845 77.4a25.97 25.97 0 01-.846.455c-.974.45-2.024.711-3.095.769a6.243 6.243 0 01-3.312-.688L2.772 55.529c-1.311-.76-1.592-1.962-.934-3.1.137-.241.302-.465.493-.667.11-.404 2.24-1.823 2.696-2.085l20.21-11.662z"
          opacity="0.64"
        ></path>
        <path
          d="M25.33 38.19a6.961 6.961 0 016.065-.441c.176.058 1.531.784 1.678.87L70.701 60.34c1.285.745 1.532 1.92.825 3.01-.17.266-.377.508-.613.72-.094.286-2.249 1.66-2.576 1.85L48.815 77.19c-.083.049-.741.413-.83.456a8.321 8.321 0 01-3.036.795 6.075 6.075 0 01-3.263-.661L2.866 55.375c-1.298-.76-1.528-1.97-.754-3.07.154-.229.334-.439.535-.627.086-.303 2.41-1.78 2.741-1.976L25.331 38.19z"
          opacity="0.73"
        ></path>
        <path
          d="M25.432 38.358a7.386 7.386 0 014.334-.846c.583.09 1.152.248 1.698.471.12.043 1.563.836 1.662.895l37.48 21.637c1.28.739 1.473 1.914.668 2.966a3.666 3.666 0 01-.667.672c-.062.19-2.385 1.606-2.605 1.743L48.793 76.987c-.053.03-.752.426-.803.453a8.205 8.205 0 01-2.977.803 5.933 5.933 0 01-3.213-.634L2.976 55.198c-1.307-.755-1.476-1.963-.6-3.028.175-.215.374-.41.591-.581.057-.204 2.555-1.738 2.782-1.874l19.683-11.357z"
          opacity="0.82"
        ></path>
        <path
          d="M25.528 38.523a7.269 7.269 0 014.32-.804c.58.102 1.145.271 1.685.504.058.024 1.606.888 1.643.915l37.331 21.554c1.274.737 1.414 1.912.509 2.924a3.917 3.917 0 01-.723.62c-.032.095-2.525 1.578-2.632 1.64L48.763 76.784c-.027.016-.766.439-.803.452a8.032 8.032 0 01-2.924.804c-1.178.072-2.329-.126-3.161-.608L3.055 55.027c-1.304-.752-1.416-1.967-.433-2.99.195-.2.412-.38.645-.535.026-.1 2.709-1.695 2.824-1.762l19.437-11.218z"
          opacity="0.91"
        ></path>
        <path d="M41.978 77.265L3.158 54.859c-1.531-.883-1.338-2.43.431-3.45l22.023-12.717c1.77-1.02 4.447-1.133 5.978-.246L70.41 60.85c1.53.884 1.338 2.428-.429 3.451L47.956 77.019c-1.77 1.02-4.447 1.132-5.978.246z"></path>
      </g>
      <path
        fill="url(#paint0_linear_1416_103154)"
        d="M41.977 77.231L3.158 54.826c-.672-.394-1.017-.921-1.017-1.473v-1.922c0-.67.508.495 1.464-.056l22.023-12.717c1.77-1.023 4.447-1.132 5.978-.249l38.82 22.406c.51.297.883-.959 1.014-.56.045.134.016 1.893.019 2.03.016.687-.482 1.416-1.462 1.983L47.972 76.982c-1.786 1.023-4.463 1.133-5.995.25z"
      ></path>
      <path
        fill="url(#paint1_linear_1416_103154)"
        d="M41.978 75.343L3.158 52.938c-1.531-.884-1.338-2.431.431-3.451L25.612 36.77c1.77-1.02 4.447-1.132 5.978-.246l38.82 22.405c1.53.884 1.338 2.428-.429 3.451L47.956 75.097c-1.77 1.02-4.447 1.132-5.978.246z"
      ></path>
      <path
        fill="url(#paint2_linear_1416_103154)"
        d="M44.574 75.168a4.509 4.509 0 01-2.208-.496L3.546 52.27c-.24-.142-.648-.434-.648-.83 0-.397.405-.892 1.071-1.28l22.026-12.717a6.157 6.157 0 012.993-.741 4.551 4.551 0 012.211.492L70.02 59.6c.24.139.647.433.647.83 0 .396-.404.891-1.07 1.28L47.566 74.425a6.16 6.16 0 01-2.993.742z"
      ></path>
      <path
        fill="#fff"
        d="M69.982 62.06L47.956 74.776c-1.77 1.023-4.446 1.133-5.978.247L3.16 52.617c-.634-.367-.97-.846-1.023-1.357-.08.626.268 1.237 1.023 1.678l38.82 22.406c1.53.886 4.208.774 5.977-.246l22.026-12.72c1.033-.597 1.526-1.373 1.45-2.093-.08.626-.57 1.266-1.45 1.775z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
        fill="url(#paint3_radial_1416_103154)"
        d="M26.606 50.24c5.06-1.74 8.33-5.574 7.301-8.562-1.027-2.988-5.962-4-11.022-2.259-5.06 1.74-8.33 5.574-7.302 8.561 1.028 2.988 5.963 4 11.023 2.26z"
      ></path>
      <path
        fill="url(#paint4_linear_1416_103154)"
        d="M48.873 67.089L17.36 48.884c-.632-.364-.552-.999.177-1.422l11.83-6.83c.728-.42 1.831-.465 2.463-.101l31.513 18.205c.63.364.552 1.001-.176 1.422l-11.834 6.83c-.736.42-1.83.476-2.46.1z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint5_linear_1416_103154)"
        d="M30.06 41.974l2.018 1.167a1.025 1.025 0 00.926 0 .281.281 0 000-.535l-2.018-1.167a1.025 1.025 0 00-.927 0c-.26.15-.257.388 0 .535zm3.456 1.997l.958.552a1.018 1.018 0 00.926 0 .283.283 0 000-.536l-.955-.551a1.022 1.022 0 00-.93 0 .284.284 0 000 .535zm2.396 1.384l.956.552a1.025 1.025 0 00.926 0c.268-.147.268-.386 0-.535l-.956-.555a1.025 1.025 0 00-.926 0c-.26.16-.257.389 0 .538zm2.393 1.382l.959.551a1.017 1.017 0 00.926 0 .284.284 0 000-.535l-.959-.552a1.018 1.018 0 00-.926 0 .284.284 0 000 .536zm2.396 1.381l.956.554a1.025 1.025 0 00.926 0c.268-.147.255-.385 0-.535l-.956-.551a1.025 1.025 0 00-.926 0 .282.282 0 00-.008.532h.008zm2.402 1.384l.958.552a1.018 1.018 0 00.926 0 .284.284 0 000-.535l-.958-.552a1.016 1.016 0 00-.926 0c-.268.147-.268.386 0 .535zm2.396 1.382l.956.554a1.026 1.026 0 00.926 0c.268-.147.268-.386 0-.535l-.956-.552a1.026 1.026 0 00-.926 0 .28.28 0 00-.008.533h.008zm2.393 1.384l.959.551a1.027 1.027 0 00.926 0 .284.284 0 000-.535l-.959-.554a1.025 1.025 0 00-.926 0c-.265.15-.265.388-.008.538h.008zm2.396 1.381l.956.552a1.018 1.018 0 00.926 0c.268-.147.255-.386 0-.536l-.955-.551a1.018 1.018 0 00-.927 0 .282.282 0 00-.008.535h.008zm2.394 1.384l.958.552a1.026 1.026 0 00.926 0 .284.284 0 000-.535l-.958-.555a1.025 1.025 0 00-.926 0c-.265.15-.265.389-.008.538h.008zm2.396 1.382l.955.551a1.018 1.018 0 00.927 0 .28.28 0 000-.535l-.956-.551a1.018 1.018 0 00-.926 0 .281.281 0 00-.008.535h.008zm2.393 1.381l.959.554a1.026 1.026 0 00.926 0c.254-.147.254-.385 0-.535l-.959-.551a1.017 1.017 0 00-.926 0 .268.268 0 00-.008.532h.008zm2.445 1.414l.958.551a1.025 1.025 0 00.926 0 .284.284 0 000-.535l-.956-.554a1.034 1.034 0 00-.928 0c-.266.15-.266.388-.009.538h.009zM27.904 43.294l.83.477a1.162 1.162 0 001.055 0l.822-.477c.292-.166.289-.44 0-.608l-.827-.479a1.168 1.168 0 00-1.058 0l-.822.474a.325.325 0 000 .613zm4.284 1.86l.824-.473a.321.321 0 000-.61l-.827-.477a1.162 1.162 0 00-1.055 0l-.822.476c-.291.166-.289.44 0 .608l.828.48a1.161 1.161 0 001.046-.003h.006zm.511.905l.83.477a1.17 1.17 0 001.055 0l.822-.477c.292-.165.289-.438 0-.607l-.835-.474a1.168 1.168 0 00-1.058 0l-.822.474a.324.324 0 00.003.597l.005.01zm2.396 1.382l.827.48a1.162 1.162 0 001.055 0l.825-.475a.32.32 0 000-.61l-.827-.477a1.162 1.162 0 00-1.055 0l-.822.474a.322.322 0 00-.164.489.322.322 0 00.156.119h.005zm5.087.779l-.827-.48a1.178 1.178 0 00-1.071 0l-.803.475a.322.322 0 000 .607l.83.48a1.17 1.17 0 001.054 0l.822-.477c.295-.163.292-.436 0-.605h-.005zm2.393 1.382l-.81-.477a1.155 1.155 0 00-1.056 0l-.819.471a.322.322 0 000 .61l.827.477a1.161 1.161 0 001.055 0l.825-.474a.322.322 0 00-.016-.608h-.006zm2.396 1.384l-.827-.48a1.177 1.177 0 00-1.057 0l-.822.477a.32.32 0 000 .608l.83.479a1.17 1.17 0 001.055 0l.821-.477c.3-.168.298-.439.006-.607h-.006zm2.394 1.381l-.828-.48a1.162 1.162 0 00-1.054 0l-.822.475a.321.321 0 000 .61l.827.477a1.162 1.162 0 001.055 0l.825-.474a.32.32 0 00.159-.49.32.32 0 00-.157-.118h-.005zm2.396 1.381l-.822-.47a1.167 1.167 0 00-1.07 0l-.823.476a.321.321 0 000 .608l.83.479a1.161 1.161 0 001.055 0l.838-.493a.322.322 0 00-.003-.6h-.005zm2.393 1.385l-.827-.48a1.162 1.162 0 00-1.055 0l-.824.474a.324.324 0 000 .61l.827.477a1.16 1.16 0 001.055 0l.824-.476c.3-.164.297-.437.006-.605h-.006zm-.308 1.986l.83.48a1.161 1.161 0 001.055 0l.822-.475a.322.322 0 000-.61l-.83-.477a1.162 1.162 0 00-1.055 0l-.822.474a.32.32 0 00.006.608h-.006zm5.087.78l-.827-.48a1.17 1.17 0 00-1.055 0l-.825.476c-.289.17-.286.44 0 .608l.828.48a1.17 1.17 0 001.054 0l.825-.477c.31-.166.308-.44.016-.608h-.016zm3.507 2.023l-1.89-1.092a1.16 1.16 0 00-1.055 0l-.822.474a.321.321 0 000 .61l1.89 1.09a1.16 1.16 0 001.055 0l.825-.474a.321.321 0 00.013-.608h-.016zM25.7 44.574l1.891 1.092a1.162 1.162 0 001.055 0l.803-.474c.29-.169.29-.439 0-.61l-1.874-1.09a1.162 1.162 0 00-1.055 0l-.822.474a.321.321 0 00.003.608zm3.444 2.01l.83.477a1.162 1.162 0 001.055 0l.83-.477c.291-.166.289-.439 0-.608l-.828-.479a1.168 1.168 0 00-1.07 0l-.823.474a.324.324 0 00.006.613zm3.212 1.874a1.162 1.162 0 001.055 0l.825-.474a.321.321 0 000-.61l-.827-.477a1.162 1.162 0 00-1.055 0l-.822.477c-.292.166-.29.44 0 .608l.824.476zm2.396 1.382a1.17 1.17 0 001.055 0l.822-.477c.292-.166.29-.439 0-.608l-.827-.479a1.177 1.177 0 00-1.057 0l-.814.45a.32.32 0 000 .608l.822.506zm2.386-.18l-.822.474a.321.321 0 000 .61l.827.48a1.161 1.161 0 001.055 0l.825-.474a.32.32 0 000-.61l-.828-.477a1.162 1.162 0 00-1.046-.03l-.011.027zm2.444 1.352l-.924.536c-.267.15-.267.396 0 .549l.932.535a1.07 1.07 0 00.953 0l.924-.535c.268-.15.268-.397 0-.536l-.93-.535a1.07 1.07 0 00-.944-.04l-.01.026zm2.41 1.385l-.924.535a.292.292 0 000 .551l.929.536a1.049 1.049 0 00.953 0l.924-.536c.267-.152.267-.398 0-.551l-.93-.535a1.05 1.05 0 00-.955-.027l.003.027zm2.393 1.38l-.924.536c-.267.15-.267.397 0 .536l.932.535a1.05 1.05 0 00.953 0l.924-.535a.29.29 0 000-.55l-.932-.535a1.07 1.07 0 00-.956-.013l.003.027zm2.396 1.385l-.923.535a.292.292 0 000 .552l.928.535a1.07 1.07 0 00.954 0l.923-.535c.268-.153.268-.399 0-.552l-.929-.535a1.05 1.05 0 00-.956-.027l.003.027zm2.394 1.381l-.924.536a.292.292 0 000 .551l.932.536a1.05 1.05 0 00.953 0l.923-.536a.292.292 0 000-.551l-.931-.536a1.07 1.07 0 00-.956-.026l.003.026zm3.357 3.007l.923-.535c.268-.15.268-.397 0-.55l-.929-.535a1.05 1.05 0 00-.953 0l-.923.536a.291.291 0 000 .551l.929.536a1.07 1.07 0 00.95-.03l.003.027zm2.396 1.381l.924-.535a.292.292 0 000-.552l-.932-.535a1.05 1.05 0 00-.953 0l-.924.535a.292.292 0 000 .552l.932.535a1.05 1.05 0 00.95-.026l.003.026zm3.365.327l-.929-.536a1.07 1.07 0 00-.956 0l-.923.536c-.268.15-.268.396 0 .549l.931.535a1.049 1.049 0 00.954 0l.923-.535a.292.292 0 00-.003-.576l.003.027zM23.417 45.824l3.004 1.735a1.05 1.05 0 00.953 0l.924-.536c.268-.15.268-.396 0-.549l-3.001-1.734a1.07 1.07 0 00-.956 0l-.924.535c-.265.15-.262.396 0 .549zm4.468 2.58l.93.536a1.05 1.05 0 00.953 0l.926-.535a.292.292 0 000-.552l-.932-.535a1.05 1.05 0 00-.953 0l-.924.535a.29.29 0 00-.142.445c.035.05.085.087.143.107zm2.394 1.393l.932.535a1.049 1.049 0 00.953 0l.923-.535a.292.292 0 000-.552l-.929-.535a1.07 1.07 0 00-.953 0l-.926.535c-.265.142-.262.389 0 .552zm2.41 1.384l.928.535a1.07 1.07 0 00.954 0l.926-.535c.267-.15.267-.396 0-.535l-.932-.536a1.05 1.05 0 00-.953 0l-.924.536a.292.292 0 00-.013.524l.013.011zm4.283 1.92l.923-.536a.292.292 0 000-.551l-.928-.536a1.054 1.054 0 00-.956 0l-.924.536a.292.292 0 000 .551l.932.536a1.049 1.049 0 00.926-.011l.027.01zm2.393 1.384l.927-.536c.267-.15.267-.396 0-.549l-.932-.535a1.049 1.049 0 00-.953 0l-.924.535a.29.29 0 000 .536l.93.535a1.072 1.072 0 00.942.003l.01.01zm2.396 1.381l.924-.535a.292.292 0 000-.552l-.929-.535a1.055 1.055 0 00-.956 0l-.923.535a.29.29 0 000 .552l.931.535a1.05 1.05 0 00.935-.01l.018.01zm2.394 1.384l.926-.535c.268-.15.268-.397 0-.55l-.931-.535a1.07 1.07 0 00-.954 0l-.923.536c-.268.15-.268.396 0 .549l.929.535a1.071 1.071 0 00.934-.01l.019.01zm2.396 1.382l.923-.536a.292.292 0 000-.551l-.928-.536a1.054 1.054 0 00-.956 0l-.924.536a.292.292 0 000 .551l.932.536a1.05 1.05 0 00.934 0h.019zm2.393 1.381l.927-.535a.29.29 0 000-.552l-.932-.535a1.07 1.07 0 00-.953 0l-.924.535c-.267.15-.267.396 0 .549l.93.535a1.05 1.05 0 00.934-.008l.018.011zm.512.846l.931.535a1.07 1.07 0 00.953 0l.924-.535a.292.292 0 000-.551l-.929-.536a1.055 1.055 0 00-.956 0l-.923.536a.292.292 0 00-.02.54l.02.011zm6.634 1.665l-2.364-1.365a1.07 1.07 0 00-.953 0l-.924.535a.29.29 0 00-.142.445c.035.05.085.087.142.107l2.364 1.365a1.07 1.07 0 00.953 0l.926-.535c.247-.16.244-.41-.021-.562l.019.01zM21.209 47.171l4.262 2.46a1.183 1.183 0 001.07 0l.804-.463a.327.327 0 000-.621l-4.262-2.46a1.191 1.191 0 00-1.071 0l-.803.462a.326.326 0 000 .622zm5.85 3.378l.802.466a1.191 1.191 0 001.071 0l.803-.46c.295-.172.295-.45 0-.624l-.803-.466a1.191 1.191 0 00-1.07 0l-.804.46c-.286.172-.286.45 0 .624zm2.39 1.39l.803.465a1.191 1.191 0 001.071 0l.803-.463a.327.327 0 000-.62l-.803-.467a1.196 1.196 0 00-1.07 0l-.804.464a.327.327 0 000 .62zm2.396 1.384l.803.463a1.184 1.184 0 001.071 0l.803-.463c.295-.169.295-.447 0-.621l-.803-.466a1.191 1.191 0 00-1.07 0l-.804.46a.329.329 0 00.014.619l-.014.008zm2.394 1.381l.803.466a1.197 1.197 0 001.07 0l.804-.463a.327.327 0 000-.621l-.803-.466a1.19 1.19 0 00-1.071 0l-.803.463a.326.326 0 00.002.613l-.002.008zm2.396 1.384l.803.463a1.184 1.184 0 001.07 0l.804-.463a.326.326 0 000-.62L38.509 55a1.199 1.199 0 00-1.071 0l-.803.464a.33.33 0 00.002.615l-.002.008zm2.393 1.382l.803.466a1.206 1.206 0 001.071 0l.803-.464c.297-.17.295-.45 0-.623l-.803-.463a1.188 1.188 0 00-1.07 0l-.804.463a.327.327 0 00.003.613l-.003.008zm2.41 1.381l.803.466a1.184 1.184 0 001.07 0l.804-.463a.327.327 0 000-.621l-.803-.466a1.191 1.191 0 00-1.071 0l-.803.463a.326.326 0 00-.011.613l.01.008zm2.393 1.384l.803.466a1.197 1.197 0 001.07 0l.804-.46c.297-.172.295-.45 0-.624l-.803-.463a1.188 1.188 0 00-1.071 0l-.803.463c-.31.158-.308.436-.01.621l.01-.003zm2.396 1.382l.803.466a1.192 1.192 0 001.071 0l.803-.464a.327.327 0 000-.62l-.803-.467a1.191 1.191 0 00-1.07 0l-.804.464a.327.327 0 00-.01.613l.01.008zM48.62 63l.803.466a1.198 1.198 0 001.071 0l.804-.46c.297-.172.294-.45 0-.625l-.804-.465a1.196 1.196 0 00-1.07 0l-.804.46c-.31.163-.307.442-.01.616l.01.008zm5.13.803l-.803-.466a1.19 1.19 0 00-1.071 0l-.803.46c-.295.172-.295.45 0 .624l.803.464a1.183 1.183 0 001.07 0l.804-.464a.326.326 0 00-.01-.634l.01.016zM22.735 48.458l-1.875-1.07a1.191 1.191 0 00-1.07 0l-.803.46c-.295.171-.295.45 0 .624l1.873 1.07a1.2 1.2 0 001.071 0l.804-.463a.33.33 0 000-.62zm2.409 1.384l-.803-.465a1.191 1.191 0 00-1.071 0l-.803.463a.327.327 0 000 .62l.803.467a1.189 1.189 0 001.07 0l.804-.463a.326.326 0 00-.013-.632l.013.01zm2.394 1.382l-.804-.463a1.183 1.183 0 00-1.07 0l-.804.463c-.294.169-.294.447 0 .621l.803.466a1.191 1.191 0 001.071 0l.803-.46c.287-.18.284-.464-.013-.638l.014.01zm16.761 9.678l-15.174-8.76a1.19 1.19 0 00-1.07 0l-.804.463a.327.327 0 000 .621l15.174 8.763a1.196 1.196 0 001.071 0l.803-.46c.287-.185.287-.464-.013-.638l.013.01zm2.41 1.384l-.803-.466a1.191 1.191 0 00-1.071 0l-.803.463a.327.327 0 000 .621l.803.466a1.191 1.191 0 001.07 0l.804-.463a.326.326 0 00-.027-.632l.027.011zm2.393 1.381l-.803-.465a1.191 1.191 0 00-1.07 0l-.804.46c-.297.171-.294.45 0 .624l.803.466a1.197 1.197 0 001.071 0l.803-.46c.273-.183.273-.461-.026-.635l.026.01zm2.447 1.411l-.803-.463a1.183 1.183 0 00-1.07 0l-.804.463a.327.327 0 000 .621l.803.466a1.198 1.198 0 001.071 0l.803-.46c.273-.185.27-.463-.026-.648l.026.021z"
        opacity="0.3"
      ></path>
      <path
        fill="url(#paint6_linear_1416_103154)"
        d="M69.795 58.63l-37.4-21.6c-1.449-.835-2.622-3.078-2.622-5.009V2.691c0-1.931 1.173-2.817 2.621-1.982l37.4 21.6c1.45.835 2.622 3.078 2.622 5.009v29.331c0 1.93-1.173 2.82-2.621 1.981z"
      ></path>
      <path
        fill="url(#paint7_linear_1416_103154)"
        d="M70.141 57.124L33.14 35.757c-1.165-.739-1.874-2.22-1.874-3.748V2.55a.466.466 0 01.688-.407.84.84 0 00.083.049L69.07 23.584c1.387.803 1.874 2.22 1.874 3.748v29.393a.501.501 0 01-.75.434l-.053-.035z"
      ></path>
      <path
        fill="url(#paint8_linear_1416_103154)"
        d="M70.54 21.915L33.146.315a1.773 1.773 0 00-1.534-.227c-.054.021-.785.41-.836.439.445-.217 1.012-.177 1.63.18l37.388 21.602c1.448.835 2.62 3.078 2.62 5.009v29.331c0 1.205-.457 2.003-1.15 2.23a.434.434 0 00.227-.077c.035-.02.827-.466.86-.49.498-.348.803-1.071.803-2.056V26.921c.005-1.928-1.17-4.166-2.616-5.007z"
      ></path>
      <path
        style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
        fill="url(#paint9_radial_1416_103154)"
        d="M69.922 22.247L32.532.645c-.594-.343-1.14-.39-1.579-.2.443-.05.89.055 1.264.297l37.392 21.6c1.446.835 2.621 3.078 2.621 5.008v29.332c0 1.137-.41 1.911-1.044 2.184.803-.128 1.357-.961 1.357-2.278V27.254c.011-1.93-1.172-4.171-2.62-5.007z"
      ></path>
      <path
        fill="url(#paint10_linear_1416_103154)"
        d="M33.605 34.706v-26.2c0-1.107.675-1.605 1.505-1.137l30.683 17.753c.833.482 1.508 1.77 1.508 2.878v26.199L33.605 34.706z"
      ></path>
      <path
        fill="url(#paint11_linear_1416_103154)"
        d="M67.732 53.97V27.771c0-1.108-.675-2.41-1.507-2.875L35.539 7.143a1.02 1.02 0 00-.884-.13l-.48.25a.985.985 0 01.938.103l30.68 17.755c.833.482 1.508 1.77 1.508 2.878v26.199l.43-.228z"
      ></path>
      <path
        fill="url(#paint12_linear_1416_103154)"
        d="M67.732 29.584V27.77c0-1.108-.675-2.41-1.507-2.875L35.539 7.143a1.02 1.02 0 00-.884-.13l-.48.25a.985.985 0 01.938.103l30.68 17.755c.833.482 1.508 1.77 1.508 2.878v1.81l.43-.225z"
      ></path>
      <path
        fill="url(#paint13_linear_1416_103154)"
        d="M65.793 25.12L35.11 7.368c-.83-.48-1.505.03-1.505 1.138v1.777l33.696 19.49v-1.775c0-1.108-.675-2.396-1.508-2.878z"
      ></path>
      <path fill="url(#paint14_linear_1416_103154)" d="M65.89 29.223V53.05l1.096.656V29.79l-1.095-.567z"></path>
      <path fill="url(#paint15_linear_1416_103154)" d="M66.055 42.676v9.033l.77.455v-9.09l-.77-.398z"></path>
      <path
        fill="url(#paint16_linear_1416_103154)"
        d="M40.621 12.502c0 .41-.289.575-.648.37a1.43 1.43 0 01-.645-1.117c0-.41.29-.576.645-.37a1.424 1.424 0 01.648 1.117z"
      ></path>
      <path
        fill="url(#paint17_linear_1416_103154)"
        d="M38.58 11.365c0 .41-.29.576-.647.37a1.425 1.425 0 01-.648-1.117c0-.41.29-.575.648-.37a1.431 1.431 0 01.648 1.117z"
      ></path>
      <path
        fill="url(#paint18_linear_1416_103154)"
        d="M36.522 10.197c0 .413-.289.576-.648.37a1.427 1.427 0 01-.647-1.117c0-.41.291-.575.647-.37a1.426 1.426 0 01.648 1.117z"
      ></path>
      <path
        fill="url(#paint19_linear_1416_103154)"
        d="M53.426 26.294l-3.194-1.834v.645l3.194 1.836v-.647zm.463.912l2.364 1.36v-.645l-2.364-1.36v.645zm-4.117-3.014l-1.582-.918v.648l1.592.918-.01-.648zm-2.054-1.186l-3.68-2.123v.645l3.68 2.118v-.64zm-.294-2.34l-10.428-6.11v.973l10.428 6.106v-.969zm-3.847-.05l-3.831-2.212v.648l3.83 2.208v-.645zm-4.284-2.477l-2.286-1.355v.648l2.286 1.338v-.631z"
      ></path>
      <path
        fill="url(#paint20_linear_1416_103154)"
        d="M56.85 39.981l.766.442v-.648l-.766-.441v.647zm-2.297-1.32l1.834 1.053v-.645l-1.834-1.053v.646zm-5.997-3.453l1.965 1.135v-.648l-1.965-1.135v.648zm-2.41-1.381l1.944 1.113v-.648l-1.943-1.113v.648zm4.836 2.784l3.108 1.783v-.645l-3.108-1.783v.645zm-10.744-6.198l5.448 3.146v-.648l-5.448-3.143v.645zm-.463-.913l-2.779-1.638v.648l2.779 1.635V29.5zm7.649 2.209l-10.428-6.11v.983l10.428 6.107v-.98z"
      ></path>
      <path
        fill="#667085"
        d="M41.162 35.519a.144.144 0 01-.067-.016l-2.27-1.312a.135.135 0 01-.067-.115V31.47a.14.14 0 01.067-.115.135.135 0 01.134 0l2.27 1.306a.131.131 0 01.067.115v2.603a.139.139 0 01-.067.117.145.145 0 01-.067.022zm-2.142-1.52l2.003 1.156V32.86l-2.003-1.156v2.294z"
      ></path>
      <path
        fill="url(#paint21_linear_1416_103154)"
        d="M36.549 32.326a.08.08 0 01-.014-.045v-.022l.536-1.338c.016-.034.042-.04.08-.016l.246.142a.164.164 0 01.08.11l.536 1.964v.027c0 .016 0 .027-.013.03a.03.03 0 01-.032 0l-.201-.115a.153.153 0 01-.065-.086l-.101-.37-.656-.393-.105.252c0 .024-.034.029-.064 0l-.2-.116a.081.081 0 01-.027-.024zm.479-.366l.506.291-.255-.934-.251.643z"
      ></path>
      <path
        fill="#667085"
        d="M48.085 39.519a.153.153 0 01-.067-.016l-2.267-1.312a.129.129 0 01-.067-.115V35.47a.129.129 0 01.067-.115.135.135 0 01.133 0l2.268 1.309a.134.134 0 01.067.118v2.602a.134.134 0 01-.067.118.137.137 0 01-.067.016zm-2.142-1.52l2 1.156V36.86l-2-1.156v2.294z"
      ></path>
      <path
        fill="url(#paint22_linear_1416_103154)"
        d="M43.622 36.41a.105.105 0 01-.016-.053v-1.671a.047.047 0 01.013-.038.038.038 0 01.04 0l.648.375c.158.084.293.207.391.356.085.13.13.282.131.437a.284.284 0 01-.056.195.169.169 0 01-.134.056c.066.075.12.16.158.252.041.09.063.19.064.29 0 .16-.045.267-.139.304a.447.447 0 01-.393-.083l-.67-.385a.09.09 0 01-.037-.035zm.645-.67a.2.2 0 00.177.038c.04-.019.061-.064.061-.136a.362.362 0 00-.061-.201.469.469 0 00-.177-.16l-.345-.202v.46l.345.202zm.024.804a.188.188 0 00.18.03.152.152 0 00.064-.148.45.45 0 00-.064-.225.493.493 0 00-.18-.176l-.37-.215v.52l.37.214z"
      ></path>
      <path
        fill="#667085"
        d="M54.834 43.415a.137.137 0 01-.067-.016l-2.27-1.312a.135.135 0 01-.067-.115V39.37a.138.138 0 01.067-.118.135.135 0 01.133 0l2.27 1.312a.13.13 0 01.068.115v2.602a.14.14 0 01-.067.118.152.152 0 01-.067.016zm-2.142-1.52l2.003 1.156v-2.294L52.692 39.6v2.295z"
      ></path>
      <path
        fill="url(#paint23_linear_1416_103154)"
        d="M50.476 40.227a1.253 1.253 0 01-.18-.618v-.228-.23c0-.215.07-.351.183-.407a.535.535 0 01.477.09c.128.072.244.162.345.268.095.103.173.22.23.349.052.11.08.23.086.353 0 0 0 .024-.014.027a.035.035 0 01-.032 0l-.217-.126a.085.085 0 01-.04-.035.179.179 0 01-.024-.064.725.725 0 00-.115-.292.737.737 0 00-.22-.193c-.214-.123-.323-.048-.334.22v.43a.672.672 0 00.334.603c.063.046.14.068.217.062.056 0 .097-.065.118-.158a.057.057 0 01.024-.038.056.056 0 01.04 0l.217.126c.014.009.026.02.035.035a.072.072 0 010 .045.377.377 0 01-.086.268.269.269 0 01-.23.083.823.823 0 01-.345-.12 1.361 1.361 0 01-.469-.45z"
      ></path>
      <path
        fill="#667085"
        d="M41.16 24.542a.145.145 0 01-.067-.016l-2.276-1.312a.135.135 0 01-.067-.115v-2.605a.14.14 0 01.067-.115.134.134 0 01.134 0l2.275 1.307a.132.132 0 01.067.115v2.602a.14.14 0 01-.067.118.145.145 0 01-.066.021zm-2.142-1.52l2.002 1.156v-2.294l-2.002-1.157v2.295z"
      ></path>
      <path
        fill="url(#paint24_linear_1416_103154)"
        d="M36.549 21.35a.08.08 0 01-.014-.046v-.021l.536-1.339c.016-.034.042-.039.08-.016l.246.142a.166.166 0 01.08.11l.536 1.965v.027c0 .016 0 .026-.013.03a.029.029 0 01-.032 0l-.201-.116a.153.153 0 01-.065-.086l-.101-.37-.656-.393-.105.252c0 .024-.034.03-.064 0l-.2-.115a.08.08 0 01-.027-.024zm.479-.367l.506.292-.255-.926-.251.634z"
      ></path>
      <path
        fill="#667085"
        d="M48.085 28.542a.153.153 0 01-.067-.016l-2.267-1.312a.128.128 0 01-.067-.115v-2.605a.129.129 0 01.067-.115.134.134 0 01.133 0l2.268 1.323a.134.134 0 01.067.118v2.602a.134.134 0 01-.067.118.135.135 0 01-.067.002zm-2.142-1.52l2 1.156v-2.294l-2-1.157v2.295z"
      ></path>
      <path
        fill="url(#paint25_linear_1416_103154)"
        d="M43.622 25.433a.104.104 0 01-.016-.054v-1.676a.047.047 0 01.013-.037.038.038 0 01.04 0l.648.375c.163.084.301.208.402.361.085.13.13.281.13.437a.283.283 0 01-.055.195.167.167 0 01-.134.056c.066.075.119.16.158.252.04.09.063.19.064.289 0 .16-.045.268-.14.305a.447.447 0 01-.393-.083l-.669-.385a.09.09 0 01-.048-.035zm.645-.67a.198.198 0 00.177.038c.04-.019.061-.064.061-.136a.362.362 0 00-.061-.201.467.467 0 00-.177-.16l-.345-.21v.46l.345.21zm.024.804a.187.187 0 00.18.03.152.152 0 00.064-.148.45.45 0 00-.064-.225.493.493 0 00-.18-.177l-.37-.214v.52l.37.214z"
      ></path>
      <path
        fill="#667085"
        d="M54.834 32.439a.137.137 0 01-.067-.016l-2.27-1.312a.135.135 0 01-.067-.115v-2.602a.138.138 0 01.067-.118.135.135 0 01.133 0l2.27 1.312a.13.13 0 01.068.115v2.602a.14.14 0 01-.067.118.152.152 0 01-.067.016zm-2.142-1.52l2.003 1.156V29.78l-2.003-1.156v2.294z"
      ></path>
      <path
        fill="url(#paint26_linear_1416_103154)"
        d="M50.476 29.25a1.253 1.253 0 01-.18-.618v-.228-.23c0-.214.07-.35.183-.407a.535.535 0 01.477.091c.128.07.244.161.345.268.095.103.173.22.23.348.052.111.08.231.086.353 0 .014 0 .024-.014.027a.035.035 0 01-.032 0l-.217-.126a.086.086 0 01-.04-.035.18.18 0 01-.024-.064.725.725 0 00-.115-.292.737.737 0 00-.22-.192c-.214-.123-.323-.049-.334.22v.43a.672.672 0 00.334.603c.063.045.14.067.217.061.056 0 .097-.064.118-.158a.055.055 0 01.024-.037.057.057 0 01.04 0l.217.126c.014.008.026.02.035.034a.073.073 0 010 .046.378.378 0 01-.086.268.269.269 0 01-.23.083.821.821 0 01-.345-.12 1.36 1.36 0 01-.469-.45z"
      ></path>
      <path
        fill="#667085"
        d="M61.956 47.525a.126.126 0 01-.067-.019l-2.267-1.31a.134.134 0 01-.067-.114v-2.605a.129.129 0 01.067-.115.134.134 0 01.133 0l2.268 1.309a.135.135 0 01.067.115v2.6a.129.129 0 01-.067.115.115.115 0 01-.067.024zm-2.142-1.52l2 1.153v-2.294l-2-1.154v2.294z"
      ></path>
      <path
        fill="url(#paint27_linear_1416_103154)"
        d="M57.489 44.414a.103.103 0 01-.016-.054v-1.67a.043.043 0 01-.004-.019c0-.006.001-.013.004-.019h.04l.535.314a1.228 1.228 0 01.675 1.087v.398c0 .236-.064.38-.171.434-.107.054-.268.014-.493-.115l-.557-.321a.09.09 0 01-.013-.035zm.584.056c.123.072.214.091.267.062.054-.03.086-.12.088-.268v-.19-.193a.732.732 0 00-.093-.364.706.706 0 00-.268-.268l-.268-.158v1.203l.273.176z"
      ></path>
      <path fill="#EA2127" d="M46.016 36.93l.803 1.38 2.053-1.158-.49-.67-1.45 1.427-.269-1.07-.647.09z"></path>
      <path fill="#AFB6E5" d="M58.398 16.826l1.321-.784-.452-2.433-1.322.79.453 2.427z"></path>
      <path
        fill="#C6CCF4"
        d="M61.28 16.346a4.523 4.523 0 012.046-.502l-.08-.533a4.02 4.02 0 00-.638.277l-1.453-1.744a5.256 5.256 0 00-1.136 1.005l1.262 1.497zM77.213 34.407l-1.005-.442a6.878 6.878 0 01-.814 2.311l1.196 2.01a5.277 5.277 0 01-1.508 1.508l1.317-.789a5.337 5.337 0 001.507-1.507l-1.2-2.01a5.77 5.77 0 00.507-1.08zM63.023 13.784a8.362 8.362 0 012.463.502l.703 2.121c.436.18.86.387 1.267.623.437.257.86.537 1.266.84l.674-1.242c-.206-.13-.407-.261-.618-.382a10.826 10.826 0 00-1.262-.623l-.708-2.12A8.362 8.362 0 0064.345 13l-1.322.784zM79.142 30.909l-1.634-1.186a17.546 17.546 0 00-.754-3.126l1.171-.694a25.45 25.45 0 00-1.507-3.281l-1.453.07a20.769 20.769 0 00-2.045-2.89l.307-1.683a20.32 20.32 0 00-2.463-2.342l-1.326.79c.875.708 1.689 1.49 2.432 2.336l-.302 1.684a21.07 21.07 0 012.046 2.89l1.447-.071a24.805 24.805 0 011.508 3.282l-1.181.608a17.26 17.26 0 01.778 3.21l1.634 1.192c.055.5.083 1.004.085 1.508 0 .48-.028.96-.085 1.437l1.326-.784c.054-.477.08-.957.08-1.438.016-.482-.014-.994-.064-1.512z"
      ></path>
      <path
        fill="#AFB6E5"
        d="M65.488 37.828l1.322-.784.709-1.302-1.327.784-.704 1.302zM71.891 40.617l1.327-.784-.306-2.04-1.322.789.301 2.035zM75.406 36.278l1.322-.784 1.201 1.99-1.327.79-1.196-1.996zM76.184 30.509l1.326-.784 1.634 1.186-1.327.789-1.633-1.191zM73.633 23.48l1.327-.785 1.447-.07-1.327.784-1.447.07zM71.59 20.589l1.322-.784.306-1.684-1.327.784-.301 1.684zM66.192 16.409l1.327-.784-.709-2.121-1.322.784.704 2.12zM61.28 16.348l1.326-.784-1.452-1.744-1.322.784 1.447 1.744zM58.723 20.433l1.322-.79-1.634-.698-1.321.784 1.633.704z"
      ></path>
      <path
        fill="url(#paint28_linear_1416_103154)"
        d="M77.815 34.675c.058-.477.086-.957.086-1.438a14.355 14.355 0 00-.086-1.507l-1.633-1.191a17.264 17.264 0 00-.794-3.237l1.196-.608a24.804 24.804 0 00-1.508-3.281l-1.447.07a21.07 21.07 0 00-2.045-2.89l.301-1.683a19.538 19.538 0 00-2.462-2.337l-.704 1.302c-.406-.302-.83-.583-1.266-.84-.408-.235-.83-.444-1.267-.623l-.703-2.12a8.362 8.362 0 00-2.463-.503l.307 2.035a4.523 4.523 0 00-2.045.503l-1.473-1.719c-.6.395-1.112.908-1.507 1.508l1.196 2.01a6.89 6.89 0 00-.78 2.307l-1.633-.699c-.057.477-.085.957-.085 1.437.002.504.03 1.007.085 1.508l1.634 1.191c.157 1.093.417 2.168.779 3.211l-1.196.634a24.804 24.804 0 001.507 3.281l1.448-.07c.607 1.02 1.3 1.986 2.07 2.89l-.301 1.683a20.261 20.261 0 002.462 2.337l.704-1.302c.406.301.829.58 1.266.834.407.239.83.449 1.266.628l.699 2.101c.785.29 1.61.46 2.447.503l-.286-2.01a4.573 4.573 0 002.045-.503l1.447 1.739a5.276 5.276 0 001.508-1.508l-1.196-2.01a6.88 6.88 0 00.779-2.312l1.648.679zM67.453 30.73a6.77 6.77 0 01-3.076-5.302c0-1.95 1.377-2.734 3.076-1.754a6.78 6.78 0 013.075 5.307c0 1.945-1.377 2.729-3.075 1.749z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint29_radial_1416_103154)"
          d="M65.43 14.372l.71 2.105c.434.18.855.39 1.26.629.44.252.862.53 1.267.834l.05-.096c-.405-.3-.826-.579-1.261-.834-.408-.236-.83-.444-1.267-.623l-.703-2.12a8.362 8.362 0 00-2.463-.503v.095c.824.05 1.636.222 2.408.513z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint30_radial_1416_103154)"
          d="M64.32 25.523a6.782 6.782 0 003.07 5.307c1.206.694 2.246.503 2.749-.367-.503.79-1.508.945-2.694.272a6.77 6.77 0 01-3.075-5.302 2.75 2.75 0 01.336-1.417 2.653 2.653 0 00-.387 1.507z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint31_radial_1416_103154)"
          d="M71.86 18.99l-.306 1.689a20.723 20.723 0 012.046 2.884l1.427-.05a23.775 23.775 0 011.507 3.231l.076-.04a24.183 24.183 0 00-1.508-3.281l-1.447.07a20.772 20.772 0 00-2.045-2.89l.306-1.683a20.689 20.689 0 00-2.462-2.342l-.056.096a20.268 20.268 0 012.463 2.316z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint32_radial_1416_103154)"
          d="M59.439 27.125l-1.146.573v.05l1.126-.568a.243.243 0 01.02-.055z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint33_radial_1416_103154)"
          d="M59.798 14.688l1.447 1.739a4.608 4.608 0 012.045-.503v-.085a4.524 4.524 0 00-1.98.502l-1.447-1.743c-.6.395-1.112.908-1.508 1.507a5.161 5.161 0 011.443-1.417z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint34_radial_1416_103154)"
          d="M77.819 31.684l-1.633-1.186a17.026 17.026 0 00-.76-3.156l-.074.035c.365 1.042.627 2.118.783 3.211l1.634 1.191c.05.503.08 1.005.08 1.508 0 .443-.023.886-.07 1.327h.04c.05-.463.074-.927.07-1.392a14.49 14.49 0 00-.07-1.538z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint35_radial_1416_103154)"
          d="M76.168 34.066h-.03a6.784 6.784 0 01-.76 2.292l1.197 2.01.055-.08-1.196-2.01c.371-.69.62-1.438.734-2.212z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint36_radial_1416_103154)"
          d="M71.531 38.658l.292 1.94h.07l-.291-1.95-.07.01z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint37_radial_1416_103154)"
          d="M66.139 36.61l-.658 1.21.658-1.206v-.005z"
        ></path>
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
          fill="url(#paint38_radial_1416_103154)"
          d="M58.672 20.497a.774.774 0 000-.105l-1.598-.689v.11l1.598.684z"
        ></path>
      </g>
      <path
        fill="url(#paint39_linear_1416_103154)"
        d="M67.449 18.283c-4.292-2.477-7.77-.502-7.77 4.433s3.478 10.925 7.77 13.403c4.292 2.477 7.774.502 7.774-4.433s-3.482-10.925-7.774-13.403zm0 13.594c-2.251-1.296-4.076-4.447-4.076-7.035s1.825-3.624 4.076-2.327c2.251 1.296 4.076 4.452 4.076 7.035s-1.825 3.629-4.076 2.327z"
      ></path>
      <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
        <path
          fill="#AFB6E5"
          d="M70.48 32.077c.944-.312 1.552-1.287 1.552-2.774 0-2.584-1.824-5.734-4.075-7.036-1.201-.689-2.277-.714-3.016-.196a3.146 3.146 0 012.513.447c2.252 1.302 4.076 4.453 4.076 7.036 0 1.206-.397 2.07-1.05 2.523z"
        ></path>
        <path
          fill="#AFB6E5"
          d="M67.96 35.866c-4.292-2.477-7.77-8.478-7.77-13.403 0-2.417.84-4.12 2.196-4.94-1.653.684-2.699 2.488-2.699 5.192 0 4.925 3.478 10.925 7.77 13.402 2.186 1.262 4.16 1.362 5.573.503-1.362.568-3.13.367-5.07-.754z"
        ></path>
      </g>
      <path
        fill="url(#paint40_linear_1416_103154)"
        d="M64.379 25.425a6.769 6.769 0 003.075 5.302c1.207.698 2.242.502 2.75-.362a2.785 2.785 0 01-1.428-.422 6.779 6.779 0 01-3.07-5.302 2.75 2.75 0 01.326-1.387c-.98.025-1.653.814-1.653 2.17z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1416_103154"
          x1="-2.251"
          x2="73.896"
          y1="33.103"
          y2="67.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#71879D"></stop>
          <stop offset="0.568" stopColor="#748AA0"></stop>
          <stop offset="0.726" stopColor="#B9D7F4"></stop>
          <stop offset="0.844" stopColor="#748AA0"></stop>
          <stop offset="1" stopColor="#748AA0"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1416_103154"
          x1="2.136"
          x2="71.443"
          y1="55.933"
          y2="55.933"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#585858"></stop>
          <stop offset="1" stopColor="#A4B1C5"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1416_103154"
          x1="95.517"
          x2="30.076"
          y1="84.084"
          y2="42.156"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.85"></stop>
        </linearGradient>
        <radialGradient
          id="paint3_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-18.98 147.302 -51.791) scale(9.6861 5.7148)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#972A74"></stop>
          <stop offset="0.04" stopColor="#8A266A"></stop>
          <stop offset="0.19" stopColor="#601B4A"></stop>
          <stop offset="0.35" stopColor="#3D112F"></stop>
          <stop offset="0.51" stopColor="#230A1B"></stop>
          <stop offset="0.67" stopColor="#0F040C"></stop>
          <stop offset="0.83" stopColor="#040103"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint4_linear_1416_103154"
          x1="36.892"
          x2="36.892"
          y1="70.499"
          y2="14.386"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#98A2B3"></stop>
          <stop offset="1" stopColor="#050A14"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1416_103154"
          x1="31.572"
          x2="49.268"
          y1="40.009"
          y2="67.782"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.06" stopColor="#9F79B8"></stop>
          <stop offset="0.25" stopColor="#A17BBA"></stop>
          <stop offset="0.35" stopColor="#A883C0"></stop>
          <stop offset="0.42" stopColor="#B490CC"></stop>
          <stop offset="0.48" stopColor="#C5A3DC"></stop>
          <stop offset="0.54" stopColor="#DBBBF0"></stop>
          <stop offset="0.56" stopColor="#E6C6FA"></stop>
          <stop offset="0.6" stopColor="#D6B6F1"></stop>
          <stop offset="0.69" stopColor="#B595DD"></stop>
          <stop offset="0.77" stopColor="#9D7DCF"></stop>
          <stop offset="0.85" stopColor="#8E6EC6"></stop>
          <stop offset="0.92" stopColor="#8969C3"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1416_103154"
          x1="5.754"
          x2="77.859"
          y1="-9.719"
          y2="52.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F4F4F"></stop>
          <stop offset="1" stopColor="#82A1A8"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1416_103154"
          x1="48.174"
          x2="48.174"
          y1="200.591"
          y2="-50.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1416_103154"
          x1="51.966"
          x2="51.966"
          y1="0.006"
          y2="58.879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6D2EA"></stop>
          <stop offset="0.698" stopColor="#F3F1FF"></stop>
          <stop offset="1" stopColor="#CBC8E0"></stop>
        </linearGradient>
        <radialGradient
          id="paint9_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(71.513 25.457) scale(6.02369)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint10_linear_1416_103154"
          x1="65.778"
          x2="3.363"
          y1="66.844"
          y2="22.835"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#F4F8FD"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_1416_103154"
          x1="50.954"
          x2="50.954"
          y1="28.5"
          y2="54.198"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F97DB"></stop>
          <stop offset="0.661" stopColor="#9BA0CE"></stop>
          <stop offset="0.958" stopColor="#8F97DB"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_1416_103154"
          x1="49.23"
          x2="51.984"
          y1="21.314"
          y2="16.685"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#686868"></stop>
          <stop offset="1" stopColor="#97959F"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_1416_103154"
          x1="65.006"
          x2="33.605"
          y1="18.416"
          y2="18.416"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_1416_103154"
          x1="66.936"
          x2="63.905"
          y1="60.292"
          y2="60.159"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1416_103154"
          x1="70.046"
          x2="65.832"
          y1="47.779"
          y2="47.358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9F79C8"></stop>
          <stop offset="0.14" stopColor="#A580CB"></stop>
          <stop offset="0.33" stopColor="#B492D3"></stop>
          <stop offset="0.55" stopColor="#CDB0E1"></stop>
          <stop offset="0.58" stopColor="#D1B4E3"></stop>
          <stop offset="0.76" stopColor="#DBC4E9"></stop>
          <stop offset="1" stopColor="#EBDEF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_1416_103154"
          x1="39.246"
          x2="40.892"
          y1="11.101"
          y2="11.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_1416_103154"
          x1="37.529"
          x2="38.254"
          y1="11.684"
          y2="10.444"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#FFA98C"></stop>
          <stop offset="0.32" stopColor="#FFB892"></stop>
          <stop offset="0.86" stopColor="#FEE1A3"></stop>
          <stop offset="1" stopColor="#FEECA8"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_1416_103154"
          x1="35.47"
          x2="36.196"
          y1="10.518"
          y2="9.276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9F79C8"></stop>
          <stop offset="0.14" stopColor="#A580CB"></stop>
          <stop offset="0.33" stopColor="#B492D3"></stop>
          <stop offset="0.55" stopColor="#CDB0E1"></stop>
          <stop offset="0.58" stopColor="#D1B4E3"></stop>
          <stop offset="0.76" stopColor="#DBC4E9"></stop>
          <stop offset="1" stopColor="#EBDEF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_1416_103154"
          x1="35.776"
          x2="58.365"
          y1="12.908"
          y2="21.067"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_1416_103154"
          x1="35.69"
          x2="59.81"
          y1="23.855"
          y2="32.672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_1416_103154"
          x1="35.389"
          x2="62.496"
          y1="30.61"
          y2="49.016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25054D"></stop>
          <stop offset="1" stopColor="#45108A"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_1416_103154"
          x1="35.719"
          x2="62.825"
          y1="30.121"
          y2="48.527"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25054D"></stop>
          <stop offset="1" stopColor="#45108A"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_1416_103154"
          x1="36.046"
          x2="63.153"
          y1="29.636"
          y2="48.042"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25054D"></stop>
          <stop offset="1" stopColor="#45108A"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_1416_103154"
          x1="35.389"
          x2="62.496"
          y1="19.634"
          y2="38.039"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25054D"></stop>
          <stop offset="1" stopColor="#45108A"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_1416_103154"
          x1="35.719"
          x2="62.825"
          y1="19.144"
          y2="37.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25054D"></stop>
          <stop offset="1" stopColor="#45108A"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_1416_103154"
          x1="36.046"
          x2="63.153"
          y1="18.659"
          y2="37.065"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25054D"></stop>
          <stop offset="1" stopColor="#45108A"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_1416_103154"
          x1="36.371"
          x2="63.478"
          y1="29.159"
          y2="47.565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25054D"></stop>
          <stop offset="1" stopColor="#45108A"></stop>
        </linearGradient>
        <linearGradient
          id="paint28_linear_1416_103154"
          x1="41.693"
          x2="73.639"
          y1="52.892"
          y2="21.036"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.39" stopColor="#CED3F4"></stop>
          <stop offset="0.67" stopColor="#DEE2FC"></stop>
          <stop offset="0.78" stopColor="#E5E9FF"></stop>
          <stop offset="1" stopColor="#EFF1FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint29_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(65.868 15.86) scale(2.49763)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint30_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(67.239 27.629) scale(3.27657)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint31_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(72.992 21.639) scale(4.40728)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint32_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.46234 0 0 .46234 58.886 27.437)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint33_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(60.793 15.512) scale(1.86945)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint34_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(76.628 31) scale(2.73885)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint35_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(75.982 36.197) scale(1.583)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint36_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(71.712 39.628) scale(.69853)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint37_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.48747 0 0 .48746 65.812 37.218)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint38_radial_1416_103154"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(57.888 20.115) scale(.6332)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint39_linear_1416_103154"
          x1="32.824"
          x2="76.294"
          y1="15.193"
          y2="30.269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#01C9EC"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint40_linear_1416_103154"
          x1="64.434"
          x2="69.389"
          y1="24.138"
          y2="31.164"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.47" stopColor="#D1D5F0"></stop>
          <stop offset="0.8" stopColor="#B8BEE8"></stop>
          <stop offset="0.99" stopColor="#AFB6E5"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const IconBenefitProduct8 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="66" height="80" fill="none" viewBox="0 0 66 80">
      <g clipPath="url(#clip0_1416_103248)">
        <path
          style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
          fill="url(#paint0_linear_1416_103248)"
          d="M56.684 57.443L31.898 71.887l15.517 6.83 17.828-9.746-8.559-11.528z"
        ></path>
        <g opacity="0.95">
          <path fill="#E5E9FF" d="M3.954 39.463l-3.278 1.85L13.73 48.74l3.286-1.859-13.062-7.418z"></path>
          <path fill="url(#paint1_linear_1416_103248)" d="M.668 54.368l13.061 7.426V48.733L.668 41.315v13.053z"></path>
          <path fill="#AFB6E5" d="M13.73 61.795l3.287-1.85V46.882l-3.287 1.85v13.062z"></path>
        </g>
        <path fill="#fff" d="M13.73 48.257L.676 41.315 13.73 48.74l3.286-1.858-3.286 1.375z"></path>
        <g opacity="0.95">
          <path fill="#E5E9FF" d="M19.556 28.049l-3.279 1.858 13.054 7.426 3.279-1.858-13.054-7.426z"></path>
          <path fill="url(#paint2_linear_1416_103248)" d="M16.27 63.417l13.06 7.418v-33.51l-13.06-7.419v33.511z"></path>
          <path fill="#AFB6E5" d="M29.324 70.834l3.286-1.85V35.473l-3.286 1.85v33.511z"></path>
        </g>
        <path fill="#fff" d="M29.358 36.88l-13.061-6.943 13.061 7.426 3.279-1.858-3.279 1.375z"></path>
        <g opacity="0.95">
          <path
            fill="#AFB6E5"
            d="M54.144 34.334l3.067-1.488L41.33 0l-3.097 1.541 15.91 32.793zM44.824 80.001l3.06-1.488V27.46l-3.06 1.488v51.052z"
          ></path>
          <path
            fill="url(#paint3_linear_1416_103248)"
            d="M31.716 21.386v51.052L44.823 80V28.948l9.322 5.386L38.266 1.488 22.395 16l9.322 5.386z"
          ></path>
        </g>
        <path fill="#fff" d="M38.266 1.488l16.18 32.506-.301.34-15.88-32.846z"></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1416_103248"
          x1="48.903"
          x2="58.996"
          y1="69.515"
          y2="64.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E5E9FF"></stop>
          <stop offset="0.23" stopColor="#F0F2FF"></stop>
          <stop offset="0.6" stopColor="#FBFCFF"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1416_103248"
          x1="27.591"
          x2="-0.556"
          y1="-2.689"
          y2="72.181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#5277F7"></stop>
          <stop offset="0.69" stopColor="#5B76F7"></stop>
          <stop offset="0.79" stopColor="#7374F6"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1416_103248"
          x1="40.866"
          x2="12.719"
          y1="2.303"
          y2="77.174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#5277F7"></stop>
          <stop offset="0.69" stopColor="#5B76F7"></stop>
          <stop offset="0.79" stopColor="#7374F6"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1416_103248"
          x1="49.56"
          x2="21.413"
          y1="5.575"
          y2="80.446"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#5277F7"></stop>
          <stop offset="0.69" stopColor="#5B76F7"></stop>
          <stop offset="0.79" stopColor="#7374F6"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <clipPath id="clip0_1416_103248">
          <path fill="#fff" d="M0 0H64.574V80H0z" transform="translate(.668)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconBenefitProduct9 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="78" height="80" fill="none" viewBox="0 0 78 80">
      <path
        fill="url(#paint0_linear_1416_103274)"
        d="M33.972 78.512L74.527 56.76c.715-.381 1.071-.892 1.079-1.428v-2.504c-.012-.65-.53.481-1.53-.055L51.06 40.431c-1.85-.991-4.647-1.098-6.248-.242L4.262 61.94c-.534.287-.921-.929-1.06-.543-.047.128-.016 2.47-.02 2.606-.015.668.502 1.373 1.53 1.924L27.728 78.27c1.85.992 4.648 1.098 6.248.243h-.004z"
      ></path>
      <path
        fill="url(#paint1_linear_1416_103274)"
        d="M34.01 76.246l40.555-21.752c1.6-.859 1.399-2.36-.45-3.351L51.097 38.8c-1.85-.991-4.648-1.097-6.248-.242L4.299 60.309c-1.6.86-1.4 2.36.45 3.352l23.017 12.342c1.849.992 4.647 1.102 6.248.243h-.004z"
      ></path>
      <path
        fill="#fff"
        d="M4.748 63.348L27.764 75.69c1.85.992 4.648 1.098 6.248.243L74.567 54.18c.664-.356 1.016-.822 1.067-1.318.083.61-.264 1.2-1.067 1.63L34.012 76.245c-1.6.859-4.398.752-6.248-.243L4.748 63.66c-1.083-.58-1.596-1.333-1.517-2.034.083.606.592 1.226 1.517 1.722z"
      ></path>
      <path
        fill="url(#paint2_linear_1416_103274)"
        d="M26.8 68.236l32.932-17.662c.66-.352.577-.973-.186-1.38l-12.366-6.63c-.763-.408-1.913-.452-2.572-.1L11.68 60.127c-.66.353-.577.973.186 1.38l12.365 6.63c.763.408 1.913.452 2.573.1H26.8z"
      ></path>
      <path
        fill="#CED3F4"
        d="M46.468 43.615c-.265-.143-.7-.143-.969 0l-2.11 1.13c-.269.144-.269.379 0 .522.265.143.7.143.968 0l2.11-1.13c.27-.144.27-.379 0-.522zm-3.612 1.938c-.265-.143-.7-.143-.969 0l-1 .537c-.268.143-.268.378 0 .52.265.144.7.144.969 0l1-.535c.268-.143.268-.378 0-.522zm-2.502 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.265.143.7.143.968 0l1-.536c.269-.144.269-.379 0-.522zm-2.502 1.344c-.264-.143-.699-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.144-.269.379 0 .522.265.143.7.143.968 0l1-.536c.269-.143.269-.378 0-.522zm-2.502 1.344c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.144.7.144.968 0l1-.536c.269-.143.269-.378 0-.52zm-2.501 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.27.143-.27.378 0 .521.264.143.7.143.968 0l1-.536c.268-.143.268-.378 0-.521zm-2.502 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.265.143.7.143.968 0l1-.536c.269-.144.269-.379 0-.522zm-2.502 1.344c-.264-.143-.699-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.521zm-2.501 1.344c-.265-.144-.7-.144-.968 0l-1 .536c-.269.143-.269.378 0 .52.265.144.7.144.968 0l1-.535c.269-.143.269-.378 0-.521zm-2.502 1.343c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.144.7.144.968 0l1-.536c.27-.143.27-.378 0-.52zM17.84 58.99c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.265.143.7.143.968 0l1-.536c.268-.143.268-.378 0-.521zm-2.553 1.37c-.265-.144-.7-.144-.968 0l-1 .535c-.269.143-.269.378 0 .521.264.144.7.144.968 0l1-.535c.268-.144.268-.379 0-.522zm33.445-15.522l-.861-.463c-.305-.161-.799-.161-1.103 0l-.865.463c-.305.165-.309.43 0 .59l.861.463c.304.162.798.162 1.103 0l.865-.462c.304-.166.309-.43 0-.591zm-3.37 2.397l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591l.862.463c.304.162.798.162 1.102 0zm-1.633.286l-.861-.462c-.305-.162-.799-.162-1.103 0l-.866.462c-.304.166-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59zm-2.502 1.344l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .591l.861.462c.305.162.799.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591zm-5.335 1.938l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.304.162.798.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.162.798.162 1.102 0l.866-.463c.304-.165.308-.429 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.463c-.304.165-.308.429 0 .59zm-2.502 1.344l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.861-.463c-.305-.162-.799-.162-1.103 0l-.866.462c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.305.162.799.162 1.103 0l.866-.462c.304-.165.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.304.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591zm.328.746l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59l.861.463c.305.162.799.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591zm-5.335 1.938l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.102 0l-.866.463c-.304.165-.308.43 0 .591zm-3.663 1.964l.861.463c.305.161.799.161 1.103 0l1.976-1.061c.304-.165.308-.43 0-.591l-.862-.463c-.304-.162-.798-.162-1.102 0l-1.976 1.061c-.305.165-.309.43 0 .591zm36.342-16.083l-.862-.463c-.304-.161-.798-.161-1.102 0l-1.976 1.061c-.304.166-.308.43 0 .591l.861.463c.305.161.799.161 1.103 0l1.976-1.061c.304-.165.308-.43 0-.591zm-3.612 1.938l-.862-.462c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.59zm-2.506 1.935c.305-.165.309-.43 0-.591l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.309.43 0 .59l.861.464c.305.161.799.161 1.103 0l.865-.463zm-2.501 1.343c.304-.165.308-.429 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .592l.862.462c.304.162.798.162 1.102 0l.866-.462zm-4.462.29l-.866.463c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.861-.463c-.305-.162-.799-.162-1.103 0zm-2.45 1.315l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0l.972-.522c.277-.146.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.522c-.277.147-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.52c.277-.148.277-.39 0-.537l-.964-.518c-.273-.146-.72-.146-.996 0zm-2.501 1.344l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.996 0l.972-.521c.276-.147.276-.39 0-.536l-.965-.518c-.272-.147-.719-.147-.995 0zm-2.502 1.344l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0l.972-.522c.277-.147.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.522c-.276.147-.276.389 0 .536l.965.517c.272.147.719.147.995 0l.973-.521c.276-.147.276-.386 0-.536l-.965-.518c-.272-.146-.719-.146-.996 0zm-1.513 2.915l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.522c-.277.146-.277.389 0 .536l.964.517c.273.147.72.147.996 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-4.517.855l.964.518c.273.147.72.147.996 0l.973-.521c.276-.147.276-.39 0-.536l-.965-.518c-.273-.147-.719-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536zm36.449-16.024l-.964-.518c-.273-.147-.72-.147-.996 0l-3.138 1.681c-.277.147-.277.39 0 .537l.964.517c.273.147.72.147.996 0l3.138-1.681c.277-.147.277-.39 0-.536zm-4.667 2.503l-.965-.517c-.272-.147-.719-.147-.995 0l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.996 0l.972-.522c.276-.146.276-.389 0-.535zm-2.502 1.344l-.964-.518c-.273-.146-.72-.146-.996 0l-.972.522c-.277.147-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.52c.277-.148.277-.39 0-.537zm-2.501 1.344l-.965-.518c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.995 0l.973-.521c.276-.147.276-.39 0-.536zm-3.478 2.397l.972-.521c.277-.147.277-.386 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.344l.973-.522c.276-.146.276-.389 0-.536l-.965-.517c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.146.72.146.996 0zm-2.501 1.343l.972-.521c.276-.147.276-.39 0-.536l-.964-.518c-.273-.146-.72-.146-.996 0l-.972.522c-.277.146-.277.389 0 .536l.964.517c.273.147.72.147.996 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.501 1.343l.972-.52c.276-.148.276-.39 0-.537l-.965-.517c-.272-.147-.719-.147-.995 0l-.973.52c-.276.148-.276.39 0 .537l.965.517c.272.147.719.147.995 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.522c-.277.146-.277.385 0 .535l.964.518c.273.147.72.147.996 0zm-1.53.287l-.964-.518c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.995 0l.973-.522c.276-.146.276-.389 0-.535zm-6.94 2.687l.965.517c.273.147.72.147.996 0l2.47-1.325c.277-.147.277-.389 0-.536l-.964-.518c-.273-.146-.72-.146-.996 0l-2.47 1.326c-.277.147-.277.389 0 .536zm36.438-16.032l-.838-.448c-.308-.165-.814-.165-1.126 0l-4.454 2.386c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l4.454-2.386c.312-.169.312-.437 0-.602zm-6.114 3.278l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.127 0l-.841.452c-.312.168-.312.436 0 .602l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-2.502 1.343l-.838-.447c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.502 1.344l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.169.312-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .601l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-2.502 1.343l-.837-.448c-.309-.165-.815-.165-1.127 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.309.165.814.165 1.127 0l.841-.451c.313-.17.313-.437 0-.603zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602zm-2.502 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.501 1.343l-.838-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.168.312-.436 0-.602zm-2.502 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-5.367 1.979l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602zm32.398-14.89l.838.447c.308.166.814.166 1.127 0l1.952-1.046c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-1.953 1.047c-.312.168-.312.436 0 .602zm-2.501 1.343l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602l-.838-.448c-.308-.166-.814-.166-1.127 0l-.841.451c-.313.169-.313.437 0 .602zm-2.502 1.344l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602zM31.628 63.16l.838.448c.308.165.814.165 1.126 0l15.86-8.506c.312-.169.312-.437 0-.602l-.838-.448c-.309-.165-.814-.165-1.127 0l-15.859 8.506c-.312.17-.312.437 0 .602zm-2.501 1.344l.837.448c.309.165.815.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602zm-2.502 1.343l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602zm-2.553 1.37l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602z"
      ></path>
      <path
        fill="#E5E9FF"
        d="M46.468 43.33c-.265-.143-.7-.143-.969 0l-2.11 1.13c-.269.144-.269.379 0 .522.265.143.7.143.968 0l2.11-1.13c.27-.144.27-.379 0-.522zm-3.612 1.938c-.265-.143-.7-.143-.969 0l-1 .536c-.268.143-.268.378 0 .522.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.522zm-2.502 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.265.144.7.144.968 0l1-.536c.269-.143.269-.378 0-.521zm-2.502 1.344c-.264-.144-.699-.144-.968 0l-1 .536c-.268.143-.268.378 0 .52.265.144.7.144.969 0l1-.535c.268-.143.268-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.268.143.7.143.968 0l1-.536c.269-.144.269-.378 0-.522zm-2.502 1.344c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.968 0l1-.536c.269-.143.269-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .537c-.27.143-.27.378 0 .52.264.144.7.144.968 0l1-.535c.268-.143.268-.378 0-.522zm-2.502 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .522.265.143.7.143.968 0l1-.536c.269-.144.269-.379 0-.522zm-2.502 1.344c-.264-.143-.699-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.143.7.143.969 0l1-.536c.268-.143.268-.378 0-.521zm-2.501 1.343c-.265-.143-.7-.143-.968 0l-1 .536c-.269.144-.269.379 0 .522.265.143.7.143.968 0l1-.536c.269-.143.269-.378 0-.522zm-2.502 1.344c-.264-.143-.7-.143-.968 0l-1 .536c-.268.143-.268.378 0 .521.265.144.7.144.968 0l1-.536c.27-.143.27-.378 0-.52zm-2.501 1.344c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.265.143.7.143.968 0l1-.536c.268-.143.268-.378 0-.521zm-2.553 1.369c-.265-.143-.7-.143-.968 0l-1 .536c-.269.143-.269.378 0 .521.264.144.7.144.968 0l1-.536c.268-.143.268-.378 0-.521zm33.445-15.521l-.861-.463c-.305-.162-.799-.162-1.103 0l-.865.462c-.305.166-.309.43 0 .592l.861.462c.304.162.798.162 1.103 0l.865-.462c.304-.166.309-.43 0-.591zm-3.37 2.397l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.102 0zm-1.633.286l-.861-.462c-.305-.162-.799-.162-1.103 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59zm-2.502 1.344l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59l.861.463c.305.162.799.162 1.103 0l.865-.462c.305-.165.309-.43 0-.591zm-5.335 1.938l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.591l-.862-.462c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.304.162.798.162 1.103 0l.865-.462c.305-.166.309-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0l-.865.463c-.305.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.162.798.162 1.102 0l.866-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591zm-2.502 1.344l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0l-.866.463c-.304.165-.308.43 0 .591zm-2.501 1.344l.861.462c.305.162.799.162 1.103 0l.866-.462c.304-.166.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.304.165-.308.43 0 .59zm-2.502 1.343l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591zm.328.745l-.861-.462c-.304-.162-.798-.162-1.103 0l-.865.462c-.305.166-.308.43 0 .591l.861.463c.305.162.799.162 1.103 0l.865-.462c.305-.166.309-.43 0-.592zm-5.335 1.939l.862.462c.304.162.798.162 1.102 0l.866-.462c.304-.165.308-.43 0-.591l-.862-.463c-.304-.161-.798-.161-1.102 0l-.866.463c-.304.165-.308.43 0 .59zm-3.663 1.964l.861.462c.305.162.799.162 1.103 0l1.976-1.06c.304-.166.308-.43 0-.592l-.862-.462c-.304-.162-.798-.162-1.102 0l-1.976 1.06c-.305.166-.309.43 0 .592zM51.056 45.8l-.862-.463c-.304-.161-.798-.161-1.102 0L47.116 46.4c-.304.165-.308.43 0 .591l.861.463c.305.161.799.161 1.103 0l1.976-1.061c.304-.165.308-.43 0-.591zm-3.612 1.938l-.862-.462c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.102 0l.866-.463c.304-.165.308-.43 0-.59zm-2.506 1.935c.305-.166.309-.43 0-.591l-.861-.463c-.304-.161-.798-.161-1.103 0l-.865.463c-.305.165-.309.43 0 .59l.861.463c.305.162.799.162 1.103 0l.865-.462zm-2.501 1.343c.304-.165.308-.43 0-.59l-.862-.463c-.304-.162-.798-.162-1.102 0l-.866.462c-.304.166-.308.43 0 .591l.862.463c.304.162.798.162 1.102 0l.866-.463zm-4.462.29l-.866.463c-.304.165-.308.43 0 .591l.862.463c.304.161.798.161 1.103 0l.865-.463c.304-.165.308-.43 0-.591l-.861-.463c-.305-.161-.799-.161-1.103 0zm-2.45 1.315l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.146.72.146.996 0l.972-.522c.277-.147.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.522c-.277.146-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0zm-2.501 1.344l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.996 0l.972-.522c.276-.146.276-.389 0-.535l-.965-.518c-.272-.147-.719-.147-.995 0zm-2.502 1.344l-.972.52c-.277.148-.277.386 0 .537l.964.517c.273.147.72.147.996 0l.972-.52c.277-.148.277-.39 0-.537l-.964-.517c-.273-.147-.72-.147-.996 0zm-2.502 1.343l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.147.719.147.995 0l.973-.521c.276-.147.276-.39 0-.536l-.965-.518c-.272-.147-.719-.147-.996 0zm-1.513 2.915l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.344l.972-.522c.277-.146.277-.385 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.146.72.146.996 0zm-4.517.855l.964.518c.273.147.72.147.996 0l.973-.522c.276-.147.276-.389 0-.536l-.965-.517c-.273-.147-.719-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536zm36.449-16.024l-.964-.518c-.273-.147-.72-.147-.996 0l-3.138 1.681c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0l3.138-1.681c.277-.147.277-.39 0-.536zm-4.667 2.503l-.965-.517c-.272-.147-.719-.147-.995 0l-.973.521c-.276.147-.276.39 0 .536l.965.518c.272.146.719.146.996 0l.972-.522c.276-.147.276-.389 0-.536zm-2.502 1.344l-.964-.518c-.273-.146-.72-.146-.996 0l-.972.522c-.277.147-.277.389 0 .536l.964.517c.273.147.72.147.996 0l.972-.521c.277-.147.277-.39 0-.536zm-2.501 1.344l-.965-.518c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.386 0 .536l.965.518c.272.147.719.147.995 0l.973-.521c.276-.147.276-.39 0-.536zm-3.478 2.397l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.343l.973-.52c.276-.148.276-.39 0-.537l-.965-.517c-.273-.147-.72-.147-.996 0l-.972.52c-.277.148-.277.39 0 .537l.964.517c.273.147.72.147.996 0zm-2.501 1.344l.972-.521c.276-.147.276-.386 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.502 1.344l.972-.522c.277-.146.277-.389 0-.536l-.964-.517c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-2.501 1.343l.972-.521c.276-.147.276-.39 0-.536l-.965-.518c-.272-.146-.719-.146-.995 0l-.973.522c-.276.147-.276.389 0 .536l.965.517c.272.147.719.147.995 0zm-2.502 1.344l.972-.521c.277-.147.277-.39 0-.536l-.964-.518c-.273-.147-.72-.147-.996 0l-.972.521c-.277.147-.277.39 0 .536l.964.518c.273.147.72.147.996 0zm-1.53.286l-.964-.517c-.272-.147-.719-.147-.996 0l-.972.521c-.276.147-.276.39 0 .536l.965.518c.272.146.719.146.995 0l.973-.522c.276-.146.276-.389 0-.536zm-6.94 2.688l.965.517c.273.147.72.147.996 0l2.47-1.325c.277-.147.277-.39 0-.536l-.964-.518c-.273-.146-.72-.146-.996 0l-2.47 1.326c-.277.146-.277.389 0 .536zm36.438-16.032l-.838-.448c-.308-.165-.814-.165-1.126 0l-4.454 2.386c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l4.454-2.386c.312-.169.312-.437 0-.602zm-6.114 3.278l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.127 0l-.841.451c-.312.17-.312.437 0 .602l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.502 1.343l-.838-.447c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.169-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.168.312-.436 0-.602zm-2.502 1.344l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.169.312-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.502 1.343l-.837-.448c-.309-.165-.815-.165-1.127 0l-.842.452c-.312.169-.312.437 0 .602l.838.448c.309.165.814.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602zm-2.501 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-2.502 1.343l-.838-.447c-.308-.166-.814-.166-1.126 0l-.842.451c-.312.17-.312.437 0 .602l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602zm-2.501 1.344l-.838-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602l.837.448c.309.165.815.165 1.127 0l.842-.452c.312-.169.312-.437 0-.602zm-2.502 1.344l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.451c-.312.17-.312.437 0 .603l.838.447c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602zm-5.367 1.978l.838.448c.308.166.814.166 1.126 0l.842-.451c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.168-.312.436 0 .602zm32.398-14.89l.838.448c.308.166.814.166 1.127 0l1.952-1.046c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-1.953 1.046c-.312.17-.312.437 0 .602zm-2.501 1.344l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.447c-.308-.166-.814-.166-1.127 0l-.841.451c-.313.169-.313.437 0 .602zm-2.502 1.344l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.437 0 .602zm-17.519 9.394l.838.448c.308.165.814.165 1.126 0l15.86-8.506c.312-.169.312-.437 0-.602l-.838-.448c-.309-.165-.814-.165-1.127 0l-15.859 8.506c-.312.169-.312.437 0 .602zm-2.501 1.344l.837.448c.309.165.815.165 1.127 0l.841-.452c.313-.169.313-.437 0-.602l-.837-.448c-.309-.165-.814-.165-1.127 0l-.841.452c-.313.169-.313.437 0 .602zm-2.502 1.343l.838.448c.308.165.814.165 1.126 0l.842-.451c.312-.17.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.451c-.312.17-.312.437 0 .602zm-2.553 1.37l.838.448c.308.165.814.165 1.126 0l.842-.452c.312-.169.312-.437 0-.602l-.838-.448c-.308-.165-.814-.165-1.126 0l-.842.452c-.312.169-.312.436 0 .602z"
      ></path>
      <path
        fill="url(#paint3_linear_1416_103274)"
        d="M4.342 60.25L46.02 37.924c1.43-.767 2.592-2.827 2.592-4.6V2.752C48.612.98 47.45.164 46.02.932L4.342 23.254c-1.43.768-2.592 2.827-2.592 4.6v30.57c0 1.773 1.162 2.588 2.592 1.82v.004z"
      ></path>
      <path
        fill="url(#paint4_linear_1416_103274)"
        d="M4.005 58.864l41.282-22.111c1.154-.68 1.866-2.041 1.866-3.429V2.62c0-.33-.387-.536-.692-.367a3.294 3.294 0 00-.083.044l-41.31 22.13c-1.37.734-1.865 2.04-1.865 3.432v30.64c0 .352.411.575.743.4l.06-.034z"
      ></path>
      <path
        fill="url(#paint5_linear_1416_103274)"
        d="M3.203 27.858v30.64c0 .352.411.575.743.4l.06-.034 41.282-22.111c1.154-.68 1.865-2.041 1.865-3.429V2.62c0-.33-.387-.536-.692-.367a3.294 3.294 0 00-.083.044l-41.31 22.13c-1.37.734-1.865 2.04-1.865 3.432zm.293 0c0-1.04.296-2.434 1.719-3.198L46.608 2.487a.175.175 0 01.082-.022c.083 0 .17.058.17.158V33.32c0 1.325-.68 2.58-1.719 3.197L3.804 58.662a.203.203 0 01-.103.026c-.099 0-.205-.073-.205-.19v-30.64z"
      ></path>
      <path
        fill="url(#paint6_linear_1416_103274)"
        d="M3.147 22.613L44.824.289c.566-.305 1.091-.36 1.518-.206.055.019 1.237.657 1.288.683-.442-.198-1.003-.161-1.612.165L4.341 23.255c-1.431.768-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-1.276-.709-1.308-.731-.494-.32-.798-.98-.798-1.89V27.216c0-1.774 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint7_linear_1416_103274)"
        d="M3.167 22.628L44.844.301c.565-.305 1.09-.36 1.517-.206.056.018 1.214.642 1.265.672-.442-.198-1.004-.162-1.612.165L4.34 23.256c-1.43.767-2.592 2.827-2.592 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.032-.018-1.253-.697-1.285-.716-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.832 2.593-4.6h-.004z"
      ></path>
      <path
        fill="url(#paint8_linear_1416_103274)"
        d="M3.19 22.64L44.868.316c.565-.304 1.09-.36 1.517-.205.055.018 1.194.631 1.245.657-.443-.198-1.004-.162-1.613.165L4.34 23.257c-1.43.767-2.592 2.827-2.592 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.473.473 0 01-.225-.074c-.032-.018-1.233-.683-1.265-.705-.494-.32-.798-.98-.798-1.89V27.244c0-1.773 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint9_linear_1416_103274)"
        d="M3.217 22.654L44.891.33c.565-.305 1.09-.36 1.517-.206.056.019 1.17.617 1.222.643-.443-.198-1.004-.162-1.613.165L4.344 23.256c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.473.473 0 01-.225-.074c-.031-.018-1.21-.668-1.24-.69-.495-.32-.799-.98-.799-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint10_linear_1416_103274)"
        d="M3.233 22.667L44.91.34c.566-.305 1.091-.36 1.518-.206.055.018 1.15.602 1.197.632-.442-.199-1.003-.162-1.612.165L4.34 23.255c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.048a.472.472 0 01-.225-.073c-.032-.018-1.19-.657-1.221-.676-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.161-3.832 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint11_linear_1416_103274)"
        d="M3.257 22.68L44.93.354c.565-.304 1.09-.36 1.517-.205.056.018 1.127.59 1.178.616-.443-.198-1.004-.161-1.612.166L4.339 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.473.473 0 01-.225-.073c-.032-.019-1.166-.643-1.198-.665-.494-.319-.798-.98-.798-1.89V27.283c0-1.773 1.162-3.833 2.593-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint12_linear_1416_103274)"
        d="M3.28 22.695L44.957.371c.565-.305 1.091-.36 1.518-.206.055.019 1.106.577 1.154.602-.443-.198-1.004-.161-1.613.166L4.343 23.257c-1.43.767-2.592 2.826-2.592 4.6V58.43c0 1.105.45 1.839 1.138 2.048a.472.472 0 01-.226-.073c-.031-.019-1.146-.628-1.177-.65-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.161-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint13_linear_1416_103274)"
        d="M3.303 22.709L44.977.38c.565-.305 1.09-.36 1.517-.206.056.018 1.083.565 1.135.591-.443-.198-1.004-.161-1.613.165L4.343 23.255c-1.43.768-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.473.473 0 01-.225-.073c-.031-.019-1.122-.617-1.154-.636-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.832 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint14_linear_1416_103274)"
        d="M3.319 22.718L44.996.394c.566-.304 1.091-.36 1.518-.205.055.018 1.059.55 1.11.576-.442-.198-1.003-.161-1.612.165L4.339 23.254c-1.431.768-2.593 2.827-2.593 4.6v30.574c0 1.105.45 1.839 1.138 2.048a.472.472 0 01-.225-.073c-.032-.019-1.103-.602-1.134-.624-.494-.32-.798-.98-.798-1.891V27.322c0-1.773 1.161-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint15_linear_1416_103274)"
        d="M3.342 22.734L45.016.41c.565-.305 1.09-.36 1.517-.206.056.019 1.04.536 1.091.562-.443-.198-1.004-.161-1.612.165L4.338 23.255c-1.43.768-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-1.08-.592-1.11-.61-.495-.32-.799-.98-.799-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint16_linear_1416_103274)"
        d="M3.362 22.75L45.039.422c.566-.305 1.091-.36 1.518-.206.055.018 1.015.525 1.067.55C47.18.57 46.62.607 46.01.933L4.338 23.256c-1.43.767-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.032-.018-1.06-.576-1.091-.595-.494-.319-.798-.98-.798-1.89v-30.57c0-1.773 1.161-3.832 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint17_linear_1416_103274)"
        d="M3.39 22.761L45.066.437c.565-.304 1.09-.36 1.517-.205.056.018.996.51 1.047.536-.442-.199-1.003-.162-1.612.165L4.342 23.257c-1.43.767-2.593 2.827-2.593 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.031-.018-1.035-.562-1.067-.584-.494-.319-.798-.98-.798-1.89V27.365c0-1.773 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint18_linear_1416_103274)"
        d="M3.409 22.775L45.086.447c.565-.305 1.09-.36 1.518-.206.055.019.972.496 1.023.522-.442-.198-1.004-.162-1.612.165L4.34 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.473.473 0 01-.225-.073c-.032-.019-1.016-.55-1.043-.57-.494-.319-.799-.98-.799-1.89v-30.57c0-1.772 1.162-3.832 2.593-4.6h-.004z"
      ></path>
      <path
        fill="url(#paint19_linear_1416_103274)"
        d="M3.428 22.785L45.106.46c.565-.305 1.09-.36 1.517-.206.056.019.953.485 1.004.51-.443-.198-1.004-.161-1.612.166L4.337 23.255c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.473.473 0 01-.225-.073l-1.024-.554c-.494-.32-.798-.98-.798-1.891v-30.57c0-1.773 1.162-3.832 2.592-4.6v-.003z"
      ></path>
      <path
        fill="url(#paint20_linear_1416_103274)"
        d="M3.452 22.8L45.129.476c.565-.304 1.09-.36 1.518-.205.055.018.928.47.98.495-.443-.198-1.004-.161-1.613.166L4.341 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.472.472 0 01-.226-.073c-.031-.019-.972-.522-1-.544-.493-.319-.798-.98-.798-1.89V27.404c0-1.773 1.162-3.833 2.593-4.6l-.004-.003z"
      ></path>
      <path
        fill="url(#paint21_linear_1416_103274)"
        d="M3.475 22.816L45.153.488c.565-.305 1.09-.36 1.517-.205.055.018.91.455.96.48-.442-.198-1.003-.161-1.612.166L4.341 23.256c-1.43.768-2.593 2.827-2.593 4.6V58.43c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.031-.018-.948-.51-.98-.528-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="url(#paint22_linear_1416_103274)"
        d="M3.495 22.826L45.172.502c.565-.305 1.09-.36 1.518-.206.055.019.885.444.936.47-.442-.198-1.003-.161-1.612.165L4.34 23.255c-1.43.768-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-.925-.496-.956-.518-.494-.32-.799-.98-.799-1.89V27.428c0-1.773 1.162-3.832 2.593-4.6l-.004-.003z"
      ></path>
      <path
        fill="url(#paint23_linear_1416_103274)"
        d="M3.518 22.84L45.196.515c.565-.304 1.09-.36 1.517-.205.056.018.866.43.917.455-.443-.198-1.004-.161-1.612.165L4.34 23.254c-1.43.768-2.592 2.827-2.592 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.073c-.032-.019-.905-.481-.937-.503-.494-.32-.798-.98-.798-1.891V27.443c0-1.773 1.162-3.833 2.592-4.6v-.003z"
      ></path>
      <path
        fill="url(#paint24_linear_1416_103274)"
        d="M3.542 22.855L45.219.527c.565-.305 1.09-.36 1.517-.205.056.018.842.414.894.444-.443-.198-1.004-.162-1.613.165L4.344 23.255c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.139 2.049a.472.472 0 01-.226-.074c-.031-.018-.881-.47-.913-.488-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.833 2.593-4.6h-.004z"
      ></path>
      <path
        fill="url(#paint25_linear_1416_103274)"
        d="M3.561 22.867L45.24.543c.565-.305 1.09-.36 1.517-.206.055.019.822.404.873.43-.442-.199-1.003-.162-1.612.165L4.34 23.256c-1.43.767-2.593 2.827-2.593 4.6v30.573c0 1.105.45 1.84 1.138 2.049a.472.472 0 01-.225-.074c-.031-.018-.861-.455-.893-.477-.494-.32-.798-.98-.798-1.89V27.47c0-1.774 1.162-3.833 2.592-4.6v-.004z"
      ></path>
      <path
        fill="url(#paint26_linear_1416_103274)"
        d="M3.58 22.883L45.259.558c.565-.304 1.09-.36 1.518-.205.055.018.798.389.85.415-.443-.199-1.005-.162-1.613.165L4.339 23.257c-1.43.767-2.592 2.827-2.592 4.6V58.43c0 1.105.45 1.84 1.138 2.048a.473.473 0 01-.225-.073c-.032-.018-.838-.44-.87-.462-.494-.32-.798-.98-.798-1.891v-30.57c0-1.773 1.162-3.832 2.593-4.6H3.58z"
      ></path>
      <path
        fill="url(#paint27_linear_1416_103274)"
        d="M3.608 22.896L45.285.568c.566-.305 1.091-.36 1.518-.205.055.018.779.374.83.403-.443-.198-1.004-.161-1.613.166L4.343 23.256c-1.43.767-2.592 2.826-2.592 4.6v30.573c0 1.105.45 1.839 1.138 2.048a.472.472 0 01-.225-.073c-.032-.019-.818-.43-.85-.448-.494-.32-.798-.98-.798-1.89v-30.57c0-1.773 1.162-3.833 2.592-4.6z"
      ></path>
      <path
        fill="#fff"
        d="M4.217 23.2L45.895.874c.589-.316 1.126-.36 1.56-.187-.37-.055-.797.03-1.248.271L4.53 23.285c-1.43.767-2.593 2.827-2.593 4.604v30.57c0 1.045.407 1.754 1.032 2.004-.799-.118-1.344-.881-1.344-2.093V27.8c0-1.772 1.162-3.832 2.592-4.6z"
      ></path>
      <path
        fill="#EF565B"
        d="M61.215 2.06c-5.794 3.346-10.497 11.491-10.497 18.181 0 6.69 4.701 9.406 10.495 6.06 5.794-3.345 10.497-11.49 10.498-18.18 0-6.69-4.702-9.405-10.496-6.06zM58.37 21.024l-3.767-2.175c-.41-.237-.41-1 0-1.71.409-.708 1.07-1.09 1.48-.854l3.033 1.74 7.222-12.509c.41-.709 1.07-1.09 1.48-.854.41.236.41 1 0 1.709l-7.968 13.799c-.398.703-1.07 1.09-1.48.854z"
      ></path>
      <path
        fill="#F5F5FF"
        d="M44.992 21.833c0-6.702-4.692-9.41-10.496-6.06C28.692 19.127 24 27.254 24 33.956c0 6.703 4.692 9.411 10.496 6.06 5.804-3.352 10.496-11.48 10.496-18.182zm-15.01 13.88c-.409-.237-.409-1 0-1.71l3.034-5.254-3.033-1.751c-.41-.237-.41-1 0-1.71.41-.708 1.07-1.09 1.48-.854l3.033 1.751 3.033-5.254c.41-.71 1.071-1.091 1.48-.855.41.237.41 1 0 1.71l-3.033 5.254 3.033 1.75c.41.237.41 1 0 1.71-.409.709-1.07 1.09-1.48.854l-3.033-1.75-3.033 5.254c-.4.69-1.07 1.078-1.48.854z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1416_103274"
          x1="131.449"
          x2="7.658"
          y1="51.392"
          y2="71.805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#CFD1E8"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1416_103274"
          x1="102.204"
          x2="34.631"
          y1="85.826"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.85"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1416_103274"
          x1="38.348"
          x2="12.714"
          y1="59.48"
          y2="13.017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.14" stopColor="#B5BCE8"></stop>
          <stop offset="0.35" stopColor="#C7CDF0"></stop>
          <stop offset="0.58" stopColor="#E5E9FF"></stop>
          <stop offset="0.86" stopColor="#F4F6FF"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1416_103274"
          x1="81.287"
          x2="-20.554"
          y1="19.151"
          y2="43.212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.14" stopColor="#B5BCE8"></stop>
          <stop offset="0.35" stopColor="#C7CDF0"></stop>
          <stop offset="0.58" stopColor="#E5E9FF"></stop>
          <stop offset="0.86" stopColor="#F4F6FF"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1416_103274"
          x1="44.16"
          x2="3.203"
          y1="30.414"
          y2="30.414"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_1416_103274"
          x1="45.166"
          x2="-31.979"
          y1="74.23"
          y2="15.481"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_1416_103274"
          x1="34.324"
          x2="3.011"
          y1="-5.684"
          y2="61.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3BAE7"></stop>
          <stop offset="0.19" stopColor="#B7BDE9"></stop>
          <stop offset="0.28" stopColor="#BAC0E9"></stop>
          <stop offset="0.41" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B3BAE7"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_1416_103274"
          x1="34.336"
          x2="3.023"
          y1="-5.676"
          y2="61.854"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4BBE8"></stop>
          <stop offset="0.19" stopColor="#B9BEEA"></stop>
          <stop offset="0.28" stopColor="#BCC2EA"></stop>
          <stop offset="0.41" stopColor="#B2B8E6"></stop>
          <stop offset="0.43" stopColor="#B2B8E6"></stop>
          <stop offset="0.54" stopColor="#B3B9E6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B4BBE8"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_1416_103274"
          x1="34.343"
          x2="3.034"
          y1="-5.668"
          y2="61.862"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B5BCE8"></stop>
          <stop offset="0.19" stopColor="#BAC0EA"></stop>
          <stop offset="0.28" stopColor="#BDC3EB"></stop>
          <stop offset="0.41" stopColor="#B4BBE7"></stop>
          <stop offset="0.43" stopColor="#B4BBE7"></stop>
          <stop offset="0.54" stopColor="#B7BDE7"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B5BCE8"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_1416_103274"
          x1="34.359"
          x2="3.049"
          y1="-5.661"
          y2="61.865"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7BDE9"></stop>
          <stop offset="0.19" stopColor="#BCC1EB"></stop>
          <stop offset="0.28" stopColor="#BFC5EC"></stop>
          <stop offset="0.41" stopColor="#B7BDE9"></stop>
          <stop offset="0.43" stopColor="#B7BDE9"></stop>
          <stop offset="0.54" stopColor="#BAC0E9"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B7BDE9"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_1416_103274"
          x1="34.363"
          x2="3.057"
          y1="-5.655"
          y2="61.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8BFE9"></stop>
          <stop offset="0.19" stopColor="#BDC3EC"></stop>
          <stop offset="0.28" stopColor="#C1C6EC"></stop>
          <stop offset="0.41" stopColor="#B9C0EA"></stop>
          <stop offset="0.43" stopColor="#B9C0EA"></stop>
          <stop offset="0.54" stopColor="#BEC4EA"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B8BFE9"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_1416_103274"
          x1="34.374"
          x2="3.068"
          y1="-5.643"
          y2="61.875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9C0EA"></stop>
          <stop offset="0.19" stopColor="#BFC4ED"></stop>
          <stop offset="0.28" stopColor="#C2C8ED"></stop>
          <stop offset="0.41" stopColor="#BCC2EB"></stop>
          <stop offset="0.43" stopColor="#BCC2EB"></stop>
          <stop offset="0.54" stopColor="#C2C7EB"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#B9C0EA"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_1416_103274"
          x1="34.39"
          x2="3.084"
          y1="-5.635"
          y2="61.884"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BAC1EA"></stop>
          <stop offset="0.19" stopColor="#C0C6ED"></stop>
          <stop offset="0.28" stopColor="#C4C9EE"></stop>
          <stop offset="0.41" stopColor="#BEC4EC"></stop>
          <stop offset="0.43" stopColor="#BEC5EC"></stop>
          <stop offset="0.54" stopColor="#C6CBEC"></stop>
          <stop offset="0.7" stopColor="#B2B9E6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#BAC1EA"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_1416_103274"
          x1="34.397"
          x2="3.091"
          y1="-5.629"
          y2="61.886"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCC2EB"></stop>
          <stop offset="0.19" stopColor="#C2C7EE"></stop>
          <stop offset="0.28" stopColor="#C6CBEF"></stop>
          <stop offset="0.41" stopColor="#C1C7ED"></stop>
          <stop offset="0.43" stopColor="#C1C7EE"></stop>
          <stop offset="0.54" stopColor="#CACEEE"></stop>
          <stop offset="0.68" stopColor="#B6BCE7"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.99" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BCC2EB"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_1416_103274"
          x1="34.405"
          x2="3.099"
          y1="-5.623"
          y2="61.892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDC3EC"></stop>
          <stop offset="0.19" stopColor="#C4C9EF"></stop>
          <stop offset="0.28" stopColor="#C7CDF0"></stop>
          <stop offset="0.41" stopColor="#C3C9EF"></stop>
          <stop offset="0.43" stopColor="#C4C9EF"></stop>
          <stop offset="0.54" stopColor="#CDD2EF"></stop>
          <stop offset="0.66" stopColor="#B9BFE8"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.98" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BDC3EC"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_1416_103274"
          x1="34.413"
          x2="3.11"
          y1="-5.614"
          y2="61.897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BEC4EC"></stop>
          <stop offset="0.19" stopColor="#C5CAEF"></stop>
          <stop offset="0.28" stopColor="#C9CEF1"></stop>
          <stop offset="0.41" stopColor="#C6CBF0"></stop>
          <stop offset="0.43" stopColor="#C6CCF0"></stop>
          <stop offset="0.53" stopColor="#D0D4F0"></stop>
          <stop offset="0.54" stopColor="#D1D5F0"></stop>
          <stop offset="0.65" stopColor="#BDC3E9"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.98" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BEC4EC"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_1416_103274"
          x1="34.424"
          x2="3.122"
          y1="-5.606"
          y2="61.905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFC5ED"></stop>
          <stop offset="0.19" stopColor="#C7CCF0"></stop>
          <stop offset="0.28" stopColor="#CBD0F2"></stop>
          <stop offset="0.41" stopColor="#C8CEF1"></stop>
          <stop offset="0.43" stopColor="#C9CEF1"></stop>
          <stop offset="0.52" stopColor="#D3D7F1"></stop>
          <stop offset="0.54" stopColor="#D5D9F1"></stop>
          <stop offset="0.64" stopColor="#C1C6EA"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.98" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#BFC5ED"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_1416_103274"
          x1="34.436"
          x2="3.137"
          y1="-5.594"
          y2="61.909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1C7ED"></stop>
          <stop offset="0.19" stopColor="#C8CDF1"></stop>
          <stop offset="0.28" stopColor="#CCD1F2"></stop>
          <stop offset="0.41" stopColor="#CBD0F2"></stop>
          <stop offset="0.43" stopColor="#CBD1F3"></stop>
          <stop offset="0.51" stopColor="#D5D8F3"></stop>
          <stop offset="0.54" stopColor="#D9DCF3"></stop>
          <stop offset="0.63" stopColor="#C5CAEC"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.97" stopColor="#B9C0E9"></stop>
          <stop offset="1" stopColor="#C1C7ED"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_1416_103274"
          x1="34.447"
          x2="3.148"
          y1="-5.588"
          y2="61.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2C8EE"></stop>
          <stop offset="0.19" stopColor="#CACFF2"></stop>
          <stop offset="0.28" stopColor="#CED3F3"></stop>
          <stop offset="0.41" stopColor="#CDD3F3"></stop>
          <stop offset="0.43" stopColor="#CED3F4"></stop>
          <stop offset="0.51" stopColor="#D8DBF4"></stop>
          <stop offset="0.54" stopColor="#DDE0F4"></stop>
          <stop offset="0.62" stopColor="#C9CEED"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.97" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#C2C8EE"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_1416_103274"
          x1="34.455"
          x2="3.156"
          y1="-5.582"
          y2="61.918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C3C9EE"></stop>
          <stop offset="0.19" stopColor="#CBD0F2"></stop>
          <stop offset="0.28" stopColor="#D0D4F4"></stop>
          <stop offset="0.41" stopColor="#D0D5F4"></stop>
          <stop offset="0.43" stopColor="#D0D6F5"></stop>
          <stop offset="0.5" stopColor="#DADDF5"></stop>
          <stop offset="0.54" stopColor="#E1E3F5"></stop>
          <stop offset="0.62" stopColor="#CDD1EE"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.97" stopColor="#B9C0E9"></stop>
          <stop offset="1" stopColor="#C3C9EE"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_1416_103274"
          x1="34.467"
          x2="3.171"
          y1="-5.574"
          y2="61.922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4CAEF"></stop>
          <stop offset="0.19" stopColor="#CDD2F3"></stop>
          <stop offset="0.28" stopColor="#D1D6F5"></stop>
          <stop offset="0.41" stopColor="#D2D7F6"></stop>
          <stop offset="0.43" stopColor="#D3D8F6"></stop>
          <stop offset="0.5" stopColor="#DDE0F6"></stop>
          <stop offset="0.54" stopColor="#E4E7F6"></stop>
          <stop offset="0.61" stopColor="#D0D4EF"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#C4CAEF"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_1416_103274"
          x1="34.478"
          x2="3.183"
          y1="-5.566"
          y2="61.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6CBF0"></stop>
          <stop offset="0.19" stopColor="#CFD3F4"></stop>
          <stop offset="0.28" stopColor="#D3D8F6"></stop>
          <stop offset="0.41" stopColor="#D5DAF7"></stop>
          <stop offset="0.43" stopColor="#D6DAF8"></stop>
          <stop offset="0.5" stopColor="#E0E2F8"></stop>
          <stop offset="0.54" stopColor="#E8EAF8"></stop>
          <stop offset="0.61" stopColor="#D4D8F1"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9BFEA"></stop>
          <stop offset="1" stopColor="#C6CBF0"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_1416_103274"
          x1="34.486"
          x2="3.194"
          y1="-5.559"
          y2="61.933"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C7CCF0"></stop>
          <stop offset="0.19" stopColor="#D0D5F4"></stop>
          <stop offset="0.28" stopColor="#D5D9F7"></stop>
          <stop offset="0.41" stopColor="#D7DCF8"></stop>
          <stop offset="0.43" stopColor="#D8DDF9"></stop>
          <stop offset="0.49" stopColor="#E2E5F9"></stop>
          <stop offset="0.54" stopColor="#ECEEF9"></stop>
          <stop offset="0.61" stopColor="#D8DBF2"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9BFE9"></stop>
          <stop offset="1" stopColor="#C7CCF0"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_1416_103274"
          x1="34.498"
          x2="3.206"
          y1="-5.549"
          y2="61.939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C8CDF1"></stop>
          <stop offset="0.19" stopColor="#D2D6F5"></stop>
          <stop offset="0.28" stopColor="#D6DBF8"></stop>
          <stop offset="0.41" stopColor="#DADEF9"></stop>
          <stop offset="0.43" stopColor="#DBDFFA"></stop>
          <stop offset="0.49" stopColor="#E5E7FA"></stop>
          <stop offset="0.54" stopColor="#F0F1FA"></stop>
          <stop offset="0.6" stopColor="#DCDFF3"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9BFEA"></stop>
          <stop offset="1" stopColor="#C8CDF1"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_1416_103274"
          x1="34.513"
          x2="3.221"
          y1="-5.541"
          y2="61.944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C9CFF1"></stop>
          <stop offset="0.19" stopColor="#D3D8F6"></stop>
          <stop offset="0.28" stopColor="#D8DCF8"></stop>
          <stop offset="0.41" stopColor="#DCE1FA"></stop>
          <stop offset="0.43" stopColor="#DDE2FB"></stop>
          <stop offset="0.49" stopColor="#E7EAFB"></stop>
          <stop offset="0.54" stopColor="#F4F5FB"></stop>
          <stop offset="0.6" stopColor="#E0E3F4"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.96" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#C9CFF1"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_1416_103274"
          x1="34.517"
          x2="3.229"
          y1="-5.533"
          y2="61.952"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CBD0F2"></stop>
          <stop offset="0.19" stopColor="#D5D9F7"></stop>
          <stop offset="0.28" stopColor="#DADEF9"></stop>
          <stop offset="0.41" stopColor="#DFE3FC"></stop>
          <stop offset="0.43" stopColor="#E0E4FD"></stop>
          <stop offset="0.49" stopColor="#EAECFD"></stop>
          <stop offset="0.54" stopColor="#F7F8FD"></stop>
          <stop offset="0.6" stopColor="#E3E5F6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#CBD0F2"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_1416_103274"
          x1="34.529"
          x2="3.24"
          y1="-5.525"
          y2="61.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCD1F2"></stop>
          <stop offset="0.19" stopColor="#D6DBF7"></stop>
          <stop offset="0.28" stopColor="#DBDFFA"></stop>
          <stop offset="0.41" stopColor="#E1E6FD"></stop>
          <stop offset="0.43" stopColor="#E2E7FE"></stop>
          <stop offset="0.48" stopColor="#ECEFFE"></stop>
          <stop offset="0.54" stopColor="#FBFCFE"></stop>
          <stop offset="0.59" stopColor="#E7E9F7"></stop>
          <stop offset="0.71" stopColor="#B4BBE6"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#B9C0E9"></stop>
          <stop offset="1" stopColor="#CCD1F2"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_1416_103274"
          x1="34.54"
          x2="3.255"
          y1="-5.519"
          y2="61.962"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD2F3"></stop>
          <stop offset="0.43" stopColor="#E5E9FF"></stop>
          <stop offset="0.48" stopColor="#EFF1FF"></stop>
          <stop offset="0.54" stopColor="#fff"></stop>
          <stop offset="0.59" stopColor="#EBEDF8"></stop>
          <stop offset="0.7" stopColor="#B8BEE8"></stop>
          <stop offset="0.72" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="0.95" stopColor="#B9C0EA"></stop>
          <stop offset="1" stopColor="#CDD2F3"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

/* Feature Product icon */

export const IconFeatureProduct1 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="none" viewBox="0 0 52 52">
      <path
        fill="#667085"
        d="M39.654 0c.265.109.543.191.794.316 1.28.626 1.963 1.653 2.016 3.08.02.575 0 1.152 0 1.804.507 0 .987-.011 1.465 0 .99.027 2-.045 2.964.127 1.934.344 3.364 2.134 3.364 4.094.01 6.622.01 13.244 0 19.867 0 .65-.31 1.019-.85 1.026-.56.008-.876-.366-.877-1.052V17.365H1.753V45.58c0 1.888 1.055 2.93 2.961 2.93H29.94c.181-.013.363-.01.543.012.442.084.696.36.722.816a.837.837 0 01-.706.886 3.45 3.45 0 01-.542.014c-8.446 0-16.89-.038-25.335.023A4.559 4.559 0 010 45.638c.054-11.945.054-23.89 0-35.836C-.01 7.197 2.05 5.049 4.623 5.19c1.04.058 2.087.01 3.239.01-.295-2.4.136-4.415 2.772-5.2h1.303c.04.035.085.064.133.087 1.81.564 2.675 1.73 2.677 3.634v1.44h6.935c0-.614-.009-1.194 0-1.765.02-1.14.491-2.068 1.42-2.712.417-.293.925-.457 1.391-.68h1.302c.04.035.085.065.134.087 1.814.559 2.679 1.73 2.68 3.634v1.436h6.935c0-.614-.008-1.194 0-1.765.018-1.14.491-2.068 1.418-2.712.418-.293.926-.457 1.392-.68l1.3-.004zM28.56 6.954c0 .809.109 1.6-.022 2.347-.325 1.845-1.981 3.02-3.829 2.813-1.727-.193-3.02-1.692-3.027-3.514V6.955h-6.934v1.637c-.008 2.005-1.5 3.53-3.452 3.534-1.952.003-3.463-1.52-3.472-3.512V6.928H4.568c-1.72.009-2.81 1.102-2.814 2.814-.005 1.786 0 3.572 0 5.358 0 .155.02.31.03.458h46.742c0-2.09.037-4.146-.014-6.199-.03-1.146-.852-2.192-1.936-2.3-1.346-.133-2.713-.03-4.11-.03v1.644a3.463 3.463 0 01-6.924.023V6.96l-6.983-.006zM9.55 6.008c0 .847-.008 1.692 0 2.538.013 1.055.748 1.837 1.718 1.845.97.008 1.736-.773 1.745-1.819.014-1.674.014-3.348 0-5.023-.01-1.045-.78-1.828-1.745-1.818-.966.01-1.701.788-1.718 1.85-.008.807 0 1.617 0 2.427zm13.86 0c0 .847-.008 1.692 0 2.538.013 1.055.75 1.837 1.72 1.845.968.008 1.735-.774 1.743-1.82.014-1.674.014-3.348 0-5.023-.009-1.045-.78-1.828-1.745-1.817-.965.01-1.704.785-1.718 1.844-.008.814 0 1.624 0 2.434zm13.861.04c0 .828-.007 1.656 0 2.484.012 1.06.735 1.845 1.705 1.861.97.016 1.752-.779 1.76-1.86.01-1.638.01-3.276 0-4.914-.005-1.092-.747-1.887-1.736-1.886-.99.001-1.722.79-1.736 1.885 0 .81.007 1.62.007 2.43z"
      ></path>
      <path
        fill="#EA2127"
        d="M52 41.907c-.14.609-.26 1.222-.42 1.825a11.234 11.234 0 01-11.811 8.233 11.238 11.238 0 01-10.153-9.173c-1.213-6.314 3.18-12.37 9.566-13.238a11.08 11.08 0 015.22.504c.701.244.965.65.782 1.193-.184.543-.651.698-1.343.471-5.456-1.792-11.02 1.294-12.357 6.853-1.26 5.25 2.333 10.628 7.666 11.473 5.334.846 10.178-2.653 10.983-7.984.361-2.387-.163-4.61-1.603-6.627 0 .309.01.62 0 .928-.02.543-.377.893-.884.881-.482-.01-.831-.353-.837-.868a153.904 153.904 0 010-3.464c.007-.518.334-.843.854-.85 1.155-.014 2.311-.04 3.464.02.298.016.581.335.868.515v.651c-.284.434-.684.591-1.194.543-.361-.032-.727-.007-1.18-.007.958 1.288 1.619 2.581 1.985 4.015.155.606.263 1.226.392 1.84l.001 2.266z"
      ></path>
      <path
        fill="#EA2127"
        d="M41.6 35.896c0 .651.013 1.303-.006 1.947-.008.284.07.44.339.584 1.05.559 1.577 1.65 1.374 2.752a2.659 2.659 0 01-2.13 2.117c-1.106.188-2.148-.352-2.762-1.386a.74.74 0 00-.52-.311c-.76-.035-1.513-.01-2.27-.018-.596-.006-.953-.342-.95-.868.004-.526.363-.85.961-.856.72-.007 1.442-.014 2.163 0 .317.008.488-.078.681-.367.283-.41.64-.764 1.053-1.044.265-.183.346-.345.344-.64-.012-1.28-.008-2.56 0-3.839 0-.684.325-1.056.88-1.045.543.01.843.376.846 1.028.003.652-.003 1.297-.003 1.946zm-.868 3.956a.869.869 0 10.868.856.906.906 0 00-.872-.856h.004z"
      ></path>
      <path
        fill="#667085"
        d="M9.53 26.853c-.576 0-1.154.009-1.735 0a1.699 1.699 0 01-1.708-1.723c-.01-.884-.013-1.769 0-2.653a1.683 1.683 0 011.692-1.679c1.174-.012 2.347-.012 3.52 0a1.693 1.693 0 011.709 1.72c.01.884.013 1.769 0 2.653a1.69 1.69 0 01-1.693 1.681c-.593.01-1.188.001-1.784.001zm-1.688-1.757h3.41v-2.534h-3.41v2.534zM19.945 26.853h-1.678c-1.048-.01-1.772-.724-1.781-1.76-.007-.848-.007-1.695 0-2.543.009-1.018.721-1.745 1.729-1.754 1.157-.01 2.312-.01 3.464 0 1.004.009 1.72.741 1.729 1.757.008.847.008 1.695 0 2.544-.01 1.04-.732 1.746-1.784 1.756-.56.003-1.115 0-1.679 0zm-1.696-4.307v2.536h3.404v-2.536H18.25zM30.34 26.853h-1.678c-1.048-.01-1.773-.723-1.782-1.759-.007-.848-.007-1.696 0-2.544.01-1.018.722-1.745 1.729-1.754 1.157-.01 2.312-.01 3.465 0 1.003.009 1.72.74 1.728 1.756.009.848.009 1.697 0 2.544-.01 1.041-.73 1.747-1.784 1.757-.559.005-1.118 0-1.677 0zm1.724-4.283h-3.417v2.517h3.42l-.003-2.517zM40.687 26.852c-.56 0-1.12.008-1.68 0-.976-.014-1.716-.732-1.729-1.7-.011-.884-.011-1.769 0-2.653.013-.977.738-1.694 1.724-1.703 1.158-.01 2.313-.01 3.465 0 .977.009 1.717.73 1.73 1.698.014.884.014 1.769 0 2.653-.012.977-.741 1.69-1.724 1.705-.596.008-1.19 0-1.786 0zm1.75-1.755v-2.534H39.03v2.534h3.406zM9.568 36.382c-.596 0-1.193.01-1.786 0a1.697 1.697 0 01-1.69-1.687 86.541 86.541 0 010-2.706 1.679 1.679 0 011.655-1.66c1.21-.017 2.418-.017 3.628 0a1.68 1.68 0 011.633 1.627c.02.92.018 1.845 0 2.761a1.69 1.69 0 01-1.657 1.662c-.591.015-1.187.002-1.783.003zm-1.718-4.32v2.553h3.395v-2.553H7.85zM19.936 36.381c-.578 0-1.156.008-1.736 0a1.698 1.698 0 01-1.72-1.712c-.01-.885-.01-1.77 0-2.653a1.682 1.682 0 011.683-1.69c1.19-.013 2.38-.013 3.572 0a1.684 1.684 0 011.664 1.654c.017.92.019 1.845 0 2.76a1.703 1.703 0 01-1.627 1.64h-.109l-1.727.001zm-1.69-4.32v2.553h3.39V32.06h-3.39zM9.603 39.852h1.627c1.049.01 1.773.72 1.783 1.756.009.849.009 1.697 0 2.545-.01 1.04-.73 1.75-1.784 1.757-1.119.006-2.238.006-3.356 0-1.048-.007-1.773-.723-1.782-1.758-.007-.849-.007-1.697 0-2.545.009-1.041.727-1.746 1.782-1.755.574-.005 1.152 0 1.73 0zm-1.75 1.752v2.536h3.401v-2.536H7.852zM19.925 45.911c-.577 0-1.154.008-1.736 0a1.698 1.698 0 01-1.708-1.723c-.01-.884-.013-1.769 0-2.652a1.684 1.684 0 011.693-1.679c1.173-.013 2.346-.013 3.519 0a1.695 1.695 0 011.709 1.721c.01.885.013 1.77 0 2.653a1.692 1.692 0 01-1.693 1.681c-.592.008-1.188 0-1.784 0zm1.727-1.753v-2.544H18.25v2.544h3.4zM28.632 32.049v2.545c.117.05.25.091.372.155a.81.81 0 01.448.95c-.088.41-.366.651-.798.68-.86.064-1.736-.668-1.765-1.547a42.503 42.503 0 010-2.974c.027-.796.76-1.502 1.556-1.527.918-.03 1.84-.02 2.759 0a.83.83 0 01.868.843c.008.506-.341.868-.887.877-.831.009-1.66-.002-2.553-.002z"
      ></path>
    </svg>
  </span>
);

export const IconFeatureProduct2 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="52" fill="none" viewBox="0 0 50 52">
      <path
        fill="#667085"
        d="M50.001 34.634c-1.546 2.712-3.077 5.432-4.645 8.131-.6 1.033-1.753 1.366-2.868.89a100.485 100.485 0 01-3.053-1.364c-.466-.218-.845-.191-1.257.144a19.66 19.66 0 01-5.506 3.182c-.516.196-.725.524-.763 1.06a60.034 60.034 0 01-.326 3.23C31.413 51.245 30.522 52 29.164 52h-8.277c-1.4 0-2.302-.8-2.449-2.179a163.38 163.38 0 01-.318-3.23c-.04-.473-.242-.775-.697-.948a20.039 20.039 0 01-5.597-3.23c-.376-.305-.737-.345-1.168-.147-.998.46-2.001.904-3.007 1.344-1.27.555-2.375.203-3.073-1.005-1.39-2.397-2.774-4.798-4.155-7.203-.7-1.22-.445-2.36.701-3.196.848-.619 1.682-1.255 2.553-1.839.458-.305.568-.675.535-1.202a91.926 91.926 0 01-.197-4.553c-.01-.62.11-1.244.196-1.863.065-.47-.079-.799-.48-1.074-.879-.603-1.73-1.245-2.592-1.873-1.168-.85-1.418-1.988-.697-3.236 1.365-2.374 2.734-4.746 4.107-7.114.746-1.288 1.812-1.628 3.185-1.026.974.427 1.949.855 2.913 1.302.452.21.814.15 1.213-.157a38.954 38.954 0 012.195-1.549c.46-.305.901-.213 1.148.181.248.394.108.814-.338 1.12-.76.533-1.517 1.072-2.271 1.616-.75.542-1.543.639-2.39.263L7.1 9.83c-.62-.271-.878-.191-1.213.387a2321.879 2321.879 0 00-4.115 7.116c-.321.558-.257.836.255 1.211.805.59 1.592 1.21 2.426 1.753 1.078.7 1.485 1.623 1.265 2.895-.347 1.984-.27 3.977.025 5.962.145.97-.184 1.73-.957 2.298-.898.663-1.806 1.314-2.708 1.971-.576.42-.637.673-.287 1.28 1.357 2.358 2.718 4.714 4.084 7.07.338.583.597.668 1.212.4.99-.434 1.98-.866 2.96-1.323.982-.457 1.856-.357 2.694.324a18.883 18.883 0 005.242 3.035c1.044.396 1.583 1.136 1.661 2.255.073 1.029.204 2.054.318 3.077.085.743.305.936 1.046.936h8.023c.736 0 .96-.194 1.045-.938.12-1.058.231-2.117.327-3.178.091-1.004.569-1.72 1.517-2.087a20.454 20.454 0 005.504-3.19c.72-.582 1.527-.678 2.38-.305 1.053.458 2.098.934 3.15 1.394.61.266.873.18 1.211-.407a3010.85 3010.85 0 004.083-7.069c.349-.605.287-.859-.29-1.281-.79-.58-1.562-1.192-2.383-1.73-1.08-.701-1.476-1.628-1.254-2.9.348-1.983.27-3.976-.029-5.96-.146-.973.204-1.722.972-2.291.9-.663 1.807-1.312 2.708-1.971.568-.416.623-.671.268-1.287-1.35-2.344-2.702-4.684-4.057-7.021-.362-.627-.615-.706-1.291-.407-1.004.442-2.008.885-3.008 1.337-.926.418-1.77.294-2.554-.343a19.145 19.145 0 00-5.292-3.061c-1.044-.397-1.575-1.143-1.65-2.263-.068-1.012-.2-2.02-.311-3.028-.088-.789-.305-.97-1.12-.97h-7.92c-.781 0-1 .182-1.085.949a138.962 138.962 0 00-.325 3.178c-.108 1.221-1.063 2.249-2.29 2.34a.922.922 0 01-.714-.4c-.112-.204.008-.555.068-.83a.396.396 0 01.27-.214c.938-.189 1.208-.814 1.22-1.695.013-.724.204-1.444.216-2.168.02-1.284.55-2.19 1.75-2.68h9.75c.935.412 1.594 1.045 1.701 2.12.107 1.06.239 2.116.314 3.178.04.555.253.894.787 1.096 1.993.754 3.85 1.83 5.496 3.183.392.32.763.355 1.212.148 1.029-.476 2.056-.94 3.095-1.38 1.111-.475 2.26-.136 2.86.9 1.565 2.696 3.096 5.409 4.64 8.123v.916a3.146 3.146 0 01-1.305 1.68c-.826.557-1.604 1.182-2.425 1.747-.37.254-.504.555-.448.986.082.635.203 1.275.197 1.911a102.681 102.681 0 01-.193 4.548c-.033.52.054.896.523 1.203.762.499 1.468 1.082 2.224 1.593.664.448 1.195.983 1.424 1.77l.002.912z"
      ></path>
      <path
        fill="#EA2127"
        d="M25.019 29.135c-.902.935-1.66 1.806-2.504 2.583-4.203 3.867-10.99 1.995-12.665-3.46-1.578-5.166 2.515-10.34 7.899-9.993 1.996.128 3.684.915 5.088 2.317.712.712 1.425 1.433 2.178 2.185.74-.741 1.438-1.45 2.144-2.15 3.169-3.141 8.127-3.188 11.13-.041 2.158 2.259 2.795 4.965 1.792 7.922s-3.169 4.712-6.254 5.168c-.993.146-2.048-.05-3.062-.177-.66-.082-.916-.508-.781-1.006.128-.466.522-.631 1.15-.478 3.5.845 6.818-1.12 7.662-4.541a6.24 6.24 0 00-2.907-6.84c-2.362-1.378-5.445-1.027-7.418.865-.916.88-1.798 1.791-2.697 2.687-.597.595-.925.591-1.533-.014-.863-.86-1.704-1.743-2.59-2.579-1.799-1.7-3.921-2.232-6.273-1.48-2.426.773-3.839 2.515-4.254 5.011-.43 2.575.927 5.167 3.264 6.395a6.218 6.218 0 007.188-1.01c.927-.892 1.822-1.817 2.734-2.724.509-.508.891-.515 1.388-.022.962.95 1.92 1.905 2.876 2.867.38.381.415.838.096 1.163-.318.324-.778.314-1.165-.074-.808-.816-1.596-1.651-2.486-2.574z"
      ></path>
      <path
        fill="#EA2127"
        d="M17.21 30.708c-2.51-.06-4.43-1.903-4.645-4.461-.187-2.24 1.483-4.422 3.804-4.868 1.526-.293 2.934.066 4.085 1.146.986.925 1.926 1.898 2.878 2.86.407.407.4.827-.01 1.24-.927.939-1.852 1.878-2.801 2.793-.918.885-2.034 1.301-3.31 1.29zM21.529 26c-.737-.795-1.488-1.772-2.407-2.553-1.208-1.025-3.103-.771-4.178.407a3.188 3.188 0 000 4.294c1.073 1.177 2.968 1.433 4.178.407.917-.774 1.668-1.757 2.407-2.555zM33.346 30.712c-1.809-.009-2.888-.407-3.765-1.24-.979-.934-1.926-1.9-2.877-2.86-.4-.407-.39-.826.02-1.24.916-.925 1.816-1.869 2.767-2.755 1.475-1.376 3.212-1.714 5.065-.956 1.853.758 2.826 2.254 2.918 4.253.117 2.58-2.088 4.797-4.128 4.798zm-4.992-4.725c.79.814 1.533 1.675 2.37 2.43 1.244 1.12 3.21.978 4.348-.243a3.196 3.196 0 00-.021-4.367c-1.158-1.213-3.107-1.335-4.352-.204-.824.748-1.566 1.585-2.345 2.384z"
      ></path>
      <path
        fill="#667085"
        d="M25.01 39.484c-3.408-.065-6.417-1.18-8.967-3.46-.212-.191-.398-.536-.394-.807 0-.212.282-.541.5-.6.24-.066.59.05.814.203.814.536 1.555 1.208 2.41 1.668 4.464 2.407 9.728 1.777 13.559-1.55.215-.187.535-.382.786-.358.25.025.575.3.63.522a1.025 1.025 0 01-.259.834 12.788 12.788 0 01-4.032 2.564c-1.623.657-3.308.95-5.046.984zM24.975 12.516c3.416.06 6.363 1.15 8.898 3.33.132.105.255.222.365.35.269.34.267.698-.028 1.01-.295.311-.646.349-1.004.093-.137-.101-.262-.214-.389-.325-4.4-3.867-11.223-3.858-15.612.015-.623.55-1.04.61-1.398.204-.359-.407-.256-.82.375-1.362 2.55-2.196 5.522-3.265 8.793-3.315z"
      ></path>
    </svg>
  </span>
);

export const IconFeatureProduct3 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="none" viewBox="0 0 52 52">
      <path
        fill="#667085"
        d="M48.54 52.001H3.459c-.11-.042-.217-.093-.33-.125C1.266 51.354 0 49.738 0 47.83V4.166A4.15 4.15 0 014.167 0H47.83a4.15 4.15 0 013.961 2.88c.065.195.14.386.21.578v45.083c-.042.105-.092.217-.125.33-.402 1.356-1.246 2.317-2.56 2.853-.256.103-.517.185-.775.277zm1.787-35.192H1.675v30.59c0 1.944.985 2.924 2.941 2.924h42.77c1.951 0 2.942-.983 2.942-2.925v-30.59h-.002zm0-1.733v-.566V4.497c0-1.798-1.028-2.823-2.83-2.823H4.518c-1.808 0-2.836 1.02-2.836 2.813V14.55c0 .169.015.338.024.525h48.622z"
      ></path>
      <path
        fill="#EA2127"
        d="M38.096 35.74c-.307.162-.364.345-.363.65.009 3.144.01 6.289.005 9.433 0 .903-.24 1.144-1.145 1.144H6.986c-.868 0-1.115-.249-1.115-1.122V27.977c0-.898.24-1.136 1.156-1.136h25.948l-.285 1.69H9.22c.155.134.217.192.284.244L21.49 38.11a.515.515 0 00.637 0c.954-.761 1.922-1.504 2.886-2.254l3.826-2.973 1.038 1.334-3.451 2.696c3.223 2.504 6.391 4.969 9.637 7.492 0-2.814.005-5.503-.014-8.194 0-.15-.18-.351-.33-.44m0 0c-.868-.516-1.328-1.26-1.332-2.274v-.786c-1.124 0-2.172.024-3.217-.016-.28-.01-.637-.145-.81-.348-.331-.389-.19-.806.155-1.165a7.268 7.268 0 001.662-2.648l.29-1.114c.089-.342.145-.692.167-1.045.026-.412.074-.804.075-1.196.012-2.377 1.858-4.218 4.222-4.21a4.134 4.134 0 014.152 4.219c-.032 2.324.624 4.354 2.24 6.064.193.204.254.645.197.946-.077.398-.456.525-.864.516-1.062-.01-2.123 0-3.242 0v.813c-.012.994-.45 1.754-1.319 2.217 0 0-.285.22-1.124.22-.84 0-1.255-.194-1.255-.194l.004.002zm-1.402 9.508c-.046-.086-.055-.123-.078-.14a45350.64 45350.64 0 00-8.917-6.953c-.225-.176-.378-.15-.589.02-.748.6-1.507 1.188-2.27 1.77-.514.393-.808.39-1.313 0-.735-.563-1.48-1.112-2.185-1.71-.315-.262-.508-.218-.799.01a2233.314 2233.314 0 01-8.464 6.593c-.14.105-.274.227-.49.407l25.105.003zM7.585 29.435v14.94l9.604-7.472-9.604-7.468zm25.257 1.562h8.12c-1.133-1.786-1.6-3.671-1.554-5.716.034-1.504-1.119-2.652-2.532-2.634-1.413.017-2.468 1.155-2.494 2.632-.01.541-.007 1.084-.062 1.62-.15 1.466-.663 2.804-1.478 4.098zm3.23 1.733c0 .575-.175 1.183.412 1.503a1.027 1.027 0 00.864-.023c.568-.34.372-.934.381-1.48h-1.656z"
      ></path>
      <path
        fill="#667085"
        d="M29.94 18.762l2.469 2.47c-.384.326-.787.67-1.136.97l-2.41-2.407 1.077-1.033zM42.466 22.343l-1.025-1.077 2.47-2.47c.328.326.707.7 1.056 1.043l-2.501 2.505zM30.989 25.148h-3.27V23.52h3.27v1.628zM46.081 25.158h-3.265V23.52h3.265v1.64zM28.549 5.033a3.353 3.353 0 11-.066 6.706c-1.859-.009-3.324-1.504-3.319-3.387.004-1.859 1.501-3.326 3.385-3.319zm-.025 1.681a1.675 1.675 0 101.667 1.68 1.711 1.711 0 00-1.667-1.683v.003zM36.881 11.738a3.354 3.354 0 113.372-3.335 3.329 3.329 0 01-3.372 3.335zm.03-5.028c-.89-.013-1.681.768-1.681 1.663a1.676 1.676 0 101.68-1.663zM45.272 11.738a3.354 3.354 0 113.368-3.335 3.332 3.332 0 01-3.368 3.335zm0-1.681c.89.012 1.681-.763 1.69-1.658.01-.895-.76-1.68-1.66-1.69-.9-.01-1.681.764-1.69 1.659a1.714 1.714 0 001.666 1.69l-.006-.001z"
      ></path>
    </svg>
  </span>
);

export const IconFeatureProduct4 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="none" viewBox="0 0 52 52">
      <path
        fill="#667085"
        d="M0 18.281V16.25c.039-.18.086-.357.114-.538.853-5.735 5.743-9.8 11.552-9.604h.521V3.173a3.23 3.23 0 01.74-2.107C13.408.49 14.06.242 14.728 0H41.03c.27.197.571.364.806.596 3.198 3.182 6.389 6.374 9.572 9.573.232.232.396.532.591.8V49.46c-.102.265-.192.535-.305.793-.438.968-1.264 1.448-2.234 1.746H14.727c-2.084-.854-2.54-1.542-2.54-3.835V28.429c-.282 0-.5-.005-.717 0-4.747.143-9.156-2.835-10.754-7.312C.39 20.203.235 19.227 0 18.28zm39.813-16.25H15.657c-1.127 0-1.438.315-1.438 1.459 0 .828.024 1.66-.01 2.487-.018.406.101.585.498.71a11.172 11.172 0 017.637 10.596c-.01 4.773-3.104 9.067-7.617 10.553-.38.125-.517.28-.516.701.016 6.669.02 13.338.01 20.008 0 1.103.322 1.422 1.423 1.422h32.903c1.102 0 1.422-.322 1.422-1.422V12.187h-8.75c-1.073 0-1.406-.327-1.407-1.388V2.031zm-29.657 6.21c-3.74.224-8.037 3.642-8.12 8.923-.078 5.055 4.063 9.252 9.141 9.242 5.281-.015 8.763-4.265 9.027-8.119h-8.676c-1.034 0-1.37-.338-1.372-1.37V8.241zm10.055 7.982c-.345-4.288-4.177-7.76-7.983-7.98v7.98h7.983zm28.047-6.094l-6.376-6.366v6.37l6.376-.004z"
      ></path>
      <path
        fill="#EA2127"
        d="M42.03 31.742c-.712-1.273-.672-2.513.27-3.666.906-1.11 2.538-1.366 3.825-.63 1.252.718 1.8 2.24 1.313 3.649-.463 1.335-1.909 2.198-3.295 1.99-.203-.03-.502-.007-.622.12-2.285 2.424-4.559 4.866-6.855 7.333.508.856.66 1.751.327 2.713-.545 1.577-2.243 2.403-3.86 1.858-1.56-.525-2.424-2.255-1.864-3.804.128-.355.067-.578-.165-.855a147.488 147.488 0 01-2.58-3.203c-.196-.25-.367-.265-.68-.222a6.24 6.24 0 01-1.696-.018c-.299-.043-.482-.055-.698.184a220.605 220.605 0 01-3.17 3.434c-.19.204-.219.365-.133.624.584 1.75-.377 3.515-2.132 3.949a3.03 3.03 0 11-1.03-5.956c.424-.042.864.11 1.298.136.17.01.406-.03.512-.14 1.101-1.169 2.19-2.351 3.266-3.548.108-.122.14-.4.087-.568-.379-1.198-.142-2.268.728-3.137.887-.886 1.985-1.14 3.181-.701 1.152.421 1.821 1.28 1.96 2.488.051.453-.115.927-.149 1.394-.014.204-.017.477.096.623.881 1.136 1.797 2.246 2.69 3.374.17.216.32.252.598.203.473-.085.966-.059 1.45-.102.166-.014.383-.035.483-.142a1250.16 1250.16 0 006.79-7.276.488.488 0 00.054-.104zm3.565-1.695a1.007 1.007 0 10-.991 1.023 1.042 1.042 0 00.991-1.023zm-17.57 4.062a1.008 1.008 0 10-.991 1.024 1.042 1.042 0 00.99-1.024zm-7.719 8.158a1.008 1.008 0 10-1.024.99 1.039 1.039 0 001.024-.99zm13.82.99a1.007 1.007 0 10-1.008-1.007 1.045 1.045 0 001.009 1.008z"
      ></path>
      <path
        fill="#667085"
        d="M37.174 16.249h7.312c.17-.007.34-.001.508.017a1.002 1.002 0 010 1.995 3.5 3.5 0 01-.508.017H29.76c-.825-.005-1.314-.383-1.315-1.016 0-.632.49-1.015 1.313-1.015l7.416.002zM37.172 22.345h-7.363a2.538 2.538 0 01-.602-.054.987.987 0 01.005-1.922c.18-.04.362-.058.546-.056h14.828c.219-.006.438.023.648.086a.983.983 0 01-.006 1.855 2.294 2.294 0 01-.7.085c-2.452.004-4.904.006-7.356.006zM31.384 6.094h5.078c.219-.007.437.022.648.084a.922.922 0 01.656.931.914.914 0 01-.656.929 2.266 2.266 0 01-.7.085c-3.35.005-6.702.005-10.054 0h-.354c-.591-.054-1.01-.474-1.01-1.01a1.015 1.015 0 011.009-1.01c.658-.029 1.32-.008 1.98-.01h3.402zM31.384 10.157c1.709 0 3.42-.01 5.127.01.29 0 .664.055.844.236.22.223.407.627.366.914-.04.288-.357.577-.621.774-.163.121-.455.094-.688.095-3.352.005-6.703.005-10.055 0h-.305c-.624-.04-1.06-.458-1.06-1.016 0-.557.435-.991 1.06-1.01.76-.022 1.523-.007 2.284-.007l3.048.004zM25.392 18.273a1.007 1.007 0 111.006-1.01 1.042 1.042 0 01-1.006 1.01zM26.398 21.306a1.007 1.007 0 11-1.03-.986 1.04 1.04 0 011.03.986zM10.888 24.368c-3.697-.13-6.781-3.267-6.818-6.907-.006-.848.604-1.384 1.315-1.14.5.17.686.558.71 1.057.087 1.625.757 2.962 2.065 3.95.86.649 1.843.964 2.92 1.015.852.044 1.34.78.982 1.463-.253.49-.695.605-1.174.562z"
      ></path>
    </svg>
  </span>
);

export const IconFeatureProduct5 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="52" fill="none" viewBox="0 0 51 52">
      <path
        fill="#667085"
        d="M40.599 40.492c-1.143-1.118-1.678-2.579-1.634-4.262.056-2.378 1.553-3.888 3.902-3.954 2.378-.069 3.992 1.386 4.133 3.767.098 1.656-.365 3.136-1.538 4.351-.058.06-.105.128-.184.221.782.17 1.539.273 2.255.508a8.252 8.252 0 011.927.897c.98.641 1.464 1.597 1.456 2.797-.011 1.744 0 3.488 0 5.232 0 1.17-.768 1.945-1.929 1.948-3.994.007-7.988.007-11.983 0-1.163 0-1.918-.768-1.925-1.946-.011-1.692.023-3.384-.011-5.075-.031-1.49.613-2.61 1.91-3.217 1.141-.544 2.398-.851 3.62-1.267zm7.092 9.83c.398 0 .715-.026 1.024.006.42.044.538-.119.532-.531-.02-1.586-.04-3.175 0-4.755.026-.929-.384-1.53-1.167-1.92a5.676 5.676 0 00-1.12-.427c-2.171-.56-4.374-.716-6.572-.28-.949.206-1.875.503-2.767.887a1.372 1.372 0 00-.863 1.281 288.083 288.083 0 000 5.389c0 .116.14.323.218.33.42.033.852.015 1.307.015V46.42c0-.682.296-1.039.83-1.043.535-.004.84.352.84 1.03.007 1.118 0 2.237 0 3.349 0 .182.018.364.028.527h6.032v-3.647a2.999 2.999 0 01.03-.572c.091-.456.382-.7.85-.681.47.018.749.29.777.755.03.505.015 1.011.015 1.517.006.876.006 1.737.006 2.667zm-7.05-13.63c.018.886.355 1.736.948 2.395.852.93 1.996.944 2.813-.02.948-1.119 1.21-2.435.721-3.812a2.113 2.113 0 00-.979-1.066c-1.807-.881-3.5.215-3.508 2.503h.005zM5.693 40.635c-1.303-1.268-1.841-2.752-1.779-4.451.118-3.242 3.458-5.023 6.252-3.343 1.201.722 1.698 1.86 1.778 3.197.102 1.698-.38 3.203-1.607 4.43a.986.986 0 00-.105.161c.646.13 1.27.241 1.886.384.998.23 1.93.605 2.69 1.321a3.094 3.094 0 011.043 2.315c0 1.832.016 3.664 0 5.495a1.8 1.8 0 01-1.864 1.849c-4.03.01-8.06.01-12.09 0-1.101 0-1.873-.785-1.88-1.887-.011-1.779 0-3.558 0-5.337 0-1.156.503-2.043 1.408-2.721 1.158-.866 2.53-1.12 3.916-1.357l.352-.056zm5.277 9.668v-.612c0-1.134-.008-2.267 0-3.402 0-.572.31-.895.795-.911.51-.019.853.313.867.896.02.82.007 1.64.007 2.459v1.589c.384 0 .699-.026 1.005.006.42.042.544-.107.539-.525-.021-1.604-.032-3.217 0-4.813.018-.856-.341-1.443-1.07-1.818a5.94 5.94 0 00-1.208-.48c-2.171-.559-4.375-.718-6.574-.288a15.2 15.2 0 00-2.762.897 1.375 1.375 0 00-.868 1.277 247.245 247.245 0 000 5.388.44.44 0 00.258.337c.407.04.821.016 1.274.016v-3.985c0-.608.3-.944.802-.958.524-.012.856.333.865.957.016.941 0 1.884 0 2.825v1.145h6.07zm-.699-13.482c.049-2.734-1.722-3.148-3.288-2.733a1.648 1.648 0 00-1.203 1.139c-.443 1.457-.201 2.804.837 3.933.766.839 1.832.818 2.632.014a3.616 3.616 0 001.029-2.353h-.007zM5.688 8.428C4.388 7.186 3.856 5.699 3.918 4 4.027.736 7.4-1.053 10.196.664c1.172.72 1.665 1.845 1.748 3.163.109 1.756-.41 3.297-1.76 4.598.607.12 1.157.225 1.705.341.98.209 1.912.539 2.701 1.184.814.665 1.267 1.51 1.259 2.58 0 1.779.01 3.556 0 5.335-.009 1.18-.746 1.926-1.937 1.929-3.992.011-7.984.011-11.978 0-1.184 0-1.916-.764-1.921-1.944-.011-1.676.033-3.35-.011-5.022-.04-1.56.66-2.684 2.006-3.318.93-.44 1.972-.647 2.968-.948.235-.058.473-.102.712-.134zm6.957 9.696c.41 0 .723-.02 1.033 0 .387.032.515-.109.51-.502-.019-1.656-.019-3.312 0-4.97a1.679 1.679 0 00-.87-1.557 5.637 5.637 0 00-1.285-.56 15.21 15.21 0 00-6.369-.388c-1.049.154-2.097.328-3.032.896-.498.304-.913.7-.923 1.312-.03 1.818-.02 3.625 0 5.438a.437.437 0 00.291.31c.392.038.789.014 1.243.014v-.63-3.294c0-.655.33-1.04.848-1.027.494.013.817.395.822 1.013.01 1.063 0 2.127 0 3.19v.71h6.057v-.66c0-1.133-.01-2.265.012-3.398a.818.818 0 01.805-.856c.445-.01.797.324.84.822.022.225.012.453.012.68.007 1.137.006 2.256.006 3.457zM10.289 4.29c-.008-.196 0-.371-.025-.545-.14-1.169-.81-1.855-1.935-1.981-1.298-.14-2.266.34-2.574 1.373-.404 1.36-.16 2.635.757 3.726.818.979 2.008.96 2.85 0 .653-.733.9-1.627.927-2.573zM40.734 8.43C39.3 7.008 38.752 5.342 39.02 3.457c.347-2.378 2.252-3.703 4.637-3.344 2.579.389 3.556 2.471 3.318 4.742-.146 1.4-.388 1.852-1.688 3.578.687.14 1.382.234 2.04.442.683.202 1.34.484 1.958.84 1.088.66 1.641 1.66 1.626 2.967-.021 1.71 0 3.42-.007 5.13 0 1.242-.737 1.984-1.989 1.987-3.96.009-7.923.009-11.888 0-1.246 0-1.958-.748-1.967-2.007-.007-1.657.03-3.316-.012-4.972-.039-1.538.642-2.657 1.971-3.292.946-.45 2.006-.661 3.017-.97.23-.054.463-.097.698-.128zm5.28 9.662v-.588-3.193c0-.736.315-1.15.854-1.142.538.008.815.398.823 1.111v2.827c0 1.034 0 1.018 1.019 1.027.402 0 .545-.107.54-.532-.024-1.64-.024-3.279 0-4.919a1.7 1.7 0 00-.898-1.598 5.417 5.417 0 00-1.24-.542 15.214 15.214 0 00-6.374-.394c-1.066.155-2.14.327-3.077.92-.477.3-.876.687-.884 1.28-.025 1.818-.02 3.63 0 5.443a.44.44 0 00.287.315c.391.038.789.014 1.233.014v-1.108c0-.994-.012-1.989.012-2.983.012-.529.395-.88.86-.86.464.02.768.355.795.87.019.33.007.663.009.994v3.057h6.04zm-5.377-13.55c.032.822.331 1.61.852 2.246.864 1.059 2.137 1.076 2.987 0 .85-1.075 1.06-2.29.715-3.6a1.792 1.792 0 00-1.102-1.243c-1.845-.762-3.444.294-3.452 2.597z"
      ></path>
      <path
        fill="#EA2127"
        d="M17.574 31.617a6.34 6.34 0 01.28-.613c.194-.35.417-.685.667-.998.368-.427.395-.825.133-1.318-.14-.267-.26-.443-.589-.486-.499-.065-.99-.19-1.484-.297-.597-.13-.823-.4-.839-1.02a47.28 47.28 0 010-1.725c.011-.575.24-.866.806-.99.387-.1.78-.177 1.177-.228.544-.05.867-.28 1.037-.826.098-.32.11-.538-.09-.808-.302-.404-.56-.839-.839-1.259-.295-.44-.27-.847.108-1.225l1.295-1.295c.376-.377.783-.41 1.224-.114.377.251.777.472 1.131.752s.653.319 1.082.117c.371-.172.594-.34.641-.763.066-.466.156-.927.27-1.383.126-.568.399-.796.987-.809a41.717 41.717 0 011.726 0c.64.011.9.24 1.032.881.107.51.206 1.024.316 1.539.101.46 1.016.839 1.417.583.455-.29.898-.6 1.354-.89.52-.332.83-.31 1.259.107.429.416.865.86 1.293 1.295.357.362.39.76.112 1.183-.296.452-.597.9-.89 1.354-.294.453.057 1.358.594 1.473.51.109 1.023.207 1.538.317.599.129.825.397.84 1.017.01.56.01 1.119 0 1.678-.01.654-.23.92-.858 1.053a9.772 9.772 0 01-1.127.218c-.541.05-.869.28-1.037.825-.096.318-.114.538.088.807.301.405.56.84.84 1.26.28.419.27.847-.108 1.224l-1.294 1.295c-.377.377-.784.409-1.226.114-.377-.252-.775-.474-1.129-.756-.354-.28-.659-.312-1.085-.113-.37.172-.593.341-.64.765-.065.466-.155.927-.27 1.383-.124.567-.4.796-.988.809-.589.012-1.151.01-1.726 0-.639-.011-.896-.24-1.03-.883-.107-.51-.206-1.023-.317-1.538-.1-.463-1.014-.84-1.416-.58-.456.29-.9.6-1.354.89-.52.329-.84.302-1.259-.113-.42-.415-.852-.824-1.259-1.259a3.953 3.953 0 01-.393-.65zm13.34-11.495c-.537.351-1.035.667-1.522.999a.965.965 0 01-1.032.078c-.502-.235-1.047-.386-1.527-.657a1.585 1.585 0 01-.643-.728c-.17-.41-.215-.876-.301-1.32-.05-.26-.05-.512-.444-.505-.364.007-.363.24-.41.48-.09.443-.2.884-.28 1.33-.081.446-.34.649-.737.788-.48.16-.946.352-1.399.576-.404.205-.752.2-1.119-.056-.484-.333-.979-.648-1.49-.98l-.453.476c.35.536.669 1.034 1 1.525.23.338.227.664.05 1.032-.226.469-.425.95-.598 1.44-.14.397-.36.66-.791.735-.463.08-.92.194-1.382.28-.236.044-.42.086-.42.406 0 .32.153.382.403.428.48.088.954.206 1.434.292.41.075.62.33.753.7.158.479.35.946.572 1.398.221.42.212.785-.057 1.17-.326.47-.632.953-.928 1.398l.434.516c.52-.338 1.019-.653 1.505-.987.355-.244.691-.24 1.077-.05.47.227.952.43 1.445.604.376.14.63.347.7.756.083.463.198.92.279 1.382.047.257.09.457.44.45.322 0 .357-.194.402-.429.09-.462.204-.917.28-1.38.074-.435.338-.65.737-.788.478-.16.946-.352 1.398-.576.404-.207.751-.2 1.119.056.484.333.979.645 1.492.979l.45-.474c-.35-.536-.721-1.007-.978-1.539a1.479 1.479 0 01-.073-.966 7.493 7.493 0 01.653-1.584c.162-.274.407-.489.7-.613.419-.165.878-.209 1.32-.302.244-.053.524-.014.531-.42.007-.405-.247-.393-.505-.443-.445-.087-.884-.197-1.33-.28-.411-.074-.622-.327-.755-.7-.158-.478-.35-.945-.572-1.398-.22-.42-.215-.783.054-1.169.336-.48.646-.979.98-1.478l-.462-.452z"
      ></path>
      <path
        fill="#667085"
        d="M31.467 4.137h3.61c.636 0 1 .298 1.013.803.012.505-.371.865-1.02.868h-6.801c-1.305 0-1.958.653-1.958 1.958v4.29c0 .723-.28 1.095-.824 1.103-.544.008-.849-.368-.85-1.075V7.637c-.003-2.041 1.433-3.483 3.474-3.499 1.119-.007 2.238-.001 3.356-.001zM26.293 42.31c0 .768.014 1.539 0 2.301a3.356 3.356 0 01-3.299 3.313c-1.515.027-3.03.012-4.547 0-.594 0-.94-.307-.95-.807-.01-.499.349-.855.966-.86 1.41-.012 2.822 0 4.233 0 1.259 0 1.925-.674 1.926-1.942V39.82c0-.577.345-.923.85-.913.481.01.796.35.819.895.008.226 0 .453 0 .68v1.829h.002zM11.681 26.91c-.64-.043-1.295-.022-1.92-.14a3.284 3.284 0 01-2.635-3.046 23.548 23.548 0 01-.015-1.777c.011-.55.331-.9.798-.919.468-.018.84.352.865.915.02.505 0 1.01.012 1.516.035 1.037.73 1.723 1.764 1.737.82.012 1.638 0 2.457 0 .617 0 .98.324.98.839 0 .514-.367.822-.99.83H11.69l-.009.045zM39.24 25.158c.643.044 1.296.021 1.922.14a3.28 3.28 0 012.638 3.045c.035.607.03 1.22.013 1.828-.014.513-.343.851-.793.871-.45.02-.84-.336-.863-.86-.024-.525 0-1.011-.013-1.516-.03-1.1-.72-1.783-1.818-1.793-.803-.007-1.604 0-2.406 0-.616 0-.979-.325-.979-.84 0-.514.363-.822.986-.83h1.308l.006-.045z"
      ></path>
      <path
        fill="#EA2127"
        d="M25.457 21.635a4.4 4.4 0 11-4.394 4.379 4.394 4.394 0 014.394-4.38zm2.734 4.408a2.725 2.725 0 00-5.397-.548 2.726 2.726 0 105.396.548h.001z"
      ></path>
    </svg>
  </span>
);

export const IconFeatureProduct6 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="none" viewBox="0 0 52 52">
      <g clipPath="url(#clip0_1949_54442)">
        <path
          fill="#667085"
          d="M36.563 46.991a.282.282 0 00-.181.263v2.171c0 .483-.305.735-.745.825a2.823 2.823 0 01-.557.02H3.096c-1.108 0-1.347-.237-1.347-1.335V3.097c0-1.11.236-1.35 1.331-1.35h27.217c.013.197.034.374.035.55 0 .897-.005 1.793 0 2.69.014 1.78 1.077 2.838 2.848 2.84h3.17v4.563a.282.282 0 00.166.258c.417.189.845.407 1.22.61a.284.284 0 00.417-.25c.008-1.79-.005-3.582.007-5.372a2.301 2.301 0 00-.723-1.765A464.497 464.497 0 0132.273.7a2.188 2.188 0 00-1.667-.69C21.348.022 12.09.04 2.842 0 1.257-.007 0 1.215 0 2.862.033 18.155.033 33.448 0 48.74c0 1.602.509 2.707 2.049 3.255H36.06c.493-.305 1.042-.558 1.463-.945.52-.478.636-1.172.636-1.868 0-.824.005-1.648 0-2.47a.281.281 0 00-.407-.254c-.358.18-.78.371-1.19.532zM32.1 3.106l2.92 2.918c-.764 0-1.547.05-2.316-.031-.221-.024-.55-.407-.577-.65-.077-.729-.027-1.47-.027-2.237z"
        ></path>
        <path
          fill="#EA2127"
          d="M50.586 46.408c-2.188-2.167-4.358-4.351-6.538-6.527a4.699 4.699 0 00-.391-.324c.551-1.01 1.109-1.918 1.556-2.876 3.547-7.591 1.001-16.714-5.834-21.406l-.013-.008c-1.9-1.27-3.459-1.892-3.895-2.056l-.125-.045c-4.69-1.622-9.315-1.376-13.835.909-3.068 1.55-5.449 3.865-7.14 6.861-3.485 6.178-3.035 13.754 1.512 19.253 5.371 6.5 12.207 7.998 20.06 5.43l.382-.128a11.224 11.224 0 001.953-1.059c.198-.128.407-.27.63-.427h.006c.17-.109.34-.232.526-.353.123.113.248.218.364.334 2.202 2.2 4.408 4.394 6.599 6.606.574.578 1.16 1.119 1.932 1.417h1.526a3.459 3.459 0 002.131-2.137v-1.526c-.283-.777-.822-1.364-1.406-1.938zm-21.144-1.342c-8.586 0-15.544-7-15.537-15.625A15.541 15.541 0 0129.51 13.904c8.58 0 15.592 7.019 15.556 15.553-.038 8.65-7.004 15.61-15.625 15.61zm12.614-1.373l-1.124-1.112 1.664-1.628 1.047 1.163-1.587 1.577zm7.85 6.212c-.465.46-1.22.455-1.73-.054-1.6-1.58-3.187-3.173-4.797-4.781l1.698-1.69c1.598 1.604 3.22 3.212 4.822 4.84a1.194 1.194 0 01.005 1.685h.002z"
        ></path>
        <path
          fill="#667085"
          d="M28.559 8.176c-.25-1.258-1.254-2.086-2.617-2.09-4.58-.013-9.16-.013-13.741 0a2.886 2.886 0 00-.798.11c-1.266.372-2.006 1.556-1.83 2.898.157 1.211 1.266 2.181 2.543 2.187 2.332.01 4.665 0 6.997 0 2.316 0 4.632.012 6.947 0a2.58 2.58 0 002.499-3.105zm-2.312 1.31c-.196.048-.398.07-.6.063h-13.14a2.606 2.606 0 01-.455-.021c-.461-.083-.775-.454-.757-.878a.852.852 0 01.867-.814c.728-.016 1.455 0 2.182 0h11.517c.453 0 .804.14.957.586a.815.815 0 01-.57 1.064zM17.223 46.813c-1.825.008-3.651 0-5.476 0H6.22c-.407 0-.777-.121-.9-.509-.08-.255-.083-.668.07-.833.248-.237.574-.374.916-.386 1.792-.036 3.583-.018 5.375-.018h5.477c.61 0 .95.234 1.034.682.11.61-.289 1.06-.97 1.064zM16.47 15.6c.005.552-.349.872-1.003.874-1.553.006-3.107 0-4.66 0-1.573 0-3.143.007-4.714 0a.851.851 0 01-.743-1.324.887.887 0 01.473-.362 1.42 1.42 0 01.4-.039h9.222c.653-.005 1.02.307 1.025.851zM13.434 42.347c-.2.086-.416.126-.634.115-1.082.011-2.165 0-3.247 0H6.255c-.648 0-1.037-.324-1.048-.846-.01-.521.407-.885 1.063-.886h6.646c.484 0 .814.204.938.679a.775.775 0 01-.42.938zM13.01 19.956c-.006.53-.393.862-1.03.865H6.25c-.627 0-1.033-.346-1.043-.863-.01-.516.377-.877 1.018-.88 1.927-.008 3.854-.008 5.78 0 .65.003 1.016.336 1.006.878zM11.282 24.267c0 .545-.387.883-1.063.893-.659.01-1.317 0-1.976 0H6.317c-.705-.007-1.119-.354-1.11-.904.012-.534.421-.865 1.095-.867 1.3-.006 2.601-.006 3.902 0 .68.008 1.073.335 1.078.878zM11.282 37.242c.017.532-.36.904-.992.91-1.368.016-2.736.016-4.104 0-.6-.006-.977-.374-.979-.877 0-.519.4-.877 1.023-.887.676-.011 1.351 0 2.028 0 .676 0 1.35-.01 2.026 0 .6.01.982.347.998.854zM10.416 32.948c0 .493-.375.86-.925.866-1.113.013-2.227.013-3.34 0-.545-.006-.93-.372-.944-.854-.014-.509.363-.857.956-.887h1.72c.539 0 1.08-.014 1.618 0 .56.023.92.378.915.875zM10.417 28.596c.006.496-.36.857-.916.87-.573.013-1.146 0-1.72 0-.556 0-1.113.011-1.67 0-.556-.011-.915-.386-.908-.876.007-.49.394-.846.941-.85 1.113-.008 2.226-.008 3.339 0 .558.006.928.36.934.856z"
        ></path>
        <path
          fill="#EA2127"
          d="M29.5 43.336c-6.582.063-12.55-4.893-13.647-11.37-1.244-7.334 3.09-14.1 10.252-15.934 1.005-.258 2.065-.314 3.104-.419.662-.066 1.094.288 1.12.822.025.534-.4.903-1.092.93-4.611.184-8.132 2.263-10.387 6.27-4.123 7.33.447 16.56 8.762 17.825 6.567.998 12.722-3.424 13.813-9.924 1.042-6.206-2.747-12.106-8.823-13.781-.322-.089-.684-.342-.838-.623-.112-.203-.005-.676.176-.853a1.105 1.105 0 01.898-.237c4.058 1.043 7.088 3.432 8.982 7.163 4.246 8.361-.825 18.338-10.1 19.928-.73.122-1.479.14-2.22.203z"
        ></path>
        <path
          fill="#EA2127"
          d="M26.857 31.726l6.036-6.039c.114-.124.237-.24.367-.349a.86.86 0 011.154.074.87.87 0 01.054 1.154 3.037 3.037 0 01-.276.297l-6.458 6.458c-.672.671-1.034.671-1.702.006-.478-.477-.963-.95-1.432-1.436-.407-.424-.417-.95-.045-1.302.35-.333.874-.315 1.27.068.34.328.66.68 1.032 1.069z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1949_54442">
          <path fill="#fff" d="M0 0H52.001V52H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconFeatureProduct7 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64">
      <g clipPath="url(#clip0_1416_102953)">
        <path
          fill="#667085"
          d="M59.89 59.867c.36 0 .707.013 1.054 0 1.719-.069 3.02-1.377 3.032-3.104.019-2.686.011-5.373 0-8.058 0-1.979-1.3-3.275-3.293-3.29-1.628-.012-3.244 0-4.956 0v-.702-5.31c-.008-1.948-1.307-3.256-3.248-3.268-2.026-.009-5.555 0-8.11 0h-1.476c-.224 0 1.479 2.117 1.479 2.117.235-.018.433-.045.626-.045h7.246c1.103 0 1.407.307 1.41 1.411v5.121c0 .203-.02.405-.035.676h-3.2c-.627 0-1.253-.015-1.879 0-1.764.057-3.077 1.252-3.116 3.013-.062 2.81-.062 5.62 0 8.43.039 1.783 1.385 2.982 3.18 3.013h.89v2.003h-12.3v-2.003h.943c1.801-.043 3.107-1.329 3.121-3.13.023-2.706.019-5.413 0-8.12-.011-1.885-1.29-3.17-3.177-3.202-1.436-.024-2.872 0-4.308 0h-.718v-4.107L32 41.296l-1.058-.016v4.14h-1.037c-1.29 0-2.582-.01-3.873 0-2.037.014-3.3 1.285-3.307 3.328-.007 2.561-.007 5.122 0 7.683 0 2.208 1.23 3.435 3.44 3.446h.648v2.003h-12.32v-2.003h.891c1.795-.032 3.13-1.23 3.178-3.015.063-2.81.063-5.62 0-8.433-.041-1.787-1.37-2.982-3.181-3.005-1.643-.022-3.286 0-4.961 0a3.7 3.7 0 01-.063-.448c0-1.853-.007-3.706 0-5.56 0-.783.33-1.183 1.05-1.188 2.567-.017 5.526-.009 8.222-.007h.433l-.153-2.089h-8.294c-2.058.007-3.35 1.299-3.35 3.36v5.92H3.339c-.864 0-1.696.167-2.283.817-.43.475-.712 1.1-1.056 1.65v9.498c.525 1.517 1.503 2.459 3.187 2.493.286.006.574 0 .9 0v2.003H0v2.129h63.983v-2.073H59.89v-2.062zM2.083 48.511c.01-.664.413-1.01 1.096-1.012 4.078-.007 8.156-.007 12.233 0 .645 0 1.068.364 1.077.966.024 1.703.009 3.406.009 5.157H2.073c0-1.745-.018-3.429.01-5.111zm10.244 13.387H6.252v-1.992h6.074v1.992zm-1.644-4.104c-2.31 0-4.62-.05-6.928.016-1.565.045-1.86-.594-1.612-2.035h14.346c.02.384.016.769-.01 1.152-.065.561-.482.858-1.179.863-1.538.009-3.079.004-4.617.004zm14.102-9.366c.011-.575.453-.927 1.056-.928 4.1-.007 8.201-.007 12.302 0 .6 0 1.044.353 1.055.928.035 1.722.013 3.443.013 5.202H24.772c0-1.759-.023-3.48.012-5.202zm1.117 9.358c-.74 0-1.103-.386-1.138-1.12-.013-.268 0-.54 0-.867H39.22c0 .326.011.596 0 .867-.035.733-.398 1.119-1.137 1.12-4.061.01-8.122.01-12.183 0zm9.158 4.09h-6.135v-1.97h6.135v1.97zm12.432-13.41c.01-.644.448-.968 1.2-.97h10.86c.416 0 .833-.008 1.252 0 .683.018 1.086.35 1.097 1.013.028 1.683.009 3.367.009 5.105H47.485c0-1.743-.017-3.446.008-5.148h-.002zm10.245 13.397h-6.107v-1.94h6.11l-.003 1.94zm-.823-4.068c-2.558 0-5.118-.045-7.675.015-1.69.039-1.904-.56-1.703-2.032h14.382c0 .297.007.562 0 .826-.03.823-.376 1.177-1.191 1.186-1.271.012-2.54.004-3.81.004h-.003z"
        ></path>
        <path
          fill="#EA2127"
          d="M44.372 35.28c0-.112-.007-.225-.02-.337-.132-1.207-.935-1.904-2.245-1.91-2.77-.007-5.539 0-8.309 0h-3.56c-2.644 0-5.29.062-7.934-.02-1.87-.057-2.88 1.025-2.687 2.67v3.207c.006 1.628.77 2.397 2.418 2.4H41.79c1.867 0 2.559-.686 2.579-2.547v-.492-2.117c.002-.323.005-.59.002-.854zM25.76 39.218H21.74v-4.06h4.018v4.06zm10.333-.014h-8.188v-4.039h8.188v4.04zm6.203 0h-4.042V35.16h4.042v4.044z"
        ></path>
        <path
          fill="#667085"
          d="M63.969 2.988A3.005 3.005 0 0060.994.034c-4.207-.03-8.414-.03-12.62 0-1.64.017-2.923 1.335-2.953 3.043a237.756 237.756 0 000 8.309c.03 1.768 1.282 2.979 3.053 3.085.327.02.655 0 1.02 0v2.032h-1.97v2.085H53.6c.024.22.056.376.056.535 0 1.791.01 3.582 0 5.372 0 .976-.34 1.311-1.322 1.313-5.269 0-10.536 0-15.805.008-.383 0-.582-.093-.729-.484a3.778 3.778 0 00-2.26-2.278c-.438-.166-.538-.39-.53-.814.026-1.182.01-2.365.01-3.63h6.17v-2.058h-2.002V14.48h.843c1.962-.048 3.224-1.317 3.233-3.283.011-2.645.011-5.29 0-7.935C41.252 1.305 39.96.026 38 .023c-4-.007-7.998-.007-11.995 0-1.995 0-3.277 1.282-3.286 3.283-.01 2.56 0 5.122 0 7.684 0 2.254 1.21 3.47 3.463 3.492h.61v2.016H24.81v2.091h6.118c.023.213.051.376.053.529 0 .854-.044 1.711.015 2.56.053.769-.05 1.279-.91 1.59-.951.342-1.56 1.163-1.908 2.118-.125.343-.295.434-.632.434a9195.4 9195.4 0 00-15.93-.009c-.91 0-1.26-.35-1.264-1.238-.007-1.954 0-3.91 0-5.936h6.114v-2.11h-1.98v-2.05c.341 0 .648.013.953 0 1.787-.081 3.076-1.252 3.114-3.018.063-2.81.063-5.621 0-8.433-.04-1.79-1.39-2.997-3.185-3.002C11.534.014 7.702.07 3.872 0 1.945-.035.616.638 0 2.516v9.503c.272.482.483 1.015.829 1.435.636.773 1.529 1.04 2.512 1.033h.733v2.04H2.13v2.043h6.135V24.542c.006 2.056 1.298 3.342 3.368 3.344 5.248 0 10.496-.003 15.745-.01.461 0 .684.108.858.565.412 1.084 1.22 1.823 2.303 2.233.314.126.47.251.448.627-.034.554-.009 1.113-.009 1.738h2.047c0-.68-.014-1.317.014-1.953a.501.501 0 01.284-.331 4.258 4.258 0 002.576-2.555c.062-.16.41-.293.626-.295 2.832-.019 5.664-.013 8.495-.013h7.373c2.058-.006 3.334-1.297 3.34-3.368V18.84c.01-.07.025-.14.044-.21h6.093v-2.078h-1.98v-2.028c.511-.038 1.002-.04 1.493-.115a3.006 3.006 0 002.588-2.926c.029-2.83.035-5.664-.001-8.495zm-61.887.133c.013-.723.426-1.02 1.281-1.02h9.864c.752 0 1.503-.016 2.254.01.609.02 1.002.375 1.014.963.021 1.705.008 3.409.008 5.157H2.073c0-1.742-.02-3.426.01-5.11zm1.058 9.265c-.64 0-1.001-.36-1.059-.989-.028-.324 0-.653 0-1.017h14.4c0 .396.06.812-.015 1.204-.101.528-.484.806-1.035.806-4.098.003-8.195.005-12.29.005v-.009zm3.09 4.087v-1.95h6.126v1.961l-6.126-.01zM24.783 3.037c.014-.616.466-.93 1.18-.934 1.602-.01 3.206 0 4.81 0h7.06c1.054 0 1.387.33 1.388 1.377v4.764H24.77c0-1.763-.026-3.487.012-5.207zm1.621 9.358c-1.456 0-1.839-.48-1.569-2.013h14.387c0 .332.006.58 0 .827-.031.803-.407 1.186-1.206 1.186-1.914.008-3.829 0-5.743 0h-5.869zm2.52 4.083v-1.954h6.135v1.95l-6.135.004zm3.075 12.42a2.03 2.03 0 01-2.055-2.047 2.065 2.065 0 012.047-2.071 2.089 2.089 0 012.066 2.063 2.05 2.05 0 01-2.055 2.055H32zM47.482 3.275c.008-.787.362-1.168 1.136-1.171 4.058-.01 8.116-.01 12.174 0 .654 0 1.073.304 1.086.877.037 1.74.014 3.482.014 5.258H47.48V6.52c0-1.082-.006-2.163.002-3.245zM57.75 16.489h-6.122v-1.965h6.122v1.966zm4.14-5.026c-.068.627-.45.93-1.175.932H48.987c-1.243 0-1.523-.29-1.502-1.554v-.458h14.413c.016.36.014.72-.008 1.08h-.001z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1416_102953">
          <path fill="#fff" d="M0 0H63.994V64H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconFeatureProduct8 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="64" fill="none" viewBox="0 0 65 64">
      <g clipPath="url(#clip0_1416_102961)">
        <path
          fill="#667085"
          d="M56.07 32.958h-5.779c-.262 4.104-1.741 7.69-4.607 10.968.263.168.556.297.771.507.894.867 1.791 1.734 2.635 2.648.51.553.889.796 1.73.438 1.896-.81 4.096.064 5.152 1.838a4.335 4.335 0 01-6.274 5.726c-1.683-1.214-2.296-3.445-1.388-5.304.242-.496.169-.745-.198-1.098-1.206-1.168-2.38-2.364-3.592-3.584-3.122 2.758-6.738 4.28-10.893 4.556v5.77c1.313.372 2.364 1.128 2.964 2.413a4.26 4.26 0 01.273 2.937c-.51 2.01-2.352 3.322-4.513 3.221-1.97-.098-3.708-1.7-3.98-3.72-.274-2.039.874-4.163 3.343-4.851v-5.775c-4.087-.277-7.678-1.746-10.71-4.4l-4.12 4.155c.415.833.692 1.84.482 2.944A4.37 4.37 0 118.96 50.08c.864-2.385 3.615-3.558 5.91-2.464.526.254.812.2 1.208-.215 1.142-1.198 2.338-2.346 3.504-3.505-3.447-5.016-3.447-5.016-4.568-10.847-1.839 0-3.686-.01-5.536.02-.142 0-.337.278-.411.464-.727 1.812-2.382 2.886-4.323 2.786a4.335 4.335 0 114.334-5.779c.075.202.132.41.212.644h5.757c.243-4.115 1.707-7.75 4.379-10.803l-4.127-4.164c-2.408 1.002-4.533.515-5.794-1.37a4.334 4.334 0 016.014-6.012c1.923 1.29 2.344 3.329 1.255 6.005l4.086 4.088a18.242 18.242 0 014.949-3.142 18.604 18.604 0 015.78-1.371V8.569c-1.383-.455-2.457-1.314-2.988-2.742a4.203 4.203 0 01-.034-2.89 4.335 4.335 0 014.67-2.906c1.95.231 3.584 1.922 3.75 3.89.187 2.218-1.117 3.986-3.531 4.699v5.779c4.148.255 7.785 1.707 10.874 4.41l4.139-4.188c-.446-.862-.71-1.867-.493-2.975a4.32 4.32 0 015.385-3.357c2.39.643 3.737 3.239 2.905 5.595-.839 2.376-3.546 3.553-5.83 2.465-.525-.252-.788-.152-1.153.221-1.152 1.194-2.336 2.364-3.56 3.586 2.748 3.106 4.286 6.73 4.557 10.901h5.79c.378-1.329 1.14-2.395 2.453-3a4.225 4.225 0 012.875-.262c2.049.517 3.357 2.318 3.263 4.48-.087 1.99-1.62 3.655-3.689 4.008-2.117.362-3.902-.847-4.901-3.325zm-7.599-.92c.082-8.626-6.987-15.73-15.723-15.799-8.706-.068-15.8 6.952-15.878 15.711-.078 8.643 6.998 15.823 15.653 15.893 8.767.062 15.861-6.967 15.947-15.795l.001-.01zm6.253-19.588a2.46 2.46 0 00-2.462-2.504 2.505 2.505 0 102.468 2.504h-.006zm-19.56-8.098a2.494 2.494 0 10-2.516 2.478 2.505 2.505 0 002.515-2.478zm-2.525 57.814a2.496 2.496 0 10-2.464-2.52 2.476 2.476 0 002.464 2.52zM2.509 31.982a2.477 2.477 0 002.469 2.517 2.496 2.496 0 00.043-4.992 2.477 2.477 0 00-2.512 2.475zm60.322.056a2.48 2.48 0 00-2.456-2.528 2.494 2.494 0 00-1.02 4.788c.302.13.625.199.953.203a2.478 2.478 0 002.523-2.463zm-49.75 22.023a2.502 2.502 0 002.536-2.47 2.546 2.546 0 00-2.496-2.53 2.495 2.495 0 00-2.51 2.487 2.461 2.461 0 002.47 2.513zm-2.465-41.6a2.496 2.496 0 002.512 2.484 2.546 2.546 0 002.489-2.53 2.496 2.496 0 00-2.537-2.463 2.45 2.45 0 00-2.464 2.508zM54.724 51.6a2.508 2.508 0 00-2.462-2.54 2.547 2.547 0 00-2.535 2.48 2.497 2.497 0 002.48 2.516 2.459 2.459 0 002.517-2.459v.003z"
        ></path>
        <path
          fill="#EA2127"
          d="M44.074 32.005c0 1.92-.014 3.842 0 5.763.006.566-.2.94-.693 1.223-3.349 1.92-6.692 3.85-10.029 5.79-.49.285-.92.263-1.404-.02-3.313-1.93-6.636-3.848-9.968-5.751-.517-.296-.725-.677-.722-1.27.016-3.82.016-7.64 0-11.462 0-.59.202-.973.72-1.268 3.334-1.906 6.659-3.825 9.974-5.757.519-.302.956-.282 1.463.013 3.3 1.918 6.605 3.824 9.918 5.72.536.306.759.703.75 1.324-.028 1.895-.01 3.795-.01 5.695zm-20.97-4.464c0 3.31-.009 6.493.018 9.677 0 .19.237.441.43.554 2.577 1.508 5.168 2.996 7.748 4.487.124.071.263.12.447.206v-7.393c0-.846.231-1.839-.131-2.496-.354-.626-1.339-.9-2.056-1.313-2.11-1.222-4.224-2.435-6.457-3.722zm10.484 14.92c.09-.022.178-.052.263-.088 2.684-1.543 5.37-3.081 8.038-4.653.196-.116.34-.485.342-.737.023-2.968.016-5.938.014-8.906 0-.141-.018-.283-.027-.427-.095.01-.143 0-.176.022-2.722 1.566-5.44 3.137-8.154 4.714a.694.694 0 00-.281.51c-.024 3.164-.02 6.328-.02 9.565h.001zm-4.42-13.544c1.084.627 2.073 1.182 3.037 1.77.345.212.6.198.943 0 2.52-1.476 5.053-2.93 7.58-4.392.164-.094.318-.206.554-.36-1.06-.614-2.06-1.174-3.037-1.771-.334-.204-.582-.174-.894.022-.553.348-1.13.657-1.695.985l-6.487 3.746zm6.807-6.05c-1.008-.583-1.939-1.096-2.841-1.656-.35-.218-.6-.182-.942.017-2.16 1.268-4.334 2.51-6.503 3.762-.525.3-1.037.603-1.655.961 1.088.628 2.077 1.211 3.083 1.763a.637.637 0 00.525-.049c2.74-1.566 5.472-3.148 8.333-4.799z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1416_102961">
          <path fill="#fff" d="M0 0H64.022V64H0z" transform="translate(.645)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconFeatureProduct9 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="67" height="64" fill="none" viewBox="0 0 67 64">
      <g clipPath="url(#clip0_1416_102970)">
        <path
          fill="#EA2127"
          d="M49.944 64.005c-.723-.083-1.446-.155-2.167-.25-6.854-.914-12.465-6.5-13.465-13.4-1.23-8.481 4.115-16.179 12.527-18.043 7.5-1.663 15.57 2.74 18.163 9.977.496 1.382.723 2.861 1.074 4.296v2.71c-.08.418-.172.836-.236 1.256-1.034 6.764-6.654 12.307-13.407 13.203-.742.099-1.487.168-2.23.251h-.26zm.15-29.897c-7.592-.018-13.813 6.196-13.845 13.826-.032 7.63 6.143 13.836 13.775 13.88 7.631.043 13.852-6.122 13.912-13.82.07-7.593-6.193-13.873-13.842-13.892v.006z"
        ></path>
        <path
          fill="#667085"
          d="M33.007 55.418v2.132H5.642c-2.716 0-4.736-1.466-5.431-3.973a6.242 6.242 0 01-.202-1.655C.003 36.5 0 21.08 0 5.66 0 2.277 2.282 0 5.68 0h46.198c3.334 0 5.662 2.255 5.67 5.538.018 7.935 0 15.872 0 23.807v.435h-2.14v-.816V5.738c0-1.846-.826-3.07-2.365-3.47a4.865 4.865 0 00-1.213-.118c-15.377-.006-30.754-.006-46.132 0-2.286 0-3.562 1.266-3.563 3.55-.005 15.377-.005 30.753 0 46.129 0 2.32 1.273 3.588 3.596 3.59 8.792.005 17.588.005 26.388 0h.888z"
        ></path>
        <path
          fill="#667085"
          d="M4.293 10.623V8.556h48.944v2.069H4.293zM15.162 25.914l1.517 1.47c-.905.873-1.79 1.735-2.564 2.484.283 1.022.619 1.841.726 2.691.388 3.015-1.955 5.644-5.087 5.81-2.937.155-5.516-2.302-5.508-5.249.02-4.108 4.157-6.614 7.846-4.743.32.165.518.16.776-.113.746-.797 1.523-1.565 2.294-2.35zM11 30.281c-1.376-.812-3.18-.3-4.028.936a3.22 3.22 0 00.459 4.162 3.18 3.18 0 004.179.122 2.992 2.992 0 00.705-3.891l-1.927 2.16-1.571-1.542L11 30.28zM15.174 38.715l1.552 1.515-2.716 2.633c.667 1.104.965 2.234.865 3.476-.222 2.742-2.676 4.933-5.47 4.845-2.792-.088-5.124-2.436-5.155-5.182-.047-4.137 4.126-6.738 7.816-4.846.347.177.555.163.826-.13.748-.787 1.528-1.55 2.282-2.311zM8.762 44.95c.73-.667 1.422-1.293 2.117-1.94-1.005-.703-2.916-.35-3.825.881a3.242 3.242 0 00.278 4.18 3.189 3.189 0 004.227.26c1.187-.936 1.563-2.561.794-3.897-.334.388-.638.742-.955 1.089-.316.346-.664.705-1.008 1.067l-1.628-1.64zM15.147 13.18l1.575 1.441c-.803.805-1.564 1.588-2.353 2.346-.259.247-.308.428-.13.764 1.226 2.361.68 5.097-1.31 6.692-2.025 1.622-4.831 1.551-6.878-.165-1.973-1.66-2.382-4.704-.925-6.902 1.494-2.252 4.43-3.09 6.749-1.873.517.27.805.237 1.19-.192.67-.747 1.415-1.435 2.082-2.111zm-4.146 4.251c-1.665-.703-3.305-.196-4.121 1.14a3.189 3.189 0 004.825 4.065c1.077-.943 1.392-2.554.635-3.75l-1.916 2.133-1.611-1.624c.707-.637 1.4-1.264 2.188-1.964zM18.145 31.944v-2.069h18.052v2.069H18.144zM36.212 17.098v2.05H18.168v-2.05h18.044zM27.773 21.336h14.795v2.084H27.773v-2.084zM18.145 44.739v-2.07h13.794v2.07H18.145zM38.387 19.137V17.09H48.99v2.047H38.387zM36.19 36.229h-8.405v-2.08h8.405v2.08zM25.519 36.224h-7.37v-2.087h7.37v2.087zM25.54 46.945v2.045h-7.392v-2.045h7.391zM18.14 23.414v-2.059h7.377v2.059h-7.376zM38.414 29.87h4.167v2.068h-4.167v-2.069zM31.951 46.938v2.049h-4.174v-2.05h4.174zM8.559 6.407v-2.09h2.103c0 .592.016 1.205-.015 1.81 0 .097-.216.258-.338.258-.571.038-1.144.022-1.75.022zM12.816 6.402v-2.09h2.112c0 .578.015 1.164-.014 1.762a.436.436 0 01-.285.314c-.592.03-1.183.014-1.813.014zM4.313 4.29H6.4c0 .617.02 1.21-.018 1.802-.007.11-.23.292-.362.3-.551.034-1.106.014-1.708.014V4.289z"
        ></path>
        <path
          fill="#EA2127"
          d="M41.684 49.5l1.9-.946 1.44 2.856 11.665-11.68 1.505 1.608c-.082.088-.222.245-.37.394-3.982 3.98-7.962 7.96-11.94 11.94-1.01 1.009-1.66.905-2.303-.388-.625-1.239-1.247-2.483-1.897-3.785z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1416_102970">
          <path fill="#fff" d="M0 0H66.075V64H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

/* icon social */
export const IconGlobal = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.988 0.333008C5.54801 0.333008 0.333008 5.55967 0.333008 11.9997C0.333008 18.4397 5.54801 23.6663 11.988 23.6663C18.4397 23.6663 23.6663 18.4397 23.6663 11.9997C23.6663 5.55967 18.4397 0.333008 11.988 0.333008ZM20.073 7.33301H16.6313C16.258 5.87467 15.7213 4.47467 15.0213 3.17967C17.168 3.91467 18.953 5.40801 20.073 7.33301ZM11.9997 2.71301C12.968 4.11301 13.7263 5.66467 14.228 7.33301H9.77134C10.273 5.66467 11.0313 4.11301 11.9997 2.71301ZM2.96967 14.333C2.78301 13.5863 2.66634 12.8047 2.66634 11.9997C2.66634 11.1947 2.78301 10.413 2.96967 9.66634H6.91301C6.81967 10.4363 6.74967 11.2063 6.74967 11.9997C6.74967 12.793 6.81967 13.563 6.91301 14.333H2.96967ZM3.92634 16.6663H7.36801C7.74134 18.1247 8.27801 19.5247 8.97801 20.8197C6.83134 20.0847 5.04634 18.603 3.92634 16.6663ZM7.36801 7.33301H3.92634C5.04634 5.39634 6.83134 3.91467 8.97801 3.17967C8.27801 4.47467 7.74134 5.87467 7.36801 7.33301ZM11.9997 21.2863C11.0313 19.8863 10.273 18.3347 9.77134 16.6663H14.228C13.7263 18.3347 12.968 19.8863 11.9997 21.2863ZM14.7297 14.333H9.26967C9.16467 13.563 9.08301 12.793 9.08301 11.9997C9.08301 11.2063 9.16467 10.4247 9.26967 9.66634H14.7297C14.8347 10.4247 14.9163 11.2063 14.9163 11.9997C14.9163 12.793 14.8347 13.563 14.7297 14.333ZM15.0213 20.8197C15.7213 19.5247 16.258 18.1247 16.6313 16.6663H20.073C18.953 18.5913 17.168 20.0847 15.0213 20.8197ZM17.0863 14.333C17.1797 13.563 17.2497 12.793 17.2497 11.9997C17.2497 11.2063 17.1797 10.4363 17.0863 9.66634H21.0297C21.2163 10.413 21.333 11.1947 21.333 11.9997C21.333 12.8047 21.2163 13.5863 21.0297 14.333H17.0863Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export const IconLinkedin = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M32 23.628V8.372A8.372 8.372 0 0023.628 0H8.372A8.372 8.372 0 000 8.372v15.256A8.372 8.372 0 008.372 32h15.256A8.372 8.372 0 0032 23.628zM9.29 13.023h3.098v9.96H9.291v-9.96zm1.555-4.946a1.795 1.795 0 11-.022 3.59 1.795 1.795 0 01.022-3.59zm6.457 4.946h-2.966v9.96h3.086v-4.925c0-1.303.252-2.561 1.86-2.561 1.61 0 1.61 1.488 1.61 2.637v4.86h3.053V17.52c0-2.681-.57-4.75-3.71-4.75a3.282 3.282 0 00-2.933 1.61v-1.358z"
        clipRule="evenodd"
      ></path>
    </svg>
  </span>
);

export const IconFb = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M0 8.372v15.256A8.394 8.394 0 008.372 32h5.133V21.155H9.434v-4.63h4.07v-3.524c0-4.038 2.387-6.227 6.042-6.227 1.199.017 2.395.123 3.579.318v3.94H21.11a2.31 2.31 0 00-2.605 2.495v2.998h4.476l-.755 4.63h-3.72V32h5.12A8.394 8.394 0 0032 23.628V8.372A8.394 8.394 0 0023.628 0H8.372A8.394 8.394 0 000 8.372z"
        clipRule="evenodd"
      ></path>
    </svg>
  </span>
);

export const IconYoutube = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        fill="#fff"
        d="M31.681 9.6s-.312-2.206-1.275-3.175C29.188 5.15 27.825 5.144 27.2 5.069c-4.475-.325-11.194-.325-11.194-.325h-.012s-6.719 0-11.194.325c-.625.075-1.987.08-3.206 1.356C.63 7.394.325 9.6.325 9.6S0 12.194 0 14.78v2.425c0 2.588.319 5.181.319 5.181s.312 2.207 1.268 3.175c1.22 1.275 2.82 1.232 3.532 1.37C7.68 27.174 16 27.25 16 27.25s6.725-.013 11.2-.331c.625-.075 1.988-.082 3.206-1.357.963-.968 1.275-3.175 1.275-3.175S32 19.8 32 17.207V14.78c0-2.587-.319-5.181-.319-5.181zM12.694 20.15v-8.994l8.643 4.513-8.643 4.48z"
      ></path>
    </svg>
  </span>
);

/* icon Arrow */
export const IconArrowRight = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1184 3.0035H1.1084C0.558398 3.0035 0.108398 3.4535 0.108398 4.0035C0.108398 4.5535 0.558398 5.0035 1.1084 5.0035H12.1184V6.7935C12.1184 7.2435 12.6584 7.4635 12.9684 7.1435L15.7484 4.3535C15.9384 4.1535 15.9384 3.8435 15.7484 3.6435L12.9684 0.853496C12.6584 0.533496 12.1184 0.763496 12.1184 1.2035V3.0035Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export const IconArrowUpward = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9997 18.7915V7.62148L17.8797 12.5015C18.2697 12.8915 18.9097 12.8915 19.2997 12.5015C19.6897 12.1115 19.6897 11.4815 19.2997 11.0915L12.7097 4.50148C12.3197 4.11148 11.6897 4.11148 11.2997 4.50148L4.69973 11.0815C4.30973 11.4715 4.30973 12.1015 4.69973 12.4915C5.08973 12.8815 5.71973 12.8815 6.10973 12.4915L10.9997 7.62148V18.7915C10.9997 19.3415 11.4497 19.7915 11.9997 19.7915C12.5497 19.7915 12.9997 19.3415 12.9997 18.7915Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export const IconArrowDownward = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0046 5.20898V16.379L6.12461 11.499C5.73461 11.109 5.09461 11.109 4.70461 11.499C4.31461 11.889 4.31461 12.519 4.70461 12.909L11.2946 19.499C11.6846 19.889 12.3146 19.889 12.7046 19.499L19.2946 12.909C19.6846 12.519 19.6846 11.889 19.2946 11.499C18.9046 11.109 18.2746 11.109 17.8846 11.499L13.0046 16.379V5.20898C13.0046 4.65898 12.5546 4.20898 12.0046 4.20898C11.4546 4.20898 11.0046 4.65898 11.0046 5.20898Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export const IconArrowForward = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5.207 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 000-1.41l-6.58-6.6a.996.996 0 10-1.41 1.41l4.87 4.89H5.207c-.55 0-1 .45-1 1s.45 1 1 1z"
      ></path>
    </svg>
  </span>
);
export const IconArrowBack = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18.793 11.005H7.623l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 00-1.41 0l-6.59 6.59a.996.996 0 000 1.41l6.59 6.59a.996.996 0 101.41-1.41l-4.88-4.88h11.17c.55 0 1-.45 1-1s-.45-1-1-1z"
      ></path>
    </svg>
  </span>
);

export const IconAngleLeft = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" fill="none" viewBox="0 0 9 15">
      <path stroke="#fff" d="M0.646 7.646L7.646 0.646"></path>
      <path stroke="#fff" d="M1.354 7.646L8.354 14.646"></path>
    </svg>
  </span>
);

export const IconAngleRight = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" fill="none" viewBox="0 0 9 15">
      <path stroke="#fff" d="M8.354 7.354L1.354 14.354"></path>
      <path stroke="#fff" d="M7.646 7.354L0.646 0.354"></path>
    </svg>
  </span>
);

export const IconDownload = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.59 9.5H15V4.5C15 3.95 14.55 3.5 14 3.5H10C9.45 3.5 9 3.95 9 4.5V9.5H7.41C6.52 9.5 6.07 10.58 6.7 11.21L11.29 15.8C11.68 16.19 12.31 16.19 12.7 15.8L17.29 11.21C17.92 10.58 17.48 9.5 16.59 9.5ZM5 19.5C5 20.05 5.45 20.5 6 20.5H18C18.55 20.5 19 20.05 19 19.5C19 18.95 18.55 18.5 18 18.5H6C5.45 18.5 5 18.95 5 19.5Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export const ImageBanner = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="658" height="456" fill="none" viewBox="0 0 658 456">
      <path
        fill="#B1B0B0"
        d="M130.523 188.015L238.272 128.8l167.008 82.665-65.141 47.058 229.827 51.719-107.434 76.106-332.009-198.333z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M573.392 295.504s1.441-.298 1.682-.187l.165.086s-2.743-4.009-2.735-4.004c.008.006 12.549-8.335 14.396-.441.246 1.048.622 2.204.541 3.425h.025v40.909c-.063.593-.48 1.178-1.265 1.624-1.703.983-4.463.983-6.163 0-.786-.452-1.206-1.037-1.265-1.624v-.135c0-.017 0-.033-.111-2.085v-34.111s-5.449-3.36-5.27-3.457z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M579.64 297.352c-.124.918-.468 1.552-.977 1.86l.016.025-3.791 2-3.133 1.646v8.617c-.019 0-.046 0-.063.019l-8.649 6.227v-17.529h.027a7.275 7.275 0 01.542-3.425c.169-.388.415-.738.723-1.029v-.035l.141-.081a1.812 1.812 0 01.601-.317l1.998-1.083 3.629-1.946 3.759-2.025.019-.019.167-.087c.256-.112.538-.149.813-.106.305.047.6.145.872.29a5.507 5.507 0 01.569.371 6.882 6.882 0 011.7 2.049c.791 1.427 1.221 3.144 1.037 4.578zM256.449 106.438s1.44-.298 1.681-.19l.168.09s-2.721-4.004-2.716-4.004c.005 0 12.549-8.336 14.398-.442.247 1.048.623 2.204.542 3.425h.027v40.906c-.059.596-.476 1.178-1.264 1.625-1.701.983-4.461.983-6.161 0-.788-.455-1.205-1.037-1.265-1.625v-.121c0-.017 0-.033-.114-2.085v-34.103s-5.462-3.379-5.296-3.476z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M262.705 108.289c-.122.915-.466 1.549-.977 1.858l.019.027-3.792 1.998-3.133 1.643v8.62c-.016 0-.043 0-.059.019l-8.65 6.226v-17.532h.027a7.239 7.239 0 01.558-3.424c.167-.39.412-.741.721-1.032v-.035l.14-.079c.157-.129.336-.23.528-.297a.129.129 0 01.063-.019l1.998-1.083 3.629-1.944 3.753-2.017.016-.019.166-.086c.254-.114.537-.15.812-.106.305.045.6.143.872.29a5.458 5.458 0 01.554.362.034.034 0 00.015.006 6.958 6.958 0 011.698 2.052c.796 1.418 1.226 3.135 1.042 4.572z"
      ></path>
      <path
        fill="#4C4848"
        d="M571.701 311.504l-.017.016-8.649 6.224-95.763 69.018-7.03-22.635 99.95-72.134 5.009-3.612.239-.176.07.257 1.56 5.794 4.631 17.248z"
      ></path>
      <path fill="#E5A628" d="M456.848 364.416l5.001-3.876-1.224 5.295-3.777-1.302v-.117z"></path>
      <path
        fill="#344054"
        d="M469.735 382.1c-.455 3.52-2.258 5.415-4.82 5.085-1.099-.138-2.313-.702-3.52-1.625-4.544-3.47-7.642-10.905-6.908-16.573.27-2.139 1.058-3.68 2.204-4.481a.92.92 0 01.146-.1h.027l.417-.219a3.696 3.696 0 012.026-.271 6.349 6.349 0 012.166.736c.466.261.913.553 1.338.875.019.019.046.032.065.051a16.996 16.996 0 014.246 5.106c2.012 3.544 3.079 7.835 2.613 11.416z"
      ></path>
      <path
        fill="#4C4848"
        d="M575.177 306.476c-.371 2.834-1.603 4.602-3.417 5.025-.019 0-.046 0-.063.018a3.973 3.973 0 01-1.354.044c-1.099-.141-2.307-.704-3.504-1.625a16.117 16.117 0 01-3.791-4.296c-2.323-3.698-3.618-8.392-3.117-12.275.06-.465.15-.927.271-1.38.387-1.427 1.056-2.483 1.936-3.1a.91.91 0 01.141-.098c.019 0 .019-.016.027-.016l.423-.222a3.682 3.682 0 012.025-.27c.155.015.308.044.458.086.105.02.208.047.309.081a6.56 6.56 0 011.4.572 10.466 10.466 0 011.424.925c.88.69 1.678 1.478 2.378 2.35a19.24 19.24 0 011.865 2.756 21.594 21.594 0 012.316 6.173c.382 1.723.475 3.498.273 5.252z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M463.524 381.394c1.286.165 2.191-.788 2.418-2.553.369-2.845-1.188-6.579-3.469-8.319a3.827 3.827 0 00-1.763-.813c-1.286-.165-2.19.788-2.418 2.553-.368 2.846 1.189 6.579 3.469 8.322a3.851 3.851 0 001.763.81z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M464.044 373.781a6.81 6.81 0 00-1.7-2.044l-.028-.022a4.377 4.377 0 00-.541-.349 2.54 2.54 0 00-.867-.295 1.468 1.468 0 00-.812.105l-.168.087a.06.06 0 01-.019 0l-9.386 5.046-.068.019c-.191.068-.369.17-.525.301l-.141.076v.035a3.26 3.26 0 00-.728 1.034 7.226 7.226 0 00-.542 3.425h-.027v36.935c.06.595.479 1.177 1.265 1.624 1.7.983 4.46.983 6.16 0 .789-.455 1.206-1.037 1.265-1.624v-34.247l6.924-3.644-.013-.03c.509-.3.856-.939.975-1.854.2-1.44-.225-3.16-1.024-4.578z"
      ></path>
      <path
        fill="#667085"
        d="M126.906 165.987l7.672 23.282v.03l.103-.049 1.966-1.034 25.997-13.68-33.347-8.162-1.624-.406h-.022a3.438 3.438 0 00-.745.019z"
      ></path>
      <path
        fill="#344054"
        d="M129.999 187.642c1.205.912 2.41 1.48 3.52 1.61.353.046.711.046 1.064 0 .041 0 .081 0 .114-.019a3.432 3.432 0 001.966-1.034c.85-.861 1.438-2.239 1.671-4.034.468-3.587-.599-7.872-2.594-11.419a16.95 16.95 0 00-4.247-5.108c0-.019-.04-.03-.062-.052a10.902 10.902 0 00-1.338-.869 7.449 7.449 0 00-2.166-.741c-.081 0-.171-.019-.252-.019h-.022a3.446 3.446 0 00-.739.019c-.35.036-.691.127-1.013.27l-.417.214h-.029a.642.642 0 00-.141.1c-1.146.812-1.936 2.342-2.21 4.489-.75 5.691 2.353 13.127 6.895 16.593z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M132.119 183.464c1.286.165 2.191-.788 2.421-2.553.368-2.845-1.189-6.578-3.469-8.319a3.79 3.79 0 00-1.763-.812c-1.286-.168-2.191.785-2.418 2.55-.368 2.848 1.186 6.579 3.469 8.322a3.78 3.78 0 001.76.812z"
      ></path>
      <path
        fill="#D0D5DD"
        d="M132.643 175.851a6.794 6.794 0 00-1.725-2.065 4.668 4.668 0 00-.541-.35 2.601 2.601 0 00-.869-.295 1.47 1.47 0 00-.813.106l-.168.089h-.019l-9.391 5.071-.068.019a1.728 1.728 0 00-.528.303l-.141.076v.032a3.267 3.267 0 00-.725 1.035 7.222 7.222 0 00-.542 3.424h-.027v36.93c.062.593.479 1.177 1.265 1.624 1.703.983 4.462.983 6.163 0 .785-.452 1.205-1.037 1.265-1.624v-34.274l6.921-3.644v-.03c.509-.3.856-.939.972-1.854.198-1.435-.23-3.154-1.029-4.573z"
      ></path>
      <path
        fill="#4C4848"
        d="M127.816 165.865l.079-.046 117.665-63.588 319.679 186.943-104.187 75.262-331.749-197.691-1.487-.88z"
      ></path>
      <path
        fill="#fff"
        d="M221.104 140.424l-59.07 34.095-4.487-2.59 59.067-34.096 4.49 2.591zM246.276 171.179l-45.013 25.981-4.49-2.591 45.013-25.981 4.49 2.591zM261.151 171.652l-45.013 25.982-4.49-2.591 45.015-25.981 4.488 2.59zM276.026 172.124l-45.015 25.981-4.488-2.591 45.013-25.981 4.49 2.591zM290.897 172.595l-45.013 25.981-4.489-2.591 45.012-25.981 4.49 2.591zM326.005 161.389l-72.277 41.716-4.49-2.591 72.277-41.716 4.49 2.591zM316.887 175.71l-55.311 31.924-4.49-2.591 55.311-31.923 4.49 2.59zM310.676 188.351l-55.311 31.923-4.49-2.59 55.311-31.924 4.49 2.591zM243.401 127.554l-16.976 9.798-4.487-2.591 16.973-9.798 4.49 2.591zM239.615 138.794l-59.067 34.095-4.489-2.59 59.069-34.095 4.487 2.59zM259.555 136.345l-59.069 34.092-4.49-2.591 59.07-34.092 4.489 2.591zM267.4 140.871l-59.066 34.095-4.49-2.591 59.067-34.095 4.489 2.591zM224.71 174.349l-20.817 12.018-4.108-2.372 20.817-12.017 4.108 2.371zM365.325 221.238l-59.069 34.093-4.49-2.591 59.069-34.093 4.49 2.591zM390.497 251.993l-45.015 25.981-4.49-2.591 45.015-25.981 4.49 2.591zM405.369 252.464l-45.015 25.981-4.487-2.591 45.013-25.981 4.489 2.591zM420.24 252.938l-45.012 25.981-4.49-2.591 45.015-25.981 4.487 2.591zM469.092 271.75l-45.012 25.984-4.49-2.593 45.012-25.982 4.49 2.591zM483.963 272.224l-45.012 25.982-4.49-2.591 45.015-25.982 4.487 2.591zM498.837 272.695l-45.015 25.981-4.49-2.591 45.015-25.981 4.49 2.591zM435.118 253.409l-45.015 25.981-4.49-2.591 45.015-25.981 4.49 2.591zM470.225 242.201l-72.277 41.718-4.487-2.591 72.276-41.718 4.488 2.591zM461.103 256.522l-55.308 31.927-4.49-2.594 55.308-31.924 4.49 2.591zM454.892 269.165l-55.308 31.923-4.49-2.59 55.311-31.924 4.487 2.591zM387.62 208.368l-16.974 9.798-4.49-2.591 16.977-9.798 4.487 2.591zM383.834 219.608l-59.069 34.095-4.488-2.59 59.067-34.095 4.49 2.59zM403.778 217.156l-59.069 34.095-4.49-2.591 59.069-34.095 4.49 2.591zM411.622 221.685l-59.07 34.095-4.49-2.591 59.07-34.095 4.49 2.591zM497.225 286.981l-16.973 9.797-4.49-2.59 16.976-9.798 4.487 2.591zM493.443 298.224l-59.066 34.092-4.49-2.59 59.069-34.093 4.487 2.591zM513.388 295.772l-59.07 34.092-4.49-2.591 59.07-34.092 4.49 2.591zM521.232 300.298l-59.069 34.095-4.487-2.591 59.067-34.095 4.489 2.591zM368.932 255.163l-20.816 12.015-4.108-2.372 20.816-12.014 4.108 2.371z"
        opacity="0.8"
      ></path>
      <path
        fill="#fff"
        d="M325.315 218.745c.367.206.723.431 1.067.674.171.107.315.252.419.425.044.108.006.19-.113.244-.182.07-.371.119-.564.146l-20.142 3.138a2.262 2.262 0 01-.988-.176 11.265 11.265 0 01-1.582-.788 12.615 12.615 0 01-.842-.525 6.083 6.083 0 01-.541-.404.855.855 0 01-.244-.303.345.345 0 010-.249l5.454-11.595a.655.655 0 01.79-.333 6.129 6.129 0 011.731.766c.525.306.937.542 1.227.739.227.138.441.297.639.474a.525.525 0 01.203.328.778.778 0 01-.087.316l-4.406 8.544 14.466-2.526c.224-.039.45-.066.677-.081.223-.005.445.029.656.1.299.099.589.221.869.366.333.179.772.414 1.311.72zM339.604 220.128a.684.684 0 01.187.357.508.508 0 01-.124.361 2.378 2.378 0 01-.455.43 8.647 8.647 0 01-.862.541 9.733 9.733 0 01-1.194.601 3.362 3.362 0 01-.891.247c-.22.03-.445.003-.652-.079a1.548 1.548 0 01-.501-.365l-22.355-24.417a.67.67 0 01-.214-.352.462.462 0 01.106-.363c.134-.166.291-.313.466-.435.275-.197.562-.378.858-.542.387-.228.788-.43 1.202-.604.279-.119.574-.2.875-.238.219-.027.44.002.645.084.192.087.367.208.517.357l22.392 24.417zM349.875 195.671c.333.192.612.366.831.52.185.124.36.26.526.409a.945.945 0 01.243.314.274.274 0 01.028.119c0 .041-.01.082-.028.119l-5.473 11.603a.566.566 0 01-.284.298.853.853 0 01-.487.038 2.933 2.933 0 01-.718-.241c-.271-.13-.609-.306-.994-.542a26.952 26.952 0 01-1.227-.736 4.497 4.497 0 01-.641-.474.586.586 0 01-.212-.335.55.55 0 01.098-.309l4.406-8.544-14.483 2.539a5.82 5.82 0 01-.695.09 1.972 1.972 0 01-.656-.1 5.433 5.433 0 01-.858-.371 34.39 34.39 0 01-1.306-.726 14.106 14.106 0 01-1.083-.669 1.193 1.193 0 01-.428-.419c-.043-.109 0-.19.12-.247.173-.07.355-.118.541-.143l20.18-3.135c.328-.024.656.031.959.16a9.99 9.99 0 011.641.782z"
      ></path>
      <path
        fill="#B9A3D3"
        d="M468.405 300.504c-2.802-1.625-6.797-2.128-10.35-1.53 1.048-2.418.147-4.922-2.821-6.635l-10.71-6.268c-4.688-2.707-12.785-2.436-18.331.542-.141.076-.287.146-.425.224-4.281 2.472-5.603 5.916-3.791 8.637l-3.707 1.7 1.354 2.436 4.284-2.279c.17.113.335.23.522.338l3.272 1.914-3.207 1.47 1.354 2.437 4.463-2.377 3.52 2.06-3.366 1.54 1.354 2.437 4.62-2.461-.086-.154c3.921 1.684 9.507 1.686 14.206.119-.06 1.592.953 3.194 3.057 4.407 4.092 2.361 10.724 2.361 14.816 0 4.091-2.36 4.061-6.199-.028-8.557z"
        opacity="0.5"
      ></path>
      <path fill="#B9A3D3" d="M462.758 288.763l-6.721 5.019-3.502-2.51 10.223-2.509z" opacity="0.5"></path>
      <path
        fill="#48423B"
        d="M445.206 282.993v-3.987l-2.291 1.323a1.39 1.39 0 01-1.795-2.048c.111-.144.25-.265.408-.356l5.37-3.099a.716.716 0 01.722 0 .726.726 0 01.361.625v3.988l1.051-.607a1.394 1.394 0 011.539.1 1.39 1.39 0 01-.15 2.302l-4.132 2.382a.724.724 0 01-1.083-.623z"
      ></path>
      <path
        fill="#48423B"
        d="M451.17 287.081v-3.987l-2.29 1.321a1.394 1.394 0 01-1.539-.1 1.378 1.378 0 01-.256-1.945c.111-.145.25-.266.408-.356l5.37-3.103a.729.729 0 01.723.001.724.724 0 01.36.627v3.988l1.054-.607a1.383 1.383 0 011.538.1c.145.111.266.249.357.407a1.367 1.367 0 01.14 1.052 1.388 1.388 0 01-.646.843l-4.133 2.385a.718.718 0 01-.989-.264.727.727 0 01-.097-.362z"
      ></path>
      <path
        fill="#48423B"
        d="M457.54 290.522v-3.988l-2.291 1.321a1.373 1.373 0 01-1.052.14 1.372 1.372 0 01-.843-.646 1.386 1.386 0 01.506-1.895l5.373-3.1a.728.728 0 01.723.002.73.73 0 01.36.626v3.985l1.053-.609a1.389 1.389 0 011.896.509 1.396 1.396 0 01.14 1.053 1.392 1.392 0 01-.646.842l-4.133 2.385a.72.72 0 01-.989-.263.73.73 0 01-.097-.362z"
      ></path>
      <path
        fill="#4B6E1E"
        d="M458.461 291.868v-4.873l-37.3-4.001v4.846c-.04 1.797 1.024 3.519 3.25 4.802l10.707 6.268c4.81 2.774 13.205 2.436 18.756-.777 3.109-1.798 4.663-4.099 4.587-6.265z"
      ></path>
      <path
        fill="#48423B"
        d="M415.322 300.485a1.389 1.389 0 01.509-1.895l2.437-1.408v-4.117c0-.342.09-.677.26-.973a1.95 1.95 0 01.712-.711l4.097-2.366a1.391 1.391 0 011.896.509 1.386 1.386 0 01-.509 1.895l-3.68 2.125v4.118a1.943 1.943 0 01-.972 1.683l-2.855 1.649a1.39 1.39 0 01-1.895-.509zM421.287 304.565a1.39 1.39 0 01.509-1.895l2.437-1.408v-4.118a1.946 1.946 0 01.972-1.686l4.095-2.364a1.386 1.386 0 011.052-.136 1.386 1.386 0 01.334 2.54l-3.68 2.125v4.118a1.94 1.94 0 01-.972 1.684l-2.857 1.649a1.392 1.392 0 01-1.89-.509zM427.654 308.014a1.39 1.39 0 01.509-1.895l2.437-1.411v-4.117a1.95 1.95 0 01.972-1.684l4.095-2.364a1.397 1.397 0 011.053-.136 1.387 1.387 0 01.333 2.54l-3.68 2.123v4.12a1.95 1.95 0 01-.972 1.684l-2.857 1.649a1.39 1.39 0 01-1.89-.509z"
      ></path>
      <path
        fill="url(#paint0_linear_911_112407)"
        d="M455.229 282.162l-10.71-6.267c-4.687-2.707-12.782-2.436-18.328.541l27.692 16.539c5.552-3.192 6.153-8.038 1.346-10.813z"
      ></path>
      <path
        fill="url(#paint1_linear_911_112407)"
        d="M425.765 276.68c-5.552 3.203-6.153 8.052-1.354 10.829l10.707 6.267c4.81 2.775 13.204 2.437 18.756-.777l-27.692-16.538a3.91 3.91 0 00-.417.219z"
      ></path>
      <path
        fill="#4B6E1E"
        d="M471.46 296.768h-20.952v3.933c0 1.546 1.023 3.095 3.068 4.275 4.092 2.361 10.724 2.361 14.815 0 2.045-1.18 3.069-2.729 3.069-4.275v-3.933z"
      ></path>
      <path
        fill="url(#paint2_linear_911_112407)"
        d="M468.404 301.045c-4.092 2.361-10.724 2.361-14.816 0-4.091-2.361-4.091-6.189 0-8.549 4.092-2.361 10.724-2.364 14.816 0 4.092 2.363 4.089 6.186 0 8.549z"
      ></path>
      <path fill="#B9A3D3" d="M348.367 170.37l-6.578 4.911-3.426-2.456 10.004-2.455z" opacity="0.5"></path>
      <path
        fill="#B9A3D3"
        d="M341 173.865l-10.48-6.132c-4.587-2.648-12.508-2.383-17.938.541-.138.073-.27.141-.414.22-4.189 2.417-5.486 5.788-3.707 8.452l-3.629 1.662 1.313 2.377 4.192-2.231c.168.111.328.225.512.333l3.201 1.871-3.136 1.437 1.314 2.38 4.368-2.326 3.447 2.017-3.293 1.522 1.313 2.379 4.523-2.409-.087-.152c4.807 2.066 12.186 1.557 17.185-1.334 5.429-3.149 6.02-7.892 1.316-10.607z"
        opacity="0.5"
      ></path>
      <path
        fill="#48423B"
        d="M331.187 164.722v-3.912l-2.243 1.294a1.35 1.35 0 01-1.855-.498 1.354 1.354 0 01.499-1.854l5.253-3.033a.711.711 0 01.967.258c.062.108.095.23.095.354v3.904l1.031-.595a1.362 1.362 0 011.032-.137 1.355 1.355 0 01.823.635 1.357 1.357 0 01.137 1.031 1.355 1.355 0 01-.635.823l-4.043 2.334a.709.709 0 01-1.061-.604z"
      ></path>
      <path
        fill="#48423B"
        d="M337.027 168.724v-3.904l-2.242 1.294a1.356 1.356 0 01-1.993-1.526 1.361 1.361 0 01.633-.824l5.257-3.035a.704.704 0 01.707.002.707.707 0 01.354.613v3.901l1.032-.593a1.357 1.357 0 011.03-.138 1.351 1.351 0 01.825.633 1.348 1.348 0 01-.498 1.855l-4.043 2.334a.711.711 0 01-.967-.258.711.711 0 01-.095-.354z"
      ></path>
      <path
        fill="#48423B"
        d="M343.26 172.091v-3.903l-2.245 1.294a1.354 1.354 0 01-1.855-.499 1.351 1.351 0 01.498-1.854l5.256-3.032a.711.711 0 011.062.612v3.904l1.029-.596a1.35 1.35 0 011.855.498 1.356 1.356 0 01-.496 1.855l-4.043 2.333a.697.697 0 01-.708.001.707.707 0 01-.353-.613z"
      ></path>
      <path
        fill="#1D5F3E"
        d="M344.186 173.407v-4.776l-36.501-3.914v4.74c-.041 1.76 1.002 3.447 3.174 4.7l10.479 6.135c4.704 2.707 12.92 2.374 18.353-.761 3.024-1.752 4.544-4.004 4.495-6.124z"
      ></path>
      <path
        fill="#48423B"
        d="M301.942 181.84a1.348 1.348 0 01.096-1.505c.109-.142.244-.26.399-.349l2.389-1.378v-4.031a1.884 1.884 0 01.953-1.646l4.005-2.315a1.358 1.358 0 011.858.498 1.35 1.35 0 01-.499 1.854l-3.601 2.08v4.028a1.893 1.893 0 01-.951 1.649l-2.794 1.624a1.349 1.349 0 01-1.034.132 1.345 1.345 0 01-.821-.641zM307.781 185.842a1.362 1.362 0 01-.137-1.031 1.351 1.351 0 01.635-.824l2.388-1.381v-4.028a1.893 1.893 0 01.951-1.649l4.008-2.312a1.35 1.35 0 011.03-.138 1.351 1.351 0 01.825.634 1.358 1.358 0 01.139 1.031 1.356 1.356 0 01-.635.826l-3.601 2.076v4.031a1.897 1.897 0 01-.951 1.649l-2.795 1.611a1.358 1.358 0 01-1.032.139 1.36 1.36 0 01-.825-.634zM314.016 189.207a1.362 1.362 0 01-.138-1.031 1.361 1.361 0 01.633-.824l2.389-1.378v-4.028a1.897 1.897 0 01.953-1.649l4.008-2.315a1.348 1.348 0 011.506.099 1.36 1.36 0 01-.149 2.254l-3.599 2.079v4.028a1.895 1.895 0 01-.954 1.649l-2.794 1.625a1.36 1.36 0 01-1.509-.107 1.362 1.362 0 01-.346-.402z"
      ></path>
      <path
        fill="url(#paint3_linear_911_112407)"
        d="M341 163.91l-10.48-6.135c-4.588-2.647-12.511-2.379-17.938.542l27.099 16.186c5.432-3.135 6.023-7.878 1.319-10.593z"
      ></path>
      <path
        fill="url(#paint4_linear_911_112407)"
        d="M312.166 158.536c-5.432 3.135-6.023 7.878-1.319 10.594l10.48 6.134c4.704 2.707 12.92 2.375 18.352-.76l-27.099-16.187c-.138.076-.281.143-.414.219z"
      ></path>
      <path
        fill="#B9A3D3"
        d="M353.818 191.356c-4.003 2.312-10.494 2.312-14.499 0-4.005-2.312-4.002-6.056 0-8.365 4.003-2.309 10.496-2.312 14.499 0 4.002 2.312 4.002 6.056 0 8.365z"
        opacity="0.5"
      ></path>
      <path
        fill="#1D5F3E"
        d="M356.821 179.336h-20.489v3.85c0 1.513.999 3.029 3 4.182 4.006 2.312 10.497 2.312 14.499 0 2.001-1.153 3.003-2.669 3.003-4.182l-.013-3.85z"
      ></path>
      <path
        fill="url(#paint5_linear_911_112407)"
        d="M353.818 183.521c-4.003 2.31-10.494 2.31-14.499 0-4.005-2.309-4.002-6.058 0-8.368 4.003-2.309 10.496-2.312 14.499 0 4.002 2.312 4.002 6.056 0 8.368z"
      ></path>
      <path
        fill="#B9A3D3"
        d="M14.938 345.155c1.316-.761 3.293-.972 5.013-.558l.057.014c1.725.411 2.876 1.353 2.876 2.436v1.625h8.183v-1.625c0-1.083 1.148-2.03 2.876-2.436l.057-.014c1.72-.414 3.696-.203 5.012.558l2.002 1.153 5.787-3.338-2.002-1.156c-1.318-.76-1.681-1.895-.966-2.894l.024-.032c.712-.997 2.367-1.66 4.233-1.66h2.819v-4.724h-2.82c-1.865 0-3.52-.663-4.232-1.66l-.024-.032c-.715-.994-.352-2.133.966-2.894l2.002-1.153-5.787-3.341-2.002 1.156c-1.316.758-3.293.969-5.012.541h-.057c-1.725-.408-2.876-1.353-2.876-2.436v-1.624h-8.183v1.624c0 1.083-1.149 2.033-2.876 2.436h-.057c-1.72.415-3.697.203-5.013-.541l-2-1.156-5.788 3.341 2.001 1.153c1.316.761 1.682 1.895.967 2.894l-.024.032c-.712.997-2.367 1.66-4.233 1.66h-2.83v4.724h2.83c1.866 0 3.52.663 4.233 1.66l.021.032c.718.994.352 2.134-.964 2.894l-2 1.156 5.786 3.338 2.001-1.153zm7.626-7.743c-2.437-1.405-2.437-3.684 0-5.092 2.437-1.408 6.386-1.405 8.823 0 2.437 1.405 2.437 3.687 0 5.092-2.438 1.405-6.389 1.408-8.823 0z"
        opacity="0.5"
      ></path>
      <path
        fill="#FFAE24"
        d="M0 334.829v-4.724h2.83c1.868 0 3.52-.663 4.232-1.659l.025-.033c.069-.096.129-.198.179-.306l-.593-.706-2.551 1.472v-8.533H19.85v-1.684h8.18v1.625a.415.415 0 000 .059h15.728v8.533l-2.713-1.567-.514.541c.057.2.149.389.27.558l.022.033c.712.996 2.367 1.659 4.235 1.659h2.828v4.724H45.06a6.707 6.707 0 00-3.006.663l1.714 1.054v4.033l-3.905 2.253-1.895 1.083-2.001-1.156c-1.317-.758-3.293-.969-5.013-.542h-.057c-1.725.409-2.876 1.354-2.876 2.437v1.624h-8.17v-1.624c0-1.083-1.148-2.033-2.876-2.437h-.056c-1.72-.414-3.697-.203-5.013.542l-2.001 1.156-1.425-.812-4.36-2.524v-4.025l1.961-.91a6.454 6.454 0 00-3.25-.812L0 334.829z"
      ></path>
      <path
        fill="url(#paint6_linear_911_112407)"
        d="M11.915 338.731c1.316-.761 3.293-.97 5.013-.558h.057c1.727.411 2.875 1.353 2.875 2.436v1.625h8.184v-1.625c0-1.083 1.15-2.033 2.876-2.436h.057c1.72-.412 3.696-.203 5.012.558l2.002 1.156 5.787-3.341-2.002-1.153c-1.316-.761-1.679-1.896-.964-2.894l.022-.033c.712-.996 2.367-1.662 4.235-1.662h2.827v-4.722h-2.835c-1.868 0-3.52-.663-4.235-1.662l-.022-.032c-.715-.991-.352-2.134.964-2.892l2.001-1.156-5.784-3.338-2.001 1.154c-1.319.76-3.296.969-5.015.557h-.055c-1.727-.411-2.878-1.353-2.878-2.436v-1.625h-8.181v1.625c0 1.083-1.15 2.033-2.879 2.436h-.056c-1.717.412-3.697.203-5.013-.557l-2.001-1.154-5.784 3.338 2 1.156c1.317.758 1.68 1.895.965 2.894l-.025.033c-.712.996-2.364 1.659-4.232 1.659H0v4.722h2.83c1.868 0 3.52.666 4.232 1.662l.025.033c.715.99.352 2.133-.964 2.894l-2.001 1.153 5.784 3.341 2.01-1.156zm7.626-7.74c-2.437-1.408-2.437-3.688 0-5.093 2.437-1.405 6.388-1.408 8.823 0 2.434 1.408 2.437 3.685 0 5.093-2.438 1.407-6.394 1.405-8.831 0h.008z"
      ></path>
      <path
        fill="#D1D3D4"
        d="M121.733 352.927v-92.414H29.055v92.414c0 6.844 4.525 13.688 13.57 18.91 18.097 10.448 47.438 10.448 65.533 0 9.047-5.222 13.572-12.066 13.572-18.91h.003z"
      ></path>
      <path
        fill="#E6E7E8"
        d="M54.32 260.513H29.055v92.414c0 6.847 4.525 13.691 13.57 18.913a54.119 54.119 0 0011.695 4.914V260.513z"
      ></path>
      <path
        fill="#B9A3D3"
        d="M141.997 384.347c-13.578.682-26.674-2.122-39.082-9.9-4.999-14.619-6.228-32.2-4.858-51.855l43.94 61.755z"
        opacity="0.5"
      ></path>
      <path
        fill="#9EA4AD"
        d="M157.809 382.16l2.499-1.332-.189-.355c5.145-4.41 8.124-11.727 8.44-21.078.369-10.778-2.827-23.093-8.998-34.675-6.172-11.581-14.624-21.116-23.766-26.801-7.94-4.952-15.668-6.576-22.205-4.76l-.193-.36-2.55 1.354c-.35.16-.699.328-1.04.509-7.228 3.847-11.417 12.15-11.802 23.374-.368 10.778 2.827 23.093 8.999 34.675 6.169 11.578 14.623 21.1 23.763 26.801 9.532 5.956 18.761 7.099 25.996 3.249.352-.184.702-.39 1.046-.601z"
      ></path>
      <path
        fill="#EDEDED"
        d="M171.639 357.754c.368-10.777-2.827-23.093-8.996-34.674-6.169-11.582-14.623-21.117-23.765-26.815-9.535-5.956-18.764-7.102-25.997-3.249-7.233 3.852-11.417 12.147-11.802 23.372-.368 10.78 2.828 23.092 8.999 34.677 6.172 11.578 14.623 21.1 23.765 26.801 9.533 5.956 18.761 7.099 25.997 3.249 7.236-3.85 11.417-12.134 11.799-23.361z"
      ></path>
      <path
        fill="#DADCE0"
        d="M169.791 356.666c.349-10.212-2.679-21.878-8.525-32.853-5.847-10.975-13.844-19.993-22.515-25.402-9.031-5.634-17.775-6.727-24.621-3.081-6.845 3.647-10.818 11.512-11.181 22.143-.349 10.212 2.678 21.88 8.525 32.855 5.846 10.97 13.84 19.99 22.514 25.399 9.029 5.631 17.773 6.725 24.619 3.081 6.845-3.644 10.813-11.508 11.184-22.142z"
      ></path>
      <path
        fill="#B9A3D3"
        d="M124.121 325.682a1.448 1.448 0 011.31-2.122c.337.008.661.133.916.354l21.268 18.585a1.44 1.44 0 01-.251 2.459 1.435 1.435 0 01-1.154.034 1.448 1.448 0 01-.49-.327l-21.269-18.585a1.52 1.52 0 01-.33-.398z"
        opacity="0.5"
      ></path>
      <path
        fill="#8997AD"
        d="M120.875 323.031a1.449 1.449 0 01.359-1.793 1.446 1.446 0 011.83-.007l4.822 3.931c7.125-.599 13.188 1.486 16.701 5.763a12.62 12.62 0 012.556 11.1l4.401 4.332c.254.272.394.632.39 1.005a1.447 1.447 0 01-2.416 1.055l-5.004-4.925a1.445 1.445 0 01-.369-1.456 9.816 9.816 0 00-1.792-9.275c-2.979-3.633-8.368-5.333-14.773-4.667a1.442 1.442 0 01-1.061-.317l-5.281-4.305a1.486 1.486 0 01-.363-.441z"
      ></path>
      <path fill="#DEDFE0" d="M54.32 269.891v106.863a73.916 73.916 0 0020.096 2.913V269.891H54.32z"></path>
      <path
        fill="#939598"
        d="M108.161 241.6c-18.094-10.445-47.436-10.445-65.533 0-18.098 10.445-18.098 27.381 0 37.826 18.097 10.444 47.439 10.444 65.533 0 18.095-10.445 18.098-27.381 0-37.826z"
      ></path>
      <path
        fill="#7F8287"
        d="M44.119 281.061c17.272 10.447 45.275 10.447 62.555 0 4.213-2.548 7.398-5.485 9.556-8.617-2.166-3.135-5.343-6.07-9.556-8.62-17.272-10.445-45.275-10.445-62.555 0-4.214 2.547-7.398 5.485-9.556 8.617 2.158 3.135 5.342 6.072 9.556 8.62z"
      ></path>
      <path
        fill="#707377"
        d="M34.915 272.443s-.542-9.797 10.136-13.474c0 0 8.581-13.133 26.446-8.054 0 0 8.46 2.854 12.806 8.975 1.249 1.754 5.254 3.912 9.148 2.231 4.94-2.131 11.601-3.471 16.399 1.415 2.782 2.651 4.572 5.591 6.378 8.523-3.03 8.059-53.656 31.388-81.313.384z"
      ></path>
      <path
        fill="#606366"
        d="M49.741 270.865s-.541-9.795 10.136-13.474c-.373-3.969 1.869-6.226 8.81-7.141-15.953-3.033-23.636 8.717-23.636 8.717-10.683 3.676-10.136 13.476-10.136 13.476C49.33 288.603 69.992 290 86.908 286.494c-13.919.079-37.319-4.545-37.167-15.629z"
      ></path>
      <path
        fill="#EDEDED"
        d="M75.398 290.779c-13.128 0-25.504-2.978-34.847-8.362-9.73-5.615-15.094-13.214-15.094-21.401s5.36-15.786 15.089-21.387c9.343-5.393 21.718-8.363 34.846-8.363 13.129 0 25.499 2.978 34.844 8.36 9.73 5.604 15.092 13.203 15.092 21.39 0 8.187-5.359 15.786-15.089 21.401-9.343 5.393-21.715 8.362-34.841 8.362zm0-55.062c-12.357 0-23.939 2.759-32.612 7.764-8.29 4.787-12.855 11.013-12.855 17.535s4.565 12.748 12.852 17.532c8.665 5.006 20.256 7.764 32.612 7.764 12.354 0 23.934-2.755 32.607-7.764 8.289-4.784 12.855-11.01 12.855-17.532s-4.566-12.751-12.852-17.535c-8.674-5.005-20.264-7.764-32.607-7.764z"
      ></path>
      <path
        fill="#CACACA"
        d="M104.057 280.671a18.474 18.474 0 01-10.518-5.228 12.69 12.69 0 01-.645-.704c.44-2.239 2.389-3.852 5.46-4.117h.368c4.831-.247 10.504 2.877 12.833 7.125l.732 1.354-1.777.812c-1.85.847-4.111 1.072-6.453.758z"
      ></path>
      <path
        fill="#F98E3C"
        d="M116.071 253.292l19.097 4.023-.615 4.421c-.241 1.741-1.413 3.282-3.46 4.218-4.098 1.868-10.145.593-13.505-2.845-1.679-1.722-2.372-3.658-2.131-5.396l.614-4.421z"
      ></path>
      <path
        fill="url(#paint7_linear_911_112407)"
        d="M118.201 258.688c3.363 3.438 9.407 4.713 13.504 2.845 4.098-1.868 4.693-6.172 1.333-9.613-3.361-3.441-9.408-4.714-13.505-2.854-4.097 1.86-4.693 6.181-1.332 9.622z"
      ></path>
      <path
        fill="#48423B"
        d="M103.784 256.682l.62-4.483 1.896 1.927a1.121 1.121 0 001.806-.208 1.85 1.85 0 00-.168-2.228l-4.422-4.519c-.398-.403-1.002-.13-1.083.496l-.62 4.483-.864-.885a1.132 1.132 0 00-.958-.356 1.123 1.123 0 00-.851.564 1.849 1.849 0 00.168 2.228l3.39 3.487c.395.395.999.119 1.086-.506z"
      ></path>
      <path
        fill="#48423B"
        d="M97.714 260.131l.62-4.483 1.882 1.927a1.117 1.117 0 00.957.357 1.122 1.122 0 00.852-.563 1.852 1.852 0 00-.168-2.23l-4.414-4.516c-.395-.403-1-.13-1.083.498l-.62 4.481-.867-.886a1.13 1.13 0 00-.956-.355 1.12 1.12 0 00-.85.564 1.842 1.842 0 00.168 2.228l3.39 3.473c.398.406 1 .13 1.089-.495z"
      ></path>
      <path
        fill="#F98E3C"
        d="M90.309 264.108l.76-5.485 34.623 2.667-.759 5.444c-.241 2.03-1.478 3.763-3.701 4.776l-10.743 4.986c-4.815 2.196-12.414.192-16.974-4.475-2.545-2.604-3.607-5.49-3.206-7.913z"
      ></path>
      <path
        fill="#48423B"
        d="M128.3 282.095a1.846 1.846 0 00-.168-2.228l-2.004-2.052.639-4.627a2.52 2.52 0 00-.623-2.082l-3.363-3.444a1.118 1.118 0 00-1.451-.175 1.116 1.116 0 00-.358.384 1.85 1.85 0 00.168 2.228l3.022 3.094-.642 4.627a2.52 2.52 0 00.626 2.082l2.345 2.401a1.117 1.117 0 00.957.356 1.123 1.123 0 00.852-.564zM122.228 285.531a1.846 1.846 0 00-.168-2.228l-2.007-2.053.642-4.626a2.52 2.52 0 00-.623-2.082l-3.355-3.441a1.121 1.121 0 00-.956-.357c-.176.02-.345.082-.493.179-.147.098-.27.23-.357.384a1.844 1.844 0 00.168 2.228l3.022 3.094-.642 4.627a2.52 2.52 0 00.625 2.082l2.346 2.401a1.122 1.122 0 00.951.348 1.132 1.132 0 00.847-.556zM115.886 288.175a1.849 1.849 0 00-.168-2.228l-2.007-2.052.642-4.629a2.51 2.51 0 00-.623-2.079l-3.363-3.444a1.117 1.117 0 00-.957-.357 1.135 1.135 0 00-.852.563 1.854 1.854 0 00.168 2.231l3.022 3.091-.642 4.63a2.512 2.512 0 00.626 2.079l2.345 2.401a1.117 1.117 0 00.957.357 1.122 1.122 0 00.852-.563z"
      ></path>
      <path
        fill="url(#paint8_linear_911_112407)"
        d="M94.783 253.823l10.74-4.989c4.696-2.139 12.032-.271 16.622 4.142l-27.82 13.265c-4.565-4.659-4.36-10.222.458-12.418z"
      ></path>
      <path
        fill="url(#paint9_linear_911_112407)"
        d="M122.491 253.309c4.561 4.667 4.355 10.23-.46 12.426l-10.729 4.989c-4.815 2.196-12.414.193-16.974-4.475l27.819-13.265c.109.105.231.211.344.325z"
      ></path>
      <path fill="#B9A3D3" d="M102.088 261.576l-6.768-3.709.764-3.89 6.004 7.599z" opacity="0.5"></path>
      <path
        fill="#48423B"
        d="M100.219 244.683l3.339-1.524-1.983-1.402a1.278 1.278 0 01-.3-1.782 1.28 1.28 0 011.782-.297l4.649 3.311a.66.66 0 01.276.606.66.66 0 01-.387.541l-3.336 1.514.913.647a1.28 1.28 0 01.297 1.781 1.274 1.274 0 01-1.781.301l-3.575-2.548a.666.666 0 01.106-1.148z"
      ></path>
      <path
        fill="#48423B"
        d="M99.072 251.232l3.342-1.524-1.983-1.413a1.269 1.269 0 01-.52-.828 1.278 1.278 0 01.22-.953 1.278 1.278 0 011.782-.298l4.646 3.311a.659.659 0 01.277.605.663.663 0 01-.385.543l-3.342 1.524.913.649a1.28 1.28 0 01.298 1.782 1.276 1.276 0 01-1.782.298l-3.575-2.548a.668.668 0 01.109-1.148z"
      ></path>
      <path
        fill="#48423B"
        d="M98.624 257.881l3.339-1.524-1.982-1.413a1.28 1.28 0 01-.3-1.782 1.281 1.281 0 011.781-.297l4.65 3.311a.66.66 0 01.276.606.67.67 0 01-.387.542l-3.339 1.524.91.647a1.276 1.276 0 01.298 1.781 1.279 1.279 0 01-1.782.301l-3.575-2.548a.669.669 0 01-.155-.929.671.671 0 01.266-.219z"
      ></path>
      <path
        fill="#00E06C"
        d="M97.854 259.178l4.087-1.865-10.895-32.758-4.062 1.855c-1.522.652-2.559 2.201-2.783 4.548l-1.16 11.37c-.487 5.082 3.012 11.98 7.816 15.402 2.686 1.895 5.21 2.328 6.997 1.448z"
      ></path>
      <path
        fill="#48423B"
        d="M74.153 226.347a1.28 1.28 0 011.782-.298l2.112 1.505 3.45-1.572a1.793 1.793 0 011.782.17l3.542 2.523a1.28 1.28 0 01.3 1.782 1.28 1.28 0 01-1.781.3l-3.185-2.266-3.45 1.573a1.785 1.785 0 01-1.782-.173l-2.47-1.76a1.267 1.267 0 01-.521-.829 1.277 1.277 0 01.22-.955zM73.007 232.899a1.278 1.278 0 011.782-.298l2.112 1.505 3.447-1.573a1.799 1.799 0 011.785.171l3.542 2.526a1.276 1.276 0 01.3 1.781 1.278 1.278 0 01-1.781.298l-3.185-2.269-3.45 1.573a1.795 1.795 0 01-1.782-.17l-2.472-1.763a1.278 1.278 0 01-.298-1.781zM72.558 239.545a1.278 1.278 0 011.782-.298l2.112 1.505 3.45-1.573a1.794 1.794 0 011.782.171l3.542 2.523a1.275 1.275 0 01.3 1.781 1.277 1.277 0 01-1.781.301l-3.185-2.269-3.45 1.573a1.785 1.785 0 01-1.782-.173l-2.47-1.76a1.276 1.276 0 01-.3-1.781z"
      ></path>
      <path
        fill="url(#paint10_linear_911_112407)"
        d="M95.164 255.764l1.988-17.868 1.289-11.617c4.62 3.501 7.937 10.169 7.463 15.131l-.165 1.578-.991 9.779a6.45 6.45 0 01-1.084 3.154c-1.638 2.29-4.925 2.388-8.5-.157z"
      ></path>
      <path
        fill="url(#paint11_linear_911_112407)"
        d="M95.163 255.764c-4.804-3.425-8.3-10.323-7.813-15.401l1.16-11.371c.18-1.895.898-3.286 1.981-4.08 1.793-1.353 4.604-1.069 7.599 1.083.114.081.233.179.35.271l-1.29 11.617-1.987 17.881z"
      ></path>
      <path
        fill="#1D5F3E"
        d="M97.714 272.31l-8.002-17.537-3.293 1.502c-1.297.591-2.201 2.036-2.41 4.199-.414 4.332 2.118 9.879 5.66 12.402 1.768 1.262 3.455 1.527 4.752.934l3.293-1.5z"
      ></path>
      <path
        fill="url(#paint12_linear_911_112407)"
        d="M92.964 271.374c-3.54-2.523-6.074-8.073-5.657-12.402.417-4.329 3.62-5.788 7.16-3.265 3.539 2.523 6.074 8.076 5.659 12.402-.414 4.326-3.623 5.788-7.162 3.265z"
      ></path>
      <path fill="#B9A3D3" d="M96.366 253.13l.924 7.661-3.61 1.644 2.686-9.305z" opacity="0.5"></path>
      <path
        fill="#48423B"
        d="M83.712 264.481l-3.182-1.827v2.436a1.28 1.28 0 01-1.276 1.281 1.281 1.281 0 01-1.262-1.278v-5.707a.663.663 0 01.328-.558.673.673 0 01.647-.016l3.182 1.828v-1.119a1.271 1.271 0 01.787-1.18 1.28 1.28 0 01.488-.097 1.263 1.263 0 01.905.37 1.274 1.274 0 01.376.902v4.391a.666.666 0 01-.993.574z"
      ></path>
      <path
        fill="#48423B"
        d="M89.708 261.6l-3.182-1.83v2.437a1.274 1.274 0 01-1.275 1.278 1.282 1.282 0 01-1.181-.787 1.274 1.274 0 01-.097-.488v-5.705a.665.665 0 01.996-.579l3.182 1.83v-1.11a1.274 1.274 0 01.787-1.182c.155-.065.32-.098.489-.098a1.262 1.262 0 01.903.372 1.28 1.28 0 01.375.903v4.388a.66.66 0 01-.334.573.666.666 0 01-.663-.002z"
      ></path>
      <path
        fill="#48423B"
        d="M95.378 258.098l-3.185-1.828v2.437a1.276 1.276 0 01-2.179.906 1.276 1.276 0 01-.377-.901v-5.707a.668.668 0 01.999-.579l3.182 1.83v-1.129a1.28 1.28 0 011.275-1.28 1.28 1.28 0 011.281 1.275v4.391a.668.668 0 01-.996.585z"
      ></path>
      <path
        fill="#1D5F3E"
        d="M96.876 257.97l-3.894-2.239-20.31 27.92 3.867 2.217c1.416.859 3.282.813 5.321-.381l9.914-5.669c4.42-2.561 7.991-9.419 7.98-15.318.006-3.292-1.118-5.588-2.878-6.53z"
      ></path>
      <path
        fill="#48423B"
        d="M83.969 296.343a1.285 1.285 0 01-.906-.372 1.269 1.269 0 01-.375-.903v-2.591l-3.288-1.895a1.792 1.792 0 01-.896-1.549v-4.35a1.278 1.278 0 01.785-1.18 1.277 1.277 0 011.769 1.174v3.909l3.284 1.896a1.783 1.783 0 01.9 1.548v3.035a1.277 1.277 0 01-1.273 1.278zM89.961 293.465a1.284 1.284 0 01-1.28-1.275v-2.594l-3.288-1.895a1.79 1.79 0 01-.905-1.546v-4.35a1.274 1.274 0 01.787-1.182 1.282 1.282 0 011.77 1.177v3.909l3.287 1.895a1.793 1.793 0 01.9 1.548v3.035a1.277 1.277 0 01-1.27 1.278zM95.629 289.959a1.264 1.264 0 01-.905-.372 1.283 1.283 0 01-.376-.903v-2.591l-3.285-1.895a1.786 1.786 0 01-.899-1.548v-4.351a1.274 1.274 0 011.275-1.28 1.278 1.278 0 011.279 1.275v3.909l3.287 1.895a1.781 1.781 0 01.897 1.549v3.032a1.277 1.277 0 01-1.273 1.28z"
      ></path>
      <path
        fill="url(#paint13_linear_911_112407)"
        d="M95.67 262.145l-15.707 8.79-10.201 5.712c.157-5.793 3.653-12.372 7.964-14.873l1.381-.785 8.53-4.873a6.46 6.46 0 013.19-.964c2.84-.011 4.831 2.604 4.842 6.993z"
      ></path>
      <path
        fill="url(#paint14_linear_911_112407)"
        d="M95.668 262.145c0 5.896-3.566 12.753-7.983 15.314l-9.917 5.669c-1.651.959-3.192 1.183-4.47.764-2.137-.677-3.543-3.114-3.548-6.803 0-.141 0-.293.016-.442l10.201-5.712 15.701-8.79z"
      ></path>
      <path
        fill="#1D5F3E"
        d="M107.638 250.439l-9.61 16.712 3.138 1.806c1.235.709 2.941.601 4.82-.488 3.762-2.182 6.803-7.472 6.795-11.817 0-2.166-.772-3.698-2.007-4.41l-3.136-1.803z"
      ></path>
      <path
        fill="url(#paint15_linear_911_112407)"
        d="M109.646 254.846c0 4.348-3.036 9.638-6.794 11.817-3.76 2.18-6.817.425-6.825-3.92-.008-4.345 3.033-9.638 6.792-11.817 3.759-2.179 6.816-.425 6.827 3.92z"
      ></path>
      <path
        fill="#CACACA"
        d="M77.863 266.899c-.783 4.459-2.916 9.069-5.93 12.231-.247.255-.49.501-.737.726-2.137-.677-3.542-3.113-3.548-6.803 0-.141 0-.295.017-.442.157-5.793 3.653-12.372 7.964-14.873l1.378-.785.656 2.165c.666 2.283.698 5.001.2 7.781z"
      ></path>
      <path
        fill="#F98E3C"
        d="M52.281 250.715l5.468-22.57 4.238 1.026c1.668.403 3.07 1.895 3.807 4.421 1.479 5.024-.252 12.169-3.864 15.959-1.806 1.895-3.743 2.593-5.416 2.19l-4.233-1.026z"
      ></path>
      <path
        fill="url(#paint16_linear_911_112407)"
        d="M57.68 248.525c3.613-3.79 5.344-10.937 3.868-15.973-1.476-5.035-5.606-6.024-9.208-2.231-3.601 3.793-5.342 10.935-3.864 15.973 1.479 5.038 5.6 6.021 9.205 2.231z"
      ></path>
      <path
        fill="#48423B"
        d="M54.565 265.634l-4.3-1.042 2.025-2.122a1.543 1.543 0 00-.054-2.166 1.537 1.537 0 00-2.167.054l-4.744 4.976a.812.812 0 00.393 1.332l4.297 1.042-.929.975a1.537 1.537 0 00.055 2.166 1.536 1.536 0 002.166-.052l3.648-3.828a.814.814 0 00-.39-1.335z"
      ></path>
      <path
        fill="#48423B"
        d="M57.413 273.123l-4.295-1.045 2.023-2.123a1.54 1.54 0 00-.052-2.165 1.537 1.537 0 00-2.166.054l-4.742 4.976a.81.81 0 00.032 1.128c.1.097.223.168.358.204l4.3 1.039-.929.977a1.537 1.537 0 00.052 2.166 1.541 1.541 0 002.166-.051l3.648-3.828a.814.814 0 00-.395-1.332z"
      ></path>
      <path
        fill="#F98E3C"
        d="M60.661 282.241l-5.259-1.275 5.416-41.226 5.221 1.269c1.95.425 3.52 2.02 4.333 4.746l3.962 13.171c1.736 5.904-.831 14.857-5.733 20.001-2.73 2.872-5.616 3.947-7.94 3.314z"
      ></path>
      <path
        fill="#48423B"
        d="M81.218 238.005a1.533 1.533 0 00-2.167.051l-2.166 2.26-4.439-1.082a2.163 2.163 0 00-2.069.606l-3.617 3.79a1.539 1.539 0 00.054 2.166c.294.28.688.431 1.094.421a1.533 1.533 0 001.072-.472l3.25-3.412 4.438 1.083a2.163 2.163 0 002.069-.606l2.524-2.648a1.537 1.537 0 00-.043-2.157zM84.069 245.493a1.541 1.541 0 00-2.167.054l-2.166 2.26-4.438-1.083a2.165 2.165 0 00-2.07.609l-3.614 3.791a1.533 1.533 0 00.05 2.165 1.541 1.541 0 002.167-.051l3.25-3.411 4.438 1.083a2.165 2.165 0 002.07-.609l2.52-2.645a1.541 1.541 0 00-.04-2.163zM86.116 253.252a1.537 1.537 0 00-2.166.054l-2.167 2.258-4.438-1.083a2.165 2.165 0 00-2.07.609l-3.617 3.79a1.536 1.536 0 00.054 2.166 1.536 1.536 0 002.166-.052l3.25-3.411 4.439 1.083a2.165 2.165 0 002.068-.609l2.524-2.645a1.543 1.543 0 00-.043-2.16z"
      ></path>
      <path
        fill="url(#paint17_linear_911_112407)"
        d="M51.053 276.212l-3.96-13.171c-1.695-5.758.713-14.405 5.379-19.603l10.599 34.149c-4.902 5.144-10.282 4.529-12.018-1.375z"
      ></path>
      <path
        fill="url(#paint18_linear_911_112407)"
        d="M52.825 243.04c4.901-5.144 10.29-4.529 12.02 1.375l3.96 13.171c1.735 5.904-.832 14.857-5.733 20.001l-10.6-34.149c.12-.133.23-.271.353-.398z"
      ></path>
      <path fill="#B9A3D3" d="M28.198 250.141l-.374 9.289 4.49 1.629-4.116-10.918z" opacity="0.5"></path>
      <path
        fill="#48423B"
        d="M44.48 262.565l3.648-2.502.225 2.924a1.545 1.545 0 001.654 1.416 1.542 1.542 0 001.417-1.654l-.542-6.852a.81.81 0 00-1.254-.598l-3.648 2.498-.102-1.353a1.534 1.534 0 00-1.059-1.343 1.545 1.545 0 00-.596-.07 1.535 1.535 0 00-1.413 1.651l.408 5.274a.808.808 0 00.457.666.817.817 0 00.805-.057z"
      ></path>
      <path
        fill="#48423B"
        d="M37.002 259.676l3.648-2.488.227 2.924a1.534 1.534 0 001.059 1.343c.192.062.395.086.596.07a1.535 1.535 0 001.414-1.651l-.542-6.855a.81.81 0 00-1.254-.598l-3.647 2.501-.106-1.353a1.533 1.533 0 00-1.056-1.344 1.542 1.542 0 00-2.012 1.582l.42 5.277a.816.816 0 00.864.724.81.81 0 00.39-.132z"
      ></path>
      <path
        fill="#48423B"
        d="M29.862 256.013l3.645-2.501.227 2.923a1.543 1.543 0 001.655 1.416 1.54 1.54 0 001.416-1.654l-.542-6.852a.815.815 0 00-.862-.732.816.816 0 00-.391.131l-3.648 2.502-.103-1.354a1.54 1.54 0 00-1.655-1.413 1.538 1.538 0 00-1.416 1.651l.412 5.274a.814.814 0 00.866.745.812.812 0 00.396-.136z"
      ></path>
      <path
        fill="url(#paint19_linear_911_112407)"
        d="M28.046 256.003l4.452-3.06 27.061 31.588-4.433 3.035c-1.625 1.167-3.864 1.275-6.426.049l-12.457-5.858c-5.551-2.656-10.499-10.559-11.051-17.633-.298-3.958.831-6.822 2.854-8.121z"
      ></path>
      <path
        fill="#48423B"
        d="M47.22 300.851a1.54 1.54 0 001.416-1.652l-.241-3.113 3.764-2.583a2.165 2.165 0 00.932-1.946l-.407-5.225a1.543 1.543 0 00-1.654-1.416 1.537 1.537 0 00-1.414 1.654l.363 4.694-3.764 2.583a2.165 2.165 0 00-.932 1.946l.285 3.644a1.533 1.533 0 001.652 1.414zM39.742 297.965a1.542 1.542 0 001.416-1.654l-.243-3.114 3.767-2.582a2.17 2.17 0 00.931-1.944l-.406-5.228a1.54 1.54 0 00-1.655-1.413 1.542 1.542 0 00-1.416 1.654l.366 4.694-3.778 2.583a2.166 2.166 0 00-.929 1.944l.27 3.644a1.545 1.545 0 001.677 1.416zM32.602 294.299a1.536 1.536 0 001.417-1.651l-.244-3.116 3.767-2.58a2.171 2.171 0 00.931-1.947l-.406-5.225a1.54 1.54 0 00-2.704-.881 1.529 1.529 0 00-.364 1.12l.363 4.694-3.764 2.583a2.158 2.158 0 00-.932 1.946l.285 3.644a1.538 1.538 0 001.056 1.343c.192.062.394.086.596.07z"
      ></path>
      <path
        fill="url(#paint20_linear_911_112407)"
        d="M38.957 252.884l12.457 5.858c5.416 2.588 10.244 10.158 10.989 17.102L29.907 260.9c-.558-7.082 3.499-10.672 9.05-8.016z"
      ></path>
      <path
        fill="url(#paint21_linear_911_112407)"
        d="M62.456 276.372c.541 7.085-3.505 10.674-9.056 8.019l-12.457-5.859c-5.551-2.656-10.499-10.558-11.048-17.632l32.496 14.944c.021.176.05.355.065.528z"
      ></path>
      <path
        fill="url(#paint22_linear_911_112407)"
        d="M14.397 247.984l13.14 19.151-3.6 2.466c-1.413.969-3.471 1.005-5.833-.124-4.725-2.258-8.885-8.322-9.29-13.537-.204-2.609.57-4.515 1.987-5.484l3.596-2.472z"
      ></path>
      <path
        fill="url(#paint23_linear_911_112407)"
        d="M12.411 253.474c.406 5.22 4.566 11.284 9.288 13.536 4.723 2.253 8.227-.141 7.821-5.36-.406-5.22-4.563-11.284-9.288-13.536-4.726-2.253-8.227.14-7.821 5.36z"
      ></path>
      <path
        fill="url(#paint24_linear_911_112407)"
        d="M658 186.215l-194.102.813v16.974h.017c-.044 2.133 1.207 4.177 3.842 5.685l82.835 47.813c5.72 3.3 15.707 2.886 22.311-.926l79.635-45.95c3.623-2.093 5.462-4.77 5.451-7.31v-17.099H658z"
      ></path>
      <path
        fill="url(#paint25_linear_911_112407)"
        d="M571.303 132.715l82.835 47.812c5.719 3.301 5.001 9.067-1.601 12.879l-79.631 45.963c-6.605 3.81-16.592 4.224-22.312.924l-82.834-47.808c-5.72-3.3-5.002-9.066 1.6-12.875l79.631-45.969c6.605-3.812 16.592-4.234 22.312-.926z"
      ></path>
      <path
        fill="url(#paint26_linear_911_112407)"
        d="M549.07 112.394c-.132-.079-.27-.157-.398-.23l-.195-.114c-5.036-2.686-11.874-2.182-19.413 2.166-15.474 8.934-28.017 30.654-28.017 48.516v24.986c0 .017.005.034.013.049a.106.106 0 00.036.037l19.874 11.582a.1.1 0 00.135-.035l46.602-76.039-18.637-10.918z"
      ></path>
      <path
        fill="url(#paint27_linear_911_112407)"
        d="M549.116 125.862c-15.495 8.915-28.065 30.663-28.065 48.541v19.815a3.029 3.029 0 001.509 2.616 3.027 3.027 0 003.021-.001l51.496-29.728v-25.042c0-17.733-12.587-25.045-27.961-16.201z"
      ></path>
      <path
        fill="url(#paint28_linear_911_112407)"
        d="M550.605 9.475c3.976-7.9 9.857-10.964 15.024-8.771.195.067.385.147.569.241.049.024.097.043.146.07l6.499 3.72 9.267 38.105 6.261 9.534c.511.797.971 1.625 1.376 2.48l.796.59c4.999 7.61 23.261 14.62 19.971 25.075l-15.116 20.053-11.235-6.796c-2.061-.882-4.005-2.528-5.671-5.065l-27.67-41.234c-5.849-8.907-5.749-27.026-.217-38.002z"
      ></path>
      <path
        fill="url(#paint29_linear_911_112407)"
        d="M590.285 95.744l-31.161-45.93c-5.85-8.907-6.107-25.037-.577-36.029 5.532-10.988 14.759-12.678 20.608-3.77l48.6 70.832c5.849 8.906-11.333.127-16.862 11.115-5.533 11-14.759 12.689-20.608 3.782z"
      ></path>
      <path
        fill="url(#paint30_linear_911_112407)"
        d="M523.726 185.917l61.2-89.761c6.521-9.895 22.88-17.261 36.539-16.457 4.116.243 7.512 1.204 10.077 2.693l19.227 11.133-66.238 78.095-11.347 17.219c-3.249 4.948-8.985 9.264-15.6 12.242l-11.645 12.724-19.226-11.122c-.168-.097-.339-.189-.501-.289l-.03-.019c-5.614-3.495-6.914-9.689-2.456-16.458z"
      ></path>
      <path
        fill="url(#paint31_linear_911_112407)"
        d="M604.048 107.207l-61.2 89.762c-6.521 9.894-.732 18.566 12.928 19.373 13.659.806 30.018-6.563 36.539-16.455l61.2-89.764c6.518-9.892.731-18.566-12.928-19.373-13.659-.807-30.021 6.57-36.539 16.457z"
      ></path>
      <path fill="#CACACA" d="M581.723 234.279l-32.653-18.658 75.995-20.597 12.714 6.901-56.056 32.354z"></path>
      <path
        fill="url(#paint32_linear_911_112407)"
        d="M597.095 140.281c-.13-.077-.263-.153-.398-.227l-.192-.114c-5.034-2.685-11.875-2.182-19.414 2.166-15.473 8.934-28.017 30.651-28.017 48.514v24.988c0 .017.005.034.013.049a.106.106 0 00.036.037l19.874 11.582c.023.013.05.016.075.01a.101.101 0 00.06-.045l46.605-76.039-18.642-10.921z"
      ></path>
      <path
        fill="url(#paint33_linear_911_112407)"
        d="M597.141 153.752c-15.495 8.915-28.063 30.663-28.063 48.541v24.872c0 .017.005.034.014.049a.09.09 0 00.036.036.096.096 0 00.049.014.096.096 0 00.05-.013l55.836-32.216a.106.106 0 00.036-.037.106.106 0 00.013-.05v-24.987c0-17.741-12.598-25.053-27.971-16.209z"
      ></path>
      <path
        fill="url(#paint34_linear_911_112407)"
        d="M608.546 69.124l7.945-33.946-41.473-23.807c-3.477-.813-7.696 1.556-11.081 7.477A26.82 26.82 0 00560.46 33.7c.36 6.05 2.556 9.879 5.484 11.227.966.433 42.602 24.197 42.602 24.197z"
      ></path>
      <path
        fill="url(#paint35_linear_911_112407)"
        d="M593.541 33.873c3.978-7.897 9.857-10.962 15.027-8.771.194.069.384.15.569.243l.146.068 6.499 3.722 9.267 38.105 6.264 9.535c.51.796.969 1.623 1.375 2.477l.796.593c4.999 7.61 23.262 14.619 19.969 25.074l-15.565 19.779-10.786-6.521c-2.059-.883-4.003-2.532-5.668-5.068l-27.673-41.218c-5.852-8.907-5.749-27.027-.22-38.018z"
      ></path>
      <path
        fill="url(#paint36_linear_911_112407)"
        d="M633.223 120.156l-31.161-45.923c-5.849-8.907-6.109-25.037-.577-36.026 5.533-10.991 14.759-12.68 20.608-3.774l31.161 45.923c5.85 8.907 6.107 25.037.574 36.028-5.529 10.989-14.755 12.678-20.605 3.772z"
      ></path>
      <path
        fill="#fff"
        d="M602.779 62.538c-2.274-7.524.241-18.272 5.619-24.003 5.379-5.731 11.588-4.283 13.863 3.249 2.274 7.531-.239 18.268-5.619 24.002-5.381 5.734-11.585 4.27-13.863-3.248z"
      ></path>
      <path
        fill="url(#paint37_linear_911_112407)"
        d="M501.721 112.584l-17.916-22.386 81.302-64.644c1.655-1.324 4.181-1.554 7.192-.379 6.026 2.353 11.696 9.44 12.671 15.83.485 3.197-.295 5.611-1.95 6.935l-81.299 64.644z"
      ></path>
      <path
        fill="#fff"
        d="M503.669 105.65c-.975-6.389-6.646-13.476-12.668-15.829-6.023-2.352-10.118.92-9.143 7.31.975 6.389 6.646 13.476 12.668 15.829 6.023 2.353 10.115-.918 9.143-7.31z"
      ></path>
      <path
        fill="url(#paint38_linear_911_112407)"
        d="M494.115 128.716l-27.822-34.774 12.484-9.709c2.57-2.054 6.499-2.412 11.173-.587 9.351 3.655 18.16 14.66 19.671 24.584.755 4.963-.455 8.712-3.022 10.77l-12.484 9.716z"
      ></path>
      <path
        fill="url(#paint39_linear_911_112407)"
        d="M497.14 117.95c-1.514-9.925-10.32-20.93-19.674-24.585-9.353-3.655-15.706 1.432-14.198 11.357 1.509 9.925 10.321 20.93 19.674 24.582 9.353 3.652 15.709-1.432 14.198-11.354z"
      ></path>
      <path fill="#fff" d="M482.959 115.139v8.953l-14.799-8.406v-9.5l14.799 8.953z"></path>
      <path
        fill="url(#paint40_linear_911_112407)"
        d="M456.423 113.295l19.026-2.618a.101.101 0 01.077.026.081.081 0 01.024.034.097.097 0 01.008.041v8.749a.103.103 0 01-.084.101l-19.051 2.62a.072.072 0 00-.035.014l-11.596 7.011a.096.096 0 01-.049.014.096.096 0 01-.084-.051.092.092 0 01-.01-.049v-8.715c0-.017.004-.034.013-.049a.096.096 0 01.035-.037l11.691-7.072a.08.08 0 01.035-.019z"
      ></path>
      <path
        fill="#586577"
        d="M482.975 115.131l5.651-3.538a.106.106 0 01.05-.012.104.104 0 01.048.015.093.093 0 01.034.037.094.094 0 01.012.049v8.715a.093.093 0 01-.011.049.09.09 0 01-.035.037l-5.738 3.593a.096.096 0 00-.041.048l-4.3 11.447a.101.101 0 01-.023.035.115.115 0 01-.035.022.113.113 0 01-.041.005.092.092 0 01-.039-.014l-7.209-4.358a.107.107 0 01-.046-.069.1.1 0 01.019-.08l11.677-15.957a.058.058 0 01.027-.024z"
      ></path>
      <path
        fill="url(#paint41_linear_911_112407)"
        d="M459.449 138.199v-8.749c0-.024.009-.047.024-.066a.112.112 0 01.06-.035l18.956-2.607a.101.101 0 01.077.026.081.081 0 01.024.034.11.11 0 01.008.04v8.748a.106.106 0 01-.023.066.107.107 0 01-.061.034l-18.956 2.61a.101.101 0 01-.077-.026.081.081 0 01-.024-.034.097.097 0 01-.008-.041z"
      ></path>
      <path
        fill="url(#paint42_linear_911_112407)"
        d="M488.628 111.416l-14.607-8.836a.088.088 0 00-.098 0l-4.168 2.607-16.48 5.222-8.623 10.063 11.775-7.171 13.32-1.833 5.655-.777a.092.092 0 01.049.009.102.102 0 01.058.079.107.107 0 01-.007.05l-4.284 11.395a.078.078 0 01-.016.028.07.07 0 01-.025.02l-11.306 6.842a.102.102 0 00-.044.05.103.103 0 00-.002.067.099.099 0 00.106.069l18.62-2.561a.097.097 0 00.046-.021.112.112 0 00.03-.041l4.333-11.5a.107.107 0 01.04-.049l5.644-3.533a.107.107 0 00.035-.041.108.108 0 00.009-.053.106.106 0 00-.019-.051.114.114 0 00-.041-.034z"
      ></path>
      <path
        fill="#fff"
        d="M451.058 96.795c8.638-5.735 7.232-23.04-3.14-38.653-10.372-15.612-25.782-23.62-34.419-17.884-8.638 5.734-7.232 23.04 3.14 38.652 10.372 15.613 25.782 23.62 34.419 17.885z"
        opacity="0.5"
      ></path>
      <path
        fill="url(#paint43_linear_911_112407)"
        d="M447.092 100.777c1.563-2.707 5.367-4.9 8.492-4.9 1.566 0 2.662.541 3.174 1.435l26.644 46.678c.512.888.439 2.114-.344 3.468-1.562 2.707-5.364 4.9-8.492 4.9-1.563 0-2.662-.541-3.174-1.435l-26.644-46.678c-.523-.888-.449-2.114.344-3.468z"
      ></path>
      <path
        fill="#4A4C51"
        d="M414.624 35.735a14.837 14.837 0 013.282-.57c3.997-.272 8.593.93 13.489 3.757 6.336 3.657 12.161 9.491 16.838 16.31l.117.169c.335.49.671.977.993 1.48.596.914 1.17 1.846 1.723 2.797a54.617 54.617 0 011.562 2.886c.271.542.542 1.083.788 1.608l.081.176c3.57 7.461 5.714 15.431 5.714 22.741 0 5.653-1.267 10.225-3.488 13.558a14.862 14.862 0 01-2.139 2.556 13.406 13.406 0 01-2.518 1.895l5.416-3.127c5.034-2.905 8.145-9.137 8.145-18.003 0-17.736-12.456-39.302-27.814-48.168-7.682-4.431-14.623-4.851-19.67-1.946l-5.416 3.127a13.412 13.412 0 012.897-1.246z"
      ></path>
      <path
        fill="#B6B6B6"
        d="M409.836 54.986c0 5.98 1.747 12.917 4.874 19.609.03.06.057.12.084.179.255.541.517 1.077.788 1.608.501.969 1.016 1.935 1.563 2.886a63.765 63.765 0 002.719 4.282c.038.055.075.106.111.16 4.232 6.054 9.369 11.035 14.55 14.024 5.332 3.081 10.222 3.79 13.41 1.949a7.687 7.687 0 002.353-2.185c-1.255.116-2.52.037-3.751-.235a22.795 22.795 0 01-6.594-2.656c-6.399-3.693-12.727-10.426-17.379-18.466-4.653-8.04-7.312-16.896-7.312-24.282a22.74 22.74 0 01.996-7.038 12.182 12.182 0 011.669-3.365 7.65 7.65 0 00-3.069.942c-3.181 1.843-5.012 6.432-5.012 12.588z"
      ></path>
      <path
        fill="url(#paint44_linear_911_112407)"
        d="M403.578 54.987c0 17.735 12.457 39.298 27.817 48.167 7.682 4.432 14.623 4.851 19.671 1.947a13.368 13.368 0 002.518-1.896 14.818 14.818 0 002.139-2.555c2.221-3.333 3.488-7.905 3.488-13.558 0-7.31-2.144-15.277-5.714-22.74l-.081-.177a53.404 53.404 0 00-.788-1.608 68.946 68.946 0 00-1.562-2.886 65.71 65.71 0 00-2.717-4.277l-.116-.168c-4.677-6.82-10.502-12.654-16.838-16.311-4.896-2.827-9.478-4.015-13.489-3.758a14.837 14.837 0 00-3.282.571 13.4 13.4 0 00-2.897 1.237c-5.035 2.913-8.149 9.145-8.149 18.012zm14.353-13.537a12.188 12.188 0 013.75.236 22.848 22.848 0 016.594 2.656c6.399 3.693 12.728 10.425 17.377 18.466 4.65 8.04 7.312 16.893 7.312 24.281a22.712 22.712 0 01-.997 7.04 12.154 12.154 0 01-1.668 3.364 7.664 7.664 0 01-2.353 2.185c-3.187 1.841-8.078 1.132-13.41-1.95-5.18-2.977-10.317-7.97-14.55-14.023l-.111-.16c-.336-.495-.677-.985-.999-1.489a62.747 62.747 0 01-1.72-2.793 55.437 55.437 0 01-1.562-2.886c-.271-.542-.542-1.083-.788-1.608l-.084-.18c-3.128-6.691-4.875-13.627-4.875-19.608 0-6.156 1.831-10.745 5.018-12.586a7.65 7.65 0 013.057-.936l.009-.009z"
      ></path>
      <path fill="url(#paint45_linear_911_112407)" d="M459.449 129.45v8.75l19.07-2.51.03-8.956-19.1 2.716z"></path>
      <path
        fill="url(#paint46_linear_911_112407)"
        d="M475.5 110.824l-4.325 11.443-11.726 7.182 19.1-2.715 4.438-11.611 5.644-3.533-14.705-9.01-4.167 2.607-5.858 1.153 3.139 5.496 8.46-1.012z"
      ></path>
      <path fill="#B9A3D3" d="M273.76 170.917l-4.846 6.095 10.527 8.365 4.847-6.095-10.528-8.365z" opacity="0.5"></path>
      <path
        fill="#48423B"
        d="M283.059 203.067l4.571.599-1.173-2.824a1.61 1.61 0 01.87-2.098 1.594 1.594 0 011.228 0 1.605 1.605 0 01.868.869l2.748 6.619a.836.836 0 01-.883 1.148l-4.571-.598.542 1.296a1.601 1.601 0 01-.869 2.096 1.599 1.599 0 01-1.749-.346 1.59 1.59 0 01-.347-.521l-2.113-5.092a.836.836 0 01.878-1.148z"
      ></path>
      <path
        fill="#48423B"
        d="M277.474 209.286l4.571.598-1.172-2.824a1.608 1.608 0 01.866-2.098 1.603 1.603 0 011.23 0 1.61 1.61 0 01.869.869l2.746 6.619a.84.84 0 01-.108.829.83.83 0 01-.772.319l-4.571-.598.541 1.297a1.606 1.606 0 01-.869 2.098 1.598 1.598 0 01-1.228 0 1.61 1.61 0 01-.868-.869l-2.115-5.092a.83.83 0 01.452-1.091.836.836 0 01.428-.057z"
      ></path>
      <path
        fill="#48423B"
        d="M272.575 216.067l4.571.599-1.17-2.824a1.599 1.599 0 01-.002-1.229 1.61 1.61 0 01.869-.869 1.607 1.607 0 012.096.866l2.749 6.622a.843.843 0 01-.115.813.828.828 0 01-.755.324l-4.571-.598.542 1.297a1.607 1.607 0 01-.867 2.095 1.606 1.606 0 01-2.098-.866l-2.113-5.093a.836.836 0 01.864-1.137z"
      ></path>
      <path
        fill="url(#paint47_linear_911_112407)"
        d="M270.892 216.936l5.592.726 10.188-42.138-5.554-.723c-2.059-.32-4.192.641-5.996 2.978l-8.793 11.332c-3.902 5.09-4.766 14.763-1.925 21.604 1.589 3.842 3.994 5.97 6.488 6.221z"
      ></path>
      <path
        fill="#48423B"
        d="M267.49 166.197a1.604 1.604 0 012.099.867l1.248 3.007 4.72.618a2.252 2.252 0 011.785 1.353l2.096 5.049a1.61 1.61 0 01-.867 2.096 1.612 1.612 0 01-2.098-.867l-1.882-4.515-4.72-.62a2.243 2.243 0 01-1.785-1.367l-1.462-3.52a1.62 1.62 0 01-.003-1.23 1.624 1.624 0 01.869-.871zM261.906 172.416a1.603 1.603 0 012.099.866l1.248 3.008 4.731.617a2.251 2.251 0 011.784 1.354l2.096 5.049a1.602 1.602 0 01-.866 2.095 1.608 1.608 0 01-2.099-.866l-1.895-4.535-4.707-.606a2.242 2.242 0 01-1.787-1.354l-1.46-3.519a1.609 1.609 0 01.856-2.109zM257.006 179.195a1.604 1.604 0 012.099.869l1.249 3.007 4.72.618a2.25 2.25 0 011.784 1.353l2.096 5.047a1.597 1.597 0 01.014 1.243 1.61 1.61 0 01-.878.882 1.612 1.612 0 01-2.098-.867l-1.896-4.537-4.72-.617a2.243 2.243 0 01-1.785-1.367l-1.462-3.52a1.603 1.603 0 01.35-1.763c.151-.15.33-.268.527-.348z"
      ></path>
      <path
        fill="url(#paint48_linear_911_112407)"
        d="M282.505 214.684l8.792-11.332c3.808-4.965 4.712-14.281 2.121-21.084l-23.121 29.238c2.841 6.841 8.305 8.26 12.208 3.178z"
      ></path>
      <path
        fill="url(#paint49_linear_911_112407)"
        d="M293.224 181.74c-2.838-6.844-8.305-8.263-12.207-3.17l-8.793 11.329c-3.902 5.093-4.766 14.766-1.926 21.607l23.121-29.238c-.065-.182-.124-.36-.195-.528z"
      ></path>
      <path
        fill="url(#paint50_linear_911_112407)"
        d="M263.321 231.093l3.144-24.008-4.508-.59c-1.774-.233-3.702.706-5.362 2.875-3.323 4.331-4.32 11.931-2.226 16.974 1.048 2.521 2.667 3.926 4.441 4.158l4.511.591z"
      ></path>
      <path
        fill="url(#paint51_linear_911_112407)"
        d="M258.884 226.934c-2.091-5.043-1.083-12.643 2.226-16.974 3.309-4.332 7.709-3.761 9.803 1.283 2.093 5.044 1.096 12.643-2.224 16.974-3.32 4.332-7.715 3.758-9.805-1.283z"
      ></path>
      <path fill="#CACACA" d="M282.92 184.918l-8.676-3.836-.932-.487 2.622-2.908 6.986 7.231z"></path>
      <path
        fill="#A3A3A3"
        d="M262.73 168.745v1.895l6.362 6.684 4.221 3.271.574-.666-2.675-2.605 11.709 7.594-10.526-8.365-9.665-7.808z"
      ></path>
      <path fill="#B1B0B0" d="M268.373 163.426l-4.846 6.095 10.528 8.366 4.846-6.096-10.528-8.365z"></path>
      <path
        fill="#CACACA"
        d="M277.245 170.475l-4.847 6.095 10.528 8.366 4.846-6.095-10.527-8.366zM259.757 150.401l-10.304 12.326 9.852 8.271c.91.76 2.323.92 4.024.297 3.404-1.248 6.664-5.143 7.287-8.717.312-1.784-.095-3.148-1.007-3.909l-9.852-8.268z"
      ></path>
      <path
        fill="#fff"
        d="M260.78 154.313c-.623 3.568-3.884 7.469-7.288 8.714-3.404 1.246-5.654-.636-5.034-4.204.62-3.568 3.886-7.472 7.287-8.717 3.402-1.246 5.644.633 5.035 4.207z"
      ></path>
      <path
        fill="#586577"
        d="M232.043 146.659l-19.435 25.935c-2.462 3.436-2.822 9.822-.813 14.265 2.015 4.445 5.644 5.26 8.105 1.825l19.436-25.936c2.458-3.435 2.819-9.822.812-14.264-2.017-4.443-5.638-5.271-8.105-1.825z"
      ></path>
      <path
        fill="url(#paint52_linear_911_112407)"
        d="M348.208 373.147l-218.755.904v19.13h.019c-.049 2.404 1.354 4.71 4.333 6.424l93.358 53.874c6.445 3.72 17.702 3.249 25.144-1.042l89.746-51.801c4.083-2.358 6.155-5.373 6.144-8.235v-19.265l.011.011z"
      ></path>
      <path
        fill="url(#paint53_linear_911_112407)"
        d="M250.502 312.851l93.358 53.888c6.445 3.72 5.636 10.217-1.806 14.511l-89.746 51.803c-7.444 4.294-18.701 4.762-25.146 1.04l-93.358-53.875c-6.445-3.719-5.636-10.217 1.806-14.513l89.746-51.801c7.444-4.304 18.701-4.772 25.146-1.053z"
      ></path>
      <path
        fill="url(#paint54_linear_911_112407)"
        d="M209.87 382.679l3.371-12.586c8.016-6.543 13.979-17.191 13.979-25.794V317.89l10.063-37.569-14.469-7.851c-3.344-1.957-8.297-1.565-13.827 1.624-10.068 5.813-18.233 18.68-18.233 28.754v62.494c0 4.749 1.817 8.022 4.793 9.549l14.323 7.788z"
      ></path>
      <path
        fill="url(#paint55_linear_911_112407)"
        d="M205.641 373.426v-62.494c0-10.068 8.164-22.941 18.235-28.753 10.069-5.813 18.233-2.364 18.233 7.704v62.494c0 10.069-8.164 22.942-18.233 28.754-10.071 5.81-18.235 2.361-18.235-7.705z"
      ></path>
      <path
        fill="url(#paint56_linear_911_112407)"
        d="M262.24 351.86l-26.647 46.126-24.967-14.321c-3.41-1.968-5.517-6.186-5.517-12.183 0-12.009 8.433-26.612 18.834-32.617 5.203-3.002 9.912-3.286 13.321-1.318l24.976 14.313z"
      ></path>
      <path
        fill="#fff"
        d="M248.92 353.178c-10.401 6.005-18.834 20.608-18.834 32.615 0 12.006 8.433 16.877 18.834 10.872 10.401-6.005 18.837-20.608 18.837-32.614 0-12.007-8.433-16.877-18.837-10.873z"
      ></path>
      <path
        fill="url(#paint57_linear_911_112407)"
        d="M168.862 226.355l41.762-57.816c2.454-3.427 5.628-4.228 8.463-2.656l.076.044.065.038 13.139 7.745-8.1 17.326c-.287.751-.627 1.48-1.018 2.182l-38.521 69.171-12.625-7.426-.032-.022-.027-.014c-1.701-.996-3.274-2.853-4.485-5.52-3.255-7.182-2.673-17.502 1.303-23.052z"
      ></path>
      <path
        fill="url(#paint58_linear_911_112407)"
        d="M223.43 176.076l-41.766 57.814c-3.975 5.552-4.555 15.872-1.297 23.049 3.25 7.18 9.121 8.498 13.093 2.948l41.766-57.816c3.975-5.55 4.557-15.87 1.3-23.049-3.258-7.177-9.121-8.498-13.096-2.946z"
      ></path>
      <path
        fill="url(#paint59_linear_911_112407)"
        d="M183.145 228.158c3.507-6.971 8.698-9.676 13.269-7.743h.044l.46.222c.043.022.087.038.127.063l22.325 12.645 8.178 33.629 5.527 8.415a19.45 19.45 0 011.216 2.187l6.933 10.558c4.414 6.72 18.847 11.143 15.942 20.361l-13.343 17.698-23.421-11.206v-.032c-1.809-.747-3.521-2.201-4.994-4.44l-22.972-34.975-.928-1.083a19.49 19.49 0 01-1.216-2.19l-6.933-10.558c-5.175-7.859-5.096-23.851-.214-33.551z"
      ></path>
      <path
        fill="url(#paint60_linear_911_112407)"
        d="M239.291 321.937l-32.049-48.798c-5.164-7.851-5.392-22.096-.509-31.796 4.874-9.701 13.025-11.19 18.189-3.33l32.063 48.798c5.162 7.851 5.389 22.096.507 31.796-4.897 9.7-13.039 11.189-18.201 3.33z"
      ></path>
      <path fill="#CACACA" d="M225.098 391.96l50.888 27.424 40.366-23.298-50.426-29.826-40.828 25.7z"></path>
      <path
        fill="url(#paint61_linear_911_112407)"
        d="M248.577 404.638l3.368-12.583c8.022-6.544 13.979-17.191 13.979-25.795v-26.412l10.06-37.568-14.466-7.851c-3.341-1.958-8.294-1.565-13.824 1.624-10.071 5.812-18.233 18.68-18.233 28.754v62.494c0 4.748 1.817 8.021 4.793 9.548l14.323 7.789z"
      ></path>
      <path
        fill="url(#paint62_linear_911_112407)"
        d="M244.336 395.384V332.89c0-10.065 8.165-22.938 18.233-28.751 10.071-5.812 18.233-2.363 18.233 7.705v62.494c0 10.066-8.162 22.939-18.233 28.751-10.068 5.813-18.233 2.364-18.233-7.705z"
      ></path>
      <path
        fill="#fff"
        d="M212.087 243.852c-3.521 5.008-4.298 13.571-1.725 19.129 2.572 5.558 7.52 6.002 11.046.994 3.526-5.009 4.3-13.572 1.725-19.127-2.576-5.555-7.52-6.005-11.046-.996z"
      ></path>
      <path
        fill="url(#paint63_linear_911_112407)"
        d="M259.377 142.685l-15.576 26.972-14.599-8.373c-1.993-1.151-3.225-3.617-3.225-7.128 0-7.023 4.931-15.562 11.013-19.073 3.041-1.754 5.795-1.919 7.788-.769l14.599 8.371z"
      ></path>
      <path
        fill="url(#paint64_linear_911_112407)"
        d="M251.588 143.457c-6.083 3.519-11.014 12.05-11.014 19.072 0 7.023 4.931 9.868 11.014 6.357 6.082-3.512 11.013-12.05 11.013-19.073 0-7.022-4.931-9.865-11.013-6.356z"
      ></path>
      <path
        fill="#586577"
        d="M247.511 154.11l-19.436 25.935c-2.461 3.435-2.819 9.822-.812 14.264 2.017 4.443 5.646 5.261 8.105 1.825l19.454-25.935c2.459-3.436 2.819-9.822.813-14.265-2.026-4.442-5.655-5.26-8.124-1.824z"
      ></path>
      <path
        fill="#CACACA"
        d="M21.865 412.14c1.224-.706 3.063-.901 4.663-.517h.051c1.606.382 2.679 1.27 2.679 2.272v1.518h7.61v-1.518c0-1.002 1.082-1.895 2.677-2.272h.052c1.6-.384 3.439-.189 4.663.517l1.863 1.083 5.38-3.105-1.86-1.083c-1.224-.706-1.562-1.77-.899-2.691l.022-.032c.663-.926 2.202-1.543 3.94-1.543h2.632v-4.394h-2.632c-1.738 0-3.277-.618-3.937-1.546l-.022-.03c-.666-.923-.328-1.984.896-2.691l1.86-1.083-5.38-3.108-1.86 1.083c-1.227.707-3.066.904-4.666.52h-.052c-1.606-.382-2.675-1.27-2.675-2.274v-1.519h-7.623v1.519c0 1.004-1.083 1.895-2.678 2.274h-.052c-1.598.384-3.439.189-4.663-.52l-1.86-1.083-5.37 3.116 1.86 1.083c1.227.707 1.565 1.768.899 2.691a.198.198 0 01-.022.03c-.663.929-2.201 1.546-3.937 1.546h-2.635v4.394h2.632c1.739 0 3.277.617 3.94 1.543l.022.032c.664.923.328 1.985-.899 2.691l-1.86 1.083 5.38 3.105 1.86-1.091zm7.095-7.201c-2.267-1.308-2.267-3.427 0-4.738 2.266-1.31 5.941-1.307 8.208 0 2.266 1.308 2.266 3.43 0 4.738-2.267 1.308-5.942 1.31-8.208 0z"
      ></path>
      <path
        fill="#1D5F3E"
        d="M8.172 402.321v-4.394h2.632c1.739 0 3.277-.617 3.938-1.546a1.95 1.95 0 00.19-.3l-.543-.658-2.372 1.37v-7.951H26.64V387.266h7.613v1.519a.417.417 0 000 .057h14.623v7.937l-2.535-1.462-.48.518c.057.185.143.359.255.517l.022.029c.66.929 2.202 1.546 3.937 1.546h2.633v4.391h-2.61a6.241 6.241 0 00-2.796.62l1.595.98v3.742l-3.634 2.098-1.75 1.01-1.86-1.083c-1.224-.707-3.065-.902-4.663-.517h-.054c-1.606.381-2.675 1.272-2.675 2.274v1.519h-7.62v-1.519c0-1.002-1.07-1.895-2.676-2.274h-.054c-1.598-.385-3.437-.19-4.663.517l-1.86 1.083-1.328-.766-4.062-2.34v-3.741l1.828-.847a6.03 6.03 0 00-3.027-.75l-2.627-.003z"
      ></path>
      <path
        fill="url(#paint65_linear_911_112407)"
        d="M19.248 405.949c1.226-.707 3.065-.902 4.663-.517l.054.013c1.606.382 2.675 1.27 2.675 2.272v1.521h7.613v-1.527c0-1.002 1.083-1.895 2.675-2.271l.054-.014c1.598-.384 3.44-.189 4.663.517l1.86 1.083 5.384-3.105-1.863-1.083c-1.224-.706-1.562-1.768-.896-2.691l.021-.032c.661-.926 2.202-1.544 3.938-1.544h2.632v-4.396h-2.624c-1.736 0-3.277-.617-3.937-1.546l-.022-.03c-.666-.923-.328-1.984.896-2.691l1.863-1.083-5.383-3.108-1.86 1.083c-1.225.71-3.066.905-4.664.52h-.051c-1.609-.382-2.678-1.27-2.678-2.274v-1.519h-7.62v1.522c0 1.001-1.07 1.895-2.676 2.271h-.052c-1.6.385-3.439.19-4.663-.52l-1.863-1.083-5.38 3.125 1.86 1.083c1.224.706 1.562 1.767.896 2.691a.103.103 0 01-.021.029c-.661.921-2.2 1.53-3.938 1.53H8.172v4.394h2.632c1.739 0 3.277.617 3.938 1.546a.103.103 0 01.021.029c.666.924.328 1.985-.896 2.691l-1.863 1.083 5.383 3.105 1.86-1.074zm7.095-7.202c-2.267-1.307-2.267-3.427 0-4.737 2.266-1.311 5.94-1.308 8.207 0 2.267 1.307 2.267 3.43 0 4.737-2.266 1.308-5.94 1.311-8.207 0z"
      ></path>
      <path
        fill="#CACACA"
        d="M93.318 441.779c1.224-.707 3.065-.902 4.663-.517h.054c1.606.382 2.676 1.269 2.676 2.271v1.538h7.606v-1.519c0-1.002 1.084-1.895 2.676-2.271h.054c1.598-.385 3.437-.19 4.663.517l1.861 1.083 5.383-3.106-1.863-1.082c-1.224-.707-1.562-1.771-.896-2.691l.021-.033c.661-.926 2.199-1.543 3.938-1.543h2.632v-4.394h-2.627c-1.736 0-3.276-.617-3.937-1.546a.315.315 0 01-.022-.029c-.666-.924-.327-1.985.897-2.692l1.863-1.082-5.384-3.108-1.86 1.083c-1.224.706-3.066.904-4.663.519h-.055c-1.605-.381-2.675-1.269-2.675-2.274v-1.551h-7.612v1.519c0 1.004-1.084 1.895-2.676 2.274h-.054c-1.598.384-3.436.189-4.663-.52l-1.86-1.083-5.384 3.105 1.863 1.083c1.224.707 1.563 1.768.897 2.691a.128.128 0 01-.022.03c-.661.929-2.202 1.546-3.938 1.546h-2.632v4.394h2.632c1.736 0 3.277.617 3.938 1.546a.267.267 0 01.022.029c.666.924.327 1.985-.897 2.691l-1.863 1.083 5.383 3.106 1.86-1.067zm7.095-7.201c-2.267-1.308-2.267-3.428 0-4.738 2.266-1.31 5.941-1.308 8.208 0 2.266 1.308 2.266 3.43 0 4.738-2.267 1.307-5.942 1.31-8.208 0z"
      ></path>
      <path
        fill="url(#paint66_linear_911_112407)"
        d="M80.488 431.021v-4.392h2.646c1.739 0 3.277-.62 3.937-1.545l.022-.03c.065-.091.12-.187.168-.287l-.542-.655-2.374 1.37v-7.938h14.623V415.968h7.612V417.544h14.623v7.938l-2.535-1.465-.479.52c.057.185.142.359.255.517.007.009.015.019.021.03.661.925 2.202 1.543 3.938 1.543h2.632v4.394H122.4a6.217 6.217 0 00-2.795.62l1.595.98v3.741l-3.634 2.098-1.749 1.01-1.861-1.083c-1.226-.707-3.065-.902-4.663-.52h-.054c-1.606.382-2.675 1.27-2.675 2.274v1.519h-7.607v-1.519c0-1.004-1.07-1.895-2.676-2.274h-.054c-1.598-.384-3.436-.189-4.663.517l-1.86 1.083-1.327-.766-4.062-2.342v-3.741l1.828-.848a6.024 6.024 0 00-3.009-.749h-2.646z"
      ></path>
      <path
        fill="url(#paint67_linear_911_112407)"
        d="M91.564 434.651c1.224-.707 3.065-.902 4.663-.517h.054c1.606.384 2.676 1.272 2.676 2.274v1.519h7.612v-1.519c0-1.002 1.07-1.895 2.676-2.274h.054c1.597-.385 3.436-.19 4.663.517l1.86 1.083 5.384-3.116-1.863-1.083c-1.224-.71-1.563-1.771-.897-2.708l.022-.029c.661-.926 2.202-1.543 3.937-1.543h2.633v-4.392H122.4c-1.736 0-3.277-.617-3.937-1.545l-.022-.03c-.666-.923-.328-1.985.896-2.691l1.863-1.083-5.383-3.108-1.861 1.083c-1.224.706-3.065.901-4.663.52h-.054c-1.606-.382-2.675-1.27-2.675-2.274v-1.519h-7.607v1.519c0 1.004-1.07 1.895-2.676 2.274h-.051c-1.6.381-3.44.186-4.666-.52l-1.86-1.083-5.384 3.108 1.863 1.083c1.224.706 1.563 1.768.896 2.691a.312.312 0 01-.021.03c-.66.928-2.199 1.545-3.938 1.545h-2.632v4.394h2.646c1.739 0 3.277.618 3.937 1.543l.022.03c.666.923.328 1.987-.896 2.707l-1.863 1.083 5.383 3.106 1.847-1.075zm7.095-7.202c-2.267-1.307-2.267-3.43 0-4.737 2.267-1.308 5.941-1.308 8.208 0 2.266 1.307 2.266 3.43 0 4.737-2.267 1.308-5.941 1.308-8.208 0z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_911_112407"
          x1="434.107"
          x2="450.375"
          y1="266.826"
          y2="295.012"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#BDEC80"></stop>
          <stop offset="0.5" stopColor="#97DB3B"></stop>
          <stop offset="0.99" stopColor="#7CA627"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_911_112407"
          x1="429.475"
          x2="445.543"
          y1="274.531"
          y2="302.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#BDEC80"></stop>
          <stop offset="0.5" stopColor="#97DB3B"></stop>
          <stop offset="0.99" stopColor="#7CA627"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_911_112407"
          x1="450.52"
          x2="471.472"
          y1="296.768"
          y2="296.768"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#BDEC80"></stop>
          <stop offset="0.5" stopColor="#97DB3B"></stop>
          <stop offset="0.99" stopColor="#7CA627"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_911_112407"
          x1="320.327"
          x2="336.246"
          y1="148.901"
          y2="176.484"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64C08A"></stop>
          <stop offset="0.5" stopColor="#00A550"></stop>
          <stop offset="1" stopColor="#00914C"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_911_112407"
          x1="315.792"
          x2="331.516"
          y1="156.441"
          y2="183.685"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00914C"></stop>
          <stop offset="0.5" stopColor="#00A550"></stop>
          <stop offset="1" stopColor="#64C08A"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_911_112407"
          x1="336.316"
          x2="356.818"
          y1="179.336"
          y2="179.336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64C08A"></stop>
          <stop offset="0.5" stopColor="#00A550"></stop>
          <stop offset="1" stopColor="#00914C"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_911_112407"
          x1="31.561"
          x2="14.637"
          y1="316.47"
          y2="345.927"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF7A9"></stop>
          <stop offset="0.5" stopColor="#FFF100"></stop>
          <stop offset="1" stopColor="gold"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_911_112407"
          x1="134.686"
          x2="115.375"
          y1="257.477"
          y2="254.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C67B"></stop>
          <stop offset="1" stopColor="#F8B02B"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_911_112407"
          x1="116.163"
          x2="95.37"
          y1="243.266"
          y2="268.278"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C67B"></stop>
          <stop offset="1" stopColor="#F8B02B"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_911_112407"
          x1="119.938"
          x2="99.385"
          y1="252.153"
          y2="276.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8B02B"></stop>
          <stop offset="1" stopColor="#F1C67B"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_911_112407"
          x1="107.226"
          x2="96.544"
          y1="242.759"
          y2="241.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00CC6B"></stop>
          <stop offset="0.5" stopColor="#00E06C"></stop>
          <stop offset="1" stopColor="#83FBB4"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_911_112407"
          x1="97.077"
          x2="86.109"
          y1="240.216"
          y2="239.143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00CC6B"></stop>
          <stop offset="0.5" stopColor="#00E06C"></stop>
          <stop offset="1" stopColor="#83FBB4"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_911_112407"
          x1="89.702"
          x2="97.7"
          y1="254.766"
          y2="272.305"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83FBB4"></stop>
          <stop offset="0.5" stopColor="#00E06C"></stop>
          <stop offset="1" stopColor="#00CC6B"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_911_112407"
          x1="78.064"
          x2="83.427"
          y1="259.917"
          y2="269.209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00914C"></stop>
          <stop offset="0.5" stopColor="#00A550"></stop>
          <stop offset="1" stopColor="#64C08A"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_911_112407"
          x1="81.901"
          x2="87.409"
          y1="269.644"
          y2="279.185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00914C"></stop>
          <stop offset="0.5" stopColor="#00A550"></stop>
          <stop offset="1" stopColor="#64C08A"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_911_112407"
          x1="98.006"
          x2="107.611"
          y1="267.144"
          y2="250.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64C08A"></stop>
          <stop offset="0.5" stopColor="#00A550"></stop>
          <stop offset="1" stopColor="#00914C"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_911_112407"
          x1="58.026"
          x2="52.454"
          y1="228.14"
          y2="250.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C67B"></stop>
          <stop offset="1" stopColor="#F8B02B"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_911_112407"
          x1="40.221"
          x2="66.201"
          y1="249.346"
          y2="274.353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C67B"></stop>
          <stop offset="1" stopColor="#F8B02B"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_911_112407"
          x1="49.744"
          x2="75.403"
          y1="246.418"
          y2="271.113"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8B02B"></stop>
          <stop offset="1" stopColor="#F1C67B"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_911_112407"
          x1="50.836"
          x2="27.272"
          y1="295.806"
          y2="261.897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0162AF"></stop>
          <stop offset="1" stopColor="#1F4075"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_911_112407"
          x1="68.002"
          x2="32.089"
          y1="265.493"
          y2="268.511"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#007C84"></stop>
          <stop offset="0.5" stopColor="#0099B9"></stop>
          <stop offset="0.99" stopColor="#3EB0CA"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_911_112407"
          x1="63.922"
          x2="28.452"
          y1="274.572"
          y2="277.555"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#3EB0CA"></stop>
          <stop offset="0.5" stopColor="#0099B9"></stop>
          <stop offset="0.99" stopColor="#007C84"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_911_112407"
          x1="22.301"
          x2="9.066"
          y1="276.173"
          y2="257.127"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1F4075"></stop>
          <stop offset="1" stopColor="#0162AF"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_911_112407"
          x1="29.389"
          x2="16.155"
          y1="270.295"
          y2="251.251"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#3EB0CA"></stop>
          <stop offset="0.5" stopColor="#0099B9"></stop>
          <stop offset="0.99" stopColor="#007C84"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_911_112407"
          x1="463.898"
          x2="658"
          y1="222.974"
          y2="222.974"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FA4C2"></stop>
          <stop offset="1" stopColor="#586577"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_911_112407"
          x1="617.236"
          x2="516.916"
          y1="153.658"
          y2="212.232"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="0.25" stopColor="#787F8A"></stop>
          <stop offset="0.45" stopColor="#828891"></stop>
          <stop offset="0.64" stopColor="#93989F"></stop>
          <stop offset="0.81" stopColor="#AAADB2"></stop>
          <stop offset="0.97" stopColor="#C9C9CA"></stop>
          <stop offset="1" stopColor="#CFCFCF"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_911_112407"
          x1="534.374"
          x2="534.374"
          y1="112.096"
          y2="197.558"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_911_112407"
          x1="521.051"
          x2="577.087"
          y1="159.673"
          y2="159.673"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint28_linear_911_112407"
          x1="680.613"
          x2="567.589"
          y1="93.405"
          y2="45.064"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint29_linear_911_112407"
          x1="554.563"
          x2="628.952"
          y1="52.883"
          y2="52.883"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint30_linear_911_112407"
          x1="521.047"
          x2="650.777"
          y1="146.722"
          y2="146.722"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint31_linear_911_112407"
          x1="598.177"
          x2="598.177"
          y1="92.488"
          y2="205.101"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint32_linear_911_112407"
          x1="582.399"
          x2="582.399"
          y1="140.893"
          y2="217.208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint33_linear_911_112407"
          x1="569.078"
          x2="625.112"
          y1="188.63"
          y2="188.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CFCFCF"></stop>
        </linearGradient>
        <linearGradient
          id="paint34_linear_911_112407"
          x1="560.414"
          x2="616.491"
          y1="40.162"
          y2="40.162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CFCFCF"></stop>
        </linearGradient>
        <linearGradient
          id="paint35_linear_911_112407"
          x1="678.44"
          x2="565.415"
          y1="98.495"
          y2="50.153"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint36_linear_911_112407"
          x1="627.658"
          x2="627.658"
          y1="29.495"
          y2="126.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint37_linear_911_112407"
          x1="528.432"
          x2="544.751"
          y1="55.94"
          y2="77.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint38_linear_911_112407"
          x1="466.293"
          x2="509.843"
          y1="105.596"
          y2="105.596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint39_linear_911_112407"
          x1="463.046"
          x2="497.362"
          y1="111.336"
          y2="111.336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CFCFCF"></stop>
          <stop offset="1" stopColor="#757C87"></stop>
        </linearGradient>
        <linearGradient
          id="paint40_linear_911_112407"
          x1="444.649"
          x2="475.558"
          y1="119.982"
          y2="119.982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="0.25" stopColor="#787F8A"></stop>
          <stop offset="0.45" stopColor="#828891"></stop>
          <stop offset="0.64" stopColor="#93989F"></stop>
          <stop offset="0.81" stopColor="#AAADB2"></stop>
          <stop offset="0.97" stopColor="#C9C9CA"></stop>
          <stop offset="1" stopColor="#CFCFCF"></stop>
        </linearGradient>
        <linearGradient
          id="paint41_linear_911_112407"
          x1="478.606"
          x2="459.449"
          y1="132.52"
          y2="132.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F25623"></stop>
          <stop offset="1" stopColor="#F68121"></stop>
        </linearGradient>
        <linearGradient
          id="paint42_linear_911_112407"
          x1="488.676"
          x2="444.647"
          y1="115.932"
          y2="115.932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6AE55"></stop>
          <stop offset="1" stopColor="#FFEABC"></stop>
        </linearGradient>
        <linearGradient
          id="paint43_linear_911_112407"
          x1="443.924"
          x2="494.369"
          y1="89.23"
          y2="98.457"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05121F"></stop>
          <stop offset="1" stopColor="#1C456B"></stop>
        </linearGradient>
        <linearGradient
          id="paint44_linear_911_112407"
          x1="459.211"
          x2="403.578"
          y1="71.046"
          y2="71.046"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3B3B3"></stop>
          <stop offset="1" stopColor="#F4F4F4"></stop>
        </linearGradient>
        <linearGradient
          id="paint45_linear_911_112407"
          x1="459.449"
          x2="478.549"
          y1="132.468"
          y2="132.468"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="0.25" stopColor="#787F8A"></stop>
          <stop offset="0.45" stopColor="#828891"></stop>
          <stop offset="0.64" stopColor="#93989F"></stop>
          <stop offset="0.81" stopColor="#AAADB2"></stop>
          <stop offset="0.97" stopColor="#C9C9CA"></stop>
          <stop offset="1" stopColor="#CFCFCF"></stop>
        </linearGradient>
        <linearGradient
          id="paint46_linear_911_112407"
          x1="459.449"
          x2="488.631"
          y1="116.016"
          y2="116.016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint47_linear_911_112407"
          x1="276.479"
          x2="270.884"
          y1="174.22"
          y2="216.966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F25623"></stop>
          <stop offset="1" stopColor="#F68121"></stop>
        </linearGradient>
        <linearGradient
          id="paint48_linear_911_112407"
          x1="303.227"
          x2="268.474"
          y1="192.78"
          y2="207.208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6026"></stop>
          <stop offset="1" stopColor="#EEC221"></stop>
        </linearGradient>
        <linearGradient
          id="paint49_linear_911_112407"
          x1="295.089"
          x2="260.765"
          y1="186.32"
          y2="200.566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEC221"></stop>
          <stop offset="1" stopColor="#FF6026"></stop>
        </linearGradient>
        <linearGradient
          id="paint50_linear_911_112407"
          x1="260.752"
          x2="257.61"
          y1="206.367"
          y2="230.373"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F25623"></stop>
          <stop offset="1" stopColor="#F68121"></stop>
        </linearGradient>
        <linearGradient
          id="paint51_linear_911_112407"
          x1="266.435"
          x2="263.293"
          y1="207.095"
          y2="231.104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEC221"></stop>
          <stop offset="1" stopColor="#FF6026"></stop>
        </linearGradient>
        <linearGradient
          id="paint52_linear_911_112407"
          x1="129.453"
          x2="348.208"
          y1="414.573"
          y2="414.573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#586577"></stop>
          <stop offset="1" stopColor="#8FA4C2"></stop>
        </linearGradient>
        <linearGradient
          id="paint53_linear_911_112407"
          x1="192.524"
          x2="297.639"
          y1="403.493"
          y2="335.314"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CFCFCF"></stop>
        </linearGradient>
        <linearGradient
          id="paint54_linear_911_112407"
          x1="214.029"
          x2="214.029"
          y1="375.768"
          y2="284.999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint55_linear_911_112407"
          x1="223.876"
          x2="223.876"
          y1="383.327"
          y2="296.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint56_linear_911_112407"
          x1="221.581"
          x2="256.397"
          y1="381.807"
          y2="369.737"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CFCFCF"></stop>
        </linearGradient>
        <linearGradient
          id="paint57_linear_911_112407"
          x1="165.452"
          x2="232.37"
          y1="213.75"
          y2="213.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint58_linear_911_112407"
          x1="178.258"
          x2="238.632"
          y1="217.982"
          y2="217.982"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint59_linear_911_112407"
          x1="218.506"
          x2="218.506"
          y1="313.136"
          y2="230.576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint60_linear_911_112407"
          x1="203.215"
          x2="260.996"
          y1="279.975"
          y2="279.975"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint61_linear_911_112407"
          x1="259.141"
          x2="248.233"
          y1="398.008"
          y2="308.384"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint62_linear_911_112407"
          x1="267.847"
          x2="256.94"
          y1="396.947"
          y2="307.322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint63_linear_911_112407"
          x1="242.677"
          x2="242.677"
          y1="133.77"
          y2="168.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#888E97"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint64_linear_911_112407"
          x1="240.574"
          x2="262.601"
          y1="156.173"
          y2="156.173"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.11" stopColor="#757C87"></stop>
          <stop offset="1" stopColor="#CCCCCD"></stop>
        </linearGradient>
        <linearGradient
          id="paint65_linear_911_112407"
          x1="37.633"
          x2="21.888"
          y1="385.657"
          y2="413.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64C08A"></stop>
          <stop offset="0.5" stopColor="#00A550"></stop>
          <stop offset="1" stopColor="#00914C"></stop>
        </linearGradient>
        <linearGradient
          id="paint66_linear_911_112407"
          x1="125.04"
          x2="80.488"
          y1="428.825"
          y2="428.825"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1F4075"></stop>
          <stop offset="1" stopColor="#0162AF"></stop>
        </linearGradient>
        <linearGradient
          id="paint67_linear_911_112407"
          x1="110.256"
          x2="94.51"
          y1="414.311"
          y2="441.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#3EB0CA"></stop>
          <stop offset="0.5" stopColor="#0099B9"></stop>
          <stop offset="0.99" stopColor="#007C84"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const ImageGroup = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="423" height="279" fill="none" viewBox="0 0 423 279">
      <path
        fill="url(#paint0_linear_1380_98514)"
        d="M368.958 95h-41.137a4.61 4.61 0 00-4.61 4.61v20.541a4.61 4.61 0 004.61 4.61h41.137a4.61 4.61 0 004.61-4.61V99.61a4.61 4.61 0 00-4.61-4.61z"
      ></path>
      <path fill="url(#paint1_linear_1380_98514)" d="M348.387 136.397l6.519-15.452h-13.037l6.518 15.452z"></path>
      <path
        fill="#fff"
        d="M348.23 104.772h11.783v1.724l5.772-3.328-5.772-3.328v1.724H348.23v3.208zM365.785 111.54h-11.774v-1.715l-5.781 3.328 5.781 3.329v-1.724h11.774v-3.218zM341.002 114.573l-.553.202a17.558 17.558 0 01-2.655-4.167 14.77 14.77 0 01-.922-4.822l.405-.175-2.489-5.956a4.863 4.863 0 00-1.208 1.365c-1.41 2.388-1.272 6.039.148 9.607 1.42 3.568 2.932 6.758 5.697 8.758a5.469 5.469 0 004.122 1.217l-2.545-6.029zM342.79 113.872l-.774.277 2.553 6.103c.265-.087.521-.198.766-.332a1.484 1.484 0 00.673-1.844l-1.328-3.346a1.48 1.48 0 00-1.89-.858zM336.712 98.576a6.447 6.447 0 00-.995.47l2.544 6.086.858-.351a1.501 1.501 0 00.811-1.908l-1.337-3.375a1.495 1.495 0 00-1.881-.922z"
      ></path>
      <path
        fill="url(#paint2_linear_1380_98514)"
        d="M9.737 55h81.854a9.518 9.518 0 019.518 9.518v38.804a9.516 9.516 0 01-9.518 9.518H84.27c-.205 3.514.3 8.786 3.243 15.448a41.091 41.091 0 01-17.747-15.448H9.73a9.518 9.518 0 01-9.518-9.518V64.518A9.518 9.518 0 019.737 55z"
      ></path>
      <path
        fill="#fff"
        d="M44.651 73.508H85.25a2.029 2.029 0 002.02-2.02 2.028 2.028 0 00-2.02-2.021H44.65a2.028 2.028 0 00-2.02 2.02 2.028 2.028 0 002.02 2.021z"
      ></path>
      <path
        fill="#D2E6FF"
        d="M15.54 85.275h70.492a1.237 1.237 0 000-2.475H15.541a1.238 1.238 0 000 2.475zM15.54 92.15h70.492a1.237 1.237 0 100-2.474H15.541a1.237 1.237 0 100 2.474zM30.916 99.47h55.116a1.237 1.237 0 000-2.475H30.916a1.237 1.237 0 000 2.475z"
      ></path>
      <path
        fill="#fff"
        d="M16.1 73.508h19.366a2.028 2.028 0 002.02-2.02 2.028 2.028 0 00-2.02-2.021H16.1a2.028 2.028 0 00-2.02 2.02 2.028 2.028 0 002.02 2.021z"
      ></path>
      <path
        fill="url(#paint3_linear_1380_98514)"
        d="M401.944 69h-54.045a3.688 3.688 0 00-3.688 3.688v8.454a3.688 3.688 0 003.688 3.688h54.045a3.688 3.688 0 003.688-3.688v-8.454A3.688 3.688 0 00401.944 69z"
      ></path>
      <path
        fill="#fff"
        d="M351.795 81.069a.71.71 0 01-.581-.258.875.875 0 01-.202-.646l.239-2.055v-.102c0-.018-.073 0-.129 0l-1.687 1.217a.788.788 0 01-.967.03.797.797 0 01-.231-.26.772.772 0 01-.083-.728.836.836 0 01.479-.443l1.89-.858c.055 0 .083 0 .083-.073 0-.074 0-.065-.083-.083l-1.89-.849a.778.778 0 01-.47-.498.87.87 0 01.074-.672.824.824 0 01.553-.406.92.92 0 01.645.147l1.687 1.245h.129c.037 0 0-.055 0-.11l-.239-2.047a.81.81 0 01.212-.646.773.773 0 01.627-.258.772.772 0 01.764.58.788.788 0 01.01.342l-.23 2.047v.11a.135.135 0 00.138 0l1.678-1.216a.852.852 0 01.664-.176.766.766 0 01.534.406.792.792 0 01.093.728.922.922 0 01-.48.443l-1.899.848c-.046 0-.074 0-.074.083s0 .055.074.074l1.899.857a.826.826 0 01.48.498.786.786 0 01-.093.673.726.726 0 01-.534.396.867.867 0 01-.664-.138l-1.678-1.244a.138.138 0 00-.138 0 .079.079 0 00-.018.05.08.08 0 00.018.051l.23 2.056a.737.737 0 01-.486.833.83.83 0 01-.344.052zM362.974 81.069a.723.723 0 01-.581-.258.873.873 0 01-.194-.646l.231-2.056v-.101c0-.019-.074 0-.129 0l-1.687 1.217a.784.784 0 01-.646.166.923.923 0 01-.636-1.125.923.923 0 01.48-.443l1.899-.857c.046 0 .074 0 .074-.074s0-.064-.074-.083l-1.899-.848a.823.823 0 01-.471-.498.927.927 0 01.083-.673.845.845 0 01.544-.406.868.868 0 01.646.148l1.687 1.245h.129c.028 0 0-.056 0-.111l-.231-2.047a.868.868 0 01.203-.645.811.811 0 01.627-.258.768.768 0 01.763.56c.031.112.035.23.012.343l-.231 2.047v.11h.129l1.687-1.216a.837.837 0 01.664-.176.754.754 0 01.526.406.766.766 0 01.092.728.925.925 0 01-.479.443l-1.89.848c-.056 0-.083.028-.083.083 0 0 0 .056.083.074l1.89.857a.801.801 0 01.514.846.752.752 0 01-.127.325.728.728 0 01-.526.397.847.847 0 01-.664-.139l-1.696-1.217h-.129c-.037 0 0 .056 0 .102l.23 2.056a.737.737 0 01-.193.645.828.828 0 01-.627.23zM374.157 81.069a.742.742 0 01-.59-.259.856.856 0 01-.194-.645l.24-2.056v-.101a.12.12 0 00-.129 0l-1.687 1.217a.788.788 0 01-.967.03.79.79 0 01-.232-.26.767.767 0 01-.083-.73.84.84 0 01.48-.442l1.89-.857c.055 0 .083 0 .083-.074s0-.064-.083-.083l-1.89-.848a.79.79 0 01-.47-.498.852.852 0 01.626-1.079.924.924 0 01.646.148l1.687 1.245a.12.12 0 00.129 0v-.111l-.24-2.047a.832.832 0 01.492-.844.784.784 0 01.338-.06.774.774 0 01.784.923l-.231 2.046v.111c.02.012.042.019.065.019a.117.117 0 00.064-.019l1.688-1.217a.852.852 0 01.663-.175.772.772 0 01.535.405.792.792 0 01.092.729.92.92 0 01-.479.442l-1.899.849c-.046 0-.074 0-.074.083 0 .082 0 .055.074.073l1.899.858a.826.826 0 01.479.498.771.771 0 01-.092.673.725.725 0 01-.535.396.867.867 0 01-.663-.138l-1.688-1.245a.117.117 0 00-.064-.019.123.123 0 00-.065.02.084.084 0 000 .1l.231 2.056a.737.737 0 01-.486.834.832.832 0 01-.344.052zM385.332 81.07a.724.724 0 01-.581-.259.856.856 0 01-.194-.645l.231-2.056v-.101c0-.019-.074 0-.129 0l-1.687 1.217a.784.784 0 01-.646.165.922.922 0 01-.636-1.124.922.922 0 01.443-.378l1.899-.858c.046 0 .074 0 .074-.073 0-.074 0-.065-.074-.083l-1.899-.849a.823.823 0 01-.471-.498.927.927 0 01.083-.672.842.842 0 01.544-.406.867.867 0 01.646.147l1.687 1.245h.129c.028 0 0-.055 0-.11l-.231-2.047a.82.82 0 01.203-.646.812.812 0 01.627-.258.768.768 0 01.763.56c.031.112.035.23.012.344l-.231 2.046v.111h.129l1.687-1.217a.839.839 0 01.664-.175.753.753 0 01.526.406.79.79 0 01.092.728.925.925 0 01-.479.442l-1.89.849c-.056 0-.083.027-.083.083 0 0 0 .055.083.073l1.963.858a.801.801 0 01.515.845.752.752 0 01-.127.326.726.726 0 01-.526.396.847.847 0 01-.664-.138l-1.687-1.245h-.129c-.037 0 0 .056 0 .102l.23 2.056a.737.737 0 01-.193.645.83.83 0 01-.673.194z"
      ></path>
      <path
        fill="url(#paint4_linear_1380_98514)"
        d="M396.517 81.07a.727.727 0 01-.59-.259.845.845 0 01-.194-.645l.24-2.056v-.101a.123.123 0 00-.065-.02.117.117 0 00-.064.02l-1.724 1.244a.852.852 0 01-.964-.015.852.852 0 01-.327-.907.925.925 0 01.488-.442l1.89-.858c.056 0 .074 0 .074-.074 0-.073 0-.064-.074-.082l-1.89-.849a.794.794 0 01-.505-.842.834.834 0 01.109-.328.83.83 0 01.544-.406.923.923 0 01.655.147l1.687 1.245a.12.12 0 00.129 0v-.11l-.24-2.047a.827.827 0 01.212-.646.787.787 0 01.618-.258.778.778 0 01.613.273.77.77 0 01.171.65l-.24 2.046v.11a.12.12 0 00.129 0l1.687-1.217a.858.858 0 01.664-.175.766.766 0 01.535.406.791.791 0 01.092.728.923.923 0 01-.489.443l-1.89.848c-.055 0-.074 0-.074.083s0 .055.074.074l1.89.857a.812.812 0 01.489.498.771.771 0 01-.092.673.737.737 0 01-.535.397.869.869 0 01-.664-.139l-1.687-1.245a.12.12 0 00-.129 0v.102l.24 2.056a.745.745 0 01-.194.645.829.829 0 01-.599.175z"
      ></path>
      <g filter="url(#filter0_dd_1380_98514)">
        <rect
          width="171.641"
          height="110.341"
          x="23.211"
          y="151.505"
          fill="#fff"
          rx="4"
          shapeRendering="crispEdges"
        ></rect>
        <g clipPath="url(#clip0_1380_98514)">
          <path
            style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}
            fill="url(#paint5_radial_1380_98514)"
            d="M111.327 210.674c9.058 0 16.401-3.964 16.401-8.853 0-4.89-7.343-8.854-16.401-8.854s-16.401 3.964-16.401 8.854c0 4.889 7.343 8.853 16.401 8.853z"
          ></path>
          <path
            fill="url(#paint6_radial_1380_98514)"
            d="M126.883 194.505c2.37-9.843-3.688-19.743-13.53-22.114-9.843-2.37-19.744 3.688-22.114 13.53-2.37 9.843 3.687 19.744 13.53 22.114 9.843 2.37 19.743-3.687 22.114-13.53z"
          ></path>
          <path
            style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
            fill="url(#paint7_radial_1380_98514)"
            d="M120.131 176.254a18.822 18.822 0 01-22.862 27.033 17.701 17.701 0 1022.862-27.033z"
            opacity="0.7"
          ></path>
          <path
            fill="url(#paint8_radial_1380_98514)"
            d="M94.344 188.723c.276.071.559.106.843.105.329-.029.476.076 1.003.485a.7.7 0 00.978-.097s-.776-.421-1.345-.682c-.569-.262-1.479.189-1.479.189zm7.746-7.775c-.224-.101-.502.266-.632.464-.131.198-.186.421-.279.489-.092.067.582.151.793.151.21 0 .278-.08.451.068.172.147.421.05.421-.042 0-.093-.185-.317-.198-.46-.013-.143-.329-.135-.514-.21-.186-.076.13-.38-.042-.46zm-5.264 7.425c-.025-.092-.421.144-.476-.092a3.552 3.552 0 00-.223-.552h-.266a1.136 1.136 0 00.632.914c.422.152.359-.198.333-.27zm1.265 1.387c.476 0 1.264-.106 1.61.063.264.143.511.315.737.514 0 0-.106-.527-1.147-.725l-1.82-.341s.169.185.063.278a1.727 1.727 0 01-.396.198l.754.181s.068-.189.215-.189l-.016.021zm8.828 5.904a1.8 1.8 0 00-1.108-.519 2.617 2.617 0 01-1.227-.552 2.024 2.024 0 01-.737-.687c-.16-.341-1.003-.91-1.188-1.066-.186-.156-.725 0-1.387-.421-.661-.422-.143-.544-.91-.674a10.612 10.612 0 00-1.437-.055c-.421-.038-.687-.422-1.028-.422-.342 0-1.109.687-1.265.818-.156.131-.21.067-.514-.118-.303-.185-.514.211-1.045-.038-.53-.249.215-1.386.228-1.572.012-.185-.24-.13-.687-.08-.447.051-1.134.093-1.134.093s.038-.384.093-.7c.055-.316.46-.632.261-.897-.198-.266-.75-.038-1.053.135-.304.172-.266.935-1.083.75-.818-.186-.594-1.53-.556-1.783a.901.901 0 01.294-.712c.32-.291 1.083-.173 1.454-.185.371-.013.7-.291 1.003-.367.304-.076.565.223.91.645a.757.757 0 01.093.842s.582.043.818-.236c.236-.278-.186-1.331-.08-1.635.105-.303 1.319-.804 1.424-.977.105-.173-.063-.502.228-1.071.29-.569 1.04-.379 1.108-.379.067 0 0-.185-.122-.371-.123-.185.08-.341.29-.446.211-.106 1.003-.384 1.003-.384a.506.506 0 00-.21.384c0 .223.29-.03.661-.198.371-.169 1.003-.384 1.003-.384l-.16-.223c-.221.05-.449.063-.674.038-.303-.055-.316-.211-.396-.515-.08-.303-1.332.144-1.332.144.217-.18.452-.338.7-.472.303-.148 1.529-.042 1.757-.055.227-.013.472-.354.843-.371.371-.017.421-.274.354-.459-.068-.186-.607-.358-1.294-.805a3.674 3.674 0 01-1.066-1.15 1.878 1.878 0 01-.422.476c-.227.147-.53.054-.804-.291a2.03 2.03 0 00-1.189-.62c-.345-.037-1.163 0-1.163 0s.03.173.055.447-.316.502-.316.502.632.24.7.569c.067.328-.843.501-.843.501s.21.687.08.7c-.131.012-.62-.553-.713-.831-.067-.206-.569-.202-1.104-.274a18.254 18.254 0 00-3.303 10.468 4.01 4.01 0 001.095.202c.451-.037.266.236 1.121.569a2.42 2.42 0 011.387 1.054c.223.371 1.028.712 1.386.476.358-.236.447 0 .632.552.186.552-.261.885-.632 1.264-.37.38-.358 1.201-.358 1.572s.253.354.45.843c.199.489.645 1.559 1.265 1.968.62.409 1.159.725 1.2 1.306.043.582-.42 2.402-.383 2.782.035.473-.091.943-.358 1.336a3.487 3.487 0 00-.152.236c.732.603 1.51 1.148 2.327 1.63l.177-.126c.21-.148-.278-.223-.278-.371 0-.147.118-.093.526 0 .409.093.477-.278.632-.501.156-.224.793-.291 1.058-.477a11.52 11.52 0 011.028-.897c.397-.224.422-.645.873-1.172.451-.526.156-.594.421-1.108.266-.514 1.264-.712 1.686-.843.421-.13.472-.649.564-.927.093-.278.422-.249.291-.341-.13-.093-.143-.514-.143-.948 0-.434.485-.725.906-1.172a.798.798 0 00.067-1.07c-.172-.329-.265-.106-.598-.354zm-11.268-17.35c.046.055.248-.059.252-.164.005-.105-.139-.08-.21-.042-.072.038-.118.097-.085.143.034.047-.016.009.043.063zm.118 1.345c-.064 0-.076.097-.064.143.013.046.123-.042.228-.042a2.12 2.12 0 01.421 0c.034.034.16-.101.026-.118-.135-.017-.312.105-.354.042-.042-.063-.093-.122-.148-.093-.055.03-.025.059-.13.068h.02zm.564-2.074a3.625 3.625 0 011.61.316c.487.185.998.296 1.517.329a7.256 7.256 0 00-.843-.501 7.82 7.82 0 001.083.215c.266 0 .224-.241.042-.346-.18-.105-.842-.396-.623-.514.219-.118.556.248.843.329.286.08.632-.329.644-.422.013-.093-.632-.265-1.12-.447a1.475 1.475 0 01-.422-.227c-.076-.059.089-.139.021-.207-.067-.067-.392-.134-.51-.214a2.873 2.873 0 00-.64-.236c-.52.395-1.02.817-1.496 1.264a.193.193 0 01.038.118c-.034.173-.616.594-.165.543h.021zm22.916 6.123a1.425 1.425 0 01-.172.038c-.144.026-.118-.063-.144.026-.025.088.076.172.076.29s-.076.241 0 .241.236 0 .287-.08a.564.564 0 00.055-.291.598.598 0 000-.198.328.328 0 00-.093-.186c0-.08.198-.198.038-.21-.16-.013-.224.042-.224.08a.716.716 0 00.093.172h.08s.169.076.004.118zm4.552 1.492c-.026-.067-.342-.122-.397-.105-.054.017-.383.13-.383.13.156-.01.312.003.464.038.139.055.337 0 .311-.063h.005zm1.968.093s.143-.122.105-.122c-.038 0-.228.029-.304.029a.375.375 0 00-.185.093l-.08.076a.614.614 0 00.316.055c.051 0 .143-.131.143-.131h.005zM114.15 180.7c-.063.067-.185 0-.105.172.08.173.569 0 .767-.029.198-.03.421-.131.421-.236a.752.752 0 01.038-.316c.042-.042 0-.24-.118-.278a1.225 1.225 0 00-.619 0c-.08.067-.118.185-.236.172-.118-.012-.422.051-.316.224.105.173.236.223.168.291zm-3.291-4.636a3.158 3.158 0 00-.746-.034c-.278.038-.569.118-.632.059-.063-.059.198-.084.257-.113.059-.03.363-.118.215-.123-.147-.004-.527 0-.421-.029.105-.03.522-.08.392-.08-.131 0-.746-.076-.451-.084.29-.003.578.057.843.177a.762.762 0 00.421.151c.181 0 .261.042.27-.063.008-.105.08-.152-.055-.198-.135-.046-.308-.093-.422-.126a1.676 1.676 0 01-.421-.165c0-.025-.691-.021-.396-.105.295-.084.548-.089.653 0a.551.551 0 00.472.143c.152-.05.152-.097 0-.152-.152-.054-.438-.012-.552-.139-.114-.126 0-.13 0-.13l.695.092a1.26 1.26 0 00.274-.042s-.076-.071 0-.143-.059-.131-.13-.223c-.072-.093.202 0 .286.029.084.03.325.127.266-.038a1.192 1.192 0 00-.198-.316c-.051-.084-.085-.152 0-.152.084 0 .459.35.459.27v-.257c0-.038-.046-.038-.207-.114-.16-.076.068-.059.068-.177s-.135-.248-.042-.358c.092-.109.198-.084.316-.126.147-.083.304-.147.468-.19.193 0 .231-.059.627-.131.397-.071.911-.046.523-.101-.371-.04-.744-.06-1.117-.059a5.454 5.454 0 00-.767 0c-.135.042-.092.139-.32.055-.228-.084 0-.139-.316-.139s-.898.278-.893.16c.004-.118.628-.181.805-.219.176-.038.573-.114.375-.114-.199 0-.506-.05-.772-.05-.265 0-.75.046-.758 0-.009-.047.135-.139-.08-.139-.215 0-.527-.139-.771 0-.245.139-.843-.047-1.1-.047-.257 0-1.804.106-2.183.106-.379 0-.805 0-1.062.029-.257.03-.843.089-.523.118.321.03.843.038.721.105-.122.068-.565.081-.544.106.021.025.561.05.392.092-.168.043-.522.097-.695-.046-.173-.143-.244-.265-.384-.265h-.164l-.35.118c.085.063.194.13.101.13a.704.704 0 01-.303-.063 18.583 18.583 0 00-3.287 1.513h.843c.215.003.429.034.636.093.164.047.31.14.422.269.054.106.488.477.51.607.021.131-.059.245.231.245.291 0 .531-.085.637-.08.105.004.337.067.345.16.009.092.143.257 0 .21a2.317 2.317 0 00-.708-.084c-.109.03-.189.084-.202.164-.013.08 0 .232.227.198.228-.033.228-.151.464-.151.236 0 .312 0 .341.071.03.072.274.085 0 .173a1.405 1.405 0 01-.526.076c-.139 0-.257.08-.257.122v.304c0 .122-.093.236 0 .307.092.072.227.114.303.245.076.13.076.071.093.177.017.105-.047.113.088.172.135.059.173-.096.253.14.08.236.384.295.421.362.038.067-.025.164.232.185.234-.018.468.015.687.097.156.114.388.278.548.232.16-.046.139-.173.249-.362.109-.19.059-.384.257-.468.198-.084.311.05.349-.219.038-.27-.257-.245.114-.342.371-.096.025-.046.422-.13.396-.084.708-.063.758-.148a2.3 2.3 0 01.843-.467c.324-.072.455-.022.729-.081a8.47 8.47 0 01.973-.198c.225-.046.447-.104.666-.172a.35.35 0 00.215-.131v.021zm2.314 1.29c0-.194-.051-.422-.59-.329-.34.098-.692.147-1.045.147-.304-.042-.793-.278-1.109 0-.231.203.557.607 1.109.658.552.05 1.622-.299 1.635-.498v.022zm13.999 13.013c-.11-.249-.548-.843-.548-1.18 0-.337-.527-.898-.632-1.197-.105-.299-.354-.683-.072-.771.283-.089.969.982 1.125 1.319l.295.569a18.245 18.245 0 00-1.222-5.614.807.807 0 00-.139 0 3.865 3.865 0 00-.948.22c-.337.105-.674.08-.767-.072a.768.768 0 01-.143-.358c.042-.173.211-.245.244-.337.15-.195.354-.341.586-.422.232-.067.662.097.687.224.025.126.088.08.181.054a18.278 18.278 0 00-2.406-3.969 2.524 2.524 0 00-.843.231.987.987 0 00-.152.321c-.046.109-.189.223-.202.328-.013.106.063.059.097.144.034.084-.337.286-.421.358-.085.072-.215-.131-.422-.152-.206-.021-.375 0-.421.072-.047.072-.198.084-.363.034-.164-.051.034-.085.093-.127.059-.042-.067-.059-.244.042s-.329 0-.295-.076c.063-.143.269 0 .421-.139.152-.139.341-.038.548-.143.206-.105.05-.291.059-.421.008-.131.375-.207.468-.304.243-.117.51-.176.779-.173.127 0 .489-.037.843-.08a14.187 14.187 0 00-.843-.969c-.109 0-.202 0-.253.055-.05.055-.109.177 0 .244.11.068.182.177.106.279a.56.56 0 01-.464.214 1.444 1.444 0 01-.341-.025h-.03a.226.226 0 01-.121-.13.217.217 0 01.016-.177.68.68 0 01.325-.304 1.52 1.52 0 01.421-.105c.097-.021.223-.042.244-.118.021-.076 0 0 0-.026a18.758 18.758 0 00-1.441-1.378l-.122.022c-.223.054-.316.172-.223.198.092.025-.068.185-.135.24-.068.055-.329.143-.422.185-.092.042-.168.262-.223.354-.055.093-.223.224-.362.392h-.034c-.422.16-1.37.211-1.336.843a.633.633 0 00.27.513.642.642 0 00.573.085 6.39 6.39 0 00.742-.21l.387.758s-.716-.51-1.171-.164c-.455.345 0 .809 0 .809a4.18 4.18 0 01-1.265.126c-.265-.109.211-.514.211-.514s-.653-.033-.687.089c-.033.122.316.21.316.21a.584.584 0 01-.265.072c-.139 0-.738-.156-.771-.282-.034-.127-.371-.27-.371-.27s.202-.249.236-.308c.034-.059.088-.097.038-.126-.051-.03-.51 0-.51-.051 0-.05.219-.16.185-.21a1.01 1.01 0 00-.581.042c-.038.063-.144.248-.203.274-.059.025-.151-.097-.24-.026-.088.072.135.182.144.236.008.055 0 .228.033.253.034.026.379-.05.371.047-.008.097-.105.194 0 .29.105.097.367.131.333.194-.034.063-.308.122-.325.245a.646.646 0 01-.143.265l.312.114s-.522.253-.421.308c.268.013.537-.005.8-.055.144 0 .915 0 1.029-.131.113-.13.248-.64.421-.518s-.371.712-.75.792a6.63 6.63 0 01-.687.08c-.042 0 .16.139-.034.164a1.783 1.783 0 00-.615.169c-.072.067.818.24.902.662.084.421.105.661-.219.644l-1.383-.063c-.164 0-.366 0-.383.122-.017.123.131.38.084.574-.046.193-.181.476-.173.564.009.089.156.068.14.236-.017.169-.034.283-.034.283l.27-.026c.16 0 .345 0 .421.122.076.123.181.123.316.051.135-.072.577-.025.746-.131.133-.082.274-.15.421-.202a.754.754 0 00.249-.299c0-.072-.16-.194.042-.388s.784-.371.775-.476c-.008-.105-.151-.27.131-.375.282-.105.687.139.738.097.05-.042.32-.152.387-.211.068-.059.266-.291.51 0 .245.291.468.637.776.704.307.067.45.072.535.194.084.122.177.105.232.177.054.071.13.194.096.248-.033.055-.029.123-.143.165a6.389 6.389 0 01-.649.025c-.143.03-.211.046-.177.097.152.082.308.157.468.223a.627.627 0 00.236.089l.042-.118s-.076-.114-.034-.156c.043-.042.139-.114.203-.089.063.026.16-.096.16-.122 0-.025.088-.105.13-.114.043-.008.114-.088.043-.134-.072-.047-.144-.064-.131-.148.013-.084.034-.164.147-.118a.572.572 0 01.22.139c.025.038.126 0 .105-.071a.29.29 0 00-.078-.117.296.296 0 00-.124-.065.69.69 0 01-.354-.172c-.021-.059.075-.118-.11-.118a.611.611 0 01-.501-.3.32.32 0 00-.173-.215c-.101-.067-.253-.219-.143-.324.109-.105.282.051.48.202.244.136.496.257.754.363.114.067.489.231.489.307 0 .076-.122.299-.029.363.14.095.26.217.354.358a.422.422 0 00.172.19c.034 0-.097.067-.033.13.063.063.122 0 .113.127-.008.126 0 .096.106.109a.763.763 0 01.269.097s-.092-.265-.042-.265c.051 0 0-.135.068-.148.067-.013.232.143.261.089.03-.055.063-.152 0-.198a3.065 3.065 0 01-.228-.228c-.042-.042-.181-.202-.134-.266.046-.063.156.089.269.047.114-.042.106-.177.169-.177h.253a.669.669 0 01.295.084s-.114.143-.089.24c.026.097.139.026.16.182.021.155 0 .198.038.24.062.055.11.124.139.202 0 .063.076.093.16.093.085 0 .224 0 .258.071.02.044.054.079.097.101a.215.215 0 00.139.017c.122 0 .122-.172.206-.177a.965.965 0 01.421.156.55.55 0 00.451 0c.068-.046.118-.164.215-.135a.32.32 0 00.27 0c.055-.038.11-.042.084 0-.025.043-.105.085-.097.161.009.075 0 .101 0 .177a.48.48 0 01-.063.358c-.088.147-.173.67-.392.703-.219.034-.451-.206-.746-.126-.295.08-.362.253-.59.228-.227-.026-.842-.186-.923-.161a.13.13 0 01-.143-.092c0-.034-.295 0-.421-.089-.127-.088-.447-.32-.733-.101-.287.219-.194.282-.186.375.009.093-.046.312-.215.236-.197-.115-.41-.2-.632-.253a.351.351 0 01-.316-.231.696.696 0 00-.539-.19.448.448 0 01-.422-.076c-.147-.122-.32-.244-.299-.295.021-.05.329-.021.341-.114.013-.092-.156-.059-.198-.139-.042-.08-.076-.076-.118-.126-.042-.051-.08-.101 0-.152.08-.05.122-.131.101-.152-.021-.021-.151.08-.189.026a.196.196 0 00-.215-.101c-.127 0-.253.126-.422.075a.704.704 0 00-.37 0c-.152 0-.177.102-.279.102a2.672 2.672 0 00-.703-.034 4.95 4.95 0 00-1.05.312.387.387 0 01-.421.08c-.181-.072-.421.08-.514 0a2.413 2.413 0 00-.202-.177l-.177.076a1.09 1.09 0 01-.527.564.792.792 0 00-.481.746.874.874 0 01-.598.687c-.421.16-.565.738-.792.881-.228.143-.78.897-.586 1.188a1.207 1.207 0 01.139 1.176c-.194.531-.35 1.235.809 2.061.497.381 1.028.716 1.585 1.003 0 0 .653-.422 1.108-.249.455.173 1.163-.211 1.513-.282a1.037 1.037 0 01.881.421c.105.177 1.053-.421.986.388-.068.809-.232.965-.127 1.175.106.211.582.704.843 1.18.261.477.388.759.282.881-.105.122.228.316.14.598-.089.283-.616.544-.477 1.353.139.809.599 1.058.725 1.707.127.649 0 .881.422 1.407.421.527.632.843.615 1.109a1.172 1.172 0 000 .324 18.294 18.294 0 005.723-12.857.689.689 0 01-.211-.244z"
          ></path>
          <path
            style={{ mixBlendMode: MIX_BLEND_MODE_COLOR_DODGE }}
            fill="url(#paint9_radial_1380_98514)"
            d="M116.137 186.2c1.175-7.307-3.797-14.183-11.104-15.357-7.308-1.174-14.183 3.797-15.358 11.105-1.174 7.307 3.797 14.183 11.105 15.357 7.307 1.174 14.183-3.797 15.357-11.105z"
            opacity="0.6"
          ></path>
          <path
            fill="#AFB6E5"
            d="M109.031 202.646c-12.959 0-23.494-4.913-23.494-10.956 0-2.588 1.939-5.087 5.453-7.046a.316.316 0 01.422.122.312.312 0 01.027.236.306.306 0 01-.15.185c-3.3 1.85-5.12 4.156-5.12 6.503 0 5.693 10.257 10.324 22.862 10.324 12.604 0 22.861-4.631 22.861-10.324 0-2.347-1.821-4.636-5.129-6.494a.303.303 0 01-.149-.185.31.31 0 01.213-.384.313.313 0 01.236.025c3.518 1.96 5.478 4.459 5.478 7.046-.017 6.035-10.556 10.948-23.51 10.948z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
            <path
              fill="#CED3F4"
              d="M126.835 194.792a24.908 24.908 0 01-4.29 1.854 40.173 40.173 0 00-7.788-10.611 45.322 45.322 0 00-4.269-3.793 32.038 32.038 0 016.397-3.325 15.29 15.29 0 015.694-1.078 20.933 20.933 0 00-.603-.633 16.83 16.83 0 00-5.314 1.147 32.867 32.867 0 00-6.683 3.502 31.723 31.723 0 00-8.85-4.834c.004-.07.004-.141 0-.211a1.5 1.5 0 00-1.25-1.49 1.498 1.498 0 00-1.665 1.006c-.338-.051-.671-.089-.991-.11-.22.19-.422.379-.65.577.524 0 1.046.038 1.564.114a1.495 1.495 0 002.777.67 31.05 31.05 0 018.496 4.636 48.47 48.47 0 00-6.65 5.592 50.075 50.075 0 00-3.683 4.113 1.526 1.526 0 00-.873-.283 1.505 1.505 0 00-1.414 1.012 1.5 1.5 0 00.492 1.669 40.33 40.33 0 00-1.551 2.393 25.037 25.037 0 01-4.416-1.884c.067.27.143.531.223.793a26.923 26.923 0 003.881 1.605 33.413 33.413 0 00-1.593 3.173c.138.208.278.411.421.607a31.038 31.038 0 011.779-3.577 44.56 44.56 0 0012.996 1.833 46.944 46.944 0 009.726-.991 1.492 1.492 0 001.682.737 1.497 1.497 0 001.129-1.449l.64-.168c.281.601.533 1.199.755 1.795.263.706.485 1.426.666 2.157.155-.202.307-.421.459-.627a22.423 22.423 0 00-1.298-3.519 26.374 26.374 0 003.793-1.614c.097-.261.172-.523.261-.788zm-5.386 2.183a1.501 1.501 0 00-2.546-.363 1.496 1.496 0 00-.336.953v.126a47.042 47.042 0 01-9.549.952c-4.289.036-8.56-.55-12.68-1.74.463-.767.965-1.537 1.504-2.309.114.03.232.045.35.046a1.505 1.505 0 001.504-1.5 1.487 1.487 0 00-.206-.746 49.51 49.51 0 013.704-4.142 47.385 47.385 0 016.742-5.622 44.574 44.574 0 014.375 3.852 40.021 40.021 0 017.631 10.349l-.493.144zM91.597 185.673c-.055-.198-.093-.388-.14-.586-.092.32-.176.645-.252.969a.337.337 0 00.173 0 .319.319 0 00.22-.383z"
            ></path>
          </g>
          <path
            fill="url(#paint10_linear_1380_98514)"
            d="M120.784 210.034a17.481 17.481 0 01-6.633-1.551.317.317 0 11.244-.582c4.813 2.027 8.745 2.01 10.801-.046 1.918-1.918 2.061-5.394.447-9.789-1.656-4.476-4.964-9.335-9.313-13.679-4.349-4.345-9.204-7.653-13.679-9.309-4.391-1.631-7.868-1.454-9.785.446-1.627 1.627-1.99 4.476-1.02 8.007a.318.318 0 01-.226.363.317.317 0 01-.38-.194c-1.067-3.818-.646-6.802 1.18-8.622 2.106-2.107 5.814-2.314 10.454-.594 4.556 1.685 9.495 5.056 13.907 9.46 4.412 4.404 7.77 9.347 9.46 13.907 1.72 4.635 1.509 8.352-.594 10.455-1.159 1.138-2.828 1.728-4.863 1.728z"
          ></path>
          <path
            fill="#AFB6E5"
            d="M97.278 210.033c-2.048 0-3.704-.59-4.858-1.732-2.108-2.107-2.314-5.815-.595-10.455 1.686-4.555 5.057-9.494 9.461-13.906 9.157-9.157 20.072-13.135 24.357-8.862 1.796 1.795 2.217 4.728 1.222 8.483a.313.313 0 01-.382.214.318.318 0 01-.229-.375c.936-3.527.569-6.249-1.057-7.876-4.025-4.024-14.552-.046-23.464 8.85-4.35 4.361-7.653 9.22-9.313 13.691-1.631 4.391-1.471 7.868.446 9.786 2.044 2.043 5.955 2.073 10.734.075a.317.317 0 01.464.287.33.33 0 01-.11.232.311.311 0 01-.114.063 17.398 17.398 0 01-6.562 1.525z"
          ></path>
          <path
            fill="url(#paint11_linear_1380_98514)"
            d="M109.031 202.647c-12.959 0-23.494-4.914-23.494-10.957 0-2.587 1.939-5.086 5.478-7.046a.32.32 0 01.422.123.315.315 0 01-.127.421c-3.32 1.85-5.14 4.155-5.14 6.502 0 5.694 10.256 10.325 22.861 10.325 12.604 0 22.861-4.631 22.861-10.325 0-2.347-1.821-4.635-5.129-6.494a.3.3 0 01-.149-.185.305.305 0 01.027-.236.312.312 0 01.422-.122c3.518 1.959 5.478 4.458 5.478 7.046-.017 6.034-10.556 10.948-23.51 10.948z"
          ></path>
          <path
            fill="url(#paint12_linear_1380_98514)"
            d="M97.278 210.034c-2.048 0-3.704-.59-4.858-1.732-2.108-2.107-2.314-5.815-.595-10.455 1.686-4.555 5.057-9.494 9.461-13.906 4.404-4.412 9.347-7.767 13.902-9.473 4.636-1.72 8.353-1.509 10.455.594 1.796 1.795 2.217 4.728 1.222 8.483a.313.313 0 01-.382.214.318.318 0 01-.229-.374c.936-3.528.569-6.25-1.057-7.877-1.918-1.883-5.394-2.06-9.785-.429-4.476 1.656-9.335 4.964-13.679 9.313-4.345 4.349-7.657 9.203-9.313 13.674-1.631 4.391-1.471 7.868.446 9.785 2.044 2.044 5.955 2.07 10.734.076a.317.317 0 01.464.287.334.334 0 01-.031.128.306.306 0 01-.079.104.327.327 0 01-.114.063 17.398 17.398 0 01-6.562 1.525z"
          ></path>
          <path
            fill="url(#paint13_radial_1380_98514)"
            d="M95.967 192.638a1.896 1.896 0 100-3.793 1.896 1.896 0 000 3.793z"
          ></path>
          <path
            fill="url(#paint14_radial_1380_98514)"
            d="M121.113 202.613a1.896 1.896 0 100-3.792 1.896 1.896 0 000 3.792z"
          ></path>
          <path
            fill="url(#paint15_radial_1380_98514)"
            d="M98.635 175.643a1.896 1.896 0 100-3.793 1.896 1.896 0 000 3.793z"
          ></path>
        </g>
        <text
          fill="#F04438"
          style={{ whiteSpace: 'pre' }}
          fontFamily="Manrope"
          fontSize="10"
          fontWeight="bold"
          letterSpacing=".01em"
        >
          <tspan x="66.177" y="239.505">
            24/7/365
          </tspan>
        </text>
        <text
          fill="#344054"
          style={{ whiteSpace: 'pre' }}
          fontFamily="Manrope"
          fontSize="10"
          fontWeight="bold"
          letterSpacing=".01em"
        >
          <tspan x="44.219" y="225.505">
            Strong Global Community,{' '}
          </tspan>
          <tspan x="110.688" y="239.505">
            {' '}
            support
          </tspan>
        </text>
      </g>
      <g filter="url(#filter1_dd_1380_98514)">
        <rect
          width="171.641"
          height="110.341"
          x="237.148"
          y="151.93"
          fill="#fff"
          rx="4"
          shapeRendering="crispEdges"
        ></rect>
        <g clipPath="url(#clip1_1380_98514)">
          <path
            fill="#C6CCF4"
            d="M309.862 181.861a6.622 6.622 0 011.67.04l-.076-.707c-.181 0-.361 0-.538.033l-1.301-2.324a5.969 5.969 0 00-1.907.654l-1.056.634a6.026 6.026 0 011.907-.654l1.301 2.324zM323.712 190.155l-1.028 1.219c.427.767.814 1.556 1.16 2.364l1.759.268a27.547 27.547 0 011.052 3.173l1.056-.634a26.164 26.164 0 00-1.056-3.173l-1.759-.268a25.248 25.248 0 00-1.156-2.36l1.024-1.218a29.776 29.776 0 00-1.907-2.88l-1.056.633c.692.92 1.33 1.881 1.911 2.876zM313.668 180.365l.586 2.409a13.308 13.308 0 011.855 1.084l.369-1.08c-.08-.049-.156-.102-.237-.146a12.691 12.691 0 00-.927-.492l-.586-2.409a11.135 11.135 0 00-2.381-.759l-1.06.633c.819.163 1.618.418 2.381.76zM319.076 184.155l-.241 2.031a23.72 23.72 0 011.67 1.913l1.048-.65a23.593 23.593 0 00-1.662-1.897l.245-2.031a22.03 22.03 0 00-2.381-2.031l-1.06.634a21.62 21.62 0 012.381 2.031zM326.344 203.365l-.876-.406a9.736 9.736 0 01-.417 1.856l1.606 2.064a7.73 7.73 0 01-1.06 1.929l1.06-.637a7.53 7.53 0 001.06-1.93l-1.606-2.063c.092-.26.164-.533.233-.813zM328.395 200.368l-1.867-1.295a18.435 18.435 0 00-.301-1.841l-1.176.134c.183.771.317 1.552.401 2.34l1.867 1.296c.04.492.064.975.064 1.454 0 .48-.024.939-.064 1.381l1.076-.645c.04-.443.06-.906.06-1.382 0-.475-.02-.95-.06-1.442z"
          ></path>
          <path
            fill="#CED3F4"
            d="M324.022 207.204l-.176-.183a5.05 5.05 0 01-1.16 1.008l.959 2.254c.39-.116.767-.274 1.124-.471l-1.024-2.437c.101-.041.185-.122.277-.171z"
          ></path>
          <path
            fill="#AFB6E5"
            d="M318.834 208.739l.241 2.295 1.06-.633-.245-2.299-1.056.637zM323.713 210.449l1.056-.637-1.024-2.417-1.059.633 1.027 2.421zM326.115 204.178l-1.056.633 1.606 2.064 1.059-.638-1.609-2.059zM318.834 186.166l1.056-.634.245-2.011-1.06.634-.241 2.011zM314.254 182.774l1.06-.634-.586-2.409-1.06.634.586 2.409zM309.857 181.861l1.06-.634-1.301-2.324-1.055.634 1.296 2.324zM306.522 183.615l1.056-.633-1.758-1.784-1.056.634 1.758 1.783zM303.029 186.804l1.06-.634 1.867.885-1.06.634-1.867-.885zM304.761 192.825l-1.06.637 1.61-.187 1.056-.637-1.606.187zM313.668 208.504l1.06-.633.586-1.723-1.06.634-.586 1.722z"
          ></path>
          <path
            fill="url(#paint16_linear_1380_98514)"
            d="M327.335 203.837c.04-.443.064-.902.064-1.381 0-.48-.024-.963-.064-1.455l-1.883-1.296a18.895 18.895 0 00-.402-2.339l1.606-.187a27.207 27.207 0 00-1.06-3.173l-1.75-.268a25.789 25.789 0 00-1.16-2.36l1.028-1.219a29.846 29.846 0 00-1.908-2.88l-1.3.813a23.757 23.757 0 00-1.671-1.913l.241-2.032a21.61 21.61 0 00-2.38-2.031l-.587 1.723a15.915 15.915 0 00-.927-.593 11.31 11.31 0 00-.927-.492l-.587-2.409a11.07 11.07 0 00-2.38-.759l.244 2.295a6.621 6.621 0 00-1.67-.041l-1.301-2.323a6.026 6.026 0 00-1.907.654l1.024 2.437a5.123 5.123 0 00-1.156 1.003l-1.759-1.779a7.756 7.756 0 00-1.064 1.934l1.606 2.063a9.692 9.692 0 00-.401 1.861l-1.875-.886c-.04.443-.06.902-.06 1.381 0 .48.02.963.06 1.454l1.867 1.292c.084.788.218 1.57.401 2.34l-1.606.187a26.364 26.364 0 001.064 3.172l1.759.273c.345.805.731 1.591 1.156 2.356l-1.024 1.218c.58.998 1.217 1.961 1.907 2.884l1.301-.812c.52.669 1.077 1.306 1.67 1.909l-.244 2.031c.745.734 1.54 1.412 2.38 2.031l.586-1.722a13.09 13.09 0 001.855 1.085l.587 2.404c.763.343 1.561.599 2.38.764l-.241-2.299a6.493 6.493 0 001.671.045l1.3 2.319a6.035 6.035 0 001.907-.65l-1.027-2.437a5.044 5.044 0 001.168-1.008l1.759 1.784a7.724 7.724 0 001.051-1.93l-1.606-2.059a9.71 9.71 0 00.402-1.861l1.883.882zm-12.153-5.167a6.414 6.414 0 01-2.035-2.169 6.495 6.495 0 01-.848-2.864c0-1.853 1.293-2.596 2.883-1.666a6.398 6.398 0 012.038 2.167c.502.875.792 1.857.849 2.866 0 1.848-1.293 2.596-2.887 1.666z"
          ></path>
          <path
            fill="url(#paint17_linear_1380_98514)"
            d="M315.183 184.448c-5.171-3.022-9.363-.601-9.363 5.403 0 6.003 4.192 13.34 9.363 16.342 5.171 3.002 9.367.601 9.367-5.403s-4.196-13.32-9.367-16.342zm0 15.363c-2.136-1.247-3.866-4.269-3.866-6.751s1.73-3.478 3.866-2.23c2.136 1.247 3.87 4.269 3.87 6.751s-1.734 3.477-3.87 2.23z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
            <path
              fill="#AFB6E5"
              d="M319.454 197.174c0-2.482-1.734-5.504-3.87-6.751-1.405-.813-2.634-.666-3.313.244.711-.528 1.751-.516 2.911.162 2.136 1.247 3.871 4.269 3.871 6.751a3.287 3.287 0 01-.558 1.983c.594-.435.959-1.247.959-2.389z"
            ></path>
            <path
              fill="#AFB6E5"
              d="M315.584 205.787c-5.171-3.002-9.362-10.339-9.362-16.343 0-2.238.582-3.972 1.578-5.118-1.241 1.117-1.98 3.022-1.98 5.525 0 6.004 4.192 13.34 9.363 16.342 3.248 1.897 6.107 1.649 7.789-.285-1.715 1.548-4.384 1.629-7.388-.121z"
            ></path>
          </g>
          <path
            fill="#AFB6E5"
            d="M324.769 189.521l-1.056.634-1.027 1.223 1.059-.634 1.024-1.223zM324.902 193.104l-1.056.634 1.758.268 1.056-.633-1.758-.269zM325.467 199.706l1.06-.634 1.867 1.296-1.06.634-1.867-1.296z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}>
            <path
              fill="#AFB6E5"
              d="M312.258 193.677a6.485 6.485 0 00.845 2.871 6.426 6.426 0 002.037 2.174c.972.564 1.827.508 2.349-.037-.526.5-1.361.532-2.297 0a6.389 6.389 0 01-2.038-2.167 6.474 6.474 0 01-.848-2.866 2.308 2.308 0 01.538-1.625 2.243 2.243 0 00-.586 1.65zM306.77 183.347zM313.628 180.406l.582 2.409c.309.146.614.309.927.492.313.182.622.381.928.593l.024-.069a11.099 11.099 0 00-.9-.573 18.79 18.79 0 00-.927-.492l-.586-2.409a11.394 11.394 0 00-2.381-.763v.061c.802.164 1.584.416 2.333.751zM308.521 179.577l1.301 2.324a6.622 6.622 0 011.67.04v-.057a6.588 6.588 0 00-1.606-.032l-1.297-2.324a5.975 5.975 0 00-1.927.654v.021a6.04 6.04 0 011.859-.626zM305.257 193.271l-1.546.17v.045l1.546-.183v-.032zM319.028 184.195l-.24 2.011a23.55 23.55 0 011.67 1.913l1.301-.812a29.847 29.847 0 011.915 2.884l-1.032 1.219c.426.765.812 1.553 1.156 2.36l1.759.268a26.889 26.889 0 011.048 3.132h.06a27.207 27.207 0 00-1.06-3.173l-1.759-.272a25.684 25.684 0 00-1.156-2.356l1.024-1.219a30.024 30.024 0 00-1.907-2.88l-1.301.813a22.508 22.508 0 00-1.67-1.913l.241-2.032a22.53 22.53 0 00-2.377-2.031l-.024.069c.831.616 1.617 1.29 2.352 2.019zM323.564 207.325zM322.643 208.065l1.015 2.401.057-.033-1.02-2.405-.052.037zM318.795 208.776l.233 2.238h.052l-.237-2.243-.048.005zM325.451 203.008h-.04a9.758 9.758 0 01-.401 1.86l1.606 2.064a7.788 7.788 0 01-1.02 1.873 7.7 7.7 0 001.06-1.958l-1.606-2.032a9.308 9.308 0 00.401-1.807zM306.483 183.655l.048-.048-1.758-1.784-.041.057 1.751 1.775zM327.346 200.993l-1.871-1.295a18.878 18.878 0 00-.401-2.3h-.06c.183.771.317 1.552.401 2.34l1.867 1.296c.04.492.064.975.064 1.454 0 .48 0 .89-.056 1.308l.044.025c.04-.443.06-.906.06-1.381 0-.476-.008-.959-.048-1.447zM304.856 187.73v-.069l-1.819-.865a.397.397 0 010 .069l1.819.865zM314.21 206.822l-.558 1.649h.028l.563-1.624-.033-.025z"
            ></path>
          </g>
          <path fill="#AFB6E5" d="M326.326 188.856l1.056-.634-.361-1.966-1.056.638.361 1.962z"></path>
          <path
            fill="#C6CCF4"
            d="M328.631 188.465a3.592 3.592 0 011.634-.406l-.064-.43a3.165 3.165 0 00-.51.223l-1.161-1.41a4.225 4.225 0 00-.907.813l1.008 1.21zM341.359 203.065l-.803-.358a5.615 5.615 0 01-.651 1.869l.956 1.624a4.24 4.24 0 01-1.205 1.219l1.052-.638c.479-.32.888-.734 1.205-1.218l-.96-1.625a4.68 4.68 0 00.406-.873zM330.025 186.393a6.632 6.632 0 011.968.407l.562 1.714a8.28 8.28 0 011.011.504c.35.207.687.434 1.012.678l.538-1.003c-.164-.106-.325-.212-.494-.309a8.602 8.602 0 00-1.007-.504l-.566-1.714a6.6 6.6 0 00-1.968-.406l-1.056.633zM342.905 200.237l-1.305-.959a14.288 14.288 0 00-.602-2.526l.935-.561a20.546 20.546 0 00-1.204-2.652l-1.16.056a16.823 16.823 0 00-1.634-2.335l.245-1.361a16.293 16.293 0 00-1.968-1.893l-1.06.638c.7.572 1.35 1.204 1.944 1.889l-.241 1.36a17.127 17.127 0 011.634 2.336l1.156-.057c.465.854.867 1.74 1.204 2.653l-.943.491c.289.843.497 1.713.622 2.596l1.305.963c.044.404.067.811.068 1.218.001.389-.022.777-.068 1.162l1.06-.634c.042-.385.064-.773.064-1.161a9.845 9.845 0 00-.052-1.223z"
          ></path>
          <path
            fill="#AFB6E5"
            d="M331.992 205.83l1.056-.633.566-1.052-1.06.633-.562 1.052zM337.108 208.082l1.06-.634-.245-1.649-1.056.638.241 1.645zM339.916 204.575l1.056-.634.959 1.609-1.059.638-.956-1.613zM340.541 199.913l1.06-.634 1.305.959-1.06.638-1.305-.963zM338.5 194.23l1.06-.634 1.156-.057-1.06.634-1.156.057zM336.867 191.893l1.056-.634.245-1.361-1.06.634-.241 1.361zM332.554 188.514l1.06-.634-.566-1.714-1.056.634.562 1.714zM328.631 188.465l1.06-.634-1.16-1.409-1.056.634 1.156 1.409zM326.592 191.768l1.056-.638-1.305-.565-1.056.634 1.305.569z"
          ></path>
          <path
            fill="url(#paint18_linear_1380_98514)"
            d="M341.844 203.276a9.82 9.82 0 00.069-1.162 11.826 11.826 0 00-.069-1.219l-1.304-.962a14.06 14.06 0 00-.635-2.616l.956-.492a20.225 20.225 0 00-1.205-2.652l-1.156.056a17.118 17.118 0 00-1.634-2.335l.241-1.361a15.814 15.814 0 00-1.967-1.889l-.563 1.052a11.21 11.21 0 00-1.011-.678 8.366 8.366 0 00-1.012-.504l-.562-1.714a6.6 6.6 0 00-1.967-.406l.245 1.645a3.567 3.567 0 00-1.634.406l-1.177-1.389a4.246 4.246 0 00-1.204 1.218l.955 1.625a5.61 5.61 0 00-.622 1.865l-1.305-.565a9.61 9.61 0 00-.068 1.162c.002.407.024.814.068 1.218l1.305.963c.125.884.334 1.753.622 2.596l-.955.512c.337.912.739 1.799 1.204 2.652l1.156-.057a17 17 0 001.655 2.336l-.241 1.361c.602.684 1.26 1.316 1.967 1.889l.562-1.052c.325.243.662.468 1.012.674.325.193.663.363 1.012.508l.558 1.698a6.51 6.51 0 001.955.406l-.229-1.625a3.624 3.624 0 001.634-.406l1.156 1.406c.48-.32.889-.734 1.205-1.219l-.956-1.625c.316-.58.527-1.213.623-1.869l1.316.549zm-8.278-3.189a5.448 5.448 0 01-1.736-1.845 5.514 5.514 0 01-.721-2.441c0-1.576 1.1-2.209 2.457-1.417a5.45 5.45 0 011.735 1.847c.427.746.674 1.582.722 2.442 0 1.572-1.1 2.206-2.457 1.414z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint19_radial_1380_98514)"
              d="M331.96 186.865l.566 1.702a8.12 8.12 0 011.008.507 10 10 0 011.012.675l.04-.077c-.324-.243-.66-.469-1.008-.675a8.515 8.515 0 00-1.012-.504l-.562-1.714a6.593 6.593 0 00-1.967-.406v.077c.658.04 1.306.18 1.923.415z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint20_radial_1380_98514)"
              d="M331.073 195.879a5.53 5.53 0 00.72 2.441 5.457 5.457 0 001.733 1.848c.963.561 1.794.407 2.196-.296-.402.638-1.205.764-2.152.219a5.438 5.438 0 01-1.736-1.845 5.513 5.513 0 01-.721-2.44 2.24 2.24 0 01.269-1.146c-.221.366-.329.79-.309 1.219z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint21_radial_1380_98514)"
              d="M337.096 190.598l-.245 1.365a16.71 16.71 0 011.634 2.332l1.141-.041c.465.839.868 1.712 1.204 2.612l.06-.032c-.335-.914-.738-1.8-1.204-2.653l-1.157.057a16.748 16.748 0 00-1.634-2.336l.245-1.361a16.674 16.674 0 00-1.967-1.893l-.044.078a16.26 16.26 0 011.967 1.872z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint22_radial_1380_98514)"
              d="M327.169 197.174l-.915.463v.041l.899-.459a.218.218 0 01.016-.045z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint23_radial_1380_98514)"
              d="M327.459 187.12l1.156 1.405a3.653 3.653 0 011.634-.406v-.069a3.596 3.596 0 00-1.582.406l-1.156-1.409a4.237 4.237 0 00-1.204 1.219 4.135 4.135 0 011.152-1.146z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint24_radial_1380_98514)"
              d="M341.856 200.859l-1.305-.958a13.846 13.846 0 00-.606-2.551l-.06.028c.291.843.501 1.712.626 2.596l1.305.962c.04.407.064.813.064 1.219 0 .358-.018.716-.056 1.073h.032c.04-.374.059-.75.056-1.126.003-.415-.015-.83-.056-1.243z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint25_radial_1380_98514)"
              d="M340.537 202.784h-.025a5.532 5.532 0 01-.606 1.853l.956 1.624.044-.065-.956-1.624a5.498 5.498 0 00.587-1.788z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint26_radial_1380_98514)"
              d="M336.834 206.496l.233 1.568h.056l-.233-1.576-.056.008z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint27_radial_1380_98514)"
              d="M332.526 204.84l-.526.979.526-.975v-.004z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint28_radial_1380_98514)"
              d="M326.56 191.816a.617.617 0 000-.086l-1.277-.556v.089l1.277.553z"
            ></path>
          </g>
          <path
            fill="url(#paint29_linear_1380_98514)"
            d="M333.566 190.029c-3.428-2.003-6.207-.406-6.207 3.583 0 3.989 2.779 8.831 6.207 10.833 3.429 2.003 6.211.407 6.211-3.582s-2.782-8.832-6.211-10.834zm0 10.988c-1.798-1.048-3.256-3.595-3.256-5.687s1.458-2.929 3.256-1.881c1.799 1.048 3.256 3.599 3.256 5.687s-1.457 2.933-3.256 1.881z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
            <path
              fill="#AFB6E5"
              d="M335.983 201.18c.755-.252 1.241-1.04 1.241-2.242 0-2.088-1.458-4.635-3.256-5.687-.96-.557-1.819-.577-2.409-.159a2.489 2.489 0 012.007.362c1.799 1.052 3.256 3.599 3.256 5.687 0 .975-.317 1.673-.839 2.039z"
            ></path>
            <path
              fill="#AFB6E5"
              d="M333.968 204.243c-3.429-2.003-6.207-6.853-6.207-10.834 0-1.954.67-3.331 1.754-3.993-1.321.552-2.156 2.011-2.156 4.196 0 3.981 2.779 8.831 6.207 10.834 1.747 1.02 3.325 1.101 4.453.406-1.088.459-2.501.297-4.051-.609z"
            ></path>
          </g>
          <path
            fill="url(#paint30_linear_1380_98514)"
            d="M331.107 195.802c.048.859.295 1.695.722 2.44a5.438 5.438 0 001.736 1.845c.963.565 1.79.407 2.196-.292a2.212 2.212 0 01-1.141-.341 5.461 5.461 0 01-1.732-1.847 5.531 5.531 0 01-.721-2.439c-.012-.39.078-.777.261-1.121-.783.02-1.321.658-1.321 1.755z"
          ></path>
          <path
            fill="#C6CCF4"
            d="M321.347 171.989l.803 2.011a6.844 6.844 0 011.293.756l.679-.894a5.812 5.812 0 00-.9-.487l-.803-2.011a4.552 4.552 0 00-2.096-.224l-1.055.634c.7-.09 1.411-.016 2.079.215zM326.326 175.901l-.362 1.54c.338.503.64 1.03.904 1.576l1.509.459c.393.938.682 1.918.86 2.921l1.059-.634a13.946 13.946 0 00-.863-2.921l-1.509-.463a12.824 12.824 0 00-.904-1.572l.366-1.543a13.965 13.965 0 00-2.084-2.214l-1.056.634c.772.659 1.47 1.403 2.08 2.217z"
          ></path>
          <path
            fill="url(#paint31_linear_1380_98514)"
            d="M321.068 179.305c.034.605.208 1.194.509 1.719.3.524.719.969 1.222 1.299.763.447 1.409.252 1.638-.406a1.739 1.739 0 01-.59-.227 3.832 3.832 0 01-1.222-1.3 3.892 3.892 0 01-.509-1.719c-.001-.198.03-.396.093-.585-.663-.113-1.141.346-1.141 1.219z"
          ></path>
          <path
            fill="#AFB6E5"
            d="M329.012 182.697v-.272l-1.088.138a6.838 6.838 0 010 1.483l1.321 1.718a4.558 4.558 0 01-.859 1.909l1.055-.634a4.62 4.62 0 00.864-1.913l-1.325-1.714a5.89 5.89 0 00.032-.715zM318.277 172.322l-1.06.638 1.509 1.3 1.06-.634-1.509-1.304zM316.354 178.237l1.059-.634 1.321-.17-1.056.633-1.324.171zM321.348 186.946l1.056-.634.815-1.06-1.06.634-.811 1.06z"
          ></path>
          <path fill="#C6CCF4" d="M328.972 183.412l-1.056.634 1.321 1.714 1.06-.634-1.325-1.714z"></path>
          <path
            fill="url(#paint32_linear_1380_98514)"
            d="M327.956 183.332c0-.252 0-.508-.04-.768l1.321-.167a13.791 13.791 0 00-.859-2.92l-1.51-.459a13.01 13.01 0 00-.903-1.577l.361-1.539a13.747 13.747 0 00-2.08-2.218l-.803 1.072a6.948 6.948 0 00-.638-.406 6.952 6.952 0 00-.638-.325l-.803-2.011a4.579 4.579 0 00-2.08-.215l.361 1.966a2.442 2.442 0 00-.903.52l-1.51-1.3a4.596 4.596 0 00-.863 1.909l1.325 1.715a6.884 6.884 0 00-.04.719c0 .252 0 .507.04.763l-1.325.171c.181 1.001.471 1.979.863 2.917l1.51.463c.263.545.564 1.071.903 1.572l-.361 1.543a13.568 13.568 0 002.064 2.186l.803-1.06c.208.15.421.292.638.406.206.121.419.229.638.325l.803 2.031c.668.234 1.38.308 2.08.215l-.361-1.962c.333-.108.641-.285.903-.52l1.51 1.3c.43-.56.724-1.214.859-1.909l-1.321-1.718c.031-.239.05-.479.056-.719zm-5.159-1.008a3.874 3.874 0 01-1.73-3.018c0-1.109.774-1.556 1.73-.999.503.33.922.776 1.222 1.301.301.525.475 1.115.508 1.721 0 1.109-.775 1.552-1.73.995z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint33_radial_1380_98514)"
              d="M317.666 178.062l-1.285.167a.14.14 0 010 .041l1.281-.163a.138.138 0 01.004-.045z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint34_radial_1380_98514)"
              d="M321.334 172.031l.803 2.031c.219.097.432.205.639.325.212.126.425.268.638.406l.803-1.064c.77.66 1.467 1.402 2.08 2.213l-.362 1.544c.337.502.637 1.027.9 1.572l1.509.463c.388.924.675 1.889.855 2.876h.045a13.954 13.954 0 00-.86-2.916l-1.489-.476a12.824 12.824 0 00-.904-1.572l.362-1.543a13.94 13.94 0 00-2.08-2.214l-.811 1.08c-.209-.15-.401-.292-.638-.406a6.844 6.844 0 00-.639-.325l-.803-2.011a4.573 4.573 0 00-2.079-.215v.045a4.572 4.572 0 012.031.187z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint35_radial_1380_98514)"
              d="M321.058 179.346c.034.606.208 1.194.509 1.719.3.524.719.97 1.222 1.3.658.385 1.228.292 1.521-.167-.301.406-.855.487-1.485.118a3.823 3.823 0 01-1.222-1.3 3.888 3.888 0 01-.509-1.718 1.536 1.536 0 01.205-.833c-.171.26-.255.569-.241.881z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint36_radial_1380_98514)"
              d="M327.985 183.319c0-.236 0-.476-.041-.719h-.04c.029.255.044.511.044.767.001.245-.014.489-.044.732l1.325 1.714a4.668 4.668 0 01-.714 1.714 4.72 4.72 0 00.75-1.763l-1.321-1.714c.027-.243.04-.487.041-.731z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint37_radial_1380_98514)"
              d="M325.955 186.943l.353 1.917h.045l-.358-1.929-.04.012z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_SCREEN }}
              fill="url(#paint38_radial_1380_98514)"
              d="M317.208 172.998l1.51 1.304c.259-.238.568-.416.903-.52v-.033a2.43 2.43 0 00-.859.504l-1.518-1.304a3.664 3.664 0 00-.036.049z"
            ></path>
          </g>
          <path
            fill="url(#paint39_linear_1380_98514)"
            d="M322.797 175.118c-2.473-1.446-4.481-.288-4.481 2.584s2.008 6.369 4.481 7.815c2.473 1.446 4.477.289 4.477-2.583 0-2.872-2.004-6.374-4.477-7.816zm0 8.035a5.422 5.422 0 01-1.726-1.837 5.5 5.5 0 01-.719-2.428c0-1.564 1.096-2.194 2.445-1.406.71.466 1.3 1.095 1.725 1.835.424.741.669 1.572.716 2.426 0 1.568-1.092 2.198-2.441 1.41z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_MULTIPLY }}>
            <path
              fill="#AFB6E5"
              d="M325.451 181.337a5.485 5.485 0 00-.716-2.426 5.413 5.413 0 00-1.725-1.835c-1.084-.634-2.007-.35-2.321.597.402-.609 1.205-.723 2.12-.191a5.408 5.408 0 011.718 1.837c.422.74.666 1.571.711 2.424.003.276-.038.55-.12.813.232-.362.348-.788.333-1.219zM322.998 185.111c-2.473-1.446-4.48-4.944-4.48-7.816a4.476 4.476 0 01.301-1.686 4.039 4.039 0 00-.502 2.092c0 2.872 2.007 6.37 4.48 7.816 1.907 1.113 3.533.674 4.18-.902-.747 1.239-2.244 1.515-3.979.496z"
            ></path>
          </g>
          <path
            fill="#AFB6E5"
            d="M323.219 173.366l-1.06.634-.811-2.011 1.056-.634.815 2.011zM326.326 175.901l1.056-.633-.361 1.539-1.056.634.361-1.54zM327.925 178.383l1.51.459-1.056.634-1.51-.459 1.056-.634z"
          ></path>
        </g>
        <text
          fill="#344054"
          style={{ whiteSpace: 'pre' }}
          fontFamily="Manrope"
          fontSize="10"
          fontWeight="bold"
          letterSpacing=".01em"
        >
          <tspan x="261.824" y="225.93">
            Onsite, offshore &amp; mixed{' '}
          </tspan>
          <tspan x="287.022" y="239.93">
            working model
          </tspan>
        </text>
      </g>
      <g filter="url(#filter2_dd_1380_98514)">
        <rect width="171.641" height="110.341" x="130.211" y="8" fill="#fff" rx="4" shapeRendering="crispEdges"></rect>
        <g clipPath="url(#clip2_1380_98514)">
          <path
            fill="url(#paint40_linear_1380_98514)"
            d="M231.782 63.96V45.448a1.318 1.318 0 00-.661-1.137L208.89 31.488a1.325 1.325 0 00-1.804.479c-.116.2-.178.427-.18.658V51.14a1.328 1.328 0 00.661 1.137l22.235 12.836a1.323 1.323 0 001.98-1.154z"
          ></path>
          <path
            fill="url(#paint41_linear_1380_98514)"
            d="M230.467 64.836a.874.874 0 00.876-.876V45.448a.878.878 0 00-.433-.74l-22.238-12.84a.87.87 0 00-1.322.757V51.14a.866.866 0 00.436.754l22.235 12.84c.136.074.291.11.446.102z"
          ></path>
          <path
            fill="url(#paint42_linear_1380_98514)"
            d="M231.783 63.96V45.448a1.328 1.328 0 00-.661-1.137L208.89 31.488a1.298 1.298 0 00-1.12-.09l.528-.28a1.325 1.325 0 011.455-.087l22.221 12.837a1.32 1.32 0 01.662 1.133v18.513a1.298 1.298 0 01-.823 1.213l-.586.33a1.3 1.3 0 00.556-1.097z"
          ></path>
          <path
            fill="url(#paint43_linear_1380_98514)"
            d="M229.813 67.372l-16.02 9.256a1.323 1.323 0 01-1.322 0l-22.222-12.843a1.32 1.32 0 01-.474-1.792c.113-.199.277-.365.474-.483l16.02-9.256a1.322 1.322 0 011.322 0l22.235 12.837a1.32 1.32 0 01.647 1.144 1.327 1.327 0 01-.66 1.137z"
          ></path>
          <path
            fill="url(#paint44_linear_1380_98514)"
            d="M189.588 62.71v1.214a1.293 1.293 0 00.661 1.078l22.235 12.836a1.322 1.322 0 001.322 0l16.02-9.256a1.3 1.3 0 00.661-1.137v-1.203a1.3 1.3 0 01-.661 1.137l-16.02 9.256a1.322 1.322 0 01-1.322 0l-22.235-12.85a1.295 1.295 0 01-.661-1.074z"
          ></path>
          <path
            fill="url(#paint45_linear_1380_98514)"
            d="M198.534 60.155l19.094 11.025c.744.43 2.046.376 2.906-.123l5.748-3.306c.86-.499.952-1.25.209-1.679l-19.095-11.035c-.743-.43-2.046-.377-2.905.123l-5.749 3.306c-.86.508-.952 1.269-.208 1.689z"
          ></path>
          <path
            fill="#99B5E0"
            d="M226.489 66.327l-19.094-11.025c-.744-.43-2.046-.377-2.906.122l-5.748 3.32a1.319 1.319 0 00-.698.822c-.076-.37.162-.777.698-1.084l5.748-3.306c.86-.499 2.162-.552 2.906-.122l19.094 11.025a.815.815 0 01.49.856.944.944 0 00-.49-.608z"
          ></path>
          <path
            fill="#99B5E0"
            d="M212.094 60.664l1.012-.598-1.012-.586-1.018.586 1.018.598zm1.984 1.15l1.011-.585-1.005-.585-1.024.585 1.018.585zm-3.967-2.314l1.015-.582-1.025-.572-1.008.586 1.018.568zm-5.792-.542l-2.109-1.206-1.012.581 2.11 1.22 1.011-.595zm-.397-1.035l1.012-.585-1.012-.578-1.011.578 1.011.585zm4.179.443l1.015-.585-1.015-.585-.992.585.992.585zm7.964 4.595l1.021-.581-1.012-.586-1.011.586 1.002.581zm-12.41-3.226l17.448 10.083 1.014-.585-17.451-10.077-1.011.579zm14.41 4.37l1.011-.585-1.011-.585-1.012.585 1.012.585zm-13.6-5.878l18.363 10.602 1.012-.585-18.384-10.602-.991.585zm-4.959 1.085l19.904 11.49 1.012-.581-19.924-11.478-.992.569zm22.555 7.097l1.012-.585-1.012-.582-1.011.582 1.011.585zm-1.983-1.147l.988-.568-1.011-.585-1.012.585 1.035.568z"
          ></path>
          <path
            fill="#E4F2FF"
            d="M212.094 60.49l1.012-.586-1.012-.585-1.018.585 1.018.585zm1.984 1.146l1.018-.578-1.012-.589-1.024.589 1.018.578zm-3.967-2.314l1.005-.578-1.015-.586-1.008.586 1.018.578zm-5.792-.539l-2.109-1.22-1.012.586 2.11 1.216 1.011-.582zm-.397-1.031l1.012-.585-1.012-.582-1.011.575 1.011.592zm4.179.44l1.015-.586-1.015-.585-.992.585.992.586zm7.964 4.595l1.011-.585-1.011-.586-1.012.586 1.012.585zm-12.41-3.22l17.448 10.086 1.014-.582-17.451-10.09-1.011.586zm14.41 4.37l1.011-.585-1.011-.585-1.012.585 1.012.585zm-13.6-5.884l18.35 10.608 1.012-.585-18.371-10.608-.991.585zm-4.959 1.084l19.887 11.507 1.012-.585-19.907-11.507-.992.585zm22.555 7.097l1.012-.585-1.012-.585-1.011.585 1.011.585zm-1.983-1.15l1.011-.585-1.011-.582-1.012.582 1.012.585z"
          ></path>
          <path
            fill="#fff"
            d="M211.04 58.8l.076-.047-1.015-.585-1.008.575.076.047.935-.542.936.552zm-1.984-1.15l.076-.044-1.031-.585-.992.585.076.043.916-.542.955.542zm3.967 2.313l.076-.043-1.011-.585-1.012.569.076.043.942-.542.929.558zm-8.704-1.18l-2.109-1.22-1.012.585.076.043.936-.538 2.033 1.173.076-.043zm10.701 2.314l.076-.043-1.012-.585-1.024.588.076.043.938-.542.946.54zm-10.162-3.89l.076-.047-1.012-.582-1.011.582.076.046.935-.542.936.542zm-5.352 1.93l.076.043.916-.54 19.834 11.449.076-.046-19.91-11.491-.992.585zm5.95-1.58l18.285 10.555.076-.043-18.361-10.602-.991.586.076.043.915-.54zm17.521 8.129l.076-.043-1.012-.585-1.011.585.076.043.935-.54.936.54zm-18.311-6.612l17.375 10.03.076-.043-17.451-10.08-1.011.586.076.042.935-.535zm16.327 5.471l.076-.046-1.011-.582-1.012.582.076.046.936-.542.935.542zm-3.966-2.314l.076-.046-1.012-.585-1.012.585.076.046.919-.512.953.512zm1.983 1.147l.076-.043-1.012-.585-1.011.585.076.043.935-.539.936.54z"
          ></path>
          <path
            fill="#B8CFF6"
            d="M200.097 66.628l5.95 3.438a1.61 1.61 0 001.445-.063l1.322-.753c.426-.245.473-.622.102-.837l-5.95-3.434a1.628 1.628 0 00-1.448.06l-1.306.756c-.439.245-.486.622-.115.833z"
          ></path>
          <path
            fill="#99B5E0"
            d="M208.903 68.591l-5.951-3.434a1.605 1.605 0 00-1.447.06l-1.306.753a.662.662 0 00-.331.387c-.053-.189.06-.403.331-.562l1.306-.77a1.623 1.623 0 011.447-.06l5.951 3.435a.41.41 0 01.235.45.474.474 0 00-.235-.258z"
          ></path>
          <path
            fill="#fff"
            d="M210.51 38.22v-.68c0-.588.413-.83.925-.536l15.838 9.144a2.048 2.048 0 01.923 1.6v.681L210.51 38.221z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}>
            <path
              fill="#fff"
              d="M226.562 46.614a.826.826 0 00.381.645c.205.119.373.02.373-.215a.827.827 0 00-.373-.661c-.215-.103-.381-.007-.381.23zM225.256 45.85a.82.82 0 00.363.662c.205.119.374.023.374-.215a.82.82 0 00-.374-.652c-.198-.125-.363-.02-.363.205zM223.967 45.107a.827.827 0 00.373.66c.205.12.371.024.371-.214a.818.818 0 00-.371-.645c-.221-.132-.373-.05-.373.199z"
            ></path>
          </g>
          <path fill="url(#paint46_linear_1380_98514)" d="M225.393 50.122l2.8 1.617v-2.55l-2.8-1.616v2.549z"></path>
          <path fill="url(#paint47_linear_1380_98514)" d="M221.895 48.102l2.8 1.616v-2.549l-2.8-1.616v2.549z"></path>
          <path fill="#9CE1F0" d="M218.396 46.082l2.8 1.617v-2.55l-2.8-1.616v2.549z"></path>
          <path fill="url(#paint48_linear_1380_98514)" d="M217.432 45.526l-6.922-3.996v-.536l6.922 3.997v.535z"></path>
          <path fill="url(#paint49_linear_1380_98514)" d="M217.432 44.518l-6.922-3.996v-.533l6.922 3.994v.535z"></path>
          <path fill="url(#paint50_linear_1380_98514)" d="M217.432 43.514l-6.922-3.997v-.536l6.922 3.997v.536z"></path>
          <path
            fill="#fff"
            d="M211.118 47.348l16.466 9.508c.331.191.608 0 .608-.46v-3.058a1.462 1.462 0 00-.608-1.16l-16.466-9.508c-.331-.191-.608 0-.608.46v3.051a1.457 1.457 0 00.608 1.167z"
          ></path>
          <path
            fill="url(#paint51_linear_1380_98514)"
            d="M220.967 52.346l2.149 1.243v-2.655l-2.149-1.243v2.655z"
          ></path>
          <path fill="#9CE1F0" d="M218.275 50.796l2.152 1.243V49.8l-2.152-1.243v2.238z"></path>
          <path
            fill="url(#paint52_linear_1380_98514)"
            d="M215.588 49.242l2.152 1.243v-3.263l-2.152-1.242v3.262z"
          ></path>
          <path
            fill="#154D81"
            d="M211.709 46.69l-.578-.333v-.536l.578.334v.536zM211.709 45.686l-.578-.334v-.536l.578.334v.536zM211.709 44.68l-.578-.334v-.535l.578.333v.536z"
          ></path>
          <mask id="path-156-inside-1_1380_98514" fill="#fff">
            <path d="M214.98 48.578l-2.992-1.726v-.536l2.992 1.726v.536z"></path>
          </mask>
          <path
            fill="url(#paint53_linear_1380_98514)"
            stroke="url(#paint54_linear_1380_98514)"
            strokeWidth="2"
            d="M214.98 48.578l-2.992-1.726v-.536l2.992 1.726v.536z"
            mask="url(#path-156-inside-1_1380_98514)"
          ></path>
          <mask id="path-157-inside-2_1380_98514" fill="#fff">
            <path d="M214.98 47.573l-2.992-1.726v-.535l2.992 1.725v.536z"></path>
          </mask>
          <path
            fill="url(#paint55_linear_1380_98514)"
            stroke="url(#paint56_linear_1380_98514)"
            strokeWidth="2"
            d="M214.98 47.573l-2.992-1.726v-.535l2.992 1.725v.536z"
            mask="url(#path-157-inside-2_1380_98514)"
          ></path>
          <mask id="path-158-inside-3_1380_98514" fill="#fff">
            <path d="M214.98 46.568l-2.992-1.726v-.535l2.992 1.725v.536z"></path>
          </mask>
          <path
            fill="url(#paint57_linear_1380_98514)"
            stroke="url(#paint58_linear_1380_98514)"
            strokeWidth="2"
            d="M214.98 46.568l-2.992-1.726v-.535l2.992 1.725v.536z"
            mask="url(#path-158-inside-3_1380_98514)"
          ></path>
          <path fill="url(#paint59_linear_1380_98514)" d="M226.977 52.958l.575.334v.535l-.575-.334v-.535z"></path>
          <path fill="url(#paint60_linear_1380_98514)" d="M226.977 53.963l.575.334v.535l-.575-.334v-.535z"></path>
          <path fill="url(#paint61_linear_1380_98514)" d="M226.977 54.968l.575.334v.535l-.575-.334v-.535z"></path>
          <path fill="url(#paint62_linear_1380_98514)" d="M223.703 51.07l2.992 1.726v.535l-2.992-1.725v-.536z"></path>
          <path fill="url(#paint63_linear_1380_98514)" d="M223.703 52.075l2.992 1.726v.535l-2.992-1.725v-.536z"></path>
          <path fill="url(#paint64_linear_1380_98514)" d="M223.703 53.08l2.992 1.726v.535l-2.992-1.725v-.536z"></path>
          <path
            fill="#fff"
            d="M211.69 50.278l15.058 8.694c.33.181.568 0 .568-.43a1.364 1.364 0 00-.568-1.084l-15.058-8.694c-.331-.182-.569 0-.569.43a1.352 1.352 0 00.569 1.084z"
          ></path>
          <path
            fill="url(#paint65_linear_1380_98514)"
            d="M227.383 61.484l14.287 8.248c.44.255.804-.02.804-.608V55.617a1.952 1.952 0 00-.804-1.538l-14.287-8.264c-.443-.255-.807.02-.807.608v13.524a1.942 1.942 0 00.807 1.537z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}
              fill="url(#paint66_linear_1380_98514)"
              d="M227.822 60.096l13.405 7.742v-1.005l-13.405-7.742v1.005z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}
              fill="url(#paint67_linear_1380_98514)"
              d="M237.458 61.461c1.619-.935 1.619-3.966 0-6.771-1.62-2.805-4.245-4.321-5.864-3.386-1.619.934-1.619 3.966 0 6.77 1.62 2.806 4.245 4.322 5.864 3.387z"
            ></path>
          </g>
          <path
            fill="url(#paint68_linear_1380_98514)"
            d="M198.044 40.777l14.287 8.264c.443.255.807-.02.807-.608V37.88a1.943 1.943 0 00-.807-1.538l-14.287-8.247c-.44-.255-.804.016-.804.608v10.535a1.94 1.94 0 00.804 1.538z"
          ></path>
          <g style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}
              fill="url(#paint69_linear_1380_98514)"
              d="M198.482 38.998l13.409 7.739v-1.005l-13.409-7.739v1.005z"
            ></path>
            <path
              style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}
              fill="url(#paint70_linear_1380_98514)"
              d="M198.482 36.939l13.409 7.739v-1.005l-13.409-7.742v1.008z"
            ></path>
            <g style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}>
              <path
                style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}
                fill="url(#paint71_linear_1380_98514)"
                d="M208.02 40.036l3.6 2.08V37.96l-3.6-2.08v4.156z"
              ></path>
              <path
                style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}
                fill="url(#paint72_linear_1380_98514)"
                d="M203.387 37.362l3.6 2.08v-4.156l-3.6-2.079v4.155z"
              ></path>
              <path
                style={{ mixBlendMode: MIX_BLEND_MODE_OVERLAY }}
                fill="url(#paint73_linear_1380_98514)"
                d="M198.756 34.688l3.6 2.079v-4.155l-3.6-2.08v4.156z"
              ></path>
            </g>
          </g>
        </g>
        <text
          fill="#344054"
          style={{ whiteSpace: 'pre' }}
          fontFamily="Manrope"
          fontSize="10"
          fontWeight="bold"
          letterSpacing=".01em"
        >
          <tspan x="158.696" y="92.83">
            Online training courses
          </tspan>
        </text>
      </g>
      <defs>
        <filter
          id="filter0_dd_1380_98514"
          width="195.641"
          height="134.341"
          x="13.211"
          y="143.505"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feMorphology in="SourceAlpha" radius="4" result="effect1_dropShadow_1380_98514"></feMorphology>
          <feOffset dx="2" dy="4"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.4 0 0 0 0 0.439216 0 0 0 0 0.521569 0 0 0 0.25 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1380_98514"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feMorphology in="SourceAlpha" radius="2" result="effect2_dropShadow_1380_98514"></feMorphology>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="3"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow_1380_98514" result="effect2_dropShadow_1380_98514"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1380_98514" result="shape"></feBlend>
        </filter>
        <filter
          id="filter1_dd_1380_98514"
          width="195.641"
          height="134.341"
          x="227.148"
          y="143.93"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feMorphology in="SourceAlpha" radius="4" result="effect1_dropShadow_1380_98514"></feMorphology>
          <feOffset dx="2" dy="4"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.4 0 0 0 0 0.439216 0 0 0 0 0.521569 0 0 0 0.25 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1380_98514"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feMorphology in="SourceAlpha" radius="2" result="effect2_dropShadow_1380_98514"></feMorphology>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="3"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow_1380_98514" result="effect2_dropShadow_1380_98514"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1380_98514" result="shape"></feBlend>
        </filter>
        <filter
          id="filter2_dd_1380_98514"
          width="195.641"
          height="134.341"
          x="120.211"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feMorphology in="SourceAlpha" radius="4" result="effect1_dropShadow_1380_98514"></feMorphology>
          <feOffset dx="2" dy="4"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.4 0 0 0 0 0.439216 0 0 0 0 0.521569 0 0 0 0.25 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1380_98514"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feMorphology in="SourceAlpha" radius="2" result="effect2_dropShadow_1380_98514"></feMorphology>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="3"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow_1380_98514" result="effect2_dropShadow_1380_98514"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow_1380_98514" result="shape"></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_1380_98514"
          x1="320.021"
          x2="380.607"
          y1="90.128"
          y2="109.495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1380_98514"
          x1="320.021"
          x2="380.607"
          y1="90.128"
          y2="109.495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1380_98514"
          x1="107.501"
          x2="-10.811"
          y1="46.375"
          y2="89.177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1380_98514"
          x1="340.32"
          x2="380.254"
          y1="67.137"
          y2="107.853"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#05121F"></stop>
          <stop offset="1" stopColor="#1C456B"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1380_98514"
          x1="392.801"
          x2="404.53"
          y1="71.225"
          y2="71.618"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#FFF3F4"></stop>
        </linearGradient>
        <radialGradient
          id="paint5_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(16.3695 0 0 8.85563 110.354 201.72)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.19" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </radialGradient>
        <radialGradient
          id="paint6_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(103.368 185.575) scale(26.3506)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.14" stopColor="#6CF"></stop>
          <stop offset="0.7" stopColor="#5277F7"></stop>
          <stop offset="0.8" stopColor="#5079F5"></stop>
          <stop offset="0.86" stopColor="#4781F0"></stop>
          <stop offset="0.91" stopColor="#398FE8"></stop>
          <stop offset="0.95" stopColor="#25A3DC"></stop>
          <stop offset="0.99" stopColor="#0BBCCC"></stop>
          <stop offset="1" stopColor="#00C7C5"></stop>
        </radialGradient>
        <radialGradient
          id="paint7_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(128.652 201.281) scale(21.6393)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.07" stopColor="#8D92B8"></stop>
          <stop offset="0.14" stopColor="#6C708D"></stop>
          <stop offset="0.22" stopColor="#4F5267"></stop>
          <stop offset="0.31" stopColor="#363947"></stop>
          <stop offset="0.4" stopColor="#22242D"></stop>
          <stop offset="0.5" stopColor="#131419"></stop>
          <stop offset="0.62" stopColor="#08090B"></stop>
          <stop offset="0.76" stopColor="#020202"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint8_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(24.8041 0 0 24.804 103.75 187.012)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.14" stopColor="#E5E9FF"></stop>
          <stop offset="0.7" stopColor="#AFB6E5"></stop>
          <stop offset="0.84" stopColor="#B1B8E6"></stop>
          <stop offset="0.92" stopColor="#BAC0EA"></stop>
          <stop offset="0.98" stopColor="#C8CDF1"></stop>
          <stop offset="1" stopColor="#CED3F4"></stop>
        </radialGradient>
        <radialGradient
          id="paint9_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(103.338 184.503) scale(9.79772)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.01" stopColor="#6CF"></stop>
          <stop offset="0.02" stopColor="#62C4F5"></stop>
          <stop offset="0.09" stopColor="#4E9BC2"></stop>
          <stop offset="0.18" stopColor="#3B7694"></stop>
          <stop offset="0.26" stopColor="#2B566C"></stop>
          <stop offset="0.35" stopColor="#1E3C4A"></stop>
          <stop offset="0.44" stopColor="#13262F"></stop>
          <stop offset="0.54" stopColor="#0A151A"></stop>
          <stop offset="0.66" stopColor="#05090B"></stop>
          <stop offset="0.79" stopColor="#010203"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint10_linear_1380_98514"
          x1="91.416"
          x2="127.973"
          y1="177.568"
          y2="205.487"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD2F3"></stop>
          <stop offset="0.25" stopColor="#E5E9FF"></stop>
          <stop offset="0.31" stopColor="#EFF2FF"></stop>
          <stop offset="0.37" stopColor="#fff"></stop>
          <stop offset="0.49" stopColor="#EBEDF9"></stop>
          <stop offset="0.72" stopColor="#B9BFE8"></stop>
          <stop offset="0.76" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#AFB6E5"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_1380_98514"
          x1="126.936"
          x2="85.954"
          y1="188.045"
          y2="197.527"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD2F3"></stop>
          <stop offset="0.25" stopColor="#E5E9FF"></stop>
          <stop offset="0.31" stopColor="#EFF2FF"></stop>
          <stop offset="0.37" stopColor="#fff"></stop>
          <stop offset="0.49" stopColor="#EBEDF9"></stop>
          <stop offset="0.72" stopColor="#B9BFE8"></stop>
          <stop offset="0.76" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#AFB6E5"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_1380_98514"
          x1="99.689"
          x2="118.336"
          y1="208.682"
          y2="173.494"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CDD2F3"></stop>
          <stop offset="0.25" stopColor="#E5E9FF"></stop>
          <stop offset="0.31" stopColor="#EFF2FF"></stop>
          <stop offset="0.37" stopColor="#fff"></stop>
          <stop offset="0.49" stopColor="#EBEDF9"></stop>
          <stop offset="0.72" stopColor="#B9BFE8"></stop>
          <stop offset="0.76" stopColor="#AFB6E5"></stop>
          <stop offset="0.91" stopColor="#AFB6E5"></stop>
          <stop offset="1" stopColor="#AFB6E5"></stop>
        </linearGradient>
        <radialGradient
          id="paint13_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(95.545 190.46) scale(1.89633)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F36DD4"></stop>
          <stop offset="0.39" stopColor="#CF6DE8"></stop>
          <stop offset="0.59" stopColor="#BB6DF3"></stop>
          <stop offset="0.73" stopColor="#A259DC"></stop>
          <stop offset="0.9" stopColor="#8A46C7"></stop>
          <stop offset="1" stopColor="#813FBF"></stop>
        </radialGradient>
        <radialGradient
          id="paint14_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(120.692 200.434) scale(1.89633)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F36DD4"></stop>
          <stop offset="0.39" stopColor="#CF6DE8"></stop>
          <stop offset="0.59" stopColor="#BB6DF3"></stop>
          <stop offset="0.73" stopColor="#A259DC"></stop>
          <stop offset="0.9" stopColor="#8A46C7"></stop>
          <stop offset="1" stopColor="#813FBF"></stop>
        </radialGradient>
        <radialGradient
          id="paint15_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="translate(98.213 173.465) scale(1.89633)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F36DD4"></stop>
          <stop offset="0.39" stopColor="#CF6DE8"></stop>
          <stop offset="0.59" stopColor="#BB6DF3"></stop>
          <stop offset="0.73" stopColor="#A259DC"></stop>
          <stop offset="0.9" stopColor="#8A46C7"></stop>
          <stop offset="1" stopColor="#813FBF"></stop>
        </radialGradient>
        <linearGradient
          id="paint16_linear_1380_98514"
          x1="296.264"
          x2="323.002"
          y1="221.982"
          y2="185.175"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.39" stopColor="#CED3F4"></stop>
          <stop offset="0.67" stopColor="#DEE2FC"></stop>
          <stop offset="0.78" stopColor="#E5E9FF"></stop>
          <stop offset="1" stopColor="#EFF1FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_1380_98514"
          x1="323.274"
          x2="305.82"
          y1="195.247"
          y2="195.247"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.49" stopColor="#01C9EC" stopOpacity="0.98"></stop>
          <stop offset="1" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_1380_98514"
          x1="312.986"
          x2="338.806"
          y1="218.001"
          y2="192.554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.39" stopColor="#CED3F4"></stop>
          <stop offset="0.67" stopColor="#DEE2FC"></stop>
          <stop offset="0.78" stopColor="#E5E9FF"></stop>
          <stop offset="1" stopColor="#EFF1FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint19_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.99538 0 0 2.01889 332.31 188.067)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint20_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(2.61769 0 0 2.64852 333.405 197.581)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint21_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(3.52103 0 0 3.56251 338 192.739)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint22_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.36937 0 0 .37372 326.728 197.426)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint23_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.49353 0 0 1.51112 328.254 187.786)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint24_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(2.1881 0 0 2.21387 340.905 200.307)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint25_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.26468 0 0 1.27958 340.388 204.507)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint26_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.55807 0 0 .56464 336.979 207.28)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint27_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.38944 0 0 .39403 332.265 205.331)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint28_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.50587 0 0 .51183 325.934 191.507)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint29_linear_1380_98514"
          x1="305.904"
          x2="340.719"
          y1="187.531"
          y2="199.465"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#01C9EC"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint30_linear_1380_98514"
          x1="331.152"
          x2="335.172"
          y1="194.762"
          y2="200.396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.47" stopColor="#D1D5F0"></stop>
          <stop offset="0.8" stopColor="#B8BEE8"></stop>
          <stop offset="0.99" stopColor="#AFB6E5"></stop>
        </linearGradient>
        <linearGradient
          id="paint31_linear_1380_98514"
          x1="321.153"
          x2="323.909"
          y1="178.513"
          y2="182.342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AFB6E5"></stop>
          <stop offset="0.47" stopColor="#D1D5F0"></stop>
          <stop offset="0.8" stopColor="#B8BEE8"></stop>
          <stop offset="0.99" stopColor="#AFB6E5"></stop>
        </linearGradient>
        <linearGradient
          id="paint32_linear_1380_98514"
          x1="305.794"
          x2="325.506"
          y1="212.051"
          y2="176.107"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9BFEA"></stop>
          <stop offset="0.39" stopColor="#CED3F4"></stop>
          <stop offset="0.67" stopColor="#DEE2FC"></stop>
          <stop offset="0.78" stopColor="#E5E9FF"></stop>
          <stop offset="1" stopColor="#EFF1FF"></stop>
        </linearGradient>
        <radialGradient
          id="paint33_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.4617 0 0 .46715 317.027 178.168)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint34_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(5.13098 0 0 5.19143 325.799 177.523)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint35_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.85085 0 0 1.87265 322.006 181.13)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint36_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.7826 0 0 1.80359 328.587 185.057)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint37_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(.69056 0 0 .69869 326.152 187.885)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <radialGradient
          id="paint38_radial_1380_98514"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(1.00773 0 0 1.0196 318.356 173.628)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1"></stop>
        </radialGradient>
        <linearGradient
          id="paint39_linear_1380_98514"
          x1="309.925"
          x2="344.74"
          y1="175.8"
          y2="187.734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C7C5"></stop>
          <stop offset="0.33" stopColor="#2D9BE0"></stop>
          <stop offset="0.63" stopColor="#5277F7"></stop>
          <stop offset="0.69" stopColor="#5B76F7"></stop>
          <stop offset="0.79" stopColor="#7374F6"></stop>
          <stop offset="0.91" stopColor="#9A70F4"></stop>
          <stop offset="1" stopColor="#BB6DF3"></stop>
        </linearGradient>
        <linearGradient
          id="paint40_linear_1380_98514"
          x1="217.507"
          x2="217.507"
          y1="153.637"
          y2="-1.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#98A2B3"></stop>
          <stop offset="1" stopColor="#F9FAFB"></stop>
        </linearGradient>
        <linearGradient
          id="paint41_linear_1380_98514"
          x1="168.037"
          x2="222.42"
          y1="48.243"
          y2="82.333"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.498" stopColor="#0197EC" stopOpacity="0.98"></stop>
          <stop offset="0.938" stopColor="#00E06C" stopOpacity="0.32"></stop>
        </linearGradient>
        <linearGradient
          id="paint42_linear_1380_98514"
          x1="210.051"
          x2="234.877"
          y1="28.73"
          y2="58.311"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint43_linear_1380_98514"
          x1="207.018"
          x2="207.018"
          y1="141.099"
          y2="28.405"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint44_linear_1380_98514"
          x1="183.32"
          x2="221.552"
          y1="67.075"
          y2="72.089"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint45_linear_1380_98514"
          x1="225.684"
          x2="205.1"
          y1="75.969"
          y2="40.903"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint46_linear_1380_98514"
          x1="228.066"
          x2="222.663"
          y1="52.859"
          y2="49.286"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint47_linear_1380_98514"
          x1="221.895"
          x2="226.319"
          y1="44.772"
          y2="44.883"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#FFF3F4"></stop>
        </linearGradient>
        <linearGradient
          id="paint48_linear_1380_98514"
          x1="217.119"
          x2="211.225"
          y1="46.746"
          y2="37.891"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint49_linear_1380_98514"
          x1="217.119"
          x2="211.231"
          y1="45.737"
          y2="36.884"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint50_linear_1380_98514"
          x1="217.119"
          x2="211.225"
          y1="44.733"
          y2="35.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint51_linear_1380_98514"
          x1="223.018"
          x2="218.414"
          y1="54.638"
          y2="52.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint52_linear_1380_98514"
          x1="215.588"
          x2="218.99"
          y1="45.135"
          y2="45.195"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#EA2127"></stop>
          <stop offset="1" stopColor="#FFF3F4"></stop>
        </linearGradient>
        <linearGradient
          id="paint53_linear_1380_98514"
          x1="215.258"
          x2="209.992"
          y1="48.538"
          y2="45.298"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFDFF" stopOpacity="0"></stop>
          <stop offset="0.12" stopColor="#FCDBE9" stopOpacity="0.16"></stop>
          <stop offset="0.37" stopColor="#FD9CC0" stopOpacity="0.45"></stop>
          <stop offset="0.59" stopColor="#FE6A9F" stopOpacity="0.69"></stop>
          <stop offset="0.77" stopColor="#FF4687" stopOpacity="0.86"></stop>
          <stop offset="0.91" stopColor="#FF2F78" stopOpacity="0.96"></stop>
          <stop offset="1" stopColor="#FF2773"></stop>
        </linearGradient>
        <linearGradient
          id="paint54_linear_1380_98514"
          x1="211.799"
          x2="215.338"
          y1="46.05"
          y2="47.281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint55_linear_1380_98514"
          x1="215.707"
          x2="210.441"
          y1="47.807"
          y2="44.571"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFDFF" stopOpacity="0"></stop>
          <stop offset="0.12" stopColor="#FCDBE9" stopOpacity="0.16"></stop>
          <stop offset="0.37" stopColor="#FD9CC0" stopOpacity="0.45"></stop>
          <stop offset="0.59" stopColor="#FE6A9F" stopOpacity="0.69"></stop>
          <stop offset="0.77" stopColor="#FF4687" stopOpacity="0.86"></stop>
          <stop offset="0.91" stopColor="#FF2F78" stopOpacity="0.96"></stop>
          <stop offset="1" stopColor="#FF2773"></stop>
        </linearGradient>
        <linearGradient
          id="paint56_linear_1380_98514"
          x1="211.799"
          x2="215.338"
          y1="45.045"
          y2="46.276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint57_linear_1380_98514"
          x1="216.157"
          x2="210.887"
          y1="47.077"
          y2="43.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFDFF" stopOpacity="0"></stop>
          <stop offset="0.12" stopColor="#FCDBE9" stopOpacity="0.16"></stop>
          <stop offset="0.37" stopColor="#FD9CC0" stopOpacity="0.45"></stop>
          <stop offset="0.59" stopColor="#FE6A9F" stopOpacity="0.69"></stop>
          <stop offset="0.77" stopColor="#FF4687" stopOpacity="0.86"></stop>
          <stop offset="0.91" stopColor="#FF2F78" stopOpacity="0.96"></stop>
          <stop offset="1" stopColor="#FF2773"></stop>
        </linearGradient>
        <linearGradient
          id="paint58_linear_1380_98514"
          x1="211.799"
          x2="215.338"
          y1="44.041"
          y2="45.271"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D3762"></stop>
          <stop offset="1" stopColor="#195893"></stop>
        </linearGradient>
        <linearGradient
          id="paint59_linear_1380_98514"
          x1="223.122"
          x2="229.079"
          y1="50.584"
          y2="54.624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFDFF" stopOpacity="0"></stop>
          <stop offset="0.12" stopColor="#FBFDD7" stopOpacity="0.16"></stop>
          <stop offset="0.37" stopColor="#F8FE8C" stopOpacity="0.45"></stop>
          <stop offset="0.59" stopColor="#F6FE50" stopOpacity="0.69"></stop>
          <stop offset="0.77" stopColor="#F5FF24" stopOpacity="0.86"></stop>
          <stop offset="0.91" stopColor="#F4FF0A" stopOpacity="0.96"></stop>
          <stop offset="1" stopColor="#F4FF00"></stop>
        </linearGradient>
        <linearGradient
          id="paint60_linear_1380_98514"
          x1="222.656"
          x2="228.613"
          y1="51.272"
          y2="55.312"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFDFF" stopOpacity="0"></stop>
          <stop offset="0.12" stopColor="#FBFDD7" stopOpacity="0.16"></stop>
          <stop offset="0.37" stopColor="#F8FE8C" stopOpacity="0.45"></stop>
          <stop offset="0.59" stopColor="#F6FE50" stopOpacity="0.69"></stop>
          <stop offset="0.77" stopColor="#F5FF24" stopOpacity="0.86"></stop>
          <stop offset="0.91" stopColor="#F4FF0A" stopOpacity="0.96"></stop>
          <stop offset="1" stopColor="#F4FF00"></stop>
        </linearGradient>
        <linearGradient
          id="paint61_linear_1380_98514"
          x1="222.186"
          x2="228.147"
          y1="51.959"
          y2="55.999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFDFF" stopOpacity="0"></stop>
          <stop offset="0.12" stopColor="#FBFDD7" stopOpacity="0.16"></stop>
          <stop offset="0.37" stopColor="#F8FE8C" stopOpacity="0.45"></stop>
          <stop offset="0.59" stopColor="#F6FE50" stopOpacity="0.69"></stop>
          <stop offset="0.77" stopColor="#F5FF24" stopOpacity="0.86"></stop>
          <stop offset="0.91" stopColor="#F4FF0A" stopOpacity="0.96"></stop>
          <stop offset="1" stopColor="#F4FF00"></stop>
        </linearGradient>
        <linearGradient
          id="paint62_linear_1380_98514"
          x1="226.56"
          x2="223.48"
          y1="53.94"
          y2="49.931"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint63_linear_1380_98514"
          x1="226.56"
          x2="223.48"
          y1="54.945"
          y2="50.936"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint64_linear_1380_98514"
          x1="226.56"
          x2="223.48"
          y1="55.95"
          y2="51.941"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#7AA5E5"></stop>
          <stop offset="1" stopColor="#F9FAFB" stopOpacity="0.35"></stop>
        </linearGradient>
        <linearGradient
          id="paint65_linear_1380_98514"
          x1="225.965"
          x2="242.037"
          y1="42.721"
          y2="70.995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.2" stopColor="#DCEAFE" stopOpacity="0.78"></stop>
          <stop offset="0.6" stopColor="#CBDBFC" stopOpacity="0.37"></stop>
          <stop offset="0.87" stopColor="#C1D2FB" stopOpacity="0.1"></stop>
          <stop offset="1" stopColor="#BDCEFA" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint66_linear_1380_98514"
          x1="224.721"
          x2="236.1"
          y1="46.641"
          y2="66.168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint67_linear_1380_98514"
          x1="227.816"
          x2="239.272"
          y1="44.913"
          y2="64.485"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint68_linear_1380_98514"
          x1="197.743"
          x2="210.797"
          y1="23.064"
          y2="50.228"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.2" stopColor="#DCEAFE" stopOpacity="0.78"></stop>
          <stop offset="0.6" stopColor="#CBDBFC" stopOpacity="0.37"></stop>
          <stop offset="0.87" stopColor="#C1D2FB" stopOpacity="0.1"></stop>
          <stop offset="1" stopColor="#BDCEFA" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint69_linear_1380_98514"
          x1="195.13"
          x2="212.539"
          y1="33.484"
          y2="48.856"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint70_linear_1380_98514"
          x1="196.152"
          x2="213.563"
          y1="32.327"
          y2="47.699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint71_linear_1380_98514"
          x1="198.829"
          x2="216.241"
          y1="29.292"
          y2="44.668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint72_linear_1380_98514"
          x1="198.127"
          x2="215.535"
          y1="30.09"
          y2="45.462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <linearGradient
          id="paint73_linear_1380_98514"
          x1="197.424"
          x2="214.835"
          y1="30.886"
          y2="46.258"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4F2FF"></stop>
          <stop offset="0.06" stopColor="#E1EFFF"></stop>
          <stop offset="0.65" stopColor="#C7D7FB"></stop>
          <stop offset="1" stopColor="#BDCEFA"></stop>
        </linearGradient>
        <clipPath id="clip0_1380_98514">
          <path fill="#fff" d="M0 0H46.987V40H0z" transform="translate(85.537 170.675)"></path>
        </clipPath>
        <clipPath id="clip1_1380_98514">
          <path fill="#fff" d="M0 0H40V40H0z" transform="translate(302.969 171.1)"></path>
        </clipPath>
        <clipPath id="clip2_1380_98514">
          <path fill="#fff" d="M0 0H52.886V50H0z" transform="translate(189.588 28)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconGithub = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <g fill="#fff" clipPath="url(#clip0_734_111807)">
        <path
          fillRule="evenodd"
          d="M16.002.667A16.057 16.057 0 005.638 4.462a15.89 15.89 0 00-5.423 9.567 15.836 15.836 0 002.101 10.782 15.986 15.986 0 008.626 6.86c.794.147 1.094-.346 1.094-.764 0-.42-.016-1.634-.021-2.962-4.451.962-5.392-1.878-5.392-1.878-.726-1.844-1.775-2.329-1.775-2.329-1.452-.985.109-.966.109-.966 1.608.113 2.453 1.64 2.453 1.64 1.425 2.432 3.744 1.729 4.655 1.318.143-1.03.56-1.73 1.018-2.129-3.556-.4-7.292-1.765-7.292-7.86a6.142 6.142 0 011.648-4.27c-.164-.401-.713-2.019.156-4.216 0 0 1.344-.427 4.401 1.63a15.27 15.27 0 018.012 0c3.055-2.057 4.396-1.63 4.396-1.63.871 2.192.323 3.81.159 4.215a6.129 6.129 0 011.65 4.276c0 6.109-3.744 7.455-7.304 7.847.572.496 1.083 1.462 1.083 2.948 0 2.129-.018 3.841-.018 4.366 0 .424.288.919 1.1.764a15.987 15.987 0 008.625-6.861 15.836 15.836 0 002.1-10.783 15.89 15.89 0 00-5.425-9.568A16.057 16.057 0 0016.007.667h-.005z"
          clipRule="evenodd"
        ></path>
        <path d="M6.058 23.51c-.034.078-.162.102-.265.047-.103-.056-.18-.158-.143-.24.037-.082.162-.103.265-.047.103.055.183.16.143.24zM6.707 24.228a.267.267 0 01-.329-.073c-.103-.111-.124-.264-.045-.332.08-.069.223-.037.326.073.104.111.127.264.048.332zM7.337 25.143c-.098.068-.265 0-.357-.137a.263.263 0 010-.38c.098-.066.264 0 .357.135.093.134.096.313 0 .382zM8.195 26.028c-.087.098-.264.071-.41-.06-.146-.132-.18-.311-.093-.406.087-.095.265-.069.416.06.151.13.18.311.087.406zM9.394 26.544c-.04.124-.22.18-.4.127-.18-.053-.3-.2-.265-.327.034-.127.217-.185.4-.127.182.058.299.198.265.327zM10.702 26.634c0 .129-.149.24-.34.242-.19.003-.346-.103-.346-.232s.148-.24.339-.242c.19-.003.347.1.347.232zM11.922 26.43c.024.13-.109.264-.3.296-.19.032-.357-.045-.381-.171-.024-.127.114-.264.3-.298.185-.034.357.045.38.174z"></path>
      </g>
      <defs>
        <clipPath id="clip0_734_111807">
          <path fill="#fff" d="M0 0H32V32H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconPushPin = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      style={{ verticalAlign: 'text-bottom' }}
    >
      <path
        fill="#344054"
        fillRule="evenodd"
        d="M19 12.87c0-.47-.34-.85-.8-.98A2.997 2.997 0 0116 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.38-.93 2.54-2.2 2.89-.46.13-.8.51-.8.98V13c0 .55.45 1 1 1h4.98l.02 7c0 .55.45 1 1 1s1-.45 1-1l-.02-7H18c.55 0 1-.45 1-1v-.13z"
        clipRule="evenodd"
      ></path>
    </svg>
  </span>
);

export const IconArrowDownGradient = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="40" fill="none" viewBox="0 0 26 40">
      <path
        fill="url(#paint0_linear_482_29988)"
        d="M13.27 39.022l12.515-16.613h-7.06V.293H7.816v22.116H.757L13.27 39.022z"
      ></path>
      <path
        fill="#fff"
        d="M12.829 1.673a.37.37 0 10.74 0h-.74zm.74 2.76a.37.37 0 00-.74 0h.74zm-.74 2.759a.37.37 0 10.74 0h-.74zm.74 2.759a.37.37 0 00-.74 0h.74zm-.74 2.76a.37.37 0 10.74 0h-.74zm.74 2.759a.37.37 0 00-.74 0h.74zm-.74 2.76a.37.37 0 00.74 0h-.74zm.74 2.759a.37.37 0 00-.74 0h.74zM12.83.293v1.38h.74V.293h-.74zm0 4.14v2.759h.74v-2.76h-.74zm0 5.518v2.76h.74V9.95h-.74zm0 5.519v2.76h.74v-2.76h-.74zm0 5.519v1.38h.74v-1.38h-.74z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_482_29988"
          x1="13.342"
          x2="13.342"
          y1="36.87"
          y2="-4.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.006" stopColor="#0FC3EA"></stop>
          <stop offset="1" stopColor="#F5FBFE" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
  </span>
);

export const IconLocation = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#fff"
        d="M12 2.161c-4.2 0-8 3.22-8 8.2 0 3.18 2.45 6.92 7.34 11.23.38.33.95.33 1.33 0 4.88-4.31 7.33-8.05 7.33-11.23 0-4.98-3.8-8.2-8-8.2zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
      ></path>
    </svg>
  </span>
);

export const IconPerson = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#344054"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
      ></path>
    </svg>
  </span>
);

export const IconMail = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="none" viewBox="0 0 20 16">
      <path
        fill="#fff"
        d="M18 0H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-.4 4.25l-6.54 4.09c-.65.41-1.47.41-2.12 0L2.4 4.25a.85.85 0 11.9-1.44L10 7l6.7-4.19a.85.85 0 11.9 1.44z"
      ></path>
    </svg>
  </span>
);

export const GroupIcon = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="176" height="72" fill="none" viewBox="0 0 176 72">
      <rect width="176" height="72" fill="#F2F2F2" rx="20"></rect>
      <path
        fill="#000"
        d="M20 43.628V28.372A8.394 8.394 0 0128.372 20h15.256A8.394 8.394 0 0152 28.372v15.256A8.394 8.394 0 0143.628 52h-5.122l-2.692-.657-2.31.657h-5.132A8.394 8.394 0 0120 43.628z"
      ></path>
      <path
        fill="#fff"
        d="M42.227 41.155l.755-4.63h-4.476v-2.998a2.31 2.31 0 012.605-2.495h2.013v-3.94c-1.183-.195-2.38-.3-3.578-.318-3.655 0-6.041 2.19-6.041 6.227v3.524h-4.071v4.63h4.07V52h5.002V41.155h3.721z"
      ></path>
      <path
        fill="#000"
        d="M104 43.628V28.372A8.372 8.372 0 0095.628 20H80.372A8.372 8.372 0 0072 28.372v15.256A8.372 8.372 0 0080.372 52h15.256A8.372 8.372 0 00104 43.628z"
      ></path>
      <path
        fill="#fff"
        d="M81.29 33.023h3.098v9.959h-3.097v-9.96zm1.555-4.947a1.795 1.795 0 11-.022 3.59 1.795 1.795 0 01.022-3.59zM86.336 33.023h2.966v1.357a3.284 3.284 0 012.933-1.609c3.14 0 3.71 2.069 3.71 4.75v5.472H92.89v-4.86c0-1.148 0-2.637-1.608-2.637-1.61 0-1.86 1.259-1.86 2.561v4.925h-3.087v-9.959z"
      ></path>
      <path
        fill="#000"
        d="M156 43.628V28.372A8.372 8.372 0 00147.628 20h-15.256A8.372 8.372 0 00124 28.372v15.256A8.372 8.372 0 00132.372 52h15.256A8.372 8.372 0 00156 43.628z"
      ></path>
      <path
        fill="#fff"
        d="M145.341 30.944h-2.955a.988.988 0 00-.985.985c0 .542.443.985.985.985h2.955a2.964 2.964 0 012.955 2.955 2.964 2.964 0 01-2.955 2.955h-2.955a.988.988 0 00-.985.985c0 .542.443.985.985.985h2.955a4.926 4.926 0 004.924-4.925 4.926 4.926 0 00-4.924-4.925zm-8.865 4.925c0 .542.443.985.985.985h5.91a.988.988 0 00.985-.985.988.988 0 00-.985-.985h-5.91a.988.988 0 00-.985.985zm1.97 2.955h-2.955a2.964 2.964 0 01-2.955-2.955 2.964 2.964 0 012.955-2.955h2.955a.988.988 0 00.985-.985.988.988 0 00-.985-.985h-2.955a4.927 4.927 0 00-4.925 4.925 4.927 4.927 0 004.925 4.925h2.955a.988.988 0 00.985-.985.988.988 0 00-.985-.985z"
      ></path>
    </svg>
  </span>
);

export const IconSpeaker = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="26" fill="none" viewBox="0 0 32 26">
      <path
        fill="#fff"
        d="M0 11.348c.032-.161.066-.322.099-.482.344-1.54 1.557-2.646 3.134-2.772.793-.066 1.6-.012 2.419-.012v9.864c-.27 0-.53.006-.794 0-.67-.021-1.355.03-2.008-.09-1.536-.286-2.634-1.554-2.802-3.11A2.01 2.01 0 000 14.523v-3.175zM7.09 17.951V8.087c.756-.126 1.509-.217 2.245-.38 2.791-.623 5.152-2.01 7.09-4.11.59-.64 1.162-1.298 1.771-1.918.685-.7 1.509-.86 2.357-.483.88.397 1.342 1.065 1.342 2.051-.002 6.505-.002 13.01 0 19.514 0 .958-.5 1.71-1.368 2.066-.846.347-1.691.179-2.36-.513-.56-.578-1.085-1.19-1.628-1.783-2.406-2.631-5.368-4.161-8.926-4.512-.165-.02-.328-.044-.523-.068zM2.145 19.16c1.401.347 2.796.113 4.19.21.014.04.023.08.028.122 0 1.145.013 2.292-.005 3.44-.013.812-.371 1.45-1.116 1.81-.762.369-1.522.317-2.23-.151-.566-.374-.847-.935-.86-1.594-.025-1.268-.007-2.534-.007-3.837zM28.256 13.712c-.682 0-1.364.007-2.046-.003-.518-.008-.802-.31-.763-.78.034-.406.296-.632.774-.636.88-.008 1.76 0 2.64 0 .495 0 .992-.005 1.485.004.297.006.58.124.636.424.044.234.017.548-.113.727-.112.158-.411.242-.633.252-.659.033-1.32.012-1.98.012zM24.725 18.773c0-.4.123-.621.385-.747.286-.137.562-.1.793.12.381.365.751.742 1.125 1.114.327.326.658.648.976.982.318.334.321.722.014 1.018-.295.285-.678.29-.997-.022-.7-.684-1.391-1.377-2.073-2.078-.123-.125-.182-.311-.223-.387zM25.427 8.1c-.307-.05-.505-.186-.623-.436s-.132-.512.059-.712a94.655 94.655 0 012.263-2.26c.264-.255.672-.198.926.066.264.279.276.676-.014.98-.518.54-1.053 1.058-1.581 1.587-.172.171-.33.36-.52.506-.15.12-.337.183-.51.27z"
      ></path>
    </svg>
  </span>
);

export const IconSearch = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#667085"
        d="M11.316 10.06h-.659l-.233-.225a5.417 5.417 0 001.233-4.45C11.266 3.068 9.332 1.218 7 .935A5.42 5.42 0 00.941 6.993c.283 2.333 2.133 4.267 4.45 4.658a5.417 5.417 0 004.45-1.233l.225.233v.659l3.541 3.541a.88.88 0 001.242 0 .88.88 0 000-1.241l-3.533-3.55zm-5 0a3.745 3.745 0 01-3.75-3.75 3.745 3.745 0 013.75-3.75 3.745 3.745 0 013.75 3.75 3.745 3.745 0 01-3.75 3.75z"
      ></path>
    </svg>
  </span>
);

/* icon nav */
export const IconNavInsights = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#101828"
        d="M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm17-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm-4 4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm4-8h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
      ></path>
    </svg>
  </span>
);

export const IconNavEvent = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#101828"
        d="M16 13h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0-10v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V3c0-.55-.45-1-1-1s-1 .45-1 1zm2 17H6c-.55 0-1-.45-1-1V9h14v10c0 .55-.45 1-1 1z"
      ></path>
    </svg>
  </span>
);

export const IconNavSuccessStories = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#101828"
        d="M19 5h-2V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"
      ></path>
    </svg>
  </span>
);

// mobile
export const IconArrowForwardMobile = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" fill="none" viewBox="0 0 10 16">
      <path
        fill="#101828"
        d="M.832 15.512a1.041 1.041 0 001.475 0l6.925-6.925a.83.83 0 000-1.175L2.307.487a1.041 1.041 0 00-1.475 0 1.041 1.041 0 000 1.475l6.033 6.042-6.042 6.042c-.4.4-.4 1.066.009 1.466z"
      ></path>
    </svg>
  </span>
);

export const IconArrowBackMobile = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#101828"
        d="M14.168 2.487a1.041 1.041 0 00-1.475 0L5.768 9.412a.83.83 0 000 1.175l6.925 6.925a1.041 1.041 0 001.475 0 1.041 1.041 0 000-1.475L8.135 9.996l6.042-6.042c.4-.4.4-1.067-.009-1.467z"
      ></path>
    </svg>
  </span>
);

/* mobile logo products menu icon */
export const IconLogoStudioMobile = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 137.05 146.4">
      <g fill="#101828">
        <path d="M130.97 42.94c-5.58.35-11.15.73-16.73 1.13-3.38.24-5.57 2.75-5.36 6.05.22 3.33 2.69 5.53 6.07 5.34 2.79-.16 5.58-.37 8.36-.56 2.79-.19 5.58-.36 8.36-.57 3.39-.26 5.57-2.75 5.36-6.05-.22-3.34-2.68-5.55-6.06-5.34zM79.07 23.98c0 .12.02.23.03.35.31 3.22 2.84 5.34 6.1 5.11 3.23-.23 5.47-2.71 5.28-5.95-.34-5.64-.73-11.27-1.14-16.9-.25-3.37-2.77-5.52-6.11-5.29-3.31.23-5.47 2.73-5.28 6.12.16 2.73.36 5.46.55 8.19l.57 8.36zM112.09 31.38c3.38-3.77 6.68-7.62 10-11.44 1.11-1.28 1.73-2.75 1.51-4.51-.23-2.42-1.43-4.19-3.76-4.96-2.49-.82-4.73-.21-6.49 1.78-3.35 3.8-6.7 7.6-9.99 11.45-2.29 2.68-2.11 6.34.3 8.46 2.4 2.12 6.09 1.83 8.43-.78zM114.48 68.23c-2.59-2.2-6.25-1.94-8.32.43-2.07 2.37-1.84 6.03.68 8.31 3.85 3.47 7.78 6.85 11.71 10.23 1.24 1.07 2.69 1.61 3.9 1.44 2.84-.24 4.56-1.44 5.36-3.66.88-2.46.37-4.75-1.61-6.53-3.87-3.45-7.76-6.87-11.71-10.22zM47.26 24.97c3.85 3.39 7.68 6.79 11.59 10.1 2.61 2.21 6.24 1.97 8.33-.39 2.13-2.4 1.82-6.07-.76-8.43-1.85-1.69-3.76-3.31-5.65-4.95-2.06-1.8-4.09-3.65-6.22-5.36-1.96-1.58-4.21-1.69-6.4-.56-2.16 1.12-3.12 3.04-2.92 5.88.01 1.3.81 2.63 2.03 3.71zM84.49 45.29c-.16.07-76 36.83-76.17 36.91-17.72 9.39-2.73 35.1 14.15 24.37l48.78-31.25-20.45 54.71c-.14.38-.27.79-.38 1.2-3.66 15.69 19.18 21.59 23.61 6.14l21.58-82.95c1.85-6.25-5.29-12.21-11.13-9.13z"></path>
      </g>
      <g fill="#101828">
        <path d="M130.63 41.66c-5.58.35-11.15.73-16.73 1.13-3.38.24-5.57 2.75-5.36 6.05.22 3.33 2.69 5.53 6.07 5.34 2.79-.16 5.58-.37 8.36-.56 2.79-.19 5.58-.36 8.36-.57 3.39-.26 5.57-2.75 5.36-6.05-.22-3.34-2.68-5.55-6.06-5.34zM78.73 22.7c0 .12.02.23.03.35.31 3.22 2.84 5.34 6.1 5.11 3.23-.23 5.47-2.71 5.28-5.95-.34-5.64-.73-11.27-1.14-16.9-.25-3.37-2.77-5.52-6.11-5.29-3.31.23-5.47 2.73-5.28 6.12.16 2.73.36 5.46.55 8.19l.57 8.36zM111.75 30.1c3.38-3.77 6.68-7.62 10-11.44 1.11-1.28 1.73-2.75 1.51-4.51-.23-2.42-1.43-4.19-3.76-4.96-2.49-.82-4.73-.21-6.49 1.78-3.35 3.8-6.7 7.6-9.99 11.45-2.29 2.68-2.11 6.34.3 8.46 2.4 2.12 6.09 1.83 8.43-.78zM114.13 66.95c-2.59-2.2-6.25-1.94-8.32.43-2.07 2.37-1.84 6.03.68 8.31 3.85 3.47 7.78 6.85 11.71 10.23 1.24 1.07 2.69 1.61 3.9 1.44 2.84-.24 4.56-1.44 5.36-3.66.88-2.46.37-4.75-1.61-6.53-3.87-3.45-7.76-6.87-11.71-10.22zM46.91 23.69c3.85 3.39 7.68 6.79 11.59 10.1 2.61 2.21 6.24 1.97 8.33-.39 2.13-2.4 1.82-6.07-.76-8.43-1.85-1.69-3.76-3.31-5.65-4.95-2.06-1.8-4.09-3.65-6.22-5.36-1.96-1.58-4.21-1.69-6.4-.56-2.16 1.12-3.12 3.04-2.92 5.88.01 1.3.81 2.63 2.03 3.71zM84.14 44c-.16.07-76 36.83-76.17 36.91-17.72 9.39-2.73 35.1 14.15 24.37L70.9 74.03l-20.45 54.71c-.14.38-.27.79-.38 1.2-3.66 15.69 19.18 21.59 23.61 6.14l21.58-82.95c1.85-6.25-5.29-12.21-11.13-9.13z"></path>
      </g>
    </svg>
  </span>
);

export const IconLogoTestEngineMobile = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 138.2 154.69">
      <path
        fill="#101828"
        d="M132.78 97.96L96.12 81.88c-2.41-1.06-5.15-.96-7.52.29-4.44 2.34-6.41 8.11-4.44 12.74l16.72 44.13.05.12c.95 2.25 2.76 3.93 4.97 4.61.76.23 1.53.35 2.29.35 3.75 0 7.32-2.71 8.71-6.91.77-2.33.74-4.78-.01-6.67l-6.24-20.11c-.06-.15-.09-.44.02-.77.05-.14.11-.25.16-.32l14.27 7.41 1.55.66c1.85.54 3.85.38 5.68-.48 2.44-1.15 4.36-3.43 5.27-6.27 1.66-5.18-.45-10.75-4.82-12.7zM89.57 72.98a8.9 8.9 0 003.11.57c1.26 0 2.49-.28 3.6-.82l37.19-16.3.14-.07c1.9-.93 3.34-2.64 4.07-4.81 1.47-4.35-.22-9.34-3.94-11.6-2.12-1.29-4.59-1.49-6.47-.66l-16.72 5.61c-.25-.14-.5-.78-.44-.97l8.32-18.1c1.8-4.87-.22-10.93-4.6-13.79-2.38-1.56-5.19-1.98-7.72-1.16-2.49.81-4.5 2.77-5.51 5.4L84.02 59.97c-.93 2.42-.89 5.2.11 7.63 1.04 2.51 3.02 4.48 5.43 5.39zM8.12 48.48l53 23.67c1.27.57 2.63.86 3.99.86s2.71-.29 3.96-.87c4.79-2.21 6.95-8.1 4.87-13.01L54.26 7.42l-.04-.1a12.16 12.16 0 00-5.08-5.78C46.45-.02 43.32-.42 40.57.46c-2.5.81-4.47 2.57-5.54 4.95-1.13 2.5-1.13 5.5-.08 8.01l8.61 25.52c.14.35.16.7.05.97-.03.07-.12.29-.43.4-.3.11-.69.08-.84.02L18.99 26.77l-1.43-.72c-3.14-1.31-6.64-1.45-9.73-.37-3.02 1.05-5.41 3.17-6.73 5.97-1.33 2.82-1.45 6.04-.34 9.08 1.24 3.38 3.92 6.2 7.36 7.75zM68.1 82.11c-2.47-.9-5.14-.75-7.41.38L7.15 106.46l-.11.05c-2.63 1.29-4.71 3.43-5.85 6.04-1.23 2.84-1.21 6.01.07 8.69 1.27 2.67 3.7 4.68 6.65 5.51 2.86.81 5.95.49 8.5-.8l26.18-11.13c.35-.18.73-.23 1.02-.12.2.07.34.18.42.37.12.27.11.61.08.72l-11.7 24.2v.19c-1.02 3.06-.83 6.29.56 8.97 1.38 2.66 3.77 4.52 6.73 5.23.87.21 1.75.31 2.62.31 5.13 0 10.15-3.43 12.15-8.65l19.3-50.86c.97-2.54.92-5.4-.15-7.84-1.08-2.47-3.03-4.32-5.52-5.23z"
      ></path>
    </svg>
  </span>
);

export const IconLogoTestManagementMobile = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 160.59 172.76">
      <path
        fill="#101828"
        d="M77.91 37.99c-.78-1.41-2.2-2.63-3.92-3.37-3.42-1.47-7.08-.68-8.15 1.78l-41.06 97.79c-1 2.49.99 5.65 4.44 7.07 1.74.71 3.6.87 5.15.44l83.38-15.71c2.12-.59 3.37-2.01 3.66-3.72 1.02-1.4 1.15-3.29.09-5.22L77.91 37.99zm14.05 71.54l-29.56 4.93c-1.42.4-3.26-.3-4.12-1.56-.42-.62-.53-1.29-.33-1.85L72.54 76.3c.26-.55.82-.93 1.55-1.07 1.5-.27 3.28.55 4 1.84l15.28 29.08c.73 1.32.03 2.98-1.42 3.38zM62.83 28.45c7.54 3.16 16.21-.38 19.37-7.92s-.38-16.21-7.92-19.37-16.21.38-19.37 7.92.38 16.21 7.92 19.37zM151.51 125.07c-7.54-3.16-16.21.38-19.37 7.92s.38 16.21 7.92 19.37 16.21-.38 19.37-7.92-.38-16.21-7.92-19.37zM20.53 144.31c-7.54-3.16-16.21.38-19.37 7.92s.38 16.21 7.92 19.37 16.21-.38 19.37-7.92-.38-16.21-7.92-19.37z"
      ></path>
    </svg>
  </span>
);

export const IconLogoDeviceFarmMobile = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 102.15 153.14">
      <path
        fill="#101828"
        d="M41.6 97.46c0 7.56 6.13 13.68 13.68 13.68s13.68-6.13 13.68-13.68-6.13-13.68-13.68-13.68S41.6 89.91 41.6 97.46z"
      ></path>
      <path
        fill="#101828"
        d="M73.96 19.04C86.49 17.56 84.76-.8 72.21.03L10.36 5.7c-4.78.46-8.59 4.45-8.67 9.36.02.07-1.72 111.19-1.69 111.25.18 15.08 22.31 14.99 22.47 0V23.91c17.07-1.57 51.49-4.87 51.49-4.87zM83.06 33.07v92.98c-14.43 1.81-43.08 5.43-43.66 5.47-14.1 2.89-10.37 23.62 3.82 21.46.2-.1 50.91-8.98 51.06-9.1a9.54 9.54 0 007.86-9.39V33.07c-.32-12.63-18.8-12.54-19.09 0z"
      ></path>
    </svg>
  </span>
);

// icon ads page

export const IconAdsProduct = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="407" height="432" fill="none" viewBox="0 0 407 432">
      <path
        fill="#fff"
        fillOpacity="0.1"
        d="M388.478 123.753a5613.057 5613.057 0 00-49.752 3.357c-10.051.713-16.564 8.17-15.939 17.973.654 9.893 7.999 16.429 18.051 15.864 8.297-.475 16.594-1.099 24.861-1.663 8.297-.565 16.594-1.07 24.861-1.694 10.081-.772 16.564-8.169 15.94-17.973-.655-9.922-7.97-16.488-18.022-15.864zM234.138 67.427c0 .356.059.683.089 1.04.922 9.566 8.445 15.864 18.14 15.18 9.606-.683 16.267-8.05 15.702-17.676-1.011-16.755-2.171-33.48-3.39-50.206-.744-10.011-8.238-16.398-18.17-15.715-9.844.683-16.267 8.11-15.702 18.181.476 8.11 1.071 16.22 1.636 24.33.565 8.29 1.13 16.578 1.695 24.836v.03zM332.333 89.41c10.052-11.2 19.866-22.637 29.739-33.985 3.301-3.803 5.144-8.17 4.49-13.398-.684-7.19-4.252-12.448-11.181-14.735-7.405-2.436-14.067-.624-19.301 5.288-9.962 11.289-19.924 22.578-29.708 34.015-6.81 7.962-6.275 18.835.892 25.133 7.137 6.298 18.111 5.436 25.069-2.317zM339.411 198.883c-7.702-6.535-18.586-5.763-24.742 1.278-6.156 7.04-5.472 17.913 2.022 24.687 11.449 10.308 23.137 20.35 34.824 30.391 3.687 3.179 7.999 4.783 11.598 4.278 8.445-.713 13.56-4.278 15.939-10.873 2.617-7.308 1.101-14.111-4.788-19.399-11.508-10.25-23.076-20.41-34.823-30.362h-.03zM139.51 70.368c11.449 10.07 22.839 20.171 34.466 30.005 7.762 6.565 18.557 5.852 24.772-1.159 6.334-7.13 5.412-18.033-2.26-25.044-5.502-5.02-11.182-9.833-16.802-14.705-6.126-5.347-12.163-10.843-18.497-15.923-5.829-4.694-12.52-5.02-19.033-1.664-6.423 3.327-9.278 9.031-8.683 17.468.03 3.862 2.409 7.813 6.037 11.022zM250.225 130.705c-.476.207-226.01 109.413-226.516 109.651-52.696 27.895-8.118 104.274 42.08 72.397l145.063-92.836-60.815 162.531a41.74 41.74 0 00-1.13 3.565c-10.884 46.611 57.038 64.139 70.212 18.24l64.175-246.425c5.502-18.568-15.732-36.273-33.099-27.123h.03z"
      ></path>
    </svg>
  </span>
);

export const IconUsers = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" fill="none" viewBox="0 0 49 48">
      <g fill="#EA2127" clipPath="url(#clip0_751_546)">
        <path d="M33.088 23.846H16.272a.696.696 0 01-.703-.703v-4.134c0-2.7 2.447-4.864 5.512-4.864.14 0 .337.056.45.196.815.732 1.912 1.125 3.12 1.125 1.21 0 2.307-.393 3.122-1.125a.617.617 0 01.478-.196c3.037 0 5.54 2.165 5.54 4.864v4.19a.684.684 0 01-.703.647zm-16.169-1.35h15.466v-3.515c0-1.828-1.8-3.402-3.937-3.515-1.04.844-2.39 1.322-3.824 1.322-1.434 0-2.784-.478-3.824-1.322-2.166.113-3.909 1.687-3.909 3.515v3.515h.028zM28.673 8.717c-.056 0-.112 0-.197-.056-.253-.056-.45-.31-.45-.59-.168-1.434-1.152-2.166-1.687-2.447-.9.984-1.912 1.49-2.924 1.519-.816.056-1.49-.282-1.968-.535-.31.619-.253 1.238-.253 1.294 0 .31-.17.534-.45.647-.253.112-.563 0-.76-.197-.675-.816-1.153-3.15-.703-5.034.31-1.321.956-2.333 1.997-2.812C22.6-.168 24.455-.168 26.17.422c1.687.59 2.98 1.687 3.683 3.121 1.238 2.615-.534 4.865-.618 4.978-.17.112-.366.196-.563.196zm-2.559-4.583c.057 0 .113 0 .197.056.056.028 1.603.506 2.503 2.025a3.33 3.33 0 00-.197-2.11c-.562-1.096-1.575-1.968-2.896-2.418-1.378-.478-2.897-.478-3.88 0-.62.31-1.041.928-1.266 1.913-.169.646-.169 1.35-.084 1.996.112-.169.224-.281.337-.45a.75.75 0 01.506-.197c.197 0 .366.085.506.253 0 0 .647.647 1.547.62.73-.029 1.462-.507 2.221-1.407a.628.628 0 01.506-.281z"></path>
        <path d="M24.596 14.088c-3.29 0-4.809-3.655-4.809-6.158v-.225c0-.394.31-.675.703-.675a.69.69 0 01.703.675v.225c0 2.025 1.153 4.809 3.43 4.809 2.222 0 3.403-2.784 3.403-4.809v-.084c0-.394.31-.647.703-.647.394 0 .703.31.703.647v.084c-.084 2.503-1.603 6.158-4.836 6.158z"></path>
        <path d="M21.081 15.466c-.084 0-.197 0-.28-.028-.366-.168-.507-.562-.366-.9.14-.252.28-.478.45-.703.309-.393.618-.871.618-1.405 0-.394.337-.703.703-.675.394 0 .647.309.647.703-.028.984-.535 1.687-.872 2.193-.14.14-.253.337-.281.422-.084.225-.366.393-.619.393zM28.223 15.466c-.28 0-.506-.169-.646-.422-.028-.14-.169-.365-.338-.59-.422-.675-1.012-1.49-.815-2.39.084-.338.45-.591.815-.507.338.085.59.478.506.816-.084.281.366.956.619 1.293.197.281.394.535.478.816a.684.684 0 01-.394.9c-.028.084-.168.084-.225.084zM20.237 47.804H3.422a.696.696 0 01-.703-.703v-4.218c0-2.671 2.502-4.893 5.54-4.893.168 0 .365.085.477.197.816.76 1.912 1.125 3.122 1.125 1.209 0 2.305-.366 3.12-1.125a.678.678 0 01.479-.197c3.037.056 5.483 2.222 5.483 4.893v4.218c-.028.394-.337.703-.703.703zm-16.14-1.378h15.437v-3.515c0-1.828-1.715-3.402-3.88-3.515-1.069.872-2.39 1.322-3.853 1.322-1.434 0-2.755-.45-3.824-1.322-2.165.113-3.937 1.687-3.937 3.515v3.515h.057zM15.879 32.62c-.084 0-.112 0-.197-.057-.281-.084-.478-.31-.478-.59-.14-1.435-1.125-2.138-1.659-2.447-.956.984-1.912 1.49-2.98 1.518-.816.029-1.49-.28-1.913-.534-.309.619-.28 1.237-.28 1.237 0 .31-.141.591-.423.675a.697.697 0 01-.787-.197c-.647-.843-1.125-3.12-.731-5.005.31-1.378 1.012-2.334 2.024-2.84 1.294-.675 3.178-.703 4.893-.14 1.716.59 3.037 1.715 3.712 3.177 1.237 2.615-.562 4.837-.647 4.921a.643.643 0 01-.534.281zm-2.587-4.584c.084 0 .113 0 .197.028.084.056 1.603.534 2.502 2.053.17-.59.17-1.35-.196-2.081-.535-1.125-1.547-1.997-2.925-2.447-1.378-.478-2.84-.45-3.824.028-.675.31-1.097.985-1.293 1.913a5.064 5.064 0 00-.085 1.94c.113-.14.197-.253.366-.422a.75.75 0 01.506-.197c.197 0 .337.085.506.253 0 0 .619.647 1.547.619.759-.056 1.546-.506 2.277-1.406.028-.197.225-.281.422-.281z"></path>
        <path d="M11.745 37.99c-2.924 0-4.78-3.205-4.78-6.158v-.253c0-.366.31-.703.703-.703.394 0 .703.337.703.703v.253c0 1.94 1.096 4.809 3.402 4.809 2.334 0 3.43-2.869 3.43-4.809v-.084c0-.394.31-.703.704-.703.393 0 .703.309.703.703v.084c-.113 2.53-1.603 6.158-4.865 6.158z"></path>
        <path d="M8.258 39.368c-.084 0-.14 0-.225-.057-.366-.14-.506-.534-.394-.9.085-.224.282-.45.422-.702.31-.422.619-.872.675-1.434 0-.394.337-.675.703-.675.394 0 .647.365.647.703-.028.956-.534 1.659-.9 2.165a1.83 1.83 0 00-.253.422.716.716 0 01-.675.478zM15.4 39.368a.725.725 0 01-.618-.394c-.084-.112-.197-.366-.337-.562-.478-.647-1.069-1.519-.872-2.419.084-.337.478-.562.816-.506.365.084.59.45.506.816-.085.337.365.956.618 1.35.197.252.366.505.478.759a.66.66 0 01-.337.9c-.056.056-.169.056-.253.056zM45.91 48H29.123a.696.696 0 01-.703-.702v-4.19c0-2.7 2.446-4.865 5.483-4.865.169 0 .366.056.478.169.816.76 1.912 1.153 3.121 1.153 1.21 0 2.306-.394 3.122-1.153.112-.113.281-.169.478-.169 3.037 0 5.511 2.165 5.511 4.865v4.19c0 .393-.31.703-.703.703zm-16.14-1.377h15.465v-3.515c0-1.884-1.715-3.43-3.908-3.515-1.04.872-2.362 1.321-3.825 1.321-1.434 0-2.755-.45-3.824-1.321-2.193.112-3.908 1.63-3.908 3.515v3.515zM41.523 32.844c-.084 0-.112 0-.197-.056a.6.6 0 01-.45-.562c-.168-1.463-1.152-2.166-1.686-2.475-.928.984-1.913 1.49-2.981 1.518a3.78 3.78 0 01-1.94-.534c-.31.59-.282 1.238-.282 1.238 0 .309-.14.59-.422.674a.696.696 0 01-.787-.196c-.646-.816-1.125-3.094-.73-5.006.28-1.35.955-2.362 2.024-2.896 1.293-.647 3.205-.647 4.892-.056 1.66.59 2.981 1.659 3.684 3.121 1.265 2.615-.534 4.837-.619 4.949a.564.564 0 01-.506.281zm-2.559-4.583c.057 0 .113 0 .197.056.057.028 1.575.506 2.475 2.025.169-.59.169-1.322-.197-2.11-.534-1.096-1.547-1.94-2.868-2.418-1.378-.478-2.896-.478-3.88.029-.647.309-1.097.984-1.294 1.968-.14.619-.14 1.322-.056 1.912.112-.169.224-.281.337-.422.113-.14.31-.197.506-.197a.61.61 0 01.506.225s.619.647 1.575.619c.731-.028 1.518-.506 2.25-1.406.056-.197.253-.281.45-.281z"></path>
        <path d="M37.39 38.243c-2.925 0-4.752-3.206-4.752-6.186v-.225c0-.394.309-.703.703-.703.365 0 .703.31.703.703v.225c0 1.968 1.068 4.808 3.374 4.808 2.362 0 3.459-2.84 3.459-4.808v-.085c0-.393.309-.703.703-.703.393 0 .703.31.703.704v.084c-.085 2.53-1.603 6.186-4.893 6.186z"></path>
        <path d="M33.903 39.593c-.056 0-.14 0-.225-.029a.666.666 0 01-.394-.871c.084-.282.281-.506.478-.788.281-.365.619-.843.619-1.35 0-.393.31-.702.703-.674.393 0 .675.309.675.703-.056.956-.507 1.659-.9 2.165-.113.14-.253.337-.281.422a.737.737 0 01-.675.422zM41.074 39.593a.715.715 0 01-.647-.394 4.96 4.96 0 00-.338-.534c-.478-.675-1.068-1.519-.871-2.419a.678.678 0 01.815-.506c.366.057.59.422.534.816-.084.31.338.928.619 1.321.197.282.337.507.45.788.169.337 0 .73-.338.9-.028 0-.112.028-.224.028z"></path>
      </g>
      <defs>
        <clipPath id="clip0_751_546">
          <path fill="#fff" d="M0 0H48V48H0z" transform="translate(.666)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconGroupPeople = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 48 48">
      <g fill="#EA2127" clipPath="url(#clip0_751_602)">
        <path d="M16.703 23.592H.675a.696.696 0 01-.703-.703v-2.222a5.832 5.832 0 015.82-5.82c.394 0 .703.309.703.703 0 .393-.309.759-.703.759a4.434 4.434 0 00-4.442 4.443v1.518H16v-1.518c0-2.39-1.912-4.387-4.303-4.443-.393 0-.674-.31-.674-.703 0-.394.309-.675.703-.675 3.093.084 5.623 2.7 5.623 5.82v2.222c.057.366-.28.619-.646.619z"></path>
        <path d="M8.773 19.43a.808.808 0 01-.506-.197l-2.98-3.177c-.282-.253-.226-.703.027-.956.281-.281.703-.253.984.028l2.503 2.615 2.503-2.615a.705.705 0 01.984-.028.728.728 0 01.028.956l-2.953 3.177c-.196.113-.393.197-.59.197z"></path>
        <path d="M5.793 16.309a.696.696 0 01-.703-.703v-2.278c0-.394.31-.703.703-.703.393 0 .703.31.703.703v2.278c0 .393-.31.703-.703.703zM4.865 11.247h-.056c-.366-.028-.76-.225-1.04-.534-.676-.815-.872-2.587-.591-5.258.112-1.153.984-1.463 1.265-1.575.366-.169.731-.225.956-.31.45-.112.619-.168 1.097-.674.31-.338.76-.816 1.378-.844 2.755-.253 5.933.844 6.242 3.234.31 2.84.113 4.555-.59 5.399-.281.31-.619.506-1.04.534-.197 0-.366-.028-.507-.14-.168-.141-.253-.338-.253-.478-.028-.703-.253-2.025-.815-2.475a.47.47 0 00-.422-.112c-.59.084-.984-.225-1.21-.422.029-.085-.084-.113-.112-.169-.197 0-.365.056-.562.056-2.447.113-3.037.14-3.037 3.122 0 .196-.084.337-.253.506a.715.715 0 01-.45.14zm5.82-4.583c.422 0 .844.14 1.21.45.45.393.787 1.068.984 1.687.056-.675.113-1.687-.084-3.29-.197-1.406-2.615-2.165-4.78-2.025-.057 0-.338.282-.45.422-.704.76-1.182.9-1.8 1.069-.253.028-.478.112-.788.225-.365.084-.393.168-.393.365a16.009 16.009 0 00-.113 2.7c.535-1.884 1.94-2.081 4.05-2.166.196 0 .393 0 .59-.028.478-.056.815.225 1.069.422.056.084.196.169.253.169h.253zm-1.462.76c-.028 0 0 0 0 0z"></path>
        <path d="M8.689 15.803c-1.913 0-4.078-1.603-4.5-5.118-.028-.394.254-.703.591-.788.394-.056.703.225.787.591.338 2.728 1.828 3.937 3.122 3.937 1.321 0 2.783-1.21 3.12-3.937.029-.394.395-.647.788-.59.394.028.619.393.59.787-.477 3.515-2.586 5.117-4.498 5.117z"></path>
        <path d="M11.782 16.31a.696.696 0 01-.703-.704v-2.615c0-.394.31-.703.703-.703.394 0 .703.31.703.703v2.615c-.056.394-.365.703-.703.703zM3.74 23.592a.696.696 0 01-.703-.703V20.47c0-.394.31-.703.703-.703.366 0 .703.309.703.703v2.418c-.056.45-.365.703-.703.703zM13.638 23.592a.696.696 0 01-.703-.703V20.47c0-.394.309-.703.703-.703.393 0 .703.309.703.703v2.418c-.029.45-.31.703-.703.703zM47.353 23.592H31.325a.696.696 0 01-.703-.703v-2.222a5.832 5.832 0 015.82-5.82c.395 0 .704.309.704.703 0 .393-.31.703-.703.703-2.447 0-4.443 1.996-4.443 4.47v1.52h14.65v-1.52c0-2.39-1.912-4.386-4.302-4.47-.394 0-.675-.31-.675-.703 0-.394.31-.647.703-.647 3.093.056 5.624 2.671 5.624 5.82v2.222c.056.394-.253.647-.647.647z"></path>
        <path d="M39.424 19.43a.808.808 0 01-.507-.197l-2.98-3.177c-.281-.253-.225-.703.056-.956.253-.281.703-.253.956.028l2.503 2.615 2.502-2.615a.705.705 0 01.985-.028.728.728 0 01.028.956l-2.953 3.177c-.253.113-.394.197-.59.197z"></path>
        <path d="M36.443 16.309a.696.696 0 01-.703-.703v-2.278c0-.394.31-.703.703-.703.394 0 .703.31.703.703v2.278c-.028.393-.337.703-.703.703zM35.515 11.247h-.028a1.632 1.632 0 01-1.068-.534c-.675-.815-.872-2.587-.59-5.258.112-1.153.983-1.463 1.264-1.575.394-.169.732-.225.957-.31.45-.112.646-.168 1.096-.674.31-.338.76-.816 1.378-.844 2.756-.253 5.933.844 6.243 3.234.309 2.84.112 4.555-.59 5.399-.282.31-.62.506-1.041.534-.197 0-.366-.028-.506-.14-.17-.141-.254-.338-.254-.478-.028-.703-.253-2.025-.815-2.475-.112-.112-.225-.14-.422-.112-.562.084-.984-.225-1.209-.422a.572.572 0 01-.197-.169c-.197 0-.365.056-.562.056-2.447.113-3.037.14-3.037 3.122 0 .196-.084.337-.225.506-.056.084-.253.14-.394.14zm5.821-4.583c.422 0 .844.14 1.21.45.477.393.787 1.068.983 1.687.057-.675.113-1.687-.084-3.29-.197-1.406-2.615-2.165-4.78-2.025-.056 0-.338.282-.45.422-.703.76-1.181.9-1.8 1.069-.225.028-.478.112-.787.225-.31.112-.338.253-.394.45-.14 1.04-.197 1.94-.14 2.615.534-1.884 1.968-2.081 4.077-2.194.197 0 .394 0 .59-.056.478-.028.816.253 1.069.45.084.056.197.14.281.14.056.057.14.057.225.057z"></path>
        <path d="M39.31 15.803c-1.911 0-4.077-1.603-4.498-5.118a.739.739 0 01.59-.788c.394-.056.703.225.788.591.337 2.728 1.827 3.937 3.12 3.937 1.266 0 2.756-1.21 3.122-3.937a.654.654 0 01.76-.59c.393.028.646.393.59.787-.422 3.515-2.56 5.117-4.471 5.117z"></path>
        <path d="M42.376 16.31a.696.696 0 01-.703-.704v-2.615c0-.394.31-.703.703-.703.394 0 .703.31.703.703v2.615c0 .394-.31.703-.703.703zM34.334 23.592a.696.696 0 01-.703-.703V20.47c0-.394.31-.703.703-.703.393 0 .703.309.703.703v2.418c0 .45-.31.703-.703.703zM44.288 23.592a.696.696 0 01-.703-.703V20.47c0-.394.31-.703.703-.703.394 0 .703.309.703.703v2.418c-.028.45-.337.703-.703.703zM32.028 31.521h-16a.696.696 0 01-.703-.703v-2.22a5.832 5.832 0 015.82-5.822c.395 0 .704.31.704.703 0 .394-.31.703-.703.703a4.434 4.434 0 00-4.443 4.443v1.547h14.622v-1.547c0-2.334-1.912-4.358-4.274-4.443-.394 0-.675-.337-.675-.703 0-.393.338-.646.703-.646 3.093.112 5.596 2.727 5.596 5.792v2.25c.028.337-.281.646-.647.646z"></path>
        <path d="M24.098 27.304c-.197 0-.337-.084-.506-.197l-2.952-3.15c-.282-.28-.225-.702.028-.983.281-.282.703-.225.984.028l2.503 2.643 2.502-2.643a.728.728 0 01.956-.028.736.736 0 01.057.984l-2.981 3.15c-.225.112-.422.196-.59.196z"></path>
        <path d="M21.118 24.154a.696.696 0 01-.703-.703v-2.277c0-.394.31-.703.703-.703.366 0 .703.309.703.703v2.306c0 .365-.337.674-.703.674zM20.218 19.15h-.056a1.51 1.51 0 01-1.04-.535c-.675-.844-.872-2.587-.59-5.286.112-.985.73-1.378 1.208-1.547.422-.169.732-.253.985-.281.45-.113.646-.169 1.124-.675l.085-.085c.31-.309.703-.702 1.265-.73 2.784-.226 5.961.815 6.27 3.205.31 2.925.113 4.612-.59 5.427-.28.31-.618.506-1.068.534a.816.816 0 01-.506-.14.644.644 0 01-.225-.478c-.028-.731-.282-2.025-.816-2.503-.112-.112-.281-.14-.422-.112-.562.084-.956-.225-1.237-.422-.028-.056-.14-.113-.169-.113l-.478.028c-2.502.113-3.12.113-3.12 3.122a.639.639 0 01-.254.506c-.056 0-.225.084-.366.084zm5.765-4.64c.478 0 .872.14 1.21.45.477.45.786 1.068.983 1.687.085-.647.085-1.688-.084-3.318-.197-1.407-2.615-2.194-4.752-1.997-.085 0-.31.253-.45.366l-.056.084c-.703.731-1.153.872-1.8 1.04-.253.029-.478.113-.787.225-.31.169-.366.253-.394.45-.113 1.125-.14 2.025-.113 2.672.59-1.913 1.997-2.11 4.162-2.166l.534-.056c.422-.028.76.253 1.013.394a.51.51 0 00.225.168h.309z"></path>
        <path d="M23.986 23.649c-1.912 0-4.05-1.575-4.471-5.118-.056-.394.225-.703.562-.787a.739.739 0 01.788.59c.365 2.7 1.828 3.909 3.121 3.909 1.322 0 2.784-1.21 3.121-3.909.056-.394.394-.619.788-.59.393.028.618.393.59.787-.422 3.543-2.587 5.118-4.499 5.118z"></path>
        <path d="M27.079 24.154a.696.696 0 01-.703-.703v-2.587c0-.394.31-.703.703-.703.394 0 .703.31.703.703v2.615c-.028.366-.31.675-.703.675zM19.037 31.521a.696.696 0 01-.703-.703V28.4c0-.393.31-.703.703-.703.394 0 .703.31.703.703v2.419c0 .393-.31.703-.703.703zM28.963 31.521a.696.696 0 01-.703-.703V28.4c0-.393.31-.703.703-.703.393 0 .703.31.703.703v2.419c0 .393-.31.703-.703.703zM16.703 45.974H.675a.696.696 0 01-.703-.702v-2.194a5.832 5.832 0 015.82-5.82c.394 0 .703.309.703.703 0 .393-.309.674-.703.674a4.452 4.452 0 00-4.442 4.443v1.519H16v-1.519c0-2.334-1.912-4.358-4.303-4.443-.393 0-.674-.365-.674-.703 0-.365.365-.703.703-.675 3.093.113 5.595 2.756 5.595 5.821v2.194c.085.393-.253.703-.618.703z"></path>
        <path d="M8.773 41.757a.809.809 0 01-.506-.197l-2.98-3.149c-.282-.281-.226-.703.027-.984.281-.281.703-.225.984.028l2.503 2.615 2.503-2.615a.766.766 0 01.984-.028.766.766 0 01.028.984l-2.953 3.15c-.196.112-.393.196-.59.196z"></path>
        <path d="M5.793 38.636a.696.696 0 01-.703-.703v-2.278c0-.365.31-.703.703-.703.393 0 .703.338.703.703v2.278c0 .394-.31.703-.703.703zM4.865 33.63h-.056c-.366-.028-.76-.224-1.04-.534-.676-.815-.872-2.587-.591-5.286.084-.76.506-1.294 1.265-1.547.366-.169.731-.253.956-.31.45-.14.619-.168 1.097-.674.281-.31.703-.787 1.378-.816 2.755-.224 5.933.816 6.242 3.206.31 2.925.113 4.612-.59 5.427-.281.31-.619.506-1.04.535-.197 0-.366-.029-.507-.141-.168-.14-.253-.31-.253-.478-.028-.731-.253-2.025-.815-2.503-.113-.112-.282-.14-.422-.112-.563.028-.956-.225-1.21-.422-.056-.056-.168-.14-.196-.169l-.506.028c-2.503.141-3.093.17-3.122 3.178 0 .197-.084.337-.253.506 0 .028-.14.112-.337.112zm5.764-4.64c.45 0 .872.141 1.21.479.478.422.787 1.04.984 1.659.084-.647.084-1.66-.085-3.318-.196-1.434-2.615-2.165-4.752-1.997-.112 0-.365.282-.478.394-.703.76-1.153.9-1.8 1.069-.224.028-.45.112-.759.224-.337.113-.365.225-.393.422-.113 1.153-.17 2.053-.113 2.7.534-1.912 1.969-2.11 4.134-2.222l.534-.028c.478-.056.815.225 1.069.422.056.084.196.169.253.169.084.028.168.028.196.028zm-1.406.788c-.028 0-.028 0 0 0z"></path>
        <path d="M8.689 38.13c-1.913 0-4.078-1.576-4.5-5.119-.028-.393.254-.703.591-.787.394-.028.703.253.787.59.338 2.7 1.828 3.91 3.122 3.91 1.321 0 2.783-1.21 3.12-3.91.029-.393.395-.618.788-.59.394.056.619.394.59.787-.477 3.543-2.586 5.118-4.498 5.118z"></path>
        <path d="M11.782 38.636a.696.696 0 01-.703-.703v-2.587c0-.394.31-.703.703-.703.394 0 .703.309.703.703v2.587c-.056.393-.365.703-.703.703zM3.74 45.975a.696.696 0 01-.703-.703v-2.419c0-.393.31-.703.703-.703.366 0 .703.31.703.703v2.419c-.056.393-.365.703-.703.703zM13.638 45.975a.696.696 0 01-.703-.703v-2.419c0-.393.309-.703.703-.703.393 0 .703.31.703.703v2.419c-.029.393-.31.703-.703.703zM47.353 45.975H31.325a.696.696 0 01-.703-.703v-2.193a5.832 5.832 0 015.82-5.821c.395 0 .704.31.704.703 0 .394-.31.703-.703.703-2.447 0-4.443 1.996-4.443 4.47v1.52h14.65v-1.52c0-2.361-1.912-4.386-4.302-4.47-.394 0-.675-.338-.675-.703 0-.394.366-.647.703-.647 3.093.112 5.596 2.728 5.596 5.82V45.3c.084.366-.225.675-.619.675z"></path>
        <path d="M39.424 41.757a.809.809 0 01-.507-.197l-2.98-3.149c-.281-.281-.225-.703.056-.984.253-.281.703-.225.956.028l2.503 2.615 2.502-2.615a.766.766 0 01.985-.028.766.766 0 01.028.984l-2.953 3.15c-.253.112-.394.196-.59.196z"></path>
        <path d="M36.443 38.636a.696.696 0 01-.703-.703v-2.278c0-.365.31-.703.703-.703.394 0 .703.338.703.703v2.278c-.028.394-.337.703-.703.703zM43.136 33.63c-.169 0-.31-.084-.478-.14a.594.594 0 01-.225-.478c-.056-.731-.282-2.025-.816-2.503a.527.527 0 00-.45-.112c-.534.028-.928-.225-1.209-.422a.573.573 0 00-.197-.169l-.506.028c-2.502.141-3.065.17-3.121 3.178 0 .197-.084.337-.225.506-.084.028-.281.112-.422.112a1.632 1.632 0 01-1.068-.534c-.675-.815-.872-2.587-.59-5.286.084-.76.505-1.294 1.264-1.547.394-.169.732-.253.957-.31.45-.14.646-.168 1.096-.674.282-.31.703-.787 1.378-.816 2.756-.224 5.933.816 6.243 3.206.309 2.925.112 4.612-.59 5.427-.282.31-.62.506-1.041.535zm-1.856-4.64c.45 0 .871.141 1.209.479.478.422.787 1.04.984 1.659.084-.647.084-1.66-.084-3.318-.197-1.434-2.615-2.165-4.752-1.997-.113 0-.338.282-.478.394-.703.76-1.153.9-1.8 1.069-.225.028-.45.112-.76.224-.309.113-.365.225-.393.422-.113 1.153-.169 2.053-.113 2.7.563-1.912 1.969-2.11 4.134-2.222l.534-.028c.478-.056.816.225 1.069.422.084.084.197.169.281.169.028.028.113.028.169.028z"></path>
        <path d="M39.31 38.13c-1.911 0-4.02-1.576-4.498-5.119a.739.739 0 01.59-.787c.394-.028.703.253.788.59.337 2.7 1.827 3.91 3.12 3.91 1.266 0 2.756-1.21 3.122-3.91.028-.393.394-.618.76-.59a.68.68 0 01.59.787c-.422 3.543-2.56 5.118-4.471 5.118z"></path>
        <path d="M42.376 38.636a.696.696 0 01-.703-.703v-2.587c0-.394.31-.703.703-.703.394 0 .703.309.703.703v2.587c0 .393-.31.703-.703.703zM34.334 45.975a.696.696 0 01-.703-.703v-2.419c0-.393.31-.703.703-.703.393 0 .703.31.703.703v2.419c0 .393-.31.703-.703.703zM44.288 45.975a.696.696 0 01-.703-.703v-2.419c0-.393.31-.703.703-.703.394 0 .703.31.703.703v2.419c-.028.393-.337.703-.703.703z"></path>
      </g>
      <defs>
        <clipPath id="clip0_751_602">
          <path fill="#fff" d="M0 0H48V48H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconBookBookMark = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 48 48">
      <path
        fill="#EA2127"
        d="M9.111 43.614a.714.714 0 01-.703-.703V7.733c0-2.755 2.278-5.033 5.006-5.033h15.071c.394 0 .704.31.704.703 0 .394-.31.675-.704.675H13.442c-1.969 0-3.628 1.63-3.628 3.655v35.178c0 .394-.31.703-.703.703zm29.75-4.752a.714.714 0 01-.702-.703V4.078h-.816a.696.696 0 01-.703-.703c0-.394.31-.703.703-.703h1.49c.394 0 .703.31.703.703v34.784c0 .365-.309.703-.674.703z"
      ></path>
      <path
        fill="#EA2127"
        d="M38.862 47.972H13.695a5.22 5.22 0 01-5.23-5.23c0-2.868 2.334-5.259 5.23-5.259h25.167c.394 0 .703.31.703.703v9.111c-.028.366-.337.675-.703.675zm-25.167-9.11a3.87 3.87 0 00-3.88 3.88c0 2.137 1.715 3.852 3.88 3.852H38.16v-7.733H13.695z"
      ></path>
      <path
        fill="#EA2127"
        d="M13.441 38.86a.714.714 0 01-.703-.702V3.402c0-.393.31-.703.703-.703.394 0 .703.31.703.703v34.784c0 .337-.31.675-.703.675zM25.814 12.289h-7.789a.696.696 0 01-.703-.703c0-.366.31-.703.703-.703h7.79c.393 0 .702.337.702.703 0 .393-.365.703-.703.703zM25.814 16h-7.789a.696.696 0 01-.703-.703c0-.394.31-.703.703-.703h7.79c.393 0 .702.31.702.703 0 .393-.365.703-.703.703zM34.278 19.656H18.025a.696.696 0 01-.703-.703.69.69 0 01.703-.675h16.281a.69.69 0 01.703.675c0 .394-.337.703-.73.703zM34.278 23.368H18.025a.696.696 0 01-.703-.703c0-.394.31-.703.703-.703h16.281c.394 0 .703.31.703.703 0 .394-.337.703-.73.703zM34.278 27.079H18.025a.696.696 0 01-.703-.703c0-.394.31-.703.703-.703h16.281c.394 0 .703.31.703.703 0 .393-.337.703-.73.703zM34.278 30.735H18.025a.696.696 0 01-.703-.703c0-.394.31-.703.703-.703h16.281c.394 0 .703.31.703.703 0 .394-.337.703-.73.703zM28.485 17.912c-.056 0-.112 0-.168-.028a.727.727 0 01-.506-.675V.731a.69.69 0 01.674-.703h7.93c.394 0 .703.31.703.703v16.507c0 .337-.197.59-.478.674-.253.085-.59-.028-.76-.28l-3.486-5.175-3.318 5.146a.696.696 0 01-.59.31zm3.909-7.367c.225 0 .422.113.59.31l2.756 4.133V1.378h-6.58v13.525l2.643-4.077c.17-.168.366-.281.591-.281z"
      ></path>
    </svg>
  </span>
);

export const IconUserHeadset = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 48 48">
      <path
        fill="#EA2127"
        d="M20.049 31.466a.696.696 0 01-.703-.703l.028-3.29c0-.394.31-.703.703-.647.393 0 .675.31.675.703l-.057 3.262a.66.66 0 01-.646.675zM27.951 31.465a.696.696 0 01-.703-.703v-3.29c0-.393.31-.703.703-.703.394 0 .703.31.703.704v3.29c-.056.421-.366.702-.703.702z"
      ></path>
      <path
        fill="#EA2127"
        d="M21.652 38.58a.678.678 0 01-.478-.196l-4.415-4.359a.734.734 0 01-.197-.478c0-.197.085-.337.197-.45l2.784-2.784c.225-.225.619-.253.9-.028l3.965 3.15c.281.196.337.59.14.9l-2.333 3.964a.698.698 0 01-.507.366c0-.084-.028-.084-.056-.084zm-3.43-5.061l3.261 3.262 1.603-2.728-3.009-2.39-1.855 1.856z"
      ></path>
      <path
        fill="#EA2127"
        d="M40.998 47.972H7.002a.696.696 0 01-.703-.703c0-10.686.843-14.144 10.938-14.37.394-.056.703.282.703.648 0 .393-.28.703-.675.703-8.632.252-9.56 2.277-9.56 12.344h32.618c-.056-10.067-1.012-12.092-9.616-12.345-.394 0-.647-.309-.647-.703 0-.365.31-.703.703-.646 9.814.225 10.91 3.121 10.938 14.369 0 .197-.084.337-.197.478-.168.14-.309.225-.506.225z"
      ></path>
      <path
        fill="#EA2127"
        d="M26.32 38.58h-.085a.694.694 0 01-.506-.337l-2.334-3.993c-.168-.31-.112-.647.14-.9l3.938-3.15a.654.654 0 01.9.057l2.783 2.755c.113.113.169.31.169.478a.594.594 0 01-.169.45l-4.386 4.443a.612.612 0 01-.45.197zm-1.434-4.471l1.574 2.728 3.29-3.29-1.884-1.828-2.98 2.39zM36.527 47.972a.696.696 0 01-.703-.703V40.83a.69.69 0 01.703-.675.69.69 0 01.703.675v6.468c-.056.365-.31.674-.703.674zm-25.055 0a.696.696 0 01-.702-.703V40.83a.69.69 0 01.703-.675.69.69 0 01.702.675v6.468a.69.69 0 01-.703.674zM23.817 47.972a.696.696 0 01-.703-.703v-7.676c0-.394.31-.703.703-.703.394 0 .703.309.703.703v7.676c-.028.394-.31.703-.703.703zM16.731 21.146h-.028a2.321 2.321 0 01-1.575-.844c-1.152-1.377-1.462-4.583-.956-9.504.366-3.346 6.215-5.68 11.248-5.708h.028c4.752 0 7.846 2.024 8.267 5.455.338 2.84.675 7.874-.9 9.757a2.321 2.321 0 01-1.546.844c-.197 0-.394-.056-.506-.197-.113-.169-.253-.337-.253-.506 0-5.82-1.013-6.355-2.644-6.608-3.346-.422-6.692-.562-8.604 1.069-1.21 1.04-1.828 2.868-1.828 5.54 0 .196-.084.337-.225.505-.14.113-.281.197-.478.197zm-1.18-10.207c-.423 4.19-.226 7.226.562 8.351.196-2.446.928-4.246 2.25-5.399 2.305-2.024 5.989-1.884 9.672-1.406 2.98.422 3.684 2.531 3.796 6.777 1.013-1.406.956-5.286.563-8.576-.478-3.853-4.95-4.275-6.946-4.275h-.028c-4.724.029-9.589 2.25-9.87 4.528z"
      ></path>
      <path
        fill="#EA2127"
        d="M23.985 29.75c-3.346 0-7.142-2.84-7.93-9.195-.027-.393.254-.703.591-.787a.739.739 0 01.787.59c.704 5.54 3.768 7.986 6.552 7.986 2.756 0 5.877-2.502 6.524-7.986.056-.393.394-.618.787-.59.394.028.62.394.59.787-.786 6.355-4.526 9.195-7.9 9.195zM36.864 14.707a.696.696 0 01-.703-.703v-.394c0-6.72-5.483-12.232-12.232-12.232-6.72 0-12.175 5.483-12.175 12.232v.394c0 .393-.31.703-.703.703a.696.696 0 01-.703-.703v-.394C10.348 6.13 16.422.028 23.9.028c7.48 0 13.582 6.074 13.582 13.582v.394c.084.393-.225.703-.619.703z"
      ></path>
      <path
        fill="#EA2127"
        d="M11.107 22.665H6.692a.714.714 0 01-.703-.703v-7.958c0-.394.31-.703.703-.703h4.415c.394 0 .703.31.703.703v7.958c-.028.421-.337.703-.703.703zm-3.712-1.378h3.065v-6.58H7.395v6.58zM41.307 22.665h-4.443a.714.714 0 01-.703-.703v-7.958c0-.394.31-.703.703-.703h4.443c.394 0 .703.31.703.703v7.958a.68.68 0 01-.703.703zm-3.74-1.378h3.093v-6.58h-3.093v6.58z"
      ></path>
      <path
        fill="#EA2127"
        d="M39.086 25.645h-6.889a.696.696 0 01-.703-.703c0-.393.31-.703.703-.703h6.243v-2.277c0-.394.309-.703.703-.703a.69.69 0 01.675.703v2.952c-.029.422-.338.731-.732.731z"
      ></path>
    </svg>
  </span>
);

export const IconLiveChat = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g fill="#EA2127" clipPath="url(#clip0_751_739)">
        <path d="M21.89 7.08h-1.472c-1.253-2.974-4.011-5.135-7.187-5.548a9.117 9.117 0 00-8.262 3.23 9.219 9.219 0 00-1.411 2.319H2.109C.946 7.08 0 8.027 0 9.19v2.812c0 1.163.946 2.11 2.11 2.11h2.887l-.302-.923c-.88-2.686-.385-5.43 1.357-7.53a7.73 7.73 0 016.997-2.734c2.824.368 5.275 2.365 6.246 5.09l.006.015c.157.416.267.844.33 1.284a7.74 7.74 0 01-.347 3.854l-.003.009a7.72 7.72 0 01-7.267 5.153c-1.171 0-2.123.946-2.123 2.11 0 1.162.946 2.109 2.109 2.109s2.11-.947 2.11-2.11v-.948a9.129 9.129 0 006.299-5.38h1.482c1.163 0 2.109-.946 2.109-2.11V9.19c0-1.163-.946-2.11-2.11-2.11z"></path>
        <path d="M5.672 15.519v1.406H12a6.335 6.335 0 006.328-6.328A6.335 6.335 0 0012 4.269a6.335 6.335 0 00-6.328 6.328c0 1.422.478 2.797 1.351 3.909a1.398 1.398 0 01-1.351 1.013zm8.437-5.625h1.407V11.3h-1.407V9.894zm-2.812 0h1.406V11.3h-1.406V9.894zm-2.813 0h1.407V11.3H8.484V9.894z"></path>
      </g>
      <defs>
        <clipPath id="clip0_751_739">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconLogoManagementRed = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 147 61">
      <g fill="#EB2127" clipPath="url(#clip0_1002_147)">
        <path d="M67.53 26.444c0-.358.09-.723.27-1.095a3.07 3.07 0 01.791-1.003c.348-.299.78-.545 1.295-.736.515-.191 1.11-.289 1.783-.289 1.127 0 2.092.198 2.896.59.8.397 1.372.918 1.71 1.564.048.072.19.437.431 1.094.24.66.543 1.507.916 2.549.372 1.042.786 2.219 1.243 3.535a730.63 730.63 0 001.403 4.019c1.103 3.18 2.35 6.782 3.742 10.8l7.843-21.997c.48-.789 1.121-1.348 1.925-1.671a6.739 6.739 0 012.535-.483 6.047 6.047 0 011.727.306c.529.18.988.413 1.385.701.397.289.7.615.916.987.216.371.324.75.324 1.132v26.128c0 .527-.209 1.041-.631 1.542-.42.503-1.12.753-2.106.753-1.128 0-1.935-.24-2.426-.719-.491-.479-.738-.979-.738-1.507V31.146l-7.59 21.783a2.55 2.55 0 00-.198.43c-.084.216-.233.431-.45.646-.215.216-.514.414-.897.59-.383.181-.898.272-1.546.272-.647.024-1.18-.066-1.601-.271-.418-.201-.749-.438-.99-.698a3.217 3.217 0 01-.612-.97l-7.52-21.747v21.39c-.024.43-.142.813-.358 1.15-.191.288-.48.548-.863.788s-.933.358-1.654.358c-.863 0-1.57-.209-2.124-.629-.55-.417-.825-.976-.825-1.67V26.444h-.007zM124.773 52.251c0 .268-.056.521-.171.757a1.995 1.995 0 01-.48.633c-.205.184-.432.33-.679.43a1.967 1.967 0 01-.773.153 2.172 2.172 0 01-1.469-.583 2.096 2.096 0 01-.463-.633 1.7 1.7 0 01-.171-.726c-1.072.966-2.172 1.64-3.303 2.018-1.135.379-2.225.57-3.276.57-1.052 0-2.019-.146-2.904-.43-.884-.285-1.605-.626-2.162-1.018a13.843 13.843 0 01-1.761-1.449 9.955 9.955 0 01-1.528-1.882 9.757 9.757 0 01-1.066-2.296 8.754 8.754 0 01-.4-2.698c0-1.028.097-1.959.292-2.789.195-.834.45-1.587.759-2.264a9.83 9.83 0 011.034-1.789c.38-.514.756-.966 1.128-1.358.369-.35.794-.688 1.267-1.018.411-.288.895-.566 1.452-.833a9.017 9.017 0 011.915-.646 9.2 9.2 0 012.009-.215c1.235 0 2.409.222 3.523.663a9.917 9.917 0 013.028 1.896c0-.514.216-.965.648-1.358.432-.389.909-.587 1.42-.587.268 0 .53.052.791.153.257.104.487.247.696.43.205.185.372.397.494.633.126.236.185.476.185.726v2.188l-.032 13.315-.003.007zm-9.981-13.562c-.599 0-1.243.094-1.932.278-.693.184-1.386.576-2.085 1.17a5.277 5.277 0 00-1.497 2.22 7.04 7.04 0 00-.418 2.743c.042.76.226 1.466.557 2.112a5.518 5.518 0 001.284 1.663 6.047 6.047 0 001.821 1.094c.689.268 1.407.4 2.148.4.783 0 1.504-.129 2.162-.386a5.367 5.367 0 001.73-1.08 5.504 5.504 0 001.205-1.663c.31-.646.494-1.362.557-2.143a5.698 5.698 0 00-.139-2.112 7.553 7.553 0 00-.791-1.865c-.369-.597-.957-1.146-1.761-1.65-.804-.503-1.751-.764-2.844-.784l.003.003zM133.448 52.807c0 .15-.042.333-.125.555a2.337 2.337 0 01-.397.65 2.457 2.457 0 01-.714.556c-.299.16-.668.24-1.114.24-.487 0-.891-.07-1.208-.206a2 2 0 01-.748-.524 1.698 1.698 0 01-.366-.68 2.677 2.677 0 01-.097-.65V44.69a848.916 848.916 0 01-.032-7.741c0-.233.042-.469.129-.715a2.098 2.098 0 011.097-1.206c.285-.135.63-.204 1.034-.204s.78.08 1.065.24c.286.159.515.343.682.555.213.233.38.496.509.792.233-.191.501-.417.811-.681a5.78 5.78 0 011.096-.73 7.496 7.496 0 011.494-.569c.571-.16 1.218-.24 1.939-.24 1.25 0 2.371.233 3.356.698a7.54 7.54 0 012.51 1.886 8.26 8.26 0 011.574 2.761c.362 1.046.543 2.164.543 3.345v10.054c0 .295-.073.56-.223.792-.15.233-.338.427-.574.587-.234.16-.488.281-.763.365a2.766 2.766 0 01-.797.128c-.425 0-.79-.07-1.097-.205a2.748 2.748 0 01-.762-.49 1.904 1.904 0 01-.446-.617 1.543 1.543 0 01-.142-.619v-9.992a5.3 5.3 0 00-.272-1.476 3.65 3.65 0 00-.745-1.285 3.833 3.833 0 00-1.257-.92c-.498-.233-1.086-.347-1.765-.347-.825 0-1.511.173-2.05.524a4.16 4.16 0 00-1.288 1.285 5.507 5.507 0 00-.683 1.57c-.136.538-.205 1-.205 1.379v1.743c0 .445.003.941.017 1.49.011.549.018 1.101.018 1.65v4.313l-.004-.003zM27.208 14.051c-.271-.49-.766-.913-1.364-1.17-1.191-.51-2.465-.236-2.838.618L8.712 47.46c-.348.865.345 1.963 1.546 2.456.606.247 1.253.302 1.793.153l29.027-5.456c.738-.205 1.173-.698 1.274-1.292.355-.486.4-1.143.031-1.813L27.208 14.05zM32.1 38.897L21.809 40.61c-.495.14-1.135-.104-1.434-.541-.147-.216-.185-.449-.115-.643l5.079-12.069c.09-.19.285-.323.54-.371.522-.094 1.141.19 1.392.639l5.32 10.1a.811.811 0 01-.495 1.173h.004zM21.959 10.738a5.155 5.155 0 006.743-2.75 5.133 5.133 0 00-2.757-6.728A5.155 5.155 0 0019.2 4.01a5.133 5.133 0 002.758 6.728zM52.831 44.294a5.154 5.154 0 00-6.743 2.75 5.133 5.133 0 002.757 6.728 5.154 5.154 0 006.744-2.75 5.133 5.133 0 00-2.758-6.728zM7.233 50.976a5.155 5.155 0 00-6.744 2.75 5.133 5.133 0 002.758 6.728 5.155 5.155 0 006.743-2.751 5.133 5.133 0 00-2.757-6.727z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1002_147">
          <path fill="#fff" d="M0 0H146.4V60H0z" transform="translate(.086 .857)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconLogoDeviceFarmRed = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 101 48">
      <g fill="#EA2127" clipPath="url(#clip0_1002_115)">
        <path d="M12.778 30.548c0 2.37 1.883 4.287 4.202 4.287 2.32 0 4.203-1.92 4.203-4.287S19.3 26.26 16.98 26.26c-2.319 0-4.202 1.921-4.202 4.288z"></path>
        <path d="M22.719 5.968c3.849-.464 3.317-6.219-.538-5.958L3.182 1.787C1.714 1.93.544 3.182.52 4.72.525 4.742-.009 39.57 0 39.59c.055 4.726 6.853 4.698 6.902 0V7.494c5.244-.492 15.817-1.526 15.817-1.526zM25.514 10.366v29.143c-4.433.568-13.233 1.702-13.412 1.715-4.33.906-3.185 7.403 1.174 6.726.061-.031 15.638-2.815 15.684-2.852 1.373-.248 2.415-1.473 2.415-2.943v-31.79c-.099-3.958-5.775-3.93-5.864 0h.003zM62.602 23.085a14.362 14.362 0 00-2.184-3.41 9.805 9.805 0 00-2.638-2.216 14.406 14.406 0 00-3.14-1.323 17.869 17.869 0 00-3.388-.636 36.883 36.883 0 00-3.388-.16H44.49c-.562 0-1.01.097-1.342.285-.332.191-.587.42-.765.686a2.188 2.188 0 00-.344.828 2.536 2.536 0 00-.046.718V41.12c.021.574.163 1.016.424 1.323.26.307.534.536.826.686.375.17.79.267 1.25.285h5.182c1.834 0 3.484-.213 4.952-.636 1.468-.426 2.768-1.04 3.904-1.849a12.055 12.055 0 002.922-2.965c.81-1.17 1.477-2.495 1.996-3.984.375-1.04.593-2.178.657-3.41.062-1.232-.03-2.48-.282-3.746a16.924 16.924 0 00-1.22-3.745l-.003.006zm-3.824 8.077a8.727 8.727 0 01-.89 2.661c-.48.912-1.048 1.661-1.703 2.248a8.634 8.634 0 01-2.107 1.4 9.19 9.19 0 01-2.344.734c-.81.138-1.612.207-2.405.207h-2.218V20.44c.916 0 1.807.016 2.67.047.863.032 1.702.138 2.512.32a9.23 9.23 0 012.344.875c.75.404 1.456.978 2.126 1.72a7.746 7.746 0 011.438 2.28c.353.858.577 1.751.67 2.676.094.925.06 1.859-.093 2.802v.003zM83.746 31.168a9.18 9.18 0 00-1.631-3.216 8.75 8.75 0 00-3.167-2.589 8.985 8.985 0 00-3.963-.909c-.586 0-1.191.063-1.821.182a8.187 8.187 0 00-1.88.614 8.841 8.841 0 00-1.81 1.135 9.227 9.227 0 00-2.93 4.222 9.953 9.953 0 00-.507 2.63c-.046.877.016 1.733.178 2.573.163.84.421 1.624.768 2.35a8.989 8.989 0 002.974 3.426 9.084 9.084 0 002.316 1.148c.857.288 1.79.432 2.795.432.787 0 1.573-.094 2.36-.279a7.34 7.34 0 001.314-.46 8.427 8.427 0 001.343-.756c.42-.288.798-.605 1.136-.95.338-.344.572-.695.7-1.05.126-.354.176-.695.139-1.021a2.193 2.193 0 00-.274-.868 1.756 1.756 0 00-.602-.615 1.6 1.6 0 00-.85-.238h-.191c-.147.038-.335.094-.562.166-.228.075-.526.27-.891.59-.329.297-.823.604-1.48.92-.658.317-1.407.477-2.25.477-.549 0-1.074-.075-1.575-.225a4.447 4.447 0 01-1.37-.671 4.576 4.576 0 01-1.069-1.09 4.181 4.181 0 01-.645-1.483h11.872c.148 0 .32-.038.523-.113.2-.075.396-.188.59-.336.193-.15.362-.338.506-.573.148-.232.227-.517.246-.853.037-.316.03-.699-.015-1.147a9.076 9.076 0 00-.274-1.426l-.003.003zm-13.448.784c.402-1.063 1.029-1.894 1.88-2.49.85-.595 1.83-.896 2.946-.896a5.47 5.47 0 011.548.223c.504.15.967.37 1.398.655.43.291.798.643 1.112 1.063.31.42.537.9.684 1.441h-9.568v.004zM100.078 27.382a1.851 1.851 0 00-.593-.589 1.488 1.488 0 00-.795-.222H92.1V20.1h7.026c.623 0 1.093-.254 1.407-.765.31-.51.467-1.084.467-1.72a3.49 3.49 0 00-.452-1.752c-.301-.53-.786-.797-1.453-.797H89.1c-.501.022-.891.123-1.17.301a1.723 1.723 0 00-.624.655c-.135.254-.218.511-.25.765-.03.254-.045.477-.045.668v23.646c0 .316.077.605.233.858.157.254.353.474.593.652.24.182.516.32.826.414.314.094.624.144.937.144.624 0 1.195-.185 1.717-.558.523-.37.78-.865.78-1.482v-9.466h6.559c.602 0 1.072-.26 1.404-.78.331-.52.5-1.11.5-1.768 0-.317-.043-.627-.126-.925a2.958 2.958 0 00-.359-.812l.003.003z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1002_115">
          <path fill="#fff" d="M0 0H101V48H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconLogoEngineRed = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 125 56">
      <g fill="#EB2127" clipPath="url(#clip0_1002_130)">
        <path d="M47.316 35.463l-13.063-5.82a3.024 3.024 0 00-2.68.104c-1.582.847-2.284 2.936-1.582 4.612l5.958 15.976.018.043c.338.815.983 1.423 1.77 1.67.272.083.546.126.817.126 1.336 0 2.608-.981 3.104-2.502.274-.843.263-1.73-.004-2.414l-2.224-7.28a.438.438 0 01.008-.279c.017-.05.039-.09.057-.116l5.085 2.683.552.239c.66.195 1.372.137 2.024-.174.87-.417 1.554-1.242 1.878-2.27.592-1.875-.16-3.892-1.718-4.598zM31.919 26.42c.363.137.737.206 1.108.206.449 0 .887-.101 1.283-.297l13.252-5.9.05-.026c.677-.337 1.19-.956 1.45-1.741.524-1.575-.078-3.381-1.404-4.2-.755-.467-1.635-.539-2.305-.239l-5.958 2.031c-.09-.05-.178-.282-.157-.35l2.965-6.553c.641-1.763-.079-3.957-1.64-4.992-.848-.565-1.849-.717-2.75-.42-.888.293-1.604 1.002-1.964 1.954L29.941 21.71a3.828 3.828 0 00.039 2.762c.37.909 1.076 1.622 1.935 1.951l.004-.003zM2.895 17.551l18.887 8.569c.452.206.937.311 1.421.311.485 0 .966-.105 1.412-.315 1.706-.8 2.476-2.932 1.735-4.71l-7.013-18.72-.014-.036a4.381 4.381 0 00-1.81-2.092c-.96-.565-2.075-.71-3.055-.391-.89.293-1.592.93-1.974 1.792a3.754 3.754 0 00-.028 2.9l3.068 9.238c.05.127.057.254.018.351-.01.026-.043.105-.153.145a.499.499 0 01-.3.008L6.77 9.69l-.51-.26c-1.119-.474-2.366-.525-3.467-.134a4.13 4.13 0 00-2.399 2.161c-.474 1.021-.516 2.187-.12 3.287.441 1.224 1.396 2.245 2.622 2.806zM24.268 29.725a3.297 3.297 0 00-2.64.138L2.547 38.54l-.039.018a4.394 4.394 0 00-2.084 2.187c-.439 1.028-.432 2.176.025 3.146a3.74 3.74 0 002.37 1.995c1.018.293 2.12.177 3.028-.29l9.33-4.03c.124-.065.26-.083.363-.043a.232.232 0 01.15.134c.042.098.039.221.028.26l-4.17 8.762v.068c-.363 1.108-.295 2.277.2 3.248a3.615 3.615 0 002.399 1.893c.31.076.623.112.933.112 1.828 0 3.617-1.242 4.33-3.131l6.877-18.412a3.829 3.829 0 00-.053-2.838 3.431 3.431 0 00-1.967-1.894zM64.257 16.837c0-.246.021-.532.06-.862.04-.33.147-.655.325-.984.178-.33.445-.609.809-.84.363-.232.87-.362 1.514-.391h13.926c.863 0 1.493.34 1.896 1.024.403.684.606 1.434.606 2.256 0 .821-.203 1.545-.606 2.172-.403.63-1.023.945-1.857.945H70.84v8.366h9.525c.402 0 .759.098 1.069.286.31.192.566.445.766.756.203.315.356.663.463 1.046.107.384.16.779.16 1.192 0 .847-.203 1.592-.605 2.233-.403.641-1.009.963-1.818.963h-9.564v8.283h10.092c.834 0 1.454.34 1.856 1.025.403.684.606 1.448.606 2.295 0 .409-.053.807-.16 1.19a3.569 3.569 0 01-.463 1.025c-.204.3-.442.547-.727.739a1.714 1.714 0 01-.987.286H66.925c-.16 0-.392-.033-.688-.102a2.617 2.617 0 01-.87-.39 2.578 2.578 0 01-.744-.819c-.218-.355-.335-.807-.364-1.354v-30.34h-.003zM91.938 47.732c0 .156-.042.351-.131.586-.09.236-.225.464-.414.688a2.53 2.53 0 01-.741.587c-.31.166-.695.25-1.154.25-.507 0-.924-.073-1.255-.218a2.076 2.076 0 01-.777-.554 1.831 1.831 0 01-.381-.72 2.886 2.886 0 01-.1-.688v-8.522a933.091 933.091 0 01-.032-8.185c0-.246.043-.496.132-.753.09-.257.225-.496.413-.72.186-.225.428-.41.727-.554.296-.145.656-.217 1.073-.217.442 0 .809.083 1.108.253.296.167.535.362.71.587.22.246.395.524.527.84.242-.203.523-.442.84-.72a5.97 5.97 0 011.141-.772 7.881 7.881 0 011.554-.605 7.463 7.463 0 012.013-.253c1.297 0 2.459.246 3.485.738a7.916 7.916 0 012.609 1.995 8.765 8.765 0 011.635 2.918c.374 1.108.563 2.288.563 3.54v10.633c0 .315-.078.594-.231.84a2.094 2.094 0 01-.595.619 2.989 2.989 0 01-.792.387c-.285.09-.563.134-.826.134-.442 0-.82-.072-1.141-.217a2.72 2.72 0 01-.791-.521 1.993 1.993 0 01-.463-.656 1.68 1.68 0 01-.15-.655V37.23a5.633 5.633 0 00-.281-1.56 3.909 3.909 0 00-.777-1.358 4.002 4.002 0 00-1.304-.974c-.517-.246-1.13-.369-1.832-.369-.859 0-1.568.185-2.13.554a4.304 4.304 0 00-1.337 1.357 5.826 5.826 0 00-.71 1.662c-.142.572-.213 1.057-.213 1.459v1.846c0 .47.004.996.018 1.579.01.582.018 1.162.018 1.745v4.561h-.008zM114.798 45.234h8.189c.684.022 1.19.253 1.518.695.327.438.495.992.495 1.665 0 .395-.068.728-.203 1.007-.136.279-.303.51-.496.695a2.089 2.089 0 01-.598.416 1.4 1.4 0 01-.545.138H112.41a7.075 7.075 0 01-1.671-.207 2.623 2.623 0 01-1.433-.901c-.271-.348-.456-.699-.545-1.057a3.185 3.185 0 01-.103-1.021c.021-.322.078-.608.171-.85.092-.243.16-.435.206-.573.114-.184.325-.496.631-.937.307-.438.688-.97 1.144-1.593.456-.627.952-1.307 1.486-2.046a547.502 547.502 0 015.887-7.939l-6.482-.036c-.545 0-1.005-.231-1.383-.695-.374-.463-.563-1.028-.563-1.698 0-.6.193-1.125.581-1.578a1.862 1.862 0 011.468-.677h9.59c.499 0 .965.098 1.4.293.431.196.791.482 1.076.851.285.37.46.804.528 1.3.067.495-.025 1.057-.275 1.683-.067.138-.256.434-.563.883-.306.45-.688 1-1.144 1.647-.456.648-.955 1.35-1.5 2.115-.545.764-1.105 1.538-1.671 2.324-1.319 1.824-2.797 3.859-4.437 6.1l-.01-.004z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1002_130">
          <path fill="#fff" d="M0 0H125V56H0z"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconStep1 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 48 49">
      <path
        fill="#FCFCFD"
        d="M45.563 45.688h-3.844c-1.219 0-2.25-1.032-2.25-2.25v-4.594c0-1.219 1.031-2.25 2.25-2.25h3.843c1.22 0 2.25 1.031 2.25 2.25v4.593c0 1.22-.937 2.25-2.25 2.25zm-3.844-7.782c-.469 0-.938.469-.938.938v4.593a.94.94 0 00.938.938h3.843a.94.94 0 00.938-.938v-4.593c0-.469-.469-.938-.938-.938H41.72zM6.094 12.406H2.25c-1.219 0-2.25-1.031-2.25-2.25V5.562c0-1.218 1.031-2.25 2.25-2.25h3.844c1.218 0 2.156.938 2.156 2.25v4.594c0 1.219-.938 2.25-2.156 2.25zM2.25 4.625a.94.94 0 00-.938.938v4.593c0 .469.47.938.938.938h3.844c.468 0 .843-.469.843-.938V5.562c0-.562-.375-.937-.843-.937H2.25zM6.094 45.688H2.25c-1.219 0-2.25-1.032-2.25-2.25v-4.594c0-1.219 1.031-2.25 2.25-2.25h3.844c1.218 0 2.156 1.031 2.156 2.25v4.593c0 1.313-.938 2.25-2.156 2.25zM2.25 37.906c-.469 0-.938.469-.938.938v4.593a.94.94 0 00.938.938h3.844c.468 0 .843-.375.843-.938v-4.593c0-.469-.375-.938-.843-.938H2.25zM45.844 12.406h-3.938c-1.218 0-2.156-1.031-2.156-2.25V5.562c0-1.312.938-2.25 2.156-2.25h3.938c1.218 0 2.156.938 2.156 2.25v4.594c0 1.219-.938 2.25-2.156 2.25zm-3.938-7.781c-.468 0-.843.375-.843.938v4.593c0 .469.374.938.843.938h3.938c.468 0 .843-.469.843-.938V5.562c0-.562-.374-.937-.843-.937h-3.938zM25.781 45.688h-3.843c-1.22 0-2.157-.938-2.157-2.25v-4.594c0-1.219.938-2.25 2.157-2.25h3.843c1.313 0 2.25.937 2.25 2.25v4.593c0 1.313-.937 2.25-2.25 2.25zm-3.843-7.782c-.47 0-.844.469-.844.938v4.593c0 .563.375.938.843.938h3.844c.563 0 .938-.375.938-.938v-4.593a.94.94 0 00-.938-.938h-3.843zM45.563 29h-3.844c-1.219 0-2.25-.938-2.25-2.156v-4.688c0-1.218 1.031-2.156 2.25-2.156h3.843c1.22 0 2.25.938 2.25 2.156v4.688c0 1.218-1.03 2.156-2.25 2.156zm-3.844-7.688c-.469 0-.938.375-.938.844v4.688c0 .468.469.843.938.843h3.843c.47 0 .938-.375.938-.843v-4.688c0-.468-.469-.843-.938-.843H41.72z"
      ></path>
      <path
        fill="#FCFCFD"
        d="M40.125 41.844h-12.75a.64.64 0 01-.656-.657.64.64 0 01.656-.656h12.75a.64.64 0 01.656.657.64.64 0 01-.656.656zm-19.688 0H7.595a.64.64 0 01-.657-.657.64.64 0 01.657-.656h12.843a.64.64 0 01.657.657.64.64 0 01-.657.656zm23.438-3.938a.64.64 0 01-.656-.656v-8.906a.64.64 0 01.656-.657.64.64 0 01.656.657v8.906a.64.64 0 01-.656.656zm-39.75 0a.64.64 0 01-.656-.656v-25.5a.64.64 0 01.656-.656.64.64 0 01.656.656v25.5a.64.64 0 01-.656.656zm39.75-16.593a.64.64 0 01-.656-.657V11.75a.64.64 0 01.656-.656.64.64 0 01.656.656v8.906a.64.64 0 01-.656.657zM40.406 8.469H7.594a.64.64 0 01-.657-.656.64.64 0 01.657-.657h32.812a.64.64 0 01.657.657.64.64 0 01-.657.656zM16.688 33.594h-2.813a.64.64 0 01-.656-.657V19.532H9.844a.64.64 0 01-.656-.656v-2.813a.64.64 0 01.656-.656h10.875a.64.64 0 01.656.656v2.813a.64.64 0 01-.656.656h-3.375v13.407a.64.64 0 01-.657.656zM14.53 32.28h1.5V18.875a.64.64 0 01.657-.656h3.375v-1.5H10.5v1.5h3.375a.64.64 0 01.656.656v13.406zM35.813 16.156h-9.75a.64.64 0 01-.657-.656.64.64 0 01.657-.656h9.75a.64.64 0 01.656.656.64.64 0 01-.657.656zM35.813 20.656h-9.75a.64.64 0 01-.657-.656.64.64 0 01.657-.656h9.75a.64.64 0 01.656.656.64.64 0 01-.657.656zM35.813 25.156h-9.75a.64.64 0 01-.657-.656.64.64 0 01.657-.656h9.75a.64.64 0 01.656.656.64.64 0 01-.657.656zM35.813 29.656h-9.75a.64.64 0 01-.657-.656.64.64 0 01.657-.656h9.75a.64.64 0 01.656.656.64.64 0 01-.657.656zM35.813 34.156h-9.75a.64.64 0 01-.657-.656.64.64 0 01.657-.656h9.75a.64.64 0 01.656.656.64.64 0 01-.657.656z"
      ></path>
    </svg>
  </span>
);

export const IconStep2 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 48 49">
      <g fill="#FCFCFD" clipPath="url(#clip0_805_2016)">
        <path d="M36.64 11.579H11.388a.696.696 0 01-.703-.703v-8.38c0-.394.31-.675.704-.675h25.25a.69.69 0 01.704.675v8.408c-.028.365-.338.675-.703.675zM12.035 10.2h23.902V3.143H12.035V10.2zM36.64 47.178H11.388a.714.714 0 01-.703-.703v-8.436c0-.394.31-.703.704-.703h25.25c.394 0 .704.31.704.703v8.436c-.028.365-.338.703-.703.703zM12.035 45.8h23.902v-7.058H12.035V45.8zM42.545 33.568H5.455a.696.696 0 01-.703-.703v-8.38c0-.393.31-.703.703-.703h37.09c.365 0 .703.31.703.703v8.408c0 .394-.338.675-.703.675zM6.158 32.19H41.87v-7.002H6.158v7.002zM31.494 16.36h-14.96a.696.696 0 01-.703-.704c0-.394.31-.703.703-.703h14.96c.393 0 .703.31.703.703a.714.714 0 01-.703.703zM36.724 20.408h-25.42a.696.696 0 01-.703-.703.69.69 0 01.703-.675h25.392c.365 0 .703.31.703.675 0 .394-.338.703-.675.703z"></path>
        <path d="M47.297 42.96H36.64a.696.696 0 01-.703-.702c0-.394.309-.703.703-.703h9.954V7.36H41.87a.69.69 0 01-.703-.675c0-.337.31-.703.703-.703h5.427c.394 0 .703.338.703.703v35.572c0 .393-.31.703-.703.703z"></path>
        <path d="M41.87 7.361c-.169 0-.31-.028-.422-.169-.281-.224-.365-.646-.084-.956l2.25-2.783c.253-.253.674-.338.984-.057.28.225.365.647.084.956l-2.278 2.784a.768.768 0 01-.534.225z"></path>
        <path d="M44.12 10.117a.703.703 0 01-.535-.225l-2.25-2.756c-.252-.281-.196-.76.057-.984.281-.225.76-.197.984.084l2.25 2.756c.253.281.197.76-.056.984-.113.113-.282.14-.45.14zM6.158 42.96H.703A.696.696 0 010 42.259V6.686c0-.365.31-.703.703-.703h10.685c.394 0 .703.338.703.703 0 .394-.309.675-.703.675H1.406v34.222h4.752c.394 0 .703.309.703.703 0 .393-.337.675-.703.675z"></path>
        <path d="M3.853 45.773a.62.62 0 01-.422-.17c-.31-.224-.337-.646-.113-.983l2.25-2.784c.253-.338.675-.366.984-.14.31.252.338.674.113.983l-2.25 2.812c-.112.197-.31.282-.562.282z"></path>
        <path d="M6.158 42.96a.692.692 0 01-.534-.253l-2.278-2.784c-.225-.281-.197-.759.085-.984a.737.737 0 01.984.084l2.25 2.756c.224.281.196.76-.085.984a.506.506 0 01-.422.197z"></path>
      </g>
      <defs>
        <clipPath id="clip0_805_2016">
          <path fill="#fff" d="M0 0H48V48H0z" transform="translate(0 .5)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconStep3 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 48 48">
      <path
        fill="#FCFCFD"
        d="M42.094 43.125H5.906A5.882 5.882 0 010 37.219V10.78c0-1.594.563-3 1.688-4.125s2.625-1.781 4.218-1.781h36.188c1.593 0 3.093.656 4.218 1.781C47.344 7.781 48 9.281 48 10.781V37.22a5.882 5.882 0 01-5.906 5.906zM5.906 6.187a4.601 4.601 0 00-4.593 4.594V37.22a4.601 4.601 0 004.593 4.593h36.188a4.601 4.601 0 004.593-4.593V10.78a4.601 4.601 0 00-4.593-4.594H5.906z"
      ></path>
      <path
        fill="#FCFCFD"
        d="M47.344 15.844H.656A.64.64 0 010 15.188a.64.64 0 01.656-.657h46.688a.64.64 0 01.656.656.64.64 0 01-.656.657zM40.5 12.375c-1.031 0-1.969-.938-1.969-1.969 0-1.125.844-1.969 1.969-1.969s1.969.844 1.969 1.97c0 1.03-.938 1.968-1.969 1.968zm0-2.625a.64.64 0 00-.656.656c0 .281.281.656.656.656s.656-.374.656-.656a.64.64 0 00-.656-.656zM35.344 12.375c-1.032 0-1.969-.938-1.969-1.969 0-1.031.938-1.969 1.969-1.969 1.125 0 1.968.844 1.968 1.97 0 1.03-.937 1.968-1.968 1.968zm0-2.625c-.282 0-.657.281-.657.656 0 .281.376.656.657.656.375 0 .656-.374.656-.656a.64.64 0 00-.656-.656zM16.688 11.063H13.03a.64.64 0 01-.656-.657.64.64 0 01.656-.656h3.656a.64.64 0 01.657.656.64.64 0 01-.657.656zM24.563 11.063h-3.657a.64.64 0 01-.656-.657.64.64 0 01.656-.656h3.657a.64.64 0 01.656.656.64.64 0 01-.657.656zM8.906 11.063H5.25a.64.64 0 01-.656-.657.64.64 0 01.656-.656h3.656a.64.64 0 01.656.656.64.64 0 01-.656.656zM20.813 20.531H5.438a.64.64 0 01-.657-.656.64.64 0 01.657-.656h15.375a.64.64 0 01.656.656.64.64 0 01-.657.656zM20.813 26.531H5.438a.64.64 0 01-.657-.656.64.64 0 01.657-.656h15.375a.64.64 0 01.656.656.64.64 0 01-.657.656zM20.813 32.531H5.438a.64.64 0 01-.657-.656.64.64 0 01.657-.656h15.375a.64.64 0 01.656.656.64.64 0 01-.657.656zM20.813 38.531H5.438a.64.64 0 01-.657-.656.64.64 0 01.657-.656h15.375a.64.64 0 01.656.656.64.64 0 01-.657.656zM33.375 37.688c-2.156 0-4.125-.844-5.625-2.25-1.406-1.5-2.25-3.47-2.25-5.626 0-4.312 3.563-7.875 7.875-7.875a.64.64 0 01.656.657v6.562h6.563a.64.64 0 01.656.657c0 4.312-3.563 7.875-7.875 7.875zm-.656-14.438c-3.282.375-5.907 3.188-5.907 6.563a6.522 6.522 0 006.563 6.562c3.375 0 6.188-2.625 6.563-5.906h-6.563a.64.64 0 01-.656-.657V23.25z"
      ></path>
      <path
        fill="#FCFCFD"
        d="M42.563 28.594h-7.22a.64.64 0 01-.656-.657V20.72a.64.64 0 01.657-.657c2.062 0 4.125.844 5.531 2.25a8.031 8.031 0 012.344 5.625.64.64 0 01-.657.657zM36 27.28h5.906a6.85 6.85 0 00-1.968-4.031C38.906 22.219 37.5 21.562 36 21.375v5.906zM33.375 30.469h-7.219a.64.64 0 01-.656-.657.64.64 0 01.656-.656h7.219a.64.64 0 01.656.657.64.64 0 01-.656.656z"
      ></path>
    </svg>
  </span>
);

export const IconAdsFeature1 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" fill="none" viewBox="0 0 49 48">
      <g fill="#EA2127" clipPath="url(#clip0_805_2147)">
        <path d="M35.13 32.867H13.543a2.38 2.38 0 01-2.376-2.376V2.396A2.38 2.38 0 0113.543.02h17.625c.182 0 .337.06.459.195l5.69 5.684a.69.69 0 01.196.466V30.49a2.39 2.39 0 01-2.383 2.376zM13.543 1.33c-.587 0-1.066.48-1.066 1.067V30.49c0 .587.479 1.066 1.066 1.066H35.13a1.07 1.07 0 001.073-1.066V6.636L30.898 1.33H13.543z"></path>
        <path d="M36.844 7.02h-4.151a2.185 2.185 0 01-2.18-2.187V.683c0-.264.162-.507.405-.608a.645.645 0 01.709.141l5.69 5.684a.669.669 0 01.142.716.666.666 0 01-.615.405zm-5.022-4.758v2.565c0 .486.399.87.871.87h2.572l-3.443-3.435zM23 28.438c-.04 0-.087 0-.121-.013a.653.653 0 01-.527-.763l2.68-13.905a.66.66 0 01.77-.527.664.664 0 01.526.77l-2.68 13.905a.677.677 0 01-.648.533zM20.49 27.082a.615.615 0 01-.46-.203l-5.596-5.589a.673.673 0 010-.931l5.596-5.59a.652.652 0 01.925 0 .652.652 0 010 .925l-5.144 5.124 5.137 5.136c.25.25.25.675 0 .925a.615.615 0 01-.459.203zM28.178 27.081a.615.615 0 01-.46-.202.664.664 0 010-.925l5.137-5.137-5.143-5.13a.66.66 0 010-.931c.25-.25.675-.25.925 0l5.596 5.596a.652.652 0 010 .924l-5.596 5.596a.609.609 0 01-.46.21zM27.273 5.812H15.136a.653.653 0 01-.655-.661c0-.365.29-.655.655-.655h12.137c.364 0 .655.29.655.655 0 .371-.29.661-.655.661zM33.53 10.497H15.136a.653.653 0 01-.655-.662c0-.364.29-.654.655-.654H33.53c.365 0 .655.29.655.654 0 .372-.29.662-.655.662z"></path>
        <path d="M45.586 41.723H3.088a2.568 2.568 0 01-2.566-2.565V10.234a2.57 2.57 0 012.566-2.572h8.734c.365 0 .655.29.655.662 0 .364-.29.654-.655.654H3.088c-.696 0-1.256.56-1.256 1.256v28.924c0 .689.56 1.256 1.255 1.256h42.5c.694 0 1.255-.567 1.255-1.256V10.234c0-.695-.56-1.256-1.256-1.256h-8.728a.651.651 0 01-.654-.654c0-.372.29-.662.654-.662h8.728a2.575 2.575 0 012.572 2.572v28.924a2.574 2.574 0 01-2.572 2.565z"></path>
        <path d="M30.277 47.98h-11.86a.65.65 0 01-.648-.567.667.667 0 01.486-.722c1.654-.425 1.803-4.273 1.728-5.596a.653.653 0 01.615-.695.667.667 0 01.695.62c.027.48.175 3.74-1.033 5.65h8.181c-1.215-1.91-1.073-5.17-1.046-5.65a.656.656 0 111.31.075c-.075 1.31.087 5.17 1.755 5.596a.65.65 0 01.485.722.675.675 0 01-.668.567z"></path>
        <path d="M28.333 45.24h-7.979a.653.653 0 01-.655-.661c0-.365.29-.655.655-.655h7.979c.364 0 .654.29.654.655 0 .37-.29.661-.654.661zM47.503 35.081H1.17a.653.653 0 01-.661-.655c0-.364.29-.654.661-.654h46.333c.364 0 .655.29.655.654 0 .365-.29.655-.655.655zM25.849 38.409h-3.031a.651.651 0 01-.655-.655c0-.371.29-.661.655-.661h3.03c.365 0 .655.29.655.661 0 .365-.29.655-.654.655z"></path>
      </g>
      <defs>
        <clipPath id="clip0_805_2147">
          <path fill="#fff" d="M0 0H48V48H0z" transform="translate(.333)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconAdsFeature2 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
      <path
        fill="#EA2127"
        d="M39.623 34.031c-.34 0-.595-.281-.595-.656V10.687H4.506v22.688c0 .375-.255.656-.595.656-.34 0-.596-.281-.596-.656V10.031c0-.375.256-.656.596-.656h35.712c.34 0 .595.281.595.656v23.344c0 .375-.255.656-.595.656z"
      ></path>
      <path
        fill="#EA2127"
        d="M40.899 38.625H2.636c-1.446 0-2.636-1.313-2.636-3v-2.25c0-.375.255-.656.595-.656H42.94c.34 0 .595.281.595.656v2.25c0 1.688-1.19 3-2.636 3zM1.19 34.031v1.594c0 .938.68 1.688 1.446 1.688h38.263c.765 0 1.445-.75 1.445-1.688v-1.594H1.19z"
      ></path>
      <path
        fill="#EA2127"
        d="M25.51 36.281h-7.483c-.85 0-1.616-.75-1.616-1.781v-1.125c0-.375.255-.656.595-.656h9.524c.34 0 .595.281.595.656V34.5c0 1.031-.765 1.781-1.616 1.781zm-7.909-2.25v.469c0 .281.256.469.426.469h7.482c.17 0 .425-.188.425-.469v-.469h-8.332zM38.603 36.281h-1.275c-.34 0-.596-.281-.596-.656 0-.281.255-.656.596-.656h1.275c.34 0 .595.375.595.656 0 .375-.255.656-.595.656zM35.457 36.281h-1.36c-.34 0-.596-.281-.596-.656 0-.281.255-.656.595-.656h1.36c.34 0 .596.375.596.656 0 .375-.255.656-.595.656zM32.311 36.281h-1.36c-.34 0-.596-.281-.596-.656 0-.281.256-.656.596-.656h1.36c.34 0 .595.375.595.656 0 .375-.255.656-.595.656z"
      ></path>
      <g clipPath="url(#clip0_805_2185)">
        <path fill="#fff" d="M0 0H18V26H0z" transform="translate(30 16)"></path>
        <path
          fill="#EA2127"
          d="M45.999 41.985H31.953c-.744 0-1.345-.579-1.345-1.28V17.31c0-.716.617-1.31 1.345-1.31h14.014c.76 0 1.36.594 1.36 1.31v23.365c.032.731-.585 1.31-1.328 1.31zM31.953 16.746a.57.57 0 00-.57.564v23.365c0 .32.27.548.57.548h14.014c.332 0 .601-.243.601-.548V17.31c0-.32-.269-.564-.601-.564H31.953z"
        ></path>
        <path
          fill="#EA2127"
          d="M46.963 39.06h-15.96c-.205 0-.395-.183-.395-.381 0-.214.19-.381.396-.381h15.975c.222 0 .396.167.396.38 0 .199-.19.381-.412.381zM42.107 18.346h-6.264c-.68 0-1.234-.518-1.234-1.173v-.792c0-.213.174-.381.396-.381.221 0 .364.168.364.38v.808c0 .259.205.442.474.442h6.264c.269 0 .458-.183.458-.442v-.807c0-.213.19-.381.396-.381.221 0 .395.168.395.38v.808c-.016.64-.57 1.158-1.25 1.158zM39.436 40.538h-.902a.384.384 0 01-.395-.38c0-.214.174-.382.395-.382h.902c.221 0 .395.168.395.381s-.174.38-.395.38zM34.72 31.11a.563.563 0 01-.205-.046c-.174-.106-.238-.335-.127-.502l5.157-8.576a.393.393 0 01.521-.121c.174.091.253.335.143.502l-5.157 8.56a.454.454 0 01-.332.183zM36.761 31.491a.565.565 0 01-.205-.046c-.174-.106-.238-.335-.127-.502l3.1-5.133a.393.393 0 01.522-.122c.174.106.237.335.127.502l-3.085 5.133c-.063.107-.205.168-.332.168zM37.569 34.004a.435.435 0 01-.19-.046c-.174-.106-.253-.335-.142-.502l5.14-8.56a.393.393 0 01.522-.122.382.382 0 01.143.502L37.9 33.821c-.063.122-.206.183-.332.183z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_805_2185">
          <path fill="#fff" d="M0 0H18V26H0z" transform="translate(30 16)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconAdsFeature3 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" fill="none" viewBox="0 0 49 48">
      <g fill="#EA2127" clipPath="url(#clip0_805_2226)">
        <path d="M14.354 29.906c-1.688 0-3.094-1.406-3.094-3.093V23.25a.64.64 0 01.656-.656h4.875a.64.64 0 01.656.656v3.563c0 1.687-1.406 3.093-3.093 3.093zm-1.782-6v2.907c0 .937.75 1.78 1.782 1.78.937 0 1.78-.843 1.78-1.78v-2.907h-3.562z"></path>
        <path d="M15.854 23.906a.64.64 0 01-.657-.656v-.844a.202.202 0 00-.187-.187h-1.313a.202.202 0 00-.187.187v.844a.64.64 0 01-.656.656.64.64 0 01-.657-.656v-.844c0-.843.657-1.5 1.5-1.5h1.313c.844 0 1.5.657 1.5 1.5v.844a.64.64 0 01-.657.656z"></path>
        <path d="M15.479 22.312h-.094c-.281 0-.563-.375-.563-.656a2.061 2.061 0 011.125-1.594c.375-.188.75 0 .844.281.188.375.094.75-.281.938-.188.093-.375.28-.375.468 0 .375-.282.563-.657.563zM13.229 22.312c-.281 0-.563-.281-.656-.656a.516.516 0 00-.282-.469c-.375-.094-.562-.562-.375-.844a.693.693 0 01.844-.375c.656.282 1.125.938 1.125 1.594.094.375-.187.656-.562.75h-.094zM9.76 31.125h-.187c-.375-.188-.563-.469-.469-.844l.75-2.718a.732.732 0 01.375-.375l1.313-.844c.374-.094.75 0 .937.281.188.281.094.75-.281.938l-1.125.656-.75 2.437c0 .282-.282.469-.563.469zM11.916 24.844c-.093 0-.28-.094-.375-.094l-1.312-.844a.732.732 0 01-.375-.375l-.75-2.718c-.094-.282.094-.657.469-.75.281-.094.656.093.75.375l.75 2.53 1.125.657c.375.188.468.563.281.844-.188.187-.375.375-.563.375zM19.042 31.125a.705.705 0 01-.656-.469l-.75-2.437-1.22-.75c-.28-.188-.374-.563-.187-.844.188-.375.563-.469.844-.281l1.5.843c.094.094.188.188.281.375l.75 2.72c.094.374-.093.655-.375.843h-.187zM16.792 24.843c-.188 0-.469-.093-.563-.281-.187-.375-.093-.75.188-.938l1.219-.656.656-2.437c.094-.375.469-.563.844-.469.375.094.562.469.468.844l-.843 2.719c0 .093-.094.28-.282.375l-1.406.75c-.094.093-.187.093-.281.093zM14.354 29.906a.64.64 0 01-.657-.656v-6a.64.64 0 01.657-.656.64.64 0 01.656.656v6a.64.64 0 01-.656.656zM33.478 31.125h-3.562a.64.64 0 01-.656-.656V23.53a.64.64 0 01.656-.656h3.562a.64.64 0 01.657.656v6.938a.64.64 0 01-.657.656zm-2.906-1.313h2.25v-5.625h-2.25v5.625zM27.854 31.125H24.29a.64.64 0 01-.656-.656v-4.782a.64.64 0 01.656-.656h3.563a.64.64 0 01.656.657v4.78a.64.64 0 01-.657.657zm-2.907-1.313h2.25v-3.468h-2.25v3.468zM39.103 31.125h-3.468a.64.64 0 01-.657-.656v-9a.64.64 0 01.657-.657h3.468a.64.64 0 01.657.657v9a.64.64 0 01-.657.656zm-2.812-1.313h2.156v-7.687h-2.156v7.688zM34.978 16.781H14.353a.64.64 0 01-.656-.656.64.64 0 01.657-.656h20.624a.64.64 0 01.657.656.64.64 0 01-.657.656zM34.978 18.75H14.353c-.374 0-.656-.375-.656-.656a.64.64 0 01.657-.657h20.624a.64.64 0 01.657.657c0 .281-.282.656-.657.656z"></path>
        <path d="M44.353 34.031a.64.64 0 01-.656-.656V10.687H5.635v22.688a.64.64 0 01-.656.656.64.64 0 01-.657-.656V10.031a.64.64 0 01.657-.656h39.374a.64.64 0 01.657.656v23.344a.64.64 0 01-.657.656z"></path>
        <path d="M45.76 38.625H3.572c-1.593 0-2.906-1.313-2.906-3v-2.25a.64.64 0 01.656-.656H48.01a.64.64 0 01.656.656v2.25c0 1.688-1.313 3-2.906 3zM1.979 34.031v1.594c0 .938.75 1.688 1.593 1.688H45.76c.843 0 1.593-.75 1.593-1.688v-1.594H1.98z"></path>
        <path d="M28.791 36.281h-8.25A1.78 1.78 0 0118.76 34.5v-1.125a.64.64 0 01.656-.656h10.5a.64.64 0 01.656.656V34.5a1.78 1.78 0 01-1.781 1.781zm-8.719-2.25v.469c0 .281.282.469.469.469h8.25c.188 0 .469-.188.469-.469v-.469h-9.188zM43.228 36.281h-1.406a.64.64 0 01-.656-.656c0-.281.281-.656.656-.656h1.406c.375 0 .657.375.657.656a.64.64 0 01-.657.656zM39.76 36.281h-1.5a.64.64 0 01-.657-.656c0-.281.282-.656.657-.656h1.5c.375 0 .656.375.656.656a.64.64 0 01-.656.656zM36.291 36.281h-1.5a.64.64 0 01-.656-.656c0-.281.281-.656.656-.656h1.5c.375 0 .656.375.656.656a.64.64 0 01-.656.656z"></path>
      </g>
      <defs>
        <clipPath id="clip0_805_2226">
          <path fill="#fff" d="M0 0H48V48H0z" transform="translate(.666)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconAdsFeature4 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" fill="none" viewBox="0 0 49 48">
      <path
        fill="#EA2127"
        d="M38.677 48H6.802a.64.64 0 01-.656-.656V12.562a.64.64 0 01.656-.656h7.687V3.844a.64.64 0 01.656-.656h23.532a.64.64 0 01.656.656v43.5a.64.64 0 01-.656.656zM7.458 46.687h30.563V4.5H15.8v8.063c0 .374-.374.656-.655.656H7.458v33.468z"
      ></path>
      <path
        fill="#EA2127"
        d="M15.145 13.219H6.801c-.28 0-.468-.188-.656-.469-.094-.187 0-.469.188-.656l8.343-8.719c.188-.187.47-.187.657-.094.28.094.468.282.468.563v8.719c0 .375-.375.656-.656.656zm-6.844-1.313h6.188V5.531L8.3 11.906zM18.895 30.281c-1.969 0-3.844-1.125-4.875-2.812-1.594-2.719-.656-6.188 2.063-7.688.843-.562 1.875-.75 2.812-.75a5.626 5.626 0 014.875 2.813c1.594 2.625.656 6.093-2.063 7.687a5.726 5.726 0 01-2.812.75zm0-9.937c-.75 0-1.5.187-2.156.562-2.063 1.125-2.813 3.844-1.594 5.907.75 1.312 2.25 2.156 3.75 2.156.75 0 1.5-.188 2.156-.563 2.063-1.218 2.813-3.843 1.594-5.906-.75-1.406-2.25-2.156-3.75-2.156z"
      ></path>
      <path
        fill="#EA2127"
        d="M23.677 23.906c-.188 0-.469-.093-.563-.281-.187-.375-.094-.75.281-.938l1.594-.937c.094 0 .188-.094.281-.094h1.032v-.843c.093-.188.093-.375.281-.47a.716.716 0 01.469-.187l1.5.188.187-.844c0-.375.375-.563.656-.563l1.407.094.187-.937c.094-.282.375-.563.75-.469l1.688.188.093-.094.75-2.063-2.062-.281-10.031 5.813c-.375.187-.75.093-.938-.282-.187-.281-.094-.656.281-.843l10.22-5.907c.093-.094.28-.094.374-.094l3.188.376c.187 0 .375.093.468.28a.597.597 0 010 .563l-1.03 3.094a.732.732 0 01-.376.375l-.468.281c-.094.094-.282.094-.376.094l-1.312-.188-.188.938c-.093.281-.375.563-.656.563l-1.406-.188-.188.844c0 .375-.375.656-.656.562l-1.5-.093-.094.843c0 .375-.28.563-.656.563h-1.406l-1.406.843c-.094.094-.282.094-.375.094zM18.896 27.188c-.938 0-1.782-.47-2.25-1.313a2.59 2.59 0 01.937-3.469c.469-.187.844-.375 1.313-.375.937 0 1.781.563 2.25 1.313.656 1.218.281 2.812-.938 3.468-.375.282-.843.375-1.312.375zm0-3.844c-.188 0-.469.093-.657.187-.562.375-.75 1.125-.375 1.688.188.375.563.656 1.032.656.187 0 .468-.094.656-.188.563-.28.75-1.125.469-1.687-.282-.375-.657-.656-1.125-.656z"
      ></path>
      <path
        fill="#EA2127"
        d="M12.802 31.97c-.75 0-1.407-.188-1.97-.563-.937-.657-1.406-1.782-1.218-2.813.281-1.312 1.406-2.25 3.188-2.625l4.312-1.031c.375-.094.656.094.75.469.094.375-.094.75-.469.843l-4.312.938c-1.219.281-1.969.844-2.156 1.594-.094.562.187 1.218.656 1.5.75.562 1.781.468 2.812-.094.282-.188.75-.094.938.188.187.28.094.75-.281.937-.75.469-1.5.656-2.25.656zM33.802 35.625H10.083a.64.64 0 01-.656-.656.64.64 0 01.656-.657h23.719a.64.64 0 01.656.657.64.64 0 01-.656.656zM30.99 39.656H10.082A.64.64 0 019.427 39a.64.64 0 01.656-.656h20.906a.64.64 0 01.656.656.64.64 0 01-.656.656zM28.458 43.781H10.083a.64.64 0 01-.656-.656.64.64 0 01.656-.656h18.375a.64.64 0 01.656.656.64.64 0 01-.656.656zM35.864 8.344H22.552c-.375 0-.657-.375-.657-.656a.64.64 0 01.657-.657h13.312a.64.64 0 01.657.657c0 .28-.282.656-.657.656zM35.864 11.531H19.271c-.282 0-.657-.281-.657-.656s.375-.656.656-.656h16.594a.64.64 0 01.657.656.64.64 0 01-.657.656z"
      ></path>
      <path
        fill="#EA2127"
        d="M41.864 44.813h-3.187a.64.64 0 01-.657-.657.64.64 0 01.657-.656h2.531V1.312H19.083v2.532a.64.64 0 01-.656.656.64.64 0 01-.657-.656V.656A.64.64 0 0118.427 0h23.437a.64.64 0 01.657.656v43.5a.64.64 0 01-.657.657z"
      ></path>
    </svg>
  </span>
);

export const IconAdsFeature5 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
      <path
        fill="#EA2127"
        d="M44.415 37.862H3.625A3.578 3.578 0 01.04 34.277V8.147c0-1.984 1.6-3.584 3.584-3.584h40.791C46.4 4.563 48 6.163 48 8.148v26.13c0 1.984-1.64 3.584-3.584 3.584zM3.625 5.927a2.218 2.218 0 00-2.221 2.22v26.13a2.245 2.245 0 002.22 2.221h40.791c1.249 0 2.221-.972 2.221-2.22V8.147a2.218 2.218 0 00-2.22-2.221H3.623z"
      ></path>
      <path
        fill="#EA2127"
        d="M30.882 43.438c-.27 0-.547-.156-.62-.425l-2.228-5.576c-.156-.351.04-.743.391-.898.351-.155.743.04.898.392l2.22 5.575c.156.351-.033.736-.384.891-.081 0-.196.04-.277.04zm-13.723 0c-.08 0-.155 0-.236-.04a.72.72 0 01-.391-.892l2.227-5.575a.713.713 0 01.891-.392.721.721 0 01.392.898l-2.221 5.576c-.155.229-.432.425-.662.425zM47.298 32.522H.702A.697.697 0 010 31.82c0-.391.31-.702.702-.702h46.596c.392 0 .702.31.702.702 0 .392-.31.702-.702.702z"
      ></path>
      <path
        fill="#EA2127"
        d="M35.91 43.437H12.13a.697.697 0 01-.702-.702c0-.391.31-.702.702-.702h23.78c.392 0 .702.31.702.702 0 .392-.31.702-.702.702zM12.13 29.404c-3.746 0-7.257-2.383-8.465-6.163-1.519-4.644 1.013-9.673 5.69-11.192a.751.751 0 01.514.04c.155.075.27.23.344.392l2.457 7.56 6.824 4.057a.69.69 0 01.236.938 8.81 8.81 0 01-4.914 3.936c-.897.276-1.795.432-2.686.432zM9.126 13.608a7.55 7.55 0 00-4.172 9.241c1.283 3.902 5.495 6.082 9.437 4.8a7.453 7.453 0 003.78-2.734l-6.433-3.82c-.155-.075-.236-.23-.31-.392l-2.302-7.095z"
      ></path>
      <path
        fill="#EA2127"
        d="M22.262 24.49c-.115 0-.23-.04-.344-.081l-7.02-4.172a.608.608 0 01-.318-.506.7.7 0 01.196-.587l5.893-5.69c.27-.27.702-.27.972 0 .972 1.012 1.674 2.146 2.065 3.428.783 2.417.507 5.07-.816 7.257a.763.763 0 01-.628.35zm-5.927-4.995l5.657 3.355a7.584 7.584 0 00.391-5.536 7.117 7.117 0 00-1.289-2.382l-4.759 4.563zM13.69 19.184c-.041 0-.122 0-.156-.04a.574.574 0 01-.472-.466l-2.532-7.763a.68.68 0 01.426-.857 8.843 8.843 0 019.126 2.261.755.755 0 01.195.473.645.645 0 01-.195.466l-5.927 5.73a.69.69 0 01-.466.196zm-1.641-7.992l1.95 6.041 4.598-4.441c-1.83-1.56-4.246-2.147-6.548-1.6zM44.881 29.012H25.812a.697.697 0 01-.702-.702c0-.391.31-.702.702-.702h19.07c.39 0 .701.31.701.702 0 .392-.35.702-.702.702z"
      ></path>
      <path
        fill="#EA2127"
        d="M31.314 29.013a.697.697 0 01-.702-.702v-5.772h-2.693v5.772c0 .391-.31.702-.702.702a.697.697 0 01-.702-.702v-6.433c0-.392.31-.702.702-.702h4.056c.392 0 .703.31.703.702v6.473c.04.351-.277.662-.662.662zM37.396 29.013a.697.697 0 01-.702-.702v-7.682h-2.693v7.682c0 .391-.31.702-.702.702a.701.701 0 01-.702-.702v-8.343c0-.392.317-.702.702-.702h4.056c.392 0 .703.31.703.702v8.383a.68.68 0 01-.662.662zM43.397 29.013a.701.701 0 01-.702-.702V17.315h-2.646V28.31a.702.702 0 01-.703.702.697.697 0 01-.701-.702V16.653c0-.391.31-.702.701-.702h4.017c.385 0 .702.31.702.702v11.658c.034.391-.277.702-.668.702zM43.362 9.984H27.331a.701.701 0 110-1.404h16.031a.701.701 0 110 1.404zM43.362 13.021H27.331a.701.701 0 110-1.404h16.031a.701.701 0 110 1.404z"
      ></path>
    </svg>
  </span>
);

export const IconAdsFeature6 = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" fill="none" viewBox="0 0 49 48">
      <g fill="#EA2127" clipPath="url(#clip0_805_2352)">
        <path d="M33.088 23.846H16.272a.696.696 0 01-.703-.703v-4.134c0-2.7 2.447-4.864 5.512-4.864.14 0 .337.056.45.196.815.732 1.912 1.125 3.12 1.125 1.21 0 2.307-.393 3.122-1.125a.617.617 0 01.478-.196c3.037 0 5.54 2.165 5.54 4.864v4.19a.684.684 0 01-.703.647zm-16.169-1.35h15.466v-3.515c0-1.828-1.8-3.402-3.937-3.515-1.04.844-2.39 1.322-3.824 1.322-1.434 0-2.784-.478-3.824-1.322-2.166.113-3.909 1.687-3.909 3.515v3.515h.028zM28.673 8.717c-.056 0-.112 0-.197-.056-.253-.056-.45-.31-.45-.59-.168-1.434-1.152-2.166-1.687-2.447-.9.984-1.912 1.49-2.924 1.519-.816.056-1.49-.282-1.968-.535-.31.619-.253 1.238-.253 1.294 0 .31-.17.534-.45.647-.253.112-.563 0-.76-.197-.675-.816-1.153-3.15-.703-5.034.31-1.321.956-2.333 1.997-2.812C22.6-.168 24.455-.168 26.17.422c1.687.59 2.98 1.687 3.683 3.121 1.238 2.615-.534 4.865-.618 4.978-.17.112-.366.196-.563.196zm-2.559-4.583c.057 0 .113 0 .197.056.056.028 1.603.506 2.503 2.025a3.33 3.33 0 00-.197-2.11c-.562-1.096-1.575-1.968-2.896-2.418-1.378-.478-2.897-.478-3.88 0-.62.31-1.041.928-1.266 1.913-.169.646-.169 1.35-.084 1.996.112-.169.224-.281.337-.45a.75.75 0 01.506-.197c.197 0 .366.085.506.253 0 0 .647.647 1.547.62.73-.029 1.462-.507 2.221-1.407a.628.628 0 01.506-.281z"></path>
        <path d="M24.596 14.088c-3.29 0-4.809-3.655-4.809-6.158v-.225c0-.394.31-.675.703-.675a.69.69 0 01.703.675v.225c0 2.025 1.153 4.809 3.43 4.809 2.222 0 3.403-2.784 3.403-4.809v-.084c0-.394.31-.647.703-.647.394 0 .703.31.703.647v.084c-.084 2.503-1.603 6.158-4.836 6.158z"></path>
        <path d="M21.081 15.466c-.084 0-.197 0-.28-.028-.366-.168-.507-.562-.366-.9.14-.252.28-.478.45-.703.309-.393.618-.871.618-1.405 0-.394.337-.703.703-.675.394 0 .647.309.647.703-.028.984-.535 1.687-.872 2.193-.14.14-.253.337-.281.422-.084.225-.366.393-.619.393zM28.223 15.466c-.28 0-.506-.169-.646-.422-.028-.14-.169-.365-.338-.59-.422-.675-1.012-1.49-.815-2.39.084-.338.45-.591.815-.507.338.085.59.478.506.816-.084.281.366.956.619 1.293.197.281.394.535.478.816a.684.684 0 01-.394.9c-.028.084-.168.084-.225.084zM20.237 47.804H3.422a.696.696 0 01-.703-.703v-4.218c0-2.671 2.502-4.893 5.54-4.893.168 0 .365.085.477.197.816.76 1.912 1.125 3.122 1.125 1.209 0 2.305-.366 3.12-1.125a.678.678 0 01.479-.197c3.037.056 5.483 2.222 5.483 4.893v4.218c-.028.394-.337.703-.703.703zm-16.14-1.378h15.437v-3.515c0-1.828-1.715-3.402-3.88-3.515-1.069.872-2.39 1.322-3.853 1.322-1.434 0-2.755-.45-3.824-1.322-2.165.113-3.937 1.687-3.937 3.515v3.515h.057zM15.879 32.62c-.084 0-.112 0-.197-.057-.281-.084-.478-.31-.478-.59-.14-1.435-1.125-2.138-1.659-2.447-.956.984-1.912 1.49-2.98 1.518-.816.029-1.49-.28-1.913-.534-.309.619-.28 1.237-.28 1.237 0 .31-.141.591-.423.675a.697.697 0 01-.787-.197c-.647-.843-1.125-3.12-.731-5.005.31-1.378 1.012-2.334 2.024-2.84 1.294-.675 3.178-.703 4.893-.14 1.716.59 3.037 1.715 3.712 3.177 1.237 2.615-.562 4.837-.647 4.921a.643.643 0 01-.534.281zm-2.587-4.584c.084 0 .113 0 .197.028.084.056 1.603.534 2.502 2.053.17-.59.17-1.35-.196-2.081-.535-1.125-1.547-1.997-2.925-2.447-1.378-.478-2.84-.45-3.824.028-.675.31-1.097.985-1.293 1.913a5.064 5.064 0 00-.085 1.94c.113-.14.197-.253.366-.422a.75.75 0 01.506-.197c.197 0 .337.085.506.253 0 0 .619.647 1.547.619.759-.056 1.546-.506 2.277-1.406.028-.197.225-.281.422-.281z"></path>
        <path d="M11.745 37.99c-2.924 0-4.78-3.205-4.78-6.158v-.253c0-.366.31-.703.703-.703.394 0 .703.337.703.703v.253c0 1.94 1.096 4.809 3.402 4.809 2.334 0 3.43-2.869 3.43-4.809v-.084c0-.394.31-.703.704-.703.393 0 .703.309.703.703v.084c-.113 2.53-1.603 6.158-4.865 6.158z"></path>
        <path d="M8.258 39.368c-.084 0-.14 0-.225-.057-.366-.14-.506-.534-.394-.9.085-.224.282-.45.422-.702.31-.422.619-.872.675-1.434 0-.394.337-.675.703-.675.394 0 .647.365.647.703-.028.956-.534 1.659-.9 2.165a1.83 1.83 0 00-.253.422.716.716 0 01-.675.478zM15.4 39.368a.725.725 0 01-.618-.394c-.084-.112-.197-.366-.337-.562-.478-.647-1.069-1.519-.872-2.419.084-.337.478-.562.816-.506.365.084.59.45.506.816-.085.337.365.956.618 1.35.197.252.366.505.478.759a.66.66 0 01-.337.9c-.056.056-.169.056-.253.056zM45.91 48H29.123a.696.696 0 01-.703-.702v-4.19c0-2.7 2.446-4.865 5.483-4.865.169 0 .366.056.478.169.816.76 1.912 1.153 3.121 1.153 1.21 0 2.306-.394 3.122-1.153.112-.113.281-.169.478-.169 3.037 0 5.511 2.165 5.511 4.865v4.19c0 .393-.31.703-.703.703zm-16.14-1.377h15.465v-3.515c0-1.884-1.715-3.43-3.908-3.515-1.04.872-2.362 1.321-3.825 1.321-1.434 0-2.755-.45-3.824-1.321-2.193.112-3.908 1.63-3.908 3.515v3.515zM41.523 32.844c-.084 0-.112 0-.197-.056a.6.6 0 01-.45-.562c-.168-1.463-1.152-2.166-1.686-2.475-.928.984-1.913 1.49-2.981 1.518a3.78 3.78 0 01-1.94-.534c-.31.59-.282 1.238-.282 1.238 0 .309-.14.59-.422.674a.696.696 0 01-.787-.196c-.646-.816-1.125-3.094-.73-5.006.28-1.35.955-2.362 2.024-2.896 1.293-.647 3.205-.647 4.892-.056 1.66.59 2.981 1.659 3.684 3.121 1.265 2.615-.534 4.837-.619 4.949a.564.564 0 01-.506.281zm-2.559-4.583c.057 0 .113 0 .197.056.057.028 1.575.506 2.475 2.025.169-.59.169-1.322-.197-2.11-.534-1.096-1.547-1.94-2.868-2.418-1.378-.478-2.896-.478-3.88.029-.647.309-1.097.984-1.294 1.968-.14.619-.14 1.322-.056 1.912.112-.169.224-.281.337-.422.113-.14.31-.197.506-.197a.61.61 0 01.506.225s.619.647 1.575.619c.731-.028 1.518-.506 2.25-1.406.056-.197.253-.281.45-.281z"></path>
        <path d="M37.39 38.243c-2.925 0-4.752-3.206-4.752-6.186v-.225c0-.394.309-.703.703-.703.365 0 .703.31.703.703v.225c0 1.968 1.068 4.808 3.374 4.808 2.362 0 3.459-2.84 3.459-4.808v-.085c0-.393.309-.703.703-.703.393 0 .703.31.703.704v.084c-.085 2.53-1.603 6.186-4.893 6.186z"></path>
        <path d="M33.903 39.593c-.056 0-.14 0-.225-.029a.666.666 0 01-.394-.871c.084-.282.281-.506.478-.788.281-.365.619-.843.619-1.35 0-.393.31-.702.703-.674.393 0 .675.309.675.703-.056.956-.507 1.659-.9 2.165-.113.14-.253.337-.281.422a.737.737 0 01-.675.422zM41.074 39.593a.715.715 0 01-.647-.394 4.96 4.96 0 00-.338-.534c-.478-.675-1.068-1.519-.871-2.419a.678.678 0 01.815-.506c.366.057.59.422.534.816-.084.31.338.928.619 1.321.197.282.337.507.45.788.169.337 0 .73-.338.9-.028 0-.112.028-.224.028z"></path>
      </g>
      <defs>
        <clipPath id="clip0_805_2352">
          <path fill="#fff" d="M0 0H48V48H0z" transform="translate(.666)"></path>
        </clipPath>
      </defs>
    </svg>
  </span>
);

export const IconLogOut = ({ className, ...rest }) => (
  <span role="img" className={`${className || ''}`} {...rest}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width="30"
      height="40"
      enableBackground="new 0 0 489.9 489.9"
      version="1.1"
      viewBox="0 0 489.9 489.9"
      xmlSpace="preserve"
    >
      <path
        fill="#555555"
        d="M468.3 255.8l.2-.2c.3-.4.6-.7.8-1.1.1-.1.1-.2.2-.3.2-.4.5-.8.7-1.2 0-.1.1-.2.1-.2.2-.4.4-.8.6-1.3 0-.1 0-.1.1-.2.2-.4.3-.9.5-1.4 0-.1 0-.2.1-.2.1-.5.3-.9.3-1.4 0-.2 0-.3.1-.5.1-.4.1-.8.2-1.2.1-.6.1-1.1.1-1.7 0-.6 0-1.1-.1-1.7 0-.4-.1-.8-.2-1.2 0-.2 0-.3-.1-.5-.1-.5-.2-.9-.3-1.4 0-.1 0-.2-.1-.2-.1-.5-.3-.9-.5-1.4 0-.1 0-.1-.1-.2-.2-.4-.4-.9-.6-1.3 0-.1-.1-.2-.1-.2-.2-.4-.4-.8-.7-1.2-.1-.1-.1-.2-.2-.3-.3-.4-.5-.8-.8-1.1l-.2-.2c-.4-.4-.7-.9-1.2-1.3l-98.9-98.8c-6.7-6.7-17.6-6.7-24.3 0-6.7 6.7-6.7 17.6 0 24.3l69.6 69.6H136.8c-9.5 0-17.2 7.7-17.2 17.1 0 9.5 7.7 17.2 17.2 17.2h276.8l-69.1 69.1c-6.7 6.7-6.7 17.6 0 24.3 3.3 3.3 7.7 5 12.1 5s8.8-1.7 12.1-5l98.3-98.3c.5-.6.9-1 1.3-1.4z"
      ></path>
      <path
        fill="#555555"
        d="M110.7 34.3h128c9.5 0 17.2-7.7 17.2-17.1 0-9.5-7.7-17.2-17.2-17.2h-128C59.4 0 17.6 41.8 17.6 93.1v303.7c0 51.3 41.8 93.1 93.1 93.1h125.9c9.5 0 17.2-7.7 17.2-17.1 0-9.5-7.7-17.2-17.2-17.2H110.7c-32.4 0-58.8-26.4-58.8-58.8V93.1c.1-32.5 26.4-58.8 58.8-58.8z"
      ></path>
    </svg>
  </span>
);
